'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('es6-promise/auto');
var React = require('react');
var React__default = _interopDefault(React);
var classnames = _interopDefault(require('classnames'));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var browserPolyfill = createCommonjsModule(function (module) {
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(typeof self !== 'undefined' ? self : commonjsGlobal);
});

var browserPolyfill$1 = unwrapExports(browserPolyfill);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;

}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

var tslib_es6 = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
};

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

var extend = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

var requestOriginator;
(function (requestOriginator) {
    requestOriginator["Unknown"] = "Unknown";
    requestOriginator["iFrameMessageHandler"] = "iFrameMessageHandler";
})(requestOriginator || (requestOriginator = {}));
var pidlTransformationTargets;
(function (pidlTransformationTargets) {
    pidlTransformationTargets["forSubmit"] = "forSubmit";
    pidlTransformationTargets["forDisplay"] = "forDisplay";
})(pidlTransformationTargets || (pidlTransformationTargets = {}));
var eventTypes;
(function (eventTypes) {
    eventTypes["message"] = "message";
})(eventTypes || (eventTypes = {}));
var displayTransformationTargets;
(function (displayTransformationTargets) {
    displayTransformationTargets["forFormat"] = "forFormat";
    displayTransformationTargets["forModel"] = "forModel";
})(displayTransformationTargets || (displayTransformationTargets = {}));
var pidlResultType;
(function (pidlResultType) {
    pidlResultType["Error"] = "error";
    pidlResultType["Fail"] = "failed";
    pidlResultType["Passed"] = "passed";
})(pidlResultType || (pidlResultType = {}));
var pidlResourceTypes;
(function (pidlResourceTypes) {
    pidlResourceTypes["PaymentInstrument"] = "PaymentInstrument";
    pidlResourceTypes["Challenge"] = "Challenge";
    pidlResourceTypes["Address"] = "Address";
    pidlResourceTypes["Profile"] = "Profile";
    pidlResourceTypes["PaymentSession"] = "PaymentSession";
    pidlResourceTypes["Checkout"] = "Checkout";
    pidlResourceTypes["PayeeTaxProfile"] = "PayeeTaxProfile";
    pidlResourceTypes["WalletToken"] = "WalletToken";
})(pidlResourceTypes || (pidlResourceTypes = {}));
var htmlClassNames;
(function (htmlClassNames) {
    htmlClassNames["div"] = "pidlddc-div";
    htmlClassNames["errorDiv"] = "pidlddc-errordiv";
    htmlClassNames["label"] = "pidlddc-label";
    htmlClassNames["key"] = "pidlddc-input-key";
    htmlClassNames["property"] = "pidlddc-input-property";
    htmlClassNames["dropdown"] = "pidlddc-input-dropdown";
    htmlClassNames["radio"] = "pidlddc-input-radio";
    htmlClassNames["radioLabel"] = "pidlddc-radio-label";
    htmlClassNames["buttonList"] = "pidlddc-input-buttonlist";
    htmlClassNames["checkBox"] = "pidlddc-input-checkbox";
    htmlClassNames["textBox"] = "pidlddc-input-text";
    htmlClassNames["filePicker"] = "pidlddc-input-file";
    htmlClassNames["staticText"] = "pidlddc-static-text";
    htmlClassNames["heading"] = "pidlddc-heading";
    htmlClassNames["subHeading"] = "pidlddc-subheading";
    htmlClassNames["text"] = "pidlddc-text";
    htmlClassNames["textGroup"] = "pidlddc-text-group";
    htmlClassNames["hyperlink"] = "pidlddc-hyperlink";
    htmlClassNames["image"] = "pidlddc-image";
    htmlClassNames["error"] = "pidlddc-error";
    htmlClassNames["separator"] = "pidlddc-separator";
    htmlClassNames["pageBody"] = "pidlddc-page-body";
    htmlClassNames["logo"] = "pidlddc-logo-image";
    htmlClassNames["submitButton"] = "pidlddc-submit-button";
    htmlClassNames["button"] = "pidlddc-button";
    htmlClassNames["busyBlock"] = "pidlddc-busy-block";
    htmlClassNames["errorBlock"] = "pidlddc-error-block";
    htmlClassNames["errorInlineGroup"] = "pidlddc-error-inlineGroup";
    htmlClassNames["submitBlock"] = "pidlddc-submit-block";
    htmlClassNames["helpImage"] = "pidlddc-help-image";
    htmlClassNames["helpDialogBlock"] = "pidlddc-help-dialog-block";
    htmlClassNames["helpDialogContentBlock"] = "pidlddc-help-dialog-content-block";
    htmlClassNames["modalDialogBlock"] = "pidlddc-modal-dialog-block";
    htmlClassNames["modalDialogContentBlock"] = "pidlddc-modal-dialog-content-block";
    htmlClassNames["helpDialogClose"] = "pidlddc-help-dialog-close";
    htmlClassNames["helpImageLink"] = "pidlddc-help-imageLink";
    htmlClassNames["helpTextLink"] = "pidlddc-help-textLink";
    htmlClassNames["pageContentBlock"] = "pidlddc-pagecontent-block";
    htmlClassNames["prefillControl"] = "pidlddc-input-prefillcontrol";
    htmlClassNames["prefillCheckbox"] = "pidlddc-input-prefillcheckbox";
    htmlClassNames["prefillDropdown"] = "pidlddc-input-prefilldropdown";
    htmlClassNames["propertyDiv"] = "pidlddc-div-property";
    htmlClassNames["dropdownDiv"] = "pidlddc-div-dropdown";
    htmlClassNames["checkBoxDiv"] = "pidlddc-div-checkbox";
    htmlClassNames["textBoxDiv"] = "pidlddc-div-textbox";
    htmlClassNames["securePropertyDiv"] = "pidlddc-div-secureproperty";
    htmlClassNames["filePickerDiv"] = "pidlddc-div-filepicker";
    htmlClassNames["imageDiv"] = "pidlddc-div-image";
    htmlClassNames["logoDiv"] = "pidlddc-div-logo";
    htmlClassNames["buttonDiv"] = "pidlddc-div-button";
    htmlClassNames["groupDiv"] = "pidlddc-div-group";
    htmlClassNames["errorStroke"] = "pidlddc-errorstroke";
    htmlClassNames["highlighted"] = "pidlddc-highlighted";
    htmlClassNames["back"] = "pidlddc-back";
    htmlClassNames["inlineGroup"] = "pidlddc-group-inline";
    htmlClassNames["inputTextDisabled"] = "pidlddc-input-text-disabled";
    htmlClassNames["inputSelectDisabled"] = "pidlddc-input-select-disabled";
    htmlClassNames["displayLogo"] = "pidlddc-input-logo";
    htmlClassNames["filled"] = "pidlddc-filled";
    htmlClassNames["iFrame"] = "pidlddc-iFrame";
    htmlClassNames["secureProperty"] = "pidlddc-secure-property";
    htmlClassNames["iFrameDiv"] = "pidlddc-div-iFrame";
    htmlClassNames["captchaDiv"] = "pidlddc-div-captcha";
    htmlClassNames["audio"] = "pidlddc-audio";
    htmlClassNames["challengeIFrame"] = "pidlddc-challengeiFrame";
    htmlClassNames["challengeIFrameDiv"] = "pidlddc-div-challengeiFrame";
})(htmlClassNames || (htmlClassNames = {}));
var htmlClassPrefixes;
(function (htmlClassPrefixes) {
    htmlClassPrefixes["index"] = "pidlddc-inline-element-";
    htmlClassPrefixes["taggedClass"] = "pidlddc-";
})(htmlClassPrefixes || (htmlClassPrefixes = {}));
var htmlElementIdPrefixes;
(function (htmlElementIdPrefixes) {
    htmlElementIdPrefixes["div"] = "pidlddc-div-";
    htmlElementIdPrefixes["error"] = "pidlddc-error-";
    htmlElementIdPrefixes["label"] = "pidlddc-label-";
    htmlElementIdPrefixes["text"] = "pidlddc-text-";
    htmlElementIdPrefixes["hyperlink"] = "pidlddc-hyperlink-";
    htmlElementIdPrefixes["property"] = "pidlddc-input-";
    htmlElementIdPrefixes["button"] = "pidlddc-button-";
    htmlElementIdPrefixes["audio"] = "pidlddc-audio-";
    htmlElementIdPrefixes["buttongroup"] = "pidlddc-button-group-";
    htmlElementIdPrefixes["iFrame"] = "pidlddc-iFrame-";
    htmlElementIdPrefixes["challengeiFrame"] = "pidlddc-challengeiFrame-";
    htmlElementIdPrefixes["input"] = "input_";
    htmlElementIdPrefixes["iframe"] = "iframe_";
    htmlElementIdPrefixes["filePicker"] = "filepicker_";
    htmlElementIdPrefixes["secureProperty"] = "pidlddc-secure-input-";
    htmlElementIdPrefixes["image"] = "pidlddc-image-";
    htmlElementIdPrefixes["helpDialog"] = "helpdialog-";
    htmlElementIdPrefixes["helpDialogContent"] = "helpdialog-content-";
    htmlElementIdPrefixes["modalDialog"] = "modaldialog-";
    htmlElementIdPrefixes["modalDialogContent"] = "modaldialog-content-";
    htmlElementIdPrefixes["prefillControl"] = "pidlddc-prefillcontrol-";
    htmlElementIdPrefixes["maxLength"] = "pidlddc-maxlength-";
    htmlElementIdPrefixes["logo"] = "pidlddc-logo-";
    htmlElementIdPrefixes["separator"] = "pidlddc-separator-";
    htmlElementIdPrefixes["spinner"] = "pidlddc-spinner-";
})(htmlElementIdPrefixes || (htmlElementIdPrefixes = {}));
var htmlElementIdSuffixes;
(function (htmlElementIdSuffixes) {
    htmlElementIdSuffixes["pageBlock"] = "pagebodycontents";
    htmlElementIdSuffixes["pageLogoBlock"] = "pagelogoblock";
    htmlElementIdSuffixes["pageBusyBlock"] = "pagebusyblock";
    htmlElementIdSuffixes["pageErrorBlock"] = "pageerrorblock";
    htmlElementIdSuffixes["pageSubmitBlock"] = "pagesubmitblock";
    htmlElementIdSuffixes["helpDialogBlock"] = "pagehelpdialog";
    htmlElementIdSuffixes["modalDialogBlock"] = "pagemodaldialog";
    htmlElementIdSuffixes["displayImage"] = "displayImage";
    htmlElementIdSuffixes["closeButton"] = "closeButton";
    htmlElementIdSuffixes["prefillCheckbox"] = "prefillCheckbox";
})(htmlElementIdSuffixes || (htmlElementIdSuffixes = {}));
var errorCode;
(function (errorCode) {
    errorCode[errorCode["Unexpected"] = 1000] = "Unexpected";
    errorCode[errorCode["InvalidInput"] = 1001] = "InvalidInput";
    errorCode[errorCode["ServerError"] = 1002] = "ServerError";
})(errorCode || (errorCode = {}));
var returnCallbackNames;
(function (returnCallbackNames) {
    returnCallbackNames["success"] = "success";
    returnCallbackNames["failure"] = "failure";
    returnCallbackNames["gohome"] = "gohome";
})(returnCallbackNames || (returnCallbackNames = {}));
var modelElementType;
(function (modelElementType) {
    modelElementType["unknown"] = "modelElementType_unknown";
    modelElementType["page"] = "modelElementType_page";
    modelElementType["group"] = "modelElementType_group";
    modelElementType["captcha"] = "modelElementType_captcha";
    modelElementType["audio"] = "modelElementType_audio";
    modelElementType["textGroup"] = "modelElementType_textGroup";
    modelElementType["heading"] = "modelElementType_heading";
    modelElementType["subheading"] = "modelElementType_subheading";
    modelElementType["text"] = "modelElementType_text";
    modelElementType["hyperlink"] = "modelElementType_hyperlink";
    modelElementType["image"] = "modelElementType_image";
    modelElementType["logo"] = "modelElementType_logo";
    modelElementType["dropdown"] = "modelElementType_dropdown";
    modelElementType["checkBox"] = "modelElementType_checkBox";
    modelElementType["textBox"] = "modelElementType_textBox";
    modelElementType["button"] = "modelElementType_button";
    modelElementType["expression"] = "modelElementType_expression";
    modelElementType["radio"] = "modelElementType_radio";
    modelElementType["buttonList"] = "modelElementType_buttonlist";
    modelElementType["pidlContainer"] = "modelElementType_pidlContainer";
    modelElementType["dataCollectionBindingGroup"] = "modelElementType_dataCollectionBindingGroup";
    modelElementType["iFrame"] = "modelElementType_iFrame";
    modelElementType["challengeIFrame"] = "modelElementType_challengeiFrame";
    modelElementType["filePicker"] = "modelElementType_filePicker";
    modelElementType["secureProperty"] = "modelElementType_secureProperty";
    modelElementType["separator"] = "modelElementType_separator";
    modelElementType["spinner"] = "modelElementType_spinner";
})(modelElementType || (modelElementType = {}));
var textBlockTypes;
(function (textBlockTypes) {
    textBlockTypes["modelElementType_heading"] = "h1";
    textBlockTypes["modelElementType_subheading"] = "h2";
    textBlockTypes["modelElementType_text"] = "p";
    textBlockTypes["modelElementType_expression"] = "p";
    textBlockTypes["modelElementType_textGroup"] = "p";
})(textBlockTypes || (textBlockTypes = {}));
var htmlBlockTypes;
(function (htmlBlockTypes) {
    htmlBlockTypes["button"] = "button";
    htmlBlockTypes["iFrame"] = "iframe";
    htmlBlockTypes["div"] = "div";
    htmlBlockTypes["hyperlink"] = "a";
    htmlBlockTypes["image"] = "img";
    htmlBlockTypes["input"] = "input";
    htmlBlockTypes["label"] = "label";
    htmlBlockTypes["select"] = "select";
    htmlBlockTypes["span"] = "span";
    htmlBlockTypes["h1"] = "h1";
    htmlBlockTypes["h2"] = "h2";
    htmlBlockTypes["hr"] = "hr";
    htmlBlockTypes["audio"] = "audio";
})(htmlBlockTypes || (htmlBlockTypes = {}));
var htmlInputTypes;
(function (htmlInputTypes) {
    htmlInputTypes["image"] = "image";
    htmlInputTypes["button"] = "button";
    htmlInputTypes["password"] = "password";
    htmlInputTypes["radio"] = "radio";
    htmlInputTypes["checkbox"] = "checkbox";
    htmlInputTypes["file"] = "file";
})(htmlInputTypes || (htmlInputTypes = {}));
var telemetryPidlOperationType;
(function (telemetryPidlOperationType) {
    telemetryPidlOperationType["add"] = "Add";
    telemetryPidlOperationType["replace"] = "Replace";
    telemetryPidlOperationType["createPaymentSession"] = "createPaymentSession";
    telemetryPidlOperationType["getSelectedResource"] = "GetSelectedResource";
    telemetryPidlOperationType["handleAction"] = "HandleAction";
    telemetryPidlOperationType["handlePaymentChallenge"] = "handlePaymentChallenge";
    telemetryPidlOperationType["handlePurchasePendingState"] = "handlePurchasePendingState";
    telemetryPidlOperationType["handlePurchaseRiskChallenge"] = "handlePurchaseRiskChallenge";
    telemetryPidlOperationType["invokeResourceAction"] = "InvokeResourceAction";
    telemetryPidlOperationType["renderPidlDocument"] = "renderPidlDocument";
    telemetryPidlOperationType["renderPidlPage"] = "RenderPidlPage";
    telemetryPidlOperationType["selectResource"] = "SelectResource";
    telemetryPidlOperationType["selectResourceType"] = "SelectResourceType";
    telemetryPidlOperationType["selectSingleResource"] = "SelectSingleResource";
    telemetryPidlOperationType["show"] = "Show";
    telemetryPidlOperationType["offer"] = "Offer";
    telemetryPidlOperationType["search"] = "Search";
    telemetryPidlOperationType["update"] = "Update";
    telemetryPidlOperationType["validateResource"] = "ValidateResource";
    telemetryPidlOperationType["verify"] = "Verify";
    telemetryPidlOperationType["fundStoredValue"] = "fundStoredValue";
    telemetryPidlOperationType["addAddress"] = "addAddress";
    telemetryPidlOperationType["addPaymentInstrument"] = "addPaymentInstrument";
    telemetryPidlOperationType["selectPaymentInstrument"] = "selectPaymentInstrument";
    telemetryPidlOperationType["applyResource"] = "applyResource";
    telemetryPidlOperationType["listAddress"] = "listAddress";
    telemetryPidlOperationType["updateProfile"] = "updateProfile";
    telemetryPidlOperationType["handleCheckout"] = "handleCheckout";
    telemetryPidlOperationType["delete"] = "Delete";
    telemetryPidlOperationType["getPayeeTaxProfile"] = "getPayeeTaxProfile";
    telemetryPidlOperationType["redeemMSRewards"] = "redeemMSRewards";
    telemetryPidlOperationType["searchTransactions"] = "searchTransactions";
    telemetryPidlOperationType["selectMSRewards"] = "selectMSRewards";
})(telemetryPidlOperationType || (telemetryPidlOperationType = {}));
var showDisplayNameValues;
(function (showDisplayNameValues) {
    showDisplayNameValues["stringTrue"] = "true";
    showDisplayNameValues["stringFalse"] = "false";
    showDisplayNameValues["stringOptional"] = "optional";
})(showDisplayNameValues || (showDisplayNameValues = {}));
var supportedPidlActions;
(function (supportedPidlActions) {
    supportedPidlActions["submit"] = "submit";
    supportedPidlActions["submitOriginalPidl"] = "submitOriginalPidl";
    supportedPidlActions["gohome"] = "gohome";
    supportedPidlActions["next"] = "moveNext";
    supportedPidlActions["prev"] = "movePrevious";
    supportedPidlActions["first"] = "moveFirst";
    supportedPidlActions["last"] = "moveLast";
    supportedPidlActions["success"] = "success";
    supportedPidlActions["navigate"] = "navigate";
    supportedPidlActions["triggerEvent"] = "triggerEvent";
    supportedPidlActions["partnerAction"] = "partnerAction";
    supportedPidlActions["redirect"] = "redirect";
    supportedPidlActions["restAction"] = "restAction";
    supportedPidlActions["restartFlow"] = "restartFlow";
    supportedPidlActions["successWithPidlPayload"] = "successWithPidlPayload";
    supportedPidlActions["navigateAndNext"] = "navigateAndMoveNext";
    supportedPidlActions["validate"] = "validate";
    supportedPidlActions["poll"] = "poll";
    supportedPidlActions["moveNextAndPoll"] = "moveNextAndPoll";
    supportedPidlActions["handleFailure"] = "handleFailure";
    supportedPidlActions["updatePoll"] = "updatePoll";
    supportedPidlActions["continueSuspendedAction"] = "continueSuspendedAction";
    supportedPidlActions["closeModalDialog"] = "closeModalDialog";
    supportedPidlActions["mergeData"] = "mergeData";
    supportedPidlActions["propertyBindingAction"] = "propertyBindingAction";
    supportedPidlActions["closePidlPage"] = "closePidlPage";
    supportedPidlActions["successWithSelectedPidlAction"] = "successWithSelectedPidlAction";
    supportedPidlActions["updatePollAndMoveLast"] = "updatePollAndMoveLast";
    supportedPidlActions["noAction"] = "noAction";
    supportedPidlActions["moveToPageIndex"] = "moveToPageIndex";
})(supportedPidlActions || (supportedPidlActions = {}));
var resourceActions;
(function (resourceActions) {
    resourceActions["selectSingleResource"] = "selectSingleResource";
    resourceActions["selectResource"] = "selectResource";
    resourceActions["selectResourceType"] = "selectResourceType";
    resourceActions["addResource"] = "addResource";
    resourceActions["updateResource"] = "updateResource";
    resourceActions["deleteResource"] = "deleteResource";
    resourceActions["handleChallenge"] = "handleChallenge";
    resourceActions["collectResourceInfo"] = "collectResourceInfo";
    resourceActions["addAddress"] = "addAddress";
    resourceActions["selectPaymentInstrument"] = "selectPaymentInstrument";
    resourceActions["addPaymentInstrument"] = "addPaymentInstrument";
    resourceActions["updateProfile"] = "updateProfile";
    resourceActions["searchTransactions"] = "searchTransactions";
})(resourceActions || (resourceActions = {}));
var eventNames;
(function (eventNames) {
    eventNames["error"] = "error";
    eventNames["styleSheetError"] = "styleSheetError";
    eventNames["captchaRendered"] = "captchaRendered";
    eventNames["propertyCreating"] = "propertyCreating";
    eventNames["propertySelected"] = "propertySelected";
    eventNames["toggleClicked"] = "toggleClicked";
    eventNames["instanceDownloading"] = "instanceDownloading";
    eventNames["instanceDownloaded"] = "instanceDownloaded";
    eventNames["pidlDownloading"] = "pidlDownloading";
    eventNames["pidlDownloaded"] = "pidlDownloaded";
    eventNames["pageRendering"] = "pageRendering";
    eventNames["pageRendered"] = "pageRendered";
    eventNames["pageRefreshed"] = "pageRefreshed";
    eventNames["pageDisplayed"] = "pageDisplayed";
    eventNames["inputReading"] = "inputReading";
    eventNames["inputRead"] = "inputRead";
    eventNames["inputValidating"] = "inputValidating";
    eventNames["inputValidated"] = "inputValidated";
    eventNames["inputTokenizing"] = "inputTokenizing";
    eventNames["inputTokenized"] = "inputTokenized";
    eventNames["inputSubmitting"] = "inputSubmitting";
    eventNames["inputSubmitted"] = "inputSubmitted";
    eventNames["redirecting"] = "redirecting";
    eventNames["implementationMissing"] = "implementationMissing";
    eventNames["navigate"] = "navigate";
    eventNames["triggerEvent"] = "triggerEvent";
    eventNames["partnerAction"] = "partnerAction";
    eventNames["propertyValidated"] = "propertyValidated";
    eventNames["propertyTokenizing"] = "propertyTokenizing";
    eventNames["propertyTokenized"] = "propertyTokenized";
    eventNames["propertyTransforming"] = "propertyTransforming";
    eventNames["propertyTransformed"] = "propertyTransformed";
    eventNames["resourceSelected"] = "resourceSelected";
    eventNames["pageNavigated"] = "pageNavigated";
    eventNames["click"] = "click";
    eventNames["payloadCreated"] = "payloadCreated";
    eventNames["restMethodInvoking"] = "restMethodInvoking";
    eventNames["restMethodInvoked"] = "restMethodInvoked";
    eventNames["noSelectionOptionsFound"] = "noSelectionOptionsFound";
    eventNames["selectionChanged"] = "selectionChanged";
    eventNames["fetchCallCompleted"] = "fetchCallCompleted";
    eventNames["renderedPidlPage"] = "renderedPidlPage";
    eventNames["closePidlPage"] = "closePidlPage";
    eventNames["submitOriginalPidl"] = "submitOriginalPidl";
    eventNames["fileUploading"] = "fileUploading";
    eventNames["fileUploaded"] = "fileUploaded";
    eventNames["isDisabled"] = "isDisabled";
    eventNames["propertyConditionallyUpdated"] = "propertyConditionallyUpdated";
    eventNames["challengeMessageReceived"] = "challengeMessageReceived";
    eventNames["getLocalDataSourceInvoked"] = "getLocalDataSourceInvoked";
    eventNames["getLocalDataSourceResolved"] = "getLocalDataSourceResolved";
    eventNames["getLocalDataSourceError"] = "getLocalDataSourceError";
})(eventNames || (eventNames = {}));
var privateEventNames;
(function (privateEventNames) {
    privateEventNames["apiCalled"] = "apiCalled";
    privateEventNames["apiReturned"] = "apiReturned";
    privateEventNames["modelUpdated"] = "modelUpdated";
    privateEventNames["dataUpdated"] = "dataUpdated";
    privateEventNames["failure"] = "failure";
    privateEventNames["success"] = "success";
    privateEventNames["gohome"] = "gohome";
    privateEventNames["stateChanged"] = "stateChanged";
    privateEventNames["propertyCreated"] = "propertyCreated";
    privateEventNames["propertyUnselected"] = "propertyUnselected";
    privateEventNames["conflictingInputValues"] = "conflictingInputValues";
    privateEventNames["pidlResolved"] = "pidlResolved";
    privateEventNames["secureFieldEventReceived"] = "secureFieldEventReceived";
    privateEventNames["secureFieldEventQueued"] = "secureFieldEventQueued";
    privateEventNames["secureFieldEventPosted"] = "secureFieldEventPosted";
    privateEventNames["secureFieldLoadWaitStarted"] = "secureFieldWaitStarted";
    privateEventNames["secureFieldsLoaded"] = "secureFieldsLoaded";
    privateEventNames["secureFieldLoadWaitEnded"] = "secureFieldWaitEnded";
    privateEventNames["challengeMessageReceived"] = "challengeMessageReceived";
    privateEventNames["postMessageReceived"] = "postMessageReceived";
    privateEventNames["postMessageHandleSuccess"] = "postMessageHandleSuccess";
    privateEventNames["postMessageHandleFailure"] = "postMessageHandleFailure";
    privateEventNames["postMessageTimeoutHandleSuccess"] = "postMessageTimeoutHandleSuccess";
    privateEventNames["postMessageTimeoutHandleFailure"] = "postMessageTimeoutHandleFailure";
    privateEventNames["postMessageBusyTimerStarted"] = "postMessageBusyTimerStarted";
    privateEventNames["postMessageBusyTimerEnded"] = "postMessageBusyTimerEnded";
    privateEventNames["pollingStarted"] = "pollingStarted";
    privateEventNames["pollingEnded"] = "pollingEnded";
    privateEventNames["resourceHelpersFunctionExecuted"] = "resourceHelpersFunctionExecuted";
    privateEventNames["submitting"] = "submitting";
    privateEventNames["submitted"] = "submitted";
    privateEventNames["pollClientActionSuccess"] = "pollClientActionSuccess";
    privateEventNames["pollClientActionFailure"] = "pollClientActionFailure";
    privateEventNames["hideModalDialog"] = "hideModalDialog";
    privateEventNames["updatePollAndMoveLast"] = "updatePollAndMoveLast";
    privateEventNames["pidlActionInvoked"] = "pidlActionInvoked";
    privateEventNames["clientActionInvoked"] = "clientActionInvoked";
    privateEventNames["propertyValueSelected"] = "propertyValueSelected";
    privateEventNames["eventExtenderRegistered"] = "eventExtenderRegistered";
    privateEventNames["addSecureFieldPreLoadIFrameStarted"] = "addSecureFieldPreLoadIFrameStarted";
    privateEventNames["addSecureFieldPreLoadIFrameCompleted"] = "addSecureFieldPreLoadIFrameCompleted";
    privateEventNames["addSecureFieldPreLoadIFrameFailed"] = "addSecureFieldPreLoadIFrameFailed";
})(privateEventNames || (privateEventNames = {}));
var displayOptionNames;
(function (displayOptionNames) {
    displayOptionNames["containerId"] = "containerId";
    displayOptionNames["busyBlockId"] = "busyBlockId";
    displayOptionNames["busyBlockShowHideHandler"] = "busyBlockShowHideHandler";
    displayOptionNames["inputPropertyIdPrefix"] = "inputPropertyIdPrefix";
    displayOptionNames["inputPropertyIdSuffix"] = "inputPropertyIdSuffix";
    displayOptionNames["displayElementIdPrefix"] = "displayElementIdPrefix";
    displayOptionNames["displayElementIdSuffix"] = "displayElementIdSuffix";
    displayOptionNames["inputPropertyErrorIdPrefix"] = "inputPropertyErrorIdPrefix";
    displayOptionNames["showPlaceholderInTextbox"] = "showPlaceholderInTextbox";
    displayOptionNames["showSubmitBlock"] = "showSubmitBlock";
    displayOptionNames["showErrorBlock"] = "showErrorBlock";
    displayOptionNames["disableEnterKeyAction"] = "disableEnterKeyAction";
    displayOptionNames["htmlExtender"] = "htmlExtender";
    displayOptionNames["hidePropertyErrors"] = "hidePropertyErrors";
    displayOptionNames["disableFocusOnLoad"] = "disableFocusOnLoad";
    displayOptionNames["alwaysValidateOnChange"] = "alwaysValidateOnChange";
    displayOptionNames["ieExtender"] = "ieExtender";
    displayOptionNames["propagateCallbackException"] = "propagateCallbackException";
    displayOptionNames["useWebView2"] = "useWebView2";
    displayOptionNames["busyUntilInitialPageRendered"] = "busyUntilInitialPageRendered";
    displayOptionNames["secureFieldPreLoadingEnabled"] = "secureFieldPreLoadingEnabled";
})(displayOptionNames || (displayOptionNames = {}));
var errorNames;
(function (errorNames) {
    errorNames["formValidationFailed"] = "formValidationFailed";
    errorNames["editedPropertiesValidationFailed"] = "editedPropertiesValidationFailed";
})(errorNames || (errorNames = {}));
var errorTypes;
(function (errorTypes) {
    errorTypes["inputValidation"] = "inputValidationError";
    errorTypes["userInputValidation"] = "userInputValidationError";
    errorTypes["formValidation"] = "formValidationFailed";
    errorTypes["unexpected"] = "unexpected";
    errorTypes["serverError"] = "serverError";
    errorTypes["missingImplementationError"] = "missingImplementationError";
    errorTypes["invalidSetup"] = "invalidSetup";
    errorTypes["paymentMethodFailure"] = "paymentMethodFailure";
    errorTypes["failedToOpenWindow"] = "failedToOpenWindow";
    errorTypes["unmatchedAmount"] = "unmatchedAmount";
    errorTypes["walletProvider"] = "walletProvider";
    errorTypes["secureFieldInitCompletedTimeout"] = "secureFieldInitCompletedTimeout";
})(errorTypes || (errorTypes = {}));
var serverErrorTypes;
(function (serverErrorTypes) {
    serverErrorTypes["validationFailed"] = "ValidationFailed";
    serverErrorTypes["tokenizationFailed"] = "TokenizationFailed";
    serverErrorTypes["fileUploadFailed"] = "FileUploadFailed";
})(serverErrorTypes || (serverErrorTypes = {}));
var validationErrorTypes;
(function (validationErrorTypes) {
    validationErrorTypes["property"] = "property";
    validationErrorTypes["group"] = "group";
})(validationErrorTypes || (validationErrorTypes = {}));
var validationOptions;
(function (validationOptions) {
    validationOptions["all"] = "all";
    validationOptions["dirtyOnly"] = "dirtyOnly";
})(validationOptions || (validationOptions = {}));
var validationErrorCodes;
(function (validationErrorCodes) {
    validationErrorCodes["empty"] = "required_field_empty";
})(validationErrorCodes || (validationErrorCodes = {}));
var htmlElementTypes;
(function (htmlElementTypes) {
    htmlElementTypes["div"] = "htmlElementType_div";
    htmlElementTypes["label"] = "htmlElementType_label";
    htmlElementTypes["captcha"] = "htmlElementType_captcha";
    htmlElementTypes["audio"] = "htmlElementType_audio";
    htmlElementTypes["dropdown"] = "htmlElementType_dropdown";
    htmlElementTypes["checkBox"] = "htmlElementType_checkBox";
    htmlElementTypes["radio"] = "htmlElementType_radio";
    htmlElementTypes["buttonList"] = "htmlElementType_buttonList";
    htmlElementTypes["textBox"] = "htmlElementType_textBox";
    htmlElementTypes["filePicker"] = "htmlElementType_filePicker";
    htmlElementTypes["button"] = "htmlElementType_button";
    htmlElementTypes["iFrame"] = "htmlElementType_iFrame";
    htmlElementTypes["challengeIFrame"] = "htmlElementType_challengeiFrame";
    htmlElementTypes["secureProperty"] = "htmlElementType_secureProperty";
    htmlElementTypes["heading"] = "htmlElementType_text_heading";
    htmlElementTypes["subHeading"] = "htmlElementType_text_subheading";
    htmlElementTypes["text"] = "htmlElementType_text";
    htmlElementTypes["textGroup"] = "htmlElementType_textGroup";
    htmlElementTypes["hyperlink"] = "htmlElementType_hyperlink";
    htmlElementTypes["image"] = "htmlElementType_image";
    htmlElementTypes["logo"] = "htmlElementType_logo";
    htmlElementTypes["errorDiv"] = "htmlElementType_errorDiv";
    htmlElementTypes["error"] = "htmlElementType_error";
    htmlElementTypes["separator"] = "htmlElementType_separator";
})(htmlElementTypes || (htmlElementTypes = {}));
var containerTypes;
(function (containerTypes) {
    containerTypes["busyBlock"] = "busyBlock";
    containerTypes["errorBlock"] = "errorBlock";
    containerTypes["helpDialogBlock"] = "helpDialogBlock";
    containerTypes["helpDialogContentBlock"] = "helpDialogContentBlock";
    containerTypes["pageContentBlock"] = "pageContentBlock";
    containerTypes["submitBlock"] = "submitBlock";
    containerTypes["modalDialogBlock"] = "modalDialogBlock";
    containerTypes["modalDialogContentBlock"] = "modalDialogContentBlock";
})(containerTypes || (containerTypes = {}));
var httpHeaders;
(function (httpHeaders) {
    httpHeaders["authorization"] = "authorization";
    httpHeaders["contentType"] = "content-type";
    httpHeaders["msCV"] = "ms-cv";
    httpHeaders["msCorrelationId"] = "x-ms-correlation-id";
    httpHeaders["msFlight"] = "x-ms-flight";
    httpHeaders["msTrackingId"] = "x-ms-tracking-id";
    httpHeaders["msRetryOnServerErr"] = "x-ms-px-retry-servererr";
    httpHeaders["correlationContext"] = "Correlation-Context";
    httpHeaders["msPidlsdkVersion"] = "x-ms-pidlsdk-version";
    httpHeaders["msTest"] = "x-ms-test";
    httpHeaders["msClientContext"] = "x-ms-pidlsdk-clientcontext";
})(httpHeaders || (httpHeaders = {}));
var flightHeaders;
(function (flightHeaders) {
    flightHeaders["enablePaymentAgentChallenge"] = "pidl-enable-payment-agent-challenge";
})(flightHeaders || (flightHeaders = {}));
var httpUrlQueryParameters;
(function (httpUrlQueryParameters) {
    httpUrlQueryParameters["operation"] = "operation";
})(httpUrlQueryParameters || (httpUrlQueryParameters = {}));
var htmlAttributes;
(function (htmlAttributes) {
    htmlAttributes["role"] = "role";
    htmlAttributes["required"] = "required";
    htmlAttributes["src"] = "src";
    htmlAttributes["controls"] = "controls";
})(htmlAttributes || (htmlAttributes = {}));
var pidlPayloadAttributes;
(function (pidlPayloadAttributes) {
    pidlPayloadAttributes["pidlInfo"] = "pidlInfo";
    pidlPayloadAttributes["paymentInstruments"] = "paymentInstruments";
})(pidlPayloadAttributes || (pidlPayloadAttributes = {}));
var htmlTags;
(function (htmlTags) {
    htmlTags["alt"] = "alt";
    htmlTags["tabIndex"] = "tabindex";
})(htmlTags || (htmlTags = {}));
var htmlNodeTypes;
(function (htmlNodeTypes) {
    htmlNodeTypes[htmlNodeTypes["element"] = 1] = "element";
    htmlNodeTypes[htmlNodeTypes["attribute"] = 2] = "attribute";
    htmlNodeTypes[htmlNodeTypes["text"] = 3] = "text";
    htmlNodeTypes[htmlNodeTypes["comment"] = 8] = "comment";
})(htmlNodeTypes || (htmlNodeTypes = {}));
var htmlRoles;
(function (htmlRoles) {
    htmlRoles["alert"] = "alert";
    htmlRoles["dialog"] = "dialog";
    htmlRoles["combobox"] = "combobox";
    htmlRoles["radiogroup"] = "radiogroup";
    htmlRoles["radio"] = "radio";
    htmlRoles["presentation"] = "presentation";
    htmlRoles["group"] = "group";
    htmlRoles["image"] = "img";
    htmlRoles["separator"] = "separator";
    htmlRoles["audio"] = "audio";
})(htmlRoles || (htmlRoles = {}));
var ariaTags;
(function (ariaTags) {
    ariaTags["activedescendant"] = "aria-activedescendant";
    ariaTags["describedBy"] = "aria-describedby";
    ariaTags["disabled"] = "aria-disabled";
    ariaTags["expanded"] = "aria-expanded";
    ariaTags["hidden"] = "aria-hidden";
    ariaTags["label"] = "aria-label";
    ariaTags["labelledBy"] = "aria-labelledby";
    ariaTags["live"] = "aria-live";
    ariaTags["selected"] = "aria-selected";
    ariaTags["checked"] = "aria-checked";
    ariaTags["required"] = "aria-required";
})(ariaTags || (ariaTags = {}));
var ariaLiveInterruptLevels;
(function (ariaLiveInterruptLevels) {
    ariaLiveInterruptLevels["polite"] = "polite";
    ariaLiveInterruptLevels["assertive"] = "assertive";
    ariaLiveInterruptLevels["off"] = "off";
})(ariaLiveInterruptLevels || (ariaLiveInterruptLevels = {}));
var dataAttributes;
(function (dataAttributes) {
    dataAttributes["errorBlockId"] = "data-pidl-error-block-id";
})(dataAttributes || (dataAttributes = {}));
// Reverse of pidlPropertyNameToPidlDocInfoProperty, must be updated together
var sdkParamUrlQueryParamMap;
(function (sdkParamUrlQueryParamMap) {
    sdkParamUrlQueryParamMap["market"] = "country";
})(sdkParamUrlQueryParamMap || (sdkParamUrlQueryParamMap = {}));
// Reverse of sdkParamUrlQueryParamMap, must be updated together
var pidlPropertyNameToPidlDocInfoProperty;
(function (pidlPropertyNameToPidlDocInfoProperty) {
    pidlPropertyNameToPidlDocInfoProperty["country"] = "market";
})(pidlPropertyNameToPidlDocInfoProperty || (pidlPropertyNameToPidlDocInfoProperty = {}));
var themes;
(function (themes) {
    themes["windows"] = "windows";
})(themes || (themes = {}));
var pidlStringKeys;
(function (pidlStringKeys) {
    pidlStringKeys["closeButtonHelpText"] = "closeButtonAccessiblityName";
    pidlStringKeys["prefillDropdownDefault"] = "dropdown_default";
    pidlStringKeys["prefillDropdownNew"] = "dropdown_new";
})(pidlStringKeys || (pidlStringKeys = {}));
var controlStates;
(function (controlStates) {
    controlStates["notInitialized"] = "notInitialized";
    controlStates["initialized"] = "initialized";
    controlStates["executing"] = "executing";
    controlStates["submitting"] = "submitting";
})(controlStates || (controlStates = {}));
var propertyEditState;
(function (propertyEditState) {
    propertyEditState["clean"] = "clean";
    propertyEditState["editing"] = "editing";
    propertyEditState["dirty"] = "dirty";
})(propertyEditState || (propertyEditState = {}));
var controlOperationTypes;
(function (controlOperationTypes) {
    controlOperationTypes["ready"] = "ready";
    controlOperationTypes["selected"] = "selected";
    controlOperationTypes["editing"] = "editing";
    controlOperationTypes["finished"] = "finished";
})(controlOperationTypes || (controlOperationTypes = {}));
var errorValue;
(function (errorValue) {
    errorValue["empty"] = "[]";
})(errorValue || (errorValue = {}));
var viewUpdateReasons;
(function (viewUpdateReasons) {
    viewUpdateReasons["pageNavigated"] = "pageNavigated";
    viewUpdateReasons["modelCreated"] = "modelCreated";
    viewUpdateReasons["modelUpdated"] = "modelUpdated";
    viewUpdateReasons["prefillChanged"] = "prefillChanged";
})(viewUpdateReasons || (viewUpdateReasons = {}));
var pidlDdcApiNames;
(function (pidlDdcApiNames) {
    pidlDdcApiNames["constructor"] = "constructor";
    pidlDdcApiNames["addResource"] = "addResource";
    pidlDdcApiNames["applyResource"] = "applyResource";
    pidlDdcApiNames["replaceResource"] = "replaceResource";
    pidlDdcApiNames["cancel"] = "cancel";
    pidlDdcApiNames["createPaymentSession"] = "createPaymentSession";
    pidlDdcApiNames["getPidlPayload"] = "getPidlPayload";
    pidlDdcApiNames["getSelectedResource"] = "getSelectedResource";
    pidlDdcApiNames["handleAction"] = "handleAction";
    pidlDdcApiNames["handleChallenge"] = "handleChallenge";
    pidlDdcApiNames["handlePaymentChallenge"] = "handlePaymentChallenge";
    pidlDdcApiNames["handlePurchasePendingState"] = "handlePurchasePendingState";
    pidlDdcApiNames["handlePurchaseRiskChallenge"] = "handlePurchaseRiskChallenge";
    pidlDdcApiNames["invokePageDefaultAction"] = "invokePageDefaultAction";
    pidlDdcApiNames["invokeResourceAction"] = "invokeResourceAction";
    pidlDdcApiNames["modelSubmitForm"] = "modelSubmitForm";
    pidlDdcApiNames["moveNextPage"] = "moveNextPage";
    pidlDdcApiNames["submitPage"] = "submitPage";
    pidlDdcApiNames["movePrevPage"] = "movePrevPage";
    pidlDdcApiNames["moveToLastPage"] = "moveToLastPage";
    pidlDdcApiNames["moveToFirstPage"] = "moveToFirstPage";
    pidlDdcApiNames["postMessageToChildIFrames"] = "postMessageToChildiFrames";
    pidlDdcApiNames["refreshData"] = "refreshData";
    pidlDdcApiNames["renderPidlDocument"] = "renderPidlDocument";
    pidlDdcApiNames["renderPidlPage"] = "renderPidlPage";
    pidlDdcApiNames["selectResource"] = "selectResource";
    pidlDdcApiNames["selectResourceType"] = "selectResourceType";
    pidlDdcApiNames["selectSingleResource"] = "selectSingleResource";
    pidlDdcApiNames["showResource"] = "showResource";
    pidlDdcApiNames["searchResource"] = "searchResource";
    pidlDdcApiNames["updateResource"] = "updateResource";
    pidlDdcApiNames["validateResource"] = "validateResource";
    pidlDdcApiNames["fundStoredValue"] = "fundStoredValue";
    pidlDdcApiNames["addAddress"] = "addAddress";
    pidlDdcApiNames["addPaymentInstrument"] = "addPaymentInstrument";
    pidlDdcApiNames["selectPaymentInstrument"] = "selectPaymentInstrument";
    pidlDdcApiNames["listAddress"] = "listAddress";
    pidlDdcApiNames["updateProfile"] = "updateProfile";
    pidlDdcApiNames["handleCheckout"] = "handleCheckout";
    pidlDdcApiNames["deleteResource"] = "deleteResource";
    pidlDdcApiNames["getPayeeTaxProfile"] = "getPayeeTaxProfile";
    pidlDdcApiNames["redeemMSRewards"] = "redeemMSRewards";
    pidlDdcApiNames["searchTransactions"] = "searchTransactions";
    pidlDdcApiNames["offerResource"] = "offerResource";
    pidlDdcApiNames["selectMSRewards"] = "selectMSRewards";
})(pidlDdcApiNames || (pidlDdcApiNames = {}));
var keyCodes;
(function (keyCodes) {
    keyCodes[keyCodes["arrowDown"] = 40] = "arrowDown";
    keyCodes[keyCodes["arrowUp"] = 38] = "arrowUp";
    keyCodes[keyCodes["enter"] = 13] = "enter";
    keyCodes[keyCodes["escape"] = 27] = "escape";
    keyCodes[keyCodes["xboxBackButton"] = 196] = "xboxBackButton";
    keyCodes[keyCodes["xboxEnterButton"] = 207] = "xboxEnterButton";
})(keyCodes || (keyCodes = {}));
var dataTypes;
(function (dataTypes) {
    dataTypes["hidden"] = "hidden";
    dataTypes["number"] = "number";
    dataTypes["bool"] = "bool";
    dataTypes["object"] = "object";
    dataTypes["returnObject"] = "returnObject";
})(dataTypes || (dataTypes = {}));
var clientDataTypes;
(function (clientDataTypes) {
    clientDataTypes["sessionId"] = "sessionId";
    clientDataTypes["riskData"] = "riskData";
    clientDataTypes["greenId"] = "greenId";
})(clientDataTypes || (clientDataTypes = {}));
var propertyTypes;
(function (propertyTypes) {
    propertyTypes["userData"] = "userData";
})(propertyTypes || (propertyTypes = {}));
var captchaPropertyName;
(function (captchaPropertyName) {
    captchaPropertyName["captchaType"] = "captchaType";
})(captchaPropertyName || (captchaPropertyName = {}));
var httpActions;
(function (httpActions) {
    httpActions["Get"] = "GET";
    httpActions["Post"] = "POST";
    httpActions["Put"] = "PUT";
    httpActions["Delete"] = "DELETE";
})(httpActions || (httpActions = {}));
var knownTags;
(function (knownTags) {
    knownTags["accessibilityName"] = "accessibilityName";
    knownTags["theme"] = "theme";
    knownTags["tabIndex"] = "tabIndex";
    knownTags["maxLengthMessage"] = "maxLengthMessage";
    knownTags["closeButtonAccessibilityName"] = "closeButtonAccessibilityName";
    knownTags["linkAccessibilityName"] = "linkAccessibilityName";
    knownTags["accessibilityHint"] = "accessibilityHint";
    knownTags["hideInlineError"] = "hideInlineError";
})(knownTags || (knownTags = {}));
var knownTagPrefixes;
(function (knownTagPrefixes) {
    // Used to add class without prefix (such as pidlddc)
    knownTagPrefixes["noPidlddc"] = "noPidlddc.";
    // To indicate tags for help dialog element of the main element
    knownTagPrefixes["helpDialog"] = "help.";
    // To pass custom prop to react elements
    // e.g. pidlReact.office-fabric.columnGap.10 would be used by pidl-office-fabric element factory
    // to set the column gap of the Stack that would be generated to 10
    // Requires implementation in the pidl-react element to pass the tag as classname and
    // in the element factory to use the value as a prop and not a classname
    knownTagPrefixes["pidlReact"] = "pidlReact.";
    knownTagPrefixes["parent"] = "parent.";
})(knownTagPrefixes || (knownTagPrefixes = {}));
var knownQueryParameters;
(function (knownQueryParameters) {
    knownQueryParameters["allowedCountries"] = "allowedCountries";
})(knownQueryParameters || (knownQueryParameters = {}));
var helpDialogPrefixedTags;
(function (helpDialogPrefixedTags) {
    helpDialogPrefixedTags["closeButtonAccessibilityName"] = "closeButtonAccessibilityName";
    helpDialogPrefixedTags["accessibilityName"] = "accessibilityName";
    helpDialogPrefixedTags["linkAccessibilityName"] = "linkAccessibilityName";
})(helpDialogPrefixedTags || (helpDialogPrefixedTags = {}));
var scenarioContextResourceType;
(function (scenarioContextResourceType) {
    scenarioContextResourceType["primary"] = "primary";
    scenarioContextResourceType["secondary"] = "secondary";
})(scenarioContextResourceType || (scenarioContextResourceType = {}));
var scenarioContextTerminatingErrorHandling;
(function (scenarioContextTerminatingErrorHandling) {
    scenarioContextTerminatingErrorHandling["ignore"] = "ignore";
    scenarioContextTerminatingErrorHandling["throw"] = "throw";
})(scenarioContextTerminatingErrorHandling || (scenarioContextTerminatingErrorHandling = {}));
var hmac;
(function (hmac) {
    hmac["token"] = "piAuthKey";
    hmac["algorithm"] = "hmacsha256";
    hmac["userCredential"] = "userCredential";
})(hmac || (hmac = {}));
var delimiters;
(function (delimiters) {
    delimiters["jarvisError"] = ".";
    delimiters["paymentMethodName"] = ".";
})(delimiters || (delimiters = {}));
var dataStores;
(function (dataStores) {
    dataStores["partnerData"] = "partnerData";
    dataStores["contextData"] = "contextData";
})(dataStores || (dataStores = {}));
var challengeScenario;
(function (challengeScenario) {
    challengeScenario["paymentTransaction"] = "PaymentTransaction";
    challengeScenario["recurringTransaction"] = "RecurringTransaction";
    challengeScenario["addCard"] = "AddCard";
})(challengeScenario || (challengeScenario = {}));
var riskChallengeIndicator;
(function (riskChallengeIndicator) {
    riskChallengeIndicator["noPreference"] = "NoPreference";
    riskChallengeIndicator["noChallengeRequested"] = "NoChallengeRequested";
    riskChallengeIndicator["challengeRequestedPreference"] = "ChallengeRequestedPreference";
    riskChallengeIndicator["challengeRequestedMandate"] = "ChallengeRequestedMandate";
})(riskChallengeIndicator || (riskChallengeIndicator = {}));
var challengeWindowSize;
(function (challengeWindowSize) {
    challengeWindowSize["small"] = "01";
    challengeWindowSize["medium"] = "02";
    challengeWindowSize["large"] = "03";
    challengeWindowSize["extraLarge"] = "04";
    challengeWindowSize["fullScreen"] = "05";
})(challengeWindowSize || (challengeWindowSize = {}));
var challengeStatus;
(function (challengeStatus) {
    challengeStatus["Succeeded"] = "Succeeded";
    challengeStatus["ByPassed"] = "ByPassed";
    challengeStatus["Failed"] = "Failed";
    challengeStatus["Cancelled"] = "Cancelled";
    challengeStatus["TimedOut"] = "TimedOut";
    challengeStatus["NotApplicable"] = "NotApplicable";
    challengeStatus["Unknown"] = "Unknown";
})(challengeStatus || (challengeStatus = {}));
var challengeType;
(function (challengeType) {
    challengeType["ThreeDS"] = "threeds";
    challengeType["CVV"] = "cvv";
    challengeType["SMS"] = "sms";
})(challengeType || (challengeType = {}));
var pollingInterval;
(function (pollingInterval) {
    pollingInterval[pollingInterval["Default"] = 3000] = "Default";
})(pollingInterval || (pollingInterval = {}));
var TextSymbols;
(function (TextSymbols) {
    TextSymbols["link"] = "](";
})(TextSymbols || (TextSymbols = {}));
var displayHelpPosition;
(function (displayHelpPosition) {
    displayHelpPosition["floatRight"] = "floatRight";
    displayHelpPosition["floatLeft"] = "floatLeft";
})(displayHelpPosition || (displayHelpPosition = {}));
var SecureFieldEvent;
(function (SecureFieldEvent) {
    SecureFieldEvent["loaded"] = "loaded";
    SecureFieldEvent["initCompleted"] = "initCompleted";
    SecureFieldEvent["readyForSubmit"] = "readyForSubmit";
    SecureFieldEvent["validationCompleted"] = "validationCompleted";
    SecureFieldEvent["valueUpdated"] = "valueUpdated";
    SecureFieldEvent["keyPropertyResolved"] = "keyPropertyResolved";
    SecureFieldEvent["focused"] = "focused";
    SecureFieldEvent["blurred"] = "blurred";
    SecureFieldEvent["hmacSignatureCreated"] = "hmacSignatureCreated";
})(SecureFieldEvent || (SecureFieldEvent = {}));
var SecureFieldMessages;
(function (SecureFieldMessages) {
    SecureFieldMessages["init"] = "init";
    SecureFieldMessages["hydrateState"] = "hydrateState";
    SecureFieldMessages["clearState"] = "clearState";
    SecureFieldMessages["applyPlaceholder"] = "applyPlaceholder";
    SecureFieldMessages["applyCss"] = "applyCss";
    SecureFieldMessages["applyFocus"] = "applyFocus";
    SecureFieldMessages["validate"] = "validate";
    SecureFieldMessages["prepareForSubmit"] = "prepareForSubmit";
    SecureFieldMessages["updateWidth"] = "updateWidth";
    SecureFieldMessages["createHmacSignature"] = "createHmacSignature";
})(SecureFieldMessages || (SecureFieldMessages = {}));
var SecureFieldConstants;
(function (SecureFieldConstants) {
    SecureFieldConstants[SecureFieldConstants["pidlSdkWaitTimeForSecureFieldsInit"] = 2000] = "pidlSdkWaitTimeForSecureFieldsInit";
    SecureFieldConstants["pidlSdkMessageSource"] = "PidlSdk";
    SecureFieldConstants["secureFieldMessageSource"] = "PXSecureField";
    SecureFieldConstants["tokenizationValuePrefix"] = "tokenized_";
})(SecureFieldConstants || (SecureFieldConstants = {}));
var ClientSettingNames;
(function (ClientSettingNames) {
    ClientSettingNames["pidlSdkWaitTimeForSecureFieldsInit"] = "pidlSdkWaitTimeForSecureFieldsInit";
})(ClientSettingNames || (ClientSettingNames = {}));
var ChallengeiFrameEvent;
(function (ChallengeiFrameEvent) {
    ChallengeiFrameEvent["challengeiFrameLoaded"] = "challengeiFrameLoaded";
    ChallengeiFrameEvent["challengeCompleted"] = "challengeCompleted";
})(ChallengeiFrameEvent || (ChallengeiFrameEvent = {}));
var ChallengeiFrameConstants;
(function (ChallengeiFrameConstants) {
    ChallengeiFrameConstants["challengeiFrameMessageSource"] = "ChallengeUI";
})(ChallengeiFrameConstants || (ChallengeiFrameConstants = {}));
var CustomTriggerEventConstants;
(function (CustomTriggerEventConstants) {
    CustomTriggerEventConstants["viewTermsTriggered"] = "viewTermsTriggered";
})(CustomTriggerEventConstants || (CustomTriggerEventConstants = {}));
var FrequencyUnitConstants;
(function (FrequencyUnitConstants) {
    FrequencyUnitConstants["year"] = "year";
    FrequencyUnitConstants["month"] = "month";
    FrequencyUnitConstants["day"] = "day";
    FrequencyUnitConstants["hour"] = "hour";
    FrequencyUnitConstants["minute"] = "minute";
})(FrequencyUnitConstants || (FrequencyUnitConstants = {}));
var PaymentMethodPIIDs;
(function (PaymentMethodPIIDs) {
    PaymentMethodPIIDs["applePay"] = "be4de87d-7e38-4b2d-8836-9237eb32848e";
})(PaymentMethodPIIDs || (PaymentMethodPIIDs = {}));

var constants = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get requestOriginator () { return requestOriginator; },
	get pidlTransformationTargets () { return pidlTransformationTargets; },
	get eventTypes () { return eventTypes; },
	get displayTransformationTargets () { return displayTransformationTargets; },
	get pidlResultType () { return pidlResultType; },
	get pidlResourceTypes () { return pidlResourceTypes; },
	get htmlClassNames () { return htmlClassNames; },
	get htmlClassPrefixes () { return htmlClassPrefixes; },
	get htmlElementIdPrefixes () { return htmlElementIdPrefixes; },
	get htmlElementIdSuffixes () { return htmlElementIdSuffixes; },
	get errorCode () { return errorCode; },
	get returnCallbackNames () { return returnCallbackNames; },
	get modelElementType () { return modelElementType; },
	get textBlockTypes () { return textBlockTypes; },
	get htmlBlockTypes () { return htmlBlockTypes; },
	get htmlInputTypes () { return htmlInputTypes; },
	get telemetryPidlOperationType () { return telemetryPidlOperationType; },
	get showDisplayNameValues () { return showDisplayNameValues; },
	get supportedPidlActions () { return supportedPidlActions; },
	get resourceActions () { return resourceActions; },
	get eventNames () { return eventNames; },
	get privateEventNames () { return privateEventNames; },
	get displayOptionNames () { return displayOptionNames; },
	get errorNames () { return errorNames; },
	get errorTypes () { return errorTypes; },
	get serverErrorTypes () { return serverErrorTypes; },
	get validationErrorTypes () { return validationErrorTypes; },
	get validationOptions () { return validationOptions; },
	get validationErrorCodes () { return validationErrorCodes; },
	get htmlElementTypes () { return htmlElementTypes; },
	get containerTypes () { return containerTypes; },
	get httpHeaders () { return httpHeaders; },
	get flightHeaders () { return flightHeaders; },
	get httpUrlQueryParameters () { return httpUrlQueryParameters; },
	get htmlAttributes () { return htmlAttributes; },
	get pidlPayloadAttributes () { return pidlPayloadAttributes; },
	get htmlTags () { return htmlTags; },
	get htmlNodeTypes () { return htmlNodeTypes; },
	get htmlRoles () { return htmlRoles; },
	get ariaTags () { return ariaTags; },
	get ariaLiveInterruptLevels () { return ariaLiveInterruptLevels; },
	get dataAttributes () { return dataAttributes; },
	get sdkParamUrlQueryParamMap () { return sdkParamUrlQueryParamMap; },
	get pidlPropertyNameToPidlDocInfoProperty () { return pidlPropertyNameToPidlDocInfoProperty; },
	get themes () { return themes; },
	get pidlStringKeys () { return pidlStringKeys; },
	get controlStates () { return controlStates; },
	get propertyEditState () { return propertyEditState; },
	get controlOperationTypes () { return controlOperationTypes; },
	get errorValue () { return errorValue; },
	get viewUpdateReasons () { return viewUpdateReasons; },
	get pidlDdcApiNames () { return pidlDdcApiNames; },
	get keyCodes () { return keyCodes; },
	get dataTypes () { return dataTypes; },
	get clientDataTypes () { return clientDataTypes; },
	get propertyTypes () { return propertyTypes; },
	get captchaPropertyName () { return captchaPropertyName; },
	get httpActions () { return httpActions; },
	get knownTags () { return knownTags; },
	get knownTagPrefixes () { return knownTagPrefixes; },
	get knownQueryParameters () { return knownQueryParameters; },
	get helpDialogPrefixedTags () { return helpDialogPrefixedTags; },
	get scenarioContextResourceType () { return scenarioContextResourceType; },
	get scenarioContextTerminatingErrorHandling () { return scenarioContextTerminatingErrorHandling; },
	get hmac () { return hmac; },
	get delimiters () { return delimiters; },
	get dataStores () { return dataStores; },
	get challengeScenario () { return challengeScenario; },
	get riskChallengeIndicator () { return riskChallengeIndicator; },
	get challengeWindowSize () { return challengeWindowSize; },
	get challengeStatus () { return challengeStatus; },
	get challengeType () { return challengeType; },
	get pollingInterval () { return pollingInterval; },
	get TextSymbols () { return TextSymbols; },
	get displayHelpPosition () { return displayHelpPosition; },
	get SecureFieldEvent () { return SecureFieldEvent; },
	get SecureFieldMessages () { return SecureFieldMessages; },
	get SecureFieldConstants () { return SecureFieldConstants; },
	get ClientSettingNames () { return ClientSettingNames; },
	get ChallengeiFrameEvent () { return ChallengeiFrameEvent; },
	get ChallengeiFrameConstants () { return ChallengeiFrameConstants; },
	get CustomTriggerEventConstants () { return CustomTriggerEventConstants; },
	get FrequencyUnitConstants () { return FrequencyUnitConstants; },
	get PaymentMethodPIIDs () { return PaymentMethodPIIDs; }
});

"use strict";
var urlBuilder = /** @class */ (function () {
    function urlBuilder() {
        var _this = this;
        this.skipQueryParameter = function (key) {
            if (!key) {
                return false;
            }
            var ret = typehelper.find(typehelper.getKeys(knownQueryParameters), function (knownQueryParameter) {
                return knownQueryParameter.toLowerCase() === key.toLowerCase();
            });
            return typehelper.boolify(ret);
        };
        this.mapQueryParameter = function (parameter) {
            return sdkParamUrlQueryParamMap[typehelper.toLowerCase(parameter)] || parameter;
        };
        // baseUrl and segments must be a valid url by itself and doesn't need further encoding
        this.buildUrlInternal = function (baseUrl, segments, queryParams) {
            var url;
            if (typehelper.startsWith(baseUrl, "https://")) {
                url = baseUrl;
            }
            else if (typehelper.startsWith(baseUrl, "http://")) { // DevSkim: ignore DS137138, condition check to remove the insecure segment
                //use substring manipulator to capture the string starting after the 2nd slash
                url = "https://" + baseUrl.substr(7);
            }
            else {
                url = "https://" + baseUrl;
            }
            if (segments) {
                for (var index = 0; index < segments.length; index++) {
                    url += typehelper.startsWith(segments[index], "/") ? segments[index] : ("/" + segments[index]);
                }
            }
            if (queryParams) {
                Object.keys(queryParams).sort().forEach(function (key) {
                    if (_this.skipQueryParameter(key)) {
                        return;
                    }
                    var value = queryParams[key];
                    if (value) {
                        url = _this.addQueryParameter(url, _this.mapQueryParameter(key), value);
                    }
                });
            }
            return url;
        };
        // Other than the placeholders ({{etc}}) and PI id the rest of the template must be valid url that doesn't need to be encoded
        this.createFromTemplateInternal = function (template, actualEndpointOverride, userContext, id, resourceTypeSegmentName, parameters) {
            if (template) {
                var url = configManager$1.replaceVirtualEndpointWithServiceAddress(template, actualEndpointOverride);
                url = url.replace(/{id}/i, encodeURIComponent(id))
                    .replace(/{resourcetype}/i, resourceTypeSegmentName);
                if (userContext) {
                    url = url.replace(/{userid}/i, userContext.getUserId(template));
                }
                return _this.buildUrlInternal(url, [], parameters);
            }
        };
        this.getUrlExpressionValue = function (template, actualEndpointOverride, userContext, id, bindingDataContext) {
            // replace url template placeholders
            var url = _this.createFromTemplateInternal(template, actualEndpointOverride, userContext, id, null, null);
            if (url && bindingDataContext) {
                // replace remaining databinding placeholders
                url = utils.getFormatStringExpressionValue("(" + url + ")", bindingDataContext, function (data) { return encodeURIComponent(data); });
            }
            return url;
        };
        this.getResourceUrl = function (resourceInfo, userContext) {
            resourceInfo = resourceInfo || {};
            var endpoint = configManager$1.getResourceEndpoint(resourceInfo.resourceType);
            return {
                url: _this.createFromTemplateInternal(endpoint.template, resourceInfo.resourceEndpoint, userContext, resourceInfo.id, resourceInfo.resourceType, resourceInfo.parameters),
                template: endpoint.template,
                recreateUrl: function (urlParameters) {
                    return _this.getResourceUrl(urlParameters.resourceInfo, urlParameters.userContext);
                },
                originalParameters: { resourceInfo: resourceInfo, userContext: userContext },
                virtualEndpoint: endpoint
            };
        };
        this.getPidlDocUrl = function (userContext, operationType, pidlDocInfo) {
            pidlDocInfo = pidlDocInfo || {};
            var parameters = typehelper.deepCopy(pidlDocInfo.parameters || {});
            if (operationType) {
                parameters[httpUrlQueryParameters.operation] = operationType;
            }
            var endpoint = configManager$1.getPidlDocEndpoint(pidlDocInfo.resourceType);
            if (endpoint.addResourceNameToQueryParam) {
                parameters.resourceName = typehelper.toLowerCase(pidlDocInfo.resourceType);
            }
            if (endpoint.removeOperationParameter) {
                delete parameters[httpUrlQueryParameters.operation];
            }
            var resourceType = pidlDocInfo.resourceType + (pidlDocInfo.resourceSuffix || endpoint.suffix);
            var template = (pidlDocInfo.anonymousPidl && endpoint.anonymousTemplate) ? endpoint.anonymousTemplate : endpoint.template;
            return {
                url: _this.createFromTemplateInternal(template, pidlDocInfo.pidlEndpoint, userContext, null, resourceType, parameters),
                template: template,
                recreateUrl: function (urlParameters) {
                    return _this.getPidlDocUrl(urlParameters.userContext, urlParameters.operationType, urlParameters.pidlDocInfo);
                },
                originalParameters: { userContext: userContext, operationType: operationType, pidlDocInfo: pidlDocInfo },
                virtualEndpoint: endpoint
            };
        };
        this.getSubmitUrl = function (operationType, userContext, context, id, bindingDataContext) {
            return {
                url: _this.getUrlExpressionValue(context.href, null, userContext, id, bindingDataContext),
                template: context.href,
                recreateUrl: function (parameters) {
                    return _this.getSubmitUrl(parameters.operationType, parameters.userContext, parameters.context, parameters.id, parameters.bindingDataContext);
                },
                originalParameters: { operationType: operationType, userContext: userContext, context: context, id: id, bindingDataContext: bindingDataContext },
                virtualEndpoint: configManager$1.findVirtualEndpointInTemplate(context.href)
            };
        };
        this.getRestMethodUrl = function (template, userContext, id, bindingDataContext) {
            return {
                url: _this.getUrlExpressionValue(template, null, userContext, id, bindingDataContext),
                template: template,
                recreateUrl: function (parameters) {
                    return _this.getRestMethodUrl(parameters.template, parameters.userContext, parameters.id, parameters.bindingDataContext);
                },
                originalParameters: { template: template, userContext: userContext, id: id, bindingDataContext: bindingDataContext },
                virtualEndpoint: configManager$1.findVirtualEndpointInTemplate(template)
            };
        };
        this.addQueryParameter = function (url, key, value) {
            if (!typehelper.isString(value)) {
                value = JSON.stringify(value);
            }
            value = encodeURIComponent(value);
            var regExp = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            if (url.match(regExp)) {
                return url.replace(regExp, "$1" + key + "=" + value + "$2");
            }
            else {
                var regExpWithAnyQueryParam = new RegExp("([?])");
                if (url.match(regExpWithAnyQueryParam)) {
                    return url.replace(regExpWithAnyQueryParam, "$1" + key + "=" + value + "&");
                }
                else {
                    var separator = url.indexOf("?") !== -1 ? "&" : "?";
                    return url + separator + key + "=" + value;
                }
            }
        };
        this.addQueryStringParameters = function (url, qsParams) {
            if (qsParams) {
                for (var p in qsParams) {
                    if (qsParams[p]) {
                        url = _this.addQueryParameter(url, p, qsParams[p]);
                    }
                }
            }
            return url;
        };
        this.buildUrl = function (baseUrl, segments, queryParams) {
            return _this.buildUrlInternal(baseUrl, segments, queryParams);
        };
        this.createFromTemplate = function (template, actualEndpointOverride, userContext, id, resourceType, parameters) {
            return _this.createFromTemplateInternal(template, actualEndpointOverride, userContext, id, resourceType, parameters);
        };
    }
    return urlBuilder;
}());
var urlBuilder$1 = new urlBuilder();

"use strict";
// Any updates to pidlOperationTypeValues enum must be followed by update to pidlOperationType
var pidlOperationTypeValues;
(function (pidlOperationTypeValues) {
    pidlOperationTypeValues["add"] = "Add";
    pidlOperationTypeValues["replace"] = "Replace";
    pidlOperationTypeValues["getPidlPayload"] = "GetPidlPayload";
    pidlOperationTypeValues["handlePurchasePendingState"] = "HandlePurchasePendingState";
    pidlOperationTypeValues["renderPidlPage"] = "RenderPidlPage";
    pidlOperationTypeValues["select"] = "Select";
    pidlOperationTypeValues["selectInstance"] = "SelectInstance";
    pidlOperationTypeValues["selectSingleInstance"] = "SelectSingleInstance";
    pidlOperationTypeValues["show"] = "Show";
    pidlOperationTypeValues["search"] = "Search";
    pidlOperationTypeValues["delete"] = "Delete";
    pidlOperationTypeValues["update"] = "Update";
    pidlOperationTypeValues["validateInstance"] = "ValidateInstance";
    pidlOperationTypeValues["fundStoredValue"] = "FundStoredValue";
    pidlOperationTypeValues["apply"] = "Apply";
    pidlOperationTypeValues["searchTransactions"] = "searchTransactions";
    pidlOperationTypeValues["redeem"] = "Redeem";
    pidlOperationTypeValues["provisionWalletToken"] = "provisionWalletToken";
    pidlOperationTypeValues["offer"] = "Offer";
})(pidlOperationTypeValues || (pidlOperationTypeValues = {}));
// Any updates to validationModesValues enum must be followed by update to validationModes
var validationModesValues;
(function (validationModesValues) {
    validationModesValues["function"] = "function";
    validationModesValues["regexMessage"] = "regexMessage";
    validationModesValues["regex"] = "regex";
    validationModesValues["service"] = "service";
    validationModesValues["size"] = "size"; // to validate a file size
})(validationModesValues || (validationModesValues = {}));
// Any updates to transformationModesValues enum must be followed by update to transformationModes
var transformationModesValues;
(function (transformationModesValues) {
    transformationModesValues["regex"] = "regex";
    transformationModesValues["service"] = "service";
})(transformationModesValues || (transformationModesValues = {}));
function isDataDescription(obj) {
    return !typehelper.isNullOrUndefined(obj) && "propertyType" in obj && "type" in obj && "dataType" in obj;
}
// Any updates to clientActionTypeValues enum must be followed by update to clientActionType and isClientAction
var clientActionTypeValues;
(function (clientActionTypeValues) {
    clientActionTypeValues["Pidl"] = "Pidl";
    clientActionTypeValues["PidlModal"] = "PidlModal";
    clientActionTypeValues["PidlPage"] = "PidlPage";
    clientActionTypeValues["Wait"] = "Wait";
    clientActionTypeValues["Redirect"] = "Redirect";
    clientActionTypeValues["ReturnContext"] = "ReturnContext";
    clientActionTypeValues["ExecuteScriptAndResume"] = "ExecuteScriptAndResume";
    clientActionTypeValues["None"] = "None";
    clientActionTypeValues["GoHome"] = "GoHome";
    clientActionTypeValues["Failure"] = "Failure";
    clientActionTypeValues["MergeData"] = "MergeData";
    clientActionTypeValues["RestAction"] = "RestAction";
    clientActionTypeValues["UpdatePropertyValue"] = "UpdatePropertyValue";
})(clientActionTypeValues || (clientActionTypeValues = {}));
// Any updates to paymentInstrumentStatusValues enum must be followed by update to paymentInstrumentStatus
var paymentInstrumentStatusValues;
(function (paymentInstrumentStatusValues) {
    paymentInstrumentStatusValues["Active"] = "Active";
    paymentInstrumentStatusValues["Banned"] = "Banned";
    paymentInstrumentStatusValues["Deactivated"] = "Deactivated";
    paymentInstrumentStatusValues["Declined"] = "Declined";
    paymentInstrumentStatusValues["Pending"] = "Pending";
    paymentInstrumentStatusValues["Removed"] = "Removed";
    paymentInstrumentStatusValues["Unknown"] = "Unknown";
})(paymentInstrumentStatusValues || (paymentInstrumentStatusValues = {}));
// Any updates to displayTransformationTypesValues enum must be followed by update to displayTransformationTypes
var displayTransformationTypesValues;
(function (displayTransformationTypesValues) {
    displayTransformationTypesValues["regex"] = "regex";
})(displayTransformationTypesValues || (displayTransformationTypesValues = {}));
// Any updates to pidlDisplayTypesValues enum must be followed by update to pidlDisplayTypes
var pidlDisplayTypesValues;
(function (pidlDisplayTypesValues) {
    pidlDisplayTypesValues["button"] = "button";
    pidlDisplayTypesValues["dataCollectionBindingGroup"] = "datacollectionbindinggroup";
    pidlDisplayTypesValues["expression"] = "expression";
    pidlDisplayTypesValues["group"] = "group";
    pidlDisplayTypesValues["captcha"] = "captcha";
    pidlDisplayTypesValues["audio"] = "audio";
    pidlDisplayTypesValues["heading"] = "heading";
    pidlDisplayTypesValues["hyperlink"] = "hyperlink";
    pidlDisplayTypesValues["iFrame"] = "iframe";
    pidlDisplayTypesValues["challengeIframe"] = "challengeiframe";
    pidlDisplayTypesValues["secureProperty"] = "secureproperty";
    pidlDisplayTypesValues["image"] = "image";
    pidlDisplayTypesValues["logo"] = "logo";
    pidlDisplayTypesValues["page"] = "page";
    pidlDisplayTypesValues["pidlContainer"] = "pidlcontainer";
    pidlDisplayTypesValues["prefillControl"] = "prefillcontrol";
    pidlDisplayTypesValues["property"] = "property";
    pidlDisplayTypesValues["subheading"] = "subheading";
    pidlDisplayTypesValues["text"] = "text";
    pidlDisplayTypesValues["textGroup"] = "textgroup";
    pidlDisplayTypesValues["separator"] = "separator";
    pidlDisplayTypesValues["spinner"] = "spinner";
    pidlDisplayTypesValues["file"] = "file";
})(pidlDisplayTypesValues || (pidlDisplayTypesValues = {}));
function isDisplayDescription(obj) {
    return !typehelper.isNullOrUndefined(obj) && "displayType" in obj;
}
// Any updates to groupLayoutOrientationTypesValues enum must be followed by update to groupLayoutOrientationTypes
var groupLayoutOrientationTypesValues;
(function (groupLayoutOrientationTypesValues) {
    groupLayoutOrientationTypesValues["inline"] = "inline";
    groupLayoutOrientationTypesValues["vertical"] = "vertical";
})(groupLayoutOrientationTypesValues || (groupLayoutOrientationTypesValues = {}));
function isContainerDisplayDescription(obj) {
    return isDisplayDescription(obj) &&
        (obj.displayType === pidlDisplayTypesValues.group ||
            obj.displayType === pidlDisplayTypesValues.dataCollectionBindingGroup ||
            obj.displayType === pidlDisplayTypesValues.page ||
            obj.displayType === pidlDisplayTypesValues.textGroup);
}
function isFilePickerDisplayDescription(obj) {
    if (isDisplayDescription(obj)) {
        var filePickerObj = obj;
        return (filePickerObj && filePickerObj.propertyElementType && filePickerObj.propertyElementType === pidlDisplayTypesValues.file);
    }
    return false;
}
function isGroupDisplayDescription(obj) {
    return isDisplayDescription(obj) &&
        (obj.displayType === pidlDisplayTypesValues.group ||
            obj.displayType === pidlDisplayTypesValues.dataCollectionBindingGroup);
}
function isCaptchaDisplayDescription(obj) {
    return isDisplayDescription(obj) &&
        (obj.displayType === pidlDisplayTypesValues.captcha);
}
function isDataCollectionBindingGroupDisplayDescription(obj) {
    return isDisplayDescription(obj) && obj.displayType === pidlDisplayTypesValues.dataCollectionBindingGroup;
}
function isPageDisplayDescription(obj) {
    return isDisplayDescription(obj) && obj.displayType === pidlDisplayTypesValues.page;
}
function isContentDisplayDescription(obj) {
    return isDisplayDescription(obj) &&
        (obj.displayType === pidlDisplayTypesValues.button ||
            obj.displayType === pidlDisplayTypesValues.expression ||
            obj.displayType === pidlDisplayTypesValues.heading ||
            obj.displayType === pidlDisplayTypesValues.hyperlink ||
            obj.displayType === pidlDisplayTypesValues.subheading ||
            obj.displayType === pidlDisplayTypesValues.text ||
            obj.displayType === pidlDisplayTypesValues.challengeIframe ||
            obj.displayType === pidlDisplayTypesValues.iFrame);
}
function isLogoDisplayDescription(obj) {
    return isDisplayDescription(obj) && obj.displayType === pidlDisplayTypesValues.logo;
}
// Any updates to pidlSubmitOrdersValues enum must be followed by update to pidlSubmitOrders
var pidlSubmitOrdersValues;
(function (pidlSubmitOrdersValues) {
    pidlSubmitOrdersValues["afterBase"] = "afterBase";
    pidlSubmitOrdersValues["beforeBase"] = "beforeBase";
    pidlSubmitOrdersValues["withBase"] = "withBase";
})(pidlSubmitOrdersValues || (pidlSubmitOrdersValues = {}));
// Any updates to pidlSelectTypeValues enum must be followed by update to pidlSelectType
var pidlSelectTypeValues;
(function (pidlSelectTypeValues) {
    pidlSelectTypeValues["buttonList"] = "buttonList";
    pidlSelectTypeValues["checkBox"] = "checkbox";
    pidlSelectTypeValues["dropDown"] = "dropDown";
    pidlSelectTypeValues["radio"] = "radio";
})(pidlSelectTypeValues || (pidlSelectTypeValues = {}));
// Any updates to resolutionPolicyValues enum must be followed by update to resolutionPolicy
var resolutionPolicyValues;
(function (resolutionPolicyValues) {
    resolutionPolicyValues["always"] = "always";
    resolutionPolicyValues["focusout"] = "focusout";
})(resolutionPolicyValues || (resolutionPolicyValues = {}));
function isPropertyDisplayDescription(obj) {
    return isDisplayDescription(obj) &&
        (obj.displayType === pidlDisplayTypesValues.property ||
            obj.displayType === pidlDisplayTypesValues.prefillControl);
}
// Any updates to serverErrorRetryPolicyValues enum must be followed by update to serverErrorRetryPolicy
var serverErrorRetryPolicyValues;
(function (serverErrorRetryPolicyValues) {
    serverErrorRetryPolicyValues["limitedRetry"] = "limitedRetry";
    serverErrorRetryPolicyValues["noRetry"] = "noRetry";
    serverErrorRetryPolicyValues["unlimitedRetry"] = "unlimitedRetry";
})(serverErrorRetryPolicyValues || (serverErrorRetryPolicyValues = {}));
function isPidlLink(obj) {
    return typehelper.isObject(obj) && "href" in obj && "method" in obj;
}
function isMembersInDataSources(obj) {
    return typehelper.isObject(obj) && "members" in obj;
}
function isPidlDocument(obj) {
    return !typehelper.isNullOrUndefined(obj) && "identity" in obj && "data_description" in obj;
}
function isPidlDocumentArray(obj) {
    return !typehelper.isNullOrUndefined(obj) && typehelper.isArray(obj) && obj.length && isPidlDocument(obj[0]);
}
function isPidlPayload(obj) {
    return !typehelper.isNullOrUndefined(obj) && "paymentInstruments" in obj && "pidlInfo" in obj;
}
function isPidlDocumentWithClientAction(obj) {
    return !typehelper.isNullOrUndefined(obj) && "clientAction" in obj;
}
function isPidlContainerDisplayDescription(obj) {
    return isDisplayDescription(obj) && obj.displayType === pidlDisplayTypesValues.pidlContainer;
}
function isClientAction(obj) {
    return !typehelper.isNullOrUndefined(obj) && typehelper.isString(obj.type) && (obj.type === clientActionTypeValues.Pidl ||
        obj.type === clientActionTypeValues.Wait ||
        obj.type === clientActionTypeValues.Redirect ||
        obj.type === clientActionTypeValues.ReturnContext ||
        obj.type === clientActionTypeValues.ExecuteScriptAndResume ||
        obj.type === clientActionTypeValues.None ||
        obj.type === clientActionTypeValues.GoHome ||
        obj.type === clientActionTypeValues.Failure ||
        obj.type === clientActionTypeValues.MergeData ||
        obj.type === clientActionTypeValues.RestAction);
}
function isInvokeResourceActionApiParams(obj) {
    return !typehelper.isNullOrUndefined(obj) && !typehelper.isNullOrUndefined(obj.resourceActionContext);
}

var pidlDocumentTypes = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get pidlOperationTypeValues () { return pidlOperationTypeValues; },
	get validationModesValues () { return validationModesValues; },
	get transformationModesValues () { return transformationModesValues; },
	isDataDescription: isDataDescription,
	get clientActionTypeValues () { return clientActionTypeValues; },
	get paymentInstrumentStatusValues () { return paymentInstrumentStatusValues; },
	get displayTransformationTypesValues () { return displayTransformationTypesValues; },
	get pidlDisplayTypesValues () { return pidlDisplayTypesValues; },
	isDisplayDescription: isDisplayDescription,
	get groupLayoutOrientationTypesValues () { return groupLayoutOrientationTypesValues; },
	isContainerDisplayDescription: isContainerDisplayDescription,
	isFilePickerDisplayDescription: isFilePickerDisplayDescription,
	isGroupDisplayDescription: isGroupDisplayDescription,
	isCaptchaDisplayDescription: isCaptchaDisplayDescription,
	isDataCollectionBindingGroupDisplayDescription: isDataCollectionBindingGroupDisplayDescription,
	isPageDisplayDescription: isPageDisplayDescription,
	isContentDisplayDescription: isContentDisplayDescription,
	isLogoDisplayDescription: isLogoDisplayDescription,
	get pidlSubmitOrdersValues () { return pidlSubmitOrdersValues; },
	get pidlSelectTypeValues () { return pidlSelectTypeValues; },
	get resolutionPolicyValues () { return resolutionPolicyValues; },
	isPropertyDisplayDescription: isPropertyDisplayDescription,
	get serverErrorRetryPolicyValues () { return serverErrorRetryPolicyValues; },
	isPidlLink: isPidlLink,
	isMembersInDataSources: isMembersInDataSources,
	isPidlDocument: isPidlDocument,
	isPidlDocumentArray: isPidlDocumentArray,
	isPidlPayload: isPidlPayload,
	isPidlDocumentWithClientAction: isPidlDocumentWithClientAction,
	isPidlContainerDisplayDescription: isPidlContainerDisplayDescription,
	isClientAction: isClientAction,
	isInvokeResourceActionApiParams: isInvokeResourceActionApiParams
});

"use strict";
var configManager = /** @class */ (function () {
    function configManager() {
        var _this = this;
        this.getContainingVirtualEndpoint = function (template) {
            if (!typehelper.isString(template)) {
                return;
            }
            var templateLower = template.toLowerCase();
            for (var virtualEndpoint in config$1.virtualEndpoints) {
                var virtualEndpointVal = config$1.virtualEndpoints[virtualEndpoint].endpoint;
                var virtualEndpointValWithDelim = "{" + virtualEndpointVal + "}";
                if (templateLower.indexOf(virtualEndpointValWithDelim) !== -1) {
                    return config$1.virtualEndpoints[virtualEndpoint];
                }
            }
        };
        this.getPidlDocInfoFromResource = function (resourceInfo, resource) {
            var resourceTypeLower = typehelper.toLowerCase(resourceInfo.resourceType);
            var resourceTypeToPidlDocInfo = config$1.resourceTypeToPidlDoc[resourceTypeLower] || config$1.resourceTypeToPidlDoc["default"];
            var parameters = resourceTypeToPidlDocInfo.getParams && resourceTypeToPidlDocInfo.getParams(resourceInfo, resource);
            return {
                resourceType: resourceTypeLower,
                parameters: parameters,
                anonymousPidl: resourceInfo.anonymousPidl
            };
        };
        this.updatePidlDocInfo = function (pidlDocInfo) {
            if (!pidlDocInfo) {
                return;
            }
            // Updating allowedPaymentMethods
            if (pidlDocInfo.parameters && pidlDocInfo.parameters.allowedPaymentMethods && typehelper.isArray(pidlDocInfo.parameters.allowedPaymentMethods)) {
                var allObjects = true;
                for (var i = 0, len = pidlDocInfo.parameters.allowedPaymentMethods.length; i < len; i++) {
                    allObjects = allObjects && typehelper.isObject(pidlDocInfo.parameters.allowedPaymentMethods[i]);
                }
                if (allObjects) {
                    var originalAllowedPaymentMethods = pidlDocInfo.parameters.allowedPaymentMethods;
                    pidlDocInfo.parameters.allowedPaymentMethods = {};
                    for (var j = 0, end = originalAllowedPaymentMethods.length; j < end; j++) {
                        var paymentMethod = originalAllowedPaymentMethods[j];
                        var paymentMethodName = paymentMethod.family;
                        paymentMethodName += paymentMethod.type ? delimiters.paymentMethodName + paymentMethod.type : "";
                        pidlDocInfo.parameters.allowedPaymentMethods[paymentMethodName] = paymentMethod.disabled ? 0 : 1;
                    }
                }
            }
        };
        // Add additional params to success redirect url for Sepa
        this.additionalRedirectParams = function (url, serverResponse) {
            var queryPairs = {};
            if (serverResponse) {
                if (serverResponse.paymentMethod) {
                    queryPairs.family = serverResponse.paymentMethod.paymentMethodFamily;
                    queryPairs.type = serverResponse.paymentMethod.paymentMethodType;
                }
                if (typehelper.equalsIgnoreCase(serverResponse.status, paymentInstrumentStatusValues.Pending) && serverResponse.details) {
                    queryPairs.pendingOn = serverResponse.details.pendingOn;
                    queryPairs.picvRequired = serverResponse.details.picvRequired;
                }
            }
            for (var param in queryPairs) {
                if (queryPairs[param]) {
                    url = urlBuilder$1.addQueryParameter(url, param, queryPairs[param]);
                }
            }
            return url;
        };
        // TODO: Add Jarvis url logic once PIDL supports Jarvis front door
        this.getErrorSourceFromUrl = function (requestUrl) {
            requestUrl = typehelper.toLowerCase(requestUrl);
            if (requestUrl) {
                if (requestUrl.indexOf(config$1.getServiceEndpoint(config$1.virtualEndpoints.pifd.endpoint)) !== -1) {
                    if (requestUrl.indexOf("/users") !== -1 && requestUrl.indexOf("/addresses") !== -1) {
                        // PIFD address url: https://{pifd-endpoint}/users/{userId}/addresses
                        return config$1.virtualEndpoints.pifdAddress.endpoint;
                    }
                    else if (requestUrl.indexOf("/users") !== -1 && requestUrl.indexOf("/profiles") !== -1) {
                        // PIFD profile update url: https://{pifd-endpoint}/users/{userId}/profiles/update
                        // PIFD profile post url: https://{pifd-endpoint}/users/{userId}/profiles
                        return config$1.virtualEndpoints.pifdProfile.endpoint;
                    }
                }
                else if (requestUrl.indexOf(config$1.getServiceEndpoint(config$1.virtualEndpoints.jarvis.endpoint)) !== -1) {
                    // Jarvis address url: https://{jarvis-address}/JarvisCM/{userId}/addresses
                    return config$1.virtualEndpoints.jarvisAddress.endpoint;
                }
            }
            return config$1.virtualEndpoints.pifd.endpoint;
        };
        this.getResourceEndpoint = function (resourceType) {
            return config$1.resourceTypeToResource[typehelper.toLowerCase(resourceType)] || config$1.resourceTypeToResource["default"];
        };
        this.getPidlDocEndpoint = function (resourceType) {
            return config$1.resourceTypeToPidlDoc[typehelper.toLowerCase(resourceType)] || config$1.resourceTypeToPidlDoc["default"];
        };
        this.replaceVirtualEndpointWithServiceAddress = function (template, serviceAddressOverride) {
            var containingVirtualEndpoint = _this.getContainingVirtualEndpoint(template);
            if (!containingVirtualEndpoint) {
                return template;
            }
            var virtualEndpointValWithDelim = "{" + containingVirtualEndpoint.endpoint + "}";
            var endpointReplaceRegex = new RegExp(virtualEndpointValWithDelim, "i");
            template = template.replace(endpointReplaceRegex, serviceAddressOverride || config$1.getServiceEndpoint(containingVirtualEndpoint.endpoint));
            return template;
        };
        this.findVirtualEndpointInTemplate = function (template) {
            return _this.getContainingVirtualEndpoint(template) || { description: null, endpoint: null, name: null, operation: null };
        };
        this.getTelemetryLoggerProperties = function () {
            return config$1.defaultTelemetryLoggerProperties;
        };
    }
    return configManager;
}());
var configManager$1 = new configManager();

"use strict";
function getDebugMessage(errorMessage, debugMessageParams) {
    // TODO: Make debug message enabled only when dev environment or debug flag is set.
    return errorMessage.debugMessage ? typehelper.format(errorMessage.debugMessage, debugMessageParams) : "";
}
var ErrorBase = /** @class */ (function () {
    function ErrorBase(type, errorMessage, message, debugMessageParams) {
        this.message = message ? message : "";
        this.name = errorMessage.name;
        this.code = errorMessage.code;
        this.type = type;
    }
    return ErrorBase;
}());
var inputParameterValidationFailedError = /** @class */ (function (_super) {
    __extends(inputParameterValidationFailedError, _super);
    function inputParameterValidationFailedError(errorMessage, parameterName, debugMessageParams) {
        var _this = _super.call(this, errorTypes.inputValidation, errorMessage, null, debugMessageParams) || this;
        _this.parameterName = parameterName;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return inputParameterValidationFailedError;
}(ErrorBase));
var apiValidationError = /** @class */ (function (_super) {
    __extends(apiValidationError, _super);
    function apiValidationError(errorMessage, apiName, debugMessageParams) {
        var _this = _super.call(this, errorTypes.inputValidation, errorMessage, null, debugMessageParams) || this;
        _this.apiName = apiName;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return apiValidationError;
}(ErrorBase));
var propertyValidationFailedError = /** @class */ (function (_super) {
    __extends(propertyValidationFailedError, _super);
    function propertyValidationFailedError(errorMessage, errorCode, propertyName, debugMessageParams) {
        var _this = _super.call(this, errorTypes.userInputValidation, errorMessage, errorCode, debugMessageParams) || this;
        _this.propertyName = propertyName;
        _this.errorCode = errorCode;
        _this.validationErrorType = validationErrorTypes.property;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return propertyValidationFailedError;
}(ErrorBase));
var groupValidationFailedError = /** @class */ (function (_super) {
    __extends(groupValidationFailedError, _super);
    function groupValidationFailedError(errorMessage, errorCode, groupDisplayId, debugMessageParams) {
        var _this = _super.call(this, errorTypes.userInputValidation, errorMessage, errorCode, debugMessageParams) || this;
        _this.groupDisplayId = groupDisplayId;
        _this.errorCode = errorCode;
        _this.validationErrorType = validationErrorTypes.group;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return groupValidationFailedError;
}(ErrorBase));
var formValidationFailedError = /** @class */ (function (_super) {
    __extends(formValidationFailedError, _super);
    function formValidationFailedError(errorMessage, message, errors, debugMessageParams) {
        var _this = _super.call(this, errorTypes.formValidation, errorMessage, message, debugMessageParams) || this;
        _this.errors = errors;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return formValidationFailedError;
}(ErrorBase));
var unexpectedError = /** @class */ (function (_super) {
    __extends(unexpectedError, _super);
    function unexpectedError(errorMessage, debugMessageParams, message) {
        var _this = _super.call(this, errorTypes.unexpected, errorMessage, message, debugMessageParams) || this;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return unexpectedError;
}(ErrorBase));
var serverError = /** @class */ (function (_super) {
    __extends(serverError, _super);
    function serverError(errorMessage, url, jsonResponse, status, statusText, failureContent, debugMessageParams, httpMethod, retryAttempt, retryable) {
        var _this = _super.call(this, errorTypes.serverError, errorMessage, null, debugMessageParams) || this;
        _this.innererror = jsonResponse;
        _this.status = status;
        _this.url = url;
        _this.statusText = statusText;
        _this.responseText = failureContent;
        _this.httpMethod = httpMethod;
        _this.retryAttempt = retryAttempt;
        _this.retryable = retryable;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return serverError;
}(ErrorBase));
var invalidSetupError = /** @class */ (function (_super) {
    __extends(invalidSetupError, _super);
    function invalidSetupError(errorMessage, message, debugMessageParams) {
        var _this = _super.call(this, errorTypes.invalidSetup, errorMessage, message, debugMessageParams) || this;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return invalidSetupError;
}(ErrorBase));
var paymentMethodFailureError = /** @class */ (function (_super) {
    __extends(paymentMethodFailureError, _super);
    function paymentMethodFailureError(errorMessage, message, debugMessageParams) {
        var _this = _super.call(this, errorTypes.paymentMethodFailure, errorMessage, message, debugMessageParams) || this;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return paymentMethodFailureError;
}(ErrorBase));
var failedToOpenWindowError = /** @class */ (function (_super) {
    __extends(failedToOpenWindowError, _super);
    function failedToOpenWindowError(errorMessage, message, debugMessageParams) {
        var _this = _super.call(this, errorTypes.failedToOpenWindow, errorMessage, message, debugMessageParams) || this;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return failedToOpenWindowError;
}(ErrorBase));
var unmatchedAmountError = /** @class */ (function (_super) {
    __extends(unmatchedAmountError, _super);
    function unmatchedAmountError(errorMessage, message, debugMessageParams) {
        var _this = _super.call(this, errorTypes.unmatchedAmount, errorMessage, message, debugMessageParams) || this;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return unmatchedAmountError;
}(ErrorBase));
var walletProviderError = /** @class */ (function (_super) {
    __extends(walletProviderError, _super);
    function walletProviderError(errorMessage, message, debugMessageParams) {
        var _this = _super.call(this, errorTypes.walletProvider, errorMessage, message, debugMessageParams) || this;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return walletProviderError;
}(ErrorBase));
var secureFieldInitCompletedTimeoutError = /** @class */ (function (_super) {
    __extends(secureFieldInitCompletedTimeoutError, _super);
    function secureFieldInitCompletedTimeoutError(errorMessage, message, debugMessageParams) {
        var _this = _super.call(this, errorTypes.secureFieldInitCompletedTimeout, errorMessage, message, debugMessageParams) || this;
        _this.debugMessage = getDebugMessage(errorMessage, debugMessageParams);
        return _this;
    }
    return secureFieldInitCompletedTimeoutError;
}(ErrorBase));
var testHookErrorBase = /** @class */ (function (_super) {
    __extends(testHookErrorBase, _super);
    function testHookErrorBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return testHookErrorBase;
}(ErrorBase));
/**
 * Since we use the global PIDL object to stub out error constructors in some tests, we need
 * to expose the constructors as members of an object. If we don't, pidlsdk will use local
 * references to the constructors, preventing us from stubbing them.
 */
var Errors = /** @class */ (function () {
    function Errors() {
        this.inputParameterValidationFailedError = inputParameterValidationFailedError;
        this.apiValidationError = apiValidationError;
        this.propertyValidationFailedError = propertyValidationFailedError;
        this.groupValidationFailedError = groupValidationFailedError;
        this.formValidationFailedError = formValidationFailedError;
        this.unexpectedError = unexpectedError;
        this.serverError = serverError;
        this.invalidSetupError = invalidSetupError;
        this.paymentMethodFailureError = paymentMethodFailureError;
        this.failedToOpenWindowError = failedToOpenWindowError;
        this.unmatchedAmountError = unmatchedAmountError;
        this.testHookErrorBase = testHookErrorBase;
        this.walletProviderError = walletProviderError;
        this.secureFieldInitCompletedTimeoutError = secureFieldInitCompletedTimeoutError;
    }
    Errors.prototype.isUnexpectedError = function (object) {
        return typehelper.isObject(object) && object.type === errorTypes.unexpected;
    };
    Errors.prototype.isServerError = function (object) {
        return typehelper.isObject(object) && object.type === errorTypes.serverError;
    };
    return Errors;
}());
var pidlErrors = new Errors();

"use strict";
var createErrorMessages = function (errorMessages) { return errorMessages; };
var errorMessages = createErrorMessages({
    inputParameterMissing: {
        code: 1000,
        name: "mandatoryInputParameterMissingOrNull",
        debugMessage: "Mandatory parameter '{0}' is missing or null"
    },
    inputParameterTypeMismatch: {
        code: 1001,
        name: "inputParameterTypeMismatch",
        debugMessage: "Parameter type is mismatched. Expected type was '{0}', but actual type passed is '{1}'"
    },
    inputParameterNotInRange: {
        code: 1002,
        name: "inputParameterNotInRange",
        debugMessage: "Value of parameter '{0}' is '{1}' not in the range of expected values. Valid range for the parameter is '{2}'"
    },
    containerIdNotFound: {
        code: 1003,
        name: "containerIdNotFound",
        debugMessage: "Value of 'containerId' parameter '{0}' is not a valid element in current HTML DOM"
    },
    apiCannotStartAsControlNotInitialized: {
        code: 1004,
        name: "apiCannotStartAsControlNotInitialized",
        debugMessage: "API '{0}' cannot start as display control is not initialized."
    },
    apiCannotStartAsNotAllowedInCurrentState: {
        code: 1005,
        name: "apiCannotStartAsNotAllowedInCurrentState",
        debugMessage: "API '{0}' cannot start as current control state is '{1}' and the API is allowed only in following states '{2}'"
    },
    busyBlockShowHideHandlerAndbusyBlockIdAreExclusive: {
        code: 1006,
        name: "busyBlockShowHideHandlerAndbusyBlockIdAreExclusive",
        debugMessage: "Both busyBlockShowHideHandler and busyBlockId are passed in displayOptions. They are exclusive and only one can be passed."
    },
    inputParameterSmallerThanMinLength: {
        code: 1007,
        name: "inputParameterSmallerThanMinLength",
        debugMessage: "Array element '{0}' is expected to have minimum length '{1}' but it has a length of '{2}'."
    },
    inputParameterLargerThanMaxLength: {
        code: 1008,
        name: "inputParameterLargerThanMaxLength",
        debugMessage: "Array element '{0}' is expected to have maximum length '{1}' but it has a length of '{2}'."
    },
    mandatoryPropertyValueMissing: {
        code: 1101,
        name: "mandatoryPropertyValueMissing",
        debugMessage: "Property '{0}' is mandatory, but its value is missing",
    },
    propertyValidationFailed: {
        code: 1102,
        name: "propertyValidationFailed",
        debugMessage: "Validation for property '{0}' failed with the message '{1}'",
    },
    formValidationFailed: {
        code: 1103,
        name: "formValidationFailed",
        debugMessage: "Validation for form failed with the message '{0}'",
    },
    readUserInputFailed: {
        code: 1104,
        name: "readUserInputFailed",
        debugMessage: "Read user input failed with the message '{0}'",
    },
    formSubmissionFailedBadUserInput: {
        code: 1105,
        name: "formSubmissionFailedBadUserInput",
        debugMessage: "Form submission failed with error '{0}' due to bad user input",
    },
    editedPropertiesValidationFailed: {
        code: 1106,
        name: "editedPropertiesValidationFailed",
        debugMessage: "Validation for edited properties failed with the message '{0}'",
    },
    propertyTransformationFailed: {
        code: 1107,
        name: "propertyTransformationFailed",
        debugMessage: "Property transformation failed with the message '{0}'",
    },
    tokenizationFailed: {
        code: 1108,
        name: "tokenizationFailed",
        debugMessage: "Tokenization failed with the message '{0}'",
    },
    hmacError: {
        code: 1109,
        name: "hmacError",
        debugMessage: "HMAC error happened with the message '{0}'",
    },
    tokenizationError: {
        code: 1110,
        name: "tokenizationError",
        debugMessage: "Some error happened during tokenization. Here is the error message '{0}'",
    },
    connectivityError: {
        code: 1200,
        name: "connectivityError",
        debugMessage: "There was a connectivity error when attempting to download PIDL document. Error message: '{0}'"
    },
    pidlDocDownloadFailed: {
        code: 1201,
        name: "pidlDocDownloadFailed",
        debugMessage: "Failed to download PIDL document. Error message: '{0}'",
    },
    formSubmitFailed: {
        code: 1202,
        name: "formSubmitFailed",
        debugMessage: "Failed to submit form. Error message: '{0}'",
    },
    resourceInstanceDownloadFailed: {
        code: 1203,
        name: "resourceInstanceDownloadFailed",
        debugMessage: "Failed to download resource instance. Error message: '{0}'",
    },
    commerceJsDownloadFailed: {
        code: 1204,
        name: "commerceJsDownloadFailed",
        debugMessage: "Failed to download Commerce JS",
    },
    restMethodInvocationFailed: {
        code: 1205,
        name: "restMethodInvocationFailed",
        debugMessage: "Rest method invocation for url '{0}' failed with error '{1}'",
    },
    missingSubmitActionInPidlDoc: {
        code: 1501,
        name: "missingSubmitActionInPidlDoc",
        debugMessage: "Cannot perform submit action as the current PIDL document does not have it.",
    },
    submitActionMissing: {
        code: 1502,
        name: "submitActionMissing",
        debugMessage: "Submit action is missing in the PIDL document",
    },
    unknownActionType: {
        code: 1503,
        name: "unknownActionType",
        debugMessage: "Unknown action type '{0}'",
    },
    unknownClientActionType: {
        code: 1504,
        name: "unknownClientActionType",
        debugMessage: "Unknown client action type '{0}'",
    },
    cannotMoveToNextPageAsOnLastPage: {
        code: 1505,
        name: "cannotMoveToNextPageAsOnLastPage",
        debugMessage: "Cannot move to next page as already on the last page",
    },
    cannotMoveToPrevPage: {
        code: 1506,
        name: "cannotMoveToPrevPage",
        debugMessage: "Cannot move to previous page",
    },
    noMappingToGetPidlDocForResource: {
        code: 1507,
        name: "noMappingToGetPidlDocForResource",
        debugMessage: "There is no mapping for getting PIDL document for the input resource type '{0}'",
    },
    noMappingToGetHtmlClassNameForElement: {
        code: 1508,
        name: "noMappingToGetHtmlClassNameForElement",
        debugMessage: "There is no mapping for getting HTML class name for element '{0}'",
    },
    missingMandatoryParameterForHtmlCreation: {
        code: 1509,
        name: "missingMandatoryParameterForHtmlCreation",
        debugMessage: "Display id '{0}' needs to be rendered as '{1}'. But the mandatory property '{2}' is missing or empty",
    },
    parameterTypeMismatchForHtmlCreation: {
        code: 1510,
        name: "parameterTypeMismatchForHtmlCreation",
        debugMessage: "Display id '{0}' needs to be rendered as '{1}'. Property '{2}' is expected to be of type '{3}' but actual type is '{4}'",
    },
    modelNotPpopulated: {
        code: 1511,
        name: "modelNotPopulated",
        debugMessage: "Model is not populated",
    },
    cannotMoveToPageIndex: {
        code: 1512,
        name: "cannotMoveToPageIndex",
        debugMessage: "Cannot move to the given page index because it is out of bounds",
    },
    apiStateMappingNotFound: {
        code: 1513,
        name: "apiStateMappingNotFound",
        debugMessage: "Api '{0}' does not have a mapping in state manager",
    },
    contextMissingFromPidlAction: {
        code: 1514,
        name: "contextMissingFromPidlAction",
        debugMessage: "PIDL action '{0}' does not have should have a context",
    },
    restActionPidlActionMissingParameters: {
        code: 1515,
        name: "restActionPidlActionMissingParameters",
        debugMessage: "Rest action is missing parameter '{0}' ",
    },
    noPidlDocumentInPopulateRequest: {
        code: 1516,
        name: "noPidlDocumentInPopulateRequest",
        debugMessage: "No PIDL documents are sent in the request for populating model",
    },
    noDisplayDescriptionInPidlDocument: {
        code: 1517,
        name: "noDisplayDescriptionInPidlDocument",
        debugMessage: "No display description are found in the PIDL document",
    },
    multiplePagesInLinkedPidlForSinglePagePidlContainer: {
        code: 1518,
        name: "multiplePagesInLinkedPidlForSinglePagePidlContainer",
        debugMessage: "Multiple pages extracted from a linked PIDL for a single page PIDL container (being a member of a PIDL Page)",
    },
    expectedPayloadValueNotPresentInServerResponse: {
        code: 1519,
        name: "expectedPayloadValueNotPresentInServerResponse",
        debugMessage: "The expected value for the next submit payload was not present in server response",
    },
    noRedirectUrlToNavigate: {
        code: 1520,
        name: "noRedirecturlToNavigate",
        debugMessage: "There is no redirection service url to navigate",
    },
    invalidCacheEntry: {
        code: 1521,
        name: "invalidCacheEntry",
        debugMessage: "Cache entry for the handle given is invalid",
    },
    unexpectedPrefillDataCount: {
        code: 1522,
        name: "unexpectedPrefillDataCount",
        debugMessage: "The expected count of prefill data objects for '{0}' is '{1}' but actual count was '{2}'",
    },
    defaultActionNotFound: {
        code: 1523,
        name: "defaultActionNotFound",
        debugMessage: "Default action is not found on the page"
    },
    isDefaultPidlActionNotFound: {
        code: 1524,
        name: "isDefaultPidlActionNotFound",
        debugMessage: "Pidl action with isDefault === true not found in the pidl with element ids: {0}"
    },
    displayElementPointingToMissingDataProperty: {
        code: 1525,
        name: "noPropertyFoundForDisplayElement",
        debugMessage: "Display element '{0}' is pointing to missing data property '{1}'"
    },
    invalidReturnContextPidl: {
        code: 1526,
        name: "invalidReturnContextPidl",
        debugMessage: "Downloaded pidl had returnContext client action type but context was empty"
    },
    duplicateDisplayHintIdOnPage: {
        code: 1527,
        name: "duplicateDisplayHintIdOnPage",
        debugMessage: "DisplayId '{0}' appears multiple times on page '{1}'"
    },
    invalidNotInPurchasePendingState: {
        code: 1528,
        name: "instanceNotInPurchasePendingState",
        debugMessage: "The PI downloaded was not a valid type for purchase pending state"
    },
    submitPidlRequestMissingParameters: {
        code: 1529,
        name: "submitPidlRequestMissingParameters",
        debugMessage: "Submit pidl request is missing parameter '{0}'",
    },
    IFrameTimedOut: {
        code: 1530,
        name: "iframetimedout",
        debugMessage: "Took to long to notify as successful. Operation timed out'",
    },
    unhandledRejection: {
        code: 1531,
        name: "unhandledrejection",
        debugMessage: "Unhandled Promise Rejection at {0}",
    },
    iFrameReturnedFailure: {
        code: 1532,
        name: "iFrameReturnedFailure",
        debugMessage: "iFrame POST message returned failure with message {0}",
    },
    failureClientActionReturned: {
        code: 1533,
        name: "failureClientActionReturned",
        debugMessage: "Client action type failure is returned with payload {0}",
    },
    validationFailedForNonUserInputProperty: {
        code: 1534,
        name: "validationFailedForNonUserInputProperty",
        debugMessage: "Validation for property '{0}' failed with error code '{1}' and message '{2}' which has caused flow termination because correct value for this property is expected either to be passed by the partner or is there as default value in the PIDL, not input by the user.",
    },
    pollingTimedOut: {
        code: 1535,
        name: "pollingTimedOut",
        debugMessage: "Polling exceeded maximum time allowed",
    },
    unableToSetupPolling: {
        code: 1536,
        name: "unableToSetupPolling",
        debugMessage: "Unable to setup polling",
    },
    msrEncryptionFailed: {
        code: 1537,
        name: "msrEncryptionFailed",
        debugMessage: "MSR Encryption failed with the message '{0}'",
    },
    onlyOneBusyBlockPropAllowed: {
        code: 1538,
        name: "onlyOneBusyBlockPropAllowed",
        debugMessage: "Please pass in only one prop option for busyBlocks (busyBlockId, busyBlockElement, or busyBlockShowHideHandler)",
    },
    failurePollingResponseReturned: {
        code: 1539,
        name: "failurePollingResponseReturned",
        debugMessage: "The following response from polling is unexpected: {0}",
    },
    fileUploadFailure: {
        code: 1540,
        name: "fileUploadFailure",
        debugMessage: "Unable to upload the file",
    },
    invalidSetup: {
        code: 1541,
        name: "invalidSetup",
        debugMessage: "PaymentAgent needs to be fully initialized",
    },
    paymentMethodFailure: {
        code: 1542,
        name: "paymentMethodFailure",
        debugMessage: "Error processing payment sheet"
    },
    unmatchedAmount: {
        code: 1543,
        name: "unmatchedAmount",
        debugMessage: "Authorization group total amount does not match amount"
    },
    failedToOpenWindow: {
        code: 1544,
        name: "failedToOpenWindow",
        debugMessage: "Failed to Open Window"
    },
    unexpectedChallengeiFrameMessage: {
        code: 1545,
        name: "unexpectedChallengeIframeMessage",
        debugMessage: "Unexpected challenge iframe message.",
    },
    challengeIframeMessagePostFailure: {
        code: 1546,
        name: "challengeIframeMessagePostFailure",
        debugMessage: "Challenge iframe message post failure.",
    },
    unmatchedSecureFieldEvent: {
        code: 1601,
        name: "unmatchedSecureFieldEvent",
        debugMessage: "The following secure field event is unexpected: {0}",
    },
    unexpectedSecureFieldMessage: {
        code: 1602,
        name: "unexpectedSecureFieldMessage",
        debugMessage: "Unexpected secure field message.",
    },
    secureFieldPromiseNotFound: {
        code: 1602,
        name: "secureFieldPromiseNotFound",
        debugMessage: "Unable to find promise after secure field posted back message.",
    },
    secureFieldInitCompletedTimeout: {
        code: 1603,
        name: "secureFieldInitCompletedTimeout",
        debugMessage: "Timeout while waiting for secure fields initCompleted events",
    },
    walletProviderError: {
        code: 1700,
        name: "walletProviderError",
        debugMessage: "Unable to retrieve wallet cards."
    },
});

"use strict";
var Commerce = /** @class */ (function () {
    function Commerce() {
        var _this = this;
        this.getResolvedPidls = function (pidlDocuments, keyPropertyNameToValueGetterMap) {
            var resolvedPidls = [];
            pidlDocuments.forEach(function (pidlDocument) {
                var match = false;
                for (var keyPropertyName in keyPropertyNameToValueGetterMap) {
                    var keyPropertyDescriptor = commerceHelper$1.getPropertyFromDataDescription(pidlDocument.data_description, keyPropertyName);
                    var keyPropertyValueGetter = keyPropertyNameToValueGetterMap[keyPropertyName];
                    if (keyPropertyValueGetter && keyPropertyValueGetter.getValue) {
                        match = _this.resolveKeyProperty(keyPropertyDescriptor, keyPropertyValueGetter.getValue(keyPropertyDescriptor));
                        if (!match) {
                            break;
                        }
                    }
                }
                if (match) {
                    resolvedPidls.push(pidlDocument);
                }
            });
            return resolvedPidls;
        };
        this.getPidlContainersInSubmitOrder = function (displayDescriptions, pidlContainers) {
            displayDescriptions.forEach(function (displayDescription) {
                if (isPidlContainerDisplayDescription(displayDescription)) {
                    var submitOrder = displayDescription.submitOrder;
                    if (submitOrder === pidlSubmitOrdersValues.beforeBase) {
                        pidlContainers.beforeBase.push(displayDescription);
                    }
                    else if (submitOrder === pidlSubmitOrdersValues.afterBase) {
                        pidlContainers.afterBase.push(displayDescription);
                    }
                    else {
                        pidlContainers.withBase.push(displayDescription);
                    }
                }
                else if (isContainerDisplayDescription(displayDescription) && displayDescription.members.length) {
                    _this.getPidlContainersInSubmitOrder(displayDescription.members, pidlContainers);
                }
            });
        };
        // function commerce2.resolveInfoDescriptionId
        //   This function takes a pidlDocument (which is an array of pidlResources) and a keyPropertyValue
        //   and helps decide which of the pidlResources in the arrays is applicable (based
        //   on the keyPropertyValue).
        //
        this.resolveInfoDescriptionId = function (pidlDocs, keyPropertyNameToValueGetterMap) {
            return _this.getResolvedPidls(pidlDocs, keyPropertyNameToValueGetterMap).map(function (resolvedPidl) { return resolvedPidl.identity; });
        };
        // function commerce2.getFirstPidlWithValidDefaultKey
        //   This function takes a pidlDocument (which is an array of pidlResources) and a keyPropertyValue
        //   and helps decide which of the pidlResources in the arrays is applicable (based
        //   on the keyPropertyValue).
        //
        this.getFirstPidlWithValidDefaultKey = function (pidlDocs, keyPropertyNameToValueGetterMap) {
            return _this.getResolvedPidls(pidlDocs, keyPropertyNameToValueGetterMap)[0];
        };
        // function commerce2.getPidlSubmitOrder
        //   Returns array of ordered pidls for submit based on each pidlContainer's submitOrder attribute.
        //
        this.getPidlSubmitOrder = function (pidlDocument) {
            var pidlContainers = { beforeBase: [], withBase: [], afterBase: [] };
            _this.getPidlContainersInSubmitOrder(pidlDocument.displayDescription, pidlContainers);
            return pidlContainers;
        };
        this.resolveKeyProperty = function (keyPropertyDescriptor, value) {
            // TODO: Ideally check for null is not needed but there is some test code
            // which calls this with null so having this extra || condition. Fix the test
            // and update it.
            var validation = (keyPropertyDescriptor || { validation: null }).validation;
            if (!typehelper.isUndefined(value) && validation) {
                return new RegExp(validation.resolutionRegex || validation.regex).test(value);
            }
            return false;
        };
    }
    return Commerce;
}());
var commerce2 = new Commerce();

"use strict";
var commerceHelper = /** @class */ (function () {
    function commerceHelper() {
        var _this = this;
        this.getPropertyDescriptorsHelper = function (dataDescription, propertyAttributeName, propertyAttributeValue) {
            var retVal = [];
            for (var propertyName in dataDescription) {
                var innerDescription = dataDescription[propertyName];
                // The property in the data_description could be a set of sub PIDL objects. Example: 'details' is a sub PIDL within Payment Method Descriptions PIDL.
                if (innerDescription instanceof Array) {
                    for (var i = 0; i < innerDescription.length; i++) {
                        retVal = retVal.concat(_this.getPropertyDescriptorsHelper(innerDescription[i].data_description, propertyAttributeName, propertyAttributeValue));
                    }
                }
                else if (innerDescription.hasOwnProperty(propertyAttributeName) && innerDescription[propertyAttributeName] === propertyAttributeValue) {
                    retVal.push({ propertyName: propertyName, propertyDescriptor: innerDescription });
                }
            }
            return retVal;
        };
        this.getPropertyValueFromInputDataHelper = function (userInputData, propertyName) {
            var retVal;
            for (var currProperty in userInputData) {
                if (currProperty === propertyName) {
                    retVal = userInputData[currProperty];
                    break;
                }
                else if (typehelper.isObject(userInputData[currProperty])) {
                    // The property in the data_description could be a sub PIDL objects. Example: 'details' is a sub PIDL within Payment Method Descriptions PIDL.
                    retVal = _this.getPropertyValueFromInputDataHelper(userInputData[currProperty], propertyName);
                    if (retVal !== undefined) {
                        break;
                    }
                }
            }
            return retVal;
        };
        this.getPropertyFromDataDescriptionHelper = function (dataDescription, propertyName, getPropertyContainer) {
            if (getPropertyContainer === void 0) { getPropertyContainer = false; }
            var retVal;
            if (propertyName) {
                for (var currProperty in dataDescription) {
                    var currentDescription = dataDescription[currProperty];
                    if (currentDescription instanceof Array) {
                        if (getPropertyContainer && (currProperty === propertyName && currentDescription[0])) {
                            return currentDescription[0].data_description;
                        }
                        else {
                            // The property in the data_description could be a set of sub PIDL objects. Example: 'details' is a sub PIDL within Payment Method Descriptions PIDL.
                            currentDescription.some(function (currentDesc) {
                                retVal = _this.getPropertyFromDataDescriptionHelper(currentDesc.data_description, propertyName, getPropertyContainer);
                                return retVal !== undefined;
                            });
                            if (retVal !== undefined) {
                                break;
                            }
                        }
                    }
                    else if (_this.propertyMatchesDataDescriptionInternal(currentDescription, currProperty, propertyName)) {
                        retVal = currentDescription;
                        break;
                    }
                }
            }
            return retVal;
        };
        this.getFirstResolvedPidlDocument = function (pidlDocuments, userInputData) {
            var firstResolved = null;
            pidlDocuments.some(function (pidlDocument) {
                var allKeyPropertyDescriptors = _this.getKeyPropertyDescriptors(pidlDocument.data_description);
                var allKeyMatches = allKeyPropertyDescriptors.every(function (keyDesc) { return commerce2.resolveKeyProperty(keyDesc.propertyDescriptor, _this.getPropertyValueFromInputData(userInputData, keyDesc.propertyName)); });
                if (allKeyMatches) {
                    firstResolved = pidlDocument;
                    return true;
                }
            });
            return firstResolved;
        };
        this.propertyMatchesDataDescriptionInternal = function (dataDescription, key, propertyName) {
            return propertyName && (key === propertyName || (dataDescription && dataDescription.display_property === propertyName));
        };
        // Gets the name of the first data description property with the given propertyAttributeName = propertyAttributeValue
        // propertyAttributeName = propertyAttributeValue should uniquely identify the property
        this.getPropertyNamesFromDataDescription = function (dataDescription, propertyAttributeName, propertyAttributeValue) {
            return _this.getPropertyDescriptorsHelper(dataDescription, propertyAttributeName, propertyAttributeValue);
        };
        this.getKeyPropertyDescriptors = function (dataDescription) {
            return _this.getPropertyNamesFromDataDescription(dataDescription, "is_key", true);
        };
        this.getPropertyValueFromInputData = function (userInputData, propertyName) {
            return _this.getPropertyValueFromInputDataHelper(userInputData, propertyName);
        };
        this.getPropertyFromDataDescription = function (dataDescription, propertyName) {
            var result = _this.getPropertyFromDataDescriptionHelper(dataDescription, propertyName);
            return isDataDescription(result) ? result : undefined;
        };
        this.getPropertiesFromDataDescription = function (dataDescription, propertyName) {
            return _this.getPropertyFromDataDescriptionHelper(dataDescription, propertyName, true);
        };
        this.propertyMatchesDataDescription = function (dataDescription, key, propertyName) {
            return _this.propertyMatchesDataDescriptionInternal(dataDescription, key, propertyName);
        };
        this.getDisplayPropertyName = function (propertyDescription, propertyName) {
            return propertyDescription.display_property || propertyName;
        };
    }
    return commerceHelper;
}());
var commerceHelper$1 = new commerceHelper();

"use strict";
var iocContainer = /** @class */ (function () {
    function iocContainer() {
        var _this = this;
        this.setService = function (name, service) {
            _this.services[name] = service;
        };
        this.getService = function (name) {
            return _this.services[name];
        };
        this.getCommerceService = function () {
            return _this.getService("commerce" /* serviceName.commerce */);
        };
        this.setCommerceService = function (commerceService) {
            _this.setService("commerce" /* serviceName.commerce */, commerceService);
        };
        this.getLoggingService = function () {
            return _this.getService("logging" /* serviceName.logging */);
        };
        this.setLoggingService = function (loggingService) {
            _this.setService("logging" /* serviceName.logging */, loggingService);
        };
        this.getPidlService = function () {
            return _this.getService("pidl" /* serviceName.pidl */);
        };
        this.setPidlService = function (pidlService) {
            _this.setService("pidl" /* serviceName.pidl */, pidlService);
        };
        this.getRedirectionService = function () {
            return _this.getService("redirection" /* serviceName.redirection */);
        };
        this.setRedirectionService = function (redirectionService) {
            _this.setService("redirection" /* serviceName.redirection */, redirectionService);
        };
        this.getTelemetryInjectionService = function () {
            return _this.getService("telemetry" /* serviceName.telemetry */);
        };
        this.setTelemetryInjectionService = function (telemetryInjectionService) {
            _this.setService("telemetry" /* serviceName.telemetry */, telemetryInjectionService);
        };
        this.getPidlStoreService = function () {
            return _this.getService("pidlStore" /* serviceName.pidlStore */);
        };
        this.setPidlStoreService = function (pidlStoreService) {
            return _this.setService("pidlStore" /* serviceName.pidlStore */, pidlStoreService);
        };
        this.getOneDSService = function () {
            return _this.getService("oneDS" /* serviceName.oneDs */);
        };
        this.setOneDSService = function (oneDSService) {
            return _this.setService("oneDS" /* serviceName.oneDs */, oneDSService);
        };
        this.testHookResetServices = function () {
            _this.services = {};
        };
        this.services = {};
    }
    return iocContainer;
}());
var iocContainer$1 = new iocContainer();

"use strict";
var pidlDocHelper = /** @class */ (function () {
    function pidlDocHelper() {
        var _this = this;
        this.getDisplayDescriptionPidlActions = function (displayDescription, actions) {
            if (!displayDescription) {
                return;
            }
            if (displayDescription.pidlAction) {
                actions.push(displayDescription.pidlAction);
            }
            if (isContainerDisplayDescription(displayDescription) && displayDescription.members) {
                for (var i = 0; i < displayDescription.members.length; i++) {
                    _this.getDisplayDescriptionPidlActions(displayDescription.members[i], actions);
                }
            }
        };
        this.getLogoDescriptions = function (displayDescription, logoDescriptions) {
            if (!displayDescription || !logoDescriptions) {
                return;
            }
            if (isLogoDisplayDescription(displayDescription)) {
                logoDescriptions.push(displayDescription);
            }
            if (isContainerDisplayDescription(displayDescription) && displayDescription.members) {
                for (var index = 0; index < displayDescription.members.length; index++) {
                    _this.getLogoDescriptions(displayDescription.members[index], logoDescriptions);
                }
            }
        };
        this.getPidlIdentityForProperty = function (pidlDoc, propertyName) {
            if (!propertyName) {
                return;
            }
            var identity;
            if (pidlDoc instanceof Array) {
                for (var i = 0; i < pidlDoc.length; i++) {
                    identity = _this.getPidlIdentityForProperty(pidlDoc[i], propertyName);
                    if (identity) {
                        return identity;
                    }
                }
            }
            else if (pidlDoc.data_description) {
                for (var key in pidlDoc.data_description) {
                    var currentDataDescription = pidlDoc.data_description[key];
                    if (currentDataDescription instanceof Array) {
                        identity = _this.getPidlIdentityForProperty(currentDataDescription, propertyName);
                        if (identity) {
                            return identity;
                        }
                    }
                    else if (commerceHelper$1.propertyMatchesDataDescription(currentDataDescription, key, propertyName)) {
                        return pidlDoc.identity;
                    }
                }
            }
        };
        this.createIdentityHash = function (identity) {
            var id = "";
            for (var k in identity) {
                if (typehelper.isString(identity[k])) {
                    id += k + "_" + identity[k];
                }
            }
            return id;
        };
        this.resolvePidlDocs = function (pidlDoc, resolvedPidlIdentities) {
            if (pidlDoc instanceof Array) {
                var resolvedPidlDocs = [];
                if (resolvedPidlIdentities) {
                    var commerceService = iocContainer$1.getCommerceService();
                    for (var i = 0; i < pidlDoc.length; i++) {
                        for (var j = 0; j < resolvedPidlIdentities.length; j++) {
                            if (commerceService.areIdentitiesEqual(pidlDoc[i].identity, resolvedPidlIdentities[j])) {
                                resolvedPidlDocs.push(pidlDoc[i]);
                                break;
                            }
                        }
                    }
                }
                return resolvedPidlDocs;
            }
            else {
                return [pidlDoc];
            }
        };
        this.getDisplayDescriptionsPidlActions = function (displayDescription) {
            var actions = [];
            _this.getDisplayDescriptionPidlActions(displayDescription, actions);
            if (isPropertyDisplayDescription(displayDescription)) {
                var possibleOptions = displayDescription.possibleOptions;
                if (possibleOptions) {
                    for (var possibleOptionName in possibleOptions) {
                        var pidlAction = possibleOptions[possibleOptionName].pidlAction;
                        if (pidlAction) {
                            actions = __spreadArray(__spreadArray([], actions, true), [pidlAction], false);
                        }
                    }
                }
            }
            return actions;
        };
        this.getSubmitPidlAction = function (pidlDoc) {
            if (!pidlDoc || !pidlDoc.displayDescription) {
                return;
            }
            var actions = [];
            pidlDoc.displayDescription.forEach(function (displayDescription) {
                _this.getDisplayDescriptionPidlActions(displayDescription, actions);
            });
            return typehelper.find(actions, function (action) { return action.type === supportedPidlActions.submit; });
        };
        this.isPrimaryResource = function (pidlDoc) {
            // Default scenario resource type is primary
            var scenarioResourceType = (pidlDoc && pidlDoc.scenarioContext && pidlDoc.scenarioContext.resourceType) ||
                scenarioContextResourceType.primary;
            return scenarioResourceType === scenarioContextResourceType.primary;
        };
        this.ignoreTerminatingError = function (pidlDocs) {
            return pidlDocs &&
                pidlDocs.length > 0 &&
                pidlDocs[0] &&
                pidlDocs[0].scenarioContext &&
                pidlDocs[0].scenarioContext.terminatingErrorHandling &&
                pidlDocs[0].scenarioContext.terminatingErrorHandling === scenarioContextTerminatingErrorHandling.ignore;
        };
        this.matchPidlIdsToPidls = function (commerceService, pidlIds, pidls) {
            var allMatched = pidlIds && pidls && pidlIds.length === pidls.length;
            for (var i = 0; allMatched && i < pidlIds.length; i++) {
                var matched = false;
                for (var j = 0; j < pidls.length; j++) {
                    var pidlId = pidls[j] ? pidls[j].identity : null;
                    matched = matched || commerceService.areIdentitiesEqual(pidlIds[i], pidlId);
                }
                allMatched = allMatched && matched;
            }
            return allMatched;
        };
        this.translateErrorTargetsToDisplayProperties = function (targets, pidlDoc) {
            var displayProperties = [];
            targets.forEach(function (target) {
                var property = commerceHelper$1.getPropertyFromDataDescription(pidlDoc.data_description, target);
                displayProperties.push((property && property.display_property) || target);
            });
            return displayProperties;
        };
        this.doesKeyPropertyTriggerPidlDownload = function (keyPropertyDescriptor) {
            return keyPropertyDescriptor && typehelper.boolify(keyPropertyDescriptor.pidl_download_enabled || keyPropertyDescriptor.possible_values);
        };
        this.getKeyPropertyPidlDownloadUrlParam = function (keyPropertyDescriptor, keyPropertyName) {
            return keyPropertyDescriptor &&
                (keyPropertyDescriptor.pidl_download_parameter || (keyPropertyDescriptor.possible_values && keyPropertyName));
        };
        this.createKeyPropertyMap = function (pidlDocs, propertyValueGetter) {
            var map = {};
            var createCallbackWrapper = function (keyPropertyName) {
                return function (keyPropertyDescriptor) { return propertyValueGetter(keyPropertyName, keyPropertyDescriptor); };
            };
            for (var i = 0, pdLen = pidlDocs.length; i < pdLen; i++) {
                var keyPropertyDescriptors = commerceHelper$1.getKeyPropertyDescriptors(pidlDocs[i].data_description);
                for (var j = 0, kpenLen = keyPropertyDescriptors.length; j < kpenLen; j++) {
                    var keyPropertyName = keyPropertyDescriptors[j].propertyName;
                    var keyPropertyDescriptor = keyPropertyDescriptors[j].propertyDescriptor;
                    map[keyPropertyName] = {
                        propertyDescriptor: keyPropertyDescriptor,
                        getValue: createCallbackWrapper(keyPropertyName)
                    };
                }
            }
            return map;
        };
        this.getPropertyValueGetter = function (currentPropertyName, currentPropertyPreferredValue, propertyValueGetter) {
            return function (propertyName, propertyDescriptor) {
                // keyValue is preferred because the model has not yet been updated with this new value at this point
                var val = (currentPropertyName === propertyName) ? currentPropertyPreferredValue : propertyValueGetter(propertyName);
                return typehelper.toString(val);
            };
        };
        this.getDefaultPropertyValueGetter = function () {
            return function (propertyName, propertyDescriptor) {
                return propertyDescriptor && typehelper.toString(propertyDescriptor.default_value);
            };
        };
        this.getDataSourceObjects = function (pidlDoc) {
            var dataSourceObjects = [];
            if (pidlDoc) {
                if (!typehelper.isNullOrEmptyObject(pidlDoc.dataSources)) {
                    dataSourceObjects.push(pidlDoc.dataSources);
                }
                if (pidlDoc.linkedPidls && pidlDoc.linkedPidls.length > 0) {
                    for (var i = 0; i < pidlDoc.linkedPidls.length; i++) {
                        if (!typehelper.isNullOrEmptyObject(pidlDoc.linkedPidls[i].dataSources)) {
                            dataSourceObjects.push(pidlDoc.linkedPidls[i].dataSources);
                        }
                    }
                }
            }
            return dataSourceObjects;
        };
    }
    return pidlDocHelper;
}());
var pidlDocHelper$1 = new pidlDocHelper();

"use strict";
var modelElementFactory = /** @class */ (function () {
    function modelElementFactory() {
        var _this = this;
        this.createModelElement = function (type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, pidlDocManager, bindingDataContext, idSuffix) {
            switch (type) {
                case modelElementType.button:
                    _this.addHandleToDisplayDescriptions(displayDescription, pidlDocManager);
                    return new ButtonElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix);
                case modelElementType.filePicker:
                    return new FilePickerElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.checkBox:
                    return new CheckBoxElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.dropdown:
                    _this.addHandleToDisplayDescriptions(displayDescription, pidlDocManager);
                    return new DropdownElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.group:
                    return new GroupElement(type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix);
                case modelElementType.captcha:
                    return new CaptchaElement(type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix);
                case modelElementType.page:
                    return new PageElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.textGroup:
                    return new TextGroupElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.dataCollectionBindingGroup:
                    return new DataCollectionBindingGroupElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.textBox:
                    return new TextBoxElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, pidlDocManager);
                case modelElementType.radio:
                    _this.addHandleToDisplayDescriptions(displayDescription, pidlDocManager);
                    return new RadioElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.buttonList:
                    _this.addHandleToDisplayDescriptions(displayDescription, pidlDocManager);
                    return new ButtonListElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.secureProperty:
                    return new SecurePropertyElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, pidlDocManager);
                case modelElementType.iFrame:
                    return new IFrameElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.challengeIFrame:
                    return new ChallengeIFrameElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.heading:
                case modelElementType.subheading:
                case modelElementType.text:
                case modelElementType.hyperlink:
                    return new TextElement(type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix);
                case modelElementType.image:
                    return new ImageElement(type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix);
                case modelElementType.logo:
                    return new LogoElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, pidlDocManager, idSuffix);
                case modelElementType.audio:
                    return new AudioElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix);
                case modelElementType.expression:
                    return new ExpressionElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix);
                case modelElementType.pidlContainer:
                    return new PidlContainer(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
                case modelElementType.separator:
                    return new SeparatorElement(type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix);
                case modelElementType.spinner:
                    return new SpinnerElement(type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix);
                default:
                    return new ModelElement(type, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl);
            }
        };
        this.addHandleToDisplayDescriptions = function (displayDescription, pidlDocManager) {
            if (pidlDocManager) {
                var handle = pidlDocManager.getOperationHandle();
                if (handle) {
                    var pidlActions = pidlDocHelper$1.getDisplayDescriptionsPidlActions(displayDescription);
                    for (var i = 0; i < pidlActions.length; i++) {
                        var pidlAction = pidlActions[i];
                        if ((pidlAction.type === supportedPidlActions.success ||
                            pidlAction.type === supportedPidlActions.successWithPidlPayload) &&
                            typehelper.isObject(pidlAction.context)) {
                            pidlAction.context.handle = handle;
                            if (typehelper.isObject(pidlAction.context.resourceActionContext)) {
                                pidlAction.context.resourceActionContext.handle = handle;
                            }
                        }
                    }
                }
            }
        };
        this.getPidlIdentityHash = function (pidlDoc, displayDescription) {
            if (!displayDescription.propertyName) {
                return;
            }
            var identity = pidlDocHelper$1.getPidlIdentityForProperty(pidlDoc, displayDescription.propertyName);
            if (identity) {
                return pidlDocHelper$1.createIdentityHash(identity);
            }
        };
        this.isErrorObject = function (obj) {
            return obj.error !== undefined;
        };
        // Returns { "elements": pages, "warnings": [warnings] } or { "error": error }
        this.addPage = function (pidlDoc, dataDescription, displayDescription, operationType, pidlDocManager, bindingDataContext, idSuffix) {
            var pageContainer = _this.create(pidlDoc, dataDescription, displayDescription, operationType, pidlDocManager, false, {}, null, bindingDataContext, idSuffix);
            if (_this.isErrorObject(pageContainer)) {
                return pageContainer;
            }
            var pages = null;
            var page = pageContainer.element;
            var warnings = __spreadArray([], pageContainer.warnings, true);
            if (page) {
                if (isPidlContainerElement(page)) {
                    // this can only be reached by a pidlcontainer that is not a child of a page rather a child of a DisplayDescription
                    // which means that it's a multipage pidlcontainer for a linked pidl with single/multiple pages because addPage is only called
                    // during traversal of DisplayDescription
                    var linkedPidlModelElementsContainer = _this.createLinkedPidlModelElements(pidlDocManager, operationType, page.linkedPidlId, true, {});
                    if (_this.isErrorObject(linkedPidlModelElementsContainer)) {
                        return linkedPidlModelElementsContainer;
                    }
                    pages = __spreadArray([], linkedPidlModelElementsContainer.elements, true);
                    warnings = __spreadArray(__spreadArray([], warnings, true), linkedPidlModelElementsContainer.warnings, true);
                }
                else {
                    pages = [page];
                }
            }
            return { elements: pages, warnings: warnings };
        };
        // Returns { "element": element, "warnings": [warnings] } or { "error": error }
        this.create = function (pidlDoc, dataDescriptionIn, displayDescriptionIn, operationTypeIn, pidlDocManager, isLinkedPidl, displayIds, pageId, bindingDataContext, idSuffix) {
            var elementTypeValue = utils.getModelElementType(dataDescriptionIn, displayDescriptionIn);
            if (elementTypeValue.error) {
                return { error: elementTypeValue.error };
            }
            var pidlIdentity = _this.getPidlIdentityHash(pidlDoc, displayDescriptionIn);
            var modelElement = _this.createModelElement(elementTypeValue.type, dataDescriptionIn, displayDescriptionIn, operationTypeIn, pidlIdentity, isLinkedPidl, pidlDocManager, bindingDataContext, idSuffix);
            var warnings = [];
            if (displayIds) {
                if (modelElement.displayType !== pidlDisplayTypesValues.page && displayIds[modelElement.displayId]) {
                    warnings = __spreadArray(__spreadArray([], warnings, true), [new pidlErrors.unexpectedError(errorMessages.duplicateDisplayHintIdOnPage, [modelElement.displayId, pageId])], false);
                }
                if (!pageId) {
                    pageId = modelElement.displayId;
                }
                displayIds[modelElement.displayId] = true;
            }
            if (isCaptchaElement(modelElement)) {
                var displayDescription = modelElement.displayDescription;
                var memberArray = ["audioMembers", "imageMembers"];
                for (var j = 0; j < memberArray.length; j++) {
                    for (var i = 0; i < displayDescription[memberArray[j]].length; i++) {
                        var childContainer = _this.create(pidlDoc, pidlDoc && commerceHelper$1.getPropertyFromDataDescription(pidlDoc.data_description, displayDescription[memberArray[j]][i].propertyName), displayDescription[memberArray[j]][i], operationTypeIn, pidlDocManager, isLinkedPidl, displayIds, pageId, bindingDataContext, idSuffix);
                        if (_this.isErrorObject(childContainer)) {
                            return childContainer;
                        }
                        warnings = __spreadArray(__spreadArray([], warnings, true), childContainer.warnings, true);
                        var child = childContainer.element;
                        (j === 0) ? modelElement.audioChildren.push(child) : modelElement.imageChildren.push(child);
                    }
                }
            }
            else if (isContainerElement(modelElement)) {
                var displayDescription = modelElement.displayDescription;
                for (var i = 0; i < displayDescription.members.length; i++) {
                    var childContainer = _this.create(pidlDoc, pidlDoc && commerceHelper$1.getPropertyFromDataDescription(pidlDoc.data_description, displayDescription.members[i].propertyName), displayDescription.members[i], operationTypeIn, pidlDocManager, isLinkedPidl, displayIds, pageId, bindingDataContext, idSuffix);
                    if (_this.isErrorObject(childContainer)) {
                        return childContainer;
                    }
                    warnings = __spreadArray(__spreadArray([], warnings, true), childContainer.warnings, true);
                    var child = childContainer.element;
                    if (!isPidlContainerElement(child)) {
                        modelElement.children.push(child);
                    }
                    else {
                        // only a pidlContainer in a page, group, or textgroup can get here which means it's not a multipage pidlcontainer
                        var linkedPidlModelElementsContainer = _this.createLinkedPidlModelElements(pidlDocManager, operationTypeIn, child.linkedPidlId, false, displayIds, pageId);
                        if (_this.isErrorObject(linkedPidlModelElementsContainer)) {
                            return linkedPidlModelElementsContainer;
                        }
                        modelElement.children = __spreadArray(__spreadArray([], modelElement.children, true), linkedPidlModelElementsContainer.elements, true);
                        warnings = __spreadArray(__spreadArray([], warnings, true), linkedPidlModelElementsContainer.warnings, true);
                    }
                }
            }
            else if (isButtonElement(modelElement)) {
                _this.createButtonWithDisplayContentGroup(modelElement);
            }
            else {
                _this.createPossibleOptionMembers(modelElement, bindingDataContext);
            }
            return { element: modelElement, warnings: warnings };
        };
        this.createPossibleOptionMembers = function (modelElement, bindingContext) {
            if (!isSelectionElement(modelElement)) {
                return;
            }
            for (var key in modelElement.possibleOptions) {
                var possibleOption = modelElement.possibleOptions[key];
                if (!possibleOption.displayContent) {
                    continue;
                }
                var result = _this.createModelElementsFromDisplayDescriptions([possibleOption.displayContent], modelElement.operationType, bindingContext);
                var elements = result.elements;
                if (elements && elements.length >= 1) {
                    possibleOption.displayContentContainer = elements[0];
                }
            }
        };
        this.createButtonWithDisplayContentGroup = function (modelElement) {
            if (modelElement.displayDescription.displayContentDisplayDescription) {
                var displayContent = modelElement.displayDescription.displayContentDisplayDescription;
                var result = _this.createModelElementsFromDisplayDescriptions([displayContent], modelElement.operationType);
                var elements = result.elements;
                if (elements && elements.length >= 1) {
                    modelElement.displayContentModelElement = elements[0];
                }
            }
        };
        // Returns { "elements": elements, "warnings": [warnings] } or { "error": error }
        this.createLinkedPidlModelElements = function (pidlDocManager, operationType, pidlId, isMultiPage, displayIds, pageId) {
            var pidlIdHash = pidlDocHelper$1.createIdentityHash(pidlId);
            var pidlDoc = pidlDocManager.getLinkedPidl(pidlIdHash);
            var ret = { elements: [], warnings: [] };
            var linkedPidlPageExtracted = false;
            for (var i = 0; i < pidlDoc.displayDescription.length; i++) {
                var displayDescription = pidlDoc.displayDescription[i];
                var elementContainer = _this.create(pidlDoc, commerceHelper$1.getPropertyFromDataDescription(pidlDoc.data_description, displayDescription.propertyName), displayDescription, operationType, pidlDocManager, true, displayIds, pageId);
                if (_this.isErrorObject(elementContainer)) {
                    return elementContainer;
                }
                var element = elementContainer.element, warnings = elementContainer.warnings;
                ret.warnings = __spreadArray(__spreadArray([], ret.warnings, true), warnings, true);
                if (!isMultiPage && isPageElement(element)) {
                    if (!linkedPidlPageExtracted) {
                        // get elements from root page container in single page scenario
                        ret.elements = __spreadArray(__spreadArray([], ret.elements, true), element.children, true);
                        linkedPidlPageExtracted = true;
                    }
                    else {
                        return { "error": new pidlErrors.unexpectedError(errorMessages.multiplePagesInLinkedPidlForSinglePagePidlContainer) };
                    }
                }
                else {
                    ret.elements = __spreadArray(__spreadArray([], ret.elements, true), [element], false);
                }
            }
            return ret;
        };
        // Returns { "elements": elements, "warnings": [warnings] } or { "error": error }
        this.createModelElements = function (pidlDocManager, operationType) {
            var pidlDoc = pidlDocManager.getResolvedOrFirstPidlDoc();
            var elements = [];
            var warnings = [];
            if (pidlDoc && pidlDoc.displayDescription && pidlDoc.displayDescription.length) {
                for (var i = 0; i < pidlDoc.displayDescription.length; i++) {
                    var displayDescription = pidlDoc.displayDescription[i];
                    var pagesContainer = _this.addPage(pidlDoc, commerceHelper$1.getPropertyFromDataDescription(pidlDoc.data_description, displayDescription.propertyName), displayDescription, operationType, pidlDocManager);
                    if (_this.isErrorObject(pagesContainer)) {
                        return pagesContainer;
                    }
                    elements = __spreadArray(__spreadArray([], elements, true), pagesContainer.elements, true);
                    warnings = __spreadArray(__spreadArray([], warnings, true), pagesContainer.warnings, true);
                }
            }
            if (elements.length === 0) {
                return { error: new pidlErrors.unexpectedError(errorMessages.noDisplayDescriptionInPidlDocument) };
            }
            return { elements: elements, warnings: warnings };
        };
        // Returns { "elements": elements }
        this.createModelElementsFromDisplayDescriptions = function (displayDescriptions, operationType, bindingDataContext, idSuffix, pidlDoc, pidlDocManager) {
            var elements = [];
            for (var i = 0; i < displayDescriptions.length; i++) {
                var displayDescription = displayDescriptions[i];
                if (displayDescription) {
                    // No error handling by design
                    var dataDescription = pidlDoc && pidlDoc.data_description && commerceHelper$1.getPropertyFromDataDescription(pidlDoc.data_description, displayDescription.propertyName);
                    var pagesContainer = _this.addPage(pidlDoc, dataDescription, displayDescription, operationType, pidlDocManager, bindingDataContext, idSuffix);
                    if (!_this.isErrorObject(pagesContainer)) {
                        elements = __spreadArray(__spreadArray([], elements, true), pagesContainer.elements, true);
                    }
                }
            }
            return { elements: elements };
        };
    }
    return modelElementFactory;
}());
var modelElementFactory$1 = new modelElementFactory();

"use strict";
var modelElementsHelper = /** @class */ (function () {
    function modelElementsHelper() {
        var _this = this;
        this.normalizeValueToOptions = function (options, value) {
            var result = typehelper.find(options, function (option) {
                return typehelper.equalsIgnoreCase(option, value);
            });
            if (!result) {
                // if we pass value, which couldn't match with any options then we are setting value as empty.
                result = "";
            }
            return result;
        };
        this.updateModelElements = function (modelElements, bindingDataContext, eventHub) {
            _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, bindingDataContext) {
                if (modelElement.update) {
                    return modelElement.update(bindingDataContext, eventHub);
                }
                return false;
            }, bindingDataContext);
        };
        this.findFirstMatchingProperty = function (modelElements, properties) {
            var context = { properties: properties };
            _this.propertiesVisitorProcessingDataProperty(modelElements, function (propertyElement, context) {
                if (!propertyElement.isPrefillControl() && typehelper.contains(context.properties, propertyElement.getPropertyName())) {
                    context.matchedProperty = propertyElement.getPropertyName();
                    return true;
                }
            }, context);
            return context.matchedProperty;
        };
        this.getParentIfSame = function (modelElements, propertyNames) {
            var parent = null;
            for (var index = 0; index < propertyNames.length; index++) {
                var context = { propertyName: propertyNames[index] };
                _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, context) {
                    if (modelElement && modelElement.children) {
                        for (var index = 0; index < modelElement.children.length; index++) {
                            if (modelElement.children[index].isProperty()) {
                                var propertyElem = modelElement.children[index];
                                if (propertyElem && propertyElem.getPropertyName && propertyElem.getPropertyName() === context.propertyName) {
                                    context.parent = modelElement;
                                    return true;
                                }
                            }
                        }
                    }
                }, context);
                if (!context.parent) {
                    continue;
                }
                if (!parent) {
                    parent = context.parent;
                }
                else if (context.parent !== parent) {
                    return null;
                }
            }
            return parent;
        };
        this.findPropertyElement = function (modelElements, propertyName) {
            var context = { propertyName: propertyName };
            _this.propertiesVisitorProcessingDataProperty(modelElements, function (modelElement, context) {
                if (modelElement.getPropertyName() === context.propertyName) {
                    context.element = modelElement;
                    return true;
                }
            }, context);
            return context.element;
        };
        this.findElement = function (modelElements, evaluator) {
            var context = {};
            _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, context) {
                if (evaluator(modelElement)) {
                    context.element = modelElement;
                    return true;
                }
            }, context);
            return context.element;
        };
        this.findAllElements = function (modelElements, evaluator) {
            var context = { elements: [] };
            _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, context) {
                if (evaluator(modelElement)) {
                    context.elements.push(modelElement);
                }
            }, context);
            return context.elements;
        };
        this.findPrefillControlElement = function (modelElements) {
            return _this.findElement(modelElements, function (modelElement) {
                if (modelElement && modelElement.displayType === pidlDisplayTypesValues.prefillControl) {
                    return true;
                }
            });
        };
        this.findFirstVisibleEnabledPropertyElement = function (modelElements) {
            var context = {};
            _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, ctx) {
                if (modelElement && (modelElement.isProperty() || modelElement.isSecureProperty() || modelElement.isPrefillControl()) && !modelElement.disabled() && !modelElement.hidden()) {
                    ctx.element = modelElement;
                    return true;
                }
            }, context);
            return context.element;
        };
        this.isButtonWithDisplayDescription = function (modelElement) {
            return isButtonElement(modelElement) && !typehelper.isNullOrUndefined(modelElement.displayDescription);
        };
        this.findFirstButtonElement = function (modelElements) {
            return _this.findElement(modelElements, function (modelElement) {
                return isButtonElement(modelElement);
            });
        };
        this.findHighlightedButton = function (modelElements) {
            return _this.findElement(modelElements, function (modelElement) {
                return _this.isButtonWithDisplayDescription(modelElement) &&
                    modelElement.displayDescription.isHighlighted;
            });
        };
        this.findDefaultPidlActionButton = function (modelElements) {
            return _this.findElement(modelElements, function (modelElement) {
                return _this.isButtonWithDisplayDescription(modelElement) &&
                    modelElement.displayDescription.pidlAction &&
                    modelElement.displayDescription.pidlAction.isDefault;
            });
        };
        this.getDefaultPidlActionButton = function (modelElements, eventHub) {
            var button = _this.findDefaultPidlActionButton(modelElements);
            if (!button) {
                //[TODO] consider logging a info event
                button = _this.findHighlightedButton(modelElements) || _this.findFirstButtonElement(modelElements);
            }
            return button;
        };
        this.getDefaultPidlAction = function (modelElements, eventHub) {
            var defaultPidlActionButton = _this.findDefaultPidlActionButton(modelElements);
            if (!defaultPidlActionButton) {
                //[TODO] consider logging a info event
                defaultPidlActionButton = _this.findHighlightedButton(modelElements);
            }
            return defaultPidlActionButton && defaultPidlActionButton.displayDescription && defaultPidlActionButton.displayDescription.pidlAction;
        };
        this.getDefaultSuccessPidlPayload = function (modelElements, eventHub) {
            var defaultPidlAction = _this.getDefaultPidlAction(modelElements, eventHub);
            if (defaultPidlAction) {
                if (defaultPidlAction.type === supportedPidlActions.success ||
                    defaultPidlAction.type === supportedPidlActions.successWithPidlPayload) {
                    return defaultPidlAction.context;
                }
            }
        };
        this.normalizeValueToPossibleValues = function (selectionElement, value) {
            var result = _this.normalizeValueToOptions(typehelper.getKeys(selectionElement.possibleOptions), value);
            if (typehelper.isEmptyString(result) && selectionElement.dataDescription.possible_values) {
                result = _this.normalizeValueToOptions(typehelper.getKeys(selectionElement.dataDescription.possible_values), value);
            }
            return result;
        };
        this.normalizeValueToDisplayDescriptionPossibleOptions = function (selectionElement, value) {
            return _this.normalizeValueToOptions(typehelper.getKeys(selectionElement.possibleOptions), value);
        };
        this.getPollingPidlActions = function (modelElements) {
            var pollingPidlActions = {};
            modelElements.forEach(function (element) {
                if (element.pidlAction && element.pidlAction.type === supportedPidlActions.poll) {
                    pollingPidlActions[element.displayId] = element.pidlAction;
                }
                if (element.children) {
                    pollingPidlActions = __assign(__assign({}, pollingPidlActions), _this.getPollingPidlActions(element.children));
                }
            });
            return pollingPidlActions;
        };
        this.getPagePidlActions = function (modelElements, actionToGet) {
            var pagePidlActions = {};
            modelElements.forEach(function (element) {
                if (typehelper.isObject(element.pidlAction) && (!typehelper.isString(actionToGet) || element.pidlAction.type === actionToGet)) {
                    pagePidlActions[element.displayId] = element.pidlAction;
                }
            });
            return pagePidlActions;
        };
        this.findRadioElements = function (modelElements) {
            return _this.findAllElements(modelElements, function (modelElement) {
                return isRadioElement(modelElement);
            });
        };
    }
    // TODO: Combine propertyVisitorProcessingDataProperty and propertyVisitorProcessingAny
    // TODO: Move { stopDescendantsProcessing?: boolean } into its own interface so that context should be combination of T and
    // that interface which is metadata for this recursive function, also remove stopDescendantsProcessing from modelData.IBindingDataContext
    modelElementsHelper.prototype.propertyVisitorProcessingDataProperty = function (modelProperty, action, context) {
        if (!modelProperty) {
            return;
        }
        if (modelProperty.isProperty() || modelProperty.isSecureProperty() || modelProperty.isCaptcha()) {
            var stopProcessing = action(modelProperty, context);
            if (stopProcessing) {
                return stopProcessing;
            }
        }
        if (modelProperty.children && modelProperty.children.length > 0 && (!context || !context.stopDescendantsProcessing)) {
            return this.propertiesVisitorProcessingDataProperty(modelProperty.children, action, context);
        }
        if (context) {
            delete context.stopDescendantsProcessing;
        }
    };
    modelElementsHelper.prototype.propertyVisitorProcessingAny = function (modelProperty, action, context) {
        if (!modelProperty) {
            return;
        }
        var stopProcessing = action(modelProperty, context);
        if (stopProcessing) {
            return stopProcessing;
        }
        if (modelProperty.children && modelProperty.children.length > 0 && (!context || !context.stopDescendantsProcessing)) {
            return this.propertiesVisitorProcessingAny(modelProperty.children, action, context);
        }
        if (context) {
            delete context.stopDescendantsProcessing;
        }
    };
    modelElementsHelper.prototype.propertiesVisitorProcessingDataProperty = function (modelProperties, action, context) {
        if (!modelProperties) {
            return;
        }
        // TODO: Code path for single element does not seem to getting hit and could be removed.
        if (!typehelper.isArray(modelProperties)) {
            return this.propertyVisitorProcessingDataProperty(modelProperties, action, context);
        }
        else {
            for (var index = 0; index < modelProperties.length; index++) {
                var stopProcessing = this.propertyVisitorProcessingDataProperty(modelProperties[index], action, context);
                if (stopProcessing) {
                    return stopProcessing;
                }
            }
        }
    };
    modelElementsHelper.prototype.propertiesVisitorProcessingAny = function (modelProperties, action, context) {
        if (!modelProperties) {
            return;
        }
        // TODO: Code path for single element does not seem to getting hit and could be removed.
        if (!typehelper.isArray(modelProperties)) {
            return this.propertyVisitorProcessingAny(modelProperties, action, context);
        }
        else {
            for (var index = 0; index < modelProperties.length; index++) {
                var stopProcessing = this.propertyVisitorProcessingAny(modelProperties[index], action, context);
                if (stopProcessing) {
                    return stopProcessing;
                }
            }
        }
    };
    return modelElementsHelper;
}());
var modelElementsHelper$1 = new modelElementsHelper();

"use strict";
var ModelElement = /** @class */ (function () {
    function ModelElement(typeIn, dataDescription, displayDescription, operationType, pidlIdentityHash, isLinkedPidl) {
        var _this = this;
        this.isText = function () {
            return _this.isStaticText() || _this.type === modelElementType.hyperlink;
        };
        this.isStaticText = function () {
            return _this.type === modelElementType.heading ||
                _this.type === modelElementType.subheading ||
                _this.type === modelElementType.text ||
                _this.type === modelElementType.expression;
        };
        this.isProperty = function () {
            return _this.displayDescription.displayType === pidlDisplayTypesValues.property;
        };
        this.isCaptcha = function () {
            return _this.displayDescription.displayType === pidlDisplayTypesValues.captcha;
        };
        this.isPrefillControl = function () {
            return _this.displayDescription.displayType === pidlDisplayTypesValues.prefillControl;
        };
        this.isButton = function () {
            return _this.displayDescription.displayType === pidlDisplayTypesValues.button;
        };
        this.isHighlighted = function () {
            return _this.displayDescription.isHighlighted;
        };
        this.isIframe = function () {
            return _this.displayDescription.displayType === pidlDisplayTypesValues.iFrame;
        };
        this.isChallengeIframe = function () {
            return _this.displayDescription.displayType === pidlDisplayTypesValues.challengeIframe;
        };
        this.isSecureProperty = function () {
            return _this.displayDescription.displayType === pidlDisplayTypesValues.secureProperty;
        };
        this.showKeyLogo = function () {
            return typehelper.boolify(_this.dataDescription) && _this.dataDescription.is_key === true;
        };
        this.disabled = function () {
            return (_this.operationType === pidlOperationTypeValues.update &&
                _this.dataDescription &&
                _this.dataDescription.is_updatable === false) ||
                _this.isDisabled === true;
        };
        this.hidden = function () {
            return _this.isHidden || _this.hasNoDataToShow;
        };
        this.canBeRendered = function () {
            return _this.displayConditionResult;
        };
        this.isConditionalFieldProperty = function () {
            return typehelper.boolify(_this.dataDescription && _this.dataDescription.isConditionalFieldValue);
        };
        // If keepKeys is true then returns tags with keys with given prefix with the prefix removed, else
        // returns tags as { value: value, ...} where each value can be added as a class to a html element
        // in htmlHelper.addTaggedClassNames
        this.getPrefixedTags = function (prefix, keepKeys, filter) {
            filter = filter || (function (key, value) { return true; });
            var result = {};
            Object.keys(_this.tags ? _this.tags : {}).forEach(function (key) {
                var value = _this.tags[key];
                if (typehelper.startsWith(key, prefix) && filter(key, value)) {
                    result[keepKeys ? key.replace(prefix, "") : value] = value;
                }
            });
            return result;
        };
        this.getParentHtmlClassTags = function () {
            return _this.getPrefixedTags(knownTagPrefixes.parent, false, function (key, value) {
                return !knownTags[key.replace(knownTagPrefixes.parent, "")];
            });
        };
        this.getHelpDialogTags = function () {
            return _this.getPrefixedTags(knownTagPrefixes.helpDialog, true, function (key, value) {
                return knownTags[key.replace(knownTagPrefixes.helpDialog, "")];
            });
        };
        this.update = function (bindingDataContext, eventHub) {
            if (_this.displayCondition) {
                _this.displayConditionResult = utils.getFunctionExecutionResult(_this.displayCondition, bindingDataContext);
            }
            if (_this.conditionalFields) {
                for (var field in _this.conditionalFields) {
                    if (_this.hasOwnProperty(field)) {
                        var valueExpression = _this.conditionalFields[field];
                        _this[field] = utils.getConditionalFieldValue(valueExpression, bindingDataContext, _this);
                    }
                }
            }
            return _this.updateModelElement(bindingDataContext, eventHub);
        };
        this.operationType = operationType;
        this.dataDescription = dataDescription;
        this.displayDescription = displayDescription;
        this.type = typeIn;
        this.pidlIdentity = pidlIdentityHash;
        this.isLinkedPidl = isLinkedPidl;
        this.hasNoDataToShow = false;
        var _a = this.displayDescription, isHidden = _a.isHidden, displayCondition = _a.displayCondition, displayId = _a.displayId, displayType = _a.displayType, tags = _a.tags, propertyName = _a.propertyName, pidlAction = _a.pidlAction, displayHelpName = _a.displayHelpName, displayHelp = _a.displayHelp, displayImage = _a.displayImage, isDisabled = _a.isDisabled, styleHints = _a.styleHints, conditionalFields = _a.conditionalFields;
        this.isHidden = isHidden === true;
        this.displayCondition = displayCondition;
        this.displayConditionResult = !this.displayCondition;
        this.pidlAction = pidlAction;
        this.displayId = displayId;
        this.displayType = displayType;
        this.tags = tags;
        this.styleHints = styleHints;
        this.conditionalFields = conditionalFields;
        this.displayHelpName = displayHelpName;
        this.displayHelp = displayHelp;
        this.displayImage = displayImage;
        this.accessibilityName = null;
        this.tabIndex = null;
        if (this.tags) {
            this.accessibilityName = this.tags.accessibilityName;
            this.accessibilityHint = this.tags.accessibilityHint;
            this.disabledAccessibilityName = this.tags.disabledAccessibilityName;
            if (this.tags.tabIndex) {
                this.tabIndex = String(this.tags.tabIndex);
            }
            this.maxLengthMessage = this.tags.maxLengthMessage;
        }
        var val = propertyName;
        this.id = val ? val : displayId;
        this.isDisabled = isDisabled;
        this.children = [];
        this.audioChildren = [];
        this.imageChildren = [];
    }
    ModelElement.prototype.updateModelElement = function (bindingDataContext, eventHub) { return false; };
    return ModelElement;
}());
var ContainerElement = /** @class */ (function (_super) {
    __extends(ContainerElement, _super);
    function ContainerElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        var layoutOrientation = displayDescription.layoutOrientation, layoutAlignment = displayDescription.layoutAlignment, containerDescription = displayDescription.containerDescription, members = displayDescription.members, displayName = displayDescription.displayName, showDisplayName = displayDescription.showDisplayName;
        _this.layoutOrientation = layoutOrientation ? layoutOrientation : groupLayoutOrientationTypesValues.vertical;
        _this.layoutAlignment = layoutAlignment;
        _this.containerDescription = containerDescription;
        _this.members = members;
        _this.displayName = displayName;
        _this.showDisplayName = displayName && (typehelper.boolify(showDisplayName));
        return _this;
    }
    return ContainerElement;
}(ModelElement));
var GenericGroupElement = /** @class */ (function (_super) {
    __extends(GenericGroupElement, _super);
    function GenericGroupElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        var displayName = displayDescription.displayName, showDisplayName = displayDescription.showDisplayName, isSubmitGroup = displayDescription.isSubmitGroup, isModalGroup = displayDescription.isModalGroup;
        _this.displayName = displayName;
        _this.showDisplayName = displayName && (!showDisplayName || showDisplayName === showDisplayNameValues.stringTrue);
        _this.isSubmitGroup = isSubmitGroup;
        _this.isModalGroup = isModalGroup;
        if (idSuffix) {
            _this.id += idSuffix;
        }
        return _this;
    }
    return GenericGroupElement;
}(ContainerElement));
var GroupElement = /** @class */ (function (_super) {
    __extends(GroupElement, _super);
    function GroupElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) {
        return _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) || this;
    }
    GroupElement.prototype.updateModelElement = function (bindingDataContext) {
        if (this.pidlAction && typehelper.isObject(this.pidlAction.context)) {
            var context = {};
            for (var key in this.pidlAction.context) {
                // if context["instance"] is of type string, then evaluate the expression
                if (key === "instance" && typehelper.isString(this.pidlAction.context[key])) {
                    context[key] = utils.getFormatInstanceExpressionValue(this.pidlAction.context[key], bindingDataContext);
                }
                else {
                    context[key] = utils.getFormatStringExpressionValue(this.pidlAction.context[key], bindingDataContext);
                }
            }
            this.pidlAction.context = context;
        }
        return false;
    };
    return GroupElement;
}(GenericGroupElement));
var DataCollectionBindingGroupElement = /** @class */ (function (_super) {
    __extends(DataCollectionBindingGroupElement, _super);
    function DataCollectionBindingGroupElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.dataCollectionBindingGroup, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.dataCollectionSource = displayDescription.dataCollectionSource;
        _this.filterDescription = displayDescription.filterDescription;
        _this.childrenTemplates = _this.children;
        return _this;
    }
    DataCollectionBindingGroupElement.prototype.updateModelElement = function (bindingDataContext) {
        if (this.dataCollectionSource) {
            var bindingData = utils.getPropertyExpressionValue(this.dataCollectionSource, bindingDataContext);
            if (this.filterDescription) {
                bindingData = utils.getFunctionExecutionResult(this.filterDescription, { modelData: bindingDataContext.modelData, contextData: bindingData });
            }
            var newElements = null;
            if (bindingData && bindingData.length && typehelper.isArray(bindingData)) {
                newElements = [];
                for (var i = 0; i < bindingData.length; i++) {
                    var memberElementsBindingDataContext = { modelData: bindingDataContext.modelData, contextData: bindingData[i] };
                    for (var j = 0; j < this.childrenTemplates.length; j++) {
                        var id = String(i);
                        if (bindingDataContext.depth) {
                            this.id = this.id + bindingDataContext.depth;
                            id = bindingDataContext.depth + "_" + id;
                            memberElementsBindingDataContext.depth = id + String.fromCharCode(bindingDataContext.depth.charCodeAt(bindingDataContext.depth.length - 1) + 1);
                        }
                        else {
                            memberElementsBindingDataContext.depth = id + "a";
                        }
                        var displayElement = typehelper.deepCopy(this.childrenTemplates[j]);
                        // The nested element ids must be unique, for now, send index of element in collection to append to id
                        var elements = modelElementFactory$1.createModelElementsFromDisplayDescriptions([displayElement.displayDescription], this.operationType, memberElementsBindingDataContext, id).elements;
                        if (elements && elements.length >= 1) {
                            bindingDataContext.stopDescendantsProcessing = true;
                            modelElementsHelper$1.updateModelElements(elements, memberElementsBindingDataContext);
                            newElements = newElements.concat(elements);
                        }
                    }
                }
            }
            this.children = newElements;
        }
        return false;
    };
    return DataCollectionBindingGroupElement;
}(GenericGroupElement));
var CaptchaContainerElement = /** @class */ (function (_super) {
    __extends(CaptchaContainerElement, _super);
    function CaptchaContainerElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        var layoutOrientation = displayDescription.layoutOrientation, layoutAlignment = displayDescription.layoutAlignment, containerDescription = displayDescription.containerDescription, audioMembers = displayDescription.audioMembers, imageMembers = displayDescription.imageMembers, displayName = displayDescription.displayName, showDisplayName = displayDescription.showDisplayName;
        _this.layoutOrientation = layoutOrientation ? layoutOrientation : groupLayoutOrientationTypesValues.vertical;
        _this.layoutAlignment = layoutAlignment;
        _this.containerDescription = containerDescription;
        _this.audioMembers = audioMembers;
        _this.imageMembers = imageMembers;
        _this.displayName = displayName;
        _this.showDisplayName = displayName && (typehelper.boolify(showDisplayName));
        return _this;
    }
    return CaptchaContainerElement;
}(ModelElement));
var GenericCaptchaElement = /** @class */ (function (_super) {
    __extends(GenericCaptchaElement, _super);
    function GenericCaptchaElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.getPropertyName = function () {
            return _this.displayDescription.propertyName;
        };
        _this.required = function () {
            return !(_this.dataDescription.is_optional === true);
        };
        var displayName = displayDescription.displayName, showDisplayName = displayDescription.showDisplayName;
        _this.displayName = displayName;
        _this.showDisplayName = displayName && (!showDisplayName || showDisplayName === showDisplayNameValues.stringTrue);
        _this.defaultValue = dataDescription.default_value;
        if (idSuffix) {
            _this.id += idSuffix;
        }
        return _this;
    }
    return GenericCaptchaElement;
}(CaptchaContainerElement));
var CaptchaElement = /** @class */ (function (_super) {
    __extends(CaptchaElement, _super);
    function CaptchaElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) {
        return _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) || this;
    }
    return CaptchaElement;
}(GenericCaptchaElement));
var PageElement = /** @class */ (function (_super) {
    __extends(PageElement, _super);
    function PageElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.page, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.displayName = displayDescription.displayName;
        _this.keyPidlActions = displayDescription.keyPidlActions;
        return _this;
    }
    return PageElement;
}(ContainerElement));
var TextGroupElement = /** @class */ (function (_super) {
    __extends(TextGroupElement, _super);
    function TextGroupElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.textGroup, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.displayContent = displayDescription.displayContent;
        return _this;
    }
    return TextGroupElement;
}(ContainerElement));
var PropertyElement = /** @class */ (function (_super) {
    __extends(PropertyElement, _super);
    function PropertyElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.getPropertyName = function () {
            return _this.displayDescription.propertyName;
        };
        _this.getErrorMessage = function (propertyValue, errorCode) {
            var displayErrors = _this.displayErrorMessages;
            var errorMessage;
            if (displayErrors) {
                if (errorCode && displayErrors.fromErrorCode) {
                    for (var i = 0; i < displayErrors.fromErrorCode.length; i++) {
                        var curErrorCode = displayErrors.fromErrorCode[i];
                        if (curErrorCode.errorCode === errorCode) {
                            errorMessage = curErrorCode.errorMessage;
                            break;
                        }
                    }
                }
                else if (displayErrors.fromRegex) {
                    for (var i = 0; i < displayErrors.fromRegex.length; i++) {
                        var curRegex = displayErrors.fromRegex[i];
                        var regex = new RegExp(curRegex.regex);
                        if (regex.test(propertyValue)) {
                            errorMessage = curRegex.errorMessage;
                            break;
                        }
                    }
                }
                if (!errorMessage) {
                    errorMessage = displayErrors.defaultErrorMessage;
                }
            }
            return errorMessage;
        };
        _this.required = function () {
            return !(_this.dataDescription.is_optional === true)
                && _this.displayDescription.displayType !== pidlDisplayTypesValues.prefillControl;
        };
        var _a = _this.displayDescription, displayName = _a.displayName, showDisplayName = _a.showDisplayName, displayErrorMessages = _a.displayErrorMessages, displayLogo = _a.displayLogo, maskDisplay = _a.maskDisplay, resolutionPolicy = _a.resolutionPolicy, displayHelpPosition = _a.displayHelpPosition;
        var is_key = dataDescription.is_key, transformation = dataDescription.transformation, displayOnly = dataDescription.displayOnly, default_value = dataDescription.default_value, broadcastTo = dataDescription.broadcastTo, sideEffects = dataDescription.sideEffects, onValidationFailed = dataDescription.onValidationFailed;
        if (typehelper.isFormatStringExpressionPlaceholder(default_value)) {
            _this.defaultValueTemplate = default_value;
        }
        else {
            _this.defaultValue = default_value;
        }
        _this.displayName = displayName;
        _this.showDisplayName = displayName && (!showDisplayName || showDisplayName === showDisplayNameValues.stringTrue);
        _this.isKeyProperty = is_key === true;
        _this.supportsDisplayTransformation = transformation && !typehelper.isNullOrUndefined(transformation.forDisplay);
        _this.displayErrorMessages = displayErrorMessages;
        _this.displayLogo = displayLogo;
        _this.maskDisplay = maskDisplay;
        _this.triggerPidlDownloadOnChange = _this.isKeyProperty && pidlDocHelper$1.doesKeyPropertyTriggerPidlDownload(_this.dataDescription);
        _this.resolutionPolicy = resolutionPolicy || resolutionPolicyValues.always;
        _this.displayOnly = displayOnly;
        _this.displayHelpPosition = displayHelpPosition;
        _this.broadcastTo = broadcastTo;
        _this.sideEffects = sideEffects;
        _this.onValidationFailed = onValidationFailed;
        return _this;
    }
    PropertyElement.prototype.updateModelElement = function (bindingDataContext, eventHub) {
        if (this.defaultValueTemplate) {
            this.defaultValue = utils.getFormatStringExpressionValue(this.defaultValueTemplate, bindingDataContext);
            if (bindingDataContext.modelData && this.defaultValue) {
                var selectionModelDataProperty = bindingDataContext.modelData.getModelDataProperty(this.getPropertyName());
                if (selectionModelDataProperty && !selectionModelDataProperty.getValue()) {
                    selectionModelDataProperty.setValue(this.defaultValue);
                }
            }
        }
        if (this.conditionalFields && !typehelper.isNullOrUndefined(this.conditionalFields.value) && bindingDataContext && bindingDataContext.resultData && bindingDataContext.resultData.propertyUpdates) {
            var value = utils.getConditionalFieldValue(this.conditionalFields.value, bindingDataContext, this);
            bindingDataContext.resultData.propertyUpdates.push({ propertyName: this.getPropertyName(), propertyValue: value, propertyElement: this });
        }
        return this.updatePropertyElement(bindingDataContext, eventHub);
    };
    PropertyElement.prototype.updatePropertyElement = function (bindingDataContext, eventHub) { return false; };
    return PropertyElement;
}(ModelElement));
var SelectionElement = /** @class */ (function (_super) {
    __extends(SelectionElement, _super);
    function SelectionElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.firstElementIdSuffix = function () {
            return _this.getFirstElementIdSuffix(_this.possibleOptions);
        };
        var possibleOptions = displayDescription.possibleOptions, possibleValues = displayDescription.possibleValues, dataCollectionSource = displayDescription.dataCollectionSource, filterDescription = displayDescription.filterDescription, displaySelectionText = displayDescription.displaySelectionText, displayPropertyDescription = displayDescription.displayPropertyDescription, isSelectFirstItem = displayDescription.isSelectFirstItem, alwaysUpdateModelValue = displayDescription.alwaysUpdateModelValue;
        _this.possibleValues = possibleValues;
        _this.possibleOptions = possibleOptions;
        if (!_this.possibleOptions && possibleValues) {
            _this.possibleOptions = _this.getPossibleOptions(possibleValues);
        }
        _this.dataCollectionSource = dataCollectionSource;
        _this.filterDescription = filterDescription;
        _this.displaySelectionText = displaySelectionText;
        _this.description = displayPropertyDescription;
        _this.isSelectFirstItem = isSelectFirstItem;
        _this.selectedIndex = _this.displaySelectionText ? 0 : -1;
        _this.alwaysUpdateModelValue = alwaysUpdateModelValue;
        // check for the data binding template
        if (_this.dataCollectionSource) {
            var keys = Object.keys(_this.possibleOptions);
            if (keys && keys.length && typehelper.isFormatStringExpressionPlaceholder(keys[0])) {
                _this.possibleOptionsTemplate = _this.possibleOptions[keys[0]];
                _this.possibleOptionsTemplate.key = keys[0];
                _this.possibleOptions = {};
            }
        }
        /* selectedIndex here can have only two value i.e -1 or 0, before we do below operation.
        if selectedIndex is 0 (displaySelectionText is present) then by doing selectedIndex++ we make it equal to 1
        if selectedIndex is -1 (displaySelectionText not present) then by doing selectedIndex++ we make it equal to 0 */
        if (_this.isSelectFirstItem) {
            _this.selectedIndex++;
        }
        return _this;
    }
    SelectionElement.prototype.updatePropertyElement = function (bindingDataContext, eventHub) {
        if (this.dataCollectionSource && this.possibleOptionsTemplate) {
            var bindingData = [];
            if (typehelper.isArray(this.dataCollectionSource)) {
                for (var _i = 0, _a = this.dataCollectionSource; _i < _a.length; _i++) {
                    var dataSource = _a[_i];
                    var dataSourceResult = utils.getPropertyExpressionValue(dataSource, bindingDataContext);
                    bindingData.push.apply(bindingData, dataSourceResult);
                }
            }
            else {
                bindingData = utils.getPropertyExpressionValue(this.dataCollectionSource, bindingDataContext);
            }
            if (this.filterDescription) {
                bindingData = utils.getFunctionExecutionResult(this.filterDescription, { modelData: bindingDataContext.modelData, contextData: bindingData }, eventHub);
            }
            var updatedPossibleOptions = {};
            var defaultValue = this.defaultValue;
            if (bindingData && bindingData.length && typehelper.isArray(bindingData)) {
                for (var i = 0; i < bindingData.length; i++) {
                    var possibleOptionBindingDataContext = { modelData: bindingDataContext.modelData, contextData: bindingData[i] };
                    var key = utils.getFormatStringExpressionValue(this.possibleOptionsTemplate.key, possibleOptionBindingDataContext);
                    if (this.isSelectFirstItem && typehelper.isNullOrUndefinedOrWhiteSpaceString(defaultValue)) {
                        defaultValue = key;
                        if (bindingDataContext.modelData) {
                            var selectionModelDataProperty = bindingDataContext.modelData.getModelDataProperty(this.getPropertyName());
                            if (selectionModelDataProperty) {
                                selectionModelDataProperty.setValue(key);
                            }
                        }
                    }
                    var possibleOption = {};
                    for (var propName in this.possibleOptionsTemplate) {
                        var value = utils.getFormatStringExpressionValue(this.possibleOptionsTemplate[propName], possibleOptionBindingDataContext);
                        possibleOption[propName] = typehelper.isObject(value) ? typehelper.deepCopy(value) : value;
                    }
                    if (possibleOption.displayContent) {
                        var result = modelElementFactory$1.createModelElementsFromDisplayDescriptions([possibleOption.displayContent], this.operationType, possibleOptionBindingDataContext, String(i));
                        if (result.elements && result.elements.length >= 1) {
                            modelElementsHelper$1.updateModelElements(result.elements, possibleOptionBindingDataContext);
                            possibleOption.displayContentContainer = result.elements[0];
                        }
                    }
                    // set possibleOption's pidlAction context to the bindingData object
                    possibleOption.pidlAction = possibleOption.pidlAction || {};
                    possibleOption.pidlAction.context = bindingData[i];
                    updatedPossibleOptions[key] = possibleOption;
                }
            }
            else if (eventHub) {
                eventHub.notifyNoSelectionOptionsFound(this.id, this.displayId, this.pidlIdentity, this.type);
            }
            this.possibleOptions = updatedPossibleOptions;
            this.hasNoDataToShow = (typehelper.keyCount(this.possibleOptions) === 0);
        }
        if (!this.hasNoDataToShow) {
            var selectOptions = utils.getFunctionExecutionResult({
                functionName: "filterOptions"
            }, {
                modelData: bindingDataContext.modelData,
                contextData: {
                    propertyName: this.getPropertyName(),
                    possible_values: this.dataDescription.possible_values,
                    possibleValues: this.possibleValues,
                    possibleOptions: this.possibleOptions
                }
            });
            if (selectOptions) {
                var possible_values = selectOptions.possible_values, possibleValues = selectOptions.possibleValues, possibleOptions = selectOptions.possibleOptions;
                if (possible_values) {
                    this.dataDescription.possible_values = possible_values;
                }
                if (possibleValues) {
                    this.possibleValues = possibleValues;
                }
                if (possibleOptions) {
                    this.possibleOptions = possibleOptions;
                }
            }
        }
        if (this.displayDescription.disableSingleItemDropdown && this.type === modelElementType.dropdown && this.possibleOptions && typehelper.keyCount(this.possibleOptions) === 1) {
            this.isDisabled = true;
            this.defaultValue = this.defaultValue || typehelper.getFirstKey(this.possibleOptions);
        }
        else {
            this.isDisabled = this.displayDescription.isDisabled;
        }
        // TODO: change to true once it's confirmed that doesn't break anything, currently false to follow current behavior
        return false;
    };
    SelectionElement.prototype.getFirstElementIdSuffix = function (possibleOptions) {
        for (var key in possibleOptions) {
            return "_" + key;
        }
    };
    SelectionElement.prototype.getPossibleOptions = function (possibleValues) {
        var possibleOptions = {};
        for (var key in possibleValues) {
            possibleOptions[key] = {
                displayText: possibleValues[key],
                isDisabled: undefined
            };
        }
        return possibleOptions;
    };
    return SelectionElement;
}(PropertyElement));
var DropdownElement = /** @class */ (function (_super) {
    __extends(DropdownElement, _super);
    function DropdownElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.dropdown, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        if (_this.defaultValue) {
            _this.defaultValue = modelElementsHelper$1.normalizeValueToPossibleValues(_this, _this.defaultValue);
        }
        return _this;
    }
    return DropdownElement;
}(SelectionElement));
var RadioElement = /** @class */ (function (_super) {
    __extends(RadioElement, _super);
    function RadioElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.radio, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        if (!_this.defaultValue) {
            _this.defaultValue = typehelper.getFirstKey(_this.possibleValues);
        }
        return _this;
    }
    return RadioElement;
}(SelectionElement));
var ButtonListElement = /** @class */ (function (_super) {
    __extends(ButtonListElement, _super);
    function ButtonListElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.buttonList, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.findFirstValidPidlAction = function (possibleOption) {
            var _a;
            var queue = typehelper.copyArray((_a = possibleOption === null || possibleOption === void 0 ? void 0 : possibleOption.displayContentContainer) === null || _a === void 0 ? void 0 : _a.children);
            var visited = {};
            while (queue.length) {
                var child = queue.shift();
                if (!visited[child.id]) {
                    visited[child.id] = true;
                    if (child.pidlAction && child.canBeRendered()) {
                        possibleOption.pidlAction = child.pidlAction;
                        break;
                    }
                    else if (isContainerElement(child)) {
                        var children = child === null || child === void 0 ? void 0 : child.children;
                        for (var i = 0; i < (children === null || children === void 0 ? void 0 : children.length); i++) {
                            queue.push(children[i]);
                        }
                    }
                }
            }
        };
        return _this;
    }
    ButtonListElement.prototype.updateModelElement = function (bindingDataContext) {
        _super.prototype.updateModelElement.call(this, bindingDataContext);
        for (var key in this.possibleOptions) {
            this.findFirstValidPidlAction(this.possibleOptions[key]);
        }
    };
    return ButtonListElement;
}(SelectionElement));
var TextBoxElement = /** @class */ (function (_super) {
    __extends(TextBoxElement, _super);
    function TextBoxElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, pidlDocManager) {
        var _this = _super.call(this, modelElementType.textBox, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.getResolvedLogo = function () {
            return ((_this.pidlDocManager && _this.pidlDocManager.getResolvedLogo()) || { sourceUrl: null }).sourceUrl;
        };
        _this.placeHolderText = function () {
            var _a = _this.displayDescription, displayPropertyDescription = _a.displayPropertyDescription, displayExample = _a.displayExample;
            if (displayPropertyDescription) {
                if (!_this.showDisplayName || displayPropertyDescription !== _this.displayDescription.displayName) {
                    return displayPropertyDescription;
                }
            }
            else if (displayExample && displayExample.length > 0) {
                return displayExample[0];
            }
            return null;
        };
        _this.getTextBoxType = function () {
            var _a = _this.displayDescription, inputScope = _a.inputScope, maskInput = _a.maskInput;
            if (inputScope) {
                return inputScope;
            }
            else {
                return (maskInput === true || _this.dataDescription.type === "password") ? "password" : "text";
            }
        };
        var maxLength = displayDescription.maxLength, direction = displayDescription.direction, textAlignment = displayDescription.textAlignment, displayTransformations = displayDescription.displayTransformations;
        _this.displayTransformations = displayTransformations;
        _this.maxLength = maxLength;
        _this.direction = direction;
        _this.textAlignment = textAlignment;
        _this.pidlDocManager = pidlDocManager;
        return _this;
    }
    return TextBoxElement;
}(PropertyElement));
var CheckBoxElement = /** @class */ (function (_super) {
    __extends(CheckBoxElement, _super);
    function CheckBoxElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.checkBox, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.description = displayDescription.displayPropertyDescription;
        return _this;
    }
    return CheckBoxElement;
}(PropertyElement));
var FilePickerElement = /** @class */ (function (_super) {
    __extends(FilePickerElement, _super);
    function FilePickerElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.filePicker, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.displayContent = displayDescription.displayContent;
        return _this;
    }
    return FilePickerElement;
}(PropertyElement));
var GenericTextElement = /** @class */ (function (_super) {
    __extends(GenericTextElement, _super);
    function GenericTextElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.displayContentTemplate = displayDescription.displayContent;
        _this.displayContent = utils.getFormatStringExpressionValue(_this.displayContentTemplate, bindingDataContext);
        if (idSuffix) {
            _this.id += idSuffix;
            _this.displayId = _this.id;
        }
        return _this;
    }
    GenericTextElement.prototype.updateModelElement = function (bindingDataContext) {
        this.displayContent = utils.getFormatStringExpressionValue(this.displayContentTemplate, bindingDataContext);
        if (this.pidlAction && this.pidlAction.context && this.pidlAction.context.resourceActionContext && this.pidlAction.context.resourceActionContext.resourceInfo && this.pidlAction.context.resourceActionContext.resourceInfo.id) {
            this.pidlAction.context.resourceActionContext.resourceInfo.id = utils.getFormatStringExpressionValue(this.pidlAction.context.resourceActionContext.resourceInfo.id, bindingDataContext);
        }
        if (this.pidlAction && this.pidlAction.context && this.pidlAction.context.resourceActionContext && this.pidlAction.context.resourceActionContext.resourceObjPath) {
            this.pidlAction.context.resourceActionContext.resource = utils.getPropertyExpressionValue(this.pidlAction.context.resourceActionContext.resourceObjPath, bindingDataContext);
        }
        if (this.type === modelElementType.hyperlink && this.pidlAction && typehelper.isString(this.pidlAction.context)) {
            this.pidlAction.context = utils.getFormatStringExpressionValue(this.pidlAction.context, bindingDataContext);
        }
        return false;
    };
    return GenericTextElement;
}(ModelElement));
var TextElement = /** @class */ (function (_super) {
    __extends(TextElement, _super);
    function TextElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) {
        return _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) || this;
    }
    return TextElement;
}(GenericTextElement));
var ButtonElement = /** @class */ (function (_super) {
    __extends(ButtonElement, _super);
    function ButtonElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) {
        var _this = _super.call(this, modelElementType.button, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) || this;
        _this.tooltipText = displayDescription.tooltipText;
        return _this;
    }
    return ButtonElement;
}(GenericTextElement));
var AudioElement = /** @class */ (function (_super) {
    __extends(AudioElement, _super);
    function AudioElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) {
        var _this = _super.call(this, modelElementType.audio, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) || this;
        _this.audioUrl = utils.convertBase64strIntoBlobUrl(displayDescription.audioUrl, "audio/mp3");
        return _this;
    }
    return AudioElement;
}(GenericTextElement));
var ExpressionElement = /** @class */ (function (_super) {
    __extends(ExpressionElement, _super);
    function ExpressionElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) {
        var _this = _super.call(this, modelElementType.expression, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) || this;
        _this.expression = displayDescription.displayContent;
        return _this;
    }
    ExpressionElement.prototype.updateModelElement = function (bindingDataContext) {
        var _a;
        this.displayContent = utils.getExpressionValue(this.expression, bindingDataContext);
        if ((_a = this.tags) === null || _a === void 0 ? void 0 : _a.accessibilityNameExpression) {
            this.accessibilityName = utils.getExpressionValue(this.tags.accessibilityNameExpression, bindingDataContext);
        }
        return false;
    };
    return ExpressionElement;
}(GenericTextElement));
var ImageElement = /** @class */ (function (_super) {
    __extends(ImageElement, _super);
    function ImageElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, bindingDataContext, idSuffix) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.sourceUrlTemplate = displayDescription.sourceUrl;
        _this.sourceUrl = utils.getFormatStringExpressionValue(_this.sourceUrlTemplate, bindingDataContext);
        if (displayDescription.codepoint) {
            _this.codepoint = Number(displayDescription.codepoint);
        }
        _this.accessibilityName = utils.getFormatStringExpressionValue(_this.accessibilityName, bindingDataContext);
        if (idSuffix) {
            _this.id += idSuffix;
            _this.displayId = _this.id;
        }
        return _this;
    }
    return ImageElement;
}(ModelElement));
var SeparatorElement = /** @class */ (function (_super) {
    __extends(SeparatorElement, _super);
    function SeparatorElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        if (idSuffix) {
            _this.id += idSuffix;
            _this.displayId = _this.id;
        }
        return _this;
    }
    return SeparatorElement;
}(ModelElement));
var SpinnerElement = /** @class */ (function (_super) {
    __extends(SpinnerElement, _super);
    function SpinnerElement(typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, idSuffix) {
        var _this = _super.call(this, typeIn, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        if (idSuffix) {
            _this.id += idSuffix;
            _this.displayId = _this.id;
        }
        return _this;
    }
    return SpinnerElement;
}(ModelElement));
var LogoElement = /** @class */ (function (_super) {
    __extends(LogoElement, _super);
    function LogoElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, pidlDocManager, idSuffix) {
        var _this = _super.call(this, modelElementType.logo, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.getResolvedLogo = function () { return ((_this.pidlDocManager && _this.pidlDocManager.getResolvedLogo()) || { sourceUrl: null }).sourceUrl; };
        _this.getAllLogos = function () { return _this.pidlDocManager.getAllLogos(); };
        _this.sourceUrl = displayDescription.sourceUrl;
        _this.pidlDocManager = pidlDocManager;
        if (idSuffix) {
            _this.id += idSuffix;
            _this.displayId = _this.id;
        }
        return _this;
    }
    return LogoElement;
}(ModelElement));
var PidlContainer = /** @class */ (function (_super) {
    __extends(PidlContainer, _super);
    function PidlContainer(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.pidlContainer, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.linkedPidlId = displayDescription.linkedPidlId;
        return _this;
    }
    return PidlContainer;
}(ModelElement));
var SecurePropertyInitializations = /** @class */ (function () {
    function SecurePropertyInitializations() {
        this.isOptional = false;
        this.resolutionPolicy = resolutionPolicyValues.always;
    }
    return SecurePropertyInitializations;
}());
var SecurePropertyElement = /** @class */ (function (_super) {
    __extends(SecurePropertyElement, _super);
    function SecurePropertyElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl, pidlDocManager) {
        var _this = _super.call(this, modelElementType.secureProperty, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        _this.placeHolderText = function () {
            var _a = _this.displayDescription, displayPropertyDescription = _a.displayPropertyDescription, displayExample = _a.displayExample;
            if (displayPropertyDescription) {
                if (!_this.showDisplayName || displayPropertyDescription !== _this.displayDescription.displayName) {
                    return displayPropertyDescription;
                }
            }
            else if (displayExample && displayExample.length > 0) {
                return displayExample[0];
            }
            return null;
        };
        _this.getResolvedLogo = function () {
            return ((_this.pidlDocManager && _this.pidlDocManager.getResolvedLogo()) || { sourceUrl: null }).sourceUrl;
        };
        var sourceUrl = displayDescription.sourceUrl, width = displayDescription.width, height = displayDescription.height, messageTimeout = displayDescription.messageTimeout, frameName = displayDescription.frameName, displayName = displayDescription.displayName, propertyName = displayDescription.propertyName, displayLogo = displayDescription.displayLogo;
        _this.sourceUrl = urlBuilder$1.createFromTemplate(sourceUrl);
        _this.width = width;
        _this.height = height;
        _this.messageTimeout = messageTimeout;
        _this.frameName = frameName;
        _this.displayName = displayName;
        _this.propertyName = propertyName;
        _this.displayLogo = displayLogo;
        _this.pidlDocManager = pidlDocManager;
        return _this;
    }
    SecurePropertyElement.prototype.validate = function () {
        return this.validationPromise();
    };
    SecurePropertyElement.prototype.prepareForSubmit = function (tokenSet) {
        return this.submitPromise(tokenSet);
    };
    return SecurePropertyElement;
}(PropertyElement));
var IFrameElement = /** @class */ (function (_super) {
    __extends(IFrameElement, _super);
    function IFrameElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.iFrame, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        var sourceUrl = displayDescription.sourceUrl, displayContent = displayDescription.displayContent, width = displayDescription.width, height = displayDescription.height, expectedClientActionId = displayDescription.expectedClientActionId, messageTimeout = displayDescription.messageTimeout, messageTimeoutClientAction = displayDescription.messageTimeoutClientAction, useAuth = displayDescription.useAuth, loadingMessage = displayDescription.loadingMessage;
        _this.sourceUrl = sourceUrl;
        _this.displayContent = displayContent;
        _this.width = width;
        _this.height = height;
        _this.expectedClientActionId = expectedClientActionId;
        _this.messageTimeout = messageTimeout;
        _this.messageTimeoutClientAction = messageTimeoutClientAction;
        _this.useAuth = useAuth;
        _this.loadingMessage = loadingMessage;
        return _this;
    }
    return IFrameElement;
}(GenericTextElement));
var ChallengeIFrameElement = /** @class */ (function (_super) {
    __extends(ChallengeIFrameElement, _super);
    function ChallengeIFrameElement(dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) {
        var _this = _super.call(this, modelElementType.challengeIFrame, dataDescription, displayDescription, operationTypeIn, pidlIdentityHash, isLinkedPidl) || this;
        var sourceUrl = displayDescription.sourceUrl, displayContent = displayDescription.displayContent, width = displayDescription.width, height = displayDescription.height, expectedClientActionId = displayDescription.expectedClientActionId, messageTimeout = displayDescription.messageTimeout, messageTimeoutClientAction = displayDescription.messageTimeoutClientAction, useAuth = displayDescription.useAuth, loadingMessage = displayDescription.loadingMessage;
        _this.sourceUrl = sourceUrl;
        _this.displayContent = displayContent;
        _this.width = width;
        _this.height = height;
        _this.expectedClientActionId = expectedClientActionId;
        _this.messageTimeout = messageTimeout;
        _this.messageTimeoutClientAction = messageTimeoutClientAction;
        _this.useAuth = useAuth;
        _this.loadingMessage = loadingMessage;
        return _this;
    }
    return ChallengeIFrameElement;
}(GenericTextElement));
function isModelElement(obj) {
    return !typehelper.isNullOrUndefined(obj) && "type" in obj;
}
function isContainerElement(obj) {
    return isModelElement(obj) &&
        (obj.type === modelElementType.page ||
            obj.type === modelElementType.group ||
            obj.type === modelElementType.textGroup ||
            obj.type === modelElementType.dataCollectionBindingGroup ||
            obj.type === modelElementType.captcha);
}
function isCaptchaElement(obj) {
    return isModelElement(obj) && obj.type === modelElementType.captcha;
}
function isPageElement(obj) {
    return isModelElement(obj) && obj.type === modelElementType.page;
}
function isSelectionElement(obj) {
    return isModelElement(obj) &&
        (obj.type === modelElementType.dropdown ||
            obj.type === modelElementType.radio ||
            obj.type === modelElementType.buttonList);
}
function isDropdownElement(obj) {
    return isModelElement(obj) && obj.type === modelElementType.dropdown;
}
function isPrefillDropdownElement(obj) {
    return isDropdownElement(obj) && obj.displayType === pidlDisplayTypesValues.prefillControl;
}
function isPidlContainerElement(obj) {
    return isModelElement(obj) && obj.type === modelElementType.pidlContainer;
}
function isImageElement(object) {
    return isModelElement(object) && object.type === modelElementType.image;
}
function isLogoElement(object) {
    return isModelElement(object) && object.type === modelElementType.logo;
}
function isButtonElement(object) {
    return isModelElement(object) && object.type === modelElementType.button;
}
function isFilePickerElement(object) {
    return isModelElement(object) && object.type === modelElementType.filePicker;
}
function isCheckBoxElement(object) {
    return isModelElement(object) && object.type === modelElementType.checkBox;
}
function isPrefilledCheckBoxElement(object) {
    return isCheckBoxElement(object) && object.displayType === pidlDisplayTypesValues.prefillControl;
}
function isPageOrGroupOrDataCollectionBindingGroup(object) {
    return isModelElement(object) &&
        (object.type === modelElementType.page ||
            object.type === modelElementType.group ||
            object.type === modelElementType.dataCollectionBindingGroup);
}
function isGroupElement(object) {
    return isModelElement(object) && object.type === modelElementType.group;
}
function isTextGroupElement(object) {
    return isModelElement(object) && object.type === modelElementType.textGroup;
}
function isTextBoxElement(object) {
    return isModelElement(object) && object.type === modelElementType.textBox;
}
function isButtonListElement(object) {
    return isModelElement(object) && object.type === modelElementType.buttonList;
}
function isRadioElement(object) {
    return isModelElement(object) && object.type === modelElementType.radio;
}
function isTextElement(object) {
    var textTypes = [modelElementType.heading, modelElementType.subheading, modelElementType.text, modelElementType.hyperlink];
    return isModelElement(object) && typehelper.contains(textTypes, object.type);
}
function isDataCollectionBindingGroup(object) {
    return isModelElement(object) && object.type === modelElementType.dataCollectionBindingGroup;
}
function isExpressionElement(object) {
    return isModelElement(object) && object.type === modelElementType.expression;
}
function isIFrameElement(object) {
    return isModelElement(object) && object.type === modelElementType.iFrame;
}
function isChallengeIFrameElement(object) {
    return isModelElement(object) && object.type === modelElementType.challengeIFrame;
}
function isSecurePropertyElement(object) {
    return isModelElement(object) && object.type === modelElementType.secureProperty;
}
function isSeparatorElement(object) {
    return isModelElement(object) && object.type === modelElementType.separator;
}
function isAudioElement(object) {
    return isModelElement(object) && object.type === modelElementType.audio;
}
function isPropertyElement(object) {
    return isModelElement(object) && object.isProperty();
}

var modelelements = /*#__PURE__*/Object.freeze({
	__proto__: null,
	ModelElement: ModelElement,
	ContainerElement: ContainerElement,
	GenericGroupElement: GenericGroupElement,
	GroupElement: GroupElement,
	DataCollectionBindingGroupElement: DataCollectionBindingGroupElement,
	CaptchaContainerElement: CaptchaContainerElement,
	GenericCaptchaElement: GenericCaptchaElement,
	CaptchaElement: CaptchaElement,
	PageElement: PageElement,
	TextGroupElement: TextGroupElement,
	PropertyElement: PropertyElement,
	SelectionElement: SelectionElement,
	DropdownElement: DropdownElement,
	RadioElement: RadioElement,
	ButtonListElement: ButtonListElement,
	TextBoxElement: TextBoxElement,
	CheckBoxElement: CheckBoxElement,
	FilePickerElement: FilePickerElement,
	GenericTextElement: GenericTextElement,
	TextElement: TextElement,
	ButtonElement: ButtonElement,
	AudioElement: AudioElement,
	ExpressionElement: ExpressionElement,
	ImageElement: ImageElement,
	SeparatorElement: SeparatorElement,
	SpinnerElement: SpinnerElement,
	LogoElement: LogoElement,
	PidlContainer: PidlContainer,
	SecurePropertyInitializations: SecurePropertyInitializations,
	SecurePropertyElement: SecurePropertyElement,
	IFrameElement: IFrameElement,
	ChallengeIFrameElement: ChallengeIFrameElement,
	isModelElement: isModelElement,
	isContainerElement: isContainerElement,
	isCaptchaElement: isCaptchaElement,
	isPageElement: isPageElement,
	isSelectionElement: isSelectionElement,
	isDropdownElement: isDropdownElement,
	isPrefillDropdownElement: isPrefillDropdownElement,
	isPidlContainerElement: isPidlContainerElement,
	isImageElement: isImageElement,
	isLogoElement: isLogoElement,
	isButtonElement: isButtonElement,
	isFilePickerElement: isFilePickerElement,
	isCheckBoxElement: isCheckBoxElement,
	isPrefilledCheckBoxElement: isPrefilledCheckBoxElement,
	isPageOrGroupOrDataCollectionBindingGroup: isPageOrGroupOrDataCollectionBindingGroup,
	isGroupElement: isGroupElement,
	isTextGroupElement: isTextGroupElement,
	isTextBoxElement: isTextBoxElement,
	isButtonListElement: isButtonListElement,
	isRadioElement: isRadioElement,
	isTextElement: isTextElement,
	isDataCollectionBindingGroup: isDataCollectionBindingGroup,
	isExpressionElement: isExpressionElement,
	isIFrameElement: isIFrameElement,
	isChallengeIFrameElement: isChallengeIFrameElement,
	isSecurePropertyElement: isSecurePropertyElement,
	isSeparatorElement: isSeparatorElement,
	isAudioElement: isAudioElement,
	isPropertyElement: isPropertyElement
});

"use strict";
var Utils = /** @class */ (function () {
    function Utils() {
        var _this = this;
        this.extend = extend;
        this.getSelectElementType = function (pidlSelectType) {
            switch (pidlSelectType) {
                case pidlSelectTypeValues.radio:
                    return modelElementType.radio;
                case pidlSelectTypeValues.buttonList:
                    return modelElementType.buttonList;
                default:
                    return modelElementType.dropdown;
            }
        };
        this.getErrorDetailsFromPidl = function (errorCode, serverErrorCodes) {
            if (errorCode && serverErrorCodes) {
                var errorMap = serverErrorCodes[errorCode];
                if (errorMap && errorMap.Target) {
                    return _this.extend(true, errorMap, { code: errorCode, target: errorMap.Target, message: errorMap.ErrorMessage });
                }
            }
        };
        this.processServerError = function (serverErrorInstance, errorCodeExpressions, serverErrorCodes) {
            var targettedInnerErrors = [];
            if (serverErrorInstance && errorCodeExpressions && errorCodeExpressions.length) {
                for (var i = 0; i < errorCodeExpressions.length; i++) {
                    var errorCode = _this.getFormatStringExpressionValue(errorCodeExpressions[i], { contextData: serverErrorInstance });
                    var innerErrorFromPidl = _this.getErrorDetailsFromPidl(errorCode, serverErrorCodes);
                    if (innerErrorFromPidl) {
                        // If we find the matched error in the serverErrorCodes, we don't look further for more matches.
                        targettedInnerErrors.push(innerErrorFromPidl);
                        break;
                    }
                }
            }
            return targettedInnerErrors;
        };
        this.processPimsPxError = function (innerError, serverErrorCodes) {
            /*
                PIFD/PIMS error looks as follows:
                {
                    "code": "InternalServerError",
                    "message": ""
                    "innererror": {
                        "clientAction": {},
                        "code": "PX/PIMSCode",
                        "details": [{
                            "code": "InternalServerError",
                            "message": "<Message to be shown below first field> | []",
                            "target": "Property1, Property2, Property3"
                        }],
                        "message":"This is an error| []",
                    }
                }
            */
            var targettedInnerErrors = [];
            if (innerError) {
                if (innerError.details && innerError.details.length) {
                    for (var i = 0; i < innerError.details.length; i++) {
                        var innerErrorDetailsInstance = innerError.details[i];
                        if (innerErrorDetailsInstance) {
                            targettedInnerErrors.push(innerErrorDetailsInstance);
                        }
                    }
                }
                else {
                    var innerErrorFromPidl = _this.getErrorDetailsFromPidl(innerError.code, serverErrorCodes);
                    if (innerErrorFromPidl) {
                        targettedInnerErrors.push(innerErrorFromPidl);
                    }
                }
            }
            return targettedInnerErrors;
        };
        this.updatePidlDocUrlParamHelper = function (pidlDocInfo, urlParamName, urlParamValue) {
            if (pidlDocInfo && pidlDocInfo.parameters) {
                if (pidlDocInfo.parameters[urlParamName]) {
                    if (typehelper.equalsIgnoreCase(pidlDocInfo.parameters[urlParamName], urlParamValue)) {
                        return false;
                    }
                    pidlDocInfo.parameters[urlParamName] = urlParamValue;
                    return true;
                }
                var mappedUrlParamName = pidlPropertyNameToPidlDocInfoProperty[urlParamName];
                if (mappedUrlParamName && pidlDocInfo.parameters[mappedUrlParamName]) {
                    if (typehelper.equalsIgnoreCase(pidlDocInfo.parameters[mappedUrlParamName], urlParamValue)) {
                        return false;
                    }
                    pidlDocInfo.parameters[mappedUrlParamName] = urlParamValue;
                    return true;
                }
                pidlDocInfo.parameters[urlParamName] = urlParamValue;
                return true;
            }
            return false;
        };
        this.s4 = function () {
            return Math.floor((Math.random() + 1) * 0x10000)
                .toString(16)
                .substring(1);
        };
        this.getAt = function (dict, name) {
            return dict ? dict[name] : null;
        };
        this.guid = function () {
            return _this.s4() + _this.s4() + "-" + _this.s4() + "-" + _this.s4() + "-" + _this.s4() + "-" + _this.s4() + _this.s4() + _this.s4();
        };
        this.parseJSON = function (jsonObject) {
            var result = { succeeded: true, value: null };
            try {
                result.value = JSON.parse(jsonObject);
            }
            catch (err) {
                result.value = err.message;
                result.succeeded = false;
            }
            return result;
        };
        this.getHostName = function (url) {
            if (url) {
                return ((url.indexOf("//") > -1) ? url.split("/")[2] : url.split("/")[0]).toLowerCase();
            }
        };
        this.getBoolValue = function (value) {
            var boolValue = false;
            // If input value is not a boolean or string with (true/false) it is caught by input valdiation.
            // so no need for other error checks
            if (typehelper.isString(value)) {
                var lowerValue = value.toLowerCase();
                // For string values other than true/false, input validation catches as an error.
                // so no need to check those error cases.
                boolValue = (lowerValue === "true");
            }
            else {
                boolValue = value;
            }
            return boolValue;
        };
        this.getStringValue = function (instance) {
            var stringValue = "";
            for (var idx = 0; idx < instance.length; ++idx) {
                stringValue += instance[idx];
                stringValue += " ";
            }
            return stringValue.trim();
        };
        this.getModelElementType = function (dataDescription, displayDescription) {
            var ret = {};
            switch (displayDescription.displayType) {
                case pidlDisplayTypesValues.page:
                    ret.type = modelElementType.page;
                    break;
                case pidlDisplayTypesValues.group:
                    ret.type = modelElementType.group;
                    break;
                case pidlDisplayTypesValues.captcha:
                    ret.type = modelElementType.captcha;
                    break;
                case pidlDisplayTypesValues.audio:
                    ret.type = modelElementType.audio;
                    break;
                case pidlDisplayTypesValues.textGroup:
                    ret.type = modelElementType.textGroup;
                    break;
                case pidlDisplayTypesValues.heading:
                    ret.type = modelElementType.heading;
                    break;
                case pidlDisplayTypesValues.subheading:
                    ret.type = modelElementType.subheading;
                    break;
                case pidlDisplayTypesValues.text:
                    ret.type = modelElementType.text;
                    break;
                case pidlDisplayTypesValues.hyperlink:
                    ret.type = modelElementType.hyperlink;
                    break;
                case pidlDisplayTypesValues.image:
                    ret.type = modelElementType.image;
                    break;
                case pidlDisplayTypesValues.logo:
                    ret.type = modelElementType.logo;
                    break;
                case pidlDisplayTypesValues.prefillControl:
                    if (displayDescription.selectType === pidlSelectTypeValues.checkBox) {
                        ret.type = modelElementType.checkBox;
                    }
                    else if (displayDescription.selectType === pidlSelectTypeValues.dropDown) {
                        ret.type = modelElementType.dropdown;
                    }
                    else {
                        ret.type = modelElementType.unknown;
                    }
                    break;
                case pidlDisplayTypesValues.property:
                    if (!dataDescription) {
                        ret.error = new pidlErrors.unexpectedError(errorMessages.displayElementPointingToMissingDataProperty, [displayDescription.displayId, displayDescription.propertyName]);
                    }
                    else if (isPropertyDisplayDescription(displayDescription) && displayDescription.possibleOptions) {
                        ret.type = _this.getSelectElementType(displayDescription.selectType);
                    }
                    else if (dataDescription.type === "bool") {
                        ret.type = modelElementType.checkBox;
                    }
                    else if (isFilePickerDisplayDescription(displayDescription)) {
                        ret.type = modelElementType.filePicker;
                    }
                    else {
                        ret.type = modelElementType.textBox;
                    }
                    break;
                case pidlDisplayTypesValues.button:
                    ret.type = modelElementType.button;
                    break;
                case pidlDisplayTypesValues.expression:
                    ret.type = modelElementType.expression;
                    break;
                case pidlDisplayTypesValues.pidlContainer:
                    ret.type = modelElementType.pidlContainer;
                    break;
                case pidlDisplayTypesValues.dataCollectionBindingGroup:
                    ret.type = modelElementType.dataCollectionBindingGroup;
                    break;
                case pidlDisplayTypesValues.iFrame:
                    ret.type = modelElementType.iFrame;
                    break;
                case pidlDisplayTypesValues.challengeIframe:
                    ret.type = modelElementType.challengeIFrame;
                    break;
                case pidlDisplayTypesValues.secureProperty:
                    ret.type = modelElementType.secureProperty;
                    break;
                case pidlDisplayTypesValues.separator:
                    ret.type = modelElementType.separator;
                    break;
                case pidlDisplayTypesValues.spinner:
                    ret.type = modelElementType.spinner;
                    break;
                default:
                    ret.type = modelElementType.unknown;
                    break;
            }
            return ret;
        };
        this.getPidlOperationType = function (resourceAction) {
            switch (resourceAction) {
                case resourceActions.addAddress:
                case resourceActions.addPaymentInstrument:
                case resourceActions.addResource:
                case resourceActions.handleChallenge:
                    return pidlOperationTypeValues.add;
                case resourceActions.collectResourceInfo:
                    return pidlOperationTypeValues.renderPidlPage;
                case resourceActions.selectPaymentInstrument:
                case resourceActions.selectResource:
                    return pidlOperationTypeValues.selectInstance;
                case resourceActions.selectResourceType:
                    return pidlOperationTypeValues.select;
                case resourceActions.selectSingleResource:
                    return pidlOperationTypeValues.selectSingleInstance;
                case resourceActions.updateProfile:
                case resourceActions.updateResource:
                    return pidlOperationTypeValues.update;
            }
        };
        this.createObjectWithNonNullProperties = function (properties) {
            var object = null;
            for (var key in properties) {
                if (!typehelper.isNullOrUndefined(properties[key])) {
                    if (!object) {
                        object = {};
                    }
                    object[key] = properties[key];
                }
            }
            return object;
        };
        this.updatePidlDocUrlParams = function (pidlDocInfo, keyPropertyMap) {
            var updated = false;
            for (var keyPropertyName in keyPropertyMap) {
                var urlParam = pidlDocHelper$1.getKeyPropertyPidlDownloadUrlParam(keyPropertyMap[keyPropertyName].propertyDescriptor, keyPropertyName);
                var urlValue = keyPropertyMap[keyPropertyName].getValue(keyPropertyMap[keyPropertyName].propertyDescriptor);
                if (urlParam) {
                    var result = _this.updatePidlDocUrlParamHelper(pidlDocInfo, urlParam, urlValue);
                    updated = updated || result;
                }
            }
            return updated;
        };
        this.getRetryableTargettedErrors = function (targettedInnerErrors, serverErrorRetries) {
            /*
            PIDL document errors contains server error retry policy.
            Here is retryPolicy structure:
            {
                retryPolicy: {
                    type: "limitedRetry",   // Options are unlimitedRetry(default), limitedRetry, noRetry
                    context: {              // Context is specific to type of the retry.
                        maxRetryCount: 3    // For limitedRetry, maxRetryCount dictates number of retries possible
                    }
                }
            }
            */
            if (targettedInnerErrors && targettedInnerErrors.length) {
                for (var i = 0; i < targettedInnerErrors.length; i++) {
                    var targettedError = targettedInnerErrors[i];
                    var canRetry = true;
                    if (!targettedError.target) {
                        canRetry = false;
                    }
                    if (canRetry && serverErrorRetries && targettedError.code) {
                        if (!serverErrorRetries[targettedError.code]) {
                            serverErrorRetries[targettedError.code] = { retryCount: 0 };
                        }
                        var errorRetryPolicy = targettedError.retryPolicy;
                        if (errorRetryPolicy &&
                            errorRetryPolicy.type === serverErrorRetryPolicyValues.limitedRetry &&
                            errorRetryPolicy.context &&
                            !typehelper.isUndefined(errorRetryPolicy.context.maxRetryCount) &&
                            targettedError.retryPolicy.context.maxRetryCount <= serverErrorRetries[targettedError.code].retryCount) {
                            canRetry = false;
                        }
                    }
                    if (!canRetry) {
                        typehelper.removeFromArray(targettedInnerErrors, i, 1);
                        i--;
                    }
                    else {
                        if (serverErrorRetries && targettedError.code) {
                            serverErrorRetries[targettedError.code].retryCount++;
                        }
                    }
                }
            }
            return targettedInnerErrors;
        };
        this.createParseErrorResponse = function (requestUrl, errorCodeExpressions, serverErrorCodes, fetchFailureMessage, serverErrorRetries) {
            var targettedInnerErrors = [];
            var clientAction = undefined;
            var jsonResponse = undefined;
            var responseText = undefined;
            if (fetchFailureMessage) {
                var parsedJson = _this.parseJSON(fetchFailureMessage.failureContent);
                var serverErrorInstance = parsedJson.succeeded ? parsedJson.value : fetchFailureMessage.failureObject;
                responseText = fetchFailureMessage.failureContent;
                if (serverErrorInstance) {
                    jsonResponse = serverErrorInstance;
                    var innerError = serverErrorInstance.innererror || serverErrorInstance;
                    var errorSource = configManager$1.getErrorSourceFromUrl(requestUrl);
                    // TODO: Add case for Jarvis front door errors once PIDL supports posting to it
                    switch (errorSource) {
                        case config$1.virtualEndpoints.pifdProfile.endpoint:
                        case config$1.virtualEndpoints.pifdAddress.endpoint:
                            errorCodeExpressions = errorCodeExpressions || ["({contextData.innererror.code})", "({contextData.InnerError.ErrorCode})"];
                            break;
                        case config$1.virtualEndpoints.jarvisAddress.endpoint:
                            errorCodeExpressions = errorCodeExpressions || ["({contextData.error_code}.{contextData.parameters.property_name})", "({contextData.error_code})"];
                            break;
                        default:
                            break;
                    }
                    if (errorCodeExpressions) {
                        targettedInnerErrors = _this.processServerError(serverErrorInstance, errorCodeExpressions, serverErrorCodes);
                    }
                    else {
                        targettedInnerErrors = _this.processPimsPxError(innerError, serverErrorCodes);
                    }
                    targettedInnerErrors = _this.getRetryableTargettedErrors(targettedInnerErrors, serverErrorRetries);
                    if (innerError && innerError.clientAction) {
                        clientAction = innerError.clientAction;
                    }
                    if (!responseText) {
                        try {
                            responseText = JSON.stringify(serverErrorInstance);
                        }
                        catch (_a) { }
                    }
                }
            }
            else {
                fetchFailureMessage = fetchFailureMessage || {
                    status: pidlResultType.Error
                };
            }
            return {
                jsonResponse: jsonResponse,
                clientAction: clientAction,
                status: fetchFailureMessage.httpStatus,
                statusText: fetchFailureMessage.httpStatusText,
                responseText: responseText,
                errorMessage: fetchFailureMessage.errorMessage,
                targettedInnerErrors: targettedInnerErrors
            };
        };
        this.convertCustomErrorsInSdkErrors = function (errors, serverErrorCodes) {
            /*
                Custom error looks as follows:
                {
                    "code": "SomethingWentWrong",
                    "message": "This is an error",
                    "target": "property1,property2",
                }
    
                Here partner can either pass "code" or "message" and "target".
                If message and target are passed, message and target are used for property error.
                If only message is passed, message is used as global error.
                If only code is passed, serverErrorCodes is queried to get message and target. In the absence of the code, it is considered a terminating error.
                If only target is passed. It is considered as a terminating error.
                If message and code are passed, message is used as global error.
                If code and target are passed, target is ignored and code is used for finding message and target.
                If message, code and target are passed, message and target are used.
            */
            var parsedErrors = [];
            for (var i = 0; i < errors.length; i++) {
                var error = errors[i];
                var parsedError = null;
                if (error.message) {
                    parsedError = { message: error.message, target: error.target, code: error.code };
                }
                else if (error.code) {
                    parsedError = _this.getErrorDetailsFromPidl(error.code, serverErrorCodes);
                }
                if (!parsedError) {
                    return null;
                }
                parsedErrors.push(parsedError);
            }
            return parsedErrors;
        };
        this.parseCustomSubmitError = function (responseText, errors, requestUrl, errorCodeExpressions, serverErrorCodes, serverErrorRetries) {
            if (!responseText && (!errors || errors.length === 0)) {
                return {
                    clientAction: { type: clientActionTypeValues.None }
                };
            }
            if (errors && errors.length !== 0) {
                return {
                    jsonResponse: responseText,
                    targettedInnerErrors: _this.convertCustomErrorsInSdkErrors(errors, serverErrorCodes)
                };
            }
            return _this.createParseErrorResponse(requestUrl, errorCodeExpressions, serverErrorCodes, { status: pidlResultType.Error, failureContent: responseText }, serverErrorRetries);
        };
        this.parseServerError = function (requestUrl, errorCodeExpressions, serverErrorCodes, fetchFailureMessage, serverErrorRetries) {
            return _this.createParseErrorResponse(requestUrl, errorCodeExpressions, serverErrorCodes, fetchFailureMessage, serverErrorRetries);
        };
        this.createServerError = function (errorMessage, requestUrl, fetchFailureMessage, failureMessageParts, serverErrorCodes) {
            var parsedServerError = _this.parseServerError(requestUrl, null, serverErrorCodes, fetchFailureMessage);
            return new pidlErrors.serverError(errorMessage, requestUrl, parsedServerError.jsonResponse, fetchFailureMessage.httpStatus, fetchFailureMessage.httpStatusText, fetchFailureMessage.failureContent, failureMessageParts);
        };
        this.createServerErrorFromIPxServiceError = function (errorMessage, pxServiceError) {
            var failureContent = JSON.stringify(pxServiceError);
            return new pidlErrors.serverError(errorMessage, null, pxServiceError, null, null, failureContent, []);
        };
        this.createPropertyErrors = function (properties, inlineParentDisplayId, firstProperty, targettedError, propertyErrors) {
            if (inlineParentDisplayId) {
                var inlineGroupError = new pidlErrors.groupValidationFailedError(errorMessages.propertyValidationFailed, targettedError.code, inlineParentDisplayId, [inlineParentDisplayId, targettedError.code]);
                inlineGroupError.message = targettedError.message;
                propertyErrors.push(inlineGroupError);
                // Setting firstProperty to null so none of the properties will have inline text
                firstProperty = null;
            }
            for (var index = 0; index < properties.length; index++) {
                var property = properties[index];
                var propertyError = new pidlErrors.propertyValidationFailedError(errorMessages.propertyValidationFailed, targettedError.code, property, [property, targettedError.code]);
                propertyError.message = (property === firstProperty) ? targettedError.message : "";
                propertyErrors.push(propertyError);
            }
        };
        this.convertErrorToString = function (error) {
            try {
                if (error instanceof Error) {
                    return error.message;
                }
                else if (typeof error === "object" && error !== null) {
                    try {
                        return JSON.stringify(error, null, 2); // Pretty-print the object
                    }
                    catch (jsonError) {
                        return "Error converting object to string";
                    }
                }
                else {
                    return String(error);
                }
            }
            catch (e) {
                return "Error converting error to string";
            }
        };
        this.createResponseHeadersDictionary = function (headerString) {
            var headers;
            if (headerString) {
                var arr = headerString.split("\r\n");
                headers = arr.reduce(function (temp, current, i) {
                    var parts = current.split(": ");
                    if (parts[0] && parts[1]) {
                        temp[typehelper.toLowerCase(parts[0])] = typehelper.toLowerCase(parts[1]);
                    }
                    return temp;
                }, {});
            }
            return headers;
        };
        this.isTagPrefixKnown = function (tag) {
            for (var prefix in knownTagPrefixes) {
                if (typehelper.startsWith(tag, knownTagPrefixes[prefix])) {
                    return true;
                }
            }
            return false;
        };
        this.registerToOrchestrator = function (pidlHook) {
            var pidlOrchestrator;
            try {
                pidlOrchestrator = window.pidlOrchestrator;
            }
            catch (err) { }
            if (pidlOrchestrator && pidlOrchestrator.registerPidlHook) {
                pidlOrchestrator.registerPidlHook(pidlHook);
            }
        };
        this.broadcastPropertyValueUpdate = function (senderId, propertyElement, propertyValue, controlOperationType, maskedValuesDisplayed) {
            var pidlOrchestrator;
            try {
                pidlOrchestrator = window.pidlOrchestrator;
            }
            catch (err) { }
            if (pidlOrchestrator && pidlOrchestrator.broadcastPropertyValueUpdate) {
                return pidlOrchestrator.broadcastPropertyValueUpdate(senderId, propertyElement, propertyValue, controlOperationType, maskedValuesDisplayed);
            }
            return Promise.resolve();
        };
        this.getFormatStringExpressionValue = function (value, bindingDataContext, propertyValueTransformer) {
            if (bindingDataContext && typehelper.isFormatStringExpressionPlaceholder(value)) {
                var evaluatedExpression = value.substring(1, value.length - 1);
                // Function call expression is expected to be in this format: <|functionName|arg1,arg2,...|>
                // The arguments can itself be a format string expression and no arguments (and no ';') are also acceptable
                var functionCallExpressions = typehelper.getProperties(evaluatedExpression, "<|", "|>");
                for (var i = 0; i < functionCallExpressions.length; i++) {
                    var functionCallExpression = functionCallExpressions[i];
                    var _a = functionCallExpression.split("|"), functionName = _a[0], argumentsExpression = _a[1];
                    var evaluatedArguments = void 0;
                    if (argumentsExpression) {
                        var argumentExpressions = argumentsExpression.split(";");
                        evaluatedArguments = [];
                        for (var j = 0; j < argumentExpressions.length; j++) {
                            evaluatedArguments[j] = _this.getPropertyExpressionValue(argumentExpressions[j], bindingDataContext);
                        }
                    }
                    var functionCallResult = _this.getFunctionExecutionResult({ functionName: functionName, arguments: evaluatedArguments }, bindingDataContext);
                    // Null and undefined are defaulted to '', but false can still be a valid result,
                    functionCallResult = typehelper.isNullOrUndefined(functionCallResult) ? "" : functionCallResult;
                    evaluatedExpression = evaluatedExpression.replace("<|" + functionCallExpression + "|>", functionCallResult);
                }
                var properyExpressions = typehelper.getProperties(evaluatedExpression, "{", "}");
                for (var i = 0; i < properyExpressions.length; i++) {
                    var propertyExpression = "{" + properyExpressions[i] + "}";
                    var propertyValue = _this.getPropertyExpressionValue(propertyExpression, bindingDataContext) || "";
                    if (propertyValueTransformer) {
                        propertyValue = propertyValueTransformer(propertyValue);
                    }
                    evaluatedExpression = evaluatedExpression.replace(propertyExpression, propertyValue);
                }
                return evaluatedExpression;
            }
            return value;
        };
        // Expects valueExpression to be:
        // a single format string expression (a single string between '(' and ')') resulting in a string
        // OR a single data binding expression (a single string between '{' and '}') resulting in a string, number or boolean
        // OR a single function call expression (a single string between '<|' and '|>') resulting in a string, number or boolean
        this.getConditionalFieldValue = function (valueExpression, bindingDataContext, modelElement) {
            if (bindingDataContext) {
                if (typehelper.isFormatStringExpressionPlaceholder(valueExpression)) {
                    return _this.getFormatStringExpressionValue(valueExpression, bindingDataContext);
                }
                else if (typehelper.isDataBindingPlaceholder(valueExpression)) {
                    return _this.getPropertyExpressionValue(valueExpression, bindingDataContext, isSelectionElement(modelElement));
                }
                else if (typehelper.isFunctionCallPlaceholder(valueExpression)) {
                    var functionCallExpression = valueExpression.substring(2, valueExpression.length - 2);
                    var functionNameIndex = functionCallExpression.indexOf("|");
                    var functionName = functionCallExpression.substring(0, functionNameIndex);
                    var argumentsExpression = functionCallExpression.substring(functionNameIndex + 1);
                    var evaluatedArguments = void 0;
                    if (argumentsExpression) {
                        var functionRegex = /\<\|([^<]*?)\|\>/gm;
                        var tempArgumentsExpression = argumentsExpression;
                        do {
                            var functionArguments = functionRegex.exec(argumentsExpression);
                            while (functionArguments !== null) {
                                var evaluatedFunctionValue = _this.getConditionalFieldValue(functionArguments[0], bindingDataContext, modelElement);
                                tempArgumentsExpression = tempArgumentsExpression.replace(functionArguments[0], evaluatedFunctionValue);
                                functionArguments = functionRegex.exec(argumentsExpression);
                            }
                            argumentsExpression = tempArgumentsExpression;
                        } while (argumentsExpression.match(functionRegex) !== null);
                        var argumentExpressions = argumentsExpression.split(";");
                        evaluatedArguments = [];
                        for (var j = 0; j < argumentExpressions.length; j++) {
                            evaluatedArguments[j] = _this.getConditionalFieldValue(argumentExpressions[j], bindingDataContext, modelElement);
                        }
                    }
                    return _this.getFunctionExecutionResult({ functionName: functionName, arguments: evaluatedArguments }, bindingDataContext);
                }
            }
            return valueExpression;
        };
        this.getFormatInstanceExpressionValue = function (value, bindingDataContext) {
            if (bindingDataContext && typehelper.isFormatStringExpressionPlaceholder(value)) {
                var evaluatedExpression = value.substring(1, value.length - 1);
                var properyExpressions = typehelper.getProperties(evaluatedExpression, "{", "}");
                for (var i = 0; i < properyExpressions.length; i++) {
                    if (properyExpressions[i].indexOf(".") < 0 && properyExpressions[i] in bindingDataContext) {
                        return bindingDataContext[properyExpressions[i]];
                    }
                }
            }
            return null;
        };
        this.getExpressionValue = function (value, bindingDataContext) {
            var expressionValue = value;
            // get the contents of each group of parentheses
            var parens = typehelper.getProperties(value, "(", ")");
            for (var index = 0; index < parens.length; index++) {
                // get the expression from parentheses contents
                var propertyName = typehelper.getProperties(parens[index], "{", "}")[0];
                var propertyValue = _this.getPropertyExpressionValue("{" + propertyName + "}", bindingDataContext);
                var openParen = void 0;
                var closeParen = void 0;
                if (propertyValue) {
                    // replace expression and remove parentheses
                    expressionValue = expressionValue.replace("{" + propertyName + "}", propertyValue);
                    openParen = expressionValue.indexOf("(");
                    expressionValue = expressionValue.substring(0, openParen) + expressionValue.substring(openParen + 1, expressionValue.length);
                    closeParen = expressionValue.indexOf(")");
                    expressionValue = expressionValue.substring(0, closeParen) + expressionValue.substring(closeParen + 1, expressionValue.length);
                }
                else {
                    // remove parentheses and their contents from display
                    openParen = expressionValue.indexOf("(");
                    closeParen = expressionValue.indexOf(")");
                    expressionValue = expressionValue.substring(0, openParen) + expressionValue.substring(closeParen + 1, expressionValue.length);
                }
            }
            return expressionValue;
        };
        // Apply the inputRegex on val to transform it into replacementPattern
        // undefined will be returned if val, inputRegex, and replacementPattern are not valid
        // Result will be trimmed of whitespace at both ends
        this.applyRegexTransformation = function (val, inputRegex, replacementPattern) {
            if (!typehelper.isNullOrUndefined(val) && inputRegex && replacementPattern) {
                return val.replace(RegExp(inputRegex), replacementPattern).trim();
            }
        };
        // TODO: once what value types htmlDomSelector.getVal is finally determined, the val type below needs to be changed, limit to string for now.
        this.applyDisplayTransformation = function (displayTransformation, val) {
            var res = val;
            switch (displayTransformation.type) {
                case displayTransformationTypesValues.regex:
                    if (typehelper.isString(val) || typehelper.isNumber(val)) {
                        res = _this.applyRegexTransformation(val.toString(), displayTransformation.inputRegex, displayTransformation.replacementPattern) || res;
                    }
                    break;
                default:
                    res = undefined;
            }
            return res;
        };
        // Get display content - Remove link []() if any else return the original text
        this.getTextContent = function (content) {
            if (content.indexOf(TextSymbols.link) === -1) {
                return content;
            }
            var displayContent = "";
            var parsedContent = _this.parseDisplayContent(content);
            if (parsedContent.length === 1) {
                return content;
            }
            for (var i = 0; i < parsedContent.length; i++) {
                var subContent = parsedContent[i];
                if (subContent.indexOf(TextSymbols.link) === -1) {
                    displayContent += subContent;
                }
                else {
                    displayContent += subContent.replace(subContent, subContent.match(/\[(.*?)\]/)[1]);
                }
            }
            return displayContent;
        };
        // Parse display content if content include hyper link with this format [display text](link)
        this.parseDisplayContent = function (content) {
            var searchIndex = 0;
            var linkIndex = content.indexOf(TextSymbols.link, searchIndex);
            var squareIndex = -1;
            var bracketIndex = -1;
            var contentList = [];
            while (linkIndex !== -1) {
                squareIndex = -1;
                // Look backward from this '](' index and find open square '[' bracket index
                for (var i = linkIndex; i <= linkIndex && i >= 0; i--) {
                    if (content[i] === "[") {
                        squareIndex = i;
                        break;
                    }
                }
                // If open square bracket '[' is not found return content list
                if (squareIndex === -1) {
                    contentList = [];
                    contentList.push(content);
                    return contentList;
                }
                // Get static text before open square '[' bracket index
                contentList.push(content.substring(bracketIndex, squareIndex));
                bracketIndex = -1;
                // Look forward from this '](' index and find close bracket ')' index
                for (var j = linkIndex; j >= linkIndex && j < content.length; j++) {
                    if (content[j] === ")") {
                        bracketIndex = j + 1;
                        break;
                    }
                }
                // If close bracket ')' is not found return content list
                if (bracketIndex === -1) {
                    contentList = [];
                    contentList.push(content);
                    return contentList;
                }
                // Get link text between '[]()' bracket
                contentList.push(content.substring(squareIndex, bracketIndex));
                searchIndex = linkIndex + 2;
                linkIndex = content.indexOf(TextSymbols.link, searchIndex);
                // Get static text if any after last link
                if (linkIndex === -1) {
                    var staticText = content.substring(bracketIndex, content.length);
                    if (staticText !== undefined && staticText !== "") {
                        contentList.push(staticText);
                    }
                }
            }
            return contentList;
        };
        this.convertBase64strIntoBlobUrl = function (base64str, type) {
            // Removing prefix to decode the string into blob
            //ToDo: REmove this prefix on PX side
            base64str = base64str.replace("data:audio/mp3;base64,", "");
            var audioURL = "";
            try {
                var decodedData = window.atob(base64str);
                var buffer = new ArrayBuffer(decodedData.length);
                var view = new Uint8Array(buffer);
                for (var i = 0; i < decodedData.length; i++) {
                    view[i] = decodedData.charCodeAt(i);
                }
                var blob = new Blob([view], { type: type });
                audioURL = URL.createObjectURL(blob);
            }
            catch (error) {
                // base64 string probably has an invalid character
                // we return a blank string in this case
            }
            return audioURL;
        };
        this.verifyClientSupported = function (pidlDocInfo) {
            var _a;
            // Clone pidl doc to modify the allowed payment methods.  If not cloned, we'll get stuck in
            // a componentDidUpdate infinite loop
            var clonePidlDocInfo = __assign({}, pidlDocInfo);
            clonePidlDocInfo.parameters = __assign({}, pidlDocInfo.parameters);
            var allowedPMs = clonePidlDocInfo.parameters.allowedPaymentMethods;
            if ((_a = window === null || window === void 0 ? void 0 : window.paymentAgent) === null || _a === void 0 ? void 0 : _a.clientSupported) {
                if (allowedPMs === null || allowedPMs === void 0 ? void 0 : allowedPMs.length) {
                    var clientSupportedPMs = window.paymentAgent.clientSupported(allowedPMs);
                    clonePidlDocInfo.parameters.allowedPaymentMethods = clientSupportedPMs;
                }
            }
            return clonePidlDocInfo;
        };
        this.getFlightHeaders = function (userContext) {
            var _a;
            var headers = ((_a = userContext === null || userContext === void 0 ? void 0 : userContext.getHeaders) === null || _a === void 0 ? void 0 : _a.call(userContext, {}, "")) || {};
            var msFlightHeaders = headers[httpHeaders.msFlight] || "";
            return msFlightHeaders;
        };
    }
    Utils.prototype.getPropertyExpressionValue = function (propertyExpression, bindingDataContext, internalValue) {
        if (internalValue === void 0) { internalValue = false; }
        if (bindingDataContext && typehelper.isString(propertyExpression) && typehelper.isDataBindingPlaceholder(propertyExpression)) {
            // trim curly braces to extract the property name
            var propertyName = propertyExpression.substring(1, propertyExpression.length - 1);
            if (propertyName.indexOf(".") < 0) {
                if (internalValue) {
                    return bindingDataContext.modelData && bindingDataContext.modelData.getPropertyValue(propertyName);
                }
                // get the value from modelData properties (userinput)
                return bindingDataContext.modelData && (bindingDataContext.modelData.getDisplayPropertyValue(propertyName) || bindingDataContext.modelData.getPropertyValue(propertyName));
            }
            else {
                // try to get the value from datasources
                var dataCollectionDetails = typehelper.getDataSourceDetails(propertyName);
                var bindingData = null;
                switch (dataCollectionDetails.dataSourceName) {
                    case dataStores.contextData:
                        bindingData = bindingDataContext.contextData;
                        break;
                    case dataStores.partnerData:
                        bindingData = bindingDataContext.modelData && bindingDataContext.modelData.getPartnerData();
                        break;
                    default:
                        bindingData = bindingDataContext.modelData && bindingDataContext.modelData.getAllDataSources();
                        break;
                }
                if (bindingData && dataCollectionDetails.jpath) {
                    return typehelper.getPropertyValueByJPath(bindingData, dataCollectionDetails.jpath);
                }
            }
            return null;
        }
        return propertyExpression;
    };
    Utils.prototype.getFunctionExecutionResult = function (functionDescription, bindingDataContext, eventHub) {
        if (functionDescription && functionDescription.functionName) {
            // prepare parameters
            var parameters = {
                contextData: bindingDataContext && bindingDataContext.contextData,
                partnerData: bindingDataContext && bindingDataContext.modelData && bindingDataContext.modelData.getPartnerData(),
                dataSources: bindingDataContext && bindingDataContext.modelData && bindingDataContext.modelData.getAllDataSources(),
                model: bindingDataContext && bindingDataContext.model,
            };
            if (functionDescription.arguments) {
                parameters["arguments"] = functionDescription.arguments;
            }
            var helpers = void 0;
            try {
                helpers = window.pidlResourceHelpers;
            }
            catch (err) { }
            if (helpers && helpers.executeExtensionFunc) {
                var funcResult = helpers.executeExtensionFunc(functionDescription.functionName, parameters);
                if (eventHub && functionDescription.functionName === "filterPaymentInstruments" && typehelper.isArray(funcResult)) {
                    var inputParams = { pidlDocInfo: parameters.partnerData && parameters.partnerData.inputParameters && parameters.partnerData.inputParameters.pidlDocInfo };
                    var outputValue = funcResult.map(function (x) {
                        return {
                            id: x && x.id,
                            paymentMethodType: x && x.paymentMethod && x.paymentMethod.paymentMethodType,
                            paymentMethodFamily: x && x.paymentMethod && x.paymentMethod.paymentMethodFamily
                        };
                    });
                    eventHub.resourceHelpersFunctionExecuted(functionDescription.functionName, inputParams, outputValue);
                }
                return funcResult;
            }
        }
        return null;
    };
    return Utils;
}());
var utils = new Utils();

"use strict";
var typeHelper = /** @class */ (function () {
    function typeHelper() {
        var _this = this;
        this.getType = function (instance) {
            return Object.prototype.toString.call(instance);
        };
        this.isArray = function (instance) {
            return instance && _this.getType(instance) === "[object Array]";
        };
        this.isObject = function (instance) {
            return instance && _this.getType(instance) === "[object Object]";
        };
        this.isFunction = function (instance) {
            return instance && _this.getType(instance) === "[object Function]";
        };
        this.isString = function (instance) {
            return typeof instance === "string";
        };
        this.isBool = function (instance) {
            return typeof instance === "boolean";
        };
        this.isNumber = function (instance) {
            return typeof instance === "number";
        };
        this.isNullOrEmptyObject = function (instance) {
            if (instance) {
                for (var prop in instance) {
                    if (instance.hasOwnProperty(prop)) {
                        return false;
                    }
                }
            }
            return true;
        };
        this.isEmptyString = function (instance) {
            return _this.isString(instance) && instance.length === 0;
        };
        this.isWhiteSpaceString = function (instance) {
            return _this.isString(instance) && instance.trim().length === 0;
        };
        this.isNull = function (instance) {
            return !instance && instance === null;
        };
        this.isUndefined = function (instance) {
            return typeof instance === "undefined";
        };
        this.isNullOrUndefined = function (instance) {
            return _this.isNull(instance) || _this.isUndefined(instance);
        };
        this.isNullOrUndefinedOrWhiteSpaceString = function (instance) {
            return _this.isNullOrUndefined(instance) || _this.isEmptyString(instance) || _this.isWhiteSpaceString(instance);
        };
        this.contains = function (array, instance) {
            var index = _this.indexOf(array, instance);
            return index >= 0;
        };
        this.indexOf = function (array, instance) {
            for (var i = 0; i < array.length; i++) {
                if (array[i] === instance) {
                    return i;
                }
            }
            return -1;
        };
        this.includes = function (fromString, searchString) {
            return !_this.isNullOrUndefined(fromString) && fromString.indexOf(searchString) >= 0;
        };
        this.keyCount = function (instance) {
            if (_this.isObject(instance)) {
                return Object.keys(instance).length;
            }
        };
        this.getFirstKey = function (instance) {
            return (_this.isObject(instance) && (_this.keyCount(instance) > 0) && Object.keys(instance)[0]) || undefined;
        };
        this.serialize = function (instance) {
            if (_this.isObject(instance) || _this.isArray(instance)) {
                try {
                    return JSON.stringify(instance);
                }
                catch (error) {
                    return error && error.message;
                }
            }
            return (instance === null || instance === undefined) ? "" : instance;
        };
        this.addSlashes = function (str) {
            str = str.replace(/[\\\'\"]/g, "\\$&");
            return str;
        };
        this.format = function (formatString, args) {
            if (!_this.isString(formatString)) {
                return formatString;
            }
            args = args || [];
            args["{"] = "{";
            args["}"] = "}";
            return formatString.replace(/{({|}|-?[0-9]+)}/g, function (item) {
                return _this.addSlashes(_this.serialize(args[item.substring(1, item.length - 1)]));
            });
        };
        this.attachAffixes = function (prefix, word, suffix) {
            var result = _this.isNullOrUndefined(prefix) ? word : prefix + word;
            return _this.isNullOrUndefined(suffix) ? result : result + suffix;
        };
        this.removeAffixes = function (prefix, word, suffix) {
            if (_this.isNullOrUndefined(word)) {
                return word;
            }
            var wordStart = _this.isNullOrUndefined(prefix) ? 0 : prefix.length;
            var wordEnd = _this.isNullOrUndefined(suffix) ? word.length : word.length - suffix.length;
            return word.substring(wordStart, wordEnd);
        };
        this.startsWithIgnoreCase = function (str, startsWith) {
            if (str) {
                if (!startsWith || !startsWith.length) {
                    return true;
                }
                return str.slice(0, startsWith.length).toLowerCase() === startsWith.toLowerCase();
            }
            return false;
        };
        this.startsWith = function (str, startsWith) {
            if (str) {
                if (!startsWith || !startsWith.length) {
                    return true;
                }
                return str.slice(0, startsWith.length) === startsWith;
            }
            return false;
        };
        this.endsWith = function (str, endsWith) {
            if (str) {
                if (!endsWith || !endsWith.length) {
                    return true;
                }
                return str.slice(str.length - endsWith.length) === endsWith;
            }
            return false;
        };
        this.isDataBindingPlaceholder = function (str) {
            return str && _this.isString(str) && _this.startsWith(str, "{") && _this.endsWith(str, "}");
        };
        this.isFormatStringExpressionPlaceholder = function (str) {
            return str && _this.isString(str) && _this.startsWith(str, "(") && _this.endsWith(str, ")");
        };
        this.isFunctionCallPlaceholder = function (str) {
            return str && _this.isString(str) && _this.startsWith(str, "<|") && _this.endsWith(str, "|>");
        };
        this.getDataSourceDetails = function (str) {
            var dataSourceName = str;
            var jpath = undefined;
            var index = str.indexOf(".");
            if (index > 0) {
                dataSourceName = str.substr(0, index);
                jpath = str.substr(index + 1);
            }
            return { dataSourceName: dataSourceName, jpath: jpath };
        };
        this.getPropertyValueByJPath = function (obj, str) {
            // ignore non required charactes in the given jpath
            if (_this.startsWith(str, "{$.")) {
                str = str.substring(3, str.length - 1);
            }
            else if (_this.startsWith(str, "{")) {
                str = str.substring(1, str.length - 1);
            }
            str = str.replace(/\[(\w+)\]/g, ".$1"); // change indexes to properties
            str = str.replace(/^\./, ""); // remove any leading dot
            var parts = str.split(".");
            for (var i = 0; i < parts.length; i++) {
                var propName = parts[i];
                if (obj && propName in obj) {
                    obj = obj[propName];
                }
                else {
                    return;
                }
            }
            return obj;
        };
        this.getDataCollectionSource = function (str) {
            return str.split(".")[0];
        };
        this.getDataCollectionName = function (str) {
            return str.split(".")[1] || str;
        };
        this.toString = function (val) {
            if (!_this.isUndefined(val) && val.toString) {
                val = val.toString();
            }
            return val;
        };
        this.toLowerCase = function (str) {
            return _this.isString(str) && str.toLowerCase ? str.toLowerCase() : str;
        };
        this.toUpperCase = function (str) {
            return _this.isString(str) && str.toUpperCase ? str.toUpperCase() : str;
        };
        this.equalsIgnoreCase = function (s1, s2) {
            return _this.toLowerCase(s1) === _this.toLowerCase(s2);
        };
        this.escapeCharactersForHtml = function (value) {
            if (value && value.replace) {
                return value.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
            }
            return value;
        };
        this.replaceCharactersForHtml = function (value) {
            // Replaces the first character of an id with 'a' if it does not begin with a letter, and replaces invalid characters with underscores
            // Documentation: https://www.w3.org/TR/html4/types.html#type-id, https://www.w3.org/TR/html5/dom.html#the-id-attribute
            // Additionally, jQuery treats '.' and ':' as special characters
            if (value && value.replace) {
                return value.replace(/(^[^A-Za-z])/, "a").replace(/([^A-Za-z0-9-_])/g, "_");
            }
            return value;
        };
        this.getProperties = function (str, initialDelim, endDelim) {
            var properties = [];
            var endIndex = -1;
            var initialDelimLength = initialDelim.length;
            var endDelimLength = endDelim.length;
            while (true) {
                var startIndex = str.indexOf(initialDelim, endIndex === -1 ? 0 : endIndex + endDelimLength);
                if (startIndex === -1) {
                    break;
                }
                endIndex = str.indexOf(endDelim, startIndex + initialDelimLength);
                if (endIndex === -1) {
                    break;
                }
                properties.push(str.substr(startIndex + initialDelimLength, endIndex - startIndex - initialDelimLength));
            }
            return properties;
        };
        this.boolify = function (instance) {
            if (_this.isString(instance)) {
                if (_this.equalsIgnoreCase(instance, "false") || _this.isEmptyString(instance)) {
                    return false;
                }
                else {
                    return true;
                }
            }
            return instance ? true : false;
        };
        this.deepCopy = function (instance, extend) {
            extend = extend || {};
            return (instance && utils.extend(true, extend, instance)) || {};
        };
        this.mergeObjectArray = function (instance) {
            var newInstance = {};
            if (instance && instance.length) {
                for (var index = 0; index < instance.length; index++) {
                    utils.extend(newInstance, instance[index]);
                }
            }
            return newInstance;
        };
        this.removeFromArray = function (array, index, count) {
            if (array) {
                array.splice(index, count);
            }
        };
        this.getKeys = function (obj) {
            if (!obj) {
                return [];
            }
            return Object.keys(obj);
        };
        this.getValues = function (obj) {
            if (!obj) {
                return [];
            }
            return Object.keys(obj).map(function (key) { return obj[key]; });
        };
        this.filter = function (arr, evaluator) {
            var notEvaluator = function (arrayElem) {
                var evltr = evaluator || function () { return true; };
                return !evltr(arrayElem);
            };
            _this.invokeIf(arr, notEvaluator, function (index) {
                arr.splice(index, 1);
            });
        };
        this.objectEquals = function (a, b) {
            if (!a || !b || _this.keyCount(a) !== _this.keyCount(b)) {
                return false;
            }
            for (var aKey in a) {
                if (a[aKey] !== b[aKey]) {
                    return false;
                }
            }
            return true;
        };
        this.bothNull = function (p1, p2) {
            return !(p1 || p2);
        };
        this.onlyOneNull = function (p1, p2) {
            return !(p1 && p2);
        };
    }
    typeHelper.prototype.copyArray = function (instance) {
        return (instance && instance.slice()) || [];
    };
    // Goes backwards to allow splice
    typeHelper.prototype.invokeIf = function (arr, evaluator, methodToInvoke) {
        if (arr && evaluator) {
            var i = arr.length;
            while (i--) {
                if (evaluator(arr[i])) {
                    methodToInvoke(i);
                }
            }
        }
    };
    typeHelper.prototype.find = function (arr, evaluator) {
        if (arr && evaluator) {
            for (var i = 0; i < arr.length; i++) {
                if (evaluator(arr[i])) {
                    return arr[i];
                }
            }
        }
    };
    return typeHelper;
}());
var typehelper = new typeHelper();

"use strict";
var config = /** @class */ (function () {
    function config() {
        var _this = this;
        this.serviceEndpoints = {};
        this.currentEnv = "prod";
        this.virtualEndpoints = {
            billingAuth: {
                description: "Billing Auth Service",
                endpoint: "billingauth-endpoint",
                name: "billingauth",
                operation: "POST Tax ID"
            },
            bsxCommerce: {
                description: "BSX Commerce Service",
                endpoint: "bsxcommerce-endpoint",
                name: "bsxcommerce",
                operation: "GET MC PI"
            },
            hapi: {
                description: "HAPI Service",
                endpoint: "hapi-endpoint",
                name: "hapi",
                operation: "POST Tax ID"
            },
            jarvis: {
                description: "Jarvis FD",
                endpoint: "jarvis-endpoint",
                name: "jarvis",
                operation: "POST Jarvis"
            },
            jarvisAddress: {
                description: "Jarvis FD",
                endpoint: "jarvis-address-endpoint",
                name: "jarvisaddress",
                operation: "POST Jarvis Address"
            },
            paypalEncryptJS: {
                description: "Static Resource Service",
                endpoint: "paypalencryptjs-endpoint",
                name: "paypalencrypt",
                operation: "Download Paypal Encrypt JS"
            },
            pidl: {
                description: "PIDL Service",
                endpoint: "pidl-endpoint",
                name: "pidl",
                operation: "GET PIDL"
            },
            pidlEdge: {
                description: "PIDL Service on Edge",
                endpoint: "pidledge-endpoint",
                name: "pidledge",
                operation: "GET PIDL on Edge"
            },
            pifdBackend: {
                description: "PIFD Backend",
                endpoint: "pifdbackend-endpoint",
                name: "pifdbackend",
                operation: "PIFD operation on PIFDBackEnd"
            },
            pifd: {
                description: "Payment Instrument FD",
                endpoint: "pifd-endpoint",
                name: "pifd",
                operation: "POST PIDL"
            },
            pifdEdge: {
                description: "Payment Instrument FD on Edge",
                endpoint: "pifdedge-endpoint",
                name: "pifdedge",
                operation: "PIFD operation on Edge"
            },
            pifdAddress: {
                description: "Payment Instrument FD",
                endpoint: "pifd-address-endpoint",
                name: "pifdaddress",
                operation: "POST Address PIDL"
            },
            pifdProfile: {
                description: "Payment Instrument FD",
                endpoint: "pifd-profile-endpoint",
                name: "pifdprofile",
                operation: "POST Profile PIDL"
            },
            pifdPx: {
                description: "Payment Instrument FD",
                endpoint: "pifd-px-endpoint",
                name: "pifdpx",
                operation: "PIFD PX"
            },
            redirection: {
                description: "Redirection Service",
                endpoint: "redirection-endpoint",
                name: "redirection",
                operation: "Redirect"
            },
            redirectionv2: {
                description: "Redirection Service",
                endpoint: "redirectionv2-endpoint",
                name: "redirection",
                operation: "Redirect"
            },
            resource: {
                description: "Resource Service",
                endpoint: "resource-endpoint",
                name: "resource",
                operation: "GET Resource"
            },
            tokenization: {
                description: "Tokenization Service",
                endpoint: "tokenization-endpoint",
                name: "tokenization",
                operation: "Tokenize User Input"
            },
            transformation: {
                description: "Transformation Service",
                endpoint: "transformation-endpoint",
                name: "transformation",
                operation: "Transform User Input"
            },
            validation: {
                description: "Validation Service",
                endpoint: "validation-endpoint",
                name: "validation",
                operation: "Validate User Input"
            },
            commercemgmt: {
                description: "Commerce Management Endpoint",
                endpoint: "commercemgmt-endpoint",
                name: "commercemgmt",
                operation: "Commerce Management"
            },
            encryptJS: {
                description: "Static Resource Service",
                endpoint: "encryptjs-endpoint",
                name: "encrypt",
                operation: "Download external service specific Encrypt JS"
            },
            msrCryptoJS: {
                description: "Static Resource Service",
                endpoint: "msrcryptojs-endpoint",
                name: "msrcrypto",
                operation: "Download MSR Crypto JS"
            },
            staticResources: {
                description: "Static Resource Service",
                endpoint: "staticResources-endpoint",
                name: "staticresources",
                operation: "Download static resources"
            },
            tokenPolicy: {
                description: "Token Policy Service",
                endpoint: "tops-endpoint",
                name: "tokenpolicy",
                operation: "Verify CSV"
            },
            purchaseFrontDoor: {
                description: "Purchase FrontDoor Service",
                endpoint: "purchase-endpoint",
                name: "purchasefrontdoor",
                operation: "Apply CSV to user account"
            },
            payeeTaxProfile: {
                description: "Payee Tax Profile PIDL Service",
                endpoint: "payeetaxprofile-endpoint",
                name: "payeetaxprofile",
                operation: "Payee Tax Profile PIDL Service"
            },
            msRewards: {
                description: "MS Rewards PIDL Service",
                endpoint: "pidl-endpoint",
                name: "msrewards",
                operation: "GET MS Rewards PIDL"
            },
            securePx: {
                description: "Secure PX Service",
                endpoint: "securepx-endpoint",
                name: "securepx",
                operation: "Secure field value handler"
            },
            provisionWalletToken: {
                description: "Wallet Token",
                endpoint: "pifd-endpoint",
                name: "pifd",
                operation: "POST Wallet Token"
            },
            gpex: {
                description: "Generic PIDL Experience Service",
                endpoint: "gpex-endpoint",
                name: "gpex",
                operation: "Address Tax Profile PIDL Service"
            },
            challengeUI: {
                description: "Challenge UI PIDL Service",
                endpoint: "challengeui-endpoint",
                name: "challengeui",
                operation: "Challenge UI PIDL Service"
            },
        };
        this.updateEndpoints = function (env) {
            var envSpecificServices = {};
            _this.currentEnv = env;
            if (env === "int") {
                envSpecificServices["billingAuth" /* services.billingAuth */] = "billingapi.cp.microsoft-int.com";
                envSpecificServices["bsxCommerce" /* services.bsxCommerce */] = "bsxcommerce.mp.microsoft-int.com/v1";
                envSpecificServices["hapi" /* services.hapi */] = "commerceapi.officeppe.net/v1";
                envSpecificServices["jarvis" /* services.jarvis */] = "jcmsdf.account.microsoft-int.com";
                envSpecificServices["paypalencryptjs" /* services.paypalEncryptJS */] = "pmservices.cp.microsoft-int.com/staticresourceservice/scripts/v6/int";
                envSpecificServices["encryptJS" /* services.encryptJS */] = "pmservices.cp.microsoft-int.com/staticresourceservice/scripts/v6/int";
                envSpecificServices["msrCryptojs" /* services.msrCryptoJS */] = "pmservices.cp.microsoft-int.com/staticresourceservice/scripts/v6/int";
                envSpecificServices["staticResources" /* services.staticResources */] = "staticresources.payments.microsoft-int.com";
                envSpecificServices["pifdBackend" /* services.pifdBackend */] = "pifd.cp.microsoft-int.com/v6.0";
                envSpecificServices["pifd" /* services.pifd */] = "pifd.cp.microsoft-int.com/v6.0";
                envSpecificServices["pifdEdge" /* services.pifdEdge */] = "paymentsfd.cp.microsoft-int.com/pifdint/v6.0";
                envSpecificServices["redirection" /* services.redirection */] = "pmservices.cp.microsoft-int.com";
                envSpecificServices["redirectionv2" /* services.redirectionv2 */] = "paymentsredirectionservice.cp.microsoft-int.com";
                envSpecificServices["tokenization" /* services.tokenization */] = "tokenization.cp.microsoft-int.com/tokens";
                envSpecificServices["transformation" /* services.transformation */] = "pifd.cp.microsoft-int.com/v6.0";
                envSpecificServices["validation" /* services.validation */] = "pifd.cp.microsoft-int.com/v6.0";
                envSpecificServices["commercemgmt" /* services.commercemgmt */] = "ppe.commercemgmt.m365.microsoft.com";
                envSpecificServices["tokenPolicy" /* services.tokenPolicy */] = "tops-int.mp.microsoft.com/v1.0";
                envSpecificServices["purchaseFrontDoor" /* services.purchaseFrontDoor */] = "purchase-int.mp.microsoft.com/v7.0";
                envSpecificServices["securePx" /* services.securePx */] = "securepxservice.cp.microsoft-int.com";
                envSpecificServices["payeeTaxProfile" /* services.payeeTaxProfile */] = "taxservice-dev-gdfveqaqepcbgmc5.z01.azurefd.net";
                envSpecificServices["gpex" /* services.gpex */] = "edge.gpex.cp.microsoft-int.com";
                envSpecificServices["challengeUI" /* services.challengeUI */] = "payint.microsoft.com/challengeui";
            }
            else if (env === "aircapi") {
                envSpecificServices["billingAuth" /* services.billingAuth */] = "billingapi.cp.microsoft-int.com";
                envSpecificServices["bsxCommerce" /* services.bsxCommerce */] = "bsxcommerce.mp.microsoft-int.com/v1";
                envSpecificServices["hapi" /* services.hapi */] = "commerceapi.officeppe.net/v1";
                envSpecificServices["jarvis" /* services.jarvis */] = "jcmsdf.account.microsoft-int.com";
                envSpecificServices["paypalencryptjs" /* services.paypalEncryptJS */] = "pmservices.cp.microsoft-int.com/staticresourceservice/scripts/v6/int";
                envSpecificServices["encryptJS" /* services.encryptJS */] = "pmservices.cp.microsoft-int.com/staticresourceservice/scripts/v6/int";
                envSpecificServices["msrCryptojs" /* services.msrCryptoJS */] = "pmservices.cp.microsoft-int.com/staticresourceservice/scripts/v6/int";
                envSpecificServices["staticResources" /* services.staticResources */] = "staticresources.payments.microsoft-int.com";
                envSpecificServices["pifdBackend" /* services.pifdBackend */] = "edge.gpex-aircapi.cp.microsoft.com";
                envSpecificServices["pifd" /* services.pifd */] = "edge.gpex-aircapi.cp.microsoft.com";
                envSpecificServices["pifdEdge" /* services.pifdEdge */] = "paymentsfd.cp.microsoft-int.com/pifdint/v6.0";
                envSpecificServices["redirection" /* services.redirection */] = "pmservices.cp.microsoft-int.com";
                envSpecificServices["redirectionv2" /* services.redirectionv2 */] = "paymentsredirectionservice.cp.microsoft-int.com";
                envSpecificServices["tokenization" /* services.tokenization */] = "tokenization.cp.microsoft-int.com/tokens";
                envSpecificServices["transformation" /* services.transformation */] = "edge.gpex-aircapi.cp.microsoft.com";
                envSpecificServices["validation" /* services.validation */] = "edge.gpex-aircapi.cp.microsoft.com";
                envSpecificServices["commercemgmt" /* services.commercemgmt */] = "ppe.commercemgmt.m365.microsoft.com";
                envSpecificServices["tokenPolicy" /* services.tokenPolicy */] = "tops-int.mp.microsoft.com/v1.0";
                envSpecificServices["purchaseFrontDoor" /* services.purchaseFrontDoor */] = "purchase-int.mp.microsoft.com/v7.0";
                envSpecificServices["securePx" /* services.securePx */] = "localhost:44326";
                envSpecificServices["payeeTaxProfile" /* services.payeeTaxProfile */] = "taxservice-dev-gdfveqaqepcbgmc5.z01.azurefd.net";
                envSpecificServices["gpex" /* services.gpex */] = "edge.gpex-aircapi.cp.microsoft.com";
                envSpecificServices["challengeUI" /* services.challengeUI */] = "payint.microsoft.com/challengeui";
            }
            else if (env === "ppe") {
                envSpecificServices["billingAuth" /* services.billingAuth */] = "billingapi.cp.microsoft.com";
                envSpecificServices["bsxCommerce" /* services.bsxCommerce */] = "bsxcommerce.mp.microsoft.com/v1";
                envSpecificServices["hapi" /* services.hapi */] = "commerceapi.office.net/v1";
                envSpecificServices["jarvis" /* services.jarvis */] = "jcmsfd.account.microsoft.com";
                envSpecificServices["paypalencryptjs" /* services.paypalEncryptJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["encryptJS" /* services.encryptJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["msrCryptojs" /* services.msrCryptoJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["staticResources" /* services.staticResources */] = "staticresources.payments.microsoft.com";
                envSpecificServices["pifdBackend" /* services.pifdBackend */] = "paymentinstruments-int.mp.microsoft.com/v6.0";
                envSpecificServices["pifd" /* services.pifd */] = "paymentinstruments-int.mp.microsoft.com/v6.0";
                envSpecificServices["pifdEdge" /* services.pifdEdge */] = "paymentsfd.cp.microsoft-int.com/pifdppe/v6.0";
                envSpecificServices["redirection" /* services.redirection */] = "pmservices.cp.microsoft.com";
                envSpecificServices["redirectionv2" /* services.redirectionv2 */] = "paymentsredirectionservice.cp.microsoft.com";
                envSpecificServices["tokenization" /* services.tokenization */] = "tokenization.cp.microsoft.com/tokens";
                envSpecificServices["transformation" /* services.transformation */] = "paymentinstruments-int.mp.microsoft.com/v6.0";
                envSpecificServices["validation" /* services.validation */] = "paymentinstruments-int.mp.microsoft.com/v6.0";
                envSpecificServices["commercemgmt" /* services.commercemgmt */] = "ppe.commercemgmt.m365.microsoft.com";
                envSpecificServices["tokenPolicy" /* services.tokenPolicy */] = "tops.mp.microsoft.com/v1.0";
                envSpecificServices["purchaseFrontDoor" /* services.purchaseFrontDoor */] = "purchase.mp.microsoft.com/v7.0";
                envSpecificServices["securePx" /* services.securePx */] = "securepxservice-ppe.cp.microsoft.com";
                envSpecificServices["payeeTaxProfile" /* services.payeeTaxProfile */] = "taxservice-uat-htdmh4h7cxfjfecg.z01.azurefd.net";
                envSpecificServices["gpex" /* services.gpex */] = "edge.gpex-ppe.cp.microsoft.com";
                envSpecificServices["challengeUI" /* services.challengeUI */] = "payppe.microsoft.com/challengeui";
            }
            else if (env === "prod") {
                envSpecificServices["billingAuth" /* services.billingAuth */] = "billingapi.cp.microsoft.com";
                envSpecificServices["bsxCommerce" /* services.bsxCommerce */] = "bsxcommerce.mp.microsoft.com/v1";
                envSpecificServices["hapi" /* services.hapi */] = "commerceapi.office.net/v1";
                envSpecificServices["jarvis" /* services.jarvis */] = "jcmsfd.account.microsoft.com";
                envSpecificServices["paypalencryptjs" /* services.paypalEncryptJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["encryptJS" /* services.encryptJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["msrCryptojs" /* services.msrCryptoJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["staticResources" /* services.staticResources */] = "staticresources.payments.microsoft.com";
                envSpecificServices["pifdBackend" /* services.pifdBackend */] = "paymentinstruments.mp.microsoft.com/v6.0";
                envSpecificServices["pifd" /* services.pifd */] = "paymentinstruments.mp.microsoft.com/v6.0";
                envSpecificServices["pifdEdge" /* services.pifdEdge */] = "paymentsfd.cp.microsoft.com/pifd/v6.0";
                envSpecificServices["redirection" /* services.redirection */] = "pmservices.cp.microsoft.com";
                envSpecificServices["redirectionv2" /* services.redirectionv2 */] = "paymentsredirectionservice.cp.microsoft.com";
                envSpecificServices["tokenization" /* services.tokenization */] = "tokenization.cp.microsoft.com/tokens";
                envSpecificServices["transformation" /* services.transformation */] = "paymentinstruments.mp.microsoft.com/v6.0";
                envSpecificServices["validation" /* services.validation */] = "paymentinstruments.mp.microsoft.com/v6.0";
                envSpecificServices["commercemgmt" /* services.commercemgmt */] = "commercemgmt.m365.microsoft.com";
                envSpecificServices["tokenPolicy" /* services.tokenPolicy */] = "tops.mp.microsoft.com/v1.0";
                envSpecificServices["purchaseFrontDoor" /* services.purchaseFrontDoor */] = "purchase.mp.microsoft.com/v7.0";
                envSpecificServices["securePx" /* services.securePx */] = "securepxservice.cp.microsoft.com";
                envSpecificServices["payeeTaxProfile" /* services.payeeTaxProfile */] = "taxprofileservice-prod-hqgqe5g5f8fwfcdw.z01.azurefd.net";
                envSpecificServices["gpex" /* services.gpex */] = "edge.gpex.cp.microsoft.com";
                envSpecificServices["challengeUI" /* services.challengeUI */] = "pay.microsoft.com/challengeui";
            }
            else if (env === "feature") {
                envSpecificServices["billingAuth" /* services.billingAuth */] = "billingapi.cp.microsoft.com";
                envSpecificServices["bsxCommerce" /* services.bsxCommerce */] = "bsxcommerce.mp.microsoft.com/v1";
                envSpecificServices["hapi" /* services.hapi */] = "commerceapi.office.net/v1";
                envSpecificServices["jarvis" /* services.jarvis */] = "jcmsfd.account.microsoft.com";
                envSpecificServices["paypalencryptjs" /* services.paypalEncryptJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["encryptJS" /* services.encryptJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["msrCryptojs" /* services.msrCryptoJS */] = "pmservices.cp.microsoft.com/staticresourceservice/scripts/v6/prod";
                envSpecificServices["staticResources" /* services.staticResources */] = "staticresources.payments.microsoft.com";
                envSpecificServices["pifdBackend" /* services.pifdBackend */] = "paymentinstruments.mp.microsoft.com/v6.0";
                envSpecificServices["pifd" /* services.pifd */] = "st-pifd-prod-wcus.azurewebsites.net/v6.0";
                envSpecificServices["pifdEdge" /* services.pifdEdge */] = "st-pifd-prod-wcus.azurewebsites.net/v6.0";
                envSpecificServices["redirection" /* services.redirection */] = "pmservices.cp.microsoft.com";
                envSpecificServices["redirectionv2" /* services.redirectionv2 */] = "paymentsredirectionservice.cp.microsoft.com";
                envSpecificServices["tokenization" /* services.tokenization */] = "tokenization.cp.microsoft.com/tokens";
                envSpecificServices["transformation" /* services.transformation */] = "st-pifd-prod-wcus.azurewebsites.net/v6.0";
                envSpecificServices["validation" /* services.validation */] = "st-pifd-prod-wcus.azurewebsites.net/v6.0";
                envSpecificServices["commercemgmt" /* services.commercemgmt */] = "commercemgmt.m365.microsoft.com";
                envSpecificServices["tokenPolicy" /* services.tokenPolicy */] = "tops.mp.microsoft.com/v1.0";
                envSpecificServices["purchaseFrontDoor" /* services.purchaseFrontDoor */] = "purchase.mp.microsoft.com/v7.0";
                envSpecificServices["payeeTaxProfile" /* services.payeeTaxProfile */] = "taxservice-dev-gdfveqaqepcbgmc5.z01.azurefd.net";
                envSpecificServices["gpex" /* services.gpex */] = "edge.gpex.cp.microsoft.com";
                envSpecificServices["challengeUI" /* services.challengeUI */] = "payint.microsoft.com/challengeui";
            }
            _this.serviceEndpoints = {};
            _this.serviceEndpoints[_this.virtualEndpoints.billingAuth.endpoint] = envSpecificServices["billingAuth" /* services.billingAuth */];
            _this.serviceEndpoints[_this.virtualEndpoints.bsxCommerce.endpoint] = envSpecificServices["bsxCommerce" /* services.bsxCommerce */];
            _this.serviceEndpoints[_this.virtualEndpoints.hapi.endpoint] = envSpecificServices["hapi" /* services.hapi */];
            _this.serviceEndpoints[_this.virtualEndpoints.jarvis.endpoint] = envSpecificServices["jarvis" /* services.jarvis */];
            _this.serviceEndpoints[_this.virtualEndpoints.jarvisAddress.endpoint] = envSpecificServices["jarvis" /* services.jarvis */];
            _this.serviceEndpoints[_this.virtualEndpoints.paypalEncryptJS.endpoint] = envSpecificServices["paypalencryptjs" /* services.paypalEncryptJS */];
            _this.serviceEndpoints[_this.virtualEndpoints.encryptJS.endpoint] = envSpecificServices["encryptJS" /* services.encryptJS */];
            _this.serviceEndpoints[_this.virtualEndpoints.msrCryptoJS.endpoint] = envSpecificServices["msrCryptojs" /* services.msrCryptoJS */];
            _this.serviceEndpoints[_this.virtualEndpoints.staticResources.endpoint] = envSpecificServices["staticResources" /* services.staticResources */];
            _this.serviceEndpoints[_this.virtualEndpoints.pidl.endpoint] = envSpecificServices["pifd" /* services.pifd */];
            _this.serviceEndpoints[_this.virtualEndpoints.pidlEdge.endpoint] = envSpecificServices["pifdEdge" /* services.pifdEdge */];
            _this.serviceEndpoints[_this.virtualEndpoints.pifdBackend.endpoint] = envSpecificServices["pifdBackend" /* services.pifdBackend */];
            _this.serviceEndpoints[_this.virtualEndpoints.pifd.endpoint] = envSpecificServices["pifd" /* services.pifd */];
            _this.serviceEndpoints[_this.virtualEndpoints.pifdEdge.endpoint] = envSpecificServices["pifdEdge" /* services.pifdEdge */];
            _this.serviceEndpoints[_this.virtualEndpoints.pifdAddress.endpoint] = envSpecificServices["pifd" /* services.pifd */];
            _this.serviceEndpoints[_this.virtualEndpoints.pifdProfile.endpoint] = envSpecificServices["pifd" /* services.pifd */];
            _this.serviceEndpoints[_this.virtualEndpoints.pifdPx.endpoint] = envSpecificServices["pifd" /* services.pifd */];
            _this.serviceEndpoints[_this.virtualEndpoints.redirection.endpoint] = envSpecificServices["redirection" /* services.redirection */];
            _this.serviceEndpoints[_this.virtualEndpoints.redirectionv2.endpoint] = envSpecificServices["redirectionv2" /* services.redirectionv2 */];
            _this.serviceEndpoints[_this.virtualEndpoints.resource.endpoint] = envSpecificServices["pifd" /* services.pifd */];
            _this.serviceEndpoints[_this.virtualEndpoints.tokenization.endpoint] = envSpecificServices["tokenization" /* services.tokenization */];
            _this.serviceEndpoints[_this.virtualEndpoints.transformation.endpoint] = envSpecificServices["transformation" /* services.transformation */];
            _this.serviceEndpoints[_this.virtualEndpoints.validation.endpoint] = envSpecificServices["validation" /* services.validation */];
            _this.serviceEndpoints[_this.virtualEndpoints.commercemgmt.endpoint] = envSpecificServices["commercemgmt" /* services.commercemgmt */];
            _this.serviceEndpoints[_this.virtualEndpoints.tokenPolicy.endpoint] = envSpecificServices["tokenPolicy" /* services.tokenPolicy */];
            _this.serviceEndpoints[_this.virtualEndpoints.purchaseFrontDoor.endpoint] = envSpecificServices["purchaseFrontDoor" /* services.purchaseFrontDoor */];
            _this.serviceEndpoints[_this.virtualEndpoints.securePx.endpoint] = envSpecificServices["securePx" /* services.securePx */];
            _this.serviceEndpoints[_this.virtualEndpoints.payeeTaxProfile.endpoint] = envSpecificServices["payeeTaxProfile" /* services.payeeTaxProfile */];
            _this.serviceEndpoints[_this.virtualEndpoints.gpex.endpoint] = envSpecificServices["gpex" /* services.gpex */];
            _this.serviceEndpoints[_this.virtualEndpoints.challengeUI.endpoint] = envSpecificServices["challengeUI" /* services.challengeUI */];
        };
        this.addGenericParameters = function (parameters, resourceInfo, operationType) {
            if (resourceInfo && resourceInfo.parameters) {
                for (var key in resourceInfo.parameters) {
                    var mappedUrlParamName = sdkParamUrlQueryParamMap[key];
                    if (resourceInfo.parameters[key] && !(parameters[key] || parameters[mappedUrlParamName])) {
                        parameters[key] = resourceInfo.parameters[key];
                    }
                }
            }
            if (operationType) {
                parameters.operationType = operationType;
            }
            return parameters;
        };
        this.getGenericResourceParams = function (resourceInfo, instance, operationType) {
            return _this.addGenericParameters({}, resourceInfo, operationType);
        };
        this.getResourceEndpointParams = function (resourceName, resourceInfo, instance, operationType) {
            var params = _this.addGenericParameters({}, resourceInfo, operationType);
            params.resourceName = resourceName;
            return params;
        };
        this.getOrderResourceEndpointParams = function (resourceInfo, instance, operationType) {
            return _this.getResourceEndpointParams("order", resourceInfo, instance, operationType);
        };
        this.getPaymentResourceParams = function (resourceInfo, instance, operationType) {
            instance = instance || {};
            var paymentMethod = instance.paymentMethod || {};
            return _this.addGenericParameters({
                family: paymentMethod.paymentMethodFamily,
                type: paymentMethod.paymentMethodType,
                country: ((instance.details || {}).address || {}).country
            }, resourceInfo, operationType);
        };
        this.resourceTypeToPidlDoc = {
            addressex: {
                description: "PIDL Service",
                getParams: this.getGenericResourceParams,
                operation: "GET Challenge PIDL",
                suffix: "Descriptions",
                template: "{pidl-endpoint}/users/{userId}/addressDescriptions"
            },
            challenge: {
                description: "PIDL Service",
                getParams: this.getGenericResourceParams,
                operation: "GET Challenge PIDL",
                suffix: "Descriptions",
                template: "{pidl-endpoint}/users/{userId}/challengeDescriptions"
            },
            order: {
                addResourceNameToQueryParam: true,
                description: "PIDL Service",
                getParams: this.getOrderResourceEndpointParams,
                operation: "GET Order resource PIDLs",
                suffix: "Descriptions",
                template: "{pidl-endpoint}/users/{userId}/resourceDescriptions"
            },
            paymentinstrument: {
                description: "PIDL Service",
                getParams: this.getPaymentResourceParams,
                operation: "GET Payment Instrument PIDL",
                suffix: "Descriptions",
                template: "{pidl-endpoint}/users/{userId}/paymentMethodDescriptions",
                anonymousTemplate: "{pidl-endpoint}/paymentMethodDescriptions"
            },
            paymentinstrumentlist: {
                description: "PIDL Service",
                getParams: this.getPaymentResourceParams,
                operation: "GET Payment Instrument PIDL",
                suffix: "Descriptions",
                template: "{pidl-endpoint}/users/{userId}/paymentInstrumentsEx",
                anonymousTemplate: "{pidl-endpoint}/paymentInstrumentsEx"
            },
            paymentmethod: {
                description: "PIDL Service",
                getParams: this.getPaymentResourceParams,
                operation: "GET Payment Method PIDL",
                suffix: "Descriptions",
                template: "{pidl-endpoint}/users/{userId}/paymentMethodDescriptions",
                anonymousTemplate: "{pidl-endpoint}/paymentMethodDescriptions"
            },
            payeetaxprofile: {
                description: "Payee Tax Profile PIDL Service",
                getParams: this.getPaymentResourceParams,
                operation: "GET Payee Tax Profile PIDL",
                suffix: "",
                template: "{payeetaxprofile-endpoint}/api/v1/getpidldocument",
                anonymousTemplate: "{payeetaxprofile-endpoint}/api/v1/getpidldocument",
                removeOperationParameter: true
            },
            msrewards: {
                description: "Rewards PIDL Service",
                getParams: this.getPaymentResourceParams,
                operation: "GET Rewards PIDL",
                suffix: "",
                template: "{pidl-endpoint}/users/{userId}/rewardsDescriptions",
                anonymousTemplate: "{pidl-endpoint}/rewardsDescriptions"
            },
            addpiqrcode: {
                description: "PIDL Service",
                getParams: this.getPaymentResourceParams,
                operation: "GET Anonymous Payment Instrument PIDL",
                suffix: "",
                template: "{pidl-endpoint}/paymentMethodDescriptions",
                anonymousTemplate: "{pidl-endpoint}/paymentMethodDescriptions",
            },
            default: {
                description: "PIDL Service",
                getParams: this.getGenericResourceParams,
                operation: "GET PIDL",
                suffix: "Descriptions",
                template: "{pidl-endpoint}/users/{userId}/{resourceType}",
                anonymousTemplate: "{pidl-endpoint}/{resourceType}"
            }
        };
        this.resourceTypeToResource = {
            paymentinstrument: {
                description: "Payment Instrument FD",
                operation: "GET Payment Instrument Resource",
                template: "{resource-endpoint}/users/{userId}/paymentInstrumentsEx/{id}"
            },
            paymentmethod: {
                description: "Payment Instrument FD",
                operation: "GET Payment Method Resource",
                template: "{resource-endpoint}/users/{userId}/paymentInstrumentsEx/{id}"
            },
            profile: {
                description: "Payment Instrument FD",
                operation: "GET Profile Resource",
                template: "{resource-endpoint}/users/{userId}/profiles/{id}"
            },
            address: {
                description: "Payment Instrument FD",
                operation: "GET Address Resource",
                template: "{resource-endpoint}/users/{userId}/addresses/{id}"
            },
            addressex: {
                description: "Payment Instrument FD",
                operation: "GET Address Resource",
                template: "{resource-endpoint}/users/{userId}/addressesEx/{id}"
            },
            legalentity: {
                description: "Jarvis FD",
                operation: "GET LegalEntity Profile Resource from Jarvis",
                template: "{jarvis-endpoint}/users/{userId}/profiles?type=legalentity"
            },
            billinggroup: {
                description: "HAPI Billing Groups",
                operation: "GET Billing Groups",
                template: "{hapi-endpoint}/{userId}/billinggroup"
            },
            wallettoken: {
                description: "PIDL Service",
                operation: "POST Provision Wallet Token",
                template: "{pifd-endpoint}/users/{userId}/provisionWalletToken"
            },
            default: {
                description: "Payment Instrument FD",
                operation: "GET Resource",
                template: "{resource-endpoint}/users/{userId}/{resourceType}/{id}"
            }
        };
        this.telemetryHeaders = {
            names: ["x-ms-operation-version", "x-ms-flight"],
            prefixes: ["x-ms-px"]
        };
        this.defaultTelemetryLoggerProperties = {
            enableMultipleLoggers: true
        };
        this.getServiceEndpoint = function (service) {
            return _this.serviceEndpoints[service];
        };
        this.getAlternateUrl = function (url) {
            if (url) {
                var protocol = "https://";
                var edgeDomain = "paymentsfd.cp.microsoft.com";
                var edgeAltDomain = "paymentsfd.signup.azure.com";
                var pifdDirect = protocol + _this.serviceEndpoints[_this.virtualEndpoints.pifd.endpoint];
                var pifdEdge = protocol + _this.serviceEndpoints[_this.virtualEndpoints.pifdEdge.endpoint];
                var pageHostName = ((window || {}).location || {}).hostname || "";
                // TODO: need to see if this special case for signup.azure.com subdomain is still needed
                if (pageHostName && pageHostName.indexOf("signup.azure.com") > -1) {
                    pifdEdge = pifdEdge.replace(edgeDomain, edgeAltDomain);
                }
                // Toggle url between direct endpoint vs AzureFD endpoint
                if (typehelper.startsWithIgnoreCase(url, pifdDirect)) {
                    url = url.replace(pifdDirect, pifdEdge);
                }
                else if (typehelper.startsWithIgnoreCase(url, pifdEdge)) {
                    url = url.replace(pifdEdge, pifdDirect);
                }
            }
            return url;
        };
        this.setEnv = function (env) {
            _this.updateEndpoints(env);
        };
        this.getEnv = function () {
            return _this.currentEnv;
        };
        this.updateEndpoints("prod");
    }
    return config;
}());
var config$1 = new config();

"use strict";
var DisplaySettings = /** @class */ (function () {
    function DisplaySettings(inputOptions) {
        this.alwaysValidateOnChange = false;
        this.busyBlockShowHideHandler = null;
        this.containerId = null;
        this.disableEnterKeyAction = false;
        this.disableFocusOnLoad = false;
        this.errorPrefix = htmlElementIdPrefixes.error;
        this.htmlExtender = null;
        this.hidePropertyErrors = false;
        this.showLogoInKeyField = null;
        this.showMandatoryIdentifier = { show: false, identifier: "*" };
        this.showPlaceholderInTextbox = false;
        this.ieExtender = null;
        this.propagateCallbackException = false;
        this.busyUntilInitialPageRendered = false;
        this.secureFieldPreLoadingEnabled = false;
        this.getAffixedPropertyElementId = null;
        this.getTrimmedPropertyElementId = null;
        this.getAffixedDisplayElementId = null;
        this.getTrimmedDisplayElementId = null;
        this.busyBlock = {
            id: htmlElementIdPrefixes.div + htmlElementIdSuffixes.pageBusyBlock,
            preExists: false,
            show: true
        };
        this.errorBlock = {
            id: htmlElementIdSuffixes.pageErrorBlock,
            preExists: false,
            show: true
        };
        this.helpDialogBlock = {
            id: htmlElementIdSuffixes.helpDialogBlock,
            preExists: false,
            show: true
        };
        this.logoBlock = {
            id: htmlElementIdSuffixes.pageLogoBlock,
            preExists: false,
            show: true,
            displayConfiguration: function (logoDescriptions, fillingLogoDialogBox) {
                var totalToShowDefault = 13;
                var validLogoDescriptions = logoDescriptions && logoDescriptions.length > 0 && logoDescriptions[0];
                var createDialog = !fillingLogoDialogBox && validLogoDescriptions && logoDescriptions[0].displayHelpName && logoDescriptions.length > totalToShowDefault;
                return {
                    totalToShow: createDialog ? totalToShowDefault : logoDescriptions.length,
                    dialogButtonText: createDialog ? logoDescriptions[0].displayHelpName : null
                };
            }
        };
        this.pageBodyBlock = {
            id: htmlElementIdSuffixes.pageBlock,
            preExists: false,
            show: true
        };
        this.submitButtonBlock = {
            id: htmlElementIdSuffixes.pageSubmitBlock,
            preExists: false,
            show: true
        };
        this.modalDialogBlock = {
            id: htmlElementIdSuffixes.modalDialogBlock,
            preExists: false,
            show: true
        };
        this.prefillCheckboxBlock = {
            id: htmlElementIdSuffixes.prefillCheckbox,
            preExists: false,
            show: true
        };
        var propertyElementIdPrefix = "pidlInput_";
        var propertyElementIdSuffix = "";
        var displayElementIdPrefix = "";
        var displayElementIdSuffix = "";
        // inputOptions are checked for valid options in input validation.
        // so no need to have error check for validity again in this method.
        for (var k in inputOptions) {
            switch (k) {
                case displayOptionNames.containerId:
                    this.containerId = inputOptions[k];
                    break;
                case displayOptionNames.busyBlockId:
                    this.setBlockId(this.busyBlock, inputOptions[k]);
                    break;
                case displayOptionNames.busyBlockShowHideHandler:
                    this.busyBlockShowHideHandler = inputOptions[k];
                    // No need to create busy block, as partner handler is responsible for creating, showing/hiding busy block.
                    this.busyBlock.preExists = true;
                    break;
                case displayOptionNames.inputPropertyIdPrefix:
                    propertyElementIdPrefix = inputOptions[k] || propertyElementIdPrefix;
                    break;
                case displayOptionNames.inputPropertyIdSuffix:
                    propertyElementIdSuffix = inputOptions[k] || propertyElementIdSuffix;
                    break;
                case displayOptionNames.displayElementIdPrefix:
                    displayElementIdPrefix = inputOptions[k] || displayElementIdPrefix;
                    break;
                case displayOptionNames.displayElementIdSuffix:
                    displayElementIdSuffix = inputOptions[k] || displayElementIdSuffix;
                    break;
                case displayOptionNames.inputPropertyErrorIdPrefix:
                    this.errorPrefix = inputOptions[k];
                    break;
                case displayOptionNames.showPlaceholderInTextbox:
                    this.showPlaceholderInTextbox = utils.getBoolValue(inputOptions[k]);
                    break;
                case displayOptionNames.disableEnterKeyAction:
                    this.disableEnterKeyAction = utils.getBoolValue(inputOptions[k]);
                    break;
                case displayOptionNames.showSubmitBlock:
                    this.setShowBlock(this.submitButtonBlock, inputOptions[k]);
                    break;
                case displayOptionNames.showErrorBlock:
                    this.setShowBlock(this.errorBlock, inputOptions[k]);
                    break;
                case displayOptionNames.hidePropertyErrors:
                    this.hidePropertyErrors = utils.getBoolValue(inputOptions[k]);
                    break;
                case displayOptionNames.htmlExtender:
                    this.htmlExtender = inputOptions[k];
                    break;
                case displayOptionNames.disableFocusOnLoad:
                    this.disableFocusOnLoad = utils.getBoolValue(inputOptions[k]);
                    break;
                case displayOptionNames.alwaysValidateOnChange:
                    this.alwaysValidateOnChange = utils.getBoolValue(inputOptions[k]);
                    break;
                case displayOptionNames.ieExtender:
                    this.ieExtender = inputOptions[k];
                    break;
                case displayOptionNames.propagateCallbackException:
                    this.propagateCallbackException = utils.getBoolValue(inputOptions[k]);
                    break;
                case displayOptionNames.busyUntilInitialPageRendered:
                    this.busyUntilInitialPageRendered = utils.getBoolValue(inputOptions[k]);
                    break;
                case displayOptionNames.secureFieldPreLoadingEnabled:
                    this.secureFieldPreLoadingEnabled = utils.getBoolValue(inputOptions[k]);
                    break;
            }
        }
        this.getAffixedPropertyElementId = this.getAffixesAttacher(propertyElementIdPrefix, propertyElementIdSuffix);
        this.getTrimmedPropertyElementId = this.getAffixesRemover(propertyElementIdPrefix, propertyElementIdSuffix);
        this.getAffixedDisplayElementId = this.getAffixesAttacher(displayElementIdPrefix, displayElementIdSuffix);
        this.getTrimmedDisplayElementId = this.getAffixesRemover(displayElementIdPrefix, displayElementIdSuffix);
    }
    DisplaySettings.prototype.setBlockId = function (block, id) {
        block.id = id;
        block.preExists = true;
    };
    DisplaySettings.prototype.setShowBlock = function (block, showBlock) {
        block.show = utils.getBoolValue(showBlock);
    };
    DisplaySettings.prototype.getAffixesAttacher = function (prefix, suffix) {
        return function (word) {
            return typehelper.attachAffixes(prefix, word, suffix);
        };
    };
    DisplaySettings.prototype.getAffixesRemover = function (prefix, suffix) {
        return function (word) {
            return typehelper.removeAffixes(prefix, word, suffix);
        };
    };
    return DisplaySettings;
}());

"use strict";
// No-op function for silently ignoring rejections
// USE CAREFULLY! These can swallow exceptions in promise chains
var doNothing = function () { };
var throwException = function (e) { throw e; };
function createFakePromise(result) {
    return Promise.resolve(result);
}
function createFakeRejectedPromise(reason) {
    return Promise.reject(reason);
}

var promise = /*#__PURE__*/Object.freeze({
	__proto__: null,
	doNothing: doNothing,
	throwException: throwException,
	createFakePromise: createFakePromise,
	createFakeRejectedPromise: createFakeRejectedPromise
});

"use strict";
var EventHub = /** @class */ (function () {
    function EventHub(telemetryLogger, telemetryContext) {
        var _this = this;
        this.returnUrls = {};
        this.returnCallbacks = {};
        this.publicEventHandlers = [];
        this.privateEventHandlers = [];
        this.eventParameterExtenders = {};
        this.telemetryContext = null;
        this.telemetryLogger = null;
        this.invokeReturnCallback = function (returnCallback, parameters) {
            parameters = _this.extendEventParameters(parameters);
            returnCallback(parameters);
        };
        this.invokePublicEvent = function (eventName, message, parameters, telemetryParameters) {
            if (message) {
                _this.logMessage(eventName, message);
            }
            return _this.invokeEventHandlers(_this.publicEventHandlers, eventName, parameters, telemetryParameters);
        };
        this.invokePrivateEvent = function (eventName, message, parameters, telemetryParameters) {
            if (message && ((_this.telemetryContext && _this.telemetryContext.enablePrivateEventConsoleLogging) || (!_this.telemetryContext))) {
                _this.logMessage(eventName, message);
            }
            return _this.invokeEventHandlers(_this.privateEventHandlers, eventName, parameters, telemetryParameters);
        };
        this.isEventConsoleLoggingEnabled = function (eventName) {
            var _a = (_this.telemetryContext || {}).telemetryOverrides, telemetryOverrides = _a === void 0 ? null : _a;
            return ((_this.telemetryContext && _this.telemetryContext.enableConsoleLogging) || (!_this.telemetryContext)) && !(telemetryOverrides && telemetryOverrides[eventName] && telemetryOverrides[eventName].disableConsoleLogging);
        };
        this.logMessage = function (eventName, message) {
            if (_this.isEventConsoleLoggingEnabled(eventName)) {
                var loggingService = iocContainer$1.getLoggingService();
                if (loggingService) {
                    loggingService.logMessage(_this.addExtendedParametersToLogMessage(message));
                }
            }
        };
        this.logError = function (eventName, type, errorObject) {
            if (_this.isEventConsoleLoggingEnabled(eventName)) {
                var loggingService = iocContainer$1.getLoggingService();
                if (loggingService) {
                    loggingService.logError(type, errorObject);
                }
            }
        };
        this.getExtendedEventParameter = function (key) {
            return _this.eventParameterExtenders[key]();
        };
        this.extendEventParameters = function (parameters) {
            // Do not use deep copy and pass them by reference here as individual property of the
            // parameters might be individual objects, which might get
            // updated by partner handlers in certain events (like propertyCreating)
            var updatedParameters = {};
            for (var name_1 in parameters) {
                if (parameters.hasOwnProperty(name_1)) {
                    updatedParameters[name_1] = parameters[name_1];
                }
            }
            for (var key in _this.eventParameterExtenders) {
                if (_this.eventParameterExtenders.hasOwnProperty(key) && !updatedParameters.hasOwnProperty(key)) {
                    updatedParameters[key] = _this.getExtendedEventParameter(key);
                }
            }
            updatedParameters = utils.createObjectWithNonNullProperties(updatedParameters);
            return updatedParameters;
        };
        this.addExtendedParametersToUrl = function (url) {
            for (var key in _this.eventParameterExtenders) {
                if (_this.eventParameterExtenders.hasOwnProperty(key)) {
                    url = urlBuilder$1.addQueryParameter(url, key, _this.getExtendedEventParameter(key));
                }
            }
            return url;
        };
        this.addExtendedParametersToLogMessage = function (message) {
            for (var key in _this.eventParameterExtenders) {
                if (_this.eventParameterExtenders.hasOwnProperty(key)) {
                    message += ", ".concat(key, "=").concat(_this.getExtendedEventParameter(key));
                }
            }
            return message;
        };
        this.redirectUrl = function (url) {
            if (url) {
                iocContainer$1.getRedirectionService().redirect(url);
            }
        };
        this.isEventTelemetryEnabled = function (eventName) {
            var _a = (_this.telemetryContext || {}).telemetryOverrides, telemetryOverrides = _a === void 0 ? null : _a;
            return !(telemetryOverrides && telemetryOverrides[eventName] && telemetryOverrides[eventName].disableLogging);
        };
        this.logTelemetryEvent = function (eventName, parameters) {
            if (_this.telemetryLogger && _this.telemetryContext && _this.telemetryContext.enableLogging) {
                // filter events.
                if ((eventName === eventNames.propertyValidated || eventName === eventNames.error) &&
                    parameters &&
                    parameters.controlOperationType === controlOperationTypes.editing) {
                    return;
                }
                if (_this.isEventTelemetryEnabled(eventName)) {
                    _this.telemetryLogger.logEvent(eventName, parameters, _this.telemetryContext);
                }
            }
        };
        this.getCorrelationId = function () {
            return _this.telemetryLogger && _this.telemetryLogger.getCorrelationId && _this.telemetryLogger.getCorrelationId();
        };
        this.getHttpRequestCorrelationHeader = function () {
            if (_this.telemetryLogger && _this.telemetryLogger.getHttpRequestCorrelationHeader) {
                return _this.telemetryLogger.getHttpRequestCorrelationHeader();
            }
        };
        this.getCorrelationContextHeaderValue = function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var _h = (_a = _this.telemetryContext) === null || _a === void 0 ? void 0 : _a.partnerContext, partnerName = _h.partnerName, scenarioId = _h.scenarioId, sessionId = _h.sessionId;
            // If partner context doesn't have these values, try to infer them from other places
            if (!partnerName && ((_c = (_b = _this.telemetryContext) === null || _b === void 0 ? void 0 : _b.telemetryResource) === null || _c === void 0 ? void 0 : _c.parameters.hasOwnProperty("partner"))) {
                partnerName = _this.telemetryContext.telemetryResource.parameters["partner"];
            }
            if (!sessionId) {
                sessionId = (_d = _this.telemetryContext) === null || _d === void 0 ? void 0 : _d.sessionId;
            }
            if (!scenarioId) {
                scenarioId = "commerce.payments.".concat((_f = (_e = _this.telemetryContext) === null || _e === void 0 ? void 0 : _e.telemetryResource) === null || _f === void 0 ? void 0 : _f.resourceType).concat((_g = _this.telemetryContext) === null || _g === void 0 ? void 0 : _g.operationType, ".1");
            }
            var correlationContext = "v=1,ms.b.tel.scenario=".concat(scenarioId, ",ms.b.tel.partner=").concat(partnerName, ",ms.c.cfs.payments.partnerSessionId=").concat(sessionId);
            return correlationContext;
        };
        this.getSessionId = function () {
            var _a;
            return (_a = _this.telemetryContext) === null || _a === void 0 ? void 0 : _a.sessionId;
        };
        this.getPidlSdkVersionHeaderValue = function () {
            var _a, _b;
            return "".concat((_a = _this.telemetryContext) === null || _a === void 0 ? void 0 : _a.sdkVersion, "_").concat((_b = _this.telemetryContext) === null || _b === void 0 ? void 0 : _b.sdkViewType);
        };
        this.updateTelemetryContext = function (resourceIdentity) {
            if (_this.telemetryContext && resourceIdentity) {
                // TODO: Fix the type for parameters below
                _this.telemetryContext.updateResourceInfo({ resourceType: undefined, parameters: resourceIdentity });
            }
        };
        this.invokeEventHandlers = function (eventHandlers, eventName, parameters, telemetryParameters) {
            _this.logTelemetryEvent(eventName, _this.extendEventParameters(telemetryParameters));
            var eventParameters = _this.extendEventParameters(parameters);
            var returnVal = false;
            // TODO: This check is not needed for production. But unittests call this functions with different
            // arguments. Needs to remove this after fixing unit tests.
            if (eventHandlers) {
                eventHandlers.forEach(function (eventHandler) {
                    returnVal = eventHandler(eventName, eventParameters) || returnVal;
                });
                return returnVal;
            }
        };
        this.addReturnOptions = function (returnOptions) {
            _this.returnUrls = returnOptions.urls ? __assign({}, returnOptions.urls) : {};
            _this.returnCallbacks = returnOptions.callbacks ? __assign({}, returnOptions.callbacks) : {};
        };
        this.addPublicEventHandler = function (handler) {
            _this.publicEventHandlers.push(handler);
        };
        this.addPrivateEventHandler = function (handler) {
            _this.privateEventHandlers.push(handler);
        };
        this.registerEventExtender = function (parameterName, valueProvider) {
            if (_this.eventParameterExtenders.hasOwnProperty(parameterName)) {
                _this.logMessage(privateEventNames.eventExtenderRegistered, "There is an existing event parameter extender for name ".concat(parameterName));
                return;
            }
            _this.eventParameterExtenders[parameterName] = valueProvider;
        };
        this.failure = function (errorObject) {
            errorObject.cv = _this.getCorrelationId();
            _this.invokePrivateEvent(privateEventNames.failure, null, { error: errorObject }, { error: errorObject });
            _this.logError(privateEventNames.failure, "failure", errorObject);
            var returnHandler = _this.returnCallbacks[returnCallbackNames.failure];
            if (returnHandler) {
                _this.invokeReturnCallback(returnHandler, { error: errorObject, cv: _this.getCorrelationId() });
                return;
            }
            var failure = _this.returnUrls.failure;
            if (failure) {
                var url = failure;
                if (errorObject) {
                    url = urlBuilder$1.addQueryParameter(url, "errormessage", errorObject.message);
                }
                _this.redirectUrl(_this.addExtendedParametersToUrl(url));
            }
            else {
                throw errorObject;
            }
        };
        this.success = function (params) {
            params = params || {};
            params.cv = _this.getCorrelationId();
            _this.logMessage(privateEventNames.success, "Successfully completed operation: ".concat(params.operationType, ". Id: ").concat(params.id));
            _this.invokePrivateEvent(privateEventNames.success, null, { operationId: params.id, operationType: params.operationType }, { operationId: params.id, operationType: params.operationType });
            var returnHandler = _this.returnCallbacks[returnCallbackNames.success];
            if (returnHandler) {
                _this.invokeReturnCallback(returnHandler, params);
                return;
            }
            var success = _this.returnUrls.success;
            if (success) {
                var url = success;
                if (params.id) {
                    url = urlBuilder$1.addQueryParameter(url, "id", params.id);
                }
                _this.redirectUrl(_this.addExtendedParametersToUrl(url));
            }
        };
        this.gohome = function () {
            _this.logMessage(privateEventNames.gohome, "Going to call go-home");
            _this.invokePrivateEvent(privateEventNames.gohome);
            var returnHandler = _this.returnCallbacks[returnCallbackNames.gohome];
            if (returnHandler) {
                _this.invokeReturnCallback(returnHandler, { cv: _this.getCorrelationId() });
                return;
            }
            var gohome = _this.returnUrls.gohome;
            if (gohome) {
                _this.redirectUrl(_this.addExtendedParametersToUrl(_this.returnUrls.gohome));
            }
        };
        this.notifyNoSelectionOptionsFound = function (id, displayId, pidlIdentity, propertyType) {
            _this.invokePublicEvent(eventNames.noSelectionOptionsFound, "No Data found in element id: ".concat(id, " of type: ").concat(propertyType, " and of displayId: ").concat(displayId), { id: id, displayId: displayId, pidlIdentity: pidlIdentity, propertyType: propertyType }, { id: id, displayId: displayId, pidlIdentity: pidlIdentity, propertyType: propertyType });
        };
        this.selectionChanged = function (propertyName, displayId, propertyValue) {
            _this.invokePublicEvent(eventNames.selectionChanged, "selection changed for ".concat(propertyName, " and display id ").concat(displayId), { propertyName: propertyName, displayId: displayId, propertyValue: propertyValue }, { propertyName: propertyName, displayId: displayId });
        };
        this.error = function (error, controlOperationType) {
            _this.logError(eventNames.error, "error", error);
            error.cv = _this.getCorrelationId();
            _this.invokePublicEvent(eventNames.error, null, { error: error }, { error: error, controlOperationType: controlOperationType });
        };
        this.apiCalled = function (name, parametersPassed, sanitizedParameters) {
            _this.invokePrivateEvent(privateEventNames.apiCalled, "API called. name: ".concat(name), { name: name }, { name: name, parametersPassed: parametersPassed, sanitizedParameters: sanitizedParameters });
        };
        this.apiReturned = function (name, succeeded, promise$1) {
            if (!promise$1) {
                promise$1 = createFakePromise();
            }
            _this.invokePrivateEvent(privateEventNames.apiReturned, "API returned. name: ".concat(name), { name: name, succeeded: succeeded, promise: promise$1 }, { name: name, succeeded: typehelper.boolify(succeeded) });
        };
        this.secureFieldLoadWaitStarted = function () {
            _this.invokePrivateEvent(privateEventNames.secureFieldLoadWaitStarted);
        };
        this.secureFieldsLoaded = function () {
            _this.invokePrivateEvent(privateEventNames.secureFieldsLoaded);
        };
        this.secureFieldLoadWaitEnded = function () {
            _this.invokePrivateEvent(privateEventNames.secureFieldLoadWaitEnded);
        };
        this.secureFieldEventReceived = function (fieldName, event, correlationId) {
            _this.invokePrivateEvent(privateEventNames.secureFieldEventReceived, "secureField event received", { fieldName: fieldName, event: event, correlationId: correlationId }, { fieldName: fieldName, event: event, correlationId: correlationId });
        };
        this.secureFieldEventQueued = function (fieldName, event, correlationId) {
            _this.invokePrivateEvent(privateEventNames.secureFieldEventQueued, "secureField event queued", { fieldName: fieldName, event: event, correlationId: correlationId }, { fieldName: fieldName, event: event, correlationId: correlationId });
        };
        this.secureFieldEventPosted = function (fieldName, event, correlationId) {
            _this.invokePrivateEvent(privateEventNames.secureFieldEventPosted, "secureField event posted", { fieldName: fieldName, event: event, correlationId: correlationId }, { fieldName: fieldName, event: event, correlationId: correlationId });
        };
        this.addSecureFieldPreLoadIFrameStarted = function () {
            _this.invokePrivateEvent(privateEventNames.addSecureFieldPreLoadIFrameStarted);
        };
        this.addSecureFieldPreLoadIFrameCompleted = function () {
            _this.invokePrivateEvent(privateEventNames.addSecureFieldPreLoadIFrameCompleted);
        };
        this.addSecureFieldPreLoadIFrameFailed = function (errorMessage) {
            _this.invokePrivateEvent(privateEventNames.addSecureFieldPreLoadIFrameFailed, errorMessage);
        };
        this.challengeMessageReceived = function (event) {
            _this.invokePublicEvent(eventNames.challengeMessageReceived, "challengeMessage received", { event: event }, { event: event });
        };
        this.postMessageReceived = function (origin, expectedOrigin, dataLength) {
            _this.invokePrivateEvent(privateEventNames.postMessageReceived, "postMessage received", { origin: origin, expectedOrigin: expectedOrigin, dataLength: dataLength }, { origin: origin, expectedOrigin: expectedOrigin, dataLength: dataLength });
        };
        this.postMessageHandleSuccess = function (actionType) {
            _this.invokePrivateEvent(privateEventNames.postMessageHandleSuccess, "postMessage handle success", { actionType: actionType }, { actionType: actionType });
        };
        this.postMessageHandleFailure = function (failureDetails) {
            _this.invokePrivateEvent(privateEventNames.postMessageHandleFailure, "postMessage handle failed", { failureDetails: failureDetails }, { failureDetails: failureDetails });
        };
        this.postMessageTimeoutHandleSuccess = function (actionType) {
            _this.invokePrivateEvent(privateEventNames.postMessageTimeoutHandleSuccess, "postMessageTimeout handle success", { actionType: actionType }, { actionType: actionType });
        };
        this.postMessageTimeoutHandleFailure = function (failureDetails) {
            _this.invokePrivateEvent(privateEventNames.postMessageTimeoutHandleFailure, "postMessageTimeout handle failed", { failureDetails: failureDetails }, { failureDetails: failureDetails });
        };
        this.postMessageBusyTimerStarted = function (details) {
            _this.invokePrivateEvent(privateEventNames.postMessageBusyTimerStarted, "postMessage busy timer started", { details: details }, { details: details });
        };
        this.postMessageBusyTimerEnded = function (details) {
            _this.invokePrivateEvent(privateEventNames.postMessageBusyTimerEnded, "postMessage busy timer ended", { details: details }, { details: details });
        };
        this.resourceHelpersFunctionExecuted = function (functionName, inputParams, outputValue) {
            _this.invokePrivateEvent(privateEventNames.resourceHelpersFunctionExecuted, "Executed Resource Helper Function ".concat(functionName), { functionName: functionName, inputParams: inputParams, outputValue: outputValue }, { functionName: functionName, inputParams: inputParams, outputValue: outputValue });
        };
        this.fetchCallCompleted = function (httpRequestTelemetryData) {
            _this.invokePublicEvent(eventNames.fetchCallCompleted, "Fetch call completed", { httpRequestTelemetryData: httpRequestTelemetryData }, { httpRequestTelemetryData: httpRequestTelemetryData });
        };
        this.toggleClicked = function (propertyName, currentValue) {
            _this.invokePublicEvent(eventNames.toggleClicked, "Toggle clicked for property: ".concat(propertyName, ", current value: ").concat(currentValue), { propertyName: propertyName, currentValue: currentValue }, { propertyName: propertyName, currentValue: currentValue });
        };
        this.propertySelected = function (id, propertyName, divId) {
            _this.invokePublicEvent(eventNames.propertySelected, "Input selected. id: ".concat(id), { id: id, propertyName: propertyName, divId: divId }, { id: id, propertyName: propertyName });
        };
        this.propertyValidated = function (propertyName, controlOperationType) {
            _this.invokePublicEvent(eventNames.propertyValidated, "Property validation succeeded for property ".concat(propertyName), { propertyName: propertyName, controlOperationType: controlOperationType }, { propertyName: propertyName, controlOperationType: controlOperationType });
        };
        this.resourceSelected = function (resourceName, value) {
            var _a;
            _this.invokePublicEvent(eventNames.resourceSelected, "Resource selected ".concat(resourceName), { resourceName: resourceName, value: value }, { resourceName: resourceName, id: value && value.id, isWalletCard: !!((_a = value === null || value === void 0 ? void 0 : value.details) === null || _a === void 0 ? void 0 : _a.isNotSaved) }); // isNotSaved is only true for imported wallet cards
        };
        this.instanceDownloading = function (url) {
            _this.invokePublicEvent(eventNames.instanceDownloading, "Downloading instance from url: ".concat(url), { url: url }, { url: url });
        };
        this.instanceDownloaded = function () {
            _this.invokePublicEvent(eventNames.instanceDownloaded, "Downloaded instance");
        };
        this.pidlDownloading = function (url) {
            _this.invokePublicEvent(eventNames.pidlDownloading, "Downloading PIDL document from url: ".concat(url), { url: url }, { url: url });
        };
        this.pidlDownloaded = function () {
            _this.invokePublicEvent(eventNames.pidlDownloaded, "PIDL document successfully downloaded");
        };
        this.pageRendering = function (successPayload) {
            _this.invokePublicEvent(eventNames.pageRendering, "PIDL document rendering begins", { successPayload: successPayload }, {});
        };
        this.pageRendered = function (prevPageIndex, prevPageId, prevPageName, currentPageIndex, currentPageId, currentPageName, currentPageDescription) {
            _this.invokePublicEvent(eventNames.pageRendered, "PIDL document rendered", { prevPageIndex: prevPageIndex, prevPageId: prevPageId, prevPageName: prevPageName, currentPageIndex: currentPageIndex, currentPageId: currentPageId, currentPageName: currentPageName, currentPageDescription: currentPageDescription }, { prevPageIndex: prevPageIndex, prevPageId: prevPageId, prevPageName: prevPageName, currentPageIndex: currentPageIndex, currentPageId: currentPageId, currentPageName: currentPageName });
        };
        this.pageRefreshed = function () {
            _this.invokePublicEvent(eventNames.pageRefreshed, "PIDL document refreshed");
        };
        this.pageDisplayed = function () {
            _this.invokePublicEvent(eventNames.pageDisplayed, "PIDL document displayed");
        };
        this.inputReading = function () {
            _this.invokePublicEvent(eventNames.inputReading, "Reading user input data");
        };
        this.inputRead = function () {
            _this.invokePublicEvent(eventNames.inputRead, "Read user input data");
        };
        this.inputValidating = function () {
            _this.invokePublicEvent(eventNames.inputValidating, "Validating user input data");
        };
        this.inputValidated = function () {
            _this.invokePublicEvent(eventNames.inputValidated, "Validated user input data");
        };
        this.inputTokenizing = function () {
            _this.invokePublicEvent(eventNames.inputTokenizing, "Tokenizing user input data");
        };
        this.inputTokenized = function () {
            _this.invokePublicEvent(eventNames.inputTokenized, "Tokenized user input data");
        };
        this.submitting = function () {
            _this.invokePrivateEvent(privateEventNames.submitting);
        };
        this.submitted = function () {
            _this.invokePrivateEvent(privateEventNames.submitted);
        };
        this.implementationMissing = function (source, component, parameters) {
            _this.invokePublicEvent(eventNames.implementationMissing, "Implentation of ".concat(component !== null && component !== void 0 ? component : "undefined", " missing in ").concat(source), parameters);
        };
        this.inputSubmitting = function (url) {
            _this.invokePublicEvent(eventNames.inputSubmitting, "Submitting PIDL document: ".concat(url), { url: url }, { url: url });
        };
        this.inputSubmitted = function (clientAction) {
            _this.invokePublicEvent(eventNames.inputSubmitted, "PIDL document submitted. Next action: ".concat(clientAction), { clientAction: clientAction }, { clientAction: clientAction });
        };
        this.propertyTokenizing = function (propertyName, url) {
            _this.invokePublicEvent(eventNames.propertyTokenizing, "Tokenizing property: ".concat(propertyName), { propertyName: propertyName, url: url }, { propertyName: propertyName, url: url });
        };
        this.propertyTokenized = function (propertyName) {
            _this.invokePublicEvent(eventNames.propertyTokenized, "Tokenized property: ".concat(propertyName), { propertyName: propertyName }, { propertyName: propertyName });
        };
        this.propertyTransforming = function (propertyName) {
            _this.invokePublicEvent(eventNames.propertyTransforming, "Transforming property: ".concat(propertyName), { propertyName: propertyName }, { propertyName: propertyName });
        };
        this.propertyTransformed = function (propertyName) {
            _this.invokePublicEvent(eventNames.propertyTransformed, "Transformed property: ".concat(propertyName), { propertyName: propertyName }, { propertyName: propertyName });
        };
        this.fileUploading = function (propertyName, url) {
            _this.invokePublicEvent(eventNames.fileUploading, "File uploading property: ".concat(propertyName), { propertyName: propertyName, url: url }, { propertyName: propertyName, url: url });
        };
        this.fileUploaded = function (propertyName) {
            _this.invokePublicEvent(eventNames.fileUploaded, "File uploaded property: ".concat(propertyName), { propertyName: propertyName }, { propertyName: propertyName });
        };
        this.styleSheetError = function (error, href) {
            _this.invokePublicEvent(eventNames.styleSheetError, "Failed to read the cssRules property from: ".concat(href), { error: error }, { error: error });
        };
        this.redirecting = function (url) {
            _this.invokePublicEvent(eventNames.redirecting, "Redirecting to url: ".concat(url), { url: url }, { url: url });
        };
        this.navigate = function (displayId, url, piRedirection, context, dest, destinationId) {
            var verb = piRedirection ? "Redirect" : "Navigate";
            return _this.invokePublicEvent(eventNames.navigate, "".concat(verb, " to url: ").concat(url), { displayId: displayId, dest: dest || displayId, url: url, piRedirection: piRedirection, context: context, destinationId: destinationId }, { displayId: displayId, dest: dest || displayId, url: url, piRedirection: piRedirection, destinationId: destinationId });
        };
        this.triggerEvent = function (eventName, params) {
            return _this.invokePublicEvent(eventNames.triggerEvent, "Event triggered: ".concat(eventName), { eventName: eventName, params: params }, { eventName: eventName, params: params });
        };
        this.partnerAction = function (displayId, context) {
            return _this.invokePublicEvent(eventNames.partnerAction, "Invoke partner action on Id: ".concat(displayId), { displayId: displayId, context: context }, { displayId: displayId });
        };
        this.pageNavigated = function (prevPageIndex, prevPageId, prevPageName, currentPageIndex, currentPageId, currentPageName, currentPageDescription) {
            _this.invokePublicEvent(eventNames.pageNavigated, "Navigating from page: ".concat(prevPageIndex, " to: ").concat(currentPageIndex), { prevPageIndex: prevPageIndex, prevPageId: prevPageId, prevPageName: prevPageName, currentPageIndex: currentPageIndex, currentPageId: currentPageId, currentPageName: currentPageName, currentPageDescription: currentPageDescription }, { prevPageIndex: prevPageIndex, prevPageId: prevPageId, prevPageName: prevPageName, currentPageIndex: currentPageIndex, currentPageId: currentPageId, currentPageName: currentPageName });
        };
        this.click = function (id) {
            _this.invokePublicEvent(eventNames.click, "Click display control for button with id ".concat(id), { id: id }, { id: id });
        };
        this.captchaRendered = function (id) {
            _this.invokePublicEvent(eventNames.captchaRendered, "Captcha is rendered with id ".concat(id), { id: id }, { id: id });
        };
        this.propertyCreating = function (id, displayDescription, htmlAttributes) {
            _this.invokePublicEvent(eventNames.propertyCreating, "Creating control with id ".concat(id), { id: id, displayDescription: displayDescription, htmlAttributes: htmlAttributes }, { id: id });
        };
        this.payloadCreated = function (value) {
            _this.invokePublicEvent(eventNames.payloadCreated, "Pidl payload created", { value: value }, {});
        };
        this.restMethodInvoking = function (requestUrl, operationType) {
            _this.invokePublicEvent(eventNames.restMethodInvoking, "invoking rest method with requestUrl: ".concat(requestUrl, " operationType: ").concat(operationType), { requestUrl: requestUrl, operationType: operationType }, { requestUrl: requestUrl, operationType: operationType });
        };
        this.restMethodInvoked = function (requestUrl) {
            _this.invokePublicEvent(eventNames.restMethodInvoked, "rest method invoked, request url: ".concat(requestUrl), { requestUrl: requestUrl }, { requestUrl: requestUrl });
        };
        this.propertyConditionallyUpdated = function (propertyName, propertyValue) {
            _this.invokePublicEvent(eventNames.propertyConditionallyUpdated, "Property ".concat(propertyName, " has been conditionally updated to ").concat(propertyValue), { propertyName: propertyName, propertyValue: propertyValue }, { propertyName: propertyName, propertyValue: propertyValue });
        };
        this.pidlResolved = function (context, resolvedPidlDocs) {
            var resolvedPidlIds = [];
            if (resolvedPidlDocs) {
                resolvedPidlIds = resolvedPidlDocs.map(function (resolvedPidlDoc) { return pidlDocHelper$1.createIdentityHash(resolvedPidlDoc.identity); });
            }
            var resolvedPidlIdentity = typehelper.serialize(resolvedPidlIds);
            _this.invokePrivateEvent(privateEventNames.pidlResolved, "PIDL document resolved successfully for context: ".concat(context, ". Pidl Identities ").concat(resolvedPidlIdentity), { context: context, resolvedPidlIdentity: resolvedPidlIdentity }, {});
        };
        this.propertyUnselected = function (id, propertyName, divId) {
            _this.invokePrivateEvent(privateEventNames.propertyUnselected, null, { id: id, propertyName: propertyName, divId: divId }, { id: id, propertyName: propertyName });
        };
        this.propertyCreated = function (propertyName, controlId, divId) {
            _this.invokePrivateEvent(privateEventNames.propertyCreated, null, { propertyName: propertyName, controlId: controlId, divId: divId }, { propertyName: propertyName, controlId: controlId });
        };
        this.pollingStarted = function (id) {
            _this.invokePrivateEvent(privateEventNames.pollingStarted, null, { id: id }, { id: id });
        };
        this.pollingEnded = function (id) {
            _this.invokePrivateEvent(privateEventNames.pollingEnded, null, { id: id }, { id: id });
        };
        this.updatePollAndMoveLast = function (pollId) {
            _this.invokePrivateEvent(privateEventNames.updatePollAndMoveLast, null, { pollId: pollId });
        };
        this.modelUpdated = function (created, skipHideBusyBlock) {
            _this.invokePrivateEvent(privateEventNames.modelUpdated, null, { created: created, skipHideBusyBlock: skipHideBusyBlock }, { created: created, skipHideBusyBlock: skipHideBusyBlock });
        };
        this.dataUpdated = function () {
            _this.invokePrivateEvent(privateEventNames.dataUpdated);
        };
        this.conflictingInputValues = function (propertyName) {
            _this.invokePrivateEvent(privateEventNames.conflictingInputValues, null, { propertyName: propertyName }, { propertyName: propertyName });
        };
        this.stateChanged = function (oldState, newState) {
            _this.invokePrivateEvent(privateEventNames.stateChanged, null, { oldState: oldState, newState: newState }, { oldState: oldState, newState: newState });
        };
        this.testHookGetInternalState = function () {
            return {
                returnUrls: _this.returnUrls,
                returnCallbacks: _this.returnCallbacks,
                publicEventHandlers: _this.publicEventHandlers,
                privateEventHandlers: _this.privateEventHandlers,
                eventParameterExtenders: _this.eventParameterExtenders,
                telemetryContext: _this.telemetryContext,
                telemetryLogger: _this.telemetryLogger
            };
        };
        this.pollClientActionSuccess = function (actionType) {
            _this.invokePrivateEvent(privateEventNames.pollClientActionSuccess, "handle client action succeeded during polling", { actionType: actionType }, { actionType: actionType });
        };
        this.pollClientActionFailure = function (failureDetails) {
            _this.invokePrivateEvent(privateEventNames.pollClientActionFailure, "handle client action failed during polling", { failureDetails: failureDetails }, { failureDetails: failureDetails });
        };
        this.hideModalDialog = function () {
            _this.invokePrivateEvent(privateEventNames.hideModalDialog);
        };
        this.pidlActionInvoked = function (actionName, actionContext) {
            _this.invokePrivateEvent(privateEventNames.pidlActionInvoked, "PidlAction ".concat(actionName, " invoked"), { actionName: actionName, actionContext: actionContext }, { actionName: actionName, actionContext: actionContext });
        };
        this.clientActionInvoked = function (actionName, actionContext) {
            _this.invokePrivateEvent(privateEventNames.clientActionInvoked, "ClientAction ".concat(actionName, " invoked"), { actionName: actionName, actionContext: actionContext }, { actionName: actionName, actionContext: actionContext });
        };
        this.propertyValueSelected = function (propertyName, propertyValue) {
            _this.invokePrivateEvent(privateEventNames.propertyValueSelected, "Property ".concat(propertyName, " has the selected value ").concat(propertyValue), { propertyName: propertyName, propertyValue: propertyValue }, { propertyName: propertyName, propertyValue: propertyValue });
        };
        this.renderedPidlPage = function () {
            _this.invokePublicEvent(eventNames.renderedPidlPage, "Rendered PidlPage");
        };
        this.closePidlPage = function () {
            _this.invokePublicEvent(eventNames.closePidlPage, "Closed PidlPage");
        };
        this.submitOriginalPidl = function () {
            _this.invokePublicEvent(eventNames.submitOriginalPidl, "Submit Original Pidl Action");
        };
        this.getLocalDataSourceInvoked = function (dataSourceName) {
            _this.invokePublicEvent(eventNames.getLocalDataSourceInvoked, "getDataSource of ".concat(dataSourceName, " invoked"), { dataSourceName: dataSourceName }, { dataSourceName: dataSourceName });
        };
        this.getLocalDataSourceResolved = function (dataSourceName, dataSourceValuesCount) {
            _this.invokePublicEvent(eventNames.getLocalDataSourceResolved, "getDataSource of ".concat(dataSourceName, " resolved"), { dataSourceName: dataSourceName, count: dataSourceValuesCount }, { dataSourceName: dataSourceName, count: dataSourceValuesCount });
        };
        this.getLocalDataSourceError = function (dataSourceName, errorObject) {
            _this.logError(eventNames.error, "error", errorObject);
            errorObject.cv = _this.getCorrelationId();
            _this.invokePublicEvent(eventNames.getLocalDataSourceError, "getDataSource of ".concat(dataSourceName, " error"), { dataSourceName: dataSourceName, errorObject: errorObject }, { dataSourceName: dataSourceName, errorObject: errorObject });
        };
        this.telemetryContext = telemetryContext;
        this.telemetryLogger = telemetryLogger;
    }
    return EventHub;
}());

var EncryptionTypes;
(function (EncryptionTypes) {
    EncryptionTypes[EncryptionTypes["PayPal"] = 0] = "PayPal";
    EncryptionTypes[EncryptionTypes["Tokenization"] = 1] = "Tokenization";
})(EncryptionTypes || (EncryptionTypes = {}));
var PaymentMethodPIIDs$1;
(function (PaymentMethodPIIDs) {
    PaymentMethodPIIDs["googlePay"] = "cdc85313-9b57-4052-81fb-dea336132cbf";
    PaymentMethodPIIDs["applePay"] = "be4de87d-7e38-4b2d-8836-9237eb32848e";
})(PaymentMethodPIIDs$1 || (PaymentMethodPIIDs$1 = {}));

"use strict";
var FetchOptions = /** @class */ (function () {
    function FetchOptions(url, httpMethod, headers, payload, retryable, pidlOperation, operation, serviceName, includeCredentials) {
        if (includeCredentials === void 0) { includeCredentials = false; }
        var _this = this;
        this.dataType = "json";
        this.contentType = "application/json";
        this.operationVersion = "";
        this.getRequest = function () {
            var requestInput = {
                method: _this.type,
                headers: new Headers(_this.headers),
                mode: "cors",
                credentials: _this.includeCredentials ? "include" : "omit"
            };
            // If requestInput.body property is added with null for Get requests
            // it makes fetch call fail on FireFox 46
            // to handle this setting it only when this.payload is defined
            if (_this.payload) {
                requestInput.body = _this.payload;
            }
            return new Request(_this.url, requestInput);
        };
        this.updateFetchOptions = function (fetchOrder, getSecondaryRequest) {
            var getSecondaryRequestPromise = createFakePromise({ success: _this.secondaryRetrieved, headers: _this.secondaryHeaders, payload: _this.secondaryPayload });
            if (getSecondaryRequest && fetchOrder.useSecondaryPayload && !_this.secondaryRetrieved) {
                getSecondaryRequestPromise = getSecondaryRequest();
            }
            return getSecondaryRequestPromise.then(function (_a) {
                var success = _a.success, headers = _a.headers, payload = _a.payload;
                if (fetchOrder && fetchOrder.endpoint) {
                    _this.url = configManager$1.replaceVirtualEndpointWithServiceAddress(fetchOrder.endpoint);
                }
                else if (!fetchOrder || !fetchOrder.useAlternateUrl) {
                    _this.url = _this.originalUrl;
                }
                if (success) {
                    _this.secondaryRetrieved = success;
                    _this.secondaryHeaders = headers;
                    _this.secondaryPayload = payload;
                }
                if (fetchOrder.useSecondaryPayload) {
                    if (_this.secondaryHeaders) {
                        _this.headers = __assign({}, _this.secondaryHeaders);
                    }
                    else if (_this.secondaryHeaders === null) {
                        _this.headers = {};
                    }
                    if (_this.secondaryPayload) {
                        _this.payload = _this.secondaryPayload;
                    }
                }
                else {
                    _this.headers = __assign({}, _this.originalHeaders);
                    _this.payload = _this.originalPayload;
                }
                if (_this.payload === undefined || _this.payload === null) {
                    delete _this.payload;
                }
                return _this;
            });
        };
        this.url = url;
        this.originalUrl = url;
        this.type = httpMethod;
        this.headers = headers;
        this.originalHeaders = __assign({}, headers);
        this.payload = payload;
        this.originalPayload = payload;
        this.retryCount = retryable ? 0 : -1;
        this.retryOnServerError = retryable;
        this.currentOperationName = pidlOperation || "pidlsdkOperation";
        this.operationName = operation || "DependentOperationName";
        this.serviceName = serviceName || "PidlSdkDependentService";
        this.includeCredentials = includeCredentials;
        this.serverErrorCount = 0;
        this.secondaryRetrieved = false;
        if (headers && typehelper.isObject(headers)) {
            var _a = headers, _b = httpHeaders.msRetryOnServerErr, canRetryOnServerError = _a[_b], filteredHeaders = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            this.retryOnServerError = (canRetryOnServerError !== "false");
            this.headers = filteredHeaders;
        }
    }
    return FetchOptions;
}());
var FetchFailureError = /** @class */ (function (_super) {
    __extends(FetchFailureError, _super);
    function FetchFailureError(status, statusText, failureContent, hasResponseFromServer, canRetryOnServerError) {
        var _this = _super.call(this, "Failed to fetch") || this;
        _this.status = status;
        _this.statusText = statusText;
        _this.failureContent = failureContent;
        _this.hasResponseFromServer = hasResponseFromServer;
        _this.canRetryOnServerError = canRetryOnServerError;
        return _this;
    }
    return FetchFailureError;
}(Error));
var defaultInitialRetryTimeout = 1000;
var defaultRetryTimeoutMultiplier = 1.5;
var defaultRetryableErrorCodes = [500, 502, 503, 504];
var defaultMaxServerErrorRetryCount = 2;
var defaultXhrGetRequestTimeout = 12000;
var defaultXhrPostRequestTimeout = 42000;
var getDefaultFetchOrder = function () {
    return [{
            retry: 2
        }, {
            retry: 1,
            xhrConfig: {
                getRequestTimeout: defaultXhrGetRequestTimeout,
                postRequestTimeout: defaultXhrPostRequestTimeout
            }
        }, {
            retry: 2,
            useAlternateUrl: true
        }, {
            retry: 1,
            useAlternateUrl: true,
            xhrConfig: {
                getRequestTimeout: defaultXhrGetRequestTimeout,
                postRequestTimeout: defaultXhrPostRequestTimeout
            }
        }];
};
var FetchConfig = /** @class */ (function () {
    function FetchConfig(config) {
        this.initialRetryTimeout = defaultInitialRetryTimeout;
        this.retryTimeoutMultiplier = defaultRetryTimeoutMultiplier;
        this.retryableErrorCodes = __spreadArray([], defaultRetryableErrorCodes, true);
        this.maxServerErrorRetryCount = defaultMaxServerErrorRetryCount;
        this.fetchOrder = getDefaultFetchOrder();
        this.initialRetryTimeout = (config === null || config === void 0 ? void 0 : config.initialRetryTimeout) || this.initialRetryTimeout;
        this.retryTimeoutMultiplier = (config === null || config === void 0 ? void 0 : config.retryTimeoutMultiplier) || this.retryTimeoutMultiplier;
        this.retryableErrorCodes = (config === null || config === void 0 ? void 0 : config.retryableErrorCodes) || this.retryableErrorCodes;
        this.maxServerErrorRetryCount = (config === null || config === void 0 ? void 0 : config.maxServerErrorRetryCount) || this.maxServerErrorRetryCount;
        this.fetchOrder = (config === null || config === void 0 ? void 0 : config.fetchOrder) || this.fetchOrder;
        var flatFetchOrder = [];
        for (var _i = 0, _a = this.fetchOrder; _i < _a.length; _i++) {
            var ro = _a[_i];
            for (var i = 0; i < ro.retry; i++) {
                flatFetchOrder.push(ro);
            }
            ro.retry = 1;
        }
        this.fetchOrder = flatFetchOrder;
    }
    return FetchConfig;
}());
var FetchHelper = /** @class */ (function () {
    function FetchHelper() {
        var _this = this;
        this.FetchOptions = FetchOptions;
        this.getHttpTelemetryData = function (fetchOptions, fetchResponse) {
            var url = fetchOptions.url, type = fetchOptions.type, contentType = fetchOptions.contentType, currentOperationName = fetchOptions.currentOperationName, operationName = fetchOptions.operationName, operationVersion = fetchOptions.operationVersion, serviceName = fetchOptions.serviceName, retryCount = fetchOptions.retryCount;
            var isSuccess = fetchResponse.isSuccess, statusCode = fetchResponse.statusCode, headers = fetchResponse.headers, failureResponseText = fetchResponse.failureResponseText, timeTaken = fetchResponse.timeTaken, serviceErrorCode = fetchResponse.serviceErrorCode, statusText = fetchResponse.statusText;
            var protocolStatusCode = statusCode ? statusCode.toString() : "0";
            var failureMessage = (!isSuccess && protocolStatusCode !== "200") ? failureResponseText || statusText : "";
            var contentLength = 0;
            try {
                contentLength = parseInt(fetchResponse.headers.get("Content-Length"), 10);
            }
            catch (_a) {
            }
            return {
                targetUri: url,
                requestMethod: type,
                responseContentType: contentType,
                operationName: currentOperationName,
                dependencyOperationName: operationName,
                dependencyOperationVersion: operationVersion,
                serviceName: serviceName,
                retryCount: retryCount,
                succeeded: isSuccess,
                protocolStatusCode: protocolStatusCode,
                failureResponse: failureMessage,
                contentLength: isNaN(contentLength) ? 0 : contentLength,
                latencyMs: timeTaken,
                serviceErrorCode: serviceErrorCode,
                headers: _this.getDesiredResponseHeaders(headers)
            };
        };
        this.getDesiredResponseHeaders = function (headers) {
            var responseHeaders = {};
            if (headers && headers.forEach) {
                var completeHeaderNames_1 = config$1.telemetryHeaders.names;
                var headerPrefixes_1 = config$1.telemetryHeaders.prefixes;
                headers.forEach(function (value, key) {
                    if (completeHeaderNames_1.indexOf(key) > -1) {
                        responseHeaders[key] = value;
                    }
                    else {
                        headerPrefixes_1.forEach(function (prefix) {
                            if (typehelper.startsWithIgnoreCase(key, prefix)) {
                                responseHeaders[key] = value;
                            }
                        });
                    }
                });
            }
            return responseHeaders;
        };
        this.isFetchFailureError = function (obj) {
            return "status" in obj && "statusText" in obj && "failureContent" in obj;
        };
        this.addCVHeader = function (eventHub, headers) {
            var header = eventHub.getHttpRequestCorrelationHeader();
            var _a = header || { name: undefined, value: undefined }, name = _a.name, value = _a.value;
            if (name && value) {
                headers[name] = value;
            }
        };
        this.handleFetchFailure = function (error, httpMethod, retryOnServerError, fetchConfig) {
            var status;
            var statusText;
            var failureContent;
            var hasAnyResponseFromServer;
            if (_this.isFetchFailureError(error)) {
                status = error.status;
                statusText = error.statusText;
                failureContent = error.failureContent;
                hasAnyResponseFromServer = error.hasResponseFromServer;
                retryOnServerError = retryOnServerError && error.canRetryOnServerError;
            }
            else if (error) {
                var unknownError = error;
                status = unknownError.status;
                statusText = unknownError.statusText;
                failureContent = unknownError.failureContent || error.message || typehelper.serialize(unknownError);
            }
            var msg;
            var retryable = false;
            var serverError = false;
            var isConnectivityError = false;
            if (!hasAnyResponseFromServer) {
                msg = "|NetworkError|Status: ".concat(status, ", StatusText: ").concat(statusText, ", FailureContent: ").concat(failureContent, "| Uncaught Error. |").concat(failureContent, "|");
                isConnectivityError = true;
                retryable = true;
            }
            else {
                if (fetchConfig && fetchConfig.retryableErrorCodes && fetchConfig.retryableErrorCodes.indexOf(status) > -1) {
                    serverError = true;
                    retryable = retryOnServerError;
                }
                msg = "HTTP Error |".concat(status, "|").concat(statusText, "|: |").concat(failureContent, "|");
            }
            var parsedFailureContent = utils.parseJSON(failureContent);
            return {
                failureMessage: {
                    status: pidlResultType.Error,
                    errorMessage: msg,
                    httpStatus: status,
                    httpStatusText: statusText,
                    failureContent: failureContent,
                    failureObject: parsedFailureContent && parsedFailureContent.succeeded ? parsedFailureContent.value : undefined,
                    connectivityError: isConnectivityError
                },
                retryable: retryable,
                serverError: serverError
            };
        };
        this.fetchWrapper = function (fetchOptions) {
            if (_this.fetchHandler) {
                return _this.fetchHandler(fetchOptions.getRequest());
            }
            else {
                return fetch(fetchOptions.getRequest());
            }
        };
        this.xhrWrapper = function (fetchOptions, fetchOrder, eventHub, startTime) {
            return new Promise(function (resolve, reject) {
                var type = fetchOptions.type, url = fetchOptions.url, headers = fetchOptions.headers, payload = fetchOptions.payload, includeCredentials = fetchOptions.includeCredentials;
                var xhrConfig = (fetchOrder || { xhrConfig: { getRequestTimeout: defaultXhrGetRequestTimeout, postRequestTimeout: defaultXhrPostRequestTimeout } }).xhrConfig;
                var request = new XMLHttpRequest();
                request.open(type, url);
                if (type === httpActions.Get) {
                    request.timeout = xhrConfig.getRequestTimeout || defaultXhrGetRequestTimeout;
                }
                else {
                    request.timeout = xhrConfig.postRequestTimeout || defaultXhrPostRequestTimeout;
                }
                if (headers) {
                    typehelper.getKeys(headers).forEach(function (key) { return request.setRequestHeader(key, headers[key]); });
                }
                if (includeCredentials) {
                    request.withCredentials = includeCredentials;
                }
                var getXHRResponseHeader = function () {
                    var responseHeadersString = request.getAllResponseHeaders();
                    var responseHeaders = {};
                    if (!typehelper.isEmptyString(responseHeadersString)) {
                        var responseHeadersArray = responseHeadersString.trim().split(/[\r\n]+/);
                        responseHeadersArray.forEach(function (header) {
                            var headerParts = header.split(": ");
                            var key = headerParts.shift();
                            var value = headerParts.join(": ");
                            responseHeaders[key] = value;
                        });
                    }
                    return responseHeaders;
                };
                var getXHRResponsePayload = function () {
                    var responsePayload = undefined;
                    if (request.responseType === "" || request.responseType === "text") {
                        responsePayload = request.responseText;
                    }
                    return responsePayload;
                };
                request.onload = function () {
                    resolve(new Response(getXHRResponsePayload(), {
                        status: request.status,
                        headers: new Headers(getXHRResponseHeader()),
                        statusText: request.statusText
                    }));
                };
                request.onerror = function () {
                    var responseDetails = { isSuccess: false, timeTaken: Date.now() - startTime, statusCode: request.status, headers: new Headers(getXHRResponseHeader()) };
                    if (eventHub) {
                        eventHub.fetchCallCompleted(_this.getHttpTelemetryData(fetchOptions, responseDetails));
                    }
                    var responsePayload = getXHRResponsePayload();
                    reject(new FetchFailureError(request.status, request.statusText, responsePayload, typehelper.boolify(responsePayload), true));
                };
                request.ontimeout = function () {
                    var responseDetails = { isSuccess: false, timeTaken: Date.now() - startTime, statusCode: request.status, headers: new Headers() };
                    if (eventHub) {
                        eventHub.fetchCallCompleted(_this.getHttpTelemetryData(fetchOptions, responseDetails));
                    }
                    reject(new FetchFailureError(request.status, request.statusText, undefined, false, true));
                };
                if (type === httpActions.Post && payload) {
                    request.setRequestHeader("Content-Type", "application/json");
                    request.send(payload);
                }
                else {
                    request.send();
                }
            });
        };
        this.loadScript = function (src) {
            return new Promise(function (resolve, reject) {
                try {
                    if (document && (document.head || document.body)) {
                        var script = document.createElement("script");
                        script.onload = function () {
                            resolve();
                        };
                        script.onerror = function () {
                            reject();
                        };
                        script.async = true;
                        script.src = src;
                        (document.head || document.body).appendChild(script);
                    }
                    else {
                        reject();
                    }
                }
                catch (e) {
                    reject(e);
                }
            });
        };
        this.getHttpHeaders = function (eventHub, userContext, actionContextHeaders, template, bindingContextData) {
            var headers = _this.getDefaultHttpHeaders(eventHub);
            if (userContext) {
                headers = userContext.getHeaders(headers, template);
            }
            if (actionContextHeaders) {
                utils.extend(true, headers, actionContextHeaders);
                if (headers.hasOwnProperty(httpHeaders.msCorrelationId) &&
                    typehelper.isNullOrUndefinedOrWhiteSpaceString(headers[httpHeaders.msCorrelationId])) {
                    headers[httpHeaders.msCorrelationId] = utils.guid();
                }
                if (headers.hasOwnProperty(httpHeaders.msTrackingId) &&
                    typehelper.isNullOrUndefinedOrWhiteSpaceString(headers[httpHeaders.msTrackingId])) {
                    headers[httpHeaders.msTrackingId] = utils.guid();
                }
            }
            // Add correlation context and pidlsdk version header only to pidl and pifd endpoints.
            if (template && (template.indexOf("{pidl") > -1 || template.indexOf("{pifd") > -1 || template.indexOf("{resource-endpoint}") > -1)) {
                if (!headers.hasOwnProperty(httpHeaders.correlationContext)) {
                    headers[httpHeaders.correlationContext] = eventHub === null || eventHub === void 0 ? void 0 : eventHub.getCorrelationContextHeaderValue();
                }
                headers[httpHeaders.msPidlsdkVersion] = eventHub === null || eventHub === void 0 ? void 0 : eventHub.getPidlSdkVersionHeaderValue();
            }
            // update the headers based on data binding context
            for (var name_1 in headers) {
                headers[name_1] = utils.getFormatStringExpressionValue(headers[name_1], bindingContextData);
            }
            return headers;
        };
        this.getDefaultHttpHeaders = function (eventHub) {
            var _a;
            var headers = (_a = {},
                _a[httpHeaders.contentType] = "application/json",
                _a);
            _this.addCVHeader(eventHub, headers);
            return headers;
        };
        this.getPayeeFileUploadHttpHeaders = function (eventHub, userCredential) {
            var headers = {};
            if (userCredential) {
                headers[httpHeaders.authorization] = userCredential;
            }
            return headers;
        };
        this.setFetchHandler = function (fetchHandler) {
            _this.fetchHandler = fetchHandler;
        };
        this.testHookSetRetryTimeout = function (value) {
            defaultInitialRetryTimeout = value;
        };
        this.testHookHandleFetchFailure = function (error, httpMethod, retryOnServerError) {
            if (httpMethod === void 0) { httpMethod = httpActions.Post; }
            if (retryOnServerError === void 0) { retryOnServerError = false; }
            return _this.handleFetchFailure(error, httpMethod, retryOnServerError, new FetchConfig());
        };
    }
    FetchHelper.prototype.successHandler = function (eventHub, fetchOptions, startTime, deferred, onSuccess, fetchConfig) {
        var _this = this;
        return function (response) {
            var responseDetails = { isSuccess: response.ok, timeTaken: Date.now() - startTime, statusCode: response.status, headers: response.headers };
            if (responseDetails.isSuccess) {
                try {
                    eventHub.fetchCallCompleted(_this.getHttpTelemetryData(fetchOptions, responseDetails));
                }
                catch (_a) {
                }
            }
            return response.text().then(function (responseText) {
                var jsonParseResult = utils.parseJSON(responseText);
                var canRetryOnServerError = false;
                if (!responseDetails.isSuccess) {
                    responseDetails = __assign(__assign({}, responseDetails), { statusText: response.statusText, serviceErrorCode: (jsonParseResult.value || {}).code, failureResponseText: responseText });
                    try {
                        eventHub.fetchCallCompleted(_this.getHttpTelemetryData(fetchOptions, responseDetails));
                    }
                    catch (_a) {
                    }
                    canRetryOnServerError = fetchOptions.serverErrorCount < fetchConfig.maxServerErrorRetryCount;
                    // check for response header if retry is not allowed
                    try {
                        var msRetryHeaderVal = responseDetails.headers.get(httpHeaders.msRetryOnServerErr);
                        canRetryOnServerError = msRetryHeaderVal === "true" ? true : (msRetryHeaderVal === "false" ? false : canRetryOnServerError);
                    }
                    catch (_b) { }
                }
                if (response.ok && (typehelper.isEmptyString(responseText) || jsonParseResult.succeeded)) {
                    try {
                        var responseJson = jsonParseResult.succeeded ? jsonParseResult.value : {};
                        if (onSuccess) {
                            onSuccess(responseJson);
                        }
                        deferred.resolve(responseJson);
                    }
                    catch (err) {
                        throw new FetchFailureError(response.status, response.statusText, err.message, true, false);
                    }
                }
                else {
                    throw new FetchFailureError(response.status, response.statusText, responseText, true, canRetryOnServerError);
                }
            });
        };
    };
    FetchHelper.prototype.exceptionHandler = function (eventHub, fetchOptions, startTime, deferred, onSuccess, onError, fetchConfig, getSecondaryRequest) {
        var _this = this;
        return function (error) {
            var failureInfo = _this.handleFetchFailure(error, fetchOptions.type, fetchOptions.retryOnServerError, fetchConfig);
            var localFailureMessage = failureInfo.failureMessage;
            var retryable = failureInfo.retryable && fetchConfig.fetchOrder.length > 0;
            eventHub.error(new pidlErrors.serverError(errorMessages.restMethodInvocationFailed, fetchOptions.url, localFailureMessage.failureObject || localFailureMessage.failureContent, localFailureMessage.httpStatus, localFailureMessage.httpStatusText, localFailureMessage.errorMessage, [fetchOptions.url, localFailureMessage.httpStatusText], fetchOptions.type, fetchOptions.retryCount, retryable));
            if (failureInfo.serverError) {
                fetchOptions.serverErrorCount++;
            }
            if (retryable) {
                fetchOptions.retryCount += 1;
                var fetchOrder_1 = fetchConfig.fetchOrder.shift();
                if (fetchOrder_1.useAlternateUrl) {
                    fetchOptions.url = config$1.getAlternateUrl(fetchOptions.originalUrl);
                }
                var updateFetchOptionsPromise_1 = fetchOptions.updateFetchOptions(fetchOrder_1, getSecondaryRequest);
                setTimeout(function () {
                    startTime = Date.now();
                    if (!fetchOrder_1.xhrConfig || _this.fetchHandler) {
                        return updateFetchOptionsPromise_1.then(function (updatedFetchOptions) {
                            _this.addCVHeader(eventHub, updatedFetchOptions.headers);
                            return _this.fetchWrapper(updatedFetchOptions)
                                .then(_this.successHandler(eventHub, updatedFetchOptions, startTime, deferred, onSuccess, fetchConfig))
                                .catch(_this.exceptionHandler(eventHub, updatedFetchOptions, startTime, deferred, onSuccess, onError, fetchConfig, getSecondaryRequest));
                        });
                    }
                    else {
                        return updateFetchOptionsPromise_1.then(function (updatedFetchOptions) {
                            _this.addCVHeader(eventHub, updatedFetchOptions.headers);
                            return _this.xhrWrapper(updatedFetchOptions, fetchOrder_1, eventHub, startTime)
                                .then(_this.successHandler(eventHub, updatedFetchOptions, startTime, deferred, onSuccess, fetchConfig))
                                .catch(_this.exceptionHandler(eventHub, updatedFetchOptions, startTime, deferred, onSuccess, onError, fetchConfig, getSecondaryRequest));
                        });
                    }
                }, fetchConfig.initialRetryTimeout * Math.pow(fetchConfig.retryTimeoutMultiplier, fetchOptions.retryCount - 1));
            }
            else {
                if (onError) {
                    onError(localFailureMessage);
                }
                deferred.reject(localFailureMessage);
            }
        };
    };
    FetchHelper.prototype.invokeFetch = function (eventHub, retry, httpMethod, url, headers, payload, onSuccess, onError, pidlOperation, operation, serviceName, includeCredentials, fetchConfig, getSecondaryRequest) {
        var _this = this;
        if (includeCredentials === void 0) { includeCredentials = false; }
        if (fetchConfig === void 0) { fetchConfig = null; }
        if (getSecondaryRequest === void 0) { getSecondaryRequest = null; }
        var startTime = Date.now();
        var fetchOptions = new this.FetchOptions(url, httpMethod, headers, payload, retry, pidlOperation, operation, serviceName, includeCredentials);
        var flatFetchConfig = new FetchConfig(fetchConfig);
        var firstFetchOrder = flatFetchConfig.fetchOrder.shift();
        var updateFetchOptionsPromise = fetchOptions.updateFetchOptions(firstFetchOrder, getSecondaryRequest);
        return new Promise(function (resolve, reject) {
            var deferred = { resolve: resolve, reject: reject };
            updateFetchOptionsPromise.then(function (updatedFetchOptions) {
                var fetchPromise = firstFetchOrder.xhrConfig && !_this.fetchHandler ? _this.xhrWrapper(updatedFetchOptions, firstFetchOrder, eventHub, startTime) : _this.fetchWrapper(updatedFetchOptions);
                fetchPromise
                    .then(_this.successHandler(eventHub, updatedFetchOptions, startTime, deferred, onSuccess, flatFetchConfig))
                    .catch(_this.exceptionHandler(eventHub, updatedFetchOptions, startTime, deferred, onSuccess, onError, flatFetchConfig, getSecondaryRequest));
            }).catch(_this.exceptionHandler(eventHub, fetchOptions, startTime, deferred, onSuccess, onError, flatFetchConfig, getSecondaryRequest));
        });
    };
    FetchHelper.prototype.post = function (eventHub, retry, url, headers, payload, onSuccess, onError, pidlOperation, operation, serviceName, includeCredentials, fetchConfig, getSecondaryRequest) {
        if (includeCredentials === void 0) { includeCredentials = false; }
        if (fetchConfig === void 0) { fetchConfig = null; }
        if (getSecondaryRequest === void 0) { getSecondaryRequest = null; }
        return this.invokeFetch(eventHub, retry, httpActions.Post, url, headers, payload, onSuccess, onError, pidlOperation, operation, serviceName, includeCredentials, fetchConfig, getSecondaryRequest);
    };
    FetchHelper.prototype.put = function (eventHub, retry, url, headers, payload, onSuccess, onError, pidlOperation, operation, serviceName, includeCredentials, fetchConfig) {
        if (includeCredentials === void 0) { includeCredentials = false; }
        if (fetchConfig === void 0) { fetchConfig = null; }
        return this.invokeFetch(eventHub, retry, httpActions.Put, url, headers, payload, onSuccess, onError, pidlOperation, operation, serviceName, includeCredentials, fetchConfig);
    };
    FetchHelper.prototype.get = function (eventHub, url, headers, pidlOperation, operation, serviceName, fetchConfig) {
        if (fetchConfig === void 0) { fetchConfig = null; }
        return this.invokeFetch(eventHub, true, httpActions.Get, url, headers, null, null, null, pidlOperation, operation, serviceName, false, fetchConfig);
    };
    FetchHelper.prototype.delete = function (eventHub, url, headers, pidlOperation, operation, serviceName, fetchConfig) {
        if (fetchConfig === void 0) { fetchConfig = null; }
        return this.invokeFetch(eventHub, true, httpActions.Delete, url, headers, null, null, null, pidlOperation, operation, serviceName, false, fetchConfig);
    };
    return FetchHelper;
}());
var fetchHelper = new FetchHelper();

"use strict";
var inputValidationHelper = /** @class */ (function () {
    function inputValidationHelper() {
        var _this = this;
        this.returnOptionSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                callbacks: {
                    type: "object" /* ValidationDataType.object */,
                    optional: true,
                    children: {
                        success: {
                            type: "function" /* ValidationDataType.function */,
                            optional: true
                        },
                        failure: {
                            type: "function" /* ValidationDataType.function */,
                            optional: true
                        },
                        gohome: {
                            type: "function" /* ValidationDataType.function */,
                            optional: true
                        }
                    }
                },
                urls: {
                    type: "object" /* ValidationDataType.object */,
                    optional: true,
                    children: {
                        success: {
                            type: "string" /* ValidationDataType.string */,
                            optional: true
                        },
                        failure: {
                            type: "string" /* ValidationDataType.string */,
                            optional: true
                        },
                        gohome: {
                            type: "string" /* ValidationDataType.string */,
                            optional: true
                        }
                    }
                }
            }
        };
        this.userContextSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true,
            children: {
                authToken: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                userId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                additionalHeaders: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                },
                serviceOverrides: {
                    type: "object" /* ValidationDataType.object */,
                    optional: true,
                    ignoreUnspecifiedChild: true,
                    children: {
                        authToken: {
                            type: "string" /* ValidationDataType.string */,
                            optional: true
                        },
                        userId: {
                            type: "string" /* ValidationDataType.string */,
                            optional: true
                        },
                        additionalHeaders: {
                            type: "dictionary" /* ValidationDataType.dictionary */,
                            optional: true
                        }
                    }
                }
            }
        };
        this.pidlDocInfoSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                resourceType: {
                    type: "string" /* ValidationDataType.string */
                },
                anonymousPidl: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                parameters: {
                    type: "dictionary" /* ValidationDataType.dictionary */
                },
                resourceSuffix: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                pidlVersion: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                pidlEndpoint: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                }
            }
        };
        this.resourceInfoSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                resourceType: {
                    type: "string" /* ValidationDataType.string */
                },
                anonymousPidl: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                parameters: {
                    type: "dictionary" /* ValidationDataType.dictionary */
                },
                id: {
                    type: "string" /* ValidationDataType.string */
                },
                resourceEndpoint: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                }
            }
        };
        this.pidlIdentitySchema = {
            type: "object" /* ValidationDataType.object */,
            ignoreUnspecifiedChild: true,
            children: {
                country: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                description_type: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                operation: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                resource_id: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                }
            }
        };
        this.displayOptionsSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                containerId: {
                    type: "string" /* ValidationDataType.string */
                },
                busyBlockId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                busyBlockElement: {
                    type: "any" /* ValidationDataType.any */,
                    optional: true,
                },
                helpDialogBlockId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                showHelpDialogBlock: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                inputPropertyIdPrefix: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                inputPropertyIdSuffix: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                displayElementIdPrefix: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                displayElementIdSuffix: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                inputPropertyErrorIdPrefix: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                showPlaceholderInTextbox: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                disableEnterKeyAction: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                showSubmitBlock: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                showErrorBlock: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                htmlExtender: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                },
                busyBlockShowHideHandler: {
                    type: "function" /* ValidationDataType.function */,
                    optional: true
                },
                hidePropertyErrors: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                disableFocusOnLoad: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                alwaysValidateOnChange: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                ieExtender: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                },
                propagateCallbackException: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                useWebView2: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                busyUntilInitialPageRendered: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                secureFieldPreLoadingEnabled: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
            }
        };
        this.suppressedEventsSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true,
            children: {
                disableLogging: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                disableConsoleLogging: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                }
            }
        };
        this.telemetryOptionsSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true,
            children: {
                contextData: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                },
                disableLogging: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                disableConsoleLogging: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                enablePrivateEventConsoleLogging: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                customTelemetryFrameworkWindowNamespace: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                overrides: {
                    type: "object" /* ValidationDataType.object */,
                    minLength: 0,
                    optional: true,
                    childType: this.suppressedEventsSchema,
                    allowedChildNames: __assign(__assign({}, eventNames), privateEventNames)
                }
            }
        };
        this.callbacksSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true,
            children: {
                view: {
                    type: "any" /* ValidationDataType.any */,
                    optional: true
                },
                submit: {
                    type: "function" /* ValidationDataType.function */,
                    optional: true
                },
                getPidlDocument: {
                    type: "function" /* ValidationDataType.function */,
                    optional: true
                },
                iFrameMessageHandler: {
                    type: "function" /* ValidationDataType.function */,
                    optional: true
                },
                telemetryLogger: {
                    type: "any" /* ValidationDataType.any */,
                    optional: true
                },
                prefetcher: {
                    type: "any" /* ValidationDataType.any */,
                    optional: true
                },
                encryptionHandler: {
                    type: "any" /* ValidationDataType.any */,
                    optional: true
                },
                fetchHandler: {
                    type: "function" /* ValidationDataType.function */,
                    optional: true
                }
            }
        };
        this.checkoutParamsSchema = {
            type: "object" /* ValidationDataType.object */,
            ignoreUnspecifiedChild: true,
            children: {
                anonymousUser: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                checkoutId: {
                    type: "string" /* ValidationDataType.string */
                },
                language: {
                    type: "string" /* ValidationDataType.string */
                },
                market: {
                    type: "string" /* ValidationDataType.string */
                },
                partner: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                paymentProviderId: {
                    type: "string" /* ValidationDataType.string */,
                },
                redirectUrl: {
                    type: "string" /* ValidationDataType.string */
                }
            }
        };
        this.payeeTaxProfileParamsSchema = {
            type: "object" /* ValidationDataType.object */,
            ignoreUnspecifiedChild: true,
            children: {
                section: {
                    type: "string" /* ValidationDataType.string */
                },
                tenant: {
                    type: "string" /* ValidationDataType.string */
                },
                sapidind: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                status: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                accounttype: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                payfromcc: {
                    type: "array" /* ValidationDataType.array */,
                    minLength: 1,
                    optional: true
                },
                residencecc: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                language: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                }
            }
        };
        this.mockEventsSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true,
            children: {
                name: {
                    type: "string" /* ValidationDataType.string */
                },
                params: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                }
            }
        };
        this.mockFunctionSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true,
            children: {
                name: {
                    type: "string" /* ValidationDataType.string */
                },
                triggers: {
                    type: "array" /* ValidationDataType.array */,
                    maxLength: 1,
                    childType: this.mockEventsSchema
                },
                returns: {
                    type: "any" /* ValidationDataType.any */,
                    optional: true
                }
            }
        };
        this.mockFunctionsSchema = {
            type: "array" /* ValidationDataType.array */,
            maxLength: 1,
            optional: true,
            childType: this.mockFunctionSchema
        };
        this.addUpdateOrDeleteOptionSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true,
            children: {
                sessionId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                riskData: {
                    type: "object" /* ValidationDataType.object */,
                    optional: true,
                    children: {
                        greenId: {
                            type: "string" /* ValidationDataType.string */
                        }
                    }
                }
            }
        };
        this.selectOrRenderOptionSchema = {
            type: "object" /* ValidationDataType.object */,
            optional: true
        };
        this.selectedResourceInfoSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                id: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                backupId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                }
            }
        };
        this.handleSchema = {
            type: "string" /* ValidationDataType.string */
        };
        this.prefillDataSchema = {
            type: "object" /* ValidationDataType.object */,
            ignoreUnspecifiedChild: true
        };
        this.purchaseContextSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                amount: {
                    type: "number" /* ValidationDataType.number */
                },
                currency: {
                    type: "string" /* ValidationDataType.string */
                },
                country: {
                    type: "string" /* ValidationDataType.string */
                },
                threeDSScenario: {
                    type: "string" /* ValidationDataType.string */,
                    possibleValues: typehelper.getValues(__assign({}, challengeScenario))
                },
                riskChallengeIndicator: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true,
                    possibleValues: typehelper.getValues(__assign({}, riskChallengeIndicator))
                }
            }
        };
        this.purchaseRiskChallengeSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                piResourceInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.resourceInfoSchema
                },
                riskChallengeData: {
                    type: "array" /* ValidationDataType.array */,
                    minLength: 1
                },
                sessionId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                orderId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                options: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                }
            }
        };
        this.purchaseRiskChallengeSchemaForThreeDS = {
            type: "object" /* ValidationDataType.object */,
            children: {
                piResourceInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.resourceInfoSchema
                },
                riskChallengeData: {
                    type: "array" /* ValidationDataType.array */,
                    minLength: 1
                },
                challengeWindowSize: {
                    type: "string" /* ValidationDataType.string */,
                    possibleValues: typehelper.getValues(__assign({}, challengeWindowSize))
                },
                purchaseContext: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.purchaseContextSchema,
                },
                sessionId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                options: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                }
            }
        };
        this.purchasePendingStateSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                piResourceInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.resourceInfoSchema
                },
                sessionId: {
                    type: "string" /* ValidationDataType.string */
                },
                orderId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                options: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                }
            }
        };
        this.resourceOptionsSchema = {
            type: "dictionary" /* ValidationDataType.dictionary */,
            optional: true
        };
        this.showResourceParamsSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                pidlDocInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.pidlDocInfoSchema
                },
                prefillData: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.prefillDataSchema,
                    optional: true
                },
                options: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.resourceOptionsSchema,
                    optional: true
                }
            }
        };
        this.offerResourceParamsSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                pidlDocInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.pidlDocInfoSchema
                },
                prefillData: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.prefillDataSchema,
                    optional: true
                },
                options: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.resourceOptionsSchema,
                    optional: true
                }
            }
        };
        this.searchResourceParamsSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                pidlDocInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.pidlDocInfoSchema
                },
                options: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.resourceOptionsSchema,
                    optional: true
                }
            }
        };
        this.fundStoredValueParamsSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                pidlDocInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.pidlDocInfoSchema
                },
                options: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.resourceOptionsSchema,
                    optional: true
                }
            }
        };
        this.resourceActionParamsSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                resourceActionContext: {
                    type: "object" /* ValidationDataType.object */,
                    ignoreUnspecifiedChild: true,
                    children: {
                        action: {
                            type: "string" /* ValidationDataType.string */,
                            possibleValues: typehelper.getValues(__assign({}, resourceActions))
                        },
                        handle: {
                            type: "string" /* ValidationDataType.string */,
                            optional: true
                        },
                        pidlDocInfo: {
                            type: "schema" /* ValidationDataType.schema */,
                            schema: this.pidlDocInfoSchema,
                            optional: true
                        },
                        pidlIdentity: {
                            type: "schema" /* ValidationDataType.schema */,
                            schema: this.pidlIdentitySchema,
                            optional: true
                        },
                        resourceInfo: {
                            type: "schema" /* ValidationDataType.schema */,
                            schema: this.resourceInfoSchema,
                            optional: true
                        },
                        prefillData: {
                            type: "schema" /* ValidationDataType.schema */,
                            schema: this.prefillDataSchema,
                            optional: true
                        }
                    }
                },
                prefillData: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.prefillDataSchema,
                    optional: true
                },
                options: {
                    type: "dictionary" /* ValidationDataType.dictionary */,
                    optional: true
                },
                selectedResourceInfo: {
                    type: "schema" /* ValidationDataType.schema */,
                    schema: this.selectedResourceInfoSchema,
                    optional: true
                }
            }
        };
        this.authorizationGroupSchema = {
            type: "object" /* ValidationDataType.object */,
            children: {
                id: {
                    type: "string" /* ValidationDataType.string */
                },
                totalAmount: {
                    type: "number" /* ValidationDataType.number */,
                },
                itemTitles: {
                    type: "array" /* ValidationDataType.array */,
                }
            }
        };
        this.paymentSessionDataSchema = {
            type: "object" /* ValidationDataType.object */,
            ignoreUnspecifiedChild: true,
            children: {
                amount: {
                    type: "number" /* ValidationDataType.number */
                },
                billableAccountId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                caid: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                challengeScenario: {
                    type: "string" /* ValidationDataType.string */,
                    possibleValues: typehelper.getValues(__assign({}, challengeScenario))
                },
                challengeWindowSize: {
                    type: "string" /* ValidationDataType.string */,
                    possibleValues: typehelper.getValues(__assign({}, challengeWindowSize))
                },
                classicProduct: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                currency: {
                    type: "string" /* ValidationDataType.string */
                },
                country: {
                    type: "string" /* ValidationDataType.string */
                },
                hasPreOrder: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                isLegacy: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                isMOTO: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                language: {
                    type: "string" /* ValidationDataType.string */
                },
                partner: {
                    type: "string" /* ValidationDataType.string */
                },
                piCid: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                piid: {
                    type: "string" /* ValidationDataType.string */
                },
                purchaseOrderId: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                redeemRewards: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                rewardsPoints: {
                    type: "number" /* ValidationDataType.number */,
                    optional: true
                },
                recurringPaymentDetails: {
                    type: "object" /* ValidationDataType.object */,
                    optional: true,
                    ignoreUnspecifiedChild: true,
                    children: {
                        label: {
                            type: "string" /* ValidationDataType.string */,
                            optional: true
                        },
                        frequencyUnit: {
                            type: "string" /* ValidationDataType.string */,
                            possibleValues: typehelper.getValues(__assign({}, FrequencyUnitConstants))
                        },
                        frequency: {
                            type: "number" /* ValidationDataType.number */
                        },
                        startTime: {
                            type: "date" /* ValidationDataType.date */,
                            optional: true
                        },
                        amount: {
                            type: "number" /* ValidationDataType.number */
                        }
                    }
                },
                authorizationGroups: {
                    type: "array" /* ValidationDataType.array */,
                    optional: true,
                    childType: this.authorizationGroupSchema
                },
                initiativeContext: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
            }
        };
        this.paymentSessionSchema = {
            type: "object" /* ValidationDataType.object */,
            ignoreUnspecifiedChild: true,
            children: {
                id: {
                    type: "string" /* ValidationDataType.string */
                },
                isChallengeRequired: {
                    type: "boolean" /* ValidationDataType.boolean */
                },
                challengeStatus: {
                    type: "string" /* ValidationDataType.string */,
                    possibleValues: typehelper.getValues(__assign({}, challengeStatus))
                },
                signature: {
                    type: "string" /* ValidationDataType.string */
                },
                amount: {
                    type: "number" /* ValidationDataType.number */
                },
                caid: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                challengeScenario: {
                    type: "string" /* ValidationDataType.string */,
                    possibleValues: typehelper.getValues(__assign({}, challengeScenario))
                },
                challengeWindowSize: {
                    type: "string" /* ValidationDataType.string */,
                    possibleValues: typehelper.getValues(__assign({}, challengeWindowSize))
                },
                currency: {
                    type: "string" /* ValidationDataType.string */
                },
                country: {
                    type: "string" /* ValidationDataType.string */
                },
                hasPreOrder: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                isLegacy: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                isMOTO: {
                    type: "boolean" /* ValidationDataType.boolean */,
                    optional: true
                },
                language: {
                    type: "string" /* ValidationDataType.string */
                },
                partner: {
                    type: "string" /* ValidationDataType.string */
                },
                piCid: {
                    type: "string" /* ValidationDataType.string */,
                    optional: true
                },
                piid: {
                    type: "string" /* ValidationDataType.string */
                }
            }
        };
        this.visitInputSchema = function (name, schema, instance) {
            var error = _this.validate(name, schema, instance);
            if (error) {
                return error;
            }
            if (schema.type === "dictionary" /* ValidationDataType.dictionary */ || !instance) {
                return null;
            }
            if (_this.isObjectSchema(schema)) {
                var allowedChildNames = schema.allowedChildNames, ignoreUnspecifiedChild = schema.ignoreUnspecifiedChild, children = schema.children, childType = schema.childType;
                if (!allowedChildNames) {
                    if (!ignoreUnspecifiedChild) {
                        for (var prop in instance) {
                            if (!children[prop]) {
                                return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterNotInRange, prop, [prop]);
                            }
                        }
                    }
                    for (var key in children) {
                        var error_1 = _this.visitInputSchema(key, children[key], instance[key]);
                        if (error_1) {
                            return error_1;
                        }
                    }
                }
                else {
                    for (var propertyName in instance) {
                        if (!allowedChildNames[propertyName]) {
                            return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterMissing, name, [schema.type, typehelper.getType(instance)]);
                        }
                        if (childType) {
                            var error_2 = _this.visitInputSchema(name + " element: ", childType, instance[propertyName]);
                            if (error_2) {
                                return error_2;
                            }
                        }
                    }
                }
            }
            if (_this.isArraySchema(schema)) {
                if (!typehelper.isArray(instance)) {
                    return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterTypeMismatch, name, [schema.type, typehelper.getType(instance)]);
                }
                var minLength = schema.minLength, maxLength = schema.maxLength, childType = schema.childType;
                if (minLength && instance.length < minLength) {
                    return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterSmallerThanMinLength, name, [name, minLength, instance.length]);
                }
                if (maxLength && instance.length > maxLength) {
                    return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterLargerThanMaxLength, name, [name, maxLength, instance.length]);
                }
                // if no childType is defined, then we will assume that no validation is desired
                if (childType) {
                    for (var i = 0; i < instance.length; ++i) {
                        var error_3 = _this.visitInputSchema(name + " element: " + i, childType, instance[i]);
                        if (error_3) {
                            return error_3;
                        }
                    }
                }
            }
            if (_this.isSchemaSchema(schema)) {
                var error_4 = _this.visitInputSchema(name, schema.schema, instance);
                if (error_4) {
                    return error_4;
                }
            }
            return null;
        };
        this.validate = function (elementName, elementSchema, elementValue) {
            if (!elementSchema.optional && (elementValue === null || elementValue === undefined)) {
                return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterMissing, elementName, [elementName]);
            }
            var expectedType = elementSchema.type;
            if (!elementValue || expectedType === "any" /* ValidationDataType.any */) {
                return null;
            }
            var actualType = typeof elementValue;
            if (expectedType === "dictionary" /* ValidationDataType.dictionary */ || expectedType === "schema" /* ValidationDataType.schema */) {
                expectedType = "object" /* ValidationDataType.object */;
            }
            else if (expectedType === "array" /* ValidationDataType.array */) {
                // For backward compatibility, we will check if this is an array only if we are looking for arrays.
                // Otherwise they will be treated as objects
                if (typehelper.isArray(elementValue)) {
                    actualType = "array" /* ValidationDataType.array */;
                }
            }
            if (expectedType === "boolean" /* ValidationDataType.boolean */ && actualType === "string" /* ValidationDataType.string */) {
                if (elementValue === "true" || elementValue === "false") {
                    actualType = "boolean" /* ValidationDataType.boolean */;
                }
            }
            if (expectedType === "date" /* ValidationDataType.date */ && actualType === "object" /* ValidationDataType.object */) {
                actualType = "date" /* ValidationDataType.date */;
            }
            if (expectedType && actualType && expectedType !== actualType) {
                return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterTypeMismatch, elementName, [expectedType, actualType]);
            }
            if (elementSchema.possibleValues && !typehelper.contains(elementSchema.possibleValues, elementValue)) {
                return new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterNotInRange, elementName, [
                    elementName,
                    elementValue,
                    JSON.stringify(elementSchema.possibleValues)
                ]);
            }
            return null;
        };
        this.resultHandler = function (eventHub, error) {
            if (error) {
                eventHub.failure(error);
            }
            return !typehelper.boolify(error);
        };
        this.validateInputParameters = function (eventHub, userContext, displayOptions, telemetryOptions, callbacks) {
            var succeeded = _this.resultHandler(eventHub, _this.visitInputSchema("userContext", _this.userContextSchema, userContext));
            succeeded = succeeded &&
                _this.resultHandler(eventHub, _this.visitInputSchema("displayOptions", _this.displayOptionsSchema, displayOptions));
            if (succeeded) {
                if (displayOptions.busyBlockShowHideHandler && displayOptions.busyBlockId) {
                    succeeded = _this.resultHandler(eventHub, new pidlErrors.inputParameterValidationFailedError(errorMessages.busyBlockShowHideHandlerAndbusyBlockIdAreExclusive));
                }
            }
            succeeded = succeeded &&
                _this.resultHandler(eventHub, _this.visitInputSchema("telemetryOptions", _this.telemetryOptionsSchema, telemetryOptions));
            succeeded = succeeded &&
                _this.resultHandler(eventHub, _this.visitInputSchema("callbacks", _this.callbacksSchema, callbacks));
            return succeeded;
        };
        this.validateCheckoutParams = function (eventHub, checkoutParams) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("checkoutParams", _this.checkoutParamsSchema, checkoutParams));
        };
        this.validatePayeeTaxProfileParams = function (eventHub, payeeTaxProfileParams) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("payeeTaxProfileParams", _this.payeeTaxProfileParamsSchema, payeeTaxProfileParams));
        };
        this.validateMockFunctions = function (eventHub, mockFunctions) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("mockFunctions", _this.mockFunctionsSchema, mockFunctions));
        };
        this.validateReturnOptions = function (eventHub, returnOptions) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("returnOptions", _this.returnOptionSchema, returnOptions));
        };
        this.validatePidlDocInfo = function (eventHub, pidlDocInfo) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("pidlDocInfo", _this.pidlDocInfoSchema, pidlDocInfo));
        };
        this.validateResourceInfo = function (eventHub, resourceInfo) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("resourceInfo", _this.resourceInfoSchema, resourceInfo));
        };
        this.validateAddUpdateOrDeleteOptions = function (eventHub, options) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("options", _this.addUpdateOrDeleteOptionSchema, options));
        };
        this.validateSelectOrRenderOptions = function (eventHub, options) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("options", _this.selectOrRenderOptionSchema, options));
        };
        this.validateShowResourceParams = function (eventHub, showResourceParams) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("showResourceParams", _this.showResourceParamsSchema, showResourceParams));
        };
        this.validateOfferResourceParams = function (eventHub, offerResourceParams) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("offerResourceParams", _this.offerResourceParamsSchema, offerResourceParams));
        };
        this.validateSearchResourceParams = function (eventHub, searchResourceParams) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("searchResourceParams", _this.searchResourceParamsSchema, searchResourceParams));
        };
        this.validateFundStoredValueParams = function (eventHub, fundStoredValueParams) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("fundStoredValueParams", _this.fundStoredValueParamsSchema, fundStoredValueParams));
        };
        this.validateResourceOptions = function (eventHub, options) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("options", _this.resourceOptionsSchema, options));
        };
        this.validateResourceActionParams = function (eventHub, resourceActionParams) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("resourceActionParams", _this.resourceActionParamsSchema, resourceActionParams));
        };
        this.validatePaymentSessionData = function (eventHub, paymentSessionData) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("paymentSessionData", _this.paymentSessionDataSchema, paymentSessionData));
        };
        this.shouldValidateAuthorizationGroups = function (authorizationGroups, piid) {
            return piid === PaymentMethodPIIDs.applePay && authorizationGroups.length > 1;
        };
        this.validatePaymentSessionOrData = function (eventHub, paymentSessionOrData) {
            var _a;
            var schema;
            if (_this.isPaymentSession(paymentSessionOrData)) {
                schema = _this.paymentSessionSchema;
            }
            else {
                schema = _this.paymentSessionDataSchema;
                if ((_a = paymentSessionOrData === null || paymentSessionOrData === void 0 ? void 0 : paymentSessionOrData.recurringPaymentDetails) === null || _a === void 0 ? void 0 : _a.frequencyUnit) {
                    // Catalog has these values capitalized, we want it all lower case, we'll convert it for them
                    var frequencyUnit = paymentSessionOrData.recurringPaymentDetails.frequencyUnit;
                    paymentSessionOrData.recurringPaymentDetails.frequencyUnit = frequencyUnit.toLowerCase();
                }
                // If there are multiple authorization groups, we need to validate that the amount of each group adds up
                // to the total amount
                if ((paymentSessionOrData === null || paymentSessionOrData === void 0 ? void 0 : paymentSessionOrData.authorizationGroups) && _this.shouldValidateAuthorizationGroups(paymentSessionOrData.authorizationGroups, paymentSessionOrData === null || paymentSessionOrData === void 0 ? void 0 : paymentSessionOrData.piid)) {
                    var totalAmount = 0;
                    for (var _i = 0, _b = paymentSessionOrData.authorizationGroups; _i < _b.length; _i++) {
                        var group = _b[_i];
                        totalAmount += (group.totalAmount * 100); // avoid floating point errors
                    }
                    if (totalAmount !== ((paymentSessionOrData === null || paymentSessionOrData === void 0 ? void 0 : paymentSessionOrData.amount) * 100)) {
                        var error = new pidlErrors.unmatchedAmountError(errorMessages.unmatchedAmount, JSON.stringify(paymentSessionOrData));
                        eventHub.error(error);
                    }
                }
            }
            return _this.resultHandler(eventHub, _this.visitInputSchema("paymentSessionOrData", schema, paymentSessionOrData));
        };
        this.validatePurchaseRiskChallengeParams = function (eventHub, params) {
            var schemaName = "purchaseRiskChallengeSchema";
            var validationObjSchema = _this.purchaseRiskChallengeSchema;
            // update validation object schema for threeDS type
            if (params && params.riskChallengeData && params.riskChallengeData.length > 0 && params.riskChallengeData[0].toLowerCase() === "threeds") {
                schemaName = "purchaseRiskChallengeSchemaForThreeDS";
                validationObjSchema = _this.purchaseRiskChallengeSchemaForThreeDS;
            }
            return _this.resultHandler(eventHub, _this.visitInputSchema(schemaName, validationObjSchema, params));
        };
        this.validateHandlePurchasePendingStateParams = function (eventHub, params) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("purchasePendingStateSchema", _this.purchasePendingStateSchema, params));
        };
        this.validateSelectedResourceInfo = function (eventHub, selectedResourceInfo) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("selectedResourceInfo", _this.selectedResourceInfoSchema, selectedResourceInfo));
        };
        this.validateHandle = function (eventHub, handle) {
            return _this.resultHandler(eventHub, _this.visitInputSchema("handle", _this.handleSchema, handle));
        };
    }
    inputValidationHelper.prototype.isObjectSchema = function (obj) {
        return obj && obj.type === "object" /* ValidationDataType.object */;
    };
    inputValidationHelper.prototype.isArraySchema = function (obj) {
        return obj && obj.type === "array" /* ValidationDataType.array */;
    };
    inputValidationHelper.prototype.isSchemaSchema = function (obj) {
        return obj && obj.type === "schema" /* ValidationDataType.schema */;
    };
    inputValidationHelper.prototype.isPaymentSession = function (object) {
        return object && typehelper.isString(object.id) && object.id.length;
    };
    return inputValidationHelper;
}());
var inputValidationHelper$1 = new inputValidationHelper();

"use strict";
var Resources = /** @class */ (function () {
    function Resources(pidlDocManager) {
        this.constants = {};
        this.errors = {};
        var pidlDoc = pidlDocManager && pidlDocManager.getResolvedOrFirstPidlDoc();
        if (!pidlDoc || !pidlDoc.strings) {
            return;
        }
        var _a = pidlDoc.strings, constants = _a.constants, errorCodes = _a.errorCodes;
        if (constants) {
            this.constants = __assign({}, constants);
        }
        if (errorCodes) {
            this.errors = __assign({}, errorCodes);
        }
    }
    return Resources;
}());

"use strict";
var DataCache = /** @class */ (function () {
    function DataCache(keyComparerIn) {
        var _this = this;
        this.cache = null;
        this.keyComparer = null;
        this.put = function (key, value) {
            var index = _this.getCacheEntryIndex(key);
            if (index === -1) {
                _this.cache.push({ key: key, value: value });
            }
            else {
                _this.cache[index].value = value;
            }
        };
        this.get = function (key) {
            var index = _this.getCacheEntryIndex(key);
            return index !== -1 && _this.cache[index].value;
        };
        this.remove = function (key) {
            var index = _this.getCacheEntryIndex(key);
            var removedEntry = null;
            if (index !== -1) {
                removedEntry = _this.cache[index];
                _this.cache.splice(index, 1);
            }
            return removedEntry && removedEntry.value;
        };
        this.clear = function () {
            _this.cache = [];
        };
        this.removeIf = function (predicate) {
            if (predicate) {
                typehelper.filter(_this.cache, function (cacheEntry) {
                    return cacheEntry && cacheEntry.value ? !predicate(cacheEntry.value) : true;
                });
            }
        };
        this.cache = [];
        this.keyComparer = typehelper.isFunction(keyComparerIn) ? keyComparerIn : function (key1, key2) { return key1 === key2; };
    }
    DataCache.prototype.getCacheEntryIndex = function (key) {
        for (var index = 0; index < this.cache.length; index++) {
            if (this.keyComparer(this.cache[index].key, key)) {
                return index;
            }
        }
        return -1;
    };
    return DataCache;
}());

"use strict";
var DataStore = /** @class */ (function () {
    function DataStore() {
        var _this = this;
        this.modelDataCache = null;
        this.dataSourceCache = null;
        this.partnerData = null;
        this.saveModelData = function (pidlIdentity, modelDataProperties) {
            _this.modelDataCache.put(pidlIdentity, _this.getModelData(modelDataProperties));
        };
        this.readModelData = function (key) {
            return _this.modelDataCache.get(key);
        };
        this.saveDataSource = function (key, val) {
            _this.dataSourceCache[key] = val;
        };
        this.readDataSource = function (key) {
            return _this.dataSourceCache[key];
        };
        this.readAllDataSources = function () {
            return _this.dataSourceCache;
        };
        this.savePartnerData = function (val) {
            _this.partnerData = val;
        };
        this.readPartnerData = function () {
            return _this.partnerData;
        };
        this.clear = function () {
            _this.modelDataCache.clear();
            _this.partnerData = null;
            _this.clearDataSourceCache();
        };
        this.clearDataSourceCache = function () {
            _this.dataSourceCache = {};
        };
        this.modelDataCache = new DataCache();
        this.dataSourceCache = {};
    }
    DataStore.prototype.getModelData = function (modelDataProperties) {
        var modelData = {};
        if (modelDataProperties) {
            for (var key in modelDataProperties) {
                var modelDataProperty = modelDataProperties[key];
                if (modelDataProperty) {
                    modelData[key] = modelDataProperty.getValue();
                }
            }
        }
        return modelData;
    };
    return DataStore;
}());

"use strict";
// Each selection will have a default selection value, which will notify that there are other selections available
// This will be followed by set of selection values. On selecting any of these selection will show all properties and disabled.
// Last selection will point be a value indicating that user can add entries.
// It will be allowed to enter values while selecting first or last entries. And values will be preserved while switching
// between them.
var possibleValueType = /** @class */ (function () {
    function possibleValueType(value, objectId) {
        /*jshint -W040 */
        this.value = value;
        this.objectId = objectId;
    }
    return possibleValueType;
}());
var MultiPropertySelector = /** @class */ (function () {
    function MultiPropertySelector(pidlIdentityHash, defaultObjectIdIn, prefillObjectInfosIn, associatedModelDataPropertiesIn, defaultSelectionStrings) {
        var _this = this;
        this.possibleValues = [];
        this.index = -1;
        this.associatedModelDataProperties = null;
        this.pidlIdentity = null;
        this.getPossibleOptions = function () {
            var values = {};
            for (var index = 0; index < _this.possibleValues.length; index++) {
                values[index] = { displayText: _this.possibleValues[index].value };
            }
            return values;
        };
        this.getIndex = function () {
            return _this.index;
        };
        this.setIndex = function (indexIn) {
            _this.index = indexIn;
            var possibleValue = _this.possibleValues[_this.index];
            if (possibleValue) {
                var objectId = possibleValue.objectId;
                for (var i = 0; i < _this.associatedModelDataProperties.length; i++) {
                    _this.associatedModelDataProperties[i].setCurrentObjectId(objectId);
                }
            }
        };
        this.pidlIdentity = pidlIdentityHash;
        this.associatedModelDataProperties = associatedModelDataPropertiesIn;
        this.possibleValues = [];
        if (defaultSelectionStrings) {
            for (var idx = 0; idx < defaultSelectionStrings.length; idx++) {
                var str = defaultSelectionStrings[idx];
                this.possibleValues.push(new possibleValueType(str, defaultObjectIdIn));
            }
        }
        for (var i = 0; i < prefillObjectInfosIn.objectIds.length; i++) {
            var objectId = prefillObjectInfosIn.objectIds[i];
            if (objectId === defaultObjectIdIn) {
                continue;
            }
            var propertyValueInstance = [];
            for (var j = 0; j < this.associatedModelDataProperties.length; j++) {
                var modelDataProperty = this.associatedModelDataProperties[j];
                modelDataProperty.setCurrentObjectId(objectId);
                var propertyValue = modelDataProperty.getValue();
                if (propertyValue) {
                    propertyValueInstance.push(propertyValue);
                }
                modelDataProperty.setCurrentObjectId(defaultObjectIdIn);
            }
            this.possibleValues.push(new possibleValueType(utils.getStringValue(propertyValueInstance), objectId));
        }
    }
    return MultiPropertySelector;
}());

"use strict";
var pidlInfoType = /** @class */ (function () {
    function pidlInfoType(pageIndex) {
        this.modelDataProperties = [];
        this.pageIndex = pageIndex;
        this.allPropertyOnSamePage = true;
        this.modelDataProperties = [];
    }
    return pidlInfoType;
}());
var prefillObjectInfoType = /** @class */ (function () {
    function prefillObjectInfoType() {
        /*jshint -W040 */
        this.currentObjectId = null;
        this.objectIds = [];
        this.currentObjectId = null;
        this.objectIds = [];
    }
    return prefillObjectInfoType;
}());
var pidlResourceInstanceId = "pidlddc_object_id";
var InputPrefillDataManager = /** @class */ (function () {
    function InputPrefillDataManager(defaultInstanceIdIn) {
        var _this = this;
        this.prefillData = null;
        this.defaultInstanceId = null;
        this.multiPropertySelectors = {};
        this.modelDataProperties = {};
        this.pidlIdentityPrefillObjectMapping = {};
        this.pidlDocInfos = {};
        this.addId = function (dataIn) {
            if (typehelper.isArray(dataIn)) {
                for (var i = 0; i < dataIn.length; i++) {
                    _this.addId(dataIn[i]);
                }
            }
            else if (typehelper.isObject(dataIn)) {
                if (!dataIn[pidlResourceInstanceId]) {
                    dataIn[pidlResourceInstanceId] = utils.guid();
                }
                for (var key in dataIn) {
                    if (key === pidlResourceInstanceId) {
                        continue;
                    }
                    _this.addId(dataIn[key]);
                }
            }
        };
        this.getPropertyInstancesInternal = function (modelElement, data, instances) {
            if (typehelper.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    _this.getPropertyInstancesInternal(modelElement, data[i], instances);
                }
            }
            else if (typehelper.isObject(data)) {
                var propertyName = modelElement.getPropertyName();
                for (var key in data) {
                    if (key === propertyName) {
                        var dataId = data[pidlResourceInstanceId];
                        if (!dataId) {
                            if (_this.pidlIdentityPrefillObjectMapping[modelElement.pidlIdentity] && _this.pidlIdentityPrefillObjectMapping[modelElement.pidlIdentity].currentObjectId) {
                                dataId = _this.pidlIdentityPrefillObjectMapping[modelElement.pidlIdentity].currentObjectId;
                            }
                            else {
                                dataId = _this.defaultInstanceId;
                            }
                        }
                        var prefillValue = data[propertyName];
                        if (isDropdownElement(modelElement)) {
                            prefillValue = modelElementsHelper$1.normalizeValueToPossibleValues(modelElement, data[propertyName]);
                        }
                        instances[dataId] = prefillValue;
                    }
                    _this.getPropertyInstancesInternal(modelElement, data[key], instances);
                }
            }
        };
        this.getPropertyInstances = function (modelElement, data) {
            var instances = {};
            if (data) {
                _this.getPropertyInstancesInternal(modelElement, data, instances);
            }
            return instances;
        };
        this.parsePrefillData = function (modelElement) {
            var instances = _this.getPropertyInstances(modelElement, _this.prefillData);
            var modelDataProperty = _this.modelDataProperties[modelElement.getPropertyName()];
            modelDataProperty.setInstances(instances);
            if (typehelper.keyCount(instances) > 0) {
                var prefillObjectInfo = _this.pidlIdentityPrefillObjectMapping[modelElement.pidlIdentity];
                if (!prefillObjectInfo) {
                    prefillObjectInfo = new prefillObjectInfoType();
                    _this.pidlIdentityPrefillObjectMapping[modelElement.pidlIdentity] = prefillObjectInfo;
                }
                for (var instanceId in instances) {
                    if (!typehelper.contains(prefillObjectInfo.objectIds, instanceId)) {
                        prefillObjectInfo.objectIds.push(instanceId);
                    }
                }
                prefillObjectInfo.currentObjectId = prefillObjectInfo.objectIds[0];
            }
        };
        this.createPidlInfos = function (modelElement, context) {
            var pidlInfo = context.pidlInfos[modelElement.pidlIdentity];
            if (!pidlInfo) {
                pidlInfo = new pidlInfoType(context.pageIndex);
                context.pidlInfos[modelElement.pidlIdentity] = pidlInfo;
            }
            if (pidlInfo.pageIndex !== context.pageIndex) {
                pidlInfo.allPropertyOnSamePage = false;
            }
            var modelDataProperty = _this.modelDataProperties[modelElement.getPropertyName()];
            if (modelDataProperty) {
                pidlInfo.modelDataProperties.push(modelDataProperty);
            }
        };
        this.getPidlInfos = function (modelElements) {
            var pidlInfos = {};
            for (var index = 0; index < modelElements.length; index++) {
                modelElementsHelper$1.propertiesVisitorProcessingDataProperty(modelElements[index].children, _this.createPidlInfos, { pageIndex: index, pidlInfos: pidlInfos });
            }
            _this.pidlDocInfos = pidlInfos;
        };
        // Attempt to get the new and default selection strings from the pidl document's string resources.
        // If this fails, return nothing to indicate that we shouldn't draw the dropdown.
        this.getDefaultSelectionStrings = function (pidlIdHash, pidlDocManager, stringResources) {
            if (!pidlIdHash || !pidlDocManager) {
                return;
            }
            var identityString = pidlDocManager.getIdentityString(pidlIdHash);
            var defaultAddressDropdownKey = identityString + "_" + pidlStringKeys.prefillDropdownDefault;
            var newAddressDropdownKey = identityString + "_" + pidlStringKeys.prefillDropdownNew;
            var prefillDropdownDefaultValue = (stringResources || {})[defaultAddressDropdownKey];
            var prefillDropdownEnterNewAddressValue = (stringResources || {})[newAddressDropdownKey];
            if (!prefillDropdownDefaultValue || !prefillDropdownEnterNewAddressValue) {
                // We were unable to get the desired strings, don't draw this prefill
                return;
            }
            var defaultStrings = [];
            defaultStrings.push(prefillDropdownDefaultValue);
            defaultStrings.push(prefillDropdownEnterNewAddressValue);
            return defaultStrings;
        };
        // Multi property selectors are allowed based on the presence of multiple objects having set of property values of a sub/embedded PIDL
        // If different properties are present on different page, multi-property selectors will not be created.
        // If only few properties of an embedded PIDLs are present on a page and others are not present at all in any other page, multi-selection will be allowed
        // For sub-PIDLs all properties are read from a single embedded input object, not from different objects.
        // The outer most PIDL is an exception to the previous rule. And any properties for that might be read from any properties in the object.
        this.createMultiPropertySelectors = function (modelElements, stringResources, pidlDocManager, eventHub) {
            var prefillModelElement = modelElementsHelper$1.findPrefillControlElement(modelElements);
            var editableSelectType = false;
            for (var pidlIdHash in _this.pidlDocInfos) {
                var pidlInfo = _this.pidlDocInfos[pidlIdHash];
                var prefillObjectInfo = _this.pidlIdentityPrefillObjectMapping[pidlIdHash];
                var multiPropertySelector;
                var isMultiSelector = prefillModelElement && pidlInfo.allPropertyOnSamePage && pidlIdHash === prefillModelElement.pidlIdentity;
                if (prefillObjectInfo && prefillObjectInfo.objectIds && pidlInfo.modelDataProperties) {
                    if (isMultiSelector && prefillModelElement.type === modelElementType.checkBox) {
                        if (prefillObjectInfo.objectIds.length > 1) {
                            eventHub.error(new pidlErrors.unexpectedError(errorMessages.unexpectedPrefillDataCount, [pidlIdHash, "1", prefillObjectInfo.objectIds.length.toString()]));
                        }
                        multiPropertySelector = new MultiPropertySelector(pidlIdHash, _this.defaultInstanceId, prefillObjectInfo, pidlInfo.modelDataProperties);
                        _this.multiPropertySelectors[pidlIdHash] = multiPropertySelector;
                        editableSelectType = true;
                    }
                    else if (isMultiSelector && prefillModelElement.type === modelElementType.dropdown && prefillObjectInfo.objectIds.length > 1) {
                        var defaultSelectionStrings = _this.getDefaultSelectionStrings(pidlIdHash, pidlDocManager, stringResources);
                        multiPropertySelector = new MultiPropertySelector(pidlIdHash, _this.defaultInstanceId, prefillObjectInfo, pidlInfo.modelDataProperties, defaultSelectionStrings);
                        _this.multiPropertySelectors[pidlIdHash] = multiPropertySelector;
                    }
                    else {
                        for (var index = 0; index < pidlInfo.modelDataProperties.length; index++) {
                            pidlInfo.modelDataProperties[index].setDefaultObjectAsCurrent();
                        }
                    }
                }
            }
            return editableSelectType;
        };
        this.getPidlInfoMatch = function (prefillDataInstance) {
            for (var pidlIdHash in _this.pidlDocInfos) {
                var modelDataProps = _this.pidlDocInfos[pidlIdHash].modelDataProperties;
                for (var i = 0; i < modelDataProps.length; i++) {
                    if (prefillDataInstance[modelDataProps[i].propertyName]) {
                        return _this.pidlDocInfos[pidlIdHash];
                    }
                }
            }
        };
        // Fill missing properties in a given prefill data pidl with empty strings
        this.fillPrefillData = function () {
            for (var i = 0; i < _this.prefillData.length; i++) {
                var prefillInstance = _this.prefillData[i];
                var pidlInfoMatch = _this.getPidlInfoMatch(prefillInstance);
                if (pidlInfoMatch) {
                    for (var j = 0; j < pidlInfoMatch.modelDataProperties.length; j++) {
                        var propertyName = pidlInfoMatch.modelDataProperties[j].propertyName;
                        prefillInstance[propertyName] = prefillInstance[propertyName] ? prefillInstance[propertyName] : "";
                    }
                }
            }
        };
        this.getPropertyValueInternal = function (propertyName, prefillDataIn, newValue) {
            if (prefillDataIn) {
                if (newValue === undefined) {
                    if (typehelper.isArray(prefillDataIn)) {
                        for (var i = 0; i < prefillDataIn.length; i++) {
                            newValue = newValue || _this.getPropertyValueInternal(propertyName, prefillDataIn[i], newValue);
                        }
                    }
                    else if (typehelper.isObject(prefillDataIn) || prefillDataIn.hasOwnProperty(propertyName)) {
                        for (var key in prefillDataIn) {
                            if (propertyName === key) {
                                newValue = prefillDataIn[key];
                            }
                            else if (newValue === undefined) {
                                newValue = _this.getPropertyValueInternal(propertyName, prefillDataIn[key], newValue);
                            }
                        }
                    }
                }
                return newValue;
            }
        };
        this.reset = function () {
            _this.prefillData = null;
            _this.multiPropertySelectors = {};
            _this.modelDataProperties = {};
            _this.pidlIdentityPrefillObjectMapping = {};
            _this.pidlDocInfos = {};
        };
        this.parse = function (prefillDataIn, modelElements, modelDataPropertiesIn, stringResources, pidlDocManager, eventHub) {
            var editable = false;
            _this.prefillData = prefillDataIn;
            _this.addId(_this.prefillData);
            _this.multiPropertySelectors = {};
            _this.modelDataProperties = modelDataPropertiesIn;
            _this.getPidlInfos(modelElements);
            if (_this.prefillData) {
                _this.fillPrefillData();
                modelElementsHelper$1.propertiesVisitorProcessingDataProperty(modelElements, _this.parsePrefillData);
                editable = _this.createMultiPropertySelectors(modelElements, stringResources, pidlDocManager, eventHub);
            }
            return { multiPropertySelectors: _this.multiPropertySelectors, editable: editable };
        };
        this.getPropertyValue = function (propertyName) {
            if (_this.prefillData) {
                return _this.getPropertyValueInternal(propertyName, _this.prefillData);
            }
        };
        this.getPrefillData = function () {
            return _this.prefillData || {};
        };
        this.testHookGetParsePrefillDataFunc = function () {
            return _this.parsePrefillData;
        };
        this.defaultInstanceId = defaultInstanceIdIn;
    }
    return InputPrefillDataManager;
}());

"use strict";
var ModelDataProperty = /** @class */ (function () {
    function ModelDataProperty(propertyNameIn, defaultObjectIdIn, objectIdValuesMappingIn, modelElementIn) {
        var _this = this;
        this.objectId = null;
        this.defaultObjectId = null;
        this.objectIdValuesMapping = {};
        this.propertyName = null;
        this.modelElement = null;
        this.editState = null;
        this.setCurrentObjectId = function (objectIdIn) {
            _this.objectId = objectIdIn;
        };
        this.setDefaultObjectAsCurrent = function () {
            var firstKey = null;
            for (firstKey in _this.objectIdValuesMapping) {
                if (firstKey !== _this.defaultObjectId) {
                    break;
                }
            }
            var value = null;
            if (firstKey) {
                value = _this.objectIdValuesMapping[firstKey];
            }
            _this.objectIdValuesMapping[_this.defaultObjectId] = value;
            _this.objectId = _this.defaultObjectId;
        };
        this.setValue = function (value) {
            var changedPrefill = false;
            if (!value && _this.modelElement && _this.modelElement.hidden()) {
                if (_this.modelElement.defaultValue) {
                    value = _this.modelElement.defaultValue;
                }
            }
            if (_this.objectId !== _this.defaultObjectId && value !== _this.objectIdValuesMapping[_this.objectId]) {
                // Prefilled data is being changed by the user, set back to defaultObjectId
                // to prevent prefill addresses from being overwritten
                _this.objectId = _this.defaultObjectId;
                changedPrefill = true;
            }
            _this.objectIdValuesMapping[_this.objectId] = value;
            return changedPrefill;
        };
        this.getValue = function (forSubmit, forPartner) {
            var value = _this.objectIdValuesMapping[_this.objectId];
            if (isSelectionElement(_this.modelElement) && typehelper.isObject(_this.modelElement.possibleOptions)) {
                if (_this.modelElement.possibleOptions[value]) {
                    if (forSubmit && forPartner &&
                        value &&
                        (_this.modelElement.possibleOptions[value]).pidlAction) {
                        return (_this.modelElement.possibleOptions[value]).pidlAction.context;
                    }
                }
                else {
                    return modelElementsHelper$1.normalizeValueToPossibleValues(_this.modelElement, value);
                }
            }
            return value;
        };
        this.isEditable = function (editablePrefillData) {
            return (_this.objectId === _this.defaultObjectId || editablePrefillData) && (!_this.modelElement || !_this.modelElement.disabled());
        };
        this.setInstances = function (instances) {
            _this.objectIdValuesMapping = utils.extend(_this.objectIdValuesMapping, instances);
        };
        this.propertyName = propertyNameIn;
        this.modelElement = modelElementIn;
        this.editState = propertyEditState.clean;
        this.objectId = defaultObjectIdIn;
        this.defaultObjectId = defaultObjectIdIn;
        this.objectIdValuesMapping = objectIdValuesMappingIn;
    }
    return ModelDataProperty;
}());

"use strict";
var ModelData = /** @class */ (function () {
    function ModelData(pidlDocManagerIn) {
        var _this = this;
        this.inputPrefillDataManager = null;
        this.multiPropertySelectors = {};
        this.modelDataProperties = {};
        this.inputInstance = null;
        this.pidlDocManager = null;
        this.dataStore = null;
        this.resourceResponse = null;
        this.getInstancePropertyValue = function (propertyName, data, value) {
            if (typehelper.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    if (_this.getInstancePropertyValue(propertyName, data[i], value)) {
                        return true;
                    }
                }
            }
            else if (typehelper.isObject(data)) {
                for (var key in data) {
                    if (key === propertyName) {
                        value[propertyName] = data[propertyName];
                        return true;
                    }
                    if (_this.getInstancePropertyValue(propertyName, data[key], value)) {
                        return true;
                    }
                }
            }
        };
        this.getDisplayPropertyValueInternal = function (propertyName) {
            var value = _this.displayData && _this.displayData.details && _this.displayData.details[propertyName];
            if (value) {
                return value;
            }
            // TODO: Should modelData have the logic to interpret possible values?  This feels like it should be taken care of in the model or somewhere else.
            var modelDataProperty = _this.modelDataProperties[propertyName];
            if (modelDataProperty) {
                var selectionPropertyElement = modelDataProperty.modelElement;
                if (selectionPropertyElement && selectionPropertyElement.possibleOptions) {
                    var key = modelDataProperty.getValue();
                    var selectedOption = selectionPropertyElement.possibleOptions[key];
                    if (selectedOption) {
                        return selectedOption.displayText;
                    }
                }
            }
        };
        this.maskPropertyValueFlagExists = function (propertyName) {
            var modelDataProperty = _this.modelDataProperties[propertyName];
            return modelDataProperty && modelDataProperty.modelElement && modelDataProperty.modelElement.maskDisplay;
        };
        this.mergeUserDataInternal = function (modelElement, context) {
            var propertyName = modelElement.getPropertyName();
            if (!context.userData.hasOwnProperty(propertyName)) {
                return;
            }
            var value = context.userData[propertyName];
            // Do not merge mask display value with real data
            var maskedValue = _this.getMaskedPropertyValue(propertyName);
            if (maskedValue && value === maskedValue) {
                return;
            }
            var modelDataProperty = _this.modelDataProperties[propertyName];
            var oldValue = modelDataProperty.getValue(false);
            if (value !== oldValue && context.conflictingInputValueReporter) {
                context.conflictingInputValueReporter(propertyName);
            }
            modelDataProperty.setValue(value);
        };
        this.updateModelElement = function (modelElement) {
            var propertyName = modelElement.getPropertyName();
            var dataProperty = _this.modelDataProperties[propertyName];
            if (!dataProperty) {
                _this.populateInternal(modelElement);
                dataProperty = _this.modelDataProperties[propertyName];
            }
            var oldModelElement = dataProperty.modelElement;
            if (oldModelElement && modelElement.pidlIdentity !== oldModelElement.pidlIdentity) {
                dataProperty.modelElement = modelElement;
                var propertySelector = _this.multiPropertySelectors[oldModelElement.pidlIdentity];
                if (propertySelector) {
                    _this.multiPropertySelectors[modelElement.pidlIdentity] = propertySelector;
                    propertySelector.pidlIdentity = modelElement.pidlIdentity;
                    delete _this.multiPropertySelectors[oldModelElement.pidlIdentity];
                }
            }
        };
        this.populateInternal = function (modelElement) {
            var instances = {};
            var propertyName = modelElement.getPropertyName();
            // Added to support split radio input with same property name so that first element created is the default in modelData
            if (!_this.modelDataProperties[propertyName]) {
                instances[_this.defaultInstanceId] = modelElement.defaultValue;
                _this.modelDataProperties[propertyName] = new ModelDataProperty(propertyName, _this.defaultInstanceId, instances, modelElement);
            }
        };
        this.getPropertyInternal = function (propertyName, forSubmit, forPartner) {
            var canEdit = true;
            var value = null;
            var modelDataProperty = _this.modelDataProperties[propertyName];
            if (modelDataProperty) {
                value = modelDataProperty.getValue(forSubmit, forPartner);
                canEdit = modelDataProperty.isEditable(_this.editablePrefillData);
            }
            else {
                if (_this.inputInstance && _this.inputInstance.hasOwnProperty(propertyName)) {
                    value = _this.inputInstance[propertyName];
                }
                else {
                    value = _this.inputPrefillDataManager.getPropertyValue(propertyName);
                }
            }
            return { value: value, editable: canEdit, propertyName: propertyName };
        };
        this.setJumpbackData = function (jumpbackData) {
            if (!jumpbackData) {
                return;
            }
            for (var key in _this.modelDataProperties) {
                if (jumpbackData.hasOwnProperty(key)) {
                    _this.modelDataProperties[key].setValue(jumpbackData[key]);
                }
            }
        };
        this.removeClientAction = function (response) {
            if (response) {
                var clone = typehelper.deepCopy(response);
                delete clone.clientAction;
                return clone;
            }
            else {
                return response;
            }
        };
        this.setPrefillData = function (model, prefillDataIn, stringResources, eventHub) {
            if (!model.elements || !prefillDataIn) {
                return;
            }
            var parseObject = _this.inputPrefillDataManager.parse(prefillDataIn, model.elements, _this.modelDataProperties, stringResources, model.pidlDocManager, eventHub);
            _this.multiPropertySelectors = parseObject.multiPropertySelectors;
            _this.editablePrefillData = parseObject.editable;
            _this.setPrefillDataInPartnerDataSource(prefillDataIn);
        };
        this.getPrefillData = function () {
            return _this.inputPrefillDataManager.getPrefillData();
        };
        this.setPrefillDataInPartnerDataSource = function (prefillDataIn) {
            var partnerData = _this.getPartnerData() || {};
            partnerData.prefillData = prefillDataIn;
            _this.setPartnerData(partnerData);
        };
        this.setInputParametersInPartnerDataSource = function (inputParameters) {
            var partnerData = _this.getPartnerData() || {};
            partnerData.inputParameters = inputParameters;
            _this.setPartnerData(partnerData);
        };
        this.setDisplayData = function (displayDataIn) {
            _this.displayData = displayDataIn;
        };
        this.updateUserData = function (payload) {
            _this.setJumpbackData(payload);
        };
        this.mergeUserData = function (model, modelDataIn, conflictingInputValueReporter) {
            if (modelDataIn && model && model.elements) {
                modelElementsHelper$1.propertiesVisitorProcessingDataProperty(model.elements, _this.mergeUserDataInternal, { userData: modelDataIn, conflictingInputValueReporter: conflictingInputValueReporter });
            }
        };
        this.updateModelElements = function (modelElements) {
            if (!modelElements) {
                return;
            }
            modelElementsHelper$1.propertiesVisitorProcessingDataProperty(modelElements, _this.updateModelElement);
        };
        this.getPropertyValue = function (propertyName, forSubmit, forPartner) {
            var property = _this.getPropertyInternal(propertyName, forSubmit, forPartner);
            if (property) {
                return property.value;
            }
        };
        this.getProperty = function (propertyName) {
            return _this.getPropertyInternal(propertyName);
        };
        this.getPropertyModelElement = function (propertyName) {
            return _this.modelDataProperties[propertyName] ? _this.modelDataProperties[propertyName].modelElement : null;
        };
        this.getDisplayPropertyValue = function (propertyName) {
            return _this.getDisplayPropertyValueInternal(propertyName);
        };
        // TODO: For short term, building masked display value on top of
        // display value. In long term, we might like to update this to
        // store masked value separately.
        this.getMaskedPropertyValue = function (propertyName) {
            return _this.maskPropertyValueFlagExists(propertyName) && _this.displayData && _this.displayData.details && _this.displayData.details[propertyName];
        };
        this.clearMaskedPropertyValue = function (propertyName) {
            if (_this.maskPropertyValueFlagExists(propertyName) && _this.displayData && _this.displayData.details && _this.displayData.details[propertyName]) {
                _this.displayData.details[propertyName] = null;
            }
        };
        this.getModelDataProperty = function (propertyName) {
            return _this.modelDataProperties[propertyName];
        };
        this.setMultiPropertySelectorIndex = function (pidlIdentity, index) {
            var multiPropertySelector = _this.multiPropertySelectors[pidlIdentity];
            if (multiPropertySelector) {
                multiPropertySelector.setIndex(index);
            }
        };
        this.getMultiPropertySelectorIndex = function (pidlIdentity) {
            var multiPropertySelector = _this.multiPropertySelectors[pidlIdentity];
            if (multiPropertySelector) {
                return multiPropertySelector.getIndex();
            }
        };
        this.getMultiPropertySelectorPossibleOptions = function (pidlIdentity) {
            var multiPropertySelector = _this.multiPropertySelectors[pidlIdentity];
            if (multiPropertySelector) {
                return multiPropertySelector.getPossibleOptions();
            }
        };
        this.getId = function () {
            if (_this.inputInstance) {
                if (_this.inputInstance.hasOwnProperty("id")) {
                    return _this.inputInstance.id;
                }
            }
            else {
                return _this.inputPrefillDataManager.getPropertyValue("id");
            }
        };
        this.setDataSource = function (dataSourceName, dataObj) {
            _this.dataStore.saveDataSource(dataSourceName, dataObj);
        };
        this.getDataSource = function (dataSourceName) {
            return _this.dataStore.readDataSource(dataSourceName);
        };
        this.getAllDataSources = function () {
            return _this.dataStore.readAllDataSources();
        };
        this.setPartnerData = function (partnerData) {
            _this.dataStore.savePartnerData(partnerData);
        };
        this.getPartnerData = function () {
            return _this.dataStore.readPartnerData();
        };
        this.cacheFlow = function () {
            var pidlIdentity = _this.pidlDocManager.getPidlIdentity();
            if (pidlIdentity) {
                _this.dataStore.saveModelData(pidlDocHelper$1.createIdentityHash(pidlIdentity), _this.modelDataProperties);
            }
            return pidlIdentity;
        };
        this.clearFlow = function () {
            _this.displayData = null;
            _this.modelDataProperties = {};
            _this.multiPropertySelectors = {};
            _this.inputInstance = null;
            _this.inputPrefillDataManager.reset();
        };
        this.clearAll = function () {
            _this.dataStore.clear();
            _this.resourceResponse = null;
            _this.clearFlow();
        };
        this.clearDataSourceCache = function () {
            _this.dataStore.clearDataSourceCache();
        };
        this.populate = function (modelElements) {
            modelElementsHelper$1.propertiesVisitorProcessingDataProperty(modelElements, _this.populateInternal);
        };
        this.getModelDataProperties = function (modelElements) {
            var context = { properties: {} };
            modelElementsHelper$1.propertiesVisitorProcessingDataProperty(modelElements, function (modelElement, context) {
                var propertyName = modelElement.getPropertyName();
                var modelDataProperty = _this.modelDataProperties[propertyName];
                if (modelDataProperty) {
                    context.properties[propertyName] = modelDataProperty;
                }
            }, context);
            return context.properties;
        };
        this.setInputInstance = function (modelElements, inputInstanceIn) {
            if (!inputInstanceIn) {
                return;
            }
            modelElementsHelper$1.propertiesVisitorProcessingDataProperty(modelElements, function (modelElement, context) {
                var value = {};
                var propertyName = modelElement.getPropertyName();
                if (_this.getInstancePropertyValue(propertyName, context.inputInstanceDetails, value)) {
                    var modelDataProperty = _this.modelDataProperties[propertyName];
                    modelDataProperty.setValue(value[propertyName]);
                }
            }, { inputInstanceDetails: inputInstanceIn });
            _this.inputInstance = inputInstanceIn;
        };
        this.setPrimaryResourceResponse = function (response, secondaryResponses) {
            var trimmedSecondResponses = [];
            if (secondaryResponses && secondaryResponses.length) {
                secondaryResponses.forEach(function (it) { return trimmedSecondResponses.push(_this.removeClientAction(it)); });
            }
            _this.resourceResponse = {
                primary: _this.removeClientAction(response),
                secondary: trimmedSecondResponses
            };
        };
        this.retrieveFromCache = function (pidlIdentity, propertyNamesToBeClearedFromCache) {
            pidlIdentity = pidlIdentity || _this.pidlDocManager.getPidlIdentity();
            if (pidlIdentity) {
                var data = _this.dataStore.readModelData(pidlDocHelper$1.createIdentityHash(pidlIdentity));
                if (propertyNamesToBeClearedFromCache) {
                    for (var i = 0; i < propertyNamesToBeClearedFromCache.length; i++) {
                        if (data.hasOwnProperty(propertyNamesToBeClearedFromCache[i])) {
                            delete data[propertyNamesToBeClearedFromCache[i]];
                        }
                    }
                }
                if (data) {
                    _this.setJumpbackData(data);
                    return true;
                }
            }
        };
        this.getPrimaryResourceResponseId = function () {
            return _this.resourceResponse && _this.resourceResponse.primary && _this.resourceResponse.primary.id;
        };
        this.getResourceResponse = function () {
            return _this.resourceResponse;
        };
        this.testHookSetMultiPropertySelectors = function (multiPropertySelectorsIn) {
            _this.multiPropertySelectors = multiPropertySelectorsIn;
        };
        this.testHookGetMultiPropertySelectors = function () {
            return _this.multiPropertySelectors;
        };
        this.testHookSetModelDataProperties = function (modelDataPropertiesIn) {
            _this.modelDataProperties = modelDataPropertiesIn;
        };
        this.testHookGetModelDataProperties = function () {
            return _this.modelDataProperties;
        };
        this.testHookGetDefaultInstanceId = function () {
            return _this.defaultInstanceId;
        };
        this.testHookGetDisplayData = function () {
            return _this.displayData;
        };
        this.testHookSetInputPrefillDataManager = function (inputPrefillDataManagerIn) {
            _this.inputPrefillDataManager = inputPrefillDataManagerIn;
        };
        this.testHookSetEditablePrefillData = function (editablePrefillDataIn) {
            _this.editablePrefillData = editablePrefillDataIn;
        };
        this.displayData = null;
        this.defaultInstanceId = utils.guid();
        this.inputPrefillDataManager = new InputPrefillDataManager(this.defaultInstanceId);
        this.multiPropertySelectors = {};
        this.pidlDocManager = pidlDocManagerIn;
        this.dataStore = new DataStore();
    }
    return ModelData;
}());

"use strict";
var validationFunctions = /** @class */ (function () {
    function validationFunctions() {
        this.luhn = function (cardnumber) {
            // Luhn algorithm:
            // 1. From the rightmost digit, which is the check digit, and moving left, double the value of every second digit.
            //    The check digit is not doubled, the first digit doubled is immediately to the left of the check digit.
            //    If the result of this doubling operation is greater than 9, subtract 9 from the result.
            // 2. Take the sum of all the digits.
            // 3. If the total mod 10 is equal to 0 then the number is valid according to the Luhn formula; else it is not valid.
            var sum = 0;
            var double = false;
            for (var i = cardnumber.length - 1; i >= 0; i--) {
                var digit = parseInt(cardnumber.charAt(i));
                if (double) {
                    digit *= 2;
                    if (digit > 9) {
                        digit -= 9;
                    }
                }
                sum += digit;
                double = !double;
            }
            return sum % 10 === 0;
        };
    }
    return validationFunctions;
}());
var validationFunctions$1 = new validationFunctions();

"use strict";
var PromiseResultHelper = /** @class */ (function () {
    function PromiseResultHelper() {
        this.aggregateCommerceResults = function (promises, errorMessageGetter) {
            if (!promises.length) {
                return createFakePromise({ innerErrors: [] });
            }
            return new Promise(function (resolve, reject) {
                var innerErrors = [];
                var resolvedPromiseCount = 0;
                var onComplete = function () {
                    resolvedPromiseCount++;
                    if (resolvedPromiseCount === promises.length) {
                        var baseError = innerErrors.length ? innerErrors[0].error : null;
                        baseError = innerErrors.length && errorMessageGetter ? errorMessageGetter(baseError) : baseError;
                        resolve({
                            innerErrors: innerErrors,
                            error: baseError
                        });
                    }
                };
                promises.forEach(function (promise) {
                    promise.then(function (result) {
                        if (result.error) {
                            innerErrors.push(result);
                        }
                        onComplete();
                    }).catch(function (err) {
                        // TODO: It is good to add a check here and handle different cases
                        // separately. They include err being an IError or not. In case of IError
                        // we can create a new error instance without wrapping it. In other cases
                        // wrapping should happen with some known error code.
                        innerErrors.push({ error: new pidlErrors.unexpectedError(err) });
                        onComplete();
                    });
                });
            });
        };
    }
    return PromiseResultHelper;
}());
var PromiseResultHelper$1 = new PromiseResultHelper();

"use strict";
var UserInputDataValidator = /** @class */ (function () {
    function UserInputDataValidator() {
        var _this = this;
        this.validateUserInputDataFromService = function (eventHub, urlValidationType, propertyName, propertyValue, pidlOperation, url, fetchConfig) {
            var validationUrl = urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.validation.endpoint), [url]);
            var data = {
                value: propertyValue,
                propertyName: propertyName
            };
            if (urlValidationType) {
                data["urlValidationType"] = urlValidationType;
            }
            var postData = JSON.stringify(data);
            var httpHeaders$1 = fetchHelper.getDefaultHttpHeaders(eventHub);
            httpHeaders$1[httpHeaders.msFlight] = "pxpidl";
            return new Promise(function (resolve, reject) {
                fetchHelper.post(eventHub, true, validationUrl, httpHeaders$1, postData, function (validatedData) {
                    var error = typehelper.equalsIgnoreCase(validatedData.status, pidlResultType.Passed) ?
                        null :
                        new pidlErrors.propertyValidationFailedError(errorMessages.propertyValidationFailed, validatedData.errorCode, propertyName, [propertyName, validatedData.errorCode]);
                    resolve({ error: error });
                }, function (fetchFailureMessage) {
                    // TODO: On service failure, showing an error message
                    // for empty property is confusing. There should
                    // be an specific error code in PIDL for providing
                    // error message for this kind of error.
                    resolve({
                        error: new pidlErrors.propertyValidationFailedError(errorMessages.propertyValidationFailed, validationErrorCodes.empty, propertyName, [propertyName, validationErrorCodes.empty])
                    });
                }, pidlOperation, config$1.virtualEndpoints.validation.operation, config$1.virtualEndpoints.validation.description, true, fetchConfig).catch(
                // We're looking for failures using callbacks, so ignore rejections
                doNothing);
            });
        };
        this.validateUserInputDataInternal = function (eventHub, pidlDocument, userInputData, pidlOperation, modelData) {
            var dataDescription = pidlDocument.data_description;
            var promises = [];
            for (var propertyName in dataDescription) {
                var propertyDescription = dataDescription[propertyName];
                if (isPidlDocumentArray(propertyDescription)) {
                    var innerPidlDoc = propertyDescription && propertyDescription.length && propertyDescription[0];
                    if (innerPidlDoc) {
                        promises = promises.concat(_this.validateUserInputDataInternal(eventHub, innerPidlDoc, userInputData[propertyName], pidlOperation, modelData));
                    }
                }
                else {
                    if (propertyDescription.displayOnly || (pidlOperation === pidlOperationTypeValues.update && !propertyDescription.is_updatable)) {
                        continue;
                    }
                    var modelElement = null;
                    if (modelData) {
                        var dataProperty = modelData.getModelDataProperty(propertyName);
                        if (dataProperty) {
                            modelElement = dataProperty.modelElement;
                        }
                    }
                    promises.push(_this.validatePropertyFromPropertyDescription(eventHub, modelElement, commerceHelper$1.getPropertyValueFromInputData(userInputData, propertyName), pidlOperation, propertyName, propertyDescription));
                }
            }
            return promises;
        };
        this.validatePropertyFromPropertyDescription = function (eventHub, modelElement, propertyValue, pidlOperation, propertyName, propertyDescription) {
            var _a;
            var status = pidlResultType.Passed;
            var errorCode = null;
            var promise$1 = null;
            if ((modelElement === null || modelElement === void 0 ? void 0 : modelElement.type) === modelElementType.secureProperty) {
                promise$1 = modelElement.validate().then(function (errorCode) {
                    if (errorCode) {
                        var error = new pidlErrors.propertyValidationFailedError(errorMessages.propertyValidationFailed, errorCode, propertyDescription.display_property || propertyName, [propertyDescription.display_property || propertyName, errorCode]);
                        return { error: error };
                    }
                    else {
                        return { error: null };
                    }
                });
            }
            // This is a required property.  So, whether the DataDescription has a validation rule or not,
            // this property cannot be left blank by the user.
            else if (!propertyValue) {
                if (!propertyDescription.is_optional) {
                    status = pidlResultType.Fail;
                    errorCode = validationErrorCodes.empty;
                }
            }
            else if (propertyDescription.validation || propertyDescription.validations) {
                var validations = propertyDescription.validations == null ? [propertyDescription.validation] : propertyDescription.validations;
                for (var i = 0; (i < validations.length) && (status === pidlResultType.Passed); i++) {
                    var validationType = validations[i].validationType;
                    switch (validationType) {
                        case validationModesValues.regex:
                            var validationRegex = new RegExp(validations[i].regex);
                            if (modelElement && modelElement.type && modelElement.type === modelElementType.filePicker) {
                                if (propertyValue && propertyValue.name && validationRegex.test(propertyValue.name) === false) {
                                    status = pidlResultType.Fail;
                                    errorCode = validations[i].error_code;
                                }
                            }
                            else if (validationRegex.test(propertyValue) === false) {
                                status = pidlResultType.Fail;
                            }
                            break;
                        case validationModesValues.function:
                            if (!(validationFunctions$1[validations[i].function] &&
                                validationFunctions$1[validations[i].function](propertyValue))) {
                                status = pidlResultType.Fail;
                                errorCode = validations[i].error_code;
                            }
                            break;
                        case validationModesValues.service:
                            promise$1 = _this.validateUserInputDataFromService(eventHub, validations[i].urlValidationType, propertyName, propertyValue, pidlOperation, validations[i].url, (_a = propertyDescription === null || propertyDescription === void 0 ? void 0 : propertyDescription.dataProtection) === null || _a === void 0 ? void 0 : _a.fetchConfig);
                            break;
                        case validationModesValues.size:
                            var maxFileSize = validations[i].maxFileSize;
                            if (modelElement && modelElement.type && modelElement.type === modelElementType.filePicker) {
                                if (propertyValue && propertyValue.size && propertyValue.size > maxFileSize) {
                                    status = pidlResultType.Fail;
                                    errorCode = validations[i].error_code;
                                }
                            }
                            break;
                    }
                }
            }
            if (!promise$1) {
                var error = (status === pidlResultType.Passed) ? null : new pidlErrors.propertyValidationFailedError(errorMessages.propertyValidationFailed, errorCode, propertyDescription.display_property || propertyName, [propertyDescription.display_property || propertyName, errorCode]);
                promise$1 = createFakePromise({ error: error });
            }
            return promise$1;
        };
        // function userInputDataValidator.validateUserInputData
        //   This function iterates through every property in the userInputData, performs validation checks
        //   and calls onValidationFail for every input field that fails validation.
        //
        this.validateUserInputData = function (eventHub, pidlDocument, userInputData, pidlOperation, modelData) {
            var promises = _this.validateUserInputDataInternal(eventHub, pidlDocument, userInputData, pidlOperation, modelData);
            return PromiseResultHelper$1.aggregateCommerceResults(promises);
        };
        // function userInputDataValidator.validatePropertyByName
        //   This function iterates through the properties and validates the matching property against the pidl metadata
        //
        this.validateUserInputProperty = function (eventHub, modelElement, propertyValue, pidlOperation) {
            var promise = _this.validatePropertyFromPropertyDescription(eventHub, modelElement, propertyValue, pidlOperation, modelElement.getPropertyName(), modelElement.dataDescription);
            return PromiseResultHelper$1.aggregateCommerceResults([promise]);
        };
    }
    return UserInputDataValidator;
}());
var UserInputDataValidator$1 = new UserInputDataValidator();

"use strict";
var Validator = /** @class */ (function () {
    function Validator(eventHubIn, alwaysValidateOnChangeIn) {
        var _this = this;
        this.shouldValidateProperty = function (modelDataProperty, controlOperationType) {
            if (_this.alwaysValidateOnChange) {
                return true;
            }
            var propertyState = modelDataProperty.editState;
            var modelElement = modelDataProperty.modelElement;
            if (modelElement && (modelElement.type === modelElementType.textBox ||
                modelElement.type === modelElementType.dropdown ||
                modelElement.type === modelElementType.checkBox ||
                modelElement.type === modelElementType.secureProperty)) {
                switch (propertyState) {
                    case propertyEditState.clean:
                        return false;
                    case propertyEditState.editing:
                        return controlOperationType === controlOperationTypes.finished ? true : false;
                    case propertyEditState.dirty:
                        return true;
                }
            }
            else {
                if (propertyState === propertyEditState.clean) {
                    return modelDataProperty.getValue() !== "";
                }
                return controlOperationType === controlOperationTypes.editing || controlOperationType === controlOperationTypes.finished;
            }
        };
        this.shouldValidatePropertyInPageValidation = function (propertyState, validationOption) {
            if (validationOption === validationOptions.dirtyOnly) {
                return propertyState === propertyEditState.dirty;
            }
            return true;
        };
        // Gets updated property states.
        // If the property state needs to be updated, it returns the new state, else it returns null.
        this.getUpdatedPropertyState = function (modelDataProperty, controlOperationType) {
            var propertyState = modelDataProperty.editState;
            var modelElement = modelDataProperty.modelElement;
            if (modelElement && (modelElement.type === modelElementType.textBox ||
                modelElement.type === modelElementType.dropdown ||
                modelElement.type === modelElementType.checkBox ||
                modelElement.type === modelElementType.secureProperty)) {
                switch (propertyState) {
                    case propertyEditState.clean:
                        // If edit state is editing, set edit state to editing and validate it
                        return controlOperationType === controlOperationTypes.editing ? propertyEditState.editing : null;
                    case propertyEditState.editing:
                        // If edit state is dirty, set edit state to dirty and validate it
                        return controlOperationType === controlOperationTypes.finished ? propertyEditState.dirty : null;
                    case propertyEditState.dirty:
                        return null;
                }
            }
            else if (propertyState === propertyEditState.clean && modelDataProperty.getValue() !== "") {
                return propertyEditState.dirty;
            }
            else {
                return null;
            }
        };
        this.validatePropertyValue = function (modelDataProperty, pidlOperation) {
            /**
             * Promise Callsites:
             * validator.validatePageElements = rejection not handled
             *  => validator.validatePage = rejection handled
             * validator.validateProperty = rejection handled
             */
            return UserInputDataValidator$1.validateUserInputProperty(_this.eventHub, modelDataProperty.modelElement, modelDataProperty.getValue(), pidlOperation);
        };
        this.validatePageElements = function (modelDataProperties, validationOption, pidlOperation, validationErrors) {
            var promises = [];
            for (var propertyName in modelDataProperties) {
                var modelDataProperty = modelDataProperties[propertyName];
                if (_this.shouldValidatePropertyInPageValidation(modelDataProperty.editState, validationOption)) {
                    promises.push(_this.validatePropertyValue(modelDataProperty, pidlOperation).then(function (result) {
                        var validationError = result.error;
                        if (!validationError) {
                            return;
                        }
                        var failedModelDataProperty = modelDataProperties[validationError.propertyName];
                        if (!failedModelDataProperty) {
                            return;
                        }
                        var modelElement = failedModelDataProperty.modelElement;
                        if (isPropertyElement(modelElement) || isSecurePropertyElement(modelElement)) {
                            validationError.message = modelElement.getErrorMessage(failedModelDataProperty.getValue(), validationError.errorCode);
                        }
                        failedModelDataProperty.editState = propertyEditState.dirty;
                        validationErrors.push(validationError);
                    }).catch(function () { return doNothing; }));
                }
            }
            return promises;
        };
        this.validateProperty = function (modelDataProperty, controlOperationType, pidlOperation) {
            var shouldValidate = _this.shouldValidateProperty(modelDataProperty, controlOperationType);
            var updatedPropertyState = _this.getUpdatedPropertyState(modelDataProperty, controlOperationType);
            if (updatedPropertyState) {
                modelDataProperty.editState = updatedPropertyState;
            }
            return new Promise(function (resolve, reject) {
                if (!shouldValidate) {
                    resolve();
                    return;
                }
                _this.validatePropertyValue(modelDataProperty, pidlOperation).then(function (result) {
                    var validationError = result.error;
                    if (!validationError) {
                        _this.eventHub.propertyValidated(modelDataProperty.propertyName, controlOperationType);
                    }
                    else {
                        var modelElement = modelDataProperty.modelElement;
                        if (isPropertyElement(modelElement) || isSecurePropertyElement(modelElement)) {
                            validationError.message = modelElement.getErrorMessage(modelDataProperty.getValue(), validationError.errorCode);
                        }
                        _this.eventHub.error(validationError, controlOperationType);
                    }
                    resolve();
                }).catch(function () { return doNothing; });
            });
        };
        this.clearElementEditState = function (dataProperty) {
            dataProperty.editState = propertyEditState.clean;
        };
        this.validatePage = function (pageModelDataProperties, validationOption, pidlOperation) {
            if (validationOption === validationOptions.all) {
                _this.eventHub.inputValidating();
            }
            if (!pageModelDataProperties) {
                if (validationOption === validationOptions.all) {
                    _this.eventHub.inputValidated();
                }
                return createFakePromise();
            }
            /**
             * Promise Callsites:
             * model.validatePage = rejection not handled
             *  => model.validateEditedProperties = rejection not handled
             *  => model.moveNextPage = rejection not handled
             */
            return new Promise(function (resolve, reject) {
                var validationErrors = [];
                var errorMessage = "";
                var promises = _this.validatePageElements(pageModelDataProperties, validationOption, pidlOperation, validationErrors);
                Promise.all(promises).then(function () {
                    if (!validationErrors.length) {
                        resolve();
                        if (validationOption === validationOptions.all) {
                            _this.eventHub.inputValidated();
                        }
                    }
                    else {
                        var error = new pidlErrors.formValidationFailedError(validationOption === validationOptions.all ? errorMessages.formValidationFailed : errorMessages.editedPropertiesValidationFailed, errorMessage, validationErrors, [errorMessage]);
                        // add the form validation and individual errors to page
                        _this.eventHub.error(error);
                        reject(error);
                    }
                }, function () {
                    // TODO: This code path should never be hit. We need to revisit this.
                    reject();
                });
            });
        };
        this.eventHub = eventHubIn;
        this.alwaysValidateOnChange = alwaysValidateOnChangeIn;
    }
    return Validator;
}());

"use strict";
var webCrypto = /** @class */ (function () {
    function webCrypto() {
        var _this = this;
        this.getCryptoSubtleInstance = function () {
            // Need to add support for IE : window.mscrypto and Safari: window.webitCrypto.
            // IE has a different promise model, so adding that support involves more work.
            return window && window.crypto && window.crypto.subtle;
        };
        this.isSupported = function () {
            return _this.getCryptoSubtleInstance();
        };
    }
    return webCrypto;
}());
var webCrypto$1 = new webCrypto();

"use strict";
var hmacAlgo = {
    name: "HMAC",
    hash: { name: "SHA-256" }
};
var hmac$1 = /** @class */ (function () {
    function hmac() {
        var _this = this;
        this.init = function () {
            /**
             * Promise Callsites:
             * tokenizer.createHmacSignatureInternal = rejection handled
             */
            var cryptoSubtleInstance = webCrypto$1.getCryptoSubtleInstance();
            if (!cryptoSubtleInstance) {
                return createFakePromise({ error: new pidlErrors.unexpectedError(errorMessages.hmacError, ["Failed to Init hmac"]) });
            }
            return new Promise(function (resolve, reject) {
                cryptoSubtleInstance.generateKey(hmacAlgo, true, ["sign"]).then(function (hmackeyInstance) {
                    _this.hmacKey = hmackeyInstance;
                    cryptoSubtleInstance.exportKey("raw", _this.hmacKey).then(function (keyBuffer) {
                        var result = {};
                        try {
                            _this.rawKey = btoa(String.fromCharCode.apply(null, new Uint8Array(keyBuffer)));
                        }
                        catch (err) {
                            result.error = new pidlErrors.unexpectedError(errorMessages.hmacError, [err && err.message]);
                        }
                        resolve(result);
                    }, function (err) {
                        resolve({ error: new pidlErrors.unexpectedError(errorMessages.hmacError, [err && err.message]) });
                    });
                }, function (err) {
                    resolve({ error: new pidlErrors.unexpectedError(errorMessages.hmacError, [err && err.message]) });
                });
            });
        };
        this.getRawKey = function () {
            return _this.rawKey;
        };
        this.sign = function (data) {
            var cryptoSubtleInstance = webCrypto$1.getCryptoSubtleInstance();
            if (!cryptoSubtleInstance || !_this.hmacKey) {
                return createFakePromise({
                    error: new pidlErrors.unexpectedError(errorMessages.hmacError, ["hmac not initialized"])
                });
            }
            /**
             * Promise Callsites:
             * tokenizer.createHmacSignatureInternal = rejection handled
             */
            return new Promise(function (resolve, reject) {
                var uint8array = new Uint8Array(data.length);
                for (var i = 0; i < data.length; i++) {
                    uint8array[i] = data.charCodeAt(i);
                }
                cryptoSubtleInstance.sign(hmacAlgo, _this.hmacKey, uint8array).then(function (signatureBuffer) {
                    var signedBase64Value = null;
                    try {
                        var uint8Array = new Uint8Array(signatureBuffer);
                        signedBase64Value = btoa(String.fromCharCode.apply(null, uint8Array));
                    }
                    catch (err) {
                        resolve({ error: new pidlErrors.unexpectedError(errorMessages.hmacError, [err && err.message]) });
                    }
                    resolve({ data: signedBase64Value });
                }, function (err) {
                    resolve({ error: new pidlErrors.unexpectedError(errorMessages.hmacError, [err && err.message]) });
                });
            });
        };
        this.testHookGetHmacAlgo = function () {
            return hmacAlgo;
        };
        this.testHookSetHmacKey = function (hmacKeyIn) {
            _this.hmacKey = hmacKeyIn;
        };
        this.hmacKey = null;
        this.rawKey = null;
    }
    return hmac;
}());

// @ts-nocheck
/* tslint:disable */
//*******************************************************************************
//
//    Copyright 2020 Microsoft
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
//
//*******************************************************************************
"use strict";
function msrCrypto$1(global) {
    var msrCryptoVersion = "1.6.6";
    global = global || {};
    var msrCrypto = function () {
        var operations = {};
        operations.register = function (operationType, algorithmName, functionToCall) {
            if (!operations[operationType]) {
                operations[operationType] = {};
            }
            var op = operations[operationType];
            if (!op[algorithmName]) {
                op[algorithmName] = functionToCall;
            }
        };
        operations.exists = function (operationType, algorithmName) {
            if (!operations[operationType]) {
                return false;
            }
            return operations[operationType][algorithmName] ? true : false;
        };
        var scriptUrl = (function () {
            if (typeof document !== "undefined") {
                try {
                    throw new Error();
                }
                catch (e) {
                    if (e.stack) {
                        var match = /\w+:\/\/(.+?\/)*.+\.js/.exec(e.stack);
                        return (match && match.length > 0) ? match[0] : null;
                    }
                }
            }
            else if (typeof self !== "undefined" && typeof self.location !== "undefined") {
                return self.location.href;
            }
            return null;
        })();
        var fprngEntropyProvided = false;
        var webWorkerSupport = (typeof Worker !== "undefined");
        var runningInWorkerInstance = typeof importScripts === "function" && self instanceof WorkerGlobalScope;
        var workerInitialized = false;
        var typedArraySupport = (typeof ArrayBuffer !== "undefined");
        var setterSupport = (function () {
            try {
                Object.defineProperty({}, "oncomplete", {});
                return true;
            }
            catch (ex) {
                return false;
            }
        }());
        var asyncMode = false;
        var createProperty = function (parentObject, propertyName, initialValue, getterFunction, setterFunction) {
            if (!setterSupport) {
                parentObject[propertyName] = initialValue;
                return;
            }
            var setGet = {};
            getterFunction && (setGet.get = getterFunction);
            setterFunction && (setGet.set = setterFunction);
            Object.defineProperty(parentObject, propertyName, setGet);
        };
        var msrcryptoHashFunctions = {};
        var msrcryptoUtilities = (function () {
            var encodingChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            function consoleLog(text) {
                if ("console" in self && "log" in console) {
                    console.log(text);
                }
            }
            function toBase64(data, base64Url) {
                var dataType = getObjectType(data);
                if (dataType !== "Array" && dataType !== "Uint8Array" && dataType !== "ArrayBuffer") {
                    throw new Error("invalid input");
                }
                var output = "";
                var input = toArray(data);
                if (!base64Url) {
                    base64Url = false;
                }
                var char1, char2, char3, enc1, enc2, enc3, enc4;
                var i;
                for (i = 0; i < input.length; i += 3) {
                    char1 = input[i];
                    char2 = input[i + 1];
                    char3 = input[i + 2];
                    enc1 = char1 >> 2;
                    enc2 = ((char1 & 0x3) << 4) | (char2 >> 4);
                    enc3 = ((char2 & 0xF) << 2) | (char3 >> 6);
                    enc4 = char3 & 0x3F;
                    if (isNaN(char2)) {
                        enc3 = enc4 = 64;
                    }
                    else if (isNaN(char3)) {
                        enc4 = 64;
                    }
                    output = output +
                        encodingChars.charAt(enc1) +
                        encodingChars.charAt(enc2) +
                        encodingChars.charAt(enc3) +
                        encodingChars.charAt(enc4);
                }
                if (base64Url) {
                    return output.replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
                }
                return output;
            }
            function base64ToBytes(encodedString) {
                encodedString = encodedString.replace(/-/g, "+").replace(/_/g, "/");
                while (encodedString.length % 4 !== 0) {
                    encodedString += "=";
                }
                var output = [];
                var char1, char2, char3;
                var enc1, enc2, enc3, enc4;
                var i;
                encodedString = encodedString.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                for (i = 0; i < encodedString.length; i += 4) {
                    enc1 = encodingChars.indexOf(encodedString.charAt(i));
                    enc2 = encodingChars.indexOf(encodedString.charAt(i + 1));
                    enc3 = encodingChars.indexOf(encodedString.charAt(i + 2));
                    enc4 = encodingChars.indexOf(encodedString.charAt(i + 3));
                    char1 = (enc1 << 2) | (enc2 >> 4);
                    char2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                    char3 = ((enc3 & 3) << 6) | enc4;
                    output.push(char1);
                    if (enc3 !== 64) {
                        output.push(char2);
                    }
                    if (enc4 !== 64) {
                        output.push(char3);
                    }
                }
                return output;
            }
            function getObjectType(object) {
                return Object.prototype.toString.call(object).slice(8, -1);
            }
            function bytesToHexString(bytes, separate) {
                var result = "";
                if (typeof separate === "undefined") {
                    separate = false;
                }
                for (var i = 0; i < bytes.length; i++) {
                    if (separate && (i % 4 === 0) && i !== 0) {
                        result += "-";
                    }
                    var hexval = bytes[i].toString(16).toUpperCase();
                    if (hexval.length === 1) {
                        result += "0";
                    }
                    result += hexval;
                }
                return result;
            }
            function bytesToInt32(bytes, index) {
                index = (index || 0);
                return (bytes[index] << 24) |
                    (bytes[index + 1] << 16) |
                    (bytes[index + 2] << 8) |
                    bytes[index + 3];
            }
            function hexToBytesArray(hexString) {
                hexString = hexString.replace(/\-/g, "");
                var result = [];
                while (hexString.length >= 2) {
                    result.push(parseInt(hexString.substring(0, 2), 16));
                    hexString = hexString.substring(2, hexString.length);
                }
                return result;
            }
            function clone(object) {
                var newObject = {};
                for (var propertyName in object) {
                    if (object.hasOwnProperty(propertyName)) {
                        newObject[propertyName] = object[propertyName];
                    }
                }
                return newObject;
            }
            function unpackData(base64String, arraySize, toUint32s) {
                var bytes = base64ToBytes(base64String), data = [], i;
                if (isNaN(arraySize)) {
                    return bytes;
                }
                else {
                    for (i = 0; i < bytes.length; i += arraySize) {
                        data.push(bytes.slice(i, i + arraySize));
                    }
                }
                if (toUint32s) {
                    for (i = 0; i < data.length; i++) {
                        data[i] = (data[i][0] << 24) + (data[i][1] << 16) + (data[i][2] << 8) + data[i][3];
                    }
                }
                return data;
            }
            function int32ToBytes(int32) {
                return [(int32 >>> 24) & 255, (int32 >>> 16) & 255, (int32 >>> 8) & 255, int32 & 255];
            }
            function int32ArrayToBytes(int32Array) {
                var result = [];
                for (var i = 0; i < int32Array.length; i++) {
                    result = result.concat(int32ToBytes(int32Array[i]));
                }
                return result;
            }
            function xorVectors(a, b, res) {
                var length = Math.min(a.length, b.length), res = res || new Array(length);
                for (var i = 0; i < length; i += 1) {
                    res[i] = a[i] ^ b[i];
                }
                return res;
            }
            function getVector(length, fillValue) {
                if (isNaN(fillValue)) {
                    fillValue = 0;
                }
                var res = new Array(length);
                for (var i = 0; i < length; i += 1) {
                    res[i] = fillValue;
                }
                return res;
            }
            function toArray(typedArray) {
                if (!typedArray) {
                    return [];
                }
                if (typedArray.pop) {
                    return typedArray;
                }
                if (getObjectType(typedArray) === "ArrayBuffer") {
                    typedArray = new Uint8Array(typedArray);
                }
                else if (typedArray.BYTES_PER_ELEMENT > 1) {
                    typedArray = new Uint8Array(typedArray.buffer);
                }
                if (typedArray.length === 1) {
                    return [typedArray[0]];
                }
                if (typedArray.length < 65536) {
                    return Array.apply(null, typedArray);
                }
                var returnArray = new Array(typedArray.length);
                for (var i = 0; i < typedArray.length; i++) {
                    returnArray[i] = typedArray[i];
                }
                return returnArray;
            }
            function padEnd(array, value, finalLength) {
                while (array.length < finalLength) {
                    array.push(value);
                }
                return array;
            }
            function padFront(array, value, finalLength) {
                while (array.length < finalLength) {
                    array.unshift(value);
                }
                return array;
            }
            function arraysEqual(array1, array2) {
                var result = true;
                if (array1.length !== array2.length) {
                    result = false;
                }
                for (var i = 0; i < array1.length; i++) {
                    if (array1[i] !== array2[i]) {
                        result = false;
                    }
                }
                return result;
            }
            function verifyByteArray(array) {
                if (getObjectType(array) !== "Array") {
                    return false;
                }
                var element;
                for (var i = 0; i < array.length; i++) {
                    element = array[i];
                    if (isNaN(element) || element < 0 || element > 255) {
                        return false;
                    }
                }
                return true;
            }
            function checkParam(param, type, errorMessage) {
                if (!param) {
                    throw new Error(errorMessage);
                }
                if (type && (getObjectType(param) !== type)) {
                    throw new Error(errorMessage);
                }
                return true;
            }
            function stringToBytes(text) {
                var encodedBytes = [];
                for (var i = 0, j = 0; i < text.length; i++) {
                    var charCode = text.charCodeAt(i);
                    if (charCode < 128) {
                        encodedBytes[j++] = charCode;
                    }
                    else if (charCode < 2048) {
                        encodedBytes[j++] = (charCode >>> 6) | 192;
                        encodedBytes[j++] = (charCode & 63) | 128;
                    }
                    else if (charCode < 0xD800 || charCode > 0xDFFF) {
                        encodedBytes[j++] = (charCode >>> 12) | 224;
                        encodedBytes[j++] = ((charCode >>> 6) & 63) | 128;
                        encodedBytes[j++] = (charCode & 63) | 128;
                    }
                    else {
                        charCode = ((charCode - 0xD800) * 0x400) + (text.charCodeAt(++i) - 0xDC00) + 0x10000;
                        encodedBytes[j++] = (charCode >>> 18) | 240;
                        encodedBytes[j++] = ((charCode >>> 12) & 63) | 128;
                        encodedBytes[j++] = (charCode >>> 6) & 63 | 128;
                        encodedBytes[j++] = (charCode & 63) | 128;
                    }
                }
                return encodedBytes;
            }
            function bytesToString(textBytes) {
                var result = "", charCode;
                textBytes = toArray(textBytes);
                for (var i = 0; i < textBytes.length;) {
                    var encodedChar = textBytes[i++];
                    if (encodedChar < 128) {
                        charCode = encodedChar;
                    }
                    else if (encodedChar < 224) {
                        charCode = (encodedChar << 6) + textBytes[i++] - 0x3080;
                    }
                    else if (encodedChar < 240) {
                        charCode =
                            (encodedChar << 12) + (textBytes[i++] << 6) + textBytes[i++] - 0xE2080;
                    }
                    else {
                        charCode =
                            (encodedChar << 18) + (textBytes[i++] << 12) + (textBytes[i++] << 6) + textBytes[i++] - 0x3C82080;
                    }
                    if (charCode > 0xFFFF) {
                        var surrogateHigh = Math.floor((charCode - 0x10000) / 0x400) + 0xD800;
                        var surrogateLow = ((charCode - 0x10000) % 0x400) + 0xDC00;
                        result += String.fromCharCode(surrogateHigh, surrogateLow);
                        continue;
                    }
                    result += String.fromCharCode(charCode);
                }
                return result;
            }
            function error(name, message) {
                var err = Error(message);
                err.name = name;
                throw err;
            }
            function isBytes(array) {
                if (!(array instanceof Array))
                    return false;
                for (var i = 0; i < array.length; i++) {
                    var d = array[i];
                    if (!isInteger(d) || d > 255 || d < 0)
                        return false;
                }
                return true;
            }
            function isInteger(value) {
                return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
            }
            ;
            return {
                consoleLog: consoleLog,
                toBase64: toBase64,
                fromBase64: base64ToBytes,
                checkParam: checkParam,
                getObjectType: getObjectType,
                bytesToHexString: bytesToHexString,
                bytesToInt32: bytesToInt32,
                stringToBytes: stringToBytes,
                bytesToString: bytesToString,
                unpackData: unpackData,
                hexToBytesArray: hexToBytesArray,
                int32ToBytes: int32ToBytes,
                int32ArrayToBytes: int32ArrayToBytes,
                toArray: toArray,
                arraysEqual: arraysEqual,
                clone: clone,
                xorVectors: xorVectors,
                padEnd: padEnd,
                padFront: padFront,
                getVector: getVector,
                verifyByteArray: verifyByteArray,
                error: error,
                isBytes: isBytes,
                isInteger: isInteger
            };
        })();
        var asn1 = (function () {
            var asn1Types = {
                0x00: "CUSTOM",
                0x01: "BOOLEAN",
                0x02: "INTEGER",
                0x03: "BIT STRING",
                0x04: "OCTET STRING",
                0x05: "NULL",
                0x06: "OBJECT IDENTIFIER",
                0x10: "SEQUENCE",
                0x11: "SET",
                0x13: "PRINTABLE STRING",
                0x17: "UTCTime"
            };
            var asn1Classes = {
                0x00: "UNIVERSAL",
                0x01: "APPLICATION",
                0x02: "Context-Defined",
                0x03: "PRIVATE"
            };
            function parse(bytes, force) {
                force = !!force;
                var type = asn1Types[bytes[0] & 0x1f], dataLen = bytes[1], i = 0, constructed = !!(bytes[0] & 0x20), remainder, child, header;
                if (dataLen & 0x80) {
                    for (i = 0, dataLen = 0; i < (bytes[1] & 127); i++) {
                        dataLen = (dataLen << 8) + bytes[2 + i];
                    }
                }
                header = 2 + i;
                if (type === undefined || dataLen > bytes.length) {
                    return null;
                }
                var obj = constructed ? [] : {};
                obj.type = type;
                obj.header = header;
                obj.data = bytes.slice(0, dataLen + header);
                if (constructed || force) {
                    if (obj.type === "BIT STRING" && bytes[header] === 0) {
                        i++;
                    }
                    remainder = bytes.slice(header, obj.data.length);
                    while (remainder.length > 0) {
                        child = parse(remainder);
                        if (child === null) {
                            break;
                        }
                        obj.push(child);
                        remainder = remainder.slice(child.data.length);
                    }
                }
                return obj;
            }
            function encode(node) {
                var INTEGER = 0x02, BIT_STRING = 0x03, OCTET_STRING = 0x04, NULL = 0x05, OBJECT_IDENTIFIER = 0x06, SEQUENCE = 0x10, APPLICATION = 0xA0, CONSTRUCTED = 0x20;
                if (node.hasOwnProperty("INTEGER")) {
                    var val = node.INTEGER;
                    if (msrcryptoUtilities.isInteger(val))
                        val = intToBytes(val);
                    if (val[0] & 128)
                        val.unshift(0);
                    var result = [INTEGER].concat(encodeLength(val), val);
                    return result;
                }
                if (node.hasOwnProperty("OCTET STRING")) {
                    var val = node["OCTET STRING"];
                    if (!(val instanceof Array))
                        val = encode(val);
                    var result = [OCTET_STRING].concat(encodeLength(val), val);
                    return result;
                }
                if (node.hasOwnProperty("BIT STRING")) {
                    var val = node["BIT STRING"];
                    if (!(val instanceof Array))
                        val = encode(val);
                    val.unshift(0);
                    var result = [BIT_STRING].concat(encodeLength(val), val);
                    return result;
                }
                if (node.hasOwnProperty("NULL")) {
                    return [NULL, 0];
                }
                if (node.hasOwnProperty("OBJECT IDENTIFIER")) {
                    var val = encodeOid(node["OBJECT IDENTIFIER"]);
                    var result = [OBJECT_IDENTIFIER].concat(encodeLength(val), val);
                    return result;
                }
                if (node.hasOwnProperty("SEQUENCE")) {
                    var nodes = node.SEQUENCE;
                    var val = [];
                    for (var i = 0; i < nodes.length; i++) {
                        val = val.concat(encode(nodes[i]));
                    }
                    var result = [SEQUENCE | CONSTRUCTED].concat(encodeLength(val), val);
                    return result;
                }
                if (node.hasOwnProperty("APPLICATION")) {
                    var nodes = node.APPLICATION;
                    var structured = isNaN(parseInt(nodes[0])) ? CONSTRUCTED : 0;
                    var tag = node.tag;
                    var val = structured ? [] : node.APPLICATION;
                    if (structured) {
                        for (var i = 0; i < nodes.length; i++) {
                            val = val.concat(encode(nodes[i]));
                        }
                    }
                    var result = [APPLICATION | structured | tag].concat(encodeLength(val), val);
                    return result;
                }
                throw new Error("unsupported asn.1 type");
            }
            function encodeLength(bytes) {
                var len = bytes.length;
                if (len <= 127)
                    return [len];
                var result = intToBytes(len);
                result.unshift(result.length | 128);
                return result;
            }
            function intToBytes(int) {
                var result = [];
                if (int === 0)
                    return [0];
                while (int > 0) {
                    result.unshift(int & 255);
                    int >>>= 8;
                }
                return result;
            }
            function encodeOid(text) {
                var parts = text.split(".");
                var result = [parseInt(parts[0] * 40 + parseInt(parts[1]))];
                for (var i = 2; i < parts.length; i++) {
                    var val = parseInt(parts[i]);
                    var bytes = [];
                    while (val > 0) {
                        bytes.push((val & 127) | 128);
                        val = val >>> 7;
                    }
                    bytes[0] = bytes[0] & 127;
                    result = result.concat(bytes.reverse());
                }
                return result;
            }
            function toString(objTree, indent) {
                var output = new Array(indent + 1).join(" ") +
                    objTree.type +
                    " (" +
                    objTree.length +
                    ") " +
                    bytesToHexString(objTree.data).substring(0, 16) +
                    "\n";
                if (!objTree.children) {
                    return output;
                }
                for (var i = 0; i < objTree.children.length; i++) {
                    output += toString(objTree.children[i], indent + 4) + "";
                }
                return output;
            }
            return {
                parse: parse,
                encode: encode,
                toString: function (objTree) {
                    return toString(objTree, 0);
                }
            };
        })();
        var msrcryptoWorker = (function () {
            function returnResult(result) {
                if (workerInitialized && runningInWorkerInstance) {
                    self.postMessage(result);
                }
                return result;
            }
            var workerId, operationType, operationSubType;
            return {
                jsCryptoRunner: function (e) {
                    workerId = e.data.workerid;
                    operationType = e.data.operationType;
                    operationSubType = e.data.operationSubType;
                    var operation = e.data.operationType, result, func = operations[operation][e.data.algorithm.name], p = e.data;
                    if (!operations.exists(operation, e.data.algorithm.name)) {
                        throw new Error("unregistered algorithm.");
                    }
                    if (p.operationSubType) {
                        result = returnResult({
                            type: p.operationSubType,
                            result: func(p)
                        });
                    }
                    else {
                        result = returnResult(func(p));
                    }
                    return result;
                },
                returnResult: returnResult
            };
        })();
        if (runningInWorkerInstance) {
            self.onmessage = function (e) {
                if (!workerInitialized && e.data.prngSeed) {
                    var entropy = e.data.prngSeed;
                    msrcryptoPseudoRandom.init(entropy);
                    workerInitialized = true;
                    return msrcryptoWorker.returnResult({
                        initialized: true
                    });
                }
                if (workerInitialized === true) {
                    msrcryptoWorker.jsCryptoRunner(e);
                }
            };
        }
        var msrcryptoJwk = (function () {
            var utils = msrcryptoUtilities;
            function stringToArray(stringData) {
                var result = [];
                for (var i = 0; i < stringData.length; i++) {
                    result[i] = stringData.charCodeAt(i);
                }
                if (result[result.length - 1] === 0) {
                    result.pop();
                }
                return result;
            }
            function getKeyType(keyHandle) {
                var algType = keyHandle.algorithm.name.slice(0, 3).toUpperCase();
                if (algType === "RSA") {
                    return "RSA";
                }
                if (algType === "ECD") {
                    return "EC";
                }
                return "oct";
            }
            function hashSize(algorithm) {
                return algorithm.hash.name.substring(algorithm.hash.name.indexOf("-") + 1);
            }
            var algorithmMap = {
                "HMAC": function (algorithm) {
                    return "HS" + hashSize(algorithm);
                },
                "AES-CBC": function (algorithm) {
                    return "A" + algorithm.length.toString() + "CBC";
                },
                "AES-GCM": function (algorithm) {
                    return "A" + algorithm.length.toString() + "GCM";
                },
                "AES-KW": function (algorithm) {
                    return "A" + algorithm.length.toString() + "KW";
                },
                "RSAES-PKCS1-V1_5": function (algorithm) {
                    return "RSA1_5";
                },
                "RSASSA-PKCS1-V1_5": function (algorithm) {
                    return "RS" + hashSize(algorithm);
                },
                "RSA-OAEP": function (algorithm) {
                    if (algorithm.hash.name.toUpperCase() === "SHA-1") {
                        return "RSA-OAEP";
                    }
                    return "RSA-OAEP-" + hashSize(algorithm);
                },
                "RSA-PSS": function (algorithm) {
                    return "PS" + hashSize(algorithm);
                },
                "ECDSA": function (algorithm) {
                    return "EC-" + algorithm.namedCurve.substring(algorithm.namedCurve.indexOf("-") + 1);
                }
            };
            function keyToJwk(keyHandle, keyData) {
                var key = {};
                key.kty = getKeyType(keyHandle);
                key.ext = keyHandle.extractable;
                if (algorithmMap[keyHandle.algorithm.name.toUpperCase()]) {
                    key.alg = algorithmMap[keyHandle.algorithm.name.toUpperCase()](keyHandle.algorithm);
                }
                key.key_ops = keyHandle.usages;
                if (keyData.pop) {
                    key.k = utils.toBase64(keyData, true);
                }
                else {
                    for (var property in keyData) {
                        if (keyData[property].pop && property !== "key_ops") {
                            key[property] = utils.toBase64(keyData[property], true);
                        }
                    }
                }
                if (keyHandle.algorithm.namedCurve) {
                    key.crv = keyHandle.algorithm.namedCurve;
                }
                return key;
            }
            function findUsage(usage, usages) {
                for (var i = 0; i < usages.length; i++) {
                    if (usage.toUpperCase() === usages[i].toUpperCase()) {
                        return true;
                    }
                }
                return false;
            }
            function keyToJwkOld(keyHandle, keyData) {
                var key = {};
                key.kty = getKeyType(keyHandle);
                key.extractable = keyHandle.extractable;
                if (keyData.pop) {
                    key.k = utils.toBase64(keyData, true);
                }
                else {
                    for (var property in keyData) {
                        if (keyData[property].pop) {
                            key[property] = utils.toBase64(keyData[property], true);
                        }
                    }
                }
                if (keyHandle.algorithm.namedCurve) {
                    key.crv = keyHandle.algorithm.namedCurve;
                }
                var stringData = JSON.stringify(key, null, "\t");
                return stringToArray(stringData);
            }
            function jwkToKey(keyData, algorithm, propsToArray) {
                var jsonKeyObject = JSON.parse(JSON.stringify(keyData));
                for (var i = 0; i < propsToArray.length; i += 1) {
                    var propValue = jsonKeyObject[propsToArray[i]];
                    if (propValue) {
                        jsonKeyObject[propsToArray[i]] =
                            utils.fromBase64(propValue);
                    }
                }
                return jsonKeyObject;
            }
            return {
                keyToJwkOld: keyToJwkOld,
                keyToJwk: keyToJwk,
                jwkToKey: jwkToKey
            };
        })();
        function msrcryptoMath() {
            var DIGIT_BITS = 24;
            var DIGIT_NUM_BYTES = Math.floor(DIGIT_BITS / 8);
            var DIGIT_MASK = (1 << DIGIT_BITS) - 1;
            var DIGIT_BASE = (1 << DIGIT_BITS);
            var DIGIT_MAX = DIGIT_MASK;
            var DIG_INV = 1 / DIGIT_BASE;
            var DIGIT_MAX_ADDS = 31;
            var DIGIT_SCALER = [1, 256];
            for (var ds = 2; ds <= DIGIT_NUM_BYTES; ds++) {
                DIGIT_SCALER[ds] = DIGIT_SCALER[ds - 1] * 256;
            }
            var Zero = [0];
            var One = [1];
            function createArray(parameter) {
                var i, array = null;
                if (!arguments.length || typeof arguments[0] === "number") {
                    array = new Array(parameter);
                    for (i = 0; i < parameter; i += 1) {
                        array[i] = 0;
                    }
                }
                else if (typeof arguments[0] === "object") {
                    array = new Array(parameter.length);
                    for (i = 0; i < parameter.length; i += 1) {
                        array[i] = parameter[i];
                    }
                }
                return array;
            }
            function stringToDigits(numberStr, radix) {
                numberStr = numberStr.replace(/^\s+|\s+$/g, "");
                var num = [0];
                var buffer = [0];
                radix = radix || 10;
                for (var i = 0; i < numberStr.length; i += 1) {
                    var char = parseInt(numberStr[i], radix);
                    if (isNaN(char)) {
                        throw new Error("Failed to convert string to integer in radix " + radix.toString());
                    }
                    multiply(num, radix, buffer);
                    add(buffer, [char], num);
                    normalizeDigitArray(num);
                }
                return num;
            }
            function digitsToString(digits, radix) {
                radix = radix || 10;
                if (DIGIT_BASE <= radix) {
                    throw new Error("DIGIT_BASE is smaller than RADIX; cannot convert.");
                }
                var wordLength = digits.length;
                var quotient = [];
                var remainder = [];
                var temp1 = [];
                var temp2 = [];
                var divisor = [];
                var a = [];
                var i;
                var sb = "";
                var pad = "0";
                divisor[0] = radix;
                while (Math.floor(DIGIT_BASE / divisor[0]) >= radix) {
                    divisor[0] = divisor[0] * radix;
                    pad = pad.concat("0");
                }
                for (i = 0; i < wordLength; i += 1) {
                    a[i] = digits[i];
                }
                do {
                    var allZeros = true;
                    for (i = 0; i < a.length; i += 1) {
                        if (a[i] !== 0) {
                            allZeros = false;
                            break;
                        }
                    }
                    if (allZeros) {
                        break;
                    }
                    divRem(a, divisor, quotient, remainder, temp1, temp2);
                    normalizeDigitArray(quotient, a.length, true);
                    var newDigits = remainder[0].toString(radix);
                    sb = pad.substring(0, pad.length - newDigits.length) + newDigits + sb;
                    var swap = a;
                    a = quotient;
                    quotient = swap;
                } while (true);
                while (sb.length !== 0 && sb[0] === "0") {
                    sb = sb.substring(1, sb.length);
                }
                if (sb.length === 0) {
                    sb = "0";
                }
                return sb;
            }
            function computeBitArray(bytes) {
                var out = createArray(bytes.length * 8);
                var bitLength = 0;
                var i = bytes.length - 1;
                while (i >= 0) {
                    var j = 0;
                    while (j < 8) {
                        var mask = (1 << j);
                        var bit = ((bytes[i] & mask) === mask) ? 1 : 0;
                        var thisBitIndex = (8 * ((bytes.length - i) - 1)) + j;
                        if (bit === 1) {
                            bitLength = thisBitIndex + 1;
                        }
                        out[thisBitIndex] = bit;
                        j += 1;
                    }
                    i--;
                }
                return out.slice(0, bitLength);
            }
            function bitScanForward(digit) {
                var index = 0;
                for (var i = 0; i < DIGIT_BITS; i++) {
                    index = Math.max(index, -(digit >>> i & 1) & i);
                }
                return index;
            }
            function highestSetBit(bytes) {
                var i = 0;
                var bitLength = 0;
                while (i < bytes.length) {
                    if (bitLength === 0) {
                        var j = 7;
                        while (j >= 0 && bitLength === 0) {
                            var mask = (1 << j);
                            if ((bytes[i] & mask) === mask) {
                                bitLength = j + 1;
                            }
                            j--;
                        }
                    }
                    else {
                        bitLength += 8;
                    }
                    i += 1;
                }
                return bitLength;
            }
            function fixedWindowRecode(digits, windowSize, t) {
                digits = digits.slice();
                var recodedDigits = [], windowSizeBits = Math.pow(2, windowSize), windowSizeMinus1Bits = Math.pow(2, windowSize - 1);
                for (var i = 0; i < t; i++) {
                    recodedDigits[i] = (digits[0] % windowSizeBits) - windowSizeMinus1Bits;
                    digits[0] = digits[0] - recodedDigits[i];
                    cryptoMath.shiftRight(digits, digits, windowSize - 1);
                }
                recodedDigits[i] = digits[0];
                return recodedDigits;
            }
            function fixedWindowRecode2(digits, windowSize) {
                var digLen = digits.length, bits = new Array(digLen * DIGIT_BITS), i = 0, j = 0, k = 0, r = 0, dig, result = new Array(Math.ceil(digLen * DIGIT_BITS / windowSize));
                for (k = 0, result[0] = 0; i < digLen; i++) {
                    for (j = 0, dig = digits[i]; j < DIGIT_BITS; j++, dig >>>= 1) {
                        if (k === windowSize) {
                            result[++r] = 0;
                            k = 0;
                        }
                        result[r] += (dig & 1) << k++;
                    }
                }
                return result;
            }
            function fetchBits(digits, startBit, count) {
                var startDigit = Math.floor(startBit / cryptoMath.DIGIT_BITS);
                var endDigit = startDigit + 1;
                var shiftRight = (startBit % cryptoMath.DIGIT_BITS);
                var shiftLeft = cryptoMath.DIGIT_BITS - shiftRight;
                var bits = (digits[startDigit] >>> shiftRight) | (digits[endDigit] << shiftLeft);
                return bits & (cryptoMath.DIGIT_MASK >>> (cryptoMath.DIGIT_BITS - count));
            }
            function fetchBits2(digits, startBit, count) {
                var startDigit = Math.floor(startBit / DIGIT_BITS), shiftRight = (startBit % DIGIT_BITS);
                return (digits[startDigit] >>> shiftRight) |
                    (digits[startDigit + 1] << (DIGIT_BITS - shiftRight)) &
                        (DIGIT_MASK >>> (DIGIT_BITS - count));
            }
            function copyArray(source, sourceIndex, destination, destIndex, length) {
                while (length-- > 0) {
                    destination[destIndex + length] = source[sourceIndex + length];
                }
            }
            function isZero(array) {
                var i, result = 0;
                for (i = 0; i < array.length; i += 1) {
                    result = result | array[i];
                }
                return !result;
            }
            function isEven(array) {
                return (array[0] & 0x1) === 0x0;
            }
            function sequenceEqual(left, right) {
                var equal = left.length === right.length;
                for (var i = 0; i < Math.min(left.length, right.length); i += 1) {
                    if (left[i] !== right[i]) {
                        equal = false;
                    }
                }
                return equal;
            }
            function bytesToDigits(bytes) {
                var arrayLength = Math.floor((bytes.length + DIGIT_NUM_BYTES - 1) / DIGIT_NUM_BYTES);
                var array = new Array(arrayLength);
                array[0] = 0;
                var digit = 0, index = 0, scIndex = 0;
                for (var i = bytes.length - 1; i >= 0; i--) {
                    digit = digit + (DIGIT_SCALER[scIndex++] * (bytes[i] & 0x0ff));
                    if (DIGIT_SCALER[scIndex] === DIGIT_BASE) {
                        scIndex = 0;
                        array[index++] = digit;
                        digit = 0;
                    }
                }
                if (digit !== 0) {
                    array[index] = digit;
                }
                while (array[--arrayLength] == null) {
                    array[arrayLength] = 0;
                }
                return array;
            }
            function digitsToBytes(digits, trim, minTrimLength) {
                var i, j, byte1;
                var bytes = [0];
                if (typeof trim === "undefined") {
                    trim = true;
                }
                for (i = 0; i < digits.length; i += 1) {
                    byte1 = digits[i];
                    for (j = 0; j < DIGIT_NUM_BYTES; j += 1) {
                        bytes[i * DIGIT_NUM_BYTES + j] = byte1 & 0x0FF;
                        byte1 = Math.floor(byte1 / 256);
                    }
                }
                bytes.reverse();
                if (minTrimLength === undefined) {
                    minTrimLength = 1;
                }
                if (trim) {
                    while (bytes.length > minTrimLength && bytes[0] === 0) {
                        bytes.shift();
                    }
                }
                return bytes;
            }
            function intToDigits(value, numDigits) {
                if (typeof numDigits === "undefined") {
                    if (value <= 1) {
                        numDigits = 1;
                    }
                    else {
                        var numBits = Math.log(value) / Math.LN2;
                        numDigits = Math.ceil(numBits / DIGIT_BITS);
                    }
                }
                var digitRepresentation = [];
                while (value > 0) {
                    digitRepresentation.push(value % DIGIT_BASE);
                    value = Math.floor(value / DIGIT_BASE);
                }
                while (digitRepresentation.length < numDigits) {
                    digitRepresentation.push(0);
                }
                return digitRepresentation;
            }
            function mswIndex(digits) {
                for (var i = digits.length - 1; i >= 0; i--) {
                    if (digits[i] !== undefined && digits[i] !== 0) {
                        return i;
                    }
                }
                return (digits[0] === 0) ? -1 : 0;
            }
            function compareDigits(left, right) {
                var result = 0, val, i;
                for (i = 0; i < Math.max(left.length, right.length); i++) {
                    val = ~~left[i] - ~~right[i];
                    result = val + (result & -!val);
                }
                return result;
            }
            function normalizeDigitArray(digits, length, pad) {
                var i = mswIndex(digits);
                digits.length = length || i + 1;
                if (pad) {
                    while (++i < digits.length) {
                        digits[i] = 0;
                    }
                }
                if (digits.length <= 0) {
                    digits[0] = 0;
                    digits.length = 1;
                }
                return digits;
            }
            function shiftRight(source, destination, bits, length) {
                if (bits === undefined) {
                    bits = 1;
                }
                else if (bits >= DIGIT_BITS || bits < 0) {
                    throw new Error("Invalid bit count for shiftRight");
                }
                if (length === undefined) {
                    length = source.length;
                }
                var n = length - 1;
                var leftShiftBitCount = DIGIT_BITS - bits;
                for (var i = 0; i < n; i++) {
                    destination[i] = ((source[i + 1] << leftShiftBitCount) | (source[i] >>> bits)) & DIGIT_MASK;
                }
                destination[n] = source[n] >>> bits;
            }
            function shiftLeft(source, destination, bits, length) {
                if (bits === undefined) {
                    bits = 1;
                }
                else if (bits >= DIGIT_BITS || bits < 0) {
                    throw new Error("bit count must be smaller than DIGIT_BITS and positive in shiftLeft");
                }
                if (length === undefined) {
                    length = source.length;
                }
                var rightShiftBitCount = DIGIT_BITS - bits;
                destination[length] = (source[length - 1] >>> (DIGIT_BITS - bits)) || destination[length];
                for (var i = length - 1; i > 0; i--) {
                    destination[i] = ((source[i] << bits) | ((source[i - 1] >>> rightShiftBitCount))) & DIGIT_MASK;
                }
                destination[0] = (source[0] << bits) & DIGIT_MASK;
            }
            function add(addend1, addend2, sum) {
                var shortArray = addend1;
                var longArray = addend2;
                if (addend2.length < addend1.length) {
                    shortArray = addend2;
                    longArray = addend1;
                }
                var s = shortArray.length;
                var carry = 0;
                var i;
                for (i = 0; i < s; i += 1) {
                    carry += shortArray[i] + longArray[i];
                    sum[i] = carry & DIGIT_MASK;
                    carry = (carry >> DIGIT_BITS);
                }
                for (i = s; i < longArray.length; i += 1) {
                    carry += longArray[i];
                    sum[i] = carry & DIGIT_MASK;
                    carry = (carry >> DIGIT_BITS);
                }
                sum.length = longArray.length;
                if (carry !== 0) {
                    sum[i] = carry & DIGIT_MASK;
                }
                return carry;
            }
            function subtract(minuend, subtrahend, difference) {
                var s = subtrahend.length;
                if (minuend.length < subtrahend.length) {
                    s = mswIndex(subtrahend) + 1;
                    if (minuend.length < s) {
                        throw new Error("Subtrahend is longer than minuend, not supported.");
                    }
                }
                var i, carry = 0;
                for (i = 0; i < s; i += 1) {
                    carry += minuend[i] - subtrahend[i];
                    difference[i] = carry & DIGIT_MASK;
                    carry = carry >> DIGIT_BITS;
                }
                while (i < minuend.length) {
                    carry += minuend[i];
                    difference[i++] = carry & DIGIT_MASK;
                    carry = carry >> DIGIT_BITS;
                }
                return carry;
            }
            function multiply(a, b, p) {
                b = (typeof b === "number") ? [b] : b;
                var i, j, k, l, c, t1, t2, alen = a.length, blen = b.length, bi;
                for (i = 0; i < alen + blen; i += 1) {
                    p[i] = 0;
                }
                i = 0;
                l = 0;
                var maxRounds = 31;
                var ks = 0;
                while (i < blen) {
                    l = Math.min(l + maxRounds, blen);
                    for (; i < l; i++) {
                        bi = b[i];
                        for (j = 0; j < alen; j++) {
                            p[i + j] += a[j] * bi;
                        }
                    }
                    c = 0;
                    for (k = ks; k < i + alen; k++) {
                        t1 = p[k] + c;
                        t2 = t1 & DIGIT_MASK;
                        p[k] = t2;
                        c = (t1 - t2) * DIG_INV;
                    }
                    p[k] = c;
                    ks += maxRounds;
                }
                p.length = alen + blen;
                return p;
            }
            function divRem(dividend, divisor, quotient, remainder, temp1, temp2) {
                var m = mswIndex(dividend) + 1;
                var n = mswIndex(divisor) + 1;
                var qhat, rhat, carry, p, t, i, j;
                if (m < n) {
                    copyArray(dividend, 0, remainder, 0, dividend.length);
                    remainder.length = dividend.length;
                    normalizeDigitArray(remainder);
                    quotient[0] = 0;
                    quotient.length = 1;
                    return;
                }
                else if (n === 0 || (n === 1 && divisor[n - 1] === 0)) {
                    throw new Error("Division by zero.");
                }
                else if (n === 1) {
                    t = divisor[0];
                    rhat = 0;
                    for (j = m - 1; j >= 0; j--) {
                        p = (rhat * DIGIT_BASE) + dividend[j];
                        quotient[j] = (p / t) & DIGIT_MASK;
                        rhat = (p - quotient[j] * t) & DIGIT_MASK;
                    }
                    quotient.length = m;
                    normalizeDigitArray(quotient);
                    remainder[0] = rhat;
                    remainder.length = 1;
                    return;
                }
                var s = DIGIT_BITS - 1 - bitScanForward(divisor[n - 1]);
                var vn = temp1 || [];
                vn.length = n;
                shiftLeft(divisor, vn, s, n);
                var un = temp2 || [];
                un.length = m;
                shiftLeft(dividend, un, s, m);
                un[m] = un[m] || 0;
                quotient.length = m - n + 1;
                remainder.length = n;
                for (j = m - n; j >= 0; j--) {
                    qhat = Math.floor((un[j + n] * DIGIT_BASE + un[j + n - 1]) / vn[n - 1]);
                    rhat = (un[j + n] * DIGIT_BASE + un[j + n - 1]) - qhat * vn[n - 1];
                    while (true) {
                        if (qhat >= DIGIT_BASE || (qhat * vn[n - 2]) > ((rhat * DIGIT_BASE) + un[j + n - 2])) {
                            qhat = qhat - 1;
                            rhat = rhat + vn[n - 1];
                            if (rhat < DIGIT_BASE) {
                                continue;
                            }
                        }
                        break;
                    }
                    carry = 0;
                    for (i = 0; i < n; i++) {
                        p = qhat * vn[i];
                        t = un[i + j] - carry - (p & DIGIT_MASK);
                        un[i + j] = t & DIGIT_MASK;
                        carry = Math.floor(p / DIGIT_BASE) - Math.floor(t / DIGIT_BASE);
                    }
                    t = un[j + n] - carry;
                    un[j + n] = t & DIGIT_MASK;
                    quotient[j] = qhat & DIGIT_MASK;
                    if (t < 0) {
                        quotient[j] = quotient[j] - 1;
                        carry = 0;
                        for (i = 0; i < n; i++) {
                            t = un[i + j] + vn[i] + carry;
                            un[i + j] = t & DIGIT_MASK;
                            carry = t >> DIGIT_BITS;
                        }
                        un[j + n] = (un[j + n] + carry) & DIGIT_MASK;
                    }
                }
                for (i = 0; i < n; i++) {
                    remainder[i] = ((un[i] >>> s) | (un[i + 1] << (DIGIT_BITS - s))) & DIGIT_MASK;
                }
                normalizeDigitArray(quotient);
                normalizeDigitArray(remainder);
            }
            function reduce(number, modulus, remainder, temp1, temp2) {
                var quotient = [];
                divRem(number, modulus, quotient, remainder, temp1, temp2);
                return remainder;
            }
            function modMul(multiplicand, multiplier, modulus, product, temp1, temp2) {
                var quotient = [];
                multiply(multiplicand, multiplier, quotient);
                divRem(quotient, modulus, quotient, product, temp1, temp2);
                return product;
            }
            function eea(a, b, upp, vpp, rpp) {
                var rp;
                if (isZero(a)) {
                    copyArray(b, 0, rpp, 0, b.length);
                    rpp.length = b.length;
                    return 0;
                }
                else if (isZero(b)) {
                    copyArray(a, 0, rpp, 0, a.length);
                    rpp.length = a.length;
                    return 0;
                }
                else if (compareDigits(a, b) < 0) {
                    rp = a.slice(0);
                    copyArray(b, 0, rpp, 0, b.length);
                    rpp.length = b.length;
                }
                else {
                    rp = b.slice(0);
                    copyArray(a, 0, rpp, 0, a.length);
                    rpp.length = a.length;
                }
                normalizeDigitArray(rpp);
                normalizeDigitArray(rp);
                var q = new Array(rpp.length);
                var r = new Array(rpp.length);
                var v = new Array(rpp.length);
                var vppPresent = vpp !== undefined;
                var vp;
                if (vppPresent) {
                    vp = new Array(rpp.length);
                    vp[0] = 1;
                    vp.length = 1;
                    vpp[0] = 0;
                    vpp.length = 1;
                }
                var up;
                var u = new Array(rpp.length);
                var uppPresent = upp !== undefined;
                if (uppPresent) {
                    up = new Array(rpp.length);
                    up[0] = 0;
                    up.length = 1;
                    upp[0] = 1;
                    upp.length = 1;
                }
                var k = -1;
                var upp_out = upp;
                var vpp_out = vpp;
                var rpp_out = rpp;
                var save;
                while (!isZero(rp)) {
                    divRem(rpp, rp, q, r, u, v);
                    if (uppPresent) {
                        multiply(q, up, u);
                        add(u, upp, u);
                        normalizeDigitArray(u);
                        save = upp;
                        upp = up;
                        up = u;
                        u = save;
                    }
                    if (vppPresent) {
                        multiply(q, vp, v);
                        add(v, vpp, v);
                        normalizeDigitArray(v);
                        save = vpp;
                        vpp = vp;
                        vp = v;
                        v = save;
                    }
                    save = rpp;
                    rpp = rp;
                    rp = r;
                    r = save;
                    k++;
                }
                if (uppPresent) {
                    copyArray(upp, 0, upp_out, 0, upp.length);
                    upp_out.length = upp.length;
                }
                if (vppPresent) {
                    copyArray(vpp, 0, vpp_out, 0, vpp.length);
                    vpp_out.length = vpp.length;
                }
                copyArray(rpp, 0, rpp_out, 0, rpp.length);
                rpp_out.length = rpp.length;
                return k;
            }
            function gcd(a, b, output) {
                var aa = a;
                var bb = b;
                if (compareDigits(a, b) > 0) {
                    aa = b;
                    bb = a;
                }
                eea(aa, bb, undefined, undefined, output);
                return normalizeDigitArray(output);
            }
            function modInv(a, n, aInv, pad) {
                var upp = new Array(n.length);
                var vpp = new Array(n.length);
                var rpp = new Array(n.length);
                var k = eea(a, n, vpp, upp, rpp);
                aInv = aInv || [];
                if (compareDigits(rpp, One) !== 0) {
                    aInv[0] = NaN;
                    aInv.length = 1;
                }
                else {
                    if ((k & 1) === 1) {
                        subtract(n, upp, aInv);
                    }
                    else {
                        copyArray(upp, 0, aInv, 0, upp.length);
                        aInv.length = upp.length;
                    }
                    if (pad) {
                        normalizeDigitArray(aInv, n.length, true);
                    }
                    else {
                        normalizeDigitArray(aInv);
                    }
                }
                return aInv;
            }
            function modInvCT(a, n, aInv, pad) {
                var nMinus2 = [];
                aInv = aInv || [];
                subtract(n, [2], nMinus2);
                modExp(a, nMinus2, n, aInv);
                normalizeDigitArray(aInv);
                return aInv;
            }
            function modExp(base, exponent, modulus, result) {
                result = result || [];
                if (compareDigits(exponent, Zero) === 0) {
                    result[0] = 1;
                }
                else if (compareDigits(exponent, One) === 0) {
                    copyArray(base, 0, result, 0, base.length);
                    result.length = base.length;
                }
                else {
                    var montmul = new MontgomeryMultiplier(modulus);
                    normalizeDigitArray(base, montmul.s, true);
                    montmul.modExp(base, exponent, result);
                    result.length = modulus.length;
                }
                return result;
            }
            function MontgomeryMultiplier(modulus, context) {
                function computeM0Prime(m0) {
                    var m0Pr = 1;
                    var a = 2;
                    var b = 3;
                    var c = b & m0;
                    for (var i = 2; i <= DIGIT_BITS; i += 1) {
                        if (a < c) {
                            m0Pr += a;
                        }
                        a = a << 1;
                        b = (b << 1) | 1;
                        c = m0 * m0Pr & b;
                    }
                    var result = (~m0Pr & DIGIT_MASK) + 1;
                    return result;
                }
                function montgomeryReduction(t, m, result) {
                    var m0 = m[0];
                    var mPrime = computeM0Prime(m0);
                    var n = m.length;
                    var A = t.slice(0);
                    var ui = [];
                    var uimbi = [];
                    var uim = [];
                    var bi = [1];
                    for (var i = 0; i < n; i++) {
                        ui = (A[i] * mPrime) % DIGIT_BASE;
                        multiply(m, [ui], uim);
                        multiply(uim, bi, uimbi);
                        add(A, uimbi, A);
                        bi.unshift(0);
                    }
                    A = A.slice(n);
                    for (i = 0; i < A.length; i++) {
                        result[i] = A[i];
                    }
                }
                function montgomeryMultiply(multiplicand, multiplier, result, ctx) {
                    ctx = ctx || this;
                    var m = ctx.m, s = m.length, mPrime = ctx.mPrime, m0 = ctx.m0, rightI, r0, q, i = 0, j, jm1, t1, t2, carry, rounds = 0;
                    var temp = createArray(s + 2);
                    while (i < s) {
                        rounds = Math.min(s, rounds + 16);
                        for (; i < rounds;) {
                            rightI = ~~multiplier[i];
                            r0 = temp[0] + multiplicand[0] * rightI;
                            q = ((r0 & DIGIT_MASK) * mPrime) & DIGIT_MASK;
                            temp[1] += ((m0 * q + r0) * DIG_INV) | 0;
                            for (j = 1, jm1 = 0; j < s; jm1 = j, j += 1) {
                                temp[jm1] = temp[j] + m[j] * q + multiplicand[j] * rightI;
                            }
                            temp[jm1] = temp[j];
                            temp[j] = 0;
                            i++;
                        }
                        carry = 0;
                        for (j = 0; j < s; j++) {
                            t1 = temp[j] + carry;
                            t2 = t1 & DIGIT_MASK;
                            temp[j] = t2;
                            carry = (t1 - t2) * DIG_INV;
                        }
                        temp[j] = carry;
                    }
                    for (i = 0; i < s; i += 1) {
                        result[i] = temp[i];
                    }
                    result.length = s;
                    var needSubtract = +(cryptoMath.compareDigits(temp, m) > 0);
                    cryptoMath.subtract(result, m, ctx.temp2);
                    ctSetArray(needSubtract, result, ctx.temp2);
                    return;
                }
                function convertToMontgomeryForm(digits) {
                    if (digits.length < this.s) {
                        digits.length = this.s;
                        for (var i = 0; i < this.s; i++) {
                            digits[i] = isNaN(digits[i]) ? 0 : digits[i];
                        }
                    }
                    var result = createArray(digits.length);
                    this.montgomeryMultiply(digits, this.rSquaredModm, result);
                    for (i = 0; i < this.s; i += 1) {
                        digits[i] = result[i];
                    }
                }
                function convertToStandardForm(digits) {
                    this.montgomeryMultiply(digits, this.one, this.temp1);
                    for (var i = 0; i < this.s; i += 1) {
                        digits[i] = this.temp1[i];
                    }
                }
                function optimalWindowSize(length) {
                    var i = 2, t1, t0, bits = length * DIGIT_BITS;
                    t0 = 4 + Math.ceil(bits / 2) * 3 + 1;
                    do {
                        i++;
                        t1 = t0;
                        t0 = Math.pow(2, i) + Math.ceil(bits / i) * (i + 1) + 1;
                    } while (t0 < t1);
                    return i - 1;
                }
                function modExp(base, exponent, result, skipSideChannel) {
                    skipSideChannel = !!skipSideChannel;
                    var windowBits = optimalWindowSize(exponent.length);
                    var i, j, expBits = fixedWindowRecode2(exponent, windowBits).reverse(), partialResult = this.rModM.slice(0), baseTableLen = Math.pow(2, windowBits), bt = baseTable;
                    bt.length = baseTableLen;
                    bt[0] = this.rModM;
                    for (i = 1; i < baseTableLen; i++) {
                        bt[i] = [];
                        multiply(bt[i - 1], base, bt[i]);
                        this.reduce(bt[i]);
                    }
                    var tableVal = [];
                    var exp;
                    for (i = 0; i < expBits.length; i++) {
                        for (j = 0; j < windowBits; j++) {
                            this.montgomeryMultiply(partialResult, partialResult, partialResult);
                        }
                        exp = expBits[i];
                        skipSideChannel ?
                            (tableVal = bt[exp]) :
                            getTableEntry(bt, exp, tableVal);
                        this.montgomeryMultiply(partialResult, tableVal, partialResult);
                    }
                    this.montgomeryMultiply(partialResult, this.one, result);
                    return result;
                }
                function getTableEntry(bt, exp, tableVal) {
                    var z, t, mask, tableEntry, k;
                    for (z = 0; z < bt[0].length; z++) {
                        tableVal[z] = 0;
                    }
                    for (t = 0; t < bt.length; t++) {
                        tableEntry = bt[t];
                        mask = -(exp === t);
                        for (k = 0; k < tableEntry.length; k++) {
                            tableVal[k] = tableVal[k] | (tableEntry[k] & mask);
                        }
                    }
                }
                function ctSetArray(condition, a, b) {
                    var bMask = -condition;
                    var aMask = ~bMask;
                    for (var i = 0; i < a.length; i++) {
                        a[i] = (a[i] & aMask) | (b[i] & bMask);
                    }
                }
                function reduce(x, result) {
                    var k = this.m.length, q1, q2, q3, r1, r2, i, needSubtract, temp = [];
                    result = result || x;
                    q1 = x.slice(k - 1);
                    q2 = [];
                    multiply(q1, this.mu, q2);
                    q3 = q2.slice(k + 1);
                    r1 = x.slice(0, k + 1);
                    r2 = [];
                    multiply(q3, m, r2);
                    r2 = r2.slice(0, k + 1);
                    r1[k + 1] = compareDigits(r1, r2) >>> 31;
                    for (i = 0; i < result.length; i++) {
                        result[i] = 0;
                    }
                    subtract(r1, r2, result);
                    needSubtract = +(compareDigits(result, m) > 0);
                    cryptoMath.subtract(result, m, temp);
                    ctSetArray(needSubtract, result, temp);
                    normalizeDigitArray(result);
                    return;
                }
                function computeContext(modulus) {
                    var s = modulus.length;
                    var m0 = modulus[0];
                    var ctx = {
                        m: modulus,
                        mPrime: computeM0Prime(m0),
                        m0: m0,
                        temp1: createArray(2 * s + 1),
                        temp2: createArray(2 * s + 1)
                    };
                    var R = createArray(modulus.length * 2);
                    R[R.length] = 1;
                    ctx.mu = [];
                    divRem(R, modulus, ctx.mu, []);
                    var quotient = createArray(2 * s + 1);
                    var rRemainder = createArray(s + 1);
                    var temp1 = createArray(2 * s + 1);
                    var temp2 = createArray(2 * s + 1);
                    var rDigits = rRemainder;
                    rDigits[s] = 1;
                    divRem(rDigits, modulus, quotient, rRemainder, temp1, temp2);
                    ctx.rModM = normalizeDigitArray(rRemainder, s, true);
                    var rSquaredModm = createArray(2 * s + 1);
                    var rSquaredDigits = rSquaredModm;
                    rSquaredDigits[s * 2] = 1;
                    divRem(rSquaredDigits, modulus, quotient, rSquaredModm, temp1, temp2);
                    ctx.rSquaredModm = normalizeDigitArray(rSquaredModm, s, true);
                    ctx.rCubedModm = createArray(s);
                    montgomeryMultiply(rSquaredModm, rSquaredModm, ctx.rCubedModm, ctx);
                    return ctx;
                }
                context = context || computeContext(modulus);
                var m = context.m;
                var mu = context.mu;
                var m0 = context.m0;
                var s = m.length;
                var zeros = createArray(s + 1);
                var one = zeros.slice(0, s);
                one[0] = 1;
                var mPrime = context.mPrime;
                var rModM = context.rModM;
                var rSquaredModm = context.rSquaredModm;
                var rCubedModm = context.rCubedModm;
                var temp1 = createArray(2 * s + 1);
                var temp2 = createArray(2 * s + 1);
                var baseTable = new Array(4);
                baseTable[0] = rModM;
                baseTable[1] = new Array(s);
                baseTable[2] = new Array(s);
                baseTable[3] = new Array(s);
                return {
                    m: m,
                    m0: m0,
                    mPrime: mPrime,
                    mu: mu,
                    rSquaredModm: rSquaredModm,
                    s: s,
                    rModM: rModM,
                    rCubedModm: rCubedModm,
                    one: one,
                    temp1: temp1,
                    temp2: temp2,
                    convertToMontgomeryForm: convertToMontgomeryForm,
                    convertToStandardForm: convertToStandardForm,
                    montgomeryMultiply: montgomeryMultiply,
                    modExp: modExp,
                    reduce: reduce,
                    ctx: context
                };
            }
            function IntegerGroup(modulusBytes) {
                var m_modulus = bytesToDigits(modulusBytes);
                var m_digitWidth = m_modulus.length;
                var m_zero = intToDigits(0, m_digitWidth);
                var m_one = intToDigits(1, m_digitWidth);
                var temp0 = createArray(m_digitWidth);
                var temp1 = createArray(m_digitWidth);
                var montmul = new MontgomeryMultiplier(m_modulus);
                function createElementFromBytes(bytes) {
                    var digits = bytesToDigits(bytes);
                    if (cryptoMath.compareDigits(digits, this.m_modulus) >= 0) {
                        throw new Error("The number provided is not an element of this group");
                    }
                    normalizeDigitArray(digits, this.m_digitWidth, true);
                    return integerGroupElement(digits, this);
                }
                function createElementFromInteger(integer) {
                    var digits = intToDigits(integer, this.m_digitWidth);
                    return integerGroupElement(digits, this);
                }
                function createElementFromDigits(digits) {
                    cryptoMath.normalizeDigitArray(digits, this.m_digitWidth, true);
                    return integerGroupElement(digits, this);
                }
                function equals(otherGroup) {
                    return compareDigits(this.m_modulus, otherGroup.m_modulus) === 0;
                }
                function add(addend1, addend2, sum) {
                    var i;
                    var s = this.m_digitWidth;
                    var result = sum.m_digits;
                    cryptoMath.add(addend1.m_digits, addend2.m_digits, result);
                    var mask = (compareDigits(result, this.m_modulus) >>> 31) - 1 & DIGIT_MASK;
                    var carry = 0;
                    for (i = 0; i < s; i += 1) {
                        carry = result[i] - (this.m_modulus[i] & mask) + carry;
                        result[i] = carry & DIGIT_MASK;
                        carry = (carry >> DIGIT_BITS);
                    }
                    result.length = s;
                }
                function subtract(leftElement, rightElement, outputElement) {
                    var i, s = this.m_digitWidth;
                    var result = outputElement.m_digits;
                    var carry = cryptoMath.subtract(leftElement.m_digits, rightElement.m_digits, outputElement.m_digits);
                    if (carry === -1) {
                        carry = 0;
                        for (i = 0; i < s; i += 1) {
                            carry += result[i] + this.m_modulus[i];
                            result[i] = carry & DIGIT_MASK;
                            carry = carry >> DIGIT_BITS;
                        }
                    }
                }
                function inverse(element, outputElement) {
                    cryptoMath.modInv(element.m_digits, this.m_modulus, outputElement.m_digits);
                }
                function multiply(multiplicand, multiplier, product) {
                    return cryptoMath.modMul(multiplicand.m_digits, multiplier.m_digits, this.m_modulus, product.m_digits, temp0, temp1);
                }
                function modexp(valueElement, exponent, outputElement) {
                    outputElement = outputElement || integerGroupElement([], this);
                    if (compareDigits(exponent, m_zero) === 0) {
                        outputElement.m_digits = intToDigits(1, this.m_digitWidth);
                    }
                    else if (compareDigits(exponent, m_one) === 0) {
                        for (var i = 0; i < valueElement.m_digits.length; i++) {
                            outputElement.m_digits[i] = valueElement.m_digits[i];
                        }
                        outputElement.m_digits.length = valueElement.m_digits.length;
                    }
                    else {
                        this.montmul.modExp(valueElement.m_digits, exponent, outputElement.m_digits);
                        outputElement.m_digits.length = this.montmul.s;
                    }
                    return outputElement;
                }
                function integerGroupElement(digits, group) {
                    return {
                        m_digits: digits,
                        m_group: group,
                        equals: function (element) {
                            return (compareDigits(this.m_digits, element.m_digits) === 0) &&
                                this.m_group.equals(this.m_group, element.m_group);
                        }
                    };
                }
                return {
                    m_modulus: m_modulus,
                    m_digitWidth: m_digitWidth,
                    montmul: montmul,
                    createElementFromInteger: createElementFromInteger,
                    createElementFromBytes: createElementFromBytes,
                    createElementFromDigits: createElementFromDigits,
                    equals: equals,
                    add: add,
                    subtract: subtract,
                    multiply: multiply,
                    inverse: inverse,
                    modexp: modexp
                };
            }
            return {
                DIGIT_BITS: DIGIT_BITS,
                DIGIT_NUM_BYTES: DIGIT_NUM_BYTES,
                DIGIT_MASK: DIGIT_MASK,
                DIGIT_BASE: DIGIT_BASE,
                DIGIT_MAX: DIGIT_MAX,
                Zero: Zero,
                One: One,
                normalizeDigitArray: normalizeDigitArray,
                bytesToDigits: bytesToDigits,
                stringToDigits: stringToDigits,
                digitsToString: digitsToString,
                intToDigits: intToDigits,
                digitsToBytes: digitsToBytes,
                isZero: isZero,
                isEven: isEven,
                shiftRight: shiftRight,
                shiftLeft: shiftLeft,
                compareDigits: compareDigits,
                bitLength: highestSetBit,
                fixedWindowRecode: fixedWindowRecode,
                IntegerGroup: IntegerGroup,
                add: add,
                subtract: subtract,
                multiply: multiply,
                divRem: divRem,
                reduce: reduce,
                modInv: modInv,
                modInvCT: modInvCT,
                modExp: modExp,
                modMul: modMul,
                MontgomeryMultiplier: MontgomeryMultiplier,
                gcd: gcd,
                sequenceEqual: sequenceEqual,
                swapEndianness: function (bytes) {
                    return bytes.reverse();
                },
                computeBitArray: computeBitArray
            };
        }
        var cryptoMath = cryptoMath || msrcryptoMath();
        function MsrcryptoECC() {
            var btd = cryptoMath.bytesToDigits;
            function createArray(parameter) {
                var i, array = null;
                if (!arguments.length || typeof arguments[0] === "number") {
                    array = [];
                    for (i = 0; i < parameter; i += 1) {
                        array[i] = 0;
                    }
                }
                else if (typeof arguments[0] === "object") {
                    array = [];
                    for (i = 0; i < parameter.length; i += 1) {
                        array[i] = parameter[i];
                    }
                }
                return array;
            }
            var EllipticCurveFp = function (p1, a1, b1, order, gx, gy) {
                var fieldStorageBitLength = p1.length;
                var generator = EllipticCurvePointFp(this, false, gx, gy, null, false);
                return {
                    p: p1,
                    a: a1,
                    b: b1,
                    order: order,
                    generator: generator,
                    allocatePointStorage: function () {
                        return EllipticCurvePointFp(this, false, cryptoMath.intToDigits(0, fieldStorageBitLength), cryptoMath.intToDigits(0, fieldStorageBitLength));
                    },
                    createPointAtInfinity: function () {
                        return EllipticCurvePointFp(this, true, cryptoMath.intToDigits(0, fieldStorageBitLength), cryptoMath.intToDigits(0, fieldStorageBitLength));
                    }
                };
            };
            var createWeierstrassCurve = function (curveData) {
                var newCurve = new EllipticCurveFp(btd(curveData.p), btd(curveData.a), btd(curveData.b), btd(curveData.order), btd(curveData.gx), btd(curveData.gy));
                newCurve.type = curveData.type;
                newCurve.name = curveData.name;
                newCurve.generator.curve = newCurve;
                return newCurve;
            };
            var createTedCurve = function (curveData) {
                var newCurve = new EllipticCurveFp(btd(curveData.p), btd(curveData.a), btd(curveData.d), btd(curveData.order), btd(curveData.gx), btd(curveData.gy));
                newCurve.type = curveData.type;
                if (newCurve.type === 1) {
                    newCurve.d = newCurve.b.slice();
                    delete newCurve.b;
                }
                newCurve.rbits = curveData.info[2];
                newCurve.name = curveData.name;
                newCurve.generator.curve = newCurve;
                return newCurve;
            };
            var EllipticCurvePointFp = function (curve, isInfinity, x, y, z, isInMontgomeryForm) {
                var returnObj;
                if (typeof z === "undefined") {
                    z = null;
                }
                if (typeof isInMontgomeryForm === "undefined") {
                    isInMontgomeryForm = false;
                }
                function equals(ellipticCurvePointFp) {
                    if (!ellipticCurvePointFp) {
                        return false;
                    }
                    if (returnObj.isInfinity && ellipticCurvePointFp.isInfinity) {
                        return true;
                    }
                    if (returnObj.z === null && ellipticCurvePointFp.z !== null) {
                        return false;
                    }
                    if (returnObj.z !== null && ellipticCurvePointFp.z === null) {
                        return false;
                    }
                    if (returnObj.z === null) {
                        return cryptoMath.compareDigits(returnObj.x, ellipticCurvePointFp.x) === 0 &&
                            cryptoMath.compareDigits(returnObj.y, ellipticCurvePointFp.y) === 0 &&
                            returnObj.isInMontgomeryForm === ellipticCurvePointFp.isInMontgomeryForm;
                    }
                    return cryptoMath.compareDigits(returnObj.x, ellipticCurvePointFp.x) === 0 &&
                        cryptoMath.compareDigits(returnObj.y, ellipticCurvePointFp.y) === 0 &&
                        cryptoMath.compareDigits(returnObj.z, ellipticCurvePointFp.z) === 0 &&
                        returnObj.isInMontgomeryForm === ellipticCurvePointFp.isInMontgomeryForm;
                }
                function copyTo(source, destination) {
                    destination.curve = source.curve;
                    destination.x = source.x.slice();
                    destination.y = source.y.slice();
                    if (source.z !== null) {
                        destination.z = source.z.slice();
                    }
                    else {
                        destination.z = null;
                    }
                    setterSupport || (destination.isAffine = source.isAffine);
                    destination.isInMontgomeryForm = source.isInMontgomeryForm;
                    destination.isInfinity = source.isInfinity;
                    if (!destination.equals(source)) {
                        throw new Error("Instances should be equal.");
                    }
                }
                function clone() {
                    var clonePoint = EllipticCurvePointFp(returnObj.curve, returnObj.isInfinity, createArray(returnObj.x), createArray(returnObj.y), returnObj.z ? createArray(returnObj.z) : null, returnObj.isInMontgomeryForm);
                    returnObj.ta && (clonePoint.ta = createArray(returnObj.ta));
                    returnObj.tb && (clonePoint.tb = createArray(returnObj.tb));
                    return clonePoint;
                }
                returnObj = {
                    equals: function (ellipticCurvePointFp) {
                        return equals(ellipticCurvePointFp);
                    },
                    copy: function (destination) {
                        copyTo(this, destination);
                        return;
                    },
                    clone: function () {
                        return clone();
                    }
                };
                createProperty(returnObj, "curve", curve, function () {
                    return curve;
                }, function (val) {
                    curve = val;
                });
                createProperty(returnObj, "x", x, function () {
                    return x;
                }, function (val) {
                    x = val;
                });
                createProperty(returnObj, "y", y, function () {
                    return y;
                }, function (val) {
                    y = val;
                });
                createProperty(returnObj, "z", z, function () {
                    return z;
                }, function (val) {
                    z = val;
                });
                createProperty(returnObj, "isInMontgomeryForm", isInMontgomeryForm, function () {
                    return isInMontgomeryForm;
                }, function (val) {
                    isInMontgomeryForm = val;
                });
                createProperty(returnObj, "isInfinity", isInfinity, function () {
                    return isInfinity;
                }, function (val) {
                    isInfinity = val;
                });
                createProperty(returnObj, "isAffine", z === null, function () {
                    return z === null;
                });
                return returnObj;
            };
            var EllipticCurveOperatorFp = function (curve) {
                var m_curve = curve;
                var tedCurve = curve.type === 1;
                var fieldElementWidth = curve.p.length;
                var montgomeryMultiplier = cryptoMath.MontgomeryMultiplier(curve.p);
                var montgomerizedA = curve.a.slice();
                montgomeryMultiplier.convertToMontgomeryForm(montgomerizedA);
                var aequalsZero = cryptoMath.isZero(curve.a);
                var one = cryptoMath.One;
                var onemontgomery = createArray(fieldElementWidth);
                onemontgomery[0] = 1;
                montgomeryMultiplier.convertToMontgomeryForm(onemontgomery);
                var group = cryptoMath.IntegerGroup(cryptoMath.digitsToBytes(montgomeryMultiplier.m), true);
                var temp0 = createArray(fieldElementWidth);
                var temp1 = createArray(fieldElementWidth);
                var temp2 = createArray(fieldElementWidth);
                var temp3 = createArray(fieldElementWidth);
                var temp4 = createArray(fieldElementWidth);
                var temp5 = createArray(fieldElementWidth);
                var temp6 = createArray(fieldElementWidth);
                var temp7 = createArray(fieldElementWidth);
                var swap0 = createArray(fieldElementWidth);
                var conversionTemp0 = createArray(fieldElementWidth);
                var conversionTemp1 = createArray(fieldElementWidth);
                var conversionTemp2 = createArray(fieldElementWidth);
                function modSub(left, right, result) {
                    var resultElement = group.createElementFromInteger(0);
                    resultElement.m_digits = result;
                    group.subtract(group.createElementFromDigits(left), group.createElementFromDigits(right), resultElement);
                }
                function modAdd(left, right, result) {
                    var resultElement = group.createElementFromInteger(0);
                    resultElement.m_digits = result;
                    group.add(group.createElementFromDigits(left), group.createElementFromDigits(right), resultElement);
                }
                function modInv(number, result) {
                    cryptoMath.modInv(number, m_curve.p, result);
                }
                function modDivByTwo(dividend, result) {
                    var s = dividend.length;
                    var modulus = curve.p;
                    if ((dividend[0] & 0x1) === 0x1) {
                        var carry = 0;
                        for (var i = 0; i < s; i += 1) {
                            carry += dividend[i] + modulus[i];
                            result[i] = carry & cryptoMath.DIGIT_MASK;
                            carry = carry >>> cryptoMath.DIGIT_BITS;
                        }
                        carry = carry << cryptoMath.DIGIT_BITS - 1;
                        cryptoMath.shiftRight(result, result);
                        result[s - 1] |= carry;
                    }
                    else {
                        cryptoMath.shiftRight(dividend, result);
                    }
                }
                function montgomeryMultiply(left, right, result) {
                    montgomeryMultiplier.montgomeryMultiply(left, right, result);
                }
                function montgomerySquare(left, result) {
                    montgomeryMultiplier.montgomeryMultiply(left, left, result);
                }
                function correctInversion(digits) {
                    var results = createArray(digits.length);
                    montgomeryMultiply(digits, montgomeryMultiplier.rCubedModm, results);
                    for (var i = 0; i < results.length; i += 1) {
                        digits[i] = results[i];
                    }
                }
                function doubleAequalsNeg3(point, outputPoint) {
                    if (point.isInfinity) {
                        outputPoint.isInfinity = true;
                        return;
                    }
                    montgomerySquare(point.z, temp1);
                    montgomeryMultiply(point.z, point.y, temp4);
                    modAdd(point.x, temp1, temp2);
                    modSub(point.x, temp1, temp1);
                    outputPoint.z = temp4.slice();
                    montgomeryMultiply(temp1, temp2, temp3);
                    modDivByTwo(temp3, temp2);
                    modAdd(temp3, temp2, temp1);
                    montgomerySquare(point.y, temp2);
                    montgomerySquare(temp1, temp4);
                    montgomeryMultiply(point.x, temp2, temp3);
                    modSub(temp4, temp3, temp4);
                    modSub(temp4, temp3, outputPoint.x);
                    modSub(temp3, outputPoint.x, temp4);
                    montgomerySquare(temp2, temp3);
                    montgomeryMultiply(temp1, temp4, temp2);
                    modSub(temp2, temp3, outputPoint.y);
                    outputPoint.isInfinity = false;
                    outputPoint.isInMontgomeryForm = true;
                }
                function doubleAequals0(point, outputPoint) {
                    if (point.isInfinity) {
                        outputPoint.isInfinity = true;
                        return;
                    }
                    montgomerySquare(point.y, temp3);
                    montgomerySquare(point.x, temp4);
                    modAdd(temp4, temp4, temp0);
                    modAdd(temp0, temp4, temp4);
                    montgomeryMultiply(point.x, temp3, temp5);
                    montgomerySquare(temp3, temp0);
                    modDivByTwo(temp4, temp1);
                    montgomerySquare(temp1, temp3);
                    montgomeryMultiply(point.y, point.z, swap0);
                    for (var i = 0; i < swap0.length; i += 1) {
                        outputPoint.z[i] = swap0[i];
                    }
                    modSub(temp3, temp5, outputPoint.x);
                    modSub(outputPoint.x, temp5, outputPoint.x);
                    modSub(temp5, outputPoint.x, temp4);
                    montgomeryMultiply(temp1, temp4, temp2);
                    modSub(temp2, temp0, outputPoint.y);
                    outputPoint.isInfinity = false;
                    outputPoint.isInMontgomeryForm = true;
                }
                function generatePrecomputationTable(w, generatorPoint) {
                    var validationPoint = generatorPoint.clone();
                    convertToStandardForm(validationPoint);
                    if (!validatePoint(validationPoint)) {
                        throw new Error("Invalid Parameter");
                    }
                    var pointJac = generatorPoint.clone();
                    convertToJacobianForm(pointJac);
                    var tablePos = [generatorPoint.clone()];
                    var qJac = pointJac.clone();
                    var px2 = pointJac.clone();
                    double(pointJac, px2);
                    convertToAffineForm(px2);
                    var qAff;
                    for (var i = 1; i < Math.pow(2, w - 2); i++) {
                        mixedAdd(qJac, px2, qJac);
                        qAff = qJac.clone();
                        convertToAffineForm(qAff);
                        tablePos[i] = qAff;
                    }
                    return tablePos;
                }
                function double(point, outputPoint) {
                    if (typeof point === "undefined") {
                        throw new Error("point undefined");
                    }
                    if (typeof outputPoint === "undefined") {
                        throw new Error("outputPoint undefined");
                    }
                    if (point.isAffine) {
                        throw new Error("Given point was in Affine form. Use convertToJacobian() first.");
                    }
                    if (!point.isInMontgomeryForm) {
                        throw new Error("Given point must be in Montgomery form. Use montgomeryize() first.");
                    }
                    if (aequalsZero) {
                        doubleAequals0(point, outputPoint);
                    }
                    else {
                        doubleAequalsNeg3(point, outputPoint);
                    }
                }
                function mixedDoubleAdd(jacobianPoint, affinePoint, outputPoint) {
                    if (jacobianPoint.isInfinity) {
                        affinePoint.copy(outputPoint);
                        this.convertToJacobianForm(outputPoint);
                        return;
                    }
                    if (affinePoint.isInfinity) {
                        jacobianPoint.copy(outputPoint);
                        return;
                    }
                    montgomerySquare(jacobianPoint.z, temp5);
                    montgomeryMultiply(jacobianPoint.z, temp5, temp6);
                    montgomeryMultiply(affinePoint.x, temp5, temp4);
                    montgomeryMultiply(affinePoint.y, temp6, temp5);
                    modSub(temp4, jacobianPoint.x, temp1);
                    modSub(temp5, jacobianPoint.y, temp2);
                    if (cryptoMath.isZero(temp1)) {
                        if (cryptoMath.isZero(temp2)) {
                            double(jacobianPoint, outputPoint);
                            mixedAdd(outputPoint, affinePoint, outputPoint);
                            return;
                        }
                        else {
                            outputPoint.x = jacobianPoint.x.slice(0);
                            outputPoint.y = jacobianPoint.y.slice(0);
                            outputPoint.z = jacobianPoint.z.slice(0);
                            return;
                        }
                    }
                    montgomerySquare(temp2, temp4);
                    montgomerySquare(temp1, temp6);
                    montgomeryMultiply(temp6, jacobianPoint.x, temp5);
                    montgomeryMultiply(temp1, temp6, temp0);
                    modSub(temp4, temp5, temp3);
                    modSub(temp3, temp5, temp3);
                    montgomeryMultiply(jacobianPoint.z, temp1, temp4);
                    modSub(temp3, temp5, temp3);
                    montgomeryMultiply(temp0, jacobianPoint.y, temp6);
                    modSub(temp3, temp0, temp3);
                    if (cryptoMath.isZero(temp3)) {
                        for (i = 0; i < outputPoint.x.length; i++) {
                            outputPoint.x[i] = 0;
                            outputPoint.y[i] = 0;
                            outputPoint.z[i] = 0;
                        }
                        outputPoint.y[0] = 1;
                        return;
                    }
                    modAdd(temp6, temp6, temp1);
                    montgomeryMultiply(temp4, temp3, outputPoint.z);
                    montgomeryMultiply(temp2, temp3, temp4);
                    montgomerySquare(temp3, temp0);
                    modAdd(temp1, temp4, temp1);
                    montgomeryMultiply(temp0, temp5, temp4);
                    montgomerySquare(temp1, temp7);
                    montgomeryMultiply(temp0, temp3, temp5);
                    modSub(temp7, temp4, outputPoint.x);
                    modSub(outputPoint.x, temp4, outputPoint.x);
                    modSub(outputPoint.x, temp5, outputPoint.x);
                    modSub(outputPoint.x, temp4, temp3);
                    montgomeryMultiply(temp5, temp6, temp0);
                    montgomeryMultiply(temp1, temp3, temp4);
                    modSub(temp4, temp0, outputPoint.y);
                    outputPoint.isInfinity = false;
                    outputPoint.isInMontgomeryForm = true;
                }
                function mixedAdd(jacobianPoint, affinePoint, outputPoint) {
                    if (jacobianPoint === null) {
                        throw new Error("jacobianPoint");
                    }
                    if (affinePoint === null) {
                        throw new Error("affinePoint");
                    }
                    if (outputPoint === null) {
                        throw new Error("outputPoint");
                    }
                    if (jacobianPoint.curve !== affinePoint.curve ||
                        jacobianPoint.curve !== outputPoint.curve) {
                        throw new Error("All points must be from the same curve object.");
                    }
                    if (jacobianPoint.isAffine) {
                        throw new Error("Given jacobianPoint was in Affine form. Use ConvertToJacobian()\
                     before calling DoubleJacobianAddAffinePoints().");
                    }
                    if (!affinePoint.isAffine) {
                        throw new Error("Given affinePoint was in Jacobian form. Use ConvertToAffine() before \
                     calling DoubleJacobianAddAffinePoints().");
                    }
                    if (outputPoint.isAffine) {
                        throw new Error("Given jacobianPoint was in Jacobian form. Use ConvertToJacobian() before \
                     calling DoubleJacobianAddAffinePoints().");
                    }
                    if (!jacobianPoint.isInMontgomeryForm) {
                        throw new Error("Jacobian point must be in Montgomery form");
                    }
                    if (!affinePoint.isInMontgomeryForm) {
                        throw new Error("Affine point must be in Montgomery form");
                    }
                    if (jacobianPoint.isInfinity) {
                        affinePoint.copy(outputPoint);
                        this.convertToJacobianForm(outputPoint);
                        return;
                    }
                    if (affinePoint.isInfinity) {
                        jacobianPoint.copy(outputPoint);
                        return;
                    }
                    montgomerySquare(jacobianPoint.z, temp1);
                    montgomeryMultiply(temp1, jacobianPoint.z, temp2);
                    montgomeryMultiply(temp1, affinePoint.x, temp3);
                    montgomeryMultiply(temp2, affinePoint.y, temp4);
                    modSub(temp3, jacobianPoint.x, temp1);
                    modSub(temp4, jacobianPoint.y, temp2);
                    var i;
                    for (i = 0; i < temp1.length; i += 1) {
                        if (temp1[i] !== 0) {
                            montgomeryMultiply(jacobianPoint.z, temp1, temp0);
                            for (var j = 0; j < fieldElementWidth; j += 1) {
                                outputPoint.z[j] = temp0[j];
                            }
                            montgomerySquare(temp1, temp3);
                            montgomeryMultiply(temp3, temp1, temp4);
                            montgomeryMultiply(temp3, jacobianPoint.x, temp5);
                            modAdd(temp5, temp5, temp1);
                            montgomerySquare(temp2, outputPoint.x);
                            modSub(outputPoint.x, temp1, outputPoint.x);
                            modSub(outputPoint.x, temp4, outputPoint.x);
                            modSub(temp5, outputPoint.x, temp3);
                            montgomeryMultiply(temp2, temp3, temp5);
                            montgomeryMultiply(jacobianPoint.y, temp4, temp6);
                            modSub(temp5, temp6, outputPoint.y);
                            outputPoint.isInfinity = false;
                            outputPoint.isInMontgomeryForm = true;
                            return;
                        }
                    }
                    for (i = 0; i < temp2.length; i += 1) {
                        if (temp2[i] !== 0) {
                            outputPoint.isInfinity = true;
                            outputPoint.isInMontgomeryForm = true;
                            return;
                        }
                    }
                    affinePoint.copy(outputPoint);
                    this.convertToJacobianForm(outputPoint);
                    this.double(outputPoint, outputPoint);
                    outputPoint.isInMontgomeryForm = true;
                }
                function scalarMultiply(k, point, outputPoint, multiplyBy4) {
                    if (point.isInfinity || cryptoMath.isZero(k)) {
                        outputPoint.isInfinity = true;
                        return;
                    }
                    if (cryptoMath.compareDigits(k, curve.order) >= 0) {
                        throw new Error("The scalar k must be in the range 1 <= k < order.");
                    }
                    k = k.slice();
                    if (point.curve.type === 1) {
                        var pointIsEP = typeof point.ta !== "undefined";
                        if (!pointIsEP) {
                            convertToExtendedProjective(point);
                        }
                        scalarMultiplyTed(k, point, outputPoint, multiplyBy4);
                        if (!pointIsEP) {
                            normalizeTed(point);
                        }
                    }
                    else {
                        var pointIsMF = point.isInMontgomeryForm, outputIsMF = outputPoint.isInMontgomeryForm, outputIsAffine = outputPoint.isAffine;
                        if (!pointIsMF) {
                            convertToMontgomeryForm(point);
                        }
                        if (!outputIsMF) {
                            convertToMontgomeryForm(outputPoint);
                        }
                        scalarMultiplyW(k, point, outputPoint);
                        if (outputIsAffine) {
                            convertToAffineForm(outputPoint);
                        }
                        if (!pointIsMF) {
                            convertToStandardForm(point);
                        }
                        if (!outputIsMF) {
                            convertToStandardForm(outputPoint);
                        }
                    }
                    return;
                }
                function scalarMultiplyW(k, point, outputPoint) {
                    var validationPoint = point.clone();
                    convertToStandardForm(validationPoint);
                    if (!validatePoint(validationPoint)) {
                        throw new Error("Invalid Parameters.");
                    }
                    var odd = k[0] & 1, tempk = [];
                    modSub(point.curve.order, k, tempk);
                    for (i = 0; i < k.length; i++) {
                        k[i] = odd - 1 & (k[i] ^ tempk[i]) ^ k[i];
                    }
                    var w = fieldElementWidth <= 8 ? 5 : 6;
                    var m = point.curve.p.length * cryptoMath.DIGIT_BITS;
                    var t = Math.ceil(m / (w - 1));
                    var kDigits = cryptoMath.fixedWindowRecode(k, w, t);
                    var Tm = generatePrecomputationTable(w, point);
                    var position = Math.floor(Math.abs(kDigits[t]) - 1) / 2;
                    var Q = Tm[position].clone();
                    convertToJacobianForm(Q);
                    for (var i = t - 1; i >= 0; i--) {
                        for (var j = 0; j < w - 2; j++) {
                            double(Q, Q);
                        }
                        position = Math.floor((Math.abs(kDigits[i]) - 1) / 2);
                        var L = tableLookupW(Tm, position);
                        modSub(L.curve.p, L.y, tempk);
                        var mask = -(kDigits[i] >>> 31);
                        for (var n = 0; n < L.y.length; n++) {
                            L.y[n] = (L.y[n] & ~mask) | (tempk[n] & mask);
                        }
                        mixedDoubleAdd(Q, L, Q);
                    }
                    modSub(point.curve.p, Q.y, tempk);
                    for (i = 0; i < Q.y.length; i++) {
                        Q.y[i] = odd - 1 & (Q.y[i] ^ tempk[i]) ^ Q.y[i];
                    }
                    Q.copy(outputPoint);
                    return;
                }
                function tableLookupW(table, index) {
                    var mask, L;
                    for (var i = 0; i < table.length; i++) {
                        mask = +(i === index);
                        L = [L, table[i].clone()][mask];
                    }
                    return L;
                }
                function tableLookupW0(table, index) {
                    var pos = (index + 1) % table.length;
                    for (var i = 0; i < table.length; i++) {
                        var L = table[pos].clone();
                        pos = (pos + 1) % table.length;
                    }
                    return L;
                }
                function negate(point, outputPoint) {
                    if (point !== outputPoint) {
                        point.copy(outputPoint);
                    }
                    modSub(point.curve.p, point.y, outputPoint.y);
                }
                function convertToMontgomeryForm(point) {
                    if (point.isInMontgomeryForm) {
                        throw new Error("The given point is already in Montgomery form.");
                    }
                    if (!point.isInfinity) {
                        montgomeryMultiplier.convertToMontgomeryForm(point.x);
                        montgomeryMultiplier.convertToMontgomeryForm(point.y);
                        if (point.z !== null) {
                            montgomeryMultiplier.convertToMontgomeryForm(point.z);
                        }
                        if (typeof point.ta !== "undefined") {
                            montgomeryMultiplier.convertToMontgomeryForm(point.ta);
                            montgomeryMultiplier.convertToMontgomeryForm(point.tb);
                        }
                    }
                    point.isInMontgomeryForm = true;
                }
                function convertToStandardForm(point) {
                    if (!point.isInMontgomeryForm) {
                        throw new Error("The given point is not in montgomery form.");
                    }
                    if (!point.isInfinity) {
                        montgomeryMultiplier.convertToStandardForm(point.x);
                        montgomeryMultiplier.convertToStandardForm(point.y);
                        if (point.z !== null) {
                            montgomeryMultiplier.convertToStandardForm(point.z);
                        }
                        if (typeof point.ta !== "undefined") {
                            montgomeryMultiplier.convertToStandardForm(point.ta);
                            montgomeryMultiplier.convertToStandardForm(point.tb);
                        }
                    }
                    point.isInMontgomeryForm = false;
                }
                function convertToAffineForm(point) {
                    if (point.isInfinity) {
                        point.z = null;
                        setterSupport || (point.isAffine = true);
                        return;
                    }
                    cryptoMath.modInv(point.z, curve.p, conversionTemp2, true);
                    if (point.isInMontgomeryForm) {
                        montgomeryMultiply(conversionTemp2, montgomeryMultiplier.rCubedModm, conversionTemp1);
                        var swap = conversionTemp2;
                        conversionTemp2 = conversionTemp1;
                        conversionTemp1 = swap;
                    }
                    montgomerySquare(conversionTemp2, conversionTemp0);
                    montgomeryMultiply(point.x, conversionTemp0, conversionTemp1);
                    for (var i = 0; i < fieldElementWidth; i += 1) {
                        point.x[i] = conversionTemp1[i];
                    }
                    montgomeryMultiply(point.y, conversionTemp0, conversionTemp1);
                    montgomeryMultiply(conversionTemp1, conversionTemp2, point.y);
                    point.z = null;
                    delete point.ta;
                    delete point.tb;
                    setterSupport || (point.isAffine = true);
                }
                function convertToJacobianForm(point) {
                    if (!point.isAffine) {
                        throw new Error("The given point is not in Affine form.");
                    }
                    setterSupport || (point.isAffine = false);
                    var clonedDigits, i, zOne = point.isInMontgomeryForm ? onemontgomery : one;
                    clonedDigits = createArray(zOne.length);
                    for (i = 0; i < zOne.length; i += 1) {
                        clonedDigits[i] = zOne[i];
                    }
                    point.z = clonedDigits;
                    return;
                }
                function validatePoint(point) {
                    if (point.isInfinity) {
                        return false;
                    }
                    cryptoMath.modMul(point.y, point.y, point.curve.p, temp1);
                    cryptoMath.modMul(point.x, point.x, point.curve.p, temp2);
                    cryptoMath.modMul(point.x, temp2, point.curve.p, temp3);
                    modAdd(temp3, point.curve.b, temp2);
                    cryptoMath.modMul(point.x, point.curve.a, point.curve.p, temp3);
                    modAdd(temp2, temp3, temp2);
                    modSub(temp1, temp2, temp1);
                    if (cryptoMath.isZero(temp1) === false) {
                        return false;
                    }
                    return true;
                }
                function validatePointTed(point) {
                    if (point.ta) {
                        point = point.clone();
                        normalizeTed(point);
                    }
                    cryptoMath.modMul(point.y, point.y, point.curve.p, temp3);
                    cryptoMath.modMul(point.x, point.x, point.curve.p, temp2);
                    cryptoMath.add(temp2, temp3, temp1);
                    cryptoMath.reduce(temp4, point.curve.p, temp4);
                    cryptoMath.modMul(temp2, temp3, point.curve.p, temp4);
                    cryptoMath.modMul(point.curve.d, temp4, point.curve.p, temp3);
                    cryptoMath.add(temp3, [1], temp2);
                    cryptoMath.reduce(temp2, point.curve.p, temp2);
                    cryptoMath.subtract(temp1, temp2, temp1);
                    if (cryptoMath.isZero(temp1) === false) {
                        cryptoMath.reduce(temp1, point.curve.p, temp1);
                        if (cryptoMath.isZero(temp1) === false) {
                            return false;
                        }
                    }
                    return true;
                }
                function generatePrecomputationTableTed(npoints, point) {
                    var Q = point.clone(), P2 = Q.clone(), T = [];
                    T[0] = convert_R1_to_R2(point);
                    doubleTed(Q, Q);
                    P2 = convert_R1_to_R2(Q);
                    Q = point.clone();
                    for (var i = 1; i < npoints; i++) {
                        addTedExtended(P2, Q, Q);
                        T[i] = convert_R1_to_R2(Q);
                    }
                    return T;
                }
                function convertToExtendedProjective(affinePoint) {
                    affinePoint.ta = affinePoint.x.slice();
                    affinePoint.tb = affinePoint.y.slice();
                    affinePoint.z = [1];
                }
                function scalarMultiplyTed(k, point, outputPoint, multiplyBy4) {
                    if (!validatePointTed(point)) {
                        throw new Error("Invalid Parameter");
                    }
                    var rbits = point.curve.rbits;
                    multiplyBy4 = typeof multiplyBy4 === "undefined" ? true : multiplyBy4;
                    var w = fieldElementWidth <= 8 ? 5 : 6;
                    var t = Math.floor((rbits + (w - 2)) / (w - 1));
                    var i, j;
                    k = k.slice();
                    var T = point.clone();
                    convertToExtendedProjective(T);
                    if (multiplyBy4) {
                        doubleTed(T, T);
                        doubleTed(T, T);
                    }
                    var precomputationTable = generatePrecomputationTableTed(1 << w - 2, T);
                    var odd = k[0] & 1, tempk = [], kisNeg;
                    modSub(point.curve.order, k, tempk);
                    for (i = 0; i < k.length; i++) {
                        k[i] = odd - 1 & (k[i] ^ tempk[i]) ^ k[i];
                    }
                    var kDigits = cryptoMath.fixedWindowRecode(k, w, t);
                    var position = Math.floor(Math.abs(kDigits[t]) - 1) / 2;
                    var R = precomputationTable[position];
                    T.x = R.x.slice();
                    T.y = R.y.slice();
                    T.z = R.z.slice();
                    for (i = t - 1; i >= 0; i--) {
                        for (j = 0; j < w - 1; j++) {
                            doubleTed(T, T);
                        }
                        position = Math.floor((Math.abs(kDigits[i]) - 1) / 2);
                        var L = tableLookupTed(precomputationTable, position);
                        var mask = -(kDigits[i] >>> 31);
                        modSub(point.curve.p, L.x, tempk);
                        for (var m = 0; m < L.x.length; m++) {
                            L.x[m] = (L.x[m] & ~mask) | (tempk[m] & mask);
                        }
                        modSub(point.curve.p, L.td, tempk);
                        for (m = 0; m < L.td.length; m++) {
                            L.td[m] = (L.td[m] & ~mask) | (tempk[m] & mask);
                        }
                        addTedExtended(L, T, T);
                    }
                    modSub(point.curve.p, T.x, tempk);
                    for (i = 0; i < T.x.length; i++) {
                        T.x[i] = odd - 1 & (T.x[i] ^ tempk[i]) ^ T.x[i];
                    }
                    normalizeTed(T);
                    outputPoint.x = T.x.slice();
                    outputPoint.y = T.y.slice();
                    return;
                }
                function tableLookupTed(table, index) {
                    var pos = (index + 1) % table.length;
                    for (var i = 0; i < table.length; i++) {
                        var L = {
                            x: table[pos].x.slice(),
                            y: table[pos].y.slice(),
                            z: table[pos].z.slice(),
                            td: table[pos].td.slice()
                        };
                        pos = (pos + 1) % table.length;
                    }
                    return L;
                }
                function normalizeTed(point) {
                    cryptoMath.modInv(point.z, curve.p, conversionTemp2, true);
                    cryptoMath.modMul(point.x, conversionTemp2, curve.p, point.x);
                    cryptoMath.modMul(point.y, conversionTemp2, curve.p, point.y);
                    delete point.ta;
                    delete point.tb;
                    point.z = null;
                    return;
                }
                function doubleTed(point, outputPoint) {
                    if (typeof point.ta === "undefined") {
                        throw new Error("Point should be in Extended Projective form.");
                    }
                    cryptoMath.modMul(point.x, point.x, point.curve.p, temp0);
                    cryptoMath.modMul(point.y, point.y, point.curve.p, temp1);
                    cryptoMath.modMul(point.z, point.z, point.curve.p, point.ta);
                    modSub(temp1, temp0, outputPoint.tb);
                    modAdd(temp0, temp1, temp0);
                    modAdd(point.ta, point.ta, point.ta);
                    modAdd(point.y, point.y, point.y);
                    modSub(point.ta, temp0, temp1);
                    cryptoMath.modMul(point.x, point.y, point.curve.p, outputPoint.ta);
                    cryptoMath.modMul(temp0, outputPoint.tb, point.curve.p, outputPoint.y);
                    cryptoMath.modMul(temp1, outputPoint.ta, point.curve.p, outputPoint.x);
                    cryptoMath.modMul(temp0, temp1, point.curve.p, outputPoint.z);
                    return;
                }
                function addTed(point1, point2, outputPoint) {
                    var cm = cryptoMath;
                    if (typeof point1.ta === "undefined") {
                        throw new Error("Point1 should be in Extended Projective form.");
                    }
                    if (typeof point2.ta === "undefined") {
                        throw new Error("Point2 should be in Extended Projective form.");
                    }
                    var qq = convert_R1_to_R2(point1);
                    addTedExtended(qq, point2, outputPoint);
                    return;
                }
                function convert_R1_to_R2(point) {
                    var curve = point.curve, modulus = curve.p, qq = {
                        x: point.x.slice(),
                        y: point.y.slice(),
                        z: point.z.slice(),
                        td: [],
                        curve: point.curve
                    };
                    cryptoMath.modMul(point.ta, point.tb, modulus, conversionTemp0);
                    cryptoMath.modMul(conversionTemp0, curve.d, modulus, qq.td);
                    return qq;
                }
                function addTedExtended(qq, point2, outputPoint) {
                    var cm = cryptoMath;
                    var modulus = point2.curve.p;
                    temp1 = [];
                    temp2 = [];
                    temp3 = [];
                    cm.modMul(point2.z, qq.z, modulus, temp3);
                    cm.modMul(point2.ta, point2.tb, modulus, temp1);
                    modAdd(point2.x, point2.y, point2.ta);
                    cm.modMul(temp1, qq.td, modulus, temp2);
                    modAdd(qq.x, qq.y, point2.tb);
                    modSub(temp3, temp2, temp1);
                    modAdd(temp3, temp2, temp3);
                    cm.modMul(point2.ta, point2.tb, modulus, temp2);
                    cm.modMul(point2.x, qq.x, modulus, point2.z);
                    cm.modMul(point2.y, qq.y, modulus, point2.x);
                    modSub(temp2, point2.z, temp2);
                    modSub(point2.x, point2.z, outputPoint.ta);
                    modSub(temp2, point2.x, outputPoint.tb);
                    cm.modMul(outputPoint.ta, temp3, modulus, outputPoint.y);
                    cm.modMul(outputPoint.tb, temp1, modulus, outputPoint.x);
                    cm.modMul(temp3, temp1, modulus, outputPoint.z);
                    return;
                }
                function convertTedToWeierstrass(tedPoint, wPoint) {
                    var a = tedPoint.curve.a.slice(), d = tedPoint.curve.d.slice(), p = tedPoint.curve.p, modMul = cryptoMath.modMul, modInv = cryptoMath.modInv;
                    temp1 = [5];
                    modMul(a, temp1, p, temp2);
                    modSub(temp2, d, temp2);
                    modMul(d, temp1, p, temp3);
                    modSub(a, temp3, temp1);
                    modMul(tedPoint.y, temp1, p, temp3);
                    modAdd(temp3, temp2, temp2);
                    temp1 = [1];
                    modSub(temp1, tedPoint.y, temp3);
                    temp1 = [12];
                    modMul(temp1, temp3, p, temp4);
                    modInv(temp4, p, temp4, true);
                    modMul(tedPoint.x, temp3, p, temp1);
                    modAdd(temp1, temp1, temp3);
                    modAdd(temp3, temp3, temp3);
                    modInv(temp3, p, temp3, true);
                    modMul(temp4, temp2, p, wPoint.x);
                    temp1 = [1];
                    modAdd(tedPoint.y, temp1, temp1);
                    modSub(a, d, temp2);
                    modMul(temp1, temp2, p, temp4);
                    modMul(temp4, temp3, p, wPoint.y);
                    return;
                }
                function convertWeierstrassToTed(wPoint, tedPoint) {
                    var a = tedPoint.curve.a.slice(), d = tedPoint.curve.d.slice(), p = tedPoint.curve.p, modMul = cryptoMath.modMul, modInv = cryptoMath.modInv;
                    modAdd(wPoint.x, wPoint.x, temp1);
                    modAdd(wPoint.x, temp1, temp1);
                    modAdd(temp1, temp1, temp1);
                    modSub(temp1, a, temp2);
                    modSub(temp2, d, temp2);
                    modAdd(wPoint.y, wPoint.y, temp3);
                    modAdd(wPoint.y, temp3, temp3);
                    modAdd(temp3, temp3, temp3);
                    modInv(temp3, p, temp3, true);
                    modMul(temp2, temp3, p, tedPoint.x);
                    modAdd(temp1, temp1, temp1);
                    modAdd(temp1, d, temp2);
                    modAdd(temp1, a, temp1);
                    modAdd(a, a, temp3);
                    modSub(temp2, temp3, temp2);
                    modSub(temp2, temp3, temp2);
                    modSub(temp2, a, temp2);
                    modAdd(d, d, temp3);
                    modSub(temp1, temp3, temp1);
                    modSub(temp1, temp3, temp1);
                    modSub(temp1, d, temp1);
                    modInv(temp1, p, temp1, true);
                    modMul(temp1, temp2, p, tedPoint.y);
                    return;
                }
                var methods = {
                    convertToMontgomeryForm: convertToMontgomeryForm,
                    convertToStandardForm: convertToStandardForm,
                    convertToAffineForm: convertToAffineForm,
                    convertToJacobianForm: convertToJacobianForm,
                    generatePrecomputationTable: function (w, generatorPoint) {
                        return generatePrecomputationTable(w, generatorPoint);
                    }
                };
                if (tedCurve) {
                    methods.double = doubleTed;
                    methods.add = addTed;
                    methods.scalarMultiply = scalarMultiply;
                    methods.normalize = normalizeTed;
                    methods.convertToExtendedProjective = convertToExtendedProjective;
                    methods.convertTedToWeierstrass = convertTedToWeierstrass;
                    methods.convertWeierstrassToTed = convertWeierstrassToTed;
                    methods.validatePoint = validatePointTed;
                    methods.generatePrecomputationTable = function (w, generatorPoint) {
                        return generatePrecomputationTableTed(w, generatorPoint);
                    };
                }
                else {
                    methods.double = double;
                    methods.mixedDoubleAdd = mixedDoubleAdd;
                    methods.mixedAdd = mixedAdd;
                    methods.scalarMultiply = scalarMultiply;
                    methods.negate = negate;
                    methods.validatePoint = validatePoint;
                }
                return methods;
            };
            var sec1EncodingFp = function () {
                return {
                    encodePoint: function (point) {
                        if (!point) {
                            throw new Error("point");
                        }
                        if (!point.isAffine) {
                            throw new Error("Point must be in affine form.");
                        }
                        if (point.isInMontgomeryForm) {
                            throw new Error("Point must not be in Montgomery form.");
                        }
                        if (point.isInfinity) {
                            return createArray(1);
                        }
                        else {
                            var xOctetString = cryptoMath.digitsToBytes(point.x);
                            var yOctetString = cryptoMath.digitsToBytes(point.y);
                            var pOctetString = cryptoMath.digitsToBytes(point.curve.p);
                            var mlen = pOctetString.length;
                            if (mlen < xOctetString.length || mlen < yOctetString.length) {
                                throw new Error("Point coordinate(s) are bigger than the field order.");
                            }
                            var output = createArray(2 * mlen + 1);
                            output[0] = 0x04;
                            var offset = mlen - xOctetString.length;
                            for (var i = 0; i < xOctetString.length; i++) {
                                output[i + 1 + offset] = xOctetString[i];
                            }
                            offset = mlen - yOctetString.length;
                            for (i = 0; i < yOctetString.length; i++) {
                                output[mlen + i + 1 + offset] = yOctetString[i];
                            }
                            return output;
                        }
                    },
                    decodePoint: function (encoded, curve) {
                        if (encoded.length < 1) {
                            throw new Error("Byte array must have non-zero length");
                        }
                        var pOctetString = cryptoMath.digitsToBytes(curve.p);
                        var mlen = pOctetString.length;
                        if (encoded[0] === 0x0 && encoded.length === 1) {
                            return curve.createPointAtInfinity();
                        }
                        else if (encoded[0] === 0x04 && encoded.length === 1 + 2 * mlen) {
                            var xbytes = createArray(mlen);
                            var ybytes = createArray(mlen);
                            for (var i = 0; i < mlen; i++) {
                                xbytes[i] = encoded[i + 1];
                                ybytes[i] = encoded[mlen + i + 1];
                            }
                            var x = cryptoMath.bytesToDigits(xbytes);
                            var y = cryptoMath.bytesToDigits(ybytes);
                            return EllipticCurvePointFp(curve, false, x, y);
                        }
                        else {
                            throw new Error("Unsupported encoding format");
                        }
                    }
                };
            };
            var ModularSquareRootSolver = function (modulus) {
                var p = modulus;
                var specialK = [];
                if (typeof modulus === "undefined") {
                    throw new Error("modulus");
                }
                if (cryptoMath.isEven(modulus)) {
                    throw new Error("Only odd moduli are supported");
                }
                var mul = cryptoMath.MontgomeryMultiplier(p);
                if (p[0] % 4 === 3) {
                    cryptoMath.add(p, cryptoMath.One, specialK);
                    cryptoMath.shiftRight(specialK, specialK, 2);
                }
                else {
                    specialK = null;
                }
                var temp0 = new Array(p.length);
                var temp1 = new Array(p.length);
                function squareRootNistCurves(a) {
                    var beta = cryptoMath.intToDigits(0, 16);
                    mul.modExp(a, specialK, beta);
                    var aPrime = [0];
                    cryptoMath.modMul(beta, beta, mul.m, aPrime);
                    if (cryptoMath.compareDigits(a, aPrime) !== 0) {
                        return null;
                    }
                    return beta;
                }
                var publicMethods = {
                    squareRoot: function (a) {
                        if (specialK !== null) {
                            return squareRootNistCurves(a);
                        }
                        else {
                            throw new Error("GeneralCase not supported.");
                        }
                    },
                    jacobiSymbol: function (a) {
                        var modEightMask = 0x7, modFourMask = 0x3, aPrime, pPrime;
                        aPrime = a.slice();
                        pPrime = p.slice();
                        cryptoMath.reduce(aPrime, pPrime, aPrime, temp0, temp1);
                        var t = 1;
                        while (!cryptoMath.isZero(aPrime)) {
                            while (cryptoMath.isEven(aPrime)) {
                                cryptoMath.shiftRight(aPrime, aPrime);
                                var pMod8 = pPrime[0] & modEightMask;
                                if (pMod8 === 3 || pMod8 === 5) {
                                    t = -t;
                                }
                            }
                            var tmp = aPrime;
                            aPrime = pPrime;
                            pPrime = tmp;
                            var aMod4 = aPrime[0] & modFourMask;
                            var pMod4 = pPrime[0] & modFourMask;
                            if (aMod4 === 3 && pMod4 === 3) {
                                t = -t;
                            }
                            cryptoMath.reduce(aPrime, pPrime, aPrime, temp0, temp1);
                        }
                        if (cryptoMath.compareDigits(pPrime, cryptoMath.One) === 0) {
                            return t;
                        }
                        else {
                            return 0;
                        }
                    }
                };
                return publicMethods;
            };
            var curvesInternal = {};
            var createCurve = function (curveName) {
                var curveData = curvesInternal[curveName.toUpperCase()];
                if (!curveData) {
                    throw new Error(curveName + " Unsupported curve.");
                }
                if (curveData.type === 0) {
                    return createWeierstrassCurve(curveData);
                }
                if (curveData.type === 1) {
                    return createTedCurve(curveData);
                }
                throw new Error(curveName + " Unsupported curve type.");
            };
            var validateEccPoint = function (curveName, x, y, z) {
                var curve = createCurve(curveName);
                var point = new EllipticCurvePointFp(curve, false, btd(x), btd(y), z && btd(z), false);
                var opp = new EllipticCurveOperatorFp(curve);
                return opp.validatePoint(point);
            };
            return {
                createCurve: createCurve,
                curves: curvesInternal,
                sec1EncodingFp: sec1EncodingFp,
                validatePoint: validateEccPoint,
                EllipticCurvePointFp: EllipticCurvePointFp,
                EllipticCurveOperatorFp: EllipticCurveOperatorFp,
                ModularSquareRootSolver: ModularSquareRootSolver
            };
        }
        var cryptoECC = cryptoECC || MsrcryptoECC();
        var curve_P256 = {
            name: "P-256",
            type: 0,
            p: [0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF],
            a: [0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC],
            b: [0x5A, 0xC6, 0x35, 0xD8, 0xAA, 0x3A, 0x93, 0xE7, 0xB3, 0xEB, 0xBD, 0x55, 0x76, 0x98, 0x86, 0xBC, 0x65, 0x1D, 0x06, 0xB0, 0xCC, 0x53, 0xB0, 0xF6, 0x3B, 0xCE, 0x3C, 0x3E, 0x27, 0xD2, 0x60, 0x4B],
            order: [0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xBC, 0xE6, 0xFA, 0xAD, 0xA7, 0x17, 0x9E, 0x84, 0xF3, 0xB9, 0xCA, 0xC2, 0xFC, 0x63, 0x25, 0x51],
            gx: [0x6B, 0x17, 0xD1, 0xF2, 0xE1, 0x2C, 0x42, 0x47, 0xF8, 0xBC, 0xE6, 0xE5, 0x63, 0xA4, 0x40, 0xF2, 0x77, 0x03, 0x7D, 0x81, 0x2D, 0xEB, 0x33, 0xA0, 0xF4, 0xA1, 0x39, 0x45, 0xD8, 0x98, 0xC2, 0x96],
            gy: [0x4F, 0xE3, 0x42, 0xE2, 0xFE, 0x1A, 0x7F, 0x9B, 0x8E, 0xE7, 0xEB, 0x4A, 0x7C, 0x0F, 0x9E, 0x16, 0x2B, 0xCE, 0x33, 0x57, 0x6B, 0x31, 0x5E, 0xCE, 0xCB, 0xB6, 0x40, 0x68, 0x37, 0xBF, 0x51, 0xF5],
            cf: 1
        };
        var curve_P384 = {
            name: "P-384",
            type: 0,
            p: [0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 0xFF],
            a: [0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xFF, 0xFF, 0xFF, 0xFC],
            b: [0xB3, 0x31, 0x2F, 0xA7, 0xE2, 0x3E, 0xE7, 0xE4, 0x98, 0x8E, 0x05, 0x6B, 0xE3, 0xF8, 0x2D, 0x19, 0x18, 0x1D, 0x9C, 0x6E, 0xFE, 0x81, 0x41, 0x12, 0x03, 0x14, 0x08, 0x8F, 0x50, 0x13, 0x87, 0x5A, 0xC6, 0x56, 0x39, 0x8D, 0x8A, 0x2E, 0xD1, 0x9D, 0x2A, 0x85, 0xC8, 0xED, 0xD3, 0xEC, 0x2A, 0xEF],
            order: [0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xC7, 0x63, 0x4D, 0x81, 0xF4, 0x37, 0x2D, 0xDF, 0x58, 0x1A, 0x0D, 0xB2, 0x48, 0xB0, 0xA7, 0x7A, 0xEC, 0xEC, 0x19, 0x6A, 0xCC, 0xC5, 0x29, 0x73],
            gx: [0xAA, 0x87, 0xCA, 0x22, 0xBE, 0x8B, 0x05, 0x37, 0x8E, 0xB1, 0xC7, 0x1E, 0xF3, 0x20, 0xAD, 0x74, 0x6E, 0x1D, 0x3B, 0x62, 0x8B, 0xA7, 0x9B, 0x98, 0x59, 0xF7, 0x41, 0xE0, 0x82, 0x54, 0x2A, 0x38, 0x55, 0x02, 0xF2, 0x5D, 0xBF, 0x55, 0x29, 0x6C, 0x3A, 0x54, 0x5E, 0x38, 0x72, 0x76, 0x0A, 0xB7],
            gy: [0x36, 0x17, 0xDE, 0x4A, 0x96, 0x26, 0x2C, 0x6F, 0x5D, 0x9E, 0x98, 0xBF, 0x92, 0x92, 0xDC, 0x29, 0xF8, 0xF4, 0x1D, 0xBD, 0x28, 0x9A, 0x14, 0x7C, 0xE9, 0xDA, 0x31, 0x13, 0xB5, 0xF0, 0xB8, 0xC0, 0x0A, 0x60, 0xB1, 0xCE, 0x1D, 0x7E, 0x81, 0x9D, 0x7A, 0x43, 0x1D, 0x7C, 0x90, 0xEA, 0x0E, 0x5F],
            cf: 1
        };
        var curve_P521 = {
            name: "P-521",
            type: 0,
            p: [0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF],
            a: [0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFC],
            b: [0x00, 0x51, 0x95, 0x3E, 0xB9, 0x61, 0x8E, 0x1C, 0x9A, 0x1F, 0x92, 0x9A, 0x21, 0xA0, 0xB6, 0x85, 0x40, 0xEE, 0xA2, 0xDA, 0x72, 0x5B, 0x99, 0xB3, 0x15, 0xF3, 0xB8, 0xB4, 0x89, 0x91, 0x8E, 0xF1, 0x09, 0xE1, 0x56, 0x19, 0x39, 0x51, 0xEC, 0x7E, 0x93, 0x7B, 0x16, 0x52, 0xC0, 0xBD, 0x3B, 0xB1, 0xBF, 0x07, 0x35, 0x73, 0xDF, 0x88, 0x3D, 0x2C, 0x34, 0xF1, 0xEF, 0x45, 0x1F, 0xD4, 0x6B, 0x50, 0x3F, 0x00],
            order: [0x01, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFA, 0x51, 0x86, 0x87, 0x83, 0xBF, 0x2F, 0x96, 0x6B, 0x7F, 0xCC, 0x01, 0x48, 0xF7, 0x09, 0xA5, 0xD0, 0x3B, 0xB5, 0xC9, 0xB8, 0x89, 0x9C, 0x47, 0xAE, 0xBB, 0x6F, 0xB7, 0x1E, 0x91, 0x38, 0x64, 0x09],
            gx: [0x00, 0xC6, 0x85, 0x8E, 0x06, 0xB7, 0x04, 0x04, 0xE9, 0xCD, 0x9E, 0x3E, 0xCB, 0x66, 0x23, 0x95, 0xB4, 0x42, 0x9C, 0x64, 0x81, 0x39, 0x05, 0x3F, 0xB5, 0x21, 0xF8, 0x28, 0xAF, 0x60, 0x6B, 0x4D, 0x3D, 0xBA, 0xA1, 0x4B, 0x5E, 0x77, 0xEF, 0xE7, 0x59, 0x28, 0xFE, 0x1D, 0xC1, 0x27, 0xA2, 0xFF, 0xA8, 0xDE, 0x33, 0x48, 0xB3, 0xC1, 0x85, 0x6A, 0x42, 0x9B, 0xF9, 0x7E, 0x7E, 0x31, 0xC2, 0xE5, 0xBD, 0x66],
            gy: [0x01, 0x18, 0x39, 0x29, 0x6A, 0x78, 0x9A, 0x3B, 0xC0, 0x04, 0x5C, 0x8A, 0x5F, 0xB4, 0x2C, 0x7D, 0x1B, 0xD9, 0x98, 0xF5, 0x44, 0x49, 0x57, 0x9B, 0x44, 0x68, 0x17, 0xAF, 0xBD, 0x17, 0x27, 0x3E, 0x66, 0x2C, 0x97, 0xEE, 0x72, 0x99, 0x5E, 0xF4, 0x26, 0x40, 0xC5, 0x50, 0xB9, 0x01, 0x3F, 0xAD, 0x07, 0x61, 0x35, 0x3C, 0x70, 0x86, 0xA2, 0x72, 0xC2, 0x40, 0x88, 0xBE, 0x94, 0x76, 0x9F, 0xD1, 0x66, 0x50],
            cf: 1
        };
        if (typeof cryptoECC !== "undefined") {
            cryptoECC.curves["P-256"] = curve_P256;
            cryptoECC.curves["P-384"] = curve_P384;
            cryptoECC.curves["P-521"] = curve_P521;
        }
        var curve_BN254 = {
            name: "BN-254",
            type: 0,
            p: [0x25, 0x23, 0x64, 0x82, 0x40, 0x00, 0x00, 0x01, 0xBA, 0x34, 0x4D, 0x80, 0x00, 0x00, 0x00, 0x08, 0x61, 0x21, 0x00, 0x00, 0x00, 0x00, 0x00, 0x13, 0xA7, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x13],
            a: [0x00],
            b: [0x02],
            order: [0x25, 0x23, 0x64, 0x82, 0x40, 0x00, 0x00, 0x01, 0xBA, 0x34, 0x4D, 0x80, 0x00, 0x00, 0x00, 0x07, 0xFF, 0x9F, 0x80, 0x00, 0x00, 0x00, 0x00, 0x10, 0xA1, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x0D],
            gx: [0x25, 0x23, 0x64, 0x82, 0x40, 0x00, 0x00, 0x01, 0xBA, 0x34, 0x4D, 0x80, 0x00, 0x00, 0x00, 0x08, 0x61, 0x21, 0x00, 0x00, 0x00, 0x00, 0x00, 0x13, 0xA7, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x12],
            gy: [0x01],
            cf: 1
        };
        if (typeof cryptoECC !== "undefined") {
            cryptoECC.curves["BN-254"] = curve_BN254;
        }
        var curve_numsp256d1 = {
            info: ["numsp256d1", 256, 256, 256],
            type: 0,
            p: [0x43, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF].reverse(),
            a: [0x40, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF].reverse(),
            b: [0x81, 0x55, 0x02].reverse(),
            order: [0x25, 0xa8, 0x51, 0x47, 0x29, 0x20, 0xab, 0x20, 0x60, 0x5c, 0x26, 0xea, 0x75, 0x82, 0x3c, 0xe4, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff].reverse(),
            gx: [0xB1, 0xAC, 0x1A, 0xB2, 0x1E, 0xEE, 0x52, 0xBC, 0x3A, 0xC7, 0xD4, 0x03, 0x09, 0x9B, 0x57, 0x83, 0x09, 0xCB, 0x42, 0x4F, 0xA0, 0x95, 0x7A, 0x29, 0x61, 0xDB, 0xAA, 0x5A, 0xB6, 0xD6, 0x9E, 0xBC].reverse(),
            gy: [0x9F, 0xDE, 0x84, 0x21, 0xCB, 0xB9, 0xB5, 0x80, 0xBB, 0x0F, 0x31, 0x15, 0xD1, 0xC3, 0x55, 0xC9, 0x35, 0xE0, 0x04, 0x7E, 0xF7, 0x8B, 0x44, 0x73, 0xA6, 0xB6, 0x99, 0x33, 0xF1, 0xC0, 0x8F, 0xD0].reverse(),
            cf: 1
        };
        var curve_numsp256t1 = {
            info: ["numsp256t1", 256, 255, 256],
            name: "numsp256t1",
            type: 1,
            p: [0x43, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF].reverse(),
            a: [0x01],
            d: [0x55, 0xC3, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF].reverse(),
            order: [0xF5, 0x4A, 0xDD, 0xEE, 0x90, 0xB1, 0x47, 0x1A, 0x9B, 0x43, 0x59, 0x2F, 0xA5, 0x5A, 0x95, 0x41, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40].reverse(),
            gx: [0xDA, 0x13, 0xED, 0x2E, 0x90, 0xC0, 0xDE, 0xA0, 0x86, 0x35, 0x08, 0xE3, 0x0E, 0x8A, 0x39, 0x0C, 0xD6, 0x9B, 0x20, 0x69, 0x5F, 0x3D, 0x1E, 0xCD, 0x7D, 0x23, 0xEA, 0x6A, 0xFB, 0x14, 0x75, 0x8A].reverse(),
            gy: [0xE6, 0x89, 0x8A, 0x79, 0xE7, 0x16, 0xA6, 0x2F, 0xD3, 0x6E, 0x85, 0x10, 0xD8, 0x61, 0x5F, 0x71, 0x10, 0x80, 0x4B, 0xA6, 0xD9, 0x65, 0x96, 0xCE, 0xC7, 0x25, 0xD9, 0xD9, 0x9F, 0x3E, 0xD5, 0x44].reverse(),
            cf: 4
        };
        var curve_numsp384d1 = {
            info: ["numsp384d1", 384, 384, 384],
            name: "numsp384d1",
            type: 0,
            p: [0xC3, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            a: [0xC0, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            b: [0xBB, 0x77, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            order: [0xb9, 0x61, 0x0e, 0x7b, 0xf6, 0x81, 0x4d, 0x60, 0x7a, 0xe2, 0x37, 0x4c, 0x3d, 0x9d, 0xda, 0xbe, 0x81, 0x68, 0x5d, 0xeb, 0x1e, 0xaf, 0x1e, 0xd6, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
                0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff
            ].reverse(),
            gx: [0x2A, 0x15, 0x98, 0x20, 0x04, 0xBA, 0x9C, 0xEB, 0x7B, 0xC4, 0x61, 0x0F, 0x10, 0xED, 0x2E, 0x52, 0x42, 0xC7, 0x6C, 0x2A, 0x1B, 0x29, 0xBD, 0xF3, 0xF4, 0xF9, 0x81, 0xFB, 0xCD, 0xC1, 0x25, 0x02,
                0xA6, 0xF1, 0x05, 0x41, 0x22, 0xCA, 0x80, 0x48, 0x1C, 0x18, 0x6F, 0xB1, 0xF0, 0x56, 0x79, 0x75
            ].reverse(),
            gy: [0x16, 0x07, 0x18, 0x66, 0xEC, 0xB8, 0x74, 0x5C, 0x26, 0xAD, 0xF4, 0xBF, 0xDB, 0xB4, 0xD6, 0xBC, 0x7E, 0x83, 0x1A, 0x12, 0x7D, 0x83, 0x20, 0xB9, 0x9C, 0x73, 0x7F, 0xF8, 0x77, 0x69, 0x04, 0xB0,
                0x7E, 0xCF, 0x84, 0x05, 0x30, 0x3D, 0xE3, 0xD7, 0x38, 0x8E, 0x9B, 0xE1, 0x68, 0xE3, 0xDE, 0xAC
            ].reverse(),
            cf: 1
        };
        var curve_numsp384t1 = {
            info: ["numsp384t1", 384, 382, 384],
            name: "numsp384t1",
            type: 1,
            p: [0xC3, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            a: [0x01],
            d: [0x9F, 0xD1, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            order: [0x7D, 0x89, 0xA3, 0xE6, 0xC4, 0xDC, 0xB9, 0x20, 0x79, 0xC8, 0x35, 0xAB, 0x5A, 0x55, 0xE4, 0x61, 0xCF, 0xE1, 0x6B, 0xB4, 0x1C, 0x1A, 0x47, 0xE2, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x3F
            ].reverse(),
            gx: [0xDE, 0x6B, 0x20, 0x6C, 0xE4, 0x40, 0xD5, 0x50, 0x13, 0x94, 0x45, 0x65, 0xB1, 0x92, 0xF2, 0x6F, 0x40, 0x63, 0x31, 0xF3, 0xA8, 0xFF, 0x63, 0x57, 0x00, 0x4C, 0xBE, 0xE5, 0x46, 0xF4, 0x0B, 0xB3,
                0xB5, 0x5D, 0xE5, 0x9A, 0x12, 0xA2, 0xB6, 0xC0, 0x6C, 0x26, 0xA9, 0x45, 0xFB, 0x11, 0xB1, 0x61
            ].reverse(),
            gy: [0x92, 0x93, 0x72, 0xF0, 0xE1, 0x03, 0x8D, 0x9D, 0xDC, 0x48, 0xEC, 0x46, 0xF9, 0xB0, 0x72, 0x00, 0x4B, 0x96, 0x45, 0xF6, 0xF7, 0x98, 0x0F, 0x83, 0x56, 0x5F, 0x42, 0xF1, 0x74, 0x82, 0xAD, 0x16,
                0xD7, 0x0D, 0xB1, 0x23, 0xA4, 0xB1, 0x38, 0x87, 0xB0, 0xEE, 0xA6, 0xB9, 0x67, 0x3E, 0x98, 0x82
            ].reverse(),
            cf: 4
        };
        var curve_numsp512d1 = {
            info: ["numsp512d1", 512, 512, 512],
            name: "numsp512d1",
            type: 0,
            p: [0xC7, 0xFD, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            a: [0xC4, 0xFD, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            b: [0x9B, 0xD9, 0x01].reverse(),
            order: [0x5d, 0x55, 0x33, 0x04, 0x39, 0x3f, 0x15, 0xce, 0x43, 0xd2, 0x7c, 0x60, 0x36, 0x8b, 0x56, 0x3b, 0xc6, 0xbd, 0xd0, 0x97, 0xed, 0x58, 0xc2, 0x4f, 0x1b, 0x83, 0xe7, 0x94, 0xfb, 0xa4, 0x3c, 0x5b,
                0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff
            ].reverse(),
            gx: [0x57, 0xAE, 0xAB, 0x8C, 0x95, 0x87, 0x82, 0xDC, 0xE2, 0x5D, 0x6F, 0x7D, 0x13, 0x60, 0x5D, 0x1D, 0x83, 0x15, 0x56, 0x25, 0x86, 0x42, 0x79, 0x93, 0x9E, 0x35, 0x6B, 0x07, 0x51, 0xA1, 0x21, 0x50,
                0xF9, 0xD9, 0x06, 0x53, 0xC2, 0xE0, 0x06, 0x45, 0x85, 0xF6, 0x01, 0xB5, 0x3B, 0xD8, 0xCA, 0x98, 0x52, 0x3B, 0x3D, 0xA0, 0x02, 0x70, 0x2B, 0xDA, 0x93, 0x0A, 0x1D, 0x14, 0x47, 0x34, 0xC0, 0x3A
            ].reverse(),
            gy: [0xA6, 0x27, 0x35, 0x38, 0x60, 0x87, 0xA0, 0x23, 0xE9, 0x0F, 0xFD, 0x4C, 0x1E, 0x5C, 0x2B, 0xCF, 0x02, 0x56, 0x5A, 0xB2, 0x40, 0xA8, 0x21, 0xC1, 0xE9, 0xED, 0x0E, 0x8B, 0xDA, 0x15, 0x84, 0xA2,
                0x14, 0x4F, 0xD1, 0x7B, 0x0C, 0x26, 0x4B, 0x8F, 0x8C, 0xBB, 0xBC, 0xAB, 0xDE, 0xDB, 0x97, 0x4B, 0x00, 0xB1, 0xEB, 0x63, 0xDC, 0xEE, 0x0E, 0xCE, 0xB3, 0x56, 0xAD, 0x29, 0xCA, 0x54, 0x3A, 0x94
            ].reverse(),
            cf: 4
        };
        var curve_numsp512t1 = {
            info: ["numsp512t1", 512, 510, 512],
            name: "numsp512t1",
            type: 1,
            p: [0xC7, 0xFD, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            a: [0x01].reverse(),
            d: [0xEF, 0xCB, 0xFE, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF
            ].reverse(),
            order: [0x6D, 0xD4, 0xEE, 0x1B, 0xF5, 0x8C, 0x46, 0x67, 0xFF, 0xEC, 0xEF, 0x6D, 0x78, 0x05, 0x46, 0x2A, 0xF5, 0x86, 0xB6, 0x70, 0xC9, 0xD8, 0x3F, 0x9E, 0xBA, 0x91, 0xCF, 0x2F, 0x6D, 0x63, 0xF0, 0xB4,
                0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0xFF, 0x3F
            ].reverse(),
            gx: [0xFE, 0x57, 0xEC, 0x99, 0x29, 0xAB, 0xB9, 0xC5, 0x15, 0xF0, 0xC4, 0x7C, 0x42, 0x25, 0xE5, 0x0F, 0xAD, 0x04, 0x89, 0x56, 0x92, 0xC9, 0xBD, 0x78, 0x0F, 0x73, 0x46, 0xEE, 0x4E, 0xC1, 0x21, 0x46,
                0x47, 0x81, 0x3B, 0x27, 0xBE, 0x7E, 0xA1, 0x27, 0x82, 0xA3, 0xC4, 0x4D, 0x9F, 0xE7, 0xD1, 0x2F, 0x33, 0xC5, 0xD3, 0x88, 0x78, 0xCB, 0x18, 0x7A, 0x9C, 0xB6, 0x8D, 0x12, 0x6D, 0x31, 0x8E, 0xDF
            ].reverse(),
            gy: [0xE1, 0xF5, 0xE2, 0xC1, 0xC0, 0xDE, 0x6D, 0x32, 0x1F, 0xD0, 0xF1, 0x9B, 0x8A, 0xD3, 0x66, 0x02, 0xFD, 0xC1, 0xEC, 0x2A, 0x86, 0x06, 0x1A, 0x60, 0x62, 0x35, 0x96, 0xE9, 0xF2, 0x53, 0xCA, 0x20,
                0x41, 0x83, 0x9E, 0x90, 0x95, 0x6B, 0x2B, 0xA9, 0x22, 0x9D, 0x25, 0xD8, 0x26, 0xF7, 0x76, 0xE4, 0x6E, 0x25, 0x2A, 0xA8, 0x77, 0xF5, 0xB0, 0x98, 0x71, 0xCA, 0x49, 0x9D, 0xF3, 0xBF, 0x09, 0x6D
            ].reverse(),
            cf: 4
        };
        if (typeof cryptoECC !== "undefined") {
            cryptoECC.curves.NUMSP256D1 = curve_numsp256d1;
            cryptoECC.curves.NUMSP384D1 = curve_numsp384d1;
            cryptoECC.curves.NUMSP512D1 = curve_numsp512d1;
            cryptoECC.curves.NUMSP256T1 = curve_numsp256t1;
            cryptoECC.curves.NUMSP384T1 = curve_numsp384t1;
            cryptoECC.curves.NUMSP512T1 = curve_numsp512t1;
        }
        var msrcryptoSha = function (name, der, h, k, blockBytes, blockFunction, truncateTo) {
            var utils = msrcryptoUtilities;
            var hv = h.slice(), w = new Array(blockBytes), buffer = [], blocksProcessed = 0;
            function hashBlocks(message) {
                var blockCount = Math.floor(message.length / blockBytes);
                for (var block = 0; block < blockCount; block++) {
                    blockFunction(message, block, hv, k, w);
                }
                blocksProcessed += blockCount;
                return message.slice(blockCount * blockBytes);
            }
            function hashToBytes() {
                var hash = [];
                for (var i = 0; i < hv.length; i++) {
                    hash = hash.concat(utils.int32ToBytes(hv[i]));
                }
                hash.length = truncateTo / 8;
                return hash;
            }
            function addPadding(messageBytes) {
                var padLen = blockBytes - messageBytes.length % blockBytes;
                (padLen <= (blockBytes / 8)) && (padLen += blockBytes);
                var padding = utils.getVector(padLen);
                padding[0] = 128;
                var messageLenBits = (messageBytes.length + blocksProcessed * blockBytes) * 8;
                for (var i = 1; i <= 8; i++) {
                    padding[padLen - i] = messageLenBits % 0x100;
                    messageLenBits = Math.floor(messageLenBits / 0x100);
                }
                return messageBytes.concat(padding);
            }
            function computeHash(messageBytes) {
                buffer = hashBlocks(messageBytes);
                return finish();
            }
            function process(messageBytes) {
                buffer = buffer.concat(messageBytes);
                if (buffer.length >= blockBytes) {
                    buffer = hashBlocks(buffer);
                }
                return;
            }
            function finish() {
                if (hashBlocks(addPadding(buffer)).length !== 0) {
                    throw new Error("buffer.length !== 0");
                }
                var result = hashToBytes();
                buffer = [];
                hv = h.slice();
                blocksProcessed = 0;
                return result;
            }
            return {
                name: name,
                computeHash: computeHash,
                process: process,
                finish: finish,
                der: der,
                hashLen: truncateTo,
                maxMessageSize: 0xFFFFFFFF
            };
        };
        var msrcryptoSha1 = (function () {
            function hashBlock(message, blockIndex, hv, k, w) {
                var t, i, temp, x0, blockSize = 64, mask = 0xFFFFFFFF;
                var ra = hv[0], rb = hv[1], rc = hv[2], rd = hv[3], re = hv[4];
                for (i = 0; i < 16; i++) {
                    w[i] = utils.bytesToInt32(message, blockIndex * blockSize + i * 4);
                }
                for (t = 16; t < 80; t++) {
                    x0 = w[t - 3] ^ w[t - 8] ^ w[t - 14] ^ w[t - 16];
                    w[t] = (x0 << 1) | (x0 >>> 31);
                }
                for (i = 0; i < 80; i++) {
                    temp = ((ra << 5) | (ra >>> 27));
                    temp +=
                        i >= 60 ? (rb ^ rc ^ rd) :
                            i >= 40 ? ((rb & rc) ^ (rb & rd) ^ (rc & rd)) :
                                i >= 20 ? (rb ^ rc ^ rd) :
                                    ((rb & rc) ^ ((~rb) & rd));
                    temp += (re + k[i] + w[i]);
                    re = rd;
                    rd = rc;
                    rc = ((rb << 30) | (rb >>> 2));
                    rb = ra;
                    ra = temp;
                }
                hv[0] += ra & mask;
                hv[1] += rb & mask;
                hv[2] += rc & mask;
                hv[3] += rd & mask;
                hv[4] += re & mask;
                return hv;
            }
            var utils = msrcryptoUtilities, upd = utils.unpackData, h = upd("Z0UjAe/Nq4mYutz+EDJUdsPS4fA=", 4, 1), k = upd("WoJ5mVqCeZlagnmZWoJ5mVqCeZlagnmZWoJ5mVqCeZlagnmZWoJ5mVqCeZlagnmZWoJ5mVqCeZlagnmZWoJ5mVqCeZlagnmZWoJ5mVqCeZlu2euhbtnroW7Z66Fu2euhbtnroW7Z66Fu2euhbtnroW7Z66Fu2euhbtnroW7Z66Fu2euhbtnroW7Z66Fu2euhbtnroW7Z66Fu2euhbtnroY8bvNyPG7zcjxu83I8bvNyPG7zcjxu83I8bvNyPG7zcjxu83I8bvNyPG7zcjxu83I8bvNyPG7zcjxu83I8bvNyPG7zcjxu83I8bvNyPG7zcymLB1spiwdbKYsHWymLB1spiwdbKYsHWymLB1spiwdbKYsHWymLB1spiwdbKYsHWymLB1spiwdbKYsHWymLB1spiwdbKYsHWymLB1spiwdY", 4, 1), der = upd("MCEwCQYFKw4DAhoFAAQU");
            return {
                sha1: function () {
                    return msrcryptoSha("SHA-1", der, h, k, 64, hashBlock, 160);
                }
            };
        })();
        if (typeof operations !== "undefined") {
            msrcryptoSha1.instances = {};
            msrcryptoSha1.getInstance = function (id) {
                return msrcryptoSha1.instances[id] || (msrcryptoSha1.instances[id] = msrcryptoSha1.sha1());
            };
            msrcryptoSha1.deleteInstance = function (id) {
                msrcryptoSha1.instances[id] = null;
                delete msrcryptoSha1.instances[id];
            };
            msrcryptoSha1.hash = function (p) {
                if (p.operationSubType === "process") {
                    msrcryptoSha1.sha1.process(p.buffer);
                    return;
                }
                if (p.operationSubType === "finish") {
                    return msrcryptoSha1.sha1.finish();
                }
                return msrcryptoSha1.sha1().computeHash(p.buffer);
            };
            operations.register("digest", "SHA-1", msrcryptoSha1.hash);
        }
        msrcryptoHashFunctions["SHA-1"] = msrcryptoSha1.sha1;
        var msrcryptoSha256 = (function () {
            var utils = msrcryptoUtilities;
            function hashBlock(message, blockIndex, hv, k, w) {
                var t, i, temp, x0, x1, blockSize = 64, mask = 0xFFFFFFFF;
                var ra = hv[0], rb = hv[1], rc = hv[2], rd = hv[3], re = hv[4], rf = hv[5], rg = hv[6], rh = hv[7];
                for (i = 0; i < 16; i++) {
                    w[i] = utils.bytesToInt32(message, blockIndex * blockSize + i * 4);
                }
                for (t = 16; t < 64; t++) {
                    x0 = w[t - 15];
                    x1 = w[t - 2];
                    w[t] = (((x1 >>> 17) | (x1 << 15)) ^ ((x1 >>> 19) | (x1 << 13)) ^ (x1 >>> 10)) +
                        w[t - 7] +
                        (((x0 >>> 7) | (x0 << 25)) ^ ((x0 >>> 18) | (x0 << 14)) ^ (x0 >>> 3)) +
                        w[t - 16];
                    w[t] = w[t] & mask;
                }
                for (i = 0; i < 64; i++) {
                    temp = rh +
                        ((re >>> 6 | re << 26) ^ (re >>> 11 | re << 21) ^ (re >>> 25 | re << 7)) +
                        ((re & rf) ^ ((~re) & rg)) +
                        k[i] + w[i];
                    rd += temp;
                    temp += ((ra >>> 2 | ra << 30) ^ (ra >>> 13 | ra << 19) ^ (ra >>> 22 | ra << 10)) +
                        ((ra & (rb ^ rc)) ^ (rb & rc));
                    rh = rg;
                    rg = rf;
                    rf = re;
                    re = rd;
                    rd = rc;
                    rc = rb;
                    rb = ra;
                    ra = temp;
                }
                hv[0] = (hv[0] + ra) >>> 0;
                hv[1] = (hv[1] + rb) >>> 0;
                hv[2] = (hv[2] + rc) >>> 0;
                hv[3] = (hv[3] + rd) >>> 0;
                hv[4] = (hv[4] + re) >>> 0;
                hv[5] = (hv[5] + rf) >>> 0;
                hv[6] = (hv[6] + rg) >>> 0;
                hv[7] = (hv[7] + rh) >>> 0;
                return hv;
            }
            var k256, h224, h256, der224, der256, upd = utils.unpackData;
            h224 = upd("wQWe2DZ81QcwcN0X9w5ZOf/ACzFoWBURZPmPp776T6Q", 4, 1);
            h256 = upd("agnmZ7tnroU8bvNypU/1OlEOUn+bBWiMH4PZq1vgzRk", 4, 1);
            k256 = upd("QoovmHE3RJG1wPvP6bXbpTlWwltZ8RHxkj+CpKscXtXYB6qYEoNbASQxhb5VDH3Dcr5ddIDesf6b3AanwZvxdOSbacHvvkeGD8GdxiQMocwt6SxvSnSEqlywqdx2+YjamD5RUqgxxm2wAyfIv1l/x8bgC/PVp5FHBspjURQpKWcntwqFLhshOE0sbfxTOA0TZQpzVHZqCruBwskuknIshaK/6KGoGmZLwkuLcMdsUaPRkugZ1pkGJPQONYUQaqBwGaTBFh43bAgnSHdMNLC8tTkcDLNO2KpKW5zKT2gub/N0j4LueKVjb4TIeBSMxwIIkL7/+qRQbOu++aP3xnF48g", 4, 1);
            der224 = upd("MC0wDQYJYIZIAWUDBAIEBQAEHA");
            der256 = upd("MDEwDQYJYIZIAWUDBAIBBQAEIA");
            return {
                sha224: function () {
                    return msrcryptoSha("SHA-224", der224, h224, k256, 64, hashBlock, 224);
                },
                sha256: function () {
                    return msrcryptoSha("SHA-256", der256, h256, k256, 64, hashBlock, 256);
                }
            };
        })();
        if (typeof operations !== "undefined") {
            msrcryptoSha256.instance224 = msrcryptoSha256.instance224 || msrcryptoSha256.sha224();
            msrcryptoSha256.instance256 = msrcryptoSha256.instance256 || msrcryptoSha256.sha256();
            msrcryptoSha256.instances = {};
            msrcryptoSha256.getInstance224 = function (id) {
                return msrcryptoSha256.instances[id] || (msrcryptoSha256.instances[id] = msrcryptoSha256.sha224());
            };
            msrcryptoSha256.getInstance256 = function (id) {
                return msrcryptoSha256.instances[id] || (msrcryptoSha256.instances[id] = msrcryptoSha256.sha256());
            };
            msrcryptoSha256.deleteInstance = function (id) {
                msrcryptoSha256.instances[id] = null;
                delete msrcryptoSha256.instances[id];
            };
            msrcryptoSha256.hash256 = function (p) {
                if (p.operationSubType === "process") {
                    msrcryptoSha256.getInstance256(p.workerid).process(p.buffer);
                    return null;
                }
                if (p.operationSubType === "finish") {
                    var result = msrcryptoSha256.getInstance256(p.workerid).finish();
                    msrcryptoSha256.deleteInstance(p.workerid);
                    return result;
                }
                if (p.operationSubType === "abort") {
                    msrcryptoSha256.deleteInstance(p.workerid);
                    return;
                }
                return msrcryptoSha256.instance256.computeHash(p.buffer);
            };
            msrcryptoSha256.hash224 = function (p) {
                if (p.operationSubType === "process") {
                    msrcryptoSha256.getInstance224(p.workerid).process(p.buffer);
                    return;
                }
                if (p.operationSubType === "finish") {
                    var result = msrcryptoSha256.getInstance224(p.workerid).finish();
                }
                if (p.operationSubType === "abort") {
                    msrcryptoSha224.deleteInstance(p.workerid);
                    return;
                }
                return msrcryptoSha256.instance224.computeHash(p.buffer);
            };
            operations.register("digest", "SHA-224", msrcryptoSha256.hash224);
            operations.register("digest", "SHA-256", msrcryptoSha256.hash256);
        }
        msrcryptoHashFunctions["SHA-224"] = msrcryptoSha256.sha224;
        msrcryptoHashFunctions["SHA-256"] = msrcryptoSha256.sha256;
        var msrcryptoSha512 = (function () {
            var utils = msrcryptoUtilities;
            function add(x0, x1, y0, y1, resultArray) {
                var lowSum = (x1 + y1) | 0;
                var carry = (lowSum >>> 0 < y1 >>> 0);
                resultArray[0] = (x0 + y0 + carry) | 0;
                resultArray[1] = lowSum;
                return;
            }
            function hashBlock(message, blockIndex, hv, k, w) {
                var t, i, blockBytes = 128, tah, tal, tbh, tbl, xh, xl, tc = [], td = [], te = [], index;
                var ah = hv[0], al = hv[1], bh = hv[2], bl = hv[3], ch = hv[4], cl = hv[5], dh = hv[6], dl = hv[7], eh = hv[8], el = hv[9], fh = hv[10], fl = hv[11], gh = hv[12], gl = hv[13], hh = hv[14], hl = hv[15];
                for (t = 0; t < 32; t++) {
                    index = blockIndex * blockBytes + t * 4;
                    w[t] = message.slice(index, index + 4);
                    w[t] = (w[t][0] << 24) | (w[t][1] << 16) | (w[t][2] << 8) | w[t][3];
                }
                for (t = 32; t < 160; t += 2) {
                    xh = w[t - 30];
                    xl = w[t - 29];
                    tah = (xh >>> 1 | xl << 31) ^ (xh >>> 8 | xl << 24) ^ (xh >>> 7);
                    tal = (xl >>> 1 | xh << 31) ^ (xl >>> 8 | xh << 24) ^ (xl >>> 7 | xh << 25);
                    xh = w[t - 4];
                    xl = w[t - 3];
                    tbh = (xh >>> 19 | xl << 13) ^ (xl >>> 29 | xh << 3) ^ (xh >>> 6);
                    tbl = (xl >>> 19 | xh << 13) ^ (xh >>> 29 | xl << 3) ^ (xl >>> 6 | xh << 26);
                    add(tbh, tbl, w[t - 14], w[t - 13], tc);
                    add(tah, tal, tc[0], tc[1], tc);
                    add(w[t - 32], w[t - 31], tc[0], tc[1], tc);
                    w[t] = tc[0];
                    w[t + 1] = tc[1];
                }
                for (i = 0; i < 160; i += 2) {
                    tah = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (el >>> 9 | eh << 23);
                    tal = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (eh >>> 9 | el << 23);
                    tbh = (eh & fh) ^ (gh & ~eh);
                    tbl = (el & fl) ^ (gl & ~el);
                    add(hh, hl, tah, tal, tc);
                    add(tbh, tbl, k[i], k[i + 1], td);
                    add(tc[0], tc[1], w[i], w[i + 1], te);
                    add(td[0], td[1], te[0], te[1], te);
                    add(te[0], te[1], dh, dl, tc);
                    dh = tc[0];
                    dl = tc[1];
                    tal = (al >>> 28 | ah << 4) ^ (ah >>> 2 | al << 30) ^ (ah >>> 7 | al << 25);
                    tah = (ah >>> 28 | al << 4) ^ (al >>> 2 | ah << 30) ^ (al >>> 7 | ah << 25);
                    tbl = (al & (bl ^ cl)) ^ (bl & cl);
                    tbh = (ah & (bh ^ ch)) ^ (bh & ch);
                    add(te[0], te[1], tah, tal, tc);
                    tah = tc[0];
                    tal = tc[1];
                    add(tbh, tbl, tah, tal, tc);
                    tah = tc[0];
                    tal = tc[1];
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    eh = dh;
                    el = dl;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    ah = tah;
                    al = tal;
                }
                add(hv[0], hv[1], ah, al, tc);
                hv[0] = tc[0];
                hv[1] = tc[1];
                add(hv[2], hv[3], bh, bl, tc);
                hv[2] = tc[0];
                hv[3] = tc[1];
                add(hv[4], hv[5], ch, cl, tc);
                hv[4] = tc[0];
                hv[5] = tc[1];
                add(hv[6], hv[7], dh, dl, tc);
                hv[6] = tc[0];
                hv[7] = tc[1];
                add(hv[8], hv[9], eh, el, tc);
                hv[8] = tc[0];
                hv[9] = tc[1];
                add(hv[10], hv[11], fh, fl, tc);
                hv[10] = tc[0];
                hv[11] = tc[1];
                add(hv[12], hv[13], gh, gl, tc);
                hv[12] = tc[0];
                hv[13] = tc[1];
                add(hv[14], hv[15], hh, hl, tc);
                hv[14] = tc[0];
                hv[15] = tc[1];
                return hv;
            }
            var h384, h512, k512, der384, der512, der512_224, der512_256, upd = utils.unpackData;
            h384 = upd("y7udXcEFnthimikqNnzVB5FZAVowcN0XFS/s2PcOWTlnMyZn/8ALMY60SodoWBUR2wwuDWT5j6dHtUgdvvpPpA==", 4, 1);
            h512 = upd("agnmZ/O8yQi7Z66FhMqnOzxu83L+lPgrpU/1Ol8dNvFRDlJ/reaC0ZsFaIwrPmwfH4PZq/tBvWtb4M0ZE34heQ", 4, 1);
            k512 = upd("QoovmNcoriJxN0SRI+9lzbXA+8/sTTsv6bXbpYGJ27w5VsJb80i1OFnxEfG2BdAZkj+CpK8ZT5urHF7" +
                "V2m2BGNgHqpijAwJCEoNbAUVwb74kMYW+TuSyjFUMfcPV/7Ticr5ddPJ7iW+A3rH+OxaWsZvcBqclxx" +
                "I1wZvxdM9pJpTkm2nBnvFK0u++R4Y4TyXjD8GdxouM1bUkDKHMd6ycZS3pLG9ZKwJ1SnSEqm6m5INcs" +
                "KncvUH71Hb5iNqDEVO1mD5RUu5m36uoMcZtLbQyELADJ8iY+yE/v1l/x77vDuTG4AvzPaiPwtWnkUeT" +
                "CqclBspjUeADgm8UKSlnCg5ucCe3CoVG0i/8LhshOFwmySZNLG38WsQq7VM4DROdlbPfZQpzVIuvY95" +
                "2agq7PHeyqIHCyS5H7a7mknIshRSCNTuiv+ihTPEDZKgaZku8QjABwkuLcND4l5HHbFGjBlS+MNGS6B" +
                "nW71IY1pkGJFVlqRD0DjWFV3EgKhBqoHAyu9G4GaTBFrjS0MgeN2wIUUGrUydId0zfjuuZNLC8teGbS" +
                "Kg5HAyzxclaY07YqkrjQYrLW5zKT3dj43NoLm/z1rK4o3SPgu5d77L8eKVjb0MXL2CEyHgUofCrcozH" +
                "AggaZDnskL7/+iNjHiikUGzr3oK96b75o/eyxnkVxnF48uNyUyvKJz7O6iZhnNGGuMchwMIH6tp91s3" +
                "g6x71fU9/7m7ReAbwZ6pyF2+6CmN9xaLImKYRP5gEvvkNrhtxCzUTHEcbKNt39SMEfYQyyqt7QMckkz" +
                "yevgoVyb68Qx1nxJwQDUxMxdS+yz5Ctll/KZz8ZX4qX8tvqzrW+uxsRBmMSkdYFw==", 4, 1);
            der384 = upd("MEEwDQYJYIZIAWUDBAICBQAEMA");
            der512 = upd("MFEwDQYJYIZIAWUDBAIDBQAEQA");
            der512_224 = upd("MC0wDQYJYIZIAWUDBAIFBQAEHA");
            der512_256 = upd("MDEwDQYJYIZIAWUDBAIGBQAEIA");
            return {
                sha384: function () {
                    return msrcryptoSha("SHA-384", der384, h384, k512, 128, hashBlock, 384);
                },
                sha512: function () {
                    return msrcryptoSha("SHA-512", der512, h512, k512, 128, hashBlock, 512);
                },
                sha512_224: function () {
                    return msrcryptoSha("SHA-512.224", der512_224, h512, k512, 128, hashBlock, 224);
                },
                sha512_256: function () {
                    return msrcryptoSha("SHA-512.256", der512_256, h512, k512, 128, hashBlock, 256);
                }
            };
        })();
        if (typeof operations !== "undefined") {
            msrcryptoSha512.instances = {};
            msrcryptoSha512.getInstance384 = function (id) {
                return msrcryptoSha512.instances[id] || (msrcryptoSha512.instances[id] = msrcryptoSha512.sha384());
            };
            msrcryptoSha512.getInstance512 = function (id) {
                return msrcryptoSha512.instances[id] || (msrcryptoSha512.instances[id] = msrcryptoSha512.sha512());
            };
            msrcryptoSha512.deleteInstance = function (id) {
                msrcryptoSha512.instances[id] = null;
                delete msrcryptoSha512.instances[id];
            };
            msrcryptoSha512.hash384 = function (p) {
                if (p.operationSubType === "process") {
                    msrcryptoSha512.sha384.process(p.buffer);
                    return;
                }
                if (p.operationSubType === "finish") {
                    return msrcryptoSha512.sha384.finish();
                }
                return msrcryptoSha512.sha384().computeHash(p.buffer);
            };
            msrcryptoSha512.hash512 = function (p) {
                if (p.operationSubType === "process") {
                    msrcryptoSha512.sha512.process(p.buffer);
                    return;
                }
                if (p.operationSubType === "finish") {
                    return msrcryptoSha512.sha512.finish();
                }
                return msrcryptoSha512.sha512().computeHash(p.buffer);
            };
            operations.register("digest", "SHA-384", msrcryptoSha512.hash384);
            operations.register("digest", "SHA-512", msrcryptoSha512.hash512);
        }
        msrcryptoHashFunctions["SHA-384"] = msrcryptoSha512.sha384;
        msrcryptoHashFunctions["SHA-512"] = msrcryptoSha512.sha512;
        var msrcryptoHmac = function (keyBytes, hashFunction) {
            var blockSize = {
                "384": 128,
                "512": 128
            }[hashFunction.name.replace(/SHA-/, "")] || 64;
            var ipad;
            var opad;
            var paddedKey = padKey();
            var keyXorOpad;
            var keyXorIpad;
            var k0IpadText;
            function xorArrays(array1, array2) {
                var newArray = new Array(array1);
                for (var j = 0; j < array1.length; j++) {
                    newArray[j] = array1[j] ^ array2[j];
                }
                return newArray;
            }
            function padZeros(bytes, paddedLength) {
                var paddedArray = bytes.slice();
                for (var j = bytes.length; j < paddedLength; j++) {
                    paddedArray.push(0);
                }
                return paddedArray;
            }
            function padKey() {
                if (keyBytes.length === blockSize) {
                    return keyBytes;
                }
                if (keyBytes.length > blockSize) {
                    return padZeros(hashFunction.computeHash(keyBytes), blockSize);
                }
                return padZeros(keyBytes, blockSize);
            }
            function processHmac(messageBytes) {
                if (!k0IpadText) {
                    k0IpadText = keyXorIpad.concat(messageBytes);
                    hashFunction.process(k0IpadText);
                }
                else {
                    hashFunction.process(messageBytes);
                }
                return;
            }
            function finishHmac() {
                var hashK0IpadText = hashFunction.finish();
                var k0IpadK0OpadText = keyXorOpad.concat(hashK0IpadText);
                return hashFunction.computeHash(k0IpadK0OpadText);
            }
            function clearState() {
                keyBytes = null;
                hashFunction = null;
                paddedKey = null;
            }
            ipad = new Array(blockSize);
            opad = new Array(blockSize);
            for (var i = 0; i < blockSize; i++) {
                ipad[i] = 0x36;
                opad[i] = 0x5c;
            }
            keyXorIpad = xorArrays(paddedKey, ipad);
            keyXorOpad = xorArrays(paddedKey, opad);
            return {
                computeHmac: function (dataBytes, key, hashAlgorithm) {
                    processHmac(dataBytes);
                    var result = finishHmac();
                    clearState();
                    return result;
                },
                process: function (dataBytes, key, hashAlgorithm) {
                    processHmac(dataBytes);
                    return null;
                },
                finish: function (key, hashAlgorithm) {
                    var result = finishHmac();
                    clearState();
                    return result;
                }
            };
        };
        if (typeof operations !== "undefined") {
            var hmacInstances = {};
            msrcryptoHmac.signHmac = function (p) {
                var hashName = p.keyHandle.algorithm.hash.name.toUpperCase(), hashAlg = msrcryptoHashFunctions[hashName](), result, id = p.workerid;
                if (!hmacInstances[id]) {
                    hmacInstances[id] = msrcryptoHmac(p.keyData, hashAlg);
                }
                if (p.operationSubType === "process") {
                    hmacInstances[id].process(p.buffer);
                    return null;
                }
                if (p.operationSubType === "finish") {
                    result = hmacInstances[id].finish();
                    hmacInstances[id] = null;
                    return result;
                }
                result = hmacInstances[id].computeHmac(p.buffer);
                hmacInstances[id] = null;
                return result;
            };
            msrcryptoHmac.verifyHmac = function (p) {
                var hashName = p.keyHandle.algorithm.hash.name.toUpperCase(), hashAlg = msrcryptoHashFunctions[hashName](), result, id = p.workerid;
                if (!hmacInstances[id]) {
                    hmacInstances[id] = msrcryptoHmac(p.keyData, hashAlg);
                }
                if (p.operationSubType === "process") {
                    hmacInstances[id].process(p.buffer);
                    return null;
                }
                if (p.operationSubType === "finish") {
                    result = hmacInstances[id].finish();
                    result = msrcryptoUtilities.arraysEqual(result, p.signature);
                    hmacInstances[id] = null;
                    return result;
                }
                result = hmacInstances[id].computeHmac(p.buffer);
                result = msrcryptoUtilities.arraysEqual(result, p.signature);
                hmacInstances[id] = null;
                return result;
            };
            msrcryptoHmac.generateKey = function (p) {
                var defaultKeyLengths = {
                    "SHA-1": 64,
                    "SHA-224": 64,
                    "SHA-256": 64,
                    "SHA-384": 128,
                    "SHA-512": 128
                };
                var keyLength = p.algorithm.length;
                if (!keyLength) {
                    keyLength = defaultKeyLengths[p.algorithm.hash.name.toUpperCase()];
                }
                return {
                    type: "keyGeneration",
                    keyData: msrcryptoPseudoRandom.getBytes(keyLength),
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable,
                        usages: null || p.usages,
                        type: "secret"
                    }
                };
            };
            msrcryptoHmac.importKey = function (p) {
                var keyObject, keyBits = p.keyData.length * 8;
                if (p.format === "jwk") {
                    keyObject = msrcryptoJwk.jwkToKey(p.keyData, p.algorithm, ["k"]);
                    keyObject.alg = keyObject.alg.replace("HS", "SHA-");
                }
                else if (p.format === "raw") {
                    keyObject = {
                        k: msrcryptoUtilities.toArray(p.keyData)
                    };
                }
                else {
                    throw new Error("unsupported import format");
                }
                return {
                    type: "keyImport",
                    keyData: keyObject.k,
                    keyHandle: {
                        algorithm: {
                            name: "HMAC",
                            hash: {
                                name: p.algorithm.hash.name
                            }
                        },
                        extractable: p.extractable || keyObject.extractable,
                        usages: p.usages,
                        type: "secret"
                    }
                };
            };
            msrcryptoHmac.exportKey = function (p) {
                if (p.format === "jwk") {
                    return {
                        type: "keyExport",
                        keyHandle: msrcryptoJwk.keyToJwk(p.keyHandle, p.keyData)
                    };
                }
                if (p.format === "raw") {
                    return {
                        type: "keyExport",
                        keyHandle: p.keyData
                    };
                }
                throw new Error("unsupported export format");
            };
            operations.register("importKey", "HMAC", msrcryptoHmac.importKey);
            operations.register("exportKey", "HMAC", msrcryptoHmac.exportKey);
            operations.register("generateKey", "HMAC", msrcryptoHmac.generateKey);
            operations.register("sign", "HMAC", msrcryptoHmac.signHmac);
            operations.register("verify", "HMAC", msrcryptoHmac.verifyHmac);
        }
        var msrcryptoBlockCipher = (function () {
            var aesConstants, x2, x3, x14, x13, x11, x9, sBoxTable, invSBoxTable, rConTable;
            return {
                aes: function (keyBytes) {
                    if (!aesConstants) {
                        aesConstants = msrcryptoUtilities.unpackData("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", 256, false);
                        x2 = aesConstants[0];
                        x3 = aesConstants[1];
                        x14 = aesConstants[2];
                        x13 = aesConstants[3];
                        x11 = aesConstants[4];
                        x9 = aesConstants[5];
                        sBoxTable = aesConstants[6];
                        invSBoxTable = aesConstants[7];
                        rConTable = aesConstants[8];
                    }
                    var blockSize = 128, keyLength, nK, nB = 4, nR, key;
                    keyLength = keyBytes.length * 8;
                    switch (keyLength) {
                        case 128:
                        case 192:
                        case 256:
                            break;
                        default:
                            throw new Error("Unsupported keyLength");
                    }
                    nK = keyLength / 32;
                    nR = nK + 6;
                    var shiftRows = function (a) {
                        var tmp = a[1];
                        a[1] = a[5];
                        a[5] = a[9];
                        a[9] = a[13];
                        a[13] = tmp;
                        tmp = a[2];
                        a[2] = a[10];
                        a[10] = tmp;
                        tmp = a[6];
                        a[6] = a[14];
                        a[14] = tmp;
                        tmp = a[15];
                        a[15] = a[11];
                        a[11] = a[7];
                        a[7] = a[3];
                        a[3] = tmp;
                    };
                    var invShiftRows = function (a) {
                        var tmp = a[13];
                        a[13] = a[9];
                        a[9] = a[5];
                        a[5] = a[1];
                        a[1] = tmp;
                        tmp = a[10];
                        a[10] = a[2];
                        a[2] = tmp;
                        tmp = a[14];
                        a[14] = a[6];
                        a[6] = tmp;
                        tmp = a[3];
                        a[3] = a[7];
                        a[7] = a[11];
                        a[11] = a[15];
                        a[15] = tmp;
                    };
                    var mixColumns = function (state) {
                        var a = state[0], b = state[1], c = state[2], d = state[3], e = state[4], f = state[5], g = state[6], h = state[7], i = state[8], j = state[9], k = state[10], l = state[11], m = state[12], n = state[13], o = state[14], p = state[15];
                        state[0] = x2[a] ^ x3[b] ^ c ^ d;
                        state[1] = a ^ x2[b] ^ x3[c] ^ d;
                        state[2] = a ^ b ^ x2[c] ^ x3[d];
                        state[3] = x3[a] ^ b ^ c ^ x2[d];
                        state[4] = x2[e] ^ x3[f] ^ g ^ h;
                        state[5] = e ^ x2[f] ^ x3[g] ^ h;
                        state[6] = e ^ f ^ x2[g] ^ x3[h];
                        state[7] = x3[e] ^ f ^ g ^ x2[h];
                        state[8] = x2[i] ^ x3[j] ^ k ^ l;
                        state[9] = i ^ x2[j] ^ x3[k] ^ l;
                        state[10] = i ^ j ^ x2[k] ^ x3[l];
                        state[11] = x3[i] ^ j ^ k ^ x2[l];
                        state[12] = x2[m] ^ x3[n] ^ o ^ p;
                        state[13] = m ^ x2[n] ^ x3[o] ^ p;
                        state[14] = m ^ n ^ x2[o] ^ x3[p];
                        state[15] = x3[m] ^ n ^ o ^ x2[p];
                    };
                    var invMixColumns = function (state) {
                        var a = state[0], b = state[1], c = state[2], d = state[3], e = state[4], f = state[5], g = state[6], h = state[7], i = state[8], j = state[9], k = state[10], l = state[11], m = state[12], n = state[13], o = state[14], p = state[15];
                        state[0] = x14[a] ^ x11[b] ^ x13[c] ^ x9[d];
                        state[1] = x9[a] ^ x14[b] ^ x11[c] ^ x13[d];
                        state[2] = x13[a] ^ x9[b] ^ x14[c] ^ x11[d];
                        state[3] = x11[a] ^ x13[b] ^ x9[c] ^ x14[d];
                        state[4] = x14[e] ^ x11[f] ^ x13[g] ^ x9[h];
                        state[5] = x9[e] ^ x14[f] ^ x11[g] ^ x13[h];
                        state[6] = x13[e] ^ x9[f] ^ x14[g] ^ x11[h];
                        state[7] = x11[e] ^ x13[f] ^ x9[g] ^ x14[h];
                        state[8] = x14[i] ^ x11[j] ^ x13[k] ^ x9[l];
                        state[9] = x9[i] ^ x14[j] ^ x11[k] ^ x13[l];
                        state[10] = x13[i] ^ x9[j] ^ x14[k] ^ x11[l];
                        state[11] = x11[i] ^ x13[j] ^ x9[k] ^ x14[l];
                        state[12] = x14[m] ^ x11[n] ^ x13[o] ^ x9[p];
                        state[13] = x9[m] ^ x14[n] ^ x11[o] ^ x13[p];
                        state[14] = x13[m] ^ x9[n] ^ x14[o] ^ x11[p];
                        state[15] = x11[m] ^ x13[n] ^ x9[o] ^ x14[p];
                    };
                    var xorWord = function (a, b) {
                        return [a[0] ^ b[0], a[1] ^ b[1], a[2] ^ b[2], a[3] ^ b[3]];
                    };
                    var addRoundKey = function (state, keySchedule, offset) {
                        for (var i = 0; i < state.length; i += 1) {
                            state[i] ^= keySchedule[i + offset];
                        }
                    };
                    var rotWord = function (word) {
                        var a = word[0];
                        word[0] = word[1];
                        word[1] = word[2];
                        word[2] = word[3];
                        word[3] = a;
                    };
                    var subWord = function (word) {
                        for (var i = 0; i < word.length; i += 1) {
                            word[i] = sBoxTable[word[i]];
                        }
                    };
                    var invSubWord = function (word) {
                        for (var i = 0; i < word.length; i += 1) {
                            word[i] = invSBoxTable[word[i]];
                        }
                    };
                    var getWord = function (tab, i) {
                        return [tab[4 * i], tab[4 * i + 1], tab[4 * i + 2], tab[4 * i + 3]];
                    };
                    var setWord = function (left, right, indexL, indexR) {
                        left[4 * indexL] = right[4 * indexR];
                        left[4 * indexL + 1] = right[4 * indexR + 1];
                        left[4 * indexL + 2] = right[4 * indexR + 2];
                        left[4 * indexL + 3] = right[4 * indexR + 3];
                    };
                    var expandKey = function (keyIn) {
                        var temp, res = [], i = 0;
                        while (i < 4 * nK) {
                            res.push(keyIn[i++]);
                        }
                        i = nK;
                        while (i < nB * (nR + 1)) {
                            temp = getWord(res, i - 1);
                            if (i % nK === 0) {
                                var index = i / nK;
                                var rcon = [rConTable[index], 0, 0, 0];
                                rotWord(temp);
                                subWord(temp);
                                temp = xorWord(temp, rcon);
                            }
                            else if (nK > 6 && i % nK === 4) {
                                subWord(temp);
                            }
                            var newWord = xorWord(getWord(res, i - nK), temp);
                            setWord(res, newWord, i, 0);
                            i += 1;
                        }
                        return res;
                    };
                    key = expandKey(keyBytes);
                    return {
                        encrypt: function (dataBytes) {
                            var state = dataBytes, round;
                            addRoundKey(state, key, 0);
                            for (round = 1; round <= nR - 1; round += 1) {
                                subWord(state);
                                shiftRows(state);
                                mixColumns(state);
                                addRoundKey(state, key, 4 * round * nB);
                            }
                            subWord(state);
                            shiftRows(state);
                            addRoundKey(state, key, 4 * nR * nB);
                            return state;
                        },
                        decrypt: function (dataBytes) {
                            var state = dataBytes, round;
                            addRoundKey(state, key, 4 * nR * nB);
                            for (round = nR - 1; round >= 1; round -= 1) {
                                invShiftRows(state);
                                invSubWord(state);
                                addRoundKey(state, key, 4 * round * nB);
                                invMixColumns(state);
                            }
                            invShiftRows(state);
                            invSubWord(state);
                            addRoundKey(state, key, 0);
                            return state;
                        },
                        clear: function () { },
                        keyLength: keyLength,
                        blockSize: blockSize
                    };
                }
            };
        })();
        var msrcryptoPadding = msrcryptoPadding || {};
        msrcryptoPadding.pkcsv7 = function (blockSize) {
            function pad(messageBlocks) {
                var lastIndex = messageBlocks.length - 1 >= 0 ? messageBlocks.length - 1 : 0;
                var lastBlock = messageBlocks[lastIndex];
                var lastBlockLength = lastBlock.length;
                var createNewBlock = lastBlockLength === blockSize;
                if (createNewBlock) {
                    var newBlock = [];
                    var i;
                    for (i = 0; i < blockSize; i += 1) {
                        newBlock.push(blockSize);
                    }
                    messageBlocks.push(newBlock);
                }
                else {
                    var byteToAdd = blockSize - lastBlockLength & 0xff;
                    while (lastBlock.length !== blockSize) {
                        lastBlock.push(byteToAdd);
                    }
                }
            }
            function unpad(messageBytes) {
                var verified = true;
                if (messageBytes.length % blockSize !== 0) {
                    verified = false;
                }
                var lastBlock = messageBytes.slice(-blockSize);
                var padLen = lastBlock[lastBlock.length - 1];
                for (var i = 0; i < blockSize; i++) {
                    var isPaddingElement = blockSize - i <= padLen;
                    var isCorrectValue = lastBlock[i] === padLen;
                    verified = (isPaddingElement ? isCorrectValue : true) && verified;
                }
                var trimLen = verified ? padLen : 0;
                messageBytes.length -= trimLen;
                return verified;
            }
            return {
                pad: pad,
                unpad: unpad
            };
        };
        var msrcryptoCbc = function (blockCipher) {
            var blockSize = blockCipher.blockSize / 8;
            var paddingScheme = msrcryptoPadding.pkcsv7(blockSize);
            var mergeBlocks = function (tab) {
                var res = [], i, j;
                for (i = 0; i < tab.length; i += 1) {
                    var block = tab[i];
                    for (j = 0; j < block.length; j += 1) {
                        res.push(block[j]);
                    }
                }
                return res;
            };
            function getBlocks(dataBytes) {
                var blocks = [];
                mBuffer = mBuffer.concat(dataBytes);
                var blockCount = Math.floor(mBuffer.length / blockSize);
                for (var i = 0; i < blockCount; i++) {
                    blocks.push(mBuffer.slice(i * blockSize, (i + 1) * blockSize));
                }
                mBuffer = mBuffer.slice(blockCount * blockSize);
                return blocks;
            }
            function encryptBlocks(blocks) {
                var result = [], toEncrypt;
                for (var i = 0; i < blocks.length; i++) {
                    toEncrypt = msrcryptoUtilities.xorVectors(mIvBytes, blocks[i]);
                    result.push(blockCipher.encrypt(toEncrypt));
                    mIvBytes = result[i];
                }
                return result;
            }
            function decryptBlocks(blocks) {
                var result = [], toDecrypt, decrypted;
                for (var i = 0; i < blocks.length; i += 1) {
                    toDecrypt = blocks[i].slice(0, blocks[i].length);
                    decrypted = blockCipher.decrypt(toDecrypt);
                    result.push(msrcryptoUtilities.xorVectors(mIvBytes, decrypted));
                    mIvBytes = blocks[i];
                }
                return result;
            }
            function clearState() {
                mBuffer = [];
                mResultBuffer = [];
                mIvBytes = null;
            }
            var mBuffer = [], mResultBuffer = [], mIvBytes;
            return {
                init: function (ivBytes) {
                    if (ivBytes.length !== blockSize) {
                        throw new Error("Invalid iv size");
                    }
                    mIvBytes = ivBytes.slice();
                },
                encrypt: function (plainBytes) {
                    var result = encryptBlocks(getBlocks(plainBytes));
                    mResultBuffer = mResultBuffer.concat(mergeBlocks(result));
                    return this.finishEncrypt();
                },
                processEncrypt: function (plainBytes) {
                    var result = mergeBlocks(encryptBlocks(getBlocks(plainBytes)));
                    return result;
                },
                finishEncrypt: function () {
                    var blocks = mBuffer.length === 1 ? [
                        [mBuffer[0]]
                    ] : [mBuffer];
                    paddingScheme.pad(blocks);
                    var result = mResultBuffer.concat(mergeBlocks(encryptBlocks(blocks)));
                    clearState();
                    return result;
                },
                decrypt: function (cipherBytes) {
                    this.processDecrypt(cipherBytes);
                    return this.finishDecrypt();
                },
                processDecrypt: function (cipherBytes) {
                    var result = decryptBlocks(getBlocks(cipherBytes));
                    mResultBuffer = mResultBuffer.concat(mergeBlocks(result));
                    return;
                },
                finishDecrypt: function () {
                    var result = mResultBuffer;
                    var verified = paddingScheme.unpad(result);
                    clearState();
                    return result;
                }
            };
        };
        if (typeof operations !== "undefined") {
            var cbcInstances = {};
            msrcryptoCbc.workerEncrypt = function (p) {
                var result, id = p.workerid;
                if (!cbcInstances[id]) {
                    cbcInstances[id] = msrcryptoCbc(msrcryptoBlockCipher.aes(p.keyData));
                    cbcInstances[id].init(p.algorithm.iv);
                }
                if (p.operationSubType === "process") {
                    return cbcInstances[id].processEncrypt(p.buffer);
                }
                if (p.operationSubType === "finish") {
                    result = cbcInstances[id].finishEncrypt();
                    cbcInstances[id] = null;
                    return result;
                }
                result = cbcInstances[id].encrypt(p.buffer);
                cbcInstances[id] = null;
                return result;
            };
            msrcryptoCbc.workerDecrypt = function (p) {
                var result, id = p.workerid;
                if (!cbcInstances[id]) {
                    cbcInstances[id] = msrcryptoCbc(msrcryptoBlockCipher.aes(p.keyData));
                    cbcInstances[id].init(p.algorithm.iv);
                }
                if (p.operationSubType === "process") {
                    cbcInstances[id].processDecrypt(p.buffer);
                    return;
                }
                if (p.operationSubType === "finish") {
                    result = cbcInstances[id].finishDecrypt();
                    cbcInstances[id] = null;
                    return result;
                }
                result = cbcInstances[id].decrypt(p.buffer);
                cbcInstances[id] = null;
                return result;
            };
            msrcryptoCbc.generateKey = function (p) {
                if (p.algorithm.length % 8 !== 0) {
                    throw new Error();
                }
                return {
                    type: "keyGeneration",
                    keyData: msrcryptoPseudoRandom.getBytes(Math.floor(p.algorithm.length / 8)),
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable,
                        usages: null || p.usages,
                        type: "secret"
                    }
                };
            };
            msrcryptoCbc.importKey = function (p) {
                var keyObject;
                var keyBits = p.keyData.length * 8;
                if (p.format === "jwk") {
                    keyObject = msrcryptoJwk.jwkToKey(p.keyData, p.algorithm, ["k"]);
                }
                else if (p.format === "raw") {
                    if (keyBits !== 128 && keyBits !== 192 && keyBits !== 256) {
                        throw new Error("invalid key length (should be 128, 192, or 256 bits)");
                    }
                    keyObject = {
                        k: msrcryptoUtilities.toArray(p.keyData)
                    };
                }
                else {
                    throw new Error("unsupported import format");
                }
                p.algorithm.length = keyObject.k.length * 8;
                return {
                    keyData: keyObject.k,
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable || keyObject.extractable,
                        usages: null || p.usages,
                        type: "secret"
                    },
                    type: "keyImport"
                };
            };
            msrcryptoCbc.exportKey = function (p) {
                if (p.format === "jwk") {
                    return {
                        type: "keyExport",
                        keyHandle: msrcryptoJwk.keyToJwk(p.keyHandle, p.keyData)
                    };
                }
                if (p.format === "raw") {
                    return {
                        type: "keyExport",
                        keyHandle: p.keyData
                    };
                }
                throw new Error("unsupported export format");
            };
            operations.register("importKey", "AES-CBC", msrcryptoCbc.importKey);
            operations.register("exportKey", "AES-CBC", msrcryptoCbc.exportKey);
            operations.register("generateKey", "AES-CBC", msrcryptoCbc.generateKey);
            operations.register("encrypt", "AES-CBC", msrcryptoCbc.workerEncrypt);
            operations.register("decrypt", "AES-CBC", msrcryptoCbc.workerDecrypt);
        }
        var msrcryptoGcm = function (blockCipher) {
            var utils = msrcryptoUtilities;
            var mBuffer = [], mIvBytes, mAdditionalBytes, mTagLength, mJ0, mJ0inc, mH = blockCipher.encrypt(utils.getVector(16)), mGHashState = utils.getVector(16), mGHashBuffer = [], mCipherText = [], mGctrCb, mBytesProcessed = 0;
            function ghash(hashSubkey, dataBytes) {
                var blockCount = Math.floor(dataBytes.length / 16), dataBlock;
                for (var i = 0; i < blockCount; i++) {
                    dataBlock = dataBytes.slice(i * 16, i * 16 + 16);
                    mGHashState = blockMultiplication(utils.xorVectors(mGHashState, dataBlock), hashSubkey);
                }
                mGHashBuffer = dataBytes.slice(blockCount * 16);
                return mGHashState;
            }
            function finishGHash() {
                var u = 16 * Math.ceil(mBytesProcessed / 16) - mBytesProcessed;
                var lenA = numberTo8Bytes(mAdditionalBytes.length * 8), lenC = numberTo8Bytes(mBytesProcessed * 8);
                var p = mGHashBuffer.concat(utils.getVector(u)).concat(lenA).concat(lenC);
                return ghash(mH, p);
            }
            function blockMultiplication(blockX, blockY) {
                var z = utils.getVector(16), v = blockY.slice(0), mask, j, i;
                for (i = 0; i < 128; i++) {
                    mask = -getBit(blockX, i) & 0xff;
                    for (j = 0; j < 16; j++) {
                        z[j] = z[j] ^ v[j] & mask;
                    }
                    mask = -(v[15] & 1) & 0xff;
                    shiftRight(v);
                    v[0] ^= 0xe1 & mask;
                }
                return z;
            }
            function shiftRight(dataBytes) {
                for (var i = dataBytes.length - 1; i > 0; i--) {
                    dataBytes[i] = (dataBytes[i - 1] & 1) << 7 | dataBytes[i] >>> 1;
                }
                dataBytes[0] = dataBytes[0] >>> 1;
                return dataBytes;
            }
            function getBit(byteArray, bitNumber) {
                var byteIndex = Math.floor(bitNumber / 8);
                return byteArray[byteIndex] >> 7 - bitNumber % 8 & 1;
            }
            function inc(dataBytes) {
                var carry = 256;
                for (var i = 1; i <= 4; i++) {
                    carry = (carry >>> 8) + dataBytes[dataBytes.length - i];
                    dataBytes[dataBytes.length - i] = carry & 255;
                }
                return dataBytes;
            }
            function gctr(icb, dataBytes) {
                var blockCount = Math.ceil(dataBytes.length / 16), dataBlock, result = [];
                if (mGctrCb !== icb) {
                    mGctrCb = icb.slice();
                }
                for (var block = 0; block < blockCount; block++) {
                    dataBlock = dataBytes.slice(block * 16, block * 16 + 16);
                    var e = blockCipher.encrypt(mGctrCb.slice());
                    result = result.concat(utils.xorVectors(dataBlock, e));
                    mGctrCb = inc(mGctrCb);
                }
                return result;
            }
            function numberTo8Bytes(integer) {
                return [
                    0, 0, 0, 0,
                    integer >>> 24 & 255,
                    integer >>> 16 & 255,
                    integer >>> 8 & 255,
                    integer & 255
                ];
            }
            function padBlocks(dataBytes) {
                var padLen = 16 * Math.ceil(mAdditionalBytes.length / 16) - mAdditionalBytes.length;
                return dataBytes.concat(utils.getVector(padLen));
            }
            function clearState() {
                mBytesProcessed = 0;
                mBuffer = [];
                mCipherText = [];
                mGHashState = utils.getVector(16);
                mGHashBuffer = [];
                mGctrCb = mIvBytes = mAdditionalBytes = null;
            }
            function init(ivBytes, additionalBytes, tagLength) {
                mAdditionalBytes = additionalBytes || [];
                mTagLength = isNaN(tagLength) ? 128 : tagLength;
                if (mTagLength % 8 !== 0) {
                    throw new Error("DataError");
                }
                mIvBytes = ivBytes;
                if (mIvBytes.length === 12) {
                    mJ0 = mIvBytes.concat([0, 0, 0, 1]);
                }
                else {
                    var l = 16 * Math.ceil(mIvBytes.length / 16) - mIvBytes.length;
                    mJ0 = ghash(mH, mIvBytes
                        .concat(utils.getVector(l + 8))
                        .concat(numberTo8Bytes(mIvBytes.length * 8)));
                    mGHashState = utils.getVector(16);
                }
                mJ0inc = inc(mJ0.slice());
                ghash(mH, padBlocks(mAdditionalBytes));
            }
            function encrypt(plainBytes) {
                mBytesProcessed = plainBytes.length;
                var c = gctr(mJ0inc, plainBytes);
                ghash(mH, c);
                var s = finishGHash();
                var t = gctr(mJ0, s).slice(0, mTagLength / 8);
                clearState();
                return c.slice().concat(t);
            }
            function decrypt(cipherBytes, tagBytes) {
                mBytesProcessed = cipherBytes.length;
                var p = gctr(mJ0inc, cipherBytes);
                ghash(mH, cipherBytes);
                var s = finishGHash();
                var t = gctr(mJ0, s).slice(0, mTagLength / 8);
                clearState();
                if (utils.arraysEqual(t, tagBytes)) {
                    return p;
                }
                else {
                    return null;
                }
            }
            function processEncrypt(plainBytes) {
                mBuffer = mBuffer.concat(plainBytes);
                var fullBlocks = mBuffer.slice(0, Math.floor(mBuffer.length / 16) * 16);
                mBytesProcessed += fullBlocks.length;
                mBuffer = mBuffer.slice(fullBlocks.length);
                var c = gctr(mGctrCb || mJ0inc, fullBlocks);
                mCipherText = mCipherText.concat(c);
                ghash(mH, c);
            }
            function processDecrypt(cipherBytes) {
                mBuffer = mBuffer.concat(cipherBytes);
                var fullBlocks = mBuffer.slice(0, Math.floor((mBuffer.length - mTagLength / 8) / 16) * 16);
                mBytesProcessed += fullBlocks.length;
                mBuffer = mBuffer.slice(fullBlocks.length);
                var c = gctr(mGctrCb || mJ0inc, fullBlocks);
                mCipherText = mCipherText.concat(c);
                ghash(mH, fullBlocks);
            }
            function finishEncrypt() {
                var c = gctr(mGctrCb, mBuffer);
                mCipherText = mCipherText.concat(c);
                mBytesProcessed += mBuffer.length;
                var s = finishGHash();
                var t = gctr(mJ0, s).slice(0, mTagLength / 8);
                var result = mCipherText.slice().concat(t);
                clearState();
                return result;
            }
            function finishDecrypt() {
                var tagLength = Math.floor(mTagLength / 8);
                var tagBytes = mBuffer.slice(-tagLength);
                mBuffer = mBuffer.slice(0, mBuffer.length - tagLength);
                var c = gctr(mGctrCb, mBuffer);
                mCipherText = mCipherText.concat(c);
                mBytesProcessed += mBuffer.length;
                var s = finishGHash();
                var t = gctr(mJ0, s).slice(0, mTagLength / 8);
                var result = mCipherText.slice();
                clearState();
                if (utils.arraysEqual(t, tagBytes)) {
                    return result;
                }
                else {
                    return null;
                }
            }
            return {
                init: init,
                encrypt: encrypt,
                decrypt: decrypt,
                processEncrypt: processEncrypt,
                processDecrypt: processDecrypt,
                finishEncrypt: finishEncrypt,
                finishDecrypt: finishDecrypt
            };
        };
        if (typeof operations !== "undefined") {
            var gcmInstances = {};
            msrcryptoGcm.encrypt = function (p) {
                var result, id = p.workerid;
                if (!gcmInstances[id]) {
                    gcmInstances[id] = msrcryptoGcm(msrcryptoBlockCipher.aes(p.keyData));
                    gcmInstances[id].init(p.algorithm.iv, p.algorithm.additionalData, p.algorithm.tagLength);
                }
                if (p.operationSubType === "process") {
                    gcmInstances[id].processEncrypt(p.buffer);
                    return;
                }
                if (p.operationSubType === "finish") {
                    result = gcmInstances[id].finishEncrypt();
                    gcmInstances[id] = null;
                    return result;
                }
                result = gcmInstances[id].encrypt(p.buffer);
                gcmInstances[id] = null;
                return result;
            };
            msrcryptoGcm.decrypt = function (p) {
                var result, id = p.workerid;
                if (!gcmInstances[id]) {
                    gcmInstances[id] = msrcryptoGcm(msrcryptoBlockCipher.aes(p.keyData));
                    gcmInstances[id].init(p.algorithm.iv, p.algorithm.additionalData, p.algorithm.tagLength);
                }
                if (p.operationSubType === "process") {
                    gcmInstances[id].processDecrypt(p.buffer);
                    return;
                }
                if (p.operationSubType === "finish") {
                    result = gcmInstances[id].finishDecrypt();
                    gcmInstances[id] = null;
                    if (result === null) {
                        throw new Error("OperationError");
                    }
                    return result;
                }
                var tagLength = p.algorithm.tagLength ? Math.floor(p.algorithm.tagLength / 8) : 16;
                var cipherBytes = p.buffer.slice(0, p.buffer.length - tagLength);
                var tagBytes = p.buffer.slice(-tagLength);
                result = gcmInstances[id].decrypt(cipherBytes, tagBytes);
                gcmInstances[id] = null;
                if (result === null) {
                    throw new Error("OperationError");
                }
                return result;
            };
            msrcryptoGcm.generateKey = function (p) {
                if (p.algorithm.length % 8 !== 0) {
                    throw new Error();
                }
                return {
                    type: "keyGeneration",
                    keyData: msrcryptoPseudoRandom.getBytes(Math.floor(p.algorithm.length / 8)),
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable,
                        usages: null || p.usages,
                        type: "secret"
                    }
                };
            };
            msrcryptoGcm.importKey = function (p) {
                var keyObject, keyBits = p.keyData.length * 8;
                if (p.format === "jwk") {
                    keyObject = msrcryptoJwk.jwkToKey(p.keyData, p.algorithm, ["k"]);
                }
                else if (p.format === "raw") {
                    if (keyBits !== 128 && keyBits !== 192 && keyBits !== 256) {
                        throw new Error("invalid key length (should be 128, 192, or 256 bits)");
                    }
                    keyObject = {
                        k: msrcryptoUtilities.toArray(p.keyData)
                    };
                }
                else {
                    throw new Error("unsupported import format");
                }
                return {
                    type: "keyImport",
                    keyData: keyObject.k,
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable || keyObject.extractable,
                        usages: null || p.usages,
                        type: "secret"
                    }
                };
            };
            msrcryptoGcm.exportKey = function (p) {
                if (p.format === "jwk") {
                    return {
                        type: "keyExport",
                        keyHandle: msrcryptoJwk.keyToJwk(p.keyHandle, p.keyData)
                    };
                }
                if (p.format === "raw") {
                    return {
                        type: "keyExport",
                        keyHandle: p.keyData
                    };
                }
                throw new Error("unsupported export format");
            };
            operations.register("importKey", "AES-GCM", msrcryptoGcm.importKey);
            operations.register("exportKey", "AES-GCM", msrcryptoGcm.exportKey);
            operations.register("generateKey", "AES-GCM", msrcryptoGcm.generateKey);
            operations.register("encrypt", "AES-GCM", msrcryptoGcm.encrypt);
            operations.register("decrypt", "AES-GCM", msrcryptoGcm.decrypt);
        }
        var msrcryptoAESKW = function (blockCipher) {
            function encrypt(buffer) {
                var plain = [
                    [0]
                ];
                for (var i = 0; i < buffer.length; i += 8) {
                    plain.push(buffer.slice(i, i + 8));
                }
                var A = [166, 166, 166, 166, 166, 166, 166, 166];
                var n = plain.length - 1;
                var registers = [];
                for (var i = 1; i <= n; i++) {
                    registers[i] = plain[i];
                }
                for (var j = 0; j <= 5; j++) {
                    for (var i = 1; i <= n; i++) {
                        var t = n * j + i;
                        var enc = blockCipher.encrypt(A.concat(registers[i]));
                        registers[i] = enc.slice(8);
                        A = enc.slice(0, 8);
                        for (var ai = 7; t > 0; ai--, t >>>= 8) {
                            A[ai] ^= t & 255;
                        }
                    }
                }
                var C = A;
                for (var i = 1; i <= n; i++) {
                    C = C.concat(registers[i]);
                }
                return C;
            }
            function decrypt(buffer) {
                var cipher = [];
                for (var i = 0; i < buffer.length; i += 8) {
                    cipher.push(buffer.slice(i, i + 8));
                }
                var n = cipher.length - 1;
                var registers = [];
                var plain = [];
                var A = cipher[0];
                for (var i = 1; i <= n; i++) {
                    registers[i] = cipher[i];
                }
                for (var j = 5; j >= 0; j--) {
                    for (var i = n; i >= 1; i--) {
                        var t = n * j + i;
                        for (var ai = 7; t > 0; ai--, t >>>= 8) {
                            A[ai] ^= t & 255;
                        }
                        var B = blockCipher.decrypt(A.concat(registers[i]));
                        A = B.slice(0, 8);
                        registers[i] = B.slice(8);
                    }
                }
                if (A.join(",") !== "166,166,166,166,166,166,166,166") {
                    throw msrcryptoUtilities.error("OperationError", "");
                }
                for (var i = 1; i <= n; i++) {
                    plain = plain.concat(registers[i]);
                }
                return plain;
            }
            return {
                encrypt: encrypt,
                decrypt: decrypt
            };
        };
        if (typeof operations !== "undefined") {
            var aeskwInstances = {};
            msrcryptoAESKW.workerEncrypt = function (p) {
                var result, id = p.workerid;
                if (p.buffer.length % 8 !== 0) {
                    throw msrcryptoUtilities.error("DataError", "The AES-KW input data length is invalid: not a multiple of 8 bytes");
                }
                if (!aeskwInstances[id]) {
                    aeskwInstances[id] = msrcryptoAESKW(msrcryptoBlockCipher.aes(p.keyData));
                }
                result = aeskwInstances[id].encrypt(p.buffer);
                aeskwInstances[id] = null;
                return result;
            };
            msrcryptoAESKW.workerDecrypt = function (p) {
                var result, id = p.workerid;
                if (p.buffer.length % 8 !== 0) {
                    throw msrcryptoUtilities.error("DataError", "The AES-KW input data length is invalid: not a multiple of 8 bytes");
                }
                if (!aeskwInstances[id]) {
                    aeskwInstances[id] = msrcryptoAESKW(msrcryptoBlockCipher.aes(p.keyData));
                }
                result = aeskwInstances[id].decrypt(p.buffer);
                aeskwInstances[id] = null;
                return result;
            };
            msrcryptoAESKW.generateKey = function (p) {
                if (p.algorithm.length % 8 !== 0) {
                    throw msrcryptoUtilities.error("OperationError", "AES key length must be 128, 192, or 256 bits");
                }
                return {
                    type: "keyGeneration",
                    keyData: msrcryptoPseudoRandom.getBytes(Math.floor(p.algorithm.length / 8)),
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable,
                        usages: null || p.usages,
                        type: "secret"
                    }
                };
            };
            msrcryptoAESKW.importKey = function (p) {
                var keyObject;
                var keyBits = p.keyData.length * 8;
                if (p.format === "jwk") {
                    keyObject = msrcryptoJwk.jwkToKey(p.keyData, p.algorithm, ["k"]);
                }
                else if (p.format === "raw") {
                    if (keyBits !== 128 && keyBits !== 192 && keyBits !== 256) {
                        throw msrcryptoUtilities.error("OperationError", "AES key length must be 128, 192, or 256 bits");
                    }
                    keyObject = {
                        k: msrcryptoUtilities.toArray(p.keyData)
                    };
                }
                else {
                    throw new TypeError("Invalid keyFormat argument");
                }
                p.algorithm.length = keyObject.k.length * 8;
                return {
                    keyData: keyObject.k,
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable || keyObject.extractable,
                        usages: null || p.usages,
                        type: "secret"
                    },
                    type: "keyImport"
                };
            };
            msrcryptoAESKW.exportKey = function (p) {
                if (p.format === "jwk") {
                    return {
                        type: "keyExport",
                        keyHandle: msrcryptoJwk.keyToJwk(p.keyHandle, p.keyData)
                    };
                }
                if (p.format === "raw") {
                    return {
                        type: "keyExport",
                        keyHandle: p.keyData
                    };
                }
                throw new TypeError("Invalid keyFormat argument");
            };
            operations.register("importKey", "AES-KW", msrcryptoAESKW.importKey);
            operations.register("exportKey", "AES-KW", msrcryptoAESKW.exportKey);
            operations.register("generateKey", "AES-KW", msrcryptoAESKW.generateKey);
            operations.register("encrypt", "AES-KW", msrcryptoAESKW.workerEncrypt);
            operations.register("decrypt", "AES-KW", msrcryptoAESKW.workerDecrypt);
        }
        function MsrcryptoPrng() {
            if (!(this instanceof MsrcryptoPrng)) {
                throw new Error("create MsrcryptoPrng object with new keyword");
            }
            var initialized = false;
            var key;
            var v;
            var keyLen;
            var seedLen;
            var reseedCounter = 1;
            var reseedInterval = Math.pow(2, 48);
            initialize();
            function addOne(counter) {
                var i;
                for (i = counter.length - 1; i >= 0; i -= 1) {
                    counter[i] += 1;
                    if (counter[i] >= 256) {
                        counter[i] = 0;
                    }
                    if (counter[i]) {
                        break;
                    }
                }
            }
            function initialize() {
                key = msrcryptoUtilities.getVector(32);
                v = msrcryptoUtilities.getVector(16);
                keyLen = 32;
                seedLen = 48;
                reseedCounter = 1;
            }
            function reseed(entropy, additionalEntropy) {
                additionalEntropy = additionalEntropy || [0];
                if (additionalEntropy.length > seedLen) {
                    throw new Error("Incorrect entropy or additionalEntropy length");
                }
                additionalEntropy = additionalEntropy.concat(msrcryptoUtilities.getVector(seedLen - additionalEntropy.length));
                entropy = entropy.concat(msrcryptoUtilities.getVector((seedLen - (entropy.length % seedLen)) % seedLen));
                for (var i = 0; i < entropy.length; i += seedLen) {
                    var seedMaterial = msrcryptoUtilities.xorVectors(entropy.slice(i, i + seedLen), additionalEntropy);
                    update(seedMaterial);
                }
                reseedCounter = 1;
            }
            function update(providedData) {
                var temp = [];
                var blockCipher = new msrcryptoBlockCipher.aes(key);
                while (temp.length < seedLen) {
                    addOne(v);
                    var toEncrypt = v.slice(0, 16);
                    var outputBlock = blockCipher.encrypt(toEncrypt);
                    temp = temp.concat(outputBlock);
                }
                temp = msrcryptoUtilities.xorVectors(temp, providedData);
                key = temp.slice(0, keyLen);
                v = temp.slice(keyLen);
            }
            function generate(requestedBytes, additionalInput) {
                if (requestedBytes >= 65536) {
                    throw new Error("too much random requested");
                }
                if (reseedCounter > reseedInterval) {
                    throw new Error("Reseeding is required");
                }
                if (additionalInput && additionalInput.length > 0) {
                    while (additionalInput.length < seedLen) {
                        additionalInput = additionalInput.concat(msrcryptoUtilities.getVector(seedLen - additionalInput.length));
                    }
                    update(additionalInput);
                }
                else {
                    additionalInput = msrcryptoUtilities.getVector(seedLen);
                }
                var temp = [];
                var blockCipher = new msrcryptoBlockCipher.aes(key);
                while (temp.length < requestedBytes) {
                    addOne(v);
                    var toEncrypt = v.slice(0, v.length);
                    var outputBlock = blockCipher.encrypt(toEncrypt);
                    temp = temp.concat(outputBlock);
                }
                temp = temp.slice(0, requestedBytes);
                update(additionalInput);
                reseedCounter += 1;
                return temp;
            }
            return {
                reseed: reseed,
                getBytes: function (length, additionalInput) {
                    if (!initialized) {
                        throw new Error("can't get randomness before initialization");
                    }
                    return generate(length, additionalInput);
                },
                getNonZeroBytes: function (length, additionalInput) {
                    if (!initialized) {
                        throw new Error("can't get randomness before initialization");
                    }
                    var result = [];
                    var buff;
                    while (result.length < length) {
                        buff = generate(length, additionalInput);
                        for (var i = 0; i < buff.length; i += 1) {
                            if (buff[i] !== 0) {
                                result.push(buff[i]);
                            }
                        }
                    }
                    return result.slice(0, length);
                },
                init: function (entropy, personalization) {
                    if (entropy.length < seedLen) {
                        throw new Error("Initial entropy length too short");
                    }
                    initialize();
                    reseed(entropy, personalization);
                    initialized = true;
                }
            };
        }
        var msrcryptoPseudoRandom = new MsrcryptoPrng();
        function MsrcryptoEntropy(global) {
            var poolLength = 48;
            var collectorPool = [];
            var collectorPoolLength = 128;
            var collectorsRegistered = 0;
            var entropyPoolPrng = new MsrcryptoPrng();
            var initialized = false;
            var cryptographicPRNGPresent = false;
            var globalScope = global;
            function collectEntropy() {
                var headerList = ["Cookie", "RedirectUri", "ETag", "x-ms-client-antiforgery-id", "x-ms-client-request-id",
                    "x-ms-client-session-id", "SubscriptionPool"
                ];
                var i, pool = [];
                for (i = 0; i < poolLength; i += 1) {
                    pool[i] = Math.floor(Math.random() * 256);
                }
                var prngCrypto = globalScope.crypto || globalScope.msCrypto;
                if (prngCrypto && typeof prngCrypto.getRandomValues === "function") {
                    if (global.Uint8Array) {
                        var res = new global.Uint8Array(poolLength);
                        prngCrypto.getRandomValues(res);
                        pool = pool.concat(Array.apply(null, res));
                        cryptographicPRNGPresent = true;
                    }
                }
                if (typeof XMLHttpRequest !== "undefined") {
                    var req = new XMLHttpRequest();
                    for (i = 0; i < headerList.length; i += 1) {
                        try {
                            var header = req.getResponseHeader(headerList[i]);
                            if (header) {
                                var arr = msrcryptoUtilities.stringToBytes(header);
                                pool = pool.concat(arr);
                            }
                        }
                        catch (err) { }
                    }
                }
                if (!cryptographicPRNGPresent && canCollect) {
                    pool = pool.concat(collectorPool.splice(0, collectorPool.length));
                    collectors.startCollectors();
                }
                initialized ? entropyPoolPrng.reseed(pool) : entropyPoolPrng.init(pool);
                initialized = true;
            }
            function updatePool(entropyData) {
                for (var i = 0; i < entropyData.length; ++i) {
                    collectorPool.push(entropyData[i]);
                }
                if (collectorPool.length >= collectorPoolLength) {
                    collectors.stopCollectors();
                }
            }
            var canCollect = (global && global.addEventListener) ||
                (typeof document !== "undefined" && document.attachEvent);
            var collectors = (function () {
                return {
                    startCollectors: function () {
                        if (!this.collectorsRegistered) {
                            if (global.addEventListener) {
                                global.addEventListener("mousemove", this.MouseEventCallBack, true);
                                global.addEventListener("load", this.LoadTimeCallBack, true);
                            }
                            else if (document.attachEvent) {
                                document.attachEvent("onmousemove", this.MouseEventCallBack);
                                document.attachEvent("onload", this.LoadTimeCallBack);
                            }
                            else {
                                throw new Error("Can't attach events for entropy collection");
                            }
                            this.collectorsRegistered = 1;
                        }
                    },
                    stopCollectors: function () {
                        if (this.collectorsRegistered) {
                            if (global.removeEventListener) {
                                global.removeEventListener("mousemove", this.MouseEventCallBack, 1);
                                global.removeEventListener("load", this.LoadTimeCallBack, 1);
                            }
                            else if (global.detachEvent) {
                                global.detachEvent("onmousemove", this.MouseEventCallBack);
                                global.detachEvent("onload", this.LoadTimeCallBack);
                            }
                            this.collectorsRegistered = 0;
                        }
                    },
                    MouseEventCallBack: function (eventData) {
                        var d = (new Date()).valueOf();
                        var x = eventData.x || eventData.clientX || eventData.offsetX || 0;
                        var y = eventData.y || eventData.clientY || eventData.offsetY || 0;
                        var arr = [d & 0x0ff, (d >> 8) & 0x0ff, (d >> 16) & 0x0ff, (d >> 24) & 0x0ff,
                            x & 0x0ff, (x >> 8) & 0x0ff, y & 0x0ff, (y >> 8) & 0x0ff
                        ];
                        updatePool(arr);
                    },
                    LoadTimeCallBack: function () {
                        var d = (new Date()).valueOf();
                        var dateArray = [d & 0x0ff, (d >> 8) & 0x0ff, (d >> 16) & 0x0ff, (d >> 24) & 0x0ff];
                        updatePool(dateArray);
                    }
                };
            })();
            return {
                init: function () {
                    collectEntropy();
                    if (!cryptographicPRNGPresent && !collectorsRegistered && canCollect) {
                        try {
                            collectors.startCollectors();
                        }
                        catch (e) { }
                    }
                },
                reseed: function (entropy) {
                    entropyPoolPrng.reseed(entropy);
                },
                read: function (length) {
                    if (!initialized) {
                        throw new Error("Entropy pool is not initialized.");
                    }
                    var ret = entropyPoolPrng.getBytes(length);
                    collectEntropy();
                    return ret;
                }
            };
        }
        var prime = (function () {
            var smallPrimes = [];
            var trialValues = [];
            var MAX_SMALL_PRIMES = 4096 * 4;
            function primeSieve(max) {
                var numbers = new Array(max + 1), results = [], i, j, limit = Math.sqrt(max) | 0;
                for (i = 3; i <= limit; i += 2) {
                    for (j = i * i; j <= max; j += i * 2) {
                        numbers[j] = 0;
                    }
                }
                for (i = 3; i <= max; i += 2) {
                    if (numbers[i] !== 0) {
                        results.push(i);
                    }
                }
                return results;
            }
            function incrementalTrialDivision(increment) {
                var i, len = trialValues.length;
                for (i = 0; i < len; i++) {
                    if ((trialValues[i] + increment) % smallPrimes[i] === 0) {
                        return false;
                    }
                }
                return true;
            }
            function setupIncrementalTrialDivision(candidate) {
                var i, j, r, p, y, primeCount, len = candidate.length - 1, db = cryptoMath.DIGIT_BASE, h = candidate[len];
                if (smallPrimes.length === 0) {
                    smallPrimes = primeSieve(MAX_SMALL_PRIMES);
                }
                primeCount = smallPrimes.length;
                trialValues = new Array(primeCount);
                for (i = 0; i < primeCount; i++) {
                    j = len;
                    y = smallPrimes[i];
                    if (h < y) {
                        r = h;
                        j--;
                    }
                    else {
                        r = 0;
                    }
                    while (j >= 0) {
                        p = r * db + candidate[j--];
                        r = p - (p / y | 0) * y;
                    }
                    trialValues[i] = r;
                }
                return;
            }
            function largestDivisibleByPowerOfTwo(number) {
                var k = 0, i = 0, s = 0, j;
                if (cryptoMath.isZero(number)) {
                    return 0;
                }
                for (k = 0; number[k] === 0; k++) { }
                for (i = 0, j = 2; number[k] % j === 0; j *= 2, i++) { }
                return k * cryptoMath.DIGIT_BITS + i;
            }
            function sizeInBits(digits) {
                var k = 0, i = 0, j = 0;
                if (cryptoMath.isZero(digits)) {
                    return 0;
                }
                for (k = digits.length - 1; digits[k] === 0; k--) { }
                for (i = cryptoMath.DIGIT_BITS - 1, j = (1 << i); i > 0; j = j >>> 1, i--) {
                    if ((digits[k] & j) !== 0) {
                        break;
                    }
                }
                return k * cryptoMath.DIGIT_BITS + i;
            }
            function millerRabin(number, iterations) {
                var w = number;
                var wminus1 = [];
                cryptoMath.subtract(w, [1], wminus1);
                var a = largestDivisibleByPowerOfTwo(wminus1);
                var m = [];
                cryptoMath.shiftRight(wminus1, m, a);
                var wlen = sizeInBits(w);
                var b;
                var montmul = cryptoMath.MontgomeryMultiplier(w);
                for (var i = 1; i <= iterations; i++) {
                    var status = false;
                    do {
                        b = getRandomOddNumber(wlen);
                    } while (cryptoMath.compareDigits(b, wminus1) >= 0);
                    var z = [];
                    montmul.modExp(b, m, z, true);
                    if (cryptoMath.compareDigits(z, [1]) === 0 || cryptoMath.compareDigits(z, wminus1) === 0) {
                        continue;
                    }
                    for (var j = 1; j < a; j++) {
                        montmul.montgomeryMultiply(z, z, z);
                        if (cryptoMath.compareDigits(z, wminus1) === 0) {
                            status = true;
                            break;
                        }
                        if (cryptoMath.compareDigits(z, [1]) === 0) {
                            return false;
                        }
                    }
                    if (status === false) {
                        return false;
                    }
                }
                return true;
            }
            function generatePrime(bits) {
                var candidate = getRandomOddNumber(bits), inc = 0, possiblePrime, isPrime = false, candidatePlusInc = [];
                setupIncrementalTrialDivision(candidate);
                while (true) {
                    possiblePrime = incrementalTrialDivision(inc);
                    if (possiblePrime) {
                        cryptoMath.add(candidate, [inc], candidatePlusInc);
                        if (millerRabin(candidatePlusInc, 6) === true) {
                            return candidatePlusInc;
                        }
                    }
                    inc += 2;
                }
            }
            function getRandomOddNumber(bits) {
                var numBytes = Math.ceil(bits / 8), bytes = msrcryptoPseudoRandom.getBytes(numBytes), digits;
                bytes[0] |= 128;
                bytes[bytes.length - 1] |= 1;
                return cryptoMath.bytesToDigits(bytes);
            }
            return {
                generatePrime: generatePrime
            };
        })();
        var msrcryptoRsaBase = function (keyStruct) {
            var utils = msrcryptoUtilities, keyIsPrivate = keyStruct.hasOwnProperty("n") && keyStruct.hasOwnProperty("d"), keyIsCrt = keyStruct.hasOwnProperty("p") && keyStruct.hasOwnProperty("q"), modulusLength = keyStruct.n.length;
            function toBytes(digits) {
                var bytes = cryptoMath.digitsToBytes(digits);
                utils.padFront(bytes, 0, modulusLength);
                return bytes;
            }
            function modExp(dataBytes, expBytes, modulusBytes) {
                var exponent = cryptoMath.bytesToDigits(expBytes);
                var group = cryptoMath.IntegerGroup(modulusBytes);
                var base = group.createElementFromBytes(dataBytes);
                var result = group.modexp(base, exponent);
                return result.m_digits;
            }
            function decryptModExp(cipherBytes) {
                var resultElement = modExp(cipherBytes, keyStruct.d, keyStruct.n);
                return toBytes(resultElement);
            }
            function decryptCrt(cipherBytes) {
                var b2d = cryptoMath.bytesToDigits, p = keyStruct.p, q = keyStruct.q, dp = keyStruct.dp, dq = keyStruct.dq, invQ = keyStruct.qi, pDigits = b2d(p), qDigits = b2d(q), temp = new Array(pDigits.length + qDigits.length), m1Digits = new Array(pDigits.length + 1), m2Digits = new Array(qDigits.length + 1), cDigits = b2d(cipherBytes), mm = cryptoMath.MontgomeryMultiplier, mmp = new mm(keyStruct.ctxp ? undefined : pDigits, keyStruct.ctxp), mmq = new mm(keyStruct.ctxq ? undefined : qDigits, keyStruct.ctxq);
                mmp.reduce(cDigits, temp);
                mmp.modExp(temp, b2d(dp), m1Digits);
                mmq.reduce(cDigits, temp);
                mmq.modExp(temp, b2d(dq), m2Digits);
                var carry = cryptoMath.subtract(m1Digits, m2Digits, temp);
                if (carry !== 0) {
                    cryptoMath.subtract(m2Digits, m1Digits, temp);
                }
                cryptoMath.modMul(temp, b2d(invQ), pDigits, cDigits);
                if (carry !== 0) {
                    cryptoMath.subtract(pDigits, cDigits, cDigits);
                }
                cryptoMath.multiply(cDigits, qDigits, temp);
                cryptoMath.add(m2Digits, temp, m1Digits);
                return toBytes(m1Digits);
            }
            return {
                encrypt: function (messageBytes) {
                    var bytes = toBytes(modExp(messageBytes, keyStruct.e, keyStruct.n, true));
                    return bytes;
                },
                decrypt: function (cipherBytes) {
                    if (keyIsCrt) {
                        return decryptCrt(cipherBytes);
                    }
                    if (keyIsPrivate) {
                        return decryptModExp(cipherBytes);
                    }
                    throw new Error("missing private key");
                }
            };
        };
        var rsaShared = {
            mgf1: function (seedBytes, maskLen, hashFunction) {
                var t = [], bytes, hash, counter, hashByteLen = hashFunction.hashLen / 8;
                for (counter = 0; counter <= Math.floor(maskLen / hashByteLen); counter += 1) {
                    bytes = [
                        counter >>> 24 & 0xff,
                        counter >>> 16 & 0xff,
                        counter >>> 8 & 0xff,
                        counter & 0xff
                    ];
                    hash = hashFunction.computeHash(seedBytes.concat(bytes));
                    t = t.concat(hash);
                }
                return t.slice(0, maskLen);
            },
            checkMessageVsMaxHash: function (messageBytes, hashFunction) {
                if (messageBytes.length > (hashFunction.maxMessageSize || 0xFFFFFFFF)) {
                    throw new Error("message too long");
                }
                return;
            }
        };
        var rsaMode = rsaMode || {};
        rsaMode.oaep = function (keyStruct, hashFunction) {
            var utils = msrcryptoUtilities, random = msrcryptoPseudoRandom, size = keyStruct.n.length;
            if (hashFunction === null) {
                throw new Error("must supply hashFunction");
            }
            function pad(message, label) {
                var lHash, psLen, psArray, i, db, seed;
                var dbMask, maskeddb, seedMask, maskedSeed;
                var encodedMessage;
                if (message.length > (size - 2 * (hashFunction.hashLen / 8) - 2)) {
                    throw new Error("Message too long.");
                }
                if (label == null) {
                    label = [];
                }
                lHash = hashFunction.computeHash(label);
                psLen = size - message.length - (2 * lHash.length) - 2;
                psArray = utils.getVector(psLen);
                db = lHash.concat(psArray, [1], message);
                seed = random.getBytes(lHash.length);
                dbMask = rsaShared.mgf1(seed, size - lHash.length - 1, hashFunction);
                maskeddb = utils.xorVectors(db, dbMask);
                seedMask = rsaShared.mgf1(maskeddb, lHash.length, hashFunction);
                maskedSeed = utils.xorVectors(seed, seedMask);
                encodedMessage = [0].concat(maskedSeed).concat(maskeddb);
                message = encodedMessage.slice();
                return message;
            }
            function unpad(encodedBytes, labelBytes) {
                var lHash, maskedSeed, maskeddb, seedMask;
                var seed, dbMask, db;
                var lHashp, i = 0;
                var valid = encodedBytes[0] === 0;
                if (!labelBytes) {
                    labelBytes = [];
                }
                lHash = hashFunction.computeHash(labelBytes);
                maskedSeed = encodedBytes.slice(1, lHash.length + 1);
                maskeddb = encodedBytes.slice(lHash.length + 1);
                seedMask = rsaShared.mgf1(maskeddb, lHash.length, hashFunction);
                seed = utils.xorVectors(maskedSeed, seedMask);
                dbMask = rsaShared.mgf1(seed, size - lHash.length - 1, hashFunction);
                db = utils.xorVectors(maskeddb, dbMask);
                lHashp = db.slice(0, lHash.length);
                valid = valid && utils.arraysEqual(lHash, lHashp);
                db = db.slice(lHash.length);
                while (!db[i++]) { }
                return {
                    valid: valid,
                    data: db.slice(i)
                };
            }
            return {
                pad: function (messageBytes, labelBytes) {
                    return pad(messageBytes, labelBytes);
                },
                unpad: function (encodedBytes, labelBytes) {
                    return unpad(encodedBytes, labelBytes);
                }
            };
        };
        var rsaMode = rsaMode || {};
        rsaMode.pkcs1Encrypt = function (keyStruct) {
            var random = msrcryptoPseudoRandom, size = keyStruct.n.length;
            function pad(data) {
                var randomness;
                if (data.length > size - 11) {
                    throw new Error("message too long");
                }
                randomness = random.getNonZeroBytes(size - data.length - 3);
                return [0, 2].concat(randomness, [0], data);
            }
            function validatePadding(paddedData) {
                var paddingValid = paddedData[0] === 0 && paddedData[1] === 2;
                for (var i = 2; i < 10; i++) {
                    paddingValid = paddingValid && !!paddedData[i];
                }
                return paddingValid;
            }
            function unpad(paddedData) {
                var i, paddingIsValid = validatePadding(paddedData), startOfData = 0;
                for (i = 1; i < paddedData.length; i += 1) {
                    startOfData = startOfData || +!paddedData[i] && i + 1;
                }
                startOfData = (-paddingIsValid && startOfData);
                return {
                    data: paddedData.slice(startOfData),
                    valid: paddingIsValid
                };
            }
            return {
                pad: function (messageBytes) {
                    return pad(messageBytes);
                },
                unpad: function (encodedBytes) {
                    return unpad(encodedBytes);
                }
            };
        };
        rsaMode.pkcs1Sign = function (keyStruct, hashFunction) {
            var utils = msrcryptoUtilities, size = keyStruct.n.length;
            function emsa_pkcs1_v15_encode(messageBytes) {
                var paddedData, hash, tlen;
                hash = hashFunction.computeHash(messageBytes.slice());
                paddedData = hashFunction.der.concat(hash);
                tlen = paddedData.length;
                if (size < tlen + 11) {
                    throw new Error("intended encoded message length too short");
                }
                return [0x00, 0x01].concat(utils.getVector(size - tlen - 3, 0xFF), [0], paddedData);
            }
            return {
                sign: function (messageBytes) {
                    return emsa_pkcs1_v15_encode(messageBytes);
                },
                verify: function (signatureBytes, messageBytes) {
                    var emp = emsa_pkcs1_v15_encode(messageBytes);
                    return utils.arraysEqual(signatureBytes, emp);
                }
            };
        };
        var rsaMode = rsaMode || {};
        rsaMode.pss = function (keyStruct, hashFunction) {
            var utils = msrcryptoUtilities, random = msrcryptoPseudoRandom;
            function emsa_pss_encode(messageBytes, saltLength, salt) {
                var modulusBits = cryptoMath.bitLength(keyStruct.n), emBits = modulusBits - 1, emLen = Math.ceil(emBits / 8), mHash = hashFunction.computeHash(messageBytes);
                saltLength = salt ? salt.length : saltLength == null ? mHash.length : saltLength;
                if (emLen < mHash.length + saltLength + 2) {
                    throw new Error("encoding error");
                }
                salt = salt || random.getBytes(saltLength);
                var mp = [0, 0, 0, 0, 0, 0, 0, 0].concat(mHash, salt);
                var h = hashFunction.computeHash(mp);
                var ps = utils.getVector(emLen - salt.length - h.length - 2);
                var db = ps.concat([1], salt);
                var dbMask = rsaShared.mgf1(h, emLen - h.length - 1, hashFunction);
                var maskedDb = utils.xorVectors(db, dbMask);
                var mask = 0;
                for (var i = 0; i < 8 - (8 * emLen - emBits); i++) {
                    mask += 1 << i;
                }
                maskedDb[0] &= mask;
                var em = maskedDb.concat(h, [0xbc]);
                return em;
            }
            function emsa_pss_verify(signatureBytes, messageBytes, saltLength) {
                var modulusBits = cryptoMath.bitLength(keyStruct.n);
                var emBits = modulusBits - 1;
                var emLen = Math.ceil(emBits / 8);
                var mHash = hashFunction.computeHash(messageBytes);
                var hLen = mHash.length;
                saltLength = saltLength == null ? hLen : saltLength;
                if (emLen < hLen + saltLength + 2) {
                    return false;
                }
                var maskedDb = signatureBytes.slice(0, emLen - hLen - 1);
                var h = signatureBytes.slice(maskedDb.length, maskedDb.length + hLen);
                var dbMask = rsaShared.mgf1(h, emLen - hLen - 1, hashFunction);
                var db = utils.xorVectors(maskedDb, dbMask);
                db[0] &= 0xff >>> (8 - (8 * emLen - emBits));
                for (var i = 0; i < emLen - hLen - saltLength - 2; i++) {
                    if (db[i] !== 0) {
                        return false;
                    }
                }
                if (db[emLen - hLen - saltLength - 2] !== 0x01) {
                    return false;
                }
                var salt = db.slice(db.length - saltLength);
                var mp = [0, 0, 0, 0, 0, 0, 0, 0].concat(mHash, salt);
                var hp = hashFunction.computeHash(mp);
                return utils.arraysEqual(hp, h);
            }
            return {
                sign: function (messageBytes, saltLength, salt) {
                    return emsa_pss_encode(messageBytes, saltLength, salt);
                },
                verify: function (signatureBytes, messageBytes, saltLength) {
                    return emsa_pss_verify(signatureBytes, messageBytes, saltLength);
                }
            };
        };
        var msrcryptoRsa = function (keyStruct, mode, hashFunction) {
            var rsaBase = msrcryptoRsaBase(keyStruct);
            if (!mode) {
                throw new Error("padding mode");
            }
            function checkHash() {
                if (!hashFunction || !hashFunction.computeHash) {
                    throw new Error("missing hash function");
                }
            }
            var paddingFunction = null, unPaddingFunction = null;
            var padding;
            switch (mode) {
                case "RSAES-PKCS1-V1_5":
                    padding = rsaMode.pkcs1Encrypt(keyStruct);
                    break;
                case "RSASSA-PKCS1-V1_5":
                    checkHash();
                    padding = rsaMode.pkcs1Sign(keyStruct, hashFunction);
                    break;
                case "RSA-OAEP":
                    checkHash();
                    padding = rsaMode.oaep(keyStruct, hashFunction);
                    break;
                case "RSA-PSS":
                    checkHash();
                    padding = rsaMode.pss(keyStruct, hashFunction);
                    break;
                case "raw":
                    padding = {
                        pad: function (mb) {
                            return mb;
                        },
                        unpad: function (eb) {
                            return eb;
                        }
                    };
                    break;
                default:
                    throw new Error("invalid mode");
            }
            if (padding) {
                paddingFunction = padding.pad || padding.sign;
                unPaddingFunction = padding.unpad || padding.verify;
            }
            var returnObj = {
                encrypt: function (dataBytes, labelBytes) {
                    var paddedData;
                    var encryptedData;
                    if (paddingFunction !== null) {
                        paddedData = paddingFunction(dataBytes, labelBytes);
                    }
                    else {
                        paddedData = dataBytes.slice();
                    }
                    encryptedData = rsaBase.encrypt(paddedData);
                    return encryptedData;
                },
                decrypt: function (cipherBytes, labelBytes) {
                    var decryptedData = rsaBase.decrypt(cipherBytes);
                    if (unPaddingFunction !== null) {
                        decryptedData = unPaddingFunction(decryptedData, labelBytes);
                        if (decryptedData.valid === false) {
                            throw new Error("OperationError");
                        }
                        decryptedData = decryptedData.data;
                    }
                    else {
                        decryptedData = decryptedData.slice(0);
                    }
                    return decryptedData;
                },
                signData: function (messageBytes, saltLength, salt) {
                    return rsaBase.decrypt(paddingFunction(messageBytes, saltLength, salt));
                },
                verifySignature: function (signature, messageBytes, saltLength) {
                    var decryptedSig = rsaBase.encrypt(signature);
                    return unPaddingFunction(decryptedSig, messageBytes, saltLength);
                },
                generateKeyPair: function (bits) {
                    var keyPair = genRsaKeyFromRandom(bits);
                },
                mode: mode
            };
            return returnObj;
        };
        if (typeof operations !== "undefined") {
            msrcryptoRsa.sign = function (p) {
                var rsaObj, hashName = p.keyHandle.algorithm.hash.name, hashFunc = msrcryptoHashFunctions[hashName.toUpperCase()](), saltLength = p.algorithm.saltLength, salt = p.algorithm.salt;
                rsaObj = msrcryptoRsa(p.keyData, p.algorithm.name, hashFunc);
                return rsaObj.signData(p.buffer, saltLength, salt);
            };
            msrcryptoRsa.verify = function (p) {
                var hashName = p.keyHandle.algorithm.hash.name, hashFunc = msrcryptoHashFunctions[hashName.toUpperCase()](), rsaObj, saltLength = p.algorithm.saltLength;
                rsaObj = msrcryptoRsa(p.keyData, p.algorithm.name, hashFunc);
                return rsaObj.verifySignature(p.signature, p.buffer, saltLength);
            };
            msrcryptoRsa.workerEncrypt = function (p) {
                var result, rsaObj, hashFunc, hashName;
                switch (p.algorithm.name) {
                    case "RSAES-PKCS1-V1_5":
                        rsaObj = msrcryptoRsa(p.keyData, p.algorithm.name);
                        result = rsaObj.encrypt(p.buffer);
                        break;
                    case "RSA-OAEP":
                        hashName = p.keyHandle.algorithm.hash.name;
                        if (!hashName) {
                            throw new Error("unsupported hash algorithm");
                        }
                        hashFunc = msrcryptoHashFunctions[hashName.toUpperCase()]();
                        rsaObj = msrcryptoRsa(p.keyData, p.algorithm.name, hashFunc);
                        result = rsaObj.encrypt(p.buffer);
                        break;
                    default:
                        throw new Error("unsupported algorithm");
                }
                return result;
            };
            msrcryptoRsa.workerDecrypt = function (p) {
                var result, rsaObj, hashFunc;
                switch (p.algorithm.name) {
                    case "RSAES-PKCS1-V1_5":
                        rsaObj = msrcryptoRsa(p.keyData, p.algorithm.name);
                        result = rsaObj.decrypt(p.buffer);
                        break;
                    case "RSA-OAEP":
                        var hashName = p.keyHandle.algorithm.hash.name;
                        if (!hashName) {
                            throw new Error("unsupported hash algorithm");
                        }
                        hashFunc = msrcryptoHashFunctions[hashName.toUpperCase()]();
                        rsaObj = msrcryptoRsa(p.keyData, p.algorithm.name, hashFunc);
                        result = rsaObj.decrypt(p.buffer);
                        break;
                    default:
                        throw new Error("unsupported algorithm");
                }
                return result;
            };
            msrcryptoRsa.importKey = function (p) {
                var keyObject;
                if (p.format === "jwk") {
                    keyObject = msrcryptoJwk.jwkToKey(p.keyData, p.algorithm, ["n", "e", "d", "p", "q", "dp", "dq", "qi"]);
                    if (keyObject.d) {
                        keyObject.ctxp = new cryptoMath.MontgomeryMultiplier(cryptoMath.bytesToDigits(keyObject.p)).ctx;
                        keyObject.ctxq = new cryptoMath.MontgomeryMultiplier(cryptoMath.bytesToDigits(keyObject.q)).ctx;
                    }
                }
                else if (p.format === "spki") {
                    var publicKeyInfo = asn1.parse(p.keyData);
                    if (publicKeyInfo == null) {
                        throw new Error("invalid key data.");
                    }
                    var octetString = publicKeyInfo[1];
                    var keySequence = asn1.parse(octetString.data.slice(octetString.header + 1), true);
                    if (keySequence == null) {
                        throw new Error("invalid key data.");
                    }
                    var n = keySequence[0], e = keySequence[1];
                    if (n.type !== "INTEGER" || e.type !== "INTEGER") {
                        throw new Error("invalid key data.");
                    }
                    n = n.data.slice(n.header);
                    e = e.data.slice(e.header);
                    if (n[0] === 0 && n[1] & 128) {
                        n = n.slice(1);
                    }
                    if (e[0] === 0 && e[1] & 128) {
                        e = e.slice(1);
                    }
                    keyObject = {
                        n: n,
                        e: e
                    };
                }
                else if (p.format === "pkcs8") {
                    var publicKeyInfo = asn1.parse(p.keyData);
                    if (publicKeyInfo == null) {
                        throw new Error("invalid key data.");
                    }
                    var octetString = publicKeyInfo[2];
                    var keySequence = asn1.parse(octetString.data.slice(octetString.header), true);
                    if (keySequence == null) {
                        throw new Error("invalid key data.");
                    }
                    var keyProps = ["n", "e", "d", "p", "q", "dp", "dq", "qi"];
                    keyObject = {};
                    for (var i = 1; i < keySequence.length; i++) {
                        var int = keySequence[i];
                        int = int.data.slice(int.header);
                        if (int[0] === 0 && int[1] & 128) {
                            int = int.slice(1);
                        }
                        keyObject[keyProps[i - 1]] = int;
                    }
                }
                else {
                    throw new Error("unsupported key import format.");
                }
                return {
                    type: "keyImport",
                    keyData: keyObject,
                    keyHandle: {
                        algorithm: p.algorithm,
                        extractable: p.extractable,
                        usages: p.usages,
                        type: keyObject.d || keyObject.dq ? "private" : "public"
                    }
                };
            };
            msrcryptoRsa.exportKey = function (p) {
                var RSA_ENCRYPTION = "1.2.840.113549.1.1.1";
                if (p.format === "jwk") {
                    var jsonKeyStringArray = msrcryptoJwk.keyToJwk(p.keyHandle, p.keyData);
                    return {
                        type: "keyExport",
                        keyHandle: jsonKeyStringArray
                    };
                }
                if (p.format === "spki") {
                    var bytes = asn1.encode({
                        SEQUENCE: [{
                                SEQUENCE: [{
                                        "OBJECT IDENTIFIER": RSA_ENCRYPTION
                                    }, {
                                        NULL: 1
                                    }]
                            },
                            {
                                "BIT STRING": {
                                    SEQUENCE: [{
                                            INTEGER: p.keyData.n
                                        }, {
                                            INTEGER: p.keyData.e
                                        }]
                                }
                            }
                        ]
                    });
                    return {
                        type: "keyExport",
                        keyHandle: bytes
                    };
                }
                if (p.format === "pkcs8") {
                    var bytes = asn1.encode({
                        SEQUENCE: [{
                                INTEGER: 0
                            },
                            {
                                SEQUENCE: [{
                                        "OBJECT IDENTIFIER": RSA_ENCRYPTION
                                    }, {
                                        NULL: 1
                                    }]
                            },
                            {
                                "OCTET STRING": {
                                    SEQUENCE: [{
                                            INTEGER: 0
                                        },
                                        {
                                            INTEGER: p.keyData.n
                                        },
                                        {
                                            INTEGER: p.keyData.e
                                        },
                                        {
                                            INTEGER: p.keyData.d
                                        },
                                        {
                                            INTEGER: p.keyData.p
                                        },
                                        {
                                            INTEGER: p.keyData.q
                                        },
                                        {
                                            INTEGER: p.keyData.dp
                                        },
                                        {
                                            INTEGER: p.keyData.dq
                                        },
                                        {
                                            INTEGER: p.keyData.qi
                                        }
                                    ]
                                }
                            }
                        ]
                    });
                    return {
                        type: "keyExport",
                        keyHandle: bytes
                    };
                }
                throw new Error(p.format + " not implemented");
            };
            msrcryptoRsa.genRsaKeyFromRandom = function (bits, e) {
                var exp = e ? cryptoMath.bytesToDigits(e) : [65537];
                do {
                    var p = prime.generatePrime(bits / 2);
                    var q = prime.generatePrime(bits / 2);
                    if (cryptoMath.compareDigits(q, p) > 0) {
                        var t = p;
                        p = q;
                        q = t;
                    }
                    var n = [];
                    cryptoMath.multiply(p, q, n);
                    var p_1 = [];
                    cryptoMath.subtract(p, [1], p_1);
                    var q_1 = [];
                    cryptoMath.subtract(q, [1], q_1);
                    var p_1q_1 = [];
                    cryptoMath.multiply(p_1, q_1, p_1q_1);
                    var gcd = [];
                    cryptoMath.gcd(exp, p_1q_1, gcd);
                    var gcdEqual1 = cryptoMath.compareDigits(gcd, cryptoMath.One) === 0;
                } while (!gcdEqual1);
                var d = [];
                cryptoMath.modInv(exp, p_1q_1, d);
                var dp = [];
                cryptoMath.reduce(d, p_1, dp);
                var dq = [];
                cryptoMath.reduce(d, q_1, dq);
                var qi = [];
                cryptoMath.modInv(q, p, qi);
                var d2b = cryptoMath.digitsToBytes;
                return {
                    privateKey: {
                        n: d2b(n),
                        e: d2b(exp),
                        d: d2b(d),
                        p: d2b(p),
                        q: d2b(q),
                        dp: d2b(dp),
                        dq: d2b(dq),
                        qi: d2b(qi)
                    },
                    publicKey: {
                        n: d2b(n),
                        e: d2b(exp)
                    }
                };
            };
            msrcryptoRsa.generateKeyPair = function (p) {
                if (typeof p.algorithm.modulusLength === "undefined") {
                    throw new Error("missing modulusLength");
                }
                var keyPair;
                var b2d = cryptoMath.bytesToDigits;
                switch (p.algorithm.modulusLength) {
                    case 1024:
                    case 2048:
                    case 4096:
                        keyPair = msrcryptoRsa.genRsaKeyFromRandom(p.algorithm.modulusLength, p.algorithm.publicExponent);
                        break;
                    default:
                        throw new Error("invalid modulusLength");
                }
                var pk = keyPair.privateKey;
                pk.ctxp = (new cryptoMath.MontgomeryMultiplier(b2d(pk.p))).ctx;
                pk.ctxq = (new cryptoMath.MontgomeryMultiplier(b2d(pk.q))).ctx;
                var algName = p.algorithm.name;
                var rsaKeyType = algName.slice(algName.indexOf("-") + 1).toUpperCase();
                var publicUsage, privateUsage;
                if (algName === "RSASSA-PKCS1-V1_5" || algName === "RSA-PSS") {
                    publicUsage = ["verify"];
                    privateUsage = ["sign"];
                }
                else {
                    publicUsage = ["encrypt"];
                    privateUsage = ["decrypt"];
                }
                return {
                    type: "keyGeneration",
                    keyPair: {
                        publicKey: {
                            keyData: keyPair.publicKey,
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: null || publicUsage,
                                type: "public"
                            }
                        },
                        privateKey: {
                            keyData: keyPair.privateKey,
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: null || privateUsage,
                                type: "private"
                            }
                        }
                    }
                };
            };
            operations.register("sign", "RSASSA-PKCS1-V1_5", msrcryptoRsa.sign);
            operations.register("sign", "RSA-PSS", msrcryptoRsa.sign);
            operations.register("verify", "RSASSA-PKCS1-V1_5", msrcryptoRsa.verify);
            operations.register("verify", "RSA-PSS", msrcryptoRsa.verify);
            operations.register("encrypt", "RSAES-PKCS1-V1_5", msrcryptoRsa.workerEncrypt);
            operations.register("decrypt", "RSAES-PKCS1-V1_5", msrcryptoRsa.workerDecrypt);
            operations.register("encrypt", "RSA-OAEP", msrcryptoRsa.workerEncrypt);
            operations.register("decrypt", "RSA-OAEP", msrcryptoRsa.workerDecrypt);
            operations.register("importKey", "RSA-OAEP", msrcryptoRsa.importKey);
            operations.register("importKey", "RSAES-PKCS1-V1_5", msrcryptoRsa.importKey);
            operations.register("importKey", "RSASSA-PKCS1-V1_5", msrcryptoRsa.importKey);
            operations.register("importKey", "RSA-PSS", msrcryptoRsa.importKey);
            operations.register("exportKey", "RSA-OAEP", msrcryptoRsa.exportKey);
            operations.register("exportKey", "RSAES-PKCS1-V1_5", msrcryptoRsa.exportKey);
            operations.register("exportKey", "RSASSA-PKCS1-V1_5", msrcryptoRsa.exportKey);
            operations.register("exportKey", "RSA-PSS", msrcryptoRsa.exportKey);
            operations.register("generateKey", "RSA-OAEP", msrcryptoRsa.generateKeyPair);
            operations.register("generateKey", "RSAES-PKCS1-V1_5", msrcryptoRsa.generateKeyPair);
            operations.register("generateKey", "RSASSA-PKCS1-V1_5", msrcryptoRsa.generateKeyPair);
            operations.register("generateKey", "RSA-PSS", msrcryptoRsa.generateKeyPair);
        }
        var msrcryptoConcatKdf = (function () {
            function deriveBits(p) {
                var hashName = p.algorithm.hash.name, hashFunction = msrcryptoHashFunctions[hashName.toUpperCase()](), alg = p.algorithm;
                var otherInfo = utils.toArray(alg.algorithmId).concat(utils.toArray(alg.partyUInfo), utils.toArray(alg.partyVInfo), utils.toArray(alg.publicInfo) || [], utils.toArray(alg.privateInfo) || []);
                var reps = Math.ceil(p.length / hashFunction.hashLen), counter = 1, digest = p.keyData.concat(otherInfo), output = [];
                for (var i = 0; i < reps; i++) {
                    var data = utils.int32ToBytes(counter++).concat(digest);
                    var h = hashFunction.computeHash(data);
                    output = output.concat(h);
                }
                return output.slice(0, p.length / 8);
            }
            return {
                deriveBits: deriveBits
            };
        }());
        var msrcryptoConcatKdfInstance = null;
        if (typeof operations !== "undefined") {
            msrcryptoConcatKdf.importKey = function (p) {
                var keyData;
                if (p.format === "raw") {
                    keyData = msrcryptoUtilities.toArray(p.keyData);
                }
                else {
                    throw new Error("unsupported import format");
                }
                if (p.extractable !== false) {
                    throw new Error("only extractable=false is supported.");
                }
                return {
                    type: "keyImport",
                    keyData: keyData,
                    keyHandle: {
                        algorithm: {
                            name: "CONCAT"
                        },
                        extractable: false,
                        usages: p.usages,
                        type: "secret"
                    }
                };
            };
            operations.register("deriveBits", "CONCAT", msrcryptoConcatKdf.deriveBits);
            operations.register("importKey", "CONCAT", msrcryptoConcatKdf.importKey);
        }
        var msrcryptoPbkdf2 = (function () {
            function deriveBits(p) {
                var algorithm = p.algorithm, keyBytes = p.keyData, bits = p.length, iterations = algorithm.iterations, saltBytes = Array.apply(null, algorithm.salt), byteLen = Math.ceil(bits / 8), hLen, blockCount, output = [];
                switch (algorithm.hash.name.toUpperCase()) {
                    case "SHA-1":
                        hLen = 20;
                        break;
                    case "SHA-256":
                        hLen = 32;
                        break;
                    case "SHA-384":
                        hLen = 48;
                        break;
                    case "SHA-512":
                        hLen = 64;
                        break;
                    default:
                        throw new Error("Unsupported hash algorithm");
                }
                blockCount = Math.ceil(byteLen / hLen);
                var hmacKey = msrcryptoHmac.importKey({
                    format: "raw",
                    keyData: keyBytes,
                    algorithm: {
                        name: "HMAC",
                        hash: algorithm.hash
                    }
                });
                var hmacContext = {
                    algorithm: algorithm,
                    keyHandle: hmacKey.keyHandle,
                    keyData: hmacKey.keyData,
                    workerid: 0,
                    buffer: null
                };
                function F(S, c, i) {
                    var result = [], u = S.concat([i >>> 24 & 0xFF, i >>> 16 & 0xFF, i >>> 8 & 0xFF, i & 0xFF]);
                    for (var j = 0; j < c; j++) {
                        hmacContext.buffer = u;
                        u = msrcryptoHmac.signHmac(hmacContext);
                        for (var k = 0; k < hLen; k++) {
                            result[k] = ~~result[k] ^ u[k];
                        }
                    }
                    return result;
                }
                for (var block = 1; block <= blockCount; block++) {
                    output = output.concat(F(saltBytes, iterations, block));
                }
                output.length = byteLen;
                return output;
            }
            return {
                deriveBits: deriveBits
            };
        }());
        var msrcryptoKdfInstance = null;
        if (typeof operations !== "undefined") {
            msrcryptoPbkdf2.importKey = function (p) {
                var keyData;
                if (p.format === "raw") {
                    keyData = msrcryptoUtilities.toArray(p.keyData);
                }
                else {
                    throw new Error("unsupported import format");
                }
                if (p.extractable !== false) {
                    throw new Error("only extractable=false is supported.");
                }
                return {
                    type: "keyImport",
                    keyData: keyData,
                    keyHandle: {
                        algorithm: {
                            name: "PBKDF2"
                        },
                        extractable: false,
                        usages: p.usages,
                        type: "secret"
                    }
                };
            };
            operations.register("deriveBits", "PBKDF2", msrcryptoPbkdf2.deriveBits);
            operations.register("importKey", "PBKDF2", msrcryptoPbkdf2.importKey);
        }
        var msrcryptoHkdf = (function () {
            function deriveBits(p) {
                var algorithm = p.algorithm, keyBytes = p.keyData, bits = p.length, saltBytes = algorithm.salt, byteLen = Math.ceil(bits / 8), hLen, output = [], infoBytes = msrcryptoUtilities.toArray(algorithm.info), t = [], i, hmacContext;
                switch (algorithm.hash.name.toUpperCase()) {
                    case "SHA-1":
                        hLen = 20;
                        break;
                    case "SHA-256":
                        hLen = 32;
                        break;
                    case "SHA-384":
                        hLen = 48;
                        break;
                    case "SHA-512":
                        hLen = 64;
                        break;
                    default:
                        throw new Error("Unsupported hash algorithm.");
                }
                if (algorithm.salt == null) {
                    throw new Error("HkdfParams: salt: Missing required property.");
                }
                if (algorithm.info == null) {
                    throw new Error("HkdfParams: info: Missing required property.");
                }
                if (bits % 8 !== 0) {
                    throw new Error("The length provided for HKDF is not a multiple of 8 bits.");
                }
                if (byteLen > 255 * hLen) {
                    throw new Error("The length provided for HKDF is too large.");
                }
                if (saltBytes.length === 0) {
                    saltBytes = msrcryptoUtilities.getVector(hLen);
                }
                hmacContext = {
                    workerid: 0,
                    keyHandle: {
                        algorithm: algorithm
                    },
                    keyData: saltBytes,
                    buffer: keyBytes
                };
                hmacContext.keyData = msrcryptoHmac.signHmac(hmacContext);
                for (i = 0; i < Math.ceil(byteLen / hLen); i++) {
                    hmacContext.buffer = t.concat(infoBytes).concat([1 + i]);
                    t = msrcryptoHmac.signHmac(hmacContext);
                    output = output.concat(t);
                }
                return output.slice(0, byteLen);
            }
            return {
                deriveBits: deriveBits
            };
        }());
        var msrcryptoKdfInstance = null;
        if (typeof operations !== "undefined") {
            msrcryptoHkdf.importKey = function (p) {
                var keyData;
                if (p.format === "raw") {
                    keyData = msrcryptoUtilities.toArray(p.keyData);
                }
                else {
                    throw new Error("unsupported import format");
                }
                if (p.extractable !== false) {
                    throw new Error("only extractable=false is supported.");
                }
                return {
                    type: "keyImport",
                    keyData: keyData,
                    keyHandle: {
                        algorithm: {
                            name: "HKDF"
                        },
                        extractable: false,
                        usages: p.usages,
                        type: "secret"
                    }
                };
            };
            operations.register("deriveBits", "HKDF", msrcryptoHkdf.deriveBits);
            operations.register("importKey", "HKDF", msrcryptoHkdf.importKey);
        }
        var msrcryptoHkdfCtr = (function () {
            function deriveBits(p) {
                var algorithm = p.algorithm, keyBytes = p.keyData, bits = p.length, labelBytes = algorithm.label, contextBytes = algorithm.context, byteLen = Math.ceil(bits / 8), hLen, output = [], i, hmacContext;
                switch (algorithm.hash.name.toUpperCase()) {
                    case "SHA-1":
                        hLen = 20;
                        break;
                    case "SHA-256":
                        hLen = 32;
                        break;
                    case "SHA-384":
                        hLen = 48;
                        break;
                    case "SHA-512":
                        hLen = 64;
                        break;
                    default:
                        throw new Error("Unsupported hash algorithm.");
                }
                if (algorithm.label == null) {
                    throw new Error("HkdfCtrParams: label: Missing required property.");
                }
                if (algorithm.context == null) {
                    throw new Error("HkdfCtrParams: context: Missing required property.");
                }
                if (bits % 8 !== 0) {
                    throw new Error("The length provided for HKDF-CTR is not a multiple of 8 bits.");
                }
                if (byteLen > 255 * hLen) {
                    throw new Error("The length provided for HKDF-CTR is too large.");
                }
                hmacContext = {
                    workerid: 0,
                    keyHandle: {
                        algorithm: algorithm
                    },
                    keyData: keyBytes,
                    buffer: keyBytes
                };
                var fixed = labelBytes.concat([0], contextBytes, utils.int32ToBytes(bits));
                for (i = 1; i <= Math.ceil(byteLen / hLen); i++) {
                    hmacContext.buffer = utils.int32ToBytes(i).concat(fixed);
                    output = output.concat(msrcryptoHmac.signHmac(hmacContext));
                }
                return output.slice(0, byteLen);
            }
            return {
                deriveBits: deriveBits
            };
        }());
        if (typeof operations !== "undefined") {
            msrcryptoHkdfCtr.importKey = function (p) {
                var keyData;
                if (p.format === "raw") {
                    keyData = msrcryptoUtilities.toArray(p.keyData);
                }
                else {
                    throw new Error("unsupported import format");
                }
                if (p.extractable !== false) {
                    throw new Error("only extractable=false is supported.");
                }
                return {
                    type: "keyImport",
                    keyData: keyData,
                    keyHandle: {
                        algorithm: {
                            name: "HKDF-CTR"
                        },
                        extractable: false,
                        usages: p.usages,
                        type: "secret"
                    }
                };
            };
            operations.register("deriveBits", "HKDF-CTR", msrcryptoHkdfCtr.deriveBits);
            operations.register("importKey", "HKDF-CTR", msrcryptoHkdfCtr.importKey);
        }
        var msrcryptoEcdh = function (curve) {
            var btd = cryptoMath.bytesToDigits, dtb = cryptoMath.digitsToBytes, e = curve, ecop = new cryptoECC.EllipticCurveOperatorFp(curve);
            function generateKey(privateKeyBytes) {
                var privateKey = [], randomBytes = msrcryptoPseudoRandom.getBytes(curve.order.length * cryptoMath.DIGIT_NUM_BYTES);
                cryptoMath.reduce(cryptoMath.bytesToDigits(randomBytes), e.order, privateKey);
                var publicKey = e.allocatePointStorage();
                ecop.scalarMultiply(privateKey, e.generator, publicKey);
                return {
                    privateKey: {
                        x: dtb(publicKey.x),
                        y: dtb(publicKey.y),
                        d: dtb(privateKey)
                    },
                    publicKey: {
                        x: dtb(publicKey.x),
                        y: dtb(publicKey.y)
                    }
                };
            }
            function deriveBits(privateKey, publicKey, length) {
                var publicPoint = new cryptoECC.EllipticCurvePointFp(e, false, btd(publicKey.x), btd(publicKey.y), null, false);
                var sharedSecretPoint = e.allocatePointStorage();
                ecop.convertToJacobianForm(sharedSecretPoint);
                ecop.convertToMontgomeryForm(sharedSecretPoint);
                ecop.scalarMultiply(btd(privateKey.d), publicPoint, sharedSecretPoint);
                ecop.convertToAffineForm(sharedSecretPoint);
                ecop.convertToStandardForm(sharedSecretPoint);
                var secretBytes = cryptoMath.digitsToBytes(sharedSecretPoint.x, true, publicKey.x.length);
                if (length && secretBytes.length * 8 < length) {
                    throw new Error("DataError");
                }
                secretBytes = length ? secretBytes.slice(0, Math.ceil(length / 8)) : secretBytes;
                var bits = length % 8;
                var mask = bits === 0 ? 0xFF : 0xFF00 >>> bits;
                secretBytes[secretBytes.length - 1] = secretBytes[secretBytes.length - 1] & mask;
                return secretBytes;
            }
            function computePublicKey(privateKeyBytes) {
                if (!e.generator.isInMontgomeryForm) {
                    ecop.convertToMontgomeryForm(e.generator);
                }
                var publicKey = e.allocatePointStorage();
                ecop.convertToJacobianForm(publicKey);
                ecop.convertToMontgomeryForm(publicKey);
                ecop.scalarMultiply(btd(privateKeyBytes), e.generator, publicKey);
                return {
                    x: dtb(publicKey.x),
                    y: dtb(publicKey.y)
                };
            }
            return {
                generateKey: generateKey,
                deriveBits: deriveBits,
                computePublicKey: computePublicKey
            };
        };
        var ecdhInstance = null;
        if (typeof operations !== "undefined") {
            msrcryptoEcdh.deriveBits = function (p) {
                var curve = cryptoECC.createCurve(p.algorithm.namedCurve.toUpperCase());
                var privateKey = p.keyData;
                var publicKey = p.additionalKeyData;
                ecdhInstance = msrcryptoEcdh(curve);
                var secretBytes = ecdhInstance.deriveBits(privateKey, publicKey, p.length);
                return secretBytes;
            };
            msrcryptoEcdh.deriveKey = function (p) {
                throw new Error("not supported");
                return secretBytes;
            };
            msrcryptoEcdh.generateKey = function (p) {
                var curve = cryptoECC.createCurve(p.algorithm.namedCurve.toUpperCase());
                ecdhInstance = msrcryptoEcdh(curve);
                var keyPairData = ecdhInstance.generateKey();
                return {
                    type: "keyPairGeneration",
                    keyPair: {
                        publicKey: {
                            keyData: keyPairData.publicKey,
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: [],
                                type: "public"
                            }
                        },
                        privateKey: {
                            keyData: keyPairData.privateKey,
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: p.usages,
                                type: "private"
                            }
                        }
                    }
                };
            };
            msrcryptoEcdh.importKey = function (p) {
                try {
                    if (p.format === "raw") {
                        var keyData = p.keyData;
                        if (keyData[0] !== 4) {
                            throw new Error("DataError");
                        }
                        var elementSize = ~~((keyData.length - 1) / 2);
                        var curveName = p.algorithm.namedCurve.toUpperCase();
                        var x = keyData.slice(1, elementSize + 1), y = keyData.slice(elementSize + 1);
                        if (cryptoECC.validatePoint(curveName, x, y) === false) {
                            throw new Error("DataError");
                        }
                        return {
                            type: "keyImport",
                            keyData: {
                                x: x,
                                y: y
                            },
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable || false,
                                usages: p.usages,
                                type: "public"
                            }
                        };
                    }
                    if (p.format === "jwk") {
                        var keyObject = msrcryptoJwk.jwkToKey(p.keyData, p.algorithm, ["x", "y", "d", "crv"]);
                        if (keyObject.d && (!keyObject.x || !keyObject.y)) {
                            var curve = cryptoECC.createCurve(p.algorithm.namedCurve.toUpperCase());
                            ecdhInstance = msrcryptoEcdh(curve);
                            var publicKey = ecdhInstance.computePublicKey(keyObject.d);
                            keyObject.x = publicKey.x;
                            keyObject.y = publicKey.y;
                        }
                        if (cryptoECC.validatePoint(p.algorithm.namedCurve.toUpperCase(), keyObject.x, keyObject.y) === false) {
                            throw new Error("DataError");
                        }
                        return {
                            type: "keyImport",
                            keyData: keyObject,
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable || keyObject.extractable,
                                usages: p.usages,
                                type: keyObject.d ? "private" : "public"
                            }
                        };
                    }
                    if (p.format === "spki") {
                        var lengths = {
                            "P-256": 32,
                            "P-384": 48,
                            "P-521": 66
                        };
                        var partLen = lengths[p.algorithm.namedCurve];
                        var privateKeyInfo = asn1.parse(p.keyData);
                        if (privateKeyInfo == null) {
                            throw new Error("invalid key data.");
                        }
                        var bitString = privateKeyInfo[1];
                        var keySequence = bitString.data.slice(bitString.header + 1);
                        if (keySequence == null || keySequence.shift() !== 4 || keySequence.length !== partLen * 2) {
                            throw new Error("invalid key data.");
                        }
                        var x = keySequence.slice(0, partLen), y = keySequence.slice(partLen);
                        if (!msrcryptoUtilities.isBytes(x) || !msrcryptoUtilities.isBytes(y)) {
                            throw new Error("invalid key data.");
                        }
                        var keyObject = {
                            x: x,
                            y: y
                        };
                        if (cryptoECC.validatePoint(p.algorithm.namedCurve.toUpperCase(), keyObject.x, keyObject.y) === false) {
                            throw new Error("DataError");
                        }
                        return {
                            type: "keyImport",
                            keyData: keyObject,
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: p.usages,
                                type: "public"
                            }
                        };
                    }
                    if (p.format === "pkcs8") {
                        var lengths = {
                            "P-256": 32,
                            "P-384": 48,
                            "P-521": 66
                        };
                        var partLen = lengths[p.algorithm.namedCurve];
                        var privateKeyInfo = asn1.parse(p.keyData);
                        if (privateKeyInfo == null) {
                            throw new Error("invalid key data.");
                        }
                        var octetString = privateKeyInfo[2];
                        var keySequence = asn1.parse(octetString.data.slice(octetString.header));
                        if (keySequence == null) {
                            throw new Error("invalid key data.");
                        }
                        var d = keySequence[1].data.slice(keySequence[1].header);
                        var bitString = asn1.parse(keySequence[2][0].data);
                        var keySequence = bitString.data.slice(bitString.header + 1);
                        if (keySequence == null || keySequence.shift() !== 4 || keySequence.length !== partLen * 2) {
                            throw new Error("invalid key data.");
                        }
                        var x = keySequence.slice(0, partLen), y = keySequence.slice(partLen);
                        if (!msrcryptoUtilities.isBytes(x) || !msrcryptoUtilities.isBytes(y)) {
                            throw new Error("invalid key data.");
                        }
                        var keyObject = {
                            x: x,
                            y: y,
                            d: d
                        };
                        if (cryptoECC.validatePoint(p.algorithm.namedCurve.toUpperCase(), keyObject.x, keyObject.y) === false) {
                            throw new Error("DataError");
                        }
                        return {
                            type: "keyImport",
                            keyData: keyObject,
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: p.usages,
                                type: "private"
                            }
                        };
                    }
                }
                catch (err) {
                    throw new msrcryptoUtilities.error("DataError", "");
                }
            };
            msrcryptoEcdh.exportKey = function (p) {
                var EC_PUBLICKEY = "1.2.840.10045.2.1";
                var curveOid = {
                    "P-256": "1.2.840.10045.3.1.7 ",
                    "P-384": "1.3.132.0.34",
                    "P-521": "1.3.132.0.35"
                };
                if (p.format === "raw" && p.keyHandle.type === "public") {
                    var keyData = [4].concat(p.keyData.x, p.keyData.y);
                    return {
                        type: "keyExport",
                        keyHandle: keyData
                    };
                }
                if (p.format === "jwk") {
                    var jsonKeyStringArray = msrcryptoJwk.keyToJwk(p.keyHandle, p.keyData);
                    return {
                        type: "keyExport",
                        keyHandle: jsonKeyStringArray
                    };
                }
                if (p.format === "spki") {
                    var bytes = asn1.encode({
                        SEQUENCE: [{
                                SEQUENCE: [{
                                        "OBJECT IDENTIFIER": EC_PUBLICKEY
                                    },
                                    {
                                        "OBJECT IDENTIFIER": curveOid[p.algorithm.namedCurve]
                                    }
                                ]
                            },
                            {
                                "BIT STRING": [4].concat(p.keyData.x, p.keyData.y)
                            }
                        ]
                    });
                    return {
                        type: "keyExport",
                        keyHandle: bytes
                    };
                }
                if (p.format === "pkcs8") {
                    var bytes = asn1.encode({
                        SEQUENCE: [{
                                INTEGER: 0
                            },
                            {
                                SEQUENCE: [{
                                        "OBJECT IDENTIFIER": EC_PUBLICKEY
                                    },
                                    {
                                        "OBJECT IDENTIFIER": curveOid[p.algorithm.namedCurve]
                                    }
                                ]
                            },
                            {
                                "OCTET STRING": {
                                    SEQUENCE: [{
                                            INTEGER: 1
                                        },
                                        {
                                            "OCTET STRING": p.keyData.d
                                        },
                                        {
                                            APPLICATION: [{
                                                    "BIT STRING": [4].concat(p.keyData.x, p.keyData.y)
                                                }],
                                            tag: 1
                                        }
                                    ]
                                }
                            }
                        ]
                    });
                    return {
                        type: "keyExport",
                        keyHandle: bytes
                    };
                }
                throw new Error("unsupported export format.");
            };
            operations.register("importKey", "ECDH", msrcryptoEcdh.importKey);
            operations.register("exportKey", "ECDH", msrcryptoEcdh.exportKey);
            operations.register("generateKey", "ECDH", msrcryptoEcdh.generateKey);
            operations.register("deriveBits", "ECDH", msrcryptoEcdh.deriveBits);
            operations.register("deriveKey", "ECDH", msrcryptoEcdh.deriveKey);
        }
        var msrcryptoEcdsa = function (curve) {
            var btd = cryptoMath.bytesToDigits, dtb = cryptoMath.digitsToBytes, ecop = new cryptoECC.EllipticCurveOperatorFp(curve), orderByteLength = dtb(curve.order).length, tedCurve = curve.type === 1;
            function createKey(privateKeyBytes) {
                return createKeyInternal(btd(privateKeyBytes));
            }
            function createKeyInternal(privateKeyDigits) {
                var publicKey = curve.allocatePointStorage();
                ecop.scalarMultiply(privateKeyDigits, curve.generator, publicKey);
                return {
                    publicKey: publicKey,
                    privateKey: privateKeyDigits
                };
            }
            function generateKey(randomBytes) {
                var privateKey = [];
                if (!randomBytes) {
                    randomBytes = msrcryptoPseudoRandom.getBytes(curve.order.length * cryptoMath.DIGIT_NUM_BYTES);
                }
                cryptoMath.reduce(cryptoMath.bytesToDigits(randomBytes), curve.order, privateKey);
                return createKeyInternal(privateKey);
            }
            function getDigest(messageBytes) {
                if (messageBytes.length > orderByteLength) {
                    messageBytes.length = orderByteLength;
                }
                var digest = btd(messageBytes);
                if (tedCurve) {
                    var shift = 8 - curve.rbits % 8;
                    cryptoMath.shiftRight(digest, digest, shift);
                }
                cryptoMath.reduce(digest, curve.order, digest);
                return digest;
            }
            function sign(privateKey, messageBytes, ephemeralKey) {
                if (!ephemeralKey) {
                    ephemeralKey = generateKey();
                }
                var r = ephemeralKey.publicKey.x, k = ephemeralKey.privateKey, d = btd(privateKey.d), digest = getDigest(messageBytes.slice()), s = [], tmp = [], signature = null;
                cryptoMath.reduce(r, curve.order, r);
                cryptoMath.modMul(r, d, curve.order, s);
                cryptoMath.add(s, digest, s);
                cryptoMath.reduce(s, curve.order, s);
                cryptoMath.modInvCT(k, curve.order, tmp);
                cryptoMath.modMul(s, tmp, curve.order, s);
                var rBytes = msrcryptoUtilities.padFront(dtb(r, true, orderByteLength), 0, orderByteLength);
                var sBytes = msrcryptoUtilities.padFront(dtb(s, true, orderByteLength), 0, orderByteLength);
                signature = rBytes.concat(sBytes);
                return signature;
            }
            function verify(publicKey, signatureBytes, messageBytes) {
                var split = Math.floor(signatureBytes.length / 2), r = btd(signatureBytes.slice(0, split)), s = btd(signatureBytes.slice(split)), digest = getDigest(messageBytes.slice()), u1 = [], u2 = [];
                var publicPoint = new cryptoECC.EllipticCurvePointFp(curve, false, btd(publicKey.x), btd(publicKey.y), null, false);
                cryptoMath.modInv(s, curve.order, s);
                cryptoMath.modMul(digest, s, curve.order, u1);
                cryptoMath.modMul(r, s, curve.order, u2);
                var r0 = curve.allocatePointStorage();
                var r1 = curve.allocatePointStorage();
                if (tedCurve) {
                    cryptoMath.add(u1, u1, u1);
                    cryptoMath.add(u1, u1, u1);
                    cryptoMath.reduce(u1, curve.order, u1);
                    ecop.scalarMultiply(u1, curve.generator, r0, false);
                    ecop.scalarMultiply(u2, publicPoint, r1, false);
                    ecop.convertToExtendedProjective(r0);
                    ecop.convertToExtendedProjective(r1);
                    ecop.add(r1, r0, r0);
                    ecop.normalize(r0);
                }
                else {
                    ecop.scalarMultiply(u1, curve.generator, r0);
                    ecop.scalarMultiply(u2, publicPoint, r1);
                    ecop.convertToJacobianForm(r0);
                    ecop.convertToMontgomeryForm(r0);
                    ecop.convertToMontgomeryForm(r1);
                    ecop.mixedAdd(r0, r1, r0);
                    ecop.convertToAffineForm(r0);
                    ecop.convertToStandardForm(r0);
                }
                if (r0.isInfinity) {
                    return false;
                }
                cryptoMath.reduce(r0.x, curve.order, r0.x);
                return cryptoMath.compareDigits(r0.x, r) === 0;
            }
            return {
                createKey: createKey,
                generateKey: generateKey,
                sign: sign,
                verify: verify
            };
        };
        if (typeof operations !== "undefined") {
            msrcryptoEcdsa.sign = function (p) {
                msrcryptoUtilities.checkParam(p.algorithm.hash, "Object", "algorithm.hash");
                msrcryptoUtilities.checkParam(p.algorithm.hash.name, "String", "algorithm.hash.name");
                msrcryptoUtilities.checkParam(p.keyHandle.algorithm.namedCurve, "String", "p.keyHandle.algorithm.namedCurve");
                var hashName = p.algorithm.hash.name, curve = cryptoECC.createCurve(p.keyHandle.algorithm.namedCurve.toUpperCase()), hashFunc = msrcryptoHashFunctions[hashName.toUpperCase()](), digest = hashFunc.computeHash(p.buffer);
                var ecdsa = msrcryptoEcdsa(curve);
                return ecdsa.sign(p.keyData, digest);
            };
            msrcryptoEcdsa.verify = function (p) {
                var hashName = p.algorithm.hash.name, curve = cryptoECC.createCurve(p.keyHandle.algorithm.namedCurve.toUpperCase()), hashFunc = msrcryptoHashFunctions[hashName.toUpperCase()](), digest = hashFunc.computeHash(p.buffer);
                var ecdsa = msrcryptoEcdsa(curve);
                return ecdsa.verify(p.keyData, p.signature, digest);
            };
            msrcryptoEcdsa.generateKey = function (p) {
                var curve = cryptoECC.createCurve(p.algorithm.namedCurve.toUpperCase());
                var ecdsa = msrcryptoEcdsa(curve);
                var keyPairData = ecdsa.generateKey();
                var dtb = cryptoMath.digitsToBytes;
                function padTo8BytesIncrement(array) {
                    return array;
                }
                var x = padTo8BytesIncrement(dtb(keyPairData.publicKey.x));
                var y = padTo8BytesIncrement(dtb(keyPairData.publicKey.y));
                var d = padTo8BytesIncrement(dtb(keyPairData.privateKey));
                return {
                    type: "keyPairGeneration",
                    keyPair: {
                        publicKey: {
                            keyData: {
                                x: x,
                                y: y
                            },
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: ["verify"],
                                type: "public"
                            }
                        },
                        privateKey: {
                            keyData: {
                                x: x,
                                y: y,
                                d: d
                            },
                            keyHandle: {
                                algorithm: p.algorithm,
                                extractable: p.extractable,
                                usages: ["sign"],
                                type: "private"
                            }
                        }
                    }
                };
            };
            msrcryptoEcdsa.importKey = function (p) {
                if (p.format === "raw") {
                    var keyData = p.keyData;
                    if (keyData[0] !== 4) {
                        throw new Error("DataError");
                    }
                    var elementSize = ~~((keyData.length - 1) / 2);
                    var curveName = p.algorithm.namedCurve.toUpperCase();
                    var x = keyData.slice(1, elementSize + 1), y = keyData.slice(elementSize + 1);
                    if (cryptoECC.validatePoint(curveName, x, y) === false) {
                        throw new Error("DataError");
                    }
                    return {
                        type: "keyImport",
                        keyData: {
                            x: x,
                            y: y
                        },
                        keyHandle: {
                            algorithm: p.algorithm,
                            extractable: p.extractable,
                            usages: p.usages,
                            type: "public"
                        }
                    };
                }
                if (p.format === "jwk") {
                    var keyObject = msrcryptoJwk.jwkToKey(p.keyData, p.algorithm, ["x", "y", "d", "crv"]);
                    if (keyObject.d && (!keyObject.x || !keyObject.y)) {
                        var curve = msrcryptoEcdsa.curves[p.algorithm.namedCurve]();
                        var ecdsa = msrcryptoEcdsa(curve);
                        var publicKey = ecdsa.computePublicKey(keyObject.d);
                        keyObject.x = publicKey.x;
                        keyObject.y = publicKey.y;
                    }
                    if (cryptoECC.validatePoint(p.algorithm.namedCurve.toUpperCase(), keyObject.x, keyObject.y) === false) {
                        throw new Error("DataError");
                    }
                    return {
                        type: "keyImport",
                        keyData: keyObject,
                        keyHandle: {
                            algorithm: p.algorithm,
                            extractable: p.extractable || keyObject.extractable,
                            usages: null || p.usages,
                            type: keyObject.d ? "private" : "public"
                        }
                    };
                }
                if (p.format === "spki") {
                    var lengths = {
                        "P-256": 32,
                        "P-384": 48,
                        "P-521": 66
                    };
                    var partLen = lengths[p.algorithm.namedCurve];
                    var privateKeyInfo = asn1.parse(p.keyData);
                    if (privateKeyInfo == null) {
                        throw new Error("invalid key data.");
                    }
                    var bitString = privateKeyInfo[1];
                    var keySequence = bitString.data.slice(bitString.header + 1);
                    if (keySequence == null || keySequence.shift() !== 4 || keySequence.length !== partLen * 2) {
                        throw new Error("invalid key data.");
                    }
                    var x = keySequence.slice(0, partLen), y = keySequence.slice(partLen);
                    if (!msrcryptoUtilities.isBytes(x) || !msrcryptoUtilities.isBytes(y)) {
                        throw new Error("invalid key data.");
                    }
                    var keyObject = {
                        x: x,
                        y: y
                    };
                    if (cryptoECC.validatePoint(p.algorithm.namedCurve.toUpperCase(), keyObject.x, keyObject.y) === false) {
                        throw new Error("DataError");
                    }
                    return {
                        type: "keyImport",
                        keyData: keyObject,
                        keyHandle: {
                            algorithm: p.algorithm,
                            extractable: p.extractable,
                            usages: p.usages,
                            type: "public"
                        }
                    };
                }
                if (p.format === "pkcs8") {
                    var lengths = {
                        "P-256": 32,
                        "P-384": 48,
                        "P-521": 66
                    };
                    var partLen = lengths[p.algorithm.namedCurve];
                    var privateKeyInfo = asn1.parse(p.keyData);
                    if (privateKeyInfo == null) {
                        throw new Error("invalid key data.");
                    }
                    var octetString = privateKeyInfo[2];
                    var keySequence = asn1.parse(octetString.data.slice(octetString.header));
                    if (keySequence == null) {
                        throw new Error("invalid key data.");
                    }
                    var d = keySequence[1].data.slice(keySequence[1].header);
                    var bitString = asn1.parse(keySequence[2][0].data);
                    var keySequence = bitString.data.slice(bitString.header + 1);
                    if (keySequence == null || keySequence.shift() !== 4 || keySequence.length !== partLen * 2) {
                        throw new Error("invalid key data.");
                    }
                    var x = keySequence.slice(0, partLen), y = keySequence.slice(partLen);
                    if (!msrcryptoUtilities.isBytes(x) || !msrcryptoUtilities.isBytes(y)) {
                        throw new Error("invalid key data.");
                    }
                    var keyObject = {
                        x: x,
                        y: y,
                        d: d
                    };
                    if (cryptoECC.validatePoint(p.algorithm.namedCurve.toUpperCase(), keyObject.x, keyObject.y) === false) {
                        throw new Error("DataError");
                    }
                    return {
                        type: "keyImport",
                        keyData: keyObject,
                        keyHandle: {
                            algorithm: p.algorithm,
                            extractable: p.extractable,
                            usages: p.usages,
                            type: "private"
                        }
                    };
                }
            };
            msrcryptoEcdsa.exportKey = function (p) {
                var EC_PUBLICKEY = "1.2.840.10045.2.1";
                var curveOid = {
                    "P-256": "1.2.840.10045.3.1.7 ",
                    "P-384": "1.3.132.0.34",
                    "P-521": "1.3.132.0.35"
                };
                if (p.format === "raw" && p.keyHandle.type === "public") {
                    var keyData = [4].concat(p.keyData.x, p.keyData.y);
                    return {
                        type: "keyExport",
                        keyHandle: keyData
                    };
                }
                if (p.format === "jwk") {
                    var jsonKeyStringArray = msrcryptoJwk.keyToJwk(p.keyHandle, p.keyData);
                    return {
                        type: "keyExport",
                        keyHandle: jsonKeyStringArray
                    };
                }
                if (p.format === "spki") {
                    var bytes = asn1.encode({
                        SEQUENCE: [{
                                SEQUENCE: [{
                                        "OBJECT IDENTIFIER": EC_PUBLICKEY
                                    },
                                    {
                                        "OBJECT IDENTIFIER": curveOid[p.algorithm.namedCurve]
                                    }
                                ]
                            },
                            {
                                "BIT STRING": [4].concat(p.keyData.x, p.keyData.y)
                            }
                        ]
                    });
                    return {
                        type: "keyExport",
                        keyHandle: bytes
                    };
                }
                if (p.format === "pkcs8") {
                    var bytes = asn1.encode({
                        SEQUENCE: [{
                                INTEGER: 0
                            },
                            {
                                SEQUENCE: [{
                                        "OBJECT IDENTIFIER": EC_PUBLICKEY
                                    },
                                    {
                                        "OBJECT IDENTIFIER": curveOid[p.algorithm.namedCurve]
                                    }
                                ]
                            },
                            {
                                "OCTET STRING": {
                                    SEQUENCE: [{
                                            INTEGER: 1
                                        },
                                        {
                                            "OCTET STRING": p.keyData.d
                                        },
                                        {
                                            APPLICATION: [{
                                                    "BIT STRING": [4].concat(p.keyData.x, p.keyData.y)
                                                }],
                                            tag: 1
                                        }
                                    ]
                                }
                            }
                        ]
                    });
                    return {
                        type: "keyExport",
                        keyHandle: bytes
                    };
                }
                throw new Error("unsupported export format.");
            };
            operations.register("sign", "ECDSA", msrcryptoEcdsa.sign);
            operations.register("verify", "ECDSA", msrcryptoEcdsa.verify);
            operations.register("generateKey", "ECDSA", msrcryptoEcdsa.generateKey);
            operations.register("importKey", "ECDSA", msrcryptoEcdsa.importKey);
            operations.register("exportKey", "ECDSA", msrcryptoEcdsa.exportKey);
        }
        var msrcryptoSubtle;
        var utils = msrcryptoUtilities;
        msrcryptoSubtle = (function () {
            function syncWorker() {
                var result;
                function postMessage(data) {
                    try {
                        data.workerid = this.id;
                        result = msrcryptoWorker.jsCryptoRunner({
                            data: data
                        });
                    }
                    catch (ex) {
                        this.onerror({
                            data: ex,
                            type: "error"
                        });
                        return;
                    }
                    this.onmessage({
                        data: result
                    });
                }
                return {
                    postMessage: postMessage,
                    onmessage: null,
                    onerror: null,
                    terminate: function () { }
                };
            }
            var streamObject = function (op) {
                return {
                    process: function (buffer) {
                        return op.process(buffer);
                    },
                    finish: function () {
                        return op.finish();
                    },
                    abort: function () {
                        return op.abort();
                    }
                };
            };
            function baseOperation(processResults) {
                var result = null, oncompleteCallback = null, onerrorCallback = null, retObj, promise, resolveFunc, rejectFunc;
                promise = new Promise(function (resolve, reject) {
                    resolveFunc = resolve;
                    rejectFunc = reject;
                });
                function opDispatchEvent(e) {
                    if (e.type === "error") {
                        if (rejectFunc) {
                            e.data && (e.data.stack = "Error") && (e.data.code = 0);
                            rejectFunc.apply(promise, [e.data || e]);
                        }
                        return;
                    }
                    if (e.data.type === "process") {
                        processResults(e.data.result, true);
                        return;
                    }
                    if (e.data.type === "finish") {
                        processResults(e.data.result, true);
                        return;
                    }
                    this.result = processResults(e.data);
                    resolveFunc.apply(promise, [this.result]);
                    return;
                }
                retObj = {
                    dispatchEvent: opDispatchEvent,
                    promise: promise,
                    result: null
                };
                return retObj;
            }
            function keyOperation() {
                function processResult(result) {
                    var publicKey, privateKey;
                    switch (result.type) {
                        case "keyGeneration":
                        case "keyImport":
                        case "keyDerive":
                            if (result.keyPair) {
                                keys.add(result.keyPair.publicKey.keyHandle, result.keyPair.publicKey.keyData);
                                keys.add(result.keyPair.privateKey.keyHandle, result.keyPair.privateKey.keyData);
                                return {
                                    publicKey: result.keyPair.publicKey.keyHandle,
                                    privateKey: result.keyPair.privateKey.keyHandle
                                };
                            }
                            else {
                                keys.add(result.keyHandle, result.keyData);
                                return result.keyHandle;
                            }
                        case "keyExport":
                            return result.keyHandle;
                        case "keyPairGeneration":
                            privateKey = result.keyPair.privateKey;
                            publicKey = result.keyPair.publicKey;
                            keys.add(publicKey.keyHandle, publicKey.keyData);
                            keys.add(privateKey.keyHandle, privateKey.keyData);
                            return {
                                publicKey: publicKey.keyHandle,
                                privateKey: privateKey.keyHandle
                            };
                        default:
                            throw new Error("Unknown key operation");
                    }
                }
                return baseOperation(processResult);
            }
            function toArrayBufferIfSupported(dataArray) {
                if (typedArraySupport && dataArray.pop) {
                    return (new Uint8Array(dataArray)).buffer;
                }
                return dataArray;
            }
            function cryptoOperation(cryptoContext) {
                function processResult(result, isProcessCall) {
                    result = result && toArrayBufferIfSupported(result);
                    if (isProcessCall) {
                        promiseQueue.resolve(result);
                        return;
                    }
                    return result;
                }
                var promiseQueue = [], op = baseOperation(processResult);
                op.stream = cryptoContext.algorithm.stream;
                promiseQueue.add = function (label) {
                    var resolveFunc, rejectFunc, promise = new Promise(function (resolve, reject) {
                        resolveFunc = resolve;
                        rejectFunc = reject;
                    });
                    promise.label = label;
                    promiseQueue.push({
                        resolve: resolveFunc,
                        reject: rejectFunc,
                        promise: promise
                    });
                    return promise;
                };
                promiseQueue.resolve = function (result) {
                    var queueItem = promiseQueue.shift();
                    queueItem.resolve.apply(queueItem.promise, [result]);
                };
                op.process = function (buffer) {
                    cryptoContext.operationSubType = "process";
                    cryptoContext.buffer = utils.toArray(buffer);
                    workerManager.continueJob(this, utils.clone(cryptoContext));
                    return promiseQueue.add("process");
                };
                op.finish = function () {
                    cryptoContext.operationSubType = "finish";
                    cryptoContext.buffer = [];
                    workerManager.continueJob(this, utils.clone(cryptoContext));
                    return promiseQueue.add("finish");
                };
                op.abort = function () {
                    workerManager.abortJob(this);
                };
                op.algorithm = cryptoContext.algorithm || null;
                op.key = cryptoContext.keyHandle || null;
                return op;
            }
            var keys = [];
            keys.add = function (keyHandle, keyData) {
                keys.push({
                    keyHandle: keyHandle,
                    keyData: keyData
                });
            };
            keys.remove = function (keyHandle) {
                for (var i = 0; i < keys.length; i += 1) {
                    if (keys[i].keyHandle === keyHandle) {
                        keys = keys.splice(i, 1);
                        return;
                    }
                }
            };
            keys.lookup = function (keyHandle) {
                for (var i = 0; i < keys.length; i += 1) {
                    if (keys[i].keyHandle === keyHandle) {
                        return keys[i].keyData;
                    }
                }
                return null;
            };
            var workerManager = (function () {
                var maxWorkers = 12;
                var maxFreeWorkers = 2;
                var workerPool = [];
                var jobQueue = [];
                var jobId = 0;
                var workerId = 0;
                var callbackQueue = [];
                var setFunction = typeof setImmediate === "undefined" ? setTimeout : setImmediate;
                function executeNextCallback() {
                    callbackQueue.shift()();
                }
                function queueCallback(callback) {
                    callbackQueue.push(callback);
                    setFunction(executeNextCallback, 0);
                }
                var workerStatus = webWorkerSupport ? "available" : "unavailable";
                function getFreeWorker() {
                    purgeWorkerType(!asyncMode);
                    for (var i = 0; i < workerPool.length; i++) {
                        if (!workerPool[i].busy) {
                            return workerPool[i];
                        }
                    }
                    return null;
                }
                function purgeWorkerType(webWorker) {
                    for (var i = workerPool.length - 1; i >= 0; i -= 1) {
                        if (workerPool[i].isWebWorker === webWorker) {
                            workerPool[i].terminate();
                            workerPool.splice(i, 1);
                        }
                    }
                }
                function freeWorkerCount() {
                    var freeWorkers = 0;
                    for (var i = 0; i < workerPool.length; i++) {
                        if (!workerPool[i].busy) {
                            freeWorkers += 1;
                        }
                    }
                    return freeWorkers;
                }
                function addWorkerToPool(worker) {
                    workerPool.push(worker);
                }
                function removeWorkerFromPool(worker) {
                    for (var i = 0; i < workerPool.length; i++) {
                        if (workerPool[i] === worker) {
                            worker.terminate();
                            workerPool.splice(i, 1);
                            return;
                        }
                    }
                }
                function lookupWorkerByOperation(operation) {
                    for (var i = 0; i < workerPool.length; i++) {
                        if (workerPool[i].operation === operation) {
                            return workerPool[i];
                        }
                    }
                    return null;
                }
                function queueJob(operation, data) {
                    jobQueue.push({
                        operation: operation,
                        data: data,
                        id: jobId++
                    });
                }
                function jobCompleted(worker) {
                    worker.busy = false;
                    if (asyncMode) {
                        if (jobQueue.length > 0) {
                            var job = jobQueue.shift(), i;
                            continueJob(job.operation, job.data);
                            if (job.data.operationSubType === "process") {
                                for (i = 0; i < jobQueue.length; i++) {
                                    if (job.operation === jobQueue[i].operation) {
                                        continueJob(jobQueue[i].operation, jobQueue[i].data);
                                    }
                                }
                                for (i = jobQueue.length - 1; i >= 0; i--) {
                                    if (job.operation === jobQueue[i].operation) {
                                        jobQueue.splice(i, 1);
                                    }
                                }
                            }
                        }
                        else if (freeWorkerCount() > maxFreeWorkers) {
                            removeWorkerFromPool(worker);
                        }
                    }
                }
                function createNewWorker(operation) {
                    var worker;
                    if (workerStatus === "pending") {
                        throw new Error("Creating new worker while workerstatus=pending");
                    }
                    if (workerStatus === "ready") {
                        try {
                            worker = new Worker(scriptUrl);
                            worker.postMessage({
                                prngSeed: msrcryptoPseudoRandom.getBytes(48)
                            });
                            worker.isWebWorker = true;
                        }
                        catch (ex) {
                            asyncMode = false;
                            workerStatus = "failed";
                            worker.terminate();
                            worker = syncWorker();
                            worker.isWebWorker = false;
                        }
                    }
                    else {
                        worker = syncWorker();
                        worker.isWebWorker = false;
                    }
                    worker.operation = operation;
                    worker.id = workerId++;
                    worker.busy = false;
                    worker.onmessage = function (e) {
                        if (e.data.initialized === true) {
                            return;
                        }
                        var op = worker.operation;
                        e.target || (e.target = {
                            data: worker.data
                        });
                        for (var i = 0; i < jobQueue.length; i++) {
                            if (jobQueue[i].operation === worker.operation) {
                                var job = jobQueue[i];
                                jobQueue.splice(i, 1);
                                postMessageToWorker(worker, job.data);
                                return;
                            }
                        }
                        if (!(e.data.hasOwnProperty("type") && e.data.type === "process")) {
                            jobCompleted(worker);
                        }
                        op.dispatchEvent(e);
                    };
                    worker.onerror = function (e) {
                        var op = worker.operation;
                        jobCompleted(worker);
                        op.dispatchEvent(e);
                    };
                    addWorkerToPool(worker);
                    return worker;
                }
                function useWebWorkers(enable) {
                    if (workerStatus === "unavailable") {
                        utils.consoleLog("web workers not available in this browser.");
                        return;
                    }
                    if (enable === true && workerStatus === "ready") {
                        return;
                    }
                    if (enable === false && workerStatus === "available") {
                        return;
                    }
                    if (enable === false && workerStatus === "ready") {
                        asyncMode = false;
                        workerStatus = "available";
                        utils.consoleLog("web workers disabled.");
                        return;
                    }
                    if (workerStatus === "pending") {
                        return;
                    }
                    workerStatus = "pending";
                    var worker = new Worker(scriptUrl);
                    function setWorkerStatus(e) {
                        var succeeded = !!(e.data && e.data.initialized === true);
                        worker.removeEventListener("message", setWorkerStatus, false);
                        worker.removeEventListener("error", setWorkerStatus, false);
                        worker.terminate();
                        workerStatus = succeeded ? "ready" : "failed";
                        asyncMode = succeeded;
                        utils.consoleLog("web worker initialization " + (succeeded ? "succeeded. Now using web workers." :
                            "failed. running synchronously." + (e.message || "")));
                        if (jobQueue.length > 0) {
                            var job = jobQueue.shift();
                            runJob(job.operation, job.data);
                        }
                        return;
                    }
                    worker.addEventListener("message", setWorkerStatus, false);
                    worker.addEventListener("error", setWorkerStatus, false);
                    worker.postMessage({
                        prngSeed: msrcryptoPseudoRandom.getBytes(48)
                    });
                    return;
                }
                function abortJob(cryptoOperationObject) {
                    var worker = lookupWorkerByOperation(cryptoOperationObject);
                    if (worker) {
                        removeWorkerFromPool(worker);
                    }
                }
                function runJob(operation, data) {
                    var worker = null;
                    if (workerStatus === "pending") {
                        queueJob(operation, data);
                        return;
                    }
                    worker = getFreeWorker();
                    if (asyncMode && worker === null && workerPool.length >= maxWorkers) {
                        queueJob(operation, data);
                        return;
                    }
                    if (worker === null) {
                        worker = createNewWorker(operation);
                    }
                    if (worker === null) {
                        queueJob(operation, data);
                        throw new Error("could not create new worker");
                    }
                    worker.operation = operation;
                    worker.busy = true;
                    data.workerid = worker.id;
                    postMessageToWorker(worker, data);
                }
                function continueJob(operation, data) {
                    var worker = lookupWorkerByOperation(operation);
                    if (worker) {
                        postMessageToWorker(worker, data);
                        return;
                    }
                    runJob(operation, data);
                }
                function postMessageToWorker(worker, data) {
                    data.workerid = worker.id;
                    if (asyncMode) {
                        worker.postMessage(data);
                    }
                    else {
                        var func = (function (postData) {
                            return function () {
                                return worker.postMessage(postData);
                            };
                        })(data);
                        queueCallback(func);
                    }
                    return;
                }
                return {
                    runJob: runJob,
                    continueJob: continueJob,
                    abortJob: abortJob,
                    useWebWorkers: useWebWorkers
                };
            })();
            function checkOperation(operationType, algorithmName) {
                if (!operations.exists(operationType, algorithmName)) {
                    throw new Error("unsupported algorithm");
                }
            }
            var subtleParameters = [{
                    name: "algorithm",
                    type: "Object",
                    required: true
                },
                {
                    name: "keyHandle",
                    type: "Object",
                    required: true
                },
                {
                    name: "buffer",
                    type: "Array",
                    required: false
                },
                {
                    name: "signature",
                    type: "Array",
                    required: true
                },
                {
                    name: "format",
                    type: "String",
                    required: true
                },
                {
                    name: "keyData",
                    type: "Object",
                    required: true
                },
                {
                    name: "extractable",
                    type: "Boolean",
                    required: false
                },
                {
                    name: "usages",
                    type: "Array",
                    required: false
                },
                {
                    name: "derivedKeyType",
                    type: "Object",
                    required: true
                },
                {
                    name: "length",
                    type: "Number",
                    required: false
                },
                {
                    name: "extractable",
                    type: "Boolean",
                    required: true
                },
                {
                    name: "usages",
                    type: "Array",
                    required: true
                },
                {
                    name: "keyData",
                    type: "Array",
                    required: true
                }
            ];
            var subtleParametersSets = {
                encrypt: [0, 1, 2],
                decrypt: [0, 1, 2],
                sign: [0, 1, 2],
                verify: [0, 1, 3, 2],
                digest: [0, 2],
                generateKey: [0, 6, 7],
                importKeyRaw: [4, 12, 0, 10, 11],
                importKeyJwk: [4, 5, 0, 10, 11],
                exportKey: [0, 4, 1, 6, 7],
                deriveKey: [0, 1, 8, 6, 7],
                deriveBits: [0, 1, 9],
                wrapKey: [1, 1, 0],
                unwrapKey: [2, 0, 1, 6, 7]
            };
            function lookupKeyData(handle) {
                var data = keys.lookup(handle);
                if (!data) {
                    throw new Error("key not found");
                }
                return data;
            }
            function buildParameterCollection(operationName, parameterSet) {
                var parameterCollection = {
                    operationType: operationName
                }, operationParameterSet, expectedParam, actualParam, i;
                if (operationName === "importKey" && (parameterSet[0] === "raw" || parameterSet[0] === "spki" || parameterSet[0] === "pkcs8")) {
                    operationName = "importKeyRaw";
                }
                if (operationName === "importKey" && parameterSet[0] === "jwk") {
                    operationName = "importKeyJwk";
                }
                operationParameterSet = subtleParametersSets[operationName];
                for (i = 0; i < operationParameterSet.length; i += 1) {
                    expectedParam = subtleParameters[operationParameterSet[i]];
                    actualParam = parameterSet[i];
                    if (actualParam == null) {
                        if (expectedParam.required) {
                            throw new Error(expectedParam.name);
                        }
                        else {
                            continue;
                        }
                    }
                    if (actualParam.subarray) {
                        actualParam = utils.toArray(actualParam);
                    }
                    if (utils.getObjectType(actualParam) === "ArrayBuffer") {
                        actualParam = utils.toArray(actualParam);
                    }
                    if (msrcryptoUtilities.getObjectType(actualParam) !== expectedParam.type) {
                        throw new Error(expectedParam.name);
                    }
                    if (expectedParam.name === "algorithm") {
                        actualParam.name = actualParam.name.toUpperCase();
                        if (actualParam.iv) {
                            actualParam.iv = utils.toArray(actualParam.iv);
                        }
                        if (actualParam.publicExponent) {
                            actualParam.publicExponent = utils.toArray(actualParam.publicExponent);
                        }
                        if (actualParam.salt) {
                            actualParam.salt = utils.toArray(actualParam.salt);
                        }
                        if (actualParam.additionalData) {
                            actualParam.additionalData = utils.toArray(actualParam.additionalData);
                        }
                        if (actualParam.hash && !actualParam.hash.name && utils.getObjectType(actualParam.hash) === "String") {
                            actualParam.hash = {
                                name: actualParam.hash
                            };
                        }
                    }
                    if (parameterCollection.hasOwnProperty(expectedParam.name)) {
                        parameterCollection[expectedParam.name + "1"] = actualParam;
                    }
                    else {
                        parameterCollection[expectedParam.name] = actualParam;
                    }
                }
                return parameterCollection;
            }
            function executeOperation(operationName, parameterSet, keyFunc) {
                var pc = buildParameterCollection(operationName, parameterSet);
                checkOperation(operationName, pc.algorithm.name);
                if (pc.keyHandle) {
                    pc.keyData = lookupKeyData(pc.keyHandle);
                }
                if (pc.keyHandle1) {
                    pc.keyData1 = lookupKeyData(pc.keyHandle1);
                }
                if (pc.algorithm && pc.algorithm.public) {
                    pc.additionalKeyData = lookupKeyData(pc.algorithm.public);
                }
                var op = keyFunc ? keyOperation(pc) : cryptoOperation(pc);
                if (keyFunc || pc.buffer || operationName === "deriveBits" || operationName === "wrapKey") {
                    workerManager.runJob(op, pc);
                }
                if (op.stream) {
                    return Promise.resolve(streamObject(op));
                }
                return op.promise;
            }
            var publicMethods = {
                encrypt: function (algorithm, keyHandle, buffer) {
                    return executeOperation("encrypt", arguments, 0);
                },
                decrypt: function (algorithm, keyHandle, buffer) {
                    return executeOperation("decrypt", arguments, 0);
                },
                sign: function (algorithm, keyHandle, buffer) {
                    return executeOperation("sign", arguments, 0);
                },
                verify: function (algorithm, keyHandle, signature, buffer) {
                    return executeOperation("verify", arguments, 0);
                },
                digest: function (algorithm, buffer) {
                    return executeOperation("digest", arguments, 0);
                },
                generateKey: function (algorithm, extractable, keyUsage) {
                    return executeOperation("generateKey", arguments, 1);
                },
                deriveKey: function (algorithm, baseKey, derivedKeyType, extractable, keyUsage) {
                    var deriveBits = this.deriveBits, importKey = this.importKey;
                    return new Promise(function (resolve, reject) {
                        var keyLength;
                        switch (derivedKeyType.name.toUpperCase()) {
                            case "AES-CBC":
                            case "AES-GCM":
                                keyLength = derivedKeyType.length;
                                break;
                            case "HMAC":
                                keyLength = derivedKeyType.length || {
                                    "SHA-1": 512,
                                    "SHA-224": 512,
                                    "SHA-256": 512,
                                    "SHA-384": 1024,
                                    "SHA-512": 1024
                                }[derivedKeyType.hash.name.toUpperCase()];
                                break;
                            default:
                                reject(new Error("No Supported"));
                                return;
                        }
                        deriveBits(algorithm, baseKey, keyLength)
                            .then(function (bits) {
                            return importKey("raw", bits, derivedKeyType, extractable, keyUsage);
                        })
                            .then(function (key) {
                            resolve(key);
                        })["catch"](function (err) {
                            reject(err);
                        });
                    });
                },
                deriveBits: function (algorithm, baseKey, length) {
                    return executeOperation("deriveBits", arguments, 0);
                },
                importKey: function (format, keyData, algorithm, extractable, keyUsage) {
                    return executeOperation("importKey", arguments, 1);
                },
                exportKey: function (format, keyHandle) {
                    return executeOperation("exportKey", [keyHandle.algorithm, format, keyHandle], 1);
                },
                wrapKey: function (format, key, wrappingKey, wrappingKeyAlgorithm) {
                    var encrypt = this.encrypt, exportKey = this.exportKey;
                    return new Promise(function (resolve, reject) {
                        if (key.extractable === false ||
                            wrappingKey.usages.indexOf("wrapKey") < 0 ||
                            wrappingKey.algorithm.name.toUpperCase() !== wrappingKeyAlgorithm.name) {
                            reject(new Error("InvalidAccessError"));
                            return;
                        }
                        exportKey(format, key)
                            .then(function (keyData) {
                            console.log(utils.toBase64(keyData));
                            return encrypt(wrappingKeyAlgorithm, wrappingKey, format === "jwk" ?
                                utils.stringToBytes(JSON.stringify(keyData, null, 0)) : keyData);
                        })
                            .then(function (cipherArrayBuffer) {
                            resolve(cipherArrayBuffer);
                        })["catch"](function (err) {
                            reject(err);
                        });
                    });
                },
                unwrapKey: function (format, wrappedKey, unwrappingKey, unwrapAlgorithm, unwrappedKeyAlgorithm, extractable, keyUsages) {
                    var decrypt = this.decrypt, importKey = this.importKey;
                    return new Promise(function (resolve, reject) {
                        if (unwrappingKey.usages.indexOf("unwrapKey") < 0 ||
                            unwrappingKey.algorithm.name.toUpperCase() !== unwrapAlgorithm.name) {
                            reject(new Error("InvalidAccessError"));
                            return;
                        }
                        decrypt(unwrapAlgorithm, unwrappingKey, wrappedKey)
                            .then(function (keyPlain) {
                            return importKey(format, format === "jwk" ? JSON.parse(utils.bytesToString(keyPlain)) : keyPlain, unwrappedKeyAlgorithm, extractable, keyUsages);
                        })
                            .then(function (key) {
                            resolve(key);
                        })["catch"](function (err) {
                            reject(err);
                        });
                    });
                }
            };
            var internalMethods = {
                useWebWorkers: workerManager.useWebWorkers
            };
            return {
                publicMethods: publicMethods,
                internalMethods: internalMethods
            };
        })();
        var msrcryptoWrapKey = (function () {
            var utils = msrcryptoUtilities;
            function wrapKey(params) {
                var rsaObj = msrcryptoRsa(params.keyData1, params.keyHandle1.algorithm.name, msrcryptoHashFunctions["SHA-1"])();
                var tagLength = 128;
                var keyToWrapJwk = msrcryptoJwk.keyToJwkOld(params.keyHandle, params.keyData);
                var jweHeader = {
                    "alg": params.keyHandle1.algorithm.name.toUpperCase(),
                    "enc": "A128GCM"
                };
                var encodedJweHeader = utils.toBase64(JSON.stringify(jweHeader), true);
                var cmk = msrcryptoPseudoRandom.getBytes(32);
                var jweEncryptedKey = rsaObj.encrypt(cmk);
                var encodedJweEncryptedKey = utils.toBase64(jweEncryptedKey, true);
                var jweIv = msrcryptoPseudoRandom.getBytes(12);
                var encodedJweIv = utils.toBase64(jweIv, true);
                var additionalData = encodedJweHeader.concat(".", encodedJweEncryptedKey, ".", encodedJweIv);
                var gcm = msrcryptoGcm(msrcryptoBlockCipher.aes(cmk));
                gcm.init(jweIv, utils.stringToBytes(additionalData), tagLength);
                var ciphertextPlusTag = gcm.encrypt(keyToWrapJwk);
                var tag = ciphertextPlusTag.slice(-(tagLength / 8));
                var encodedIntegrityValue = utils.toBase64(tag, true);
                var encodedCiphertext = utils.toBase64(ciphertextPlusTag.slice(0, ciphertextPlusTag.length - tag.length), true);
                var jwe = {
                    recipients: [{
                            header: encodedJweHeader,
                            encrypted_key: encodedJweEncryptedKey,
                            integrity_value: encodedIntegrityValue
                        }],
                    initialization_vector: encodedJweIv,
                    ciphertext: encodedCiphertext
                };
                return utils.stringToBytes(JSON.stringify(jwe));
            }
            function unwrapKey(params) {
                var b64Tobytes = utils.fromBase64;
                var keyDataJwk = JSON.parse(String.fromCharCode.apply(null, params.buffer));
                var header = utils.fromBase64(keyDataJwk.recipients[0].header);
                var encrypted_key = b64Tobytes(keyDataJwk.recipients[0].encrypted_key);
                var integrity_value = b64Tobytes(keyDataJwk.recipients[0].integrity_value);
                var initialization_vector = b64Tobytes(keyDataJwk.initialization_vector);
                var ciphertext = b64Tobytes(keyDataJwk.ciphertext);
                var hashFunc = msrcryptoHashFunctions["SHA-1"]();
                var rsaObj = msrcryptoRsa(params.keyData, params.keyHandle.algorithm.name, hashFunc);
                var inKey = rsaObj.decrypt(encrypted_key);
                var additionalData = keyDataJwk.recipients[0].header.concat(".", keyDataJwk.recipients[0].encrypted_key, ".", keyDataJwk.initialization_vector);
                var gcm = msrcryptoGcm(msrcryptoBlockCipher.aes(inKey));
                gcm.init(initialization_vector, utils.stringToBytes(additionalData), 128);
                var result = gcm.decrypt(ciphertext, integrity_value);
                var keyObject = msrcryptoJwk.jwkToKey(result, params.algorithm, ["k"]);
                return {
                    type: "keyImport",
                    keyData: keyObject.k,
                    keyHandle: {
                        algorithm: {
                            name: params.algorithm.name
                        },
                        extractable: params.extractable || keyObject.extractable,
                        usages: params.usages,
                        type: "secret"
                    }
                };
            }
            return {
                wrapKey: wrapKey,
                unwrapKey: unwrapKey
            };
        })();
        if (typeof operations !== "undefined") {
            operations.register("wrapKey", "AES-GCM", msrcryptoWrapKey.wrapKey);
            operations.register("unwrapKey", "AES-CBC", msrcryptoWrapKey.unwrapKey);
        }
        var publicMethods = {
            subtle: msrcryptoSubtle ? msrcryptoSubtle.publicMethods : null,
            getRandomValues: function (array) {
                var i;
                var randomValues = msrcryptoPseudoRandom.getBytes(array.length);
                for (i = 0; i < array.length; i += 1) {
                    array[i] = randomValues[i];
                }
                return array;
            },
            initPrng: function (entropyData) {
                var entropyDataType = Object.prototype.toString.call(entropyData);
                if (entropyDataType !== "[object Array]" && entropyDataType !== "[object Uint8Array]") {
                    throw new Error("entropyData must be a Array or Uint8Array");
                }
                entropyPool && entropyPool.reseed(entropyData);
                msrcryptoPseudoRandom.reseed(entropyPool.read(48));
                fprngEntropyProvided = true;
            },
            toBase64: function (data, base64Url) {
                return msrcryptoUtilities.toBase64(data, base64Url);
            },
            fromBase64: function (base64String) {
                return msrcryptoUtilities.fromBase64(base64String);
            },
            textToBytes: function (text) {
                return msrcryptoUtilities.stringToBytes(text);
            },
            bytesToText: function (byteArray) {
                return msrcryptoUtilities.bytesToString(byteArray);
            },
            asn1: asn1,
            url: scriptUrl,
            version: msrCryptoVersion,
            useWebWorkers: function (useWebWorkers) {
                return msrcryptoSubtle ? msrcryptoSubtle.internalMethods.useWebWorkers(useWebWorkers) : null;
            }
        };
        var entropyPool;
        entropyPool = entropyPool || new MsrcryptoEntropy(global);
        entropyPool.init();
        var localEntropy = entropyPool.read(48);
        msrcryptoPseudoRandom.init(localEntropy);
        return publicMethods;
    };
    return msrCrypto();
}
;

var msrCrypto$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	msrCrypto: msrCrypto$1
});

// @ts-nocheck
/* tslint:disable */
//*******************************************************************************
//
//    Copyright 2020 Microsoft
//
//    Most recent version of the Token Encryption API.
//    Compatible with IE8 and up, Edge; latest versions of Chrome, Safari, Opera
//
//*******************************************************************************
function TokenEncrypt(msrCrypto) {
    // Newer browsers use window.crypto.    
    // Browsers which is not support window.crypto use window.msrCrypto    
    var cryptoObject = window.crypto || window.msrCrypto || msrCrypto;
    // IE 11 use window.msCrypto
    if (CheckUseMsCrypto()) {
        cryptoObject = window.msCrypto;
    }
    // The crypto functions are on the subtle interface just as in the Web Crypto API.
    var subtle = cryptoObject.subtle;
    // The crypto function getRandomValues just as in the Web Crypto API.
    var getRandomValues = function (arr) { return cryptoObject.getRandomValues(arr); };
    // Algorithm name to Encrypt/Import
    var algorithmName = "RSA-OAEP";
    // Algorithm for Encryption
    var encryptAlgorithm = { name: algorithmName, hash: { name: "SHA-256" } };
    // Partner public key
    var publicKeyJwk = undefined;
    // Encrypted output is set to undefined
    var EncryptedOutput = undefined;
    function Encrypt(propertyDescription, plainText, successCallback, errorCallBack) {
        EncryptTokenData(propertyDescription, plainText, function (encReqBody) { successCallback(encReqBody); }, function (error) { errorCallBack(error); });
    }
    function EncryptTokenData(propertyDescription, plainText, successCallback, errorCallBack) {
        var encryptionParameters = propertyDescription["dataProtection"]["parameters"];
        SetPublicKey(encryptionParameters.publicKey);
        // Token set helps to identify the logic for complex object
        var token_set = propertyDescription.token_set || undefined;
        var publicKeyHandle = undefined;
        // Import key format - Json Web Key
        var keyFormat = "jwk";
        // Import key failure message
        var keyImportFailureMessage = "Public Jwk key import failure";
        // User agent flag helps to use msCrypto
        var isMsCrypto = CheckUseMsCrypto();
        // Import key usage
        var keyUsage = "encrypt";
        if (isMsCrypto) {
            var publicKeyBytes = toSupportedArray(JSON.stringify(publicKeyJwk));
            var jwkImport = subtle.importKey(keyFormat, publicKeyBytes, encryptAlgorithm, true, [keyUsage]);
            jwkImport.onerror = function (error) {
                errorCallBack(keyImportFailureMessage + " in IE11: " + error.target.result);
            };
            jwkImport.oncomplete = function (key) {
                publicKeyHandle = key.target.result;
                EncryptPayload(publicKeyHandle, plainText, token_set, successCallback, errorCallBack, isMsCrypto);
            };
        }
        else {
            subtle.importKey(keyFormat, publicKeyJwk, encryptAlgorithm, true, [keyUsage]).then(function (key) {
                publicKeyHandle = key;
                EncryptPayload(publicKeyHandle, plainText, token_set, successCallback, errorCallBack, isMsCrypto);
            }).catch(function (error) {
                errorCallBack(keyImportFailureMessage + ": " + error);
            });
        }
    }
    function EncryptPayload(publicKeyHandle, plainText, token_set, successCallback, errorCallBack, isMsCrypto) {
        // Generate AES key and nonce
        var key = getRandomValues(new Uint8Array(256 / 8));
        var nonce = getRandomValues(new Uint8Array(12));
        // Prepare the JWE header
        var header = {
            alg: "RSA-OAEP-256",
            enc: "A256GCM",
            typ: "JOSE",
            kid: publicKeyJwk.kid,
            uuid: getGUID(),
            iat: Math.floor(Date.now() / 1000).toString(),
        };
        var serializedHeader = toSupportedArray(JSON.stringify(header));
        var aad = toSupportedArray(toBase64(serializedHeader, true));
        // Encrypt the data with the AES key
        var aesGcmParams = {
            name: "AES-GCM",
            iv: nonce,
            additionalData: aad,
            tagLength: 128,
        };
        var rsaParams = {
            name: "RSA-OAEP",
        };
        var encryptContext = {
            aesGcmParams: aesGcmParams,
            rsaParams: rsaParams,
            serializedHeader: serializedHeader,
            aesKeyData: key,
            nonce: nonce,
            aad: aad
        };
        // Encrypt data
        TokenEncryption(publicKeyHandle, plainText, encryptContext, token_set, successCallback, errorCallBack, isMsCrypto);
    }
    function TokenEncryption(publicKeyHandle, plainText, encryptContext, token_set, successCallback, errorCallBack, isMsCrypto) {
        var plainTextBytes = toSupportedArray(plainText, errorCallBack);
        if (isMsCrypto) {
            EncryptUseMsCrypto(publicKeyHandle, plainTextBytes, encryptContext, token_set, successCallback, errorCallBack);
        }
        else {
            EncryptUsePromise(publicKeyHandle, plainTextBytes, encryptContext, token_set, successCallback, errorCallBack);
        }
    }
    function EncryptComplete(encryptedData, encryptedKey, encryptContext, successCallback, errorCallBack) {
        // Extract ciphertext and tag from encryptedData
        var ct = encryptedData.slice(0, encryptedData.byteLength - 16);
        var tag = encryptedData.slice(encryptedData.byteLength - 16);
        var requestObject = {
            header: GetBase64(encryptContext.serializedHeader, errorCallBack),
            key_version: publicKeyJwk.kid,
            session_key: GetBase64(encryptedKey, errorCallBack),
            iv: GetBase64(encryptContext.nonce, errorCallBack),
            payload: GetBase64(ct, errorCallBack),
            tag: GetBase64(tag, errorCallBack),
            authenticated_data: GetBase64(encryptContext.aad, errorCallBack)
        };
        // Call back to source - PIDL SDK
        successCallback(requestObject);
    }
    function EncryptUseMsCrypto(publicKeyHandle, plainTextBytes, encryptContext, token_set, successCallback, errorCallBack) {
        var aesKeyImport = subtle.importKey("raw", encryptContext.aesKeyData, { name: "AES-GCM" }, true, ["encrypt"]);
        aesKeyImport.onerror = function (error) {
            errorCallBack(keyImportFailureMessage + " in IE11: " + error.target.result);
        };
        aesKeyImport.oncomplete = function (aesKeyObj) {
            var aesKey = aesKeyObj.target.result;
            // Encrypt the data with the AES key
            var encryptData = subtle.encrypt(encryptContext.aesGcmParams, aesKey, plainTextBytes);
            encryptData.onerror = function (error) {
                errorCallBack(token_set + " Encrypt data failure in IE11: " + error.target.result);
            };
            encryptData.oncomplete = function (encryptedData) {
                // Encrypt the AES key with the RSA public key
                var encryptKey = subtle.encrypt(encryptContext.rsaParams, publicKeyHandle, encryptContext.aesKeyData);
                encryptKey.onerror = function (error) {
                    errorCallBack(token_set + " Encrypt key failure in IE11: " + error.target.result);
                };
                encryptKey.oncomplete = function (encryptedKey) {
                    EncryptComplete(encryptedData, encryptedKey, encryptContext, successCallback, errorCallBack);
                };
            };
        };
    }
    function EncryptUsePromise(publicKeyHandle, plainTextBytes, encryptContext, token_set, successCallback, errorCallBack) {
        subtle.importKey("raw", encryptContext.aesKeyData, { name: "AES-GCM" }, true, ["encrypt"]).then(function (aesKey) {
            // Encrypt the data with the AES key
            subtle.encrypt(encryptContext.aesGcmParams, aesKey, plainTextBytes).then(function (encryptedData) {
                // Extract ciphertext and tag from encryptedData
                var ct = encryptedData.slice(0, encryptedData.byteLength - 16);
                var tag = encryptedData.slice(encryptedData.byteLength - 16);
                // Encrypt the AES key with the RSA public key
                subtle.encrypt(encryptContext.rsaParams, publicKeyHandle, encryptContext.aesKeyData).then(function (encryptedKey) {
                    EncryptComplete(encryptedData, encryptedKey, encryptContext, successCallback, errorCallBack);
                }).catch(function (error) {
                    errorCallBack(token_set + " Encrypt key failure: " + error);
                });
            }).catch(function (error) {
                errorCallBack(token_set + "Encrypt data failure: " + error);
            });
        }).catch(function (error) {
            errorCallBack(token_set + "Encrypt data failure: " + error);
        });
    }
    function SetPublicKey(publicKey) {
        // Encryption public key in JWK format.
        publicKeyJwk = JSON.parse(publicKey);
    }
    function s4() {
        return getRandomValues(new Uint16Array(1))[0].toString(16);
    }
    function getGUID() {
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
    function GetBase64(encryptedText, errorCallBack) {
        // We get our encrypted bytes as an ArrayBuffer
        var encryptedBytes = toSupportedArray(encryptedText, errorCallBack);
        // Content - Base 64 Encoding
        return toBase64(encryptedBytes);
    }
    function CheckUseMsCrypto() {
        var _a;
        return (((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.indexOf("rv:11.0")) > -1 && window.msCrypto != undefined);
    }
    //*******************************************************************************
    //
    //    Copyright 2020 Microsoft
    //
    //    Licensed under the Apache License, Version 2.0 (the "License");
    //    you may not use this file except in compliance with the License.
    //    You may obtain a copy of the License at
    //
    //        http://www.apache.org/licenses/LICENSE-2.0
    //
    //    Unless required by applicable law or agreed to in writing, software
    //    distributed under the License is distributed on an "AS IS" BASIS,
    //    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    //    See the License for the specific language governing permissions and
    //    limitations under the License.
    //
    //*******************************************************************************
    function toSupportedArray(data, errorCallBack) {
        // does this browser support Typed Arrays?
        var typedArraySupport = (typeof Uint8Array !== "undefined");
        // get the data type of the parameter
        var dataType = Object.prototype.toString.call(data);
        dataType = dataType.substring(8, dataType.length - 1);
        // determine the type
        switch (dataType) {
            // Regular JavaScript Array. Convert to Uint8Array if supported
            // else do nothing and return the array
            case "Array":
                return typedArraySupport ? new Uint8Array(data) : data;
            // ArrayBuffer. IE11 Web Crypto API returns ArrayBuffers that you have to convert
            // to Typed Arrays. Convert to a Uint8Arrays and return;
            case "ArrayBuffer":
                return new Uint8Array(data);
            // Already Uint8Array. Obviously there is support.
            case "Uint8Array":
                return data;
            case "Uint16Array":
            case "Uint32Array":
                return new Uint8Array(data);
            // String. Convert the string to a byte array using Typed Arrays if
            // supported.
            case "String":
                var newArray = typedArraySupport ? new Uint8Array(data.length) : new Array(data.length);
                for (var i = 0; i < data.length; i += 1) {
                    newArray[i] = data.charCodeAt(i);
                }
                return newArray;
            // Some other type. Just return the data unchanged.
            default:
                errorCallBack("toSupportedArray : unsupported data type " + dataType);
        }
    }
    //*******************************************************************************
    //
    //    Copyright 2020 Microsoft
    //
    //    Licensed under the Apache License, Version 2.0 (the "License");
    //    you may not use this file except in compliance with the License.
    //    You may obtain a copy of the License at
    //
    //        http://www.apache.org/licenses/LICENSE-2.0
    //
    //    Unless required by applicable law or agreed to in writing, software
    //    distributed under the License is distributed on an "AS IS" BASIS,
    //    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    //    See the License for the specific language governing permissions and
    //    limitations under the License.
    //
    //*******************************************************************************
    var btoaSupport = (typeof btoa !== "undefined");
    var encodingChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    function toBase64(data, base64Url) {
        /// <signature>
        ///     <summary>Converts byte data to Base64 string</summary>
        ///     <param name="data" type="Array">An array of bytes values (numbers from 0-255)</param>
        ///     <param name="base64Url" type="Boolean" optional="true">Converts to a Base64Url string if True (default = false)</param>
        ///     <returns type="String" />
        /// </signature>
        /// <signature>
        ///     <summary>Converts byte data to Base64 string</summary>
        ///     <param name="data" type="UInt8Array">A UInt8Array</param>
        ///     <param name="base64Url" type="Boolean" optional="true">Converts to a Base64Url string if True (default = false)</param>
        ///     <returns type="String" />
        /// </signature>
        /// <signature>
        ///     <summary>Converts text to Base64 string</summary>
        ///     <param name="data" type="String">Text string</param>
        ///     <param name="base64Url" type="Boolean" optional="true">Converts to a Base64Url string if True (default = false)</param>
        ///     <returns type="String" />
        /// </signature>
        var output = "";
        if (!base64Url) {
            base64Url = false;
        }
        // If the input is an array type, convert it to a string.
        // The built-in btoa takes strings.
        if (data.pop || data.subarray) {
            data = String.fromCharCode.apply(null, data);
        }
        if (btoaSupport) {
            output = btoa(data);
        }
        else {
            var char1, char2, char3, enc1, enc2, enc3, enc4;
            var i;
            for (i = 0; i < data.length; i += 3) {
                // Get the next three chars.
                char1 = data.charCodeAt(i);
                char2 = data.charCodeAt(i + 1);
                char3 = data.charCodeAt(i + 2);
                // Encode three bytes over four 6-bit values.
                // [A7,A6,A5,A4,A3,A2,A1,A0][B7,B6,B5,B4,B3,B2,B1,B0][C7,C6,C5,C4,C3,C2,C1,C0].
                // [A7,A6,A5,A4,A3,A2][A1,A0,B7,B6,B5,B4][B3,B2,B1,B0,C7,C6][C5,C4,C3,C2,C1,C0].
                // 'enc1' = high 6-bits from char1
                enc1 = char1 >> 2;
                // 'enc2' = 2 low-bits of char1 + 4 high-bits of char2
                enc2 = ((char1 & 0x3) << 4) | (char2 >> 4);
                // 'enc3' = 4 low-bits of char2 + 2 high-bits of char3
                enc3 = ((char2 & 0xF) << 2) | (char3 >> 6);
                // 'enc4' = 6 low-bits of char3
                enc4 = char3 & 0x3F;
                // 'char2' could be 'nothing' if there is only one char left to encode
                //   if so, set enc3 & enc4 to 64 as padding.
                if (isNaN(char2)) {
                    enc3 = enc4 = 64;
                    // If there was only two chars to encode char3 will be 'nothing'
                    //   set enc4 to 64 as padding.
                }
                else if (isNaN(char3)) {
                    enc4 = 64;
                }
                // Lookup the base-64 value for each encoding.
                output = output +
                    encodingChars.charAt(enc1) +
                    encodingChars.charAt(enc2) +
                    encodingChars.charAt(enc3) +
                    encodingChars.charAt(enc4);
            }
        }
        if (base64Url) {
            return output.replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
        }
        return output;
    }
    // Return the list of objects to callers
    return {
        Encrypt: Encrypt,
        SetPublicKey: SetPublicKey,
        EncryptedOutput: EncryptedOutput
    };
}

var encrypt = /*#__PURE__*/Object.freeze({
	__proto__: null,
	TokenEncrypt: TokenEncrypt
});

"use strict";
var Tokenizer = /** @class */ (function () {
    function Tokenizer() {
        var _this = this;
        this.doServerTokenization = function (eventHub, tokenSet, valueToTokenize, pidlOperation, fetchConfig) {
            /**
             * Promise Callsites:
             * tokenizer.serverTokenization = rejection handled
             * tokenizer.createHmacSignatureInternal = rejection handled
             */
            return new Promise(function (resolve, reject) {
                var tokenizationEndpointInfo = config$1.virtualEndpoints.tokenization;
                var tokenizationUrl = urlBuilder$1.buildUrl(config$1.getServiceEndpoint(tokenizationEndpointInfo.endpoint), [tokenSet, "getToken"]);
                return fetchHelper.post(eventHub, true, tokenizationUrl, fetchHelper.getDefaultHttpHeaders(eventHub), '{ "data": "' + valueToTokenize + '" }', function (tokenData) {
                    resolve({ data: tokenData.data });
                }, function (fetchFailureMessage) {
                    fetchFailureMessage = fetchFailureMessage || { status: pidlResultType.Fail };
                    fetchFailureMessage.failureObject = fetchFailureMessage.failureObject || {};
                    fetchFailureMessage.failureObject.code = serverErrorTypes.tokenizationFailed;
                    var valueProperties = " ";
                    if (typehelper.isString(valueToTokenize)) {
                        for (var i = 0; i < valueToTokenize.length; i++) {
                            var charCode = valueToTokenize.charCodeAt(i);
                            if (charCode >= 48 && charCode <= 57) {
                                valueProperties = valueProperties + "d";
                            }
                            else {
                                valueProperties = valueProperties + "c";
                            }
                        }
                    }
                    else {
                        valueProperties = " n_s";
                    }
                    fetchFailureMessage.failureObject.message = fetchFailureMessage.failureObject.message ? fetchFailureMessage.failureObject.message + valueProperties : valueProperties;
                    resolve({
                        error: new pidlErrors.serverError(errorMessages.tokenizationFailed, tokenizationUrl, fetchFailureMessage.failureObject, fetchFailureMessage.httpStatus, fetchFailureMessage.httpStatusText, undefined, [fetchFailureMessage.errorMessage + valueProperties])
                    });
                }, pidlOperation, tokenizationEndpointInfo.operation, tokenizationEndpointInfo.description, false, fetchConfig).catch(function (error) {
                    resolve({
                        error: new pidlErrors.unexpectedError(errorMessages.tokenizationFailed, [error.message])
                    });
                });
            });
        };
        this.serverTokenization = function (propertyDescription, propertyName, eventHub, userInputData, pidlOperation) {
            var _a;
            eventHub.propertyTokenizing(propertyName, urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.tokenization.endpoint), [propertyDescription.token_set, "getToken"]));
            return _this.doServerTokenization(eventHub, propertyDescription.token_set, userInputData[propertyName], pidlOperation, (_a = propertyDescription === null || propertyDescription === void 0 ? void 0 : propertyDescription.dataProtection) === null || _a === void 0 ? void 0 : _a.fetchConfig).then(function (result) {
                if (!result.error) {
                    userInputData[propertyName] = result.data;
                    eventHub.propertyTokenized(propertyName);
                }
                return { error: result.error };
            });
        };
        this.doFileUpload = function (eventHub, dataToUpload, context, pidlOperation, uploadUrl, fetchConfig) {
            var hmacContext = context.hmacContext;
            return new Promise(function (resolve, reject) {
                var fileUploadEndpointInfo = config$1.virtualEndpoints.payeeTaxProfile;
                return fetchHelper.post(eventHub, true, uploadUrl, fetchHelper.getPayeeFileUploadHttpHeaders(eventHub, hmacContext.userCredential), dataToUpload, function (fileData) {
                    resolve({ data: fileData.filename });
                }, function (fetchFailureMessage) {
                    fetchFailureMessage = fetchFailureMessage || { status: pidlResultType.Fail };
                    fetchFailureMessage.failureObject = fetchFailureMessage.failureObject || {};
                    fetchFailureMessage.failureObject.code = serverErrorTypes.fileUploadFailed;
                    resolve({
                        error: new pidlErrors.serverError(errorMessages.fileUploadFailure, uploadUrl, fetchFailureMessage.failureObject, fetchFailureMessage.httpStatus, fetchFailureMessage.httpStatusText, undefined, [fetchFailureMessage.errorMessage])
                    });
                }, pidlOperation, fileUploadEndpointInfo.operation, fileUploadEndpointInfo.description, false, fetchConfig).catch(function (error) {
                    resolve({
                        error: new pidlErrors.unexpectedError(errorMessages.fileUploadFailure, [error.message])
                    });
                });
            });
        };
        this.composePayeeFileUploadPayload = function (userInputData, propertyName) {
            var fileUploadPayload = new FormData();
            fileUploadPayload.append("file", userInputData[propertyName]);
            fileUploadPayload.append("payeeid", userInputData["payee_id"]);
            fileUploadPayload.append("taxprofileid", userInputData["tax_profile_id"]);
            return fileUploadPayload;
        };
        this.fileUpload = function (propertyDescription, propertyName, eventHub, userInputData, context, pidlOperation, uploadUrlTemplate) {
            var _a;
            var fileUploadPayload = _this.composePayeeFileUploadPayload(userInputData, propertyName);
            var uploadUrl = urlBuilder$1.createFromTemplate(uploadUrlTemplate);
            eventHub.fileUploading(propertyName, uploadUrl);
            return _this.doFileUpload(eventHub, fileUploadPayload, context, pidlOperation, uploadUrl, (_a = propertyDescription === null || propertyDescription === void 0 ? void 0 : propertyDescription.dataProtection) === null || _a === void 0 ? void 0 : _a.fetchConfig).then(function (result) {
                if (!result.error) {
                    userInputData[propertyName] = result.data;
                    eventHub.fileUploaded(propertyName);
                }
                return { error: result.error };
            });
        };
        // MSR encryption method to encrypt user's data using external service specific script file
        this.msrCryptoEncryption = function (propertyDescription, propertyName, eventHub, userInputData) {
            var encryptionScriptDownloadPromise;
            var encryptionLibraryDownloadPromise;
            var encryptionLibrary;
            var encryptionScript;
            eventHub.propertyTokenizing(propertyName, "");
            var dataProtectionParams = propertyDescription && propertyDescription.dataProtection && propertyDescription.dataProtection.parameters;
            // Initialize promise object - MSR Crypto scripts
            if (typeof msrCrypto !== "undefined" || (dataProtectionParams && !dataProtectionParams.encryptionLibrary)) {
                encryptionLibraryDownloadPromise = createFakePromise();
            }
            else {
                encryptionLibrary = (dataProtectionParams && dataProtectionParams.encryptionLibrary) || undefined;
                var encryptionLibraryUrl = (dataProtectionParams && dataProtectionParams.encryptionLibraryUrl) || urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.msrCryptoJS.endpoint), [encryptionLibrary]);
                encryptionLibraryDownloadPromise = fetchHelper.loadScript(encryptionLibraryUrl);
            }
            // Initialize promise object - external service specific scripts (e.g., LiftForward)
            // There can be only 1 external service specific encryption file per PIDL/session.
            if (typeof encryption !== "undefined") {
                encryptionScriptDownloadPromise = createFakePromise();
            }
            else {
                encryptionScript = (dataProtectionParams && dataProtectionParams.encryptionScript) || undefined;
                var encryptionScriptUrl = (dataProtectionParams && dataProtectionParams.encryptionScriptUrl) || urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.encryptJS.endpoint), [encryptionScript]);
                encryptionScriptDownloadPromise = fetchHelper.loadScript(encryptionScriptUrl);
            }
            // Download MSR crypto and external service specific scripts from virtual enpoints
            return encryptionLibraryDownloadPromise.then(function () {
                return encryptionScriptDownloadPromise.then(function () {
                    if (typeof encryption === "undefined") {
                        return { error: new pidlErrors.unexpectedError(errorMessages.msrEncryptionFailed, ["Fail to initialize " + encryptionScript + " instance"]) };
                    }
                    else {
                        return new Promise(function (resolve, reject) {
                            // Call encrypt method from external service specific script
                            encryption.Encrypt(propertyDescription, userInputData[propertyName], function (encryptedValue) {
                                // Receive encrypted value using call back method
                                userInputData[propertyName] = encryptedValue;
                                eventHub.propertyTokenized(propertyName);
                                resolve({});
                            }, function (error) {
                                // Handle error from script file using call back method
                                reject(error);
                            });
                        }).catch(function (err) {
                            var message = "Encryption failure: " + JSON.stringify(err);
                            return { error: new pidlErrors.serverError(errorMessages.msrEncryptionFailed, null, null, null, message, null, [message]) };
                        });
                    }
                }).catch(function (err) {
                    var message = "Fail to download " + encryptionScript + " script file: " + JSON.stringify(err);
                    return { error: new pidlErrors.serverError(errorMessages.msrEncryptionFailed, null, null, null, message, null, [message]) };
                });
            }).catch(function (err) {
                var message = "Fail to download " + encryptionLibrary + " script file: " + JSON.stringify(err);
                return { error: new pidlErrors.serverError(errorMessages.msrEncryptionFailed, null, null, null, message, null, [message]) };
            });
        };
        // MSR encryption method to encrypt user's data using external service specific script file
        // which is then tokenized by the tokenization service
        this.doTokenizeMsrCryptoEncryption = function (propertyDescription, eventHub, tokenSet, valueToTokenize, pidlOperation, encryptionHandler) {
            var encryptionScriptDownloadPromise = createFakePromise();
            var encryptionLibraryDownloadPromise = createFakePromise();
            var encryptionLibrary;
            var encryptionScript;
            var dataProtectionParams = propertyDescription && propertyDescription.dataProtection && propertyDescription.dataProtection.parameters;
            var tokenizeEncryptor;
            if (!encryptionHandler) {
                if (dataProtectionParams && dataProtectionParams.encryptionFunction) {
                    if (!_this.localMsrCryptoInstance) {
                        _this.localMsrCryptoInstance = msrCrypto$1(window);
                    }
                    if (!_this.localEncryptionInstance) {
                        _this.localEncryptionInstance = TokenEncrypt(_this.localMsrCryptoInstance);
                    }
                    tokenizeEncryptor = _this.localEncryptionInstance;
                }
                else {
                    // Initialize promise object - MSR Crypto scripts
                    if (typeof msrCrypto !== "undefined" || (dataProtectionParams && !dataProtectionParams.encryptionLibrary)) {
                        encryptionLibraryDownloadPromise = createFakePromise();
                    }
                    else {
                        encryptionLibrary = (dataProtectionParams && dataProtectionParams.encryptionLibrary) || undefined;
                        var encryptionLibraryUrl = (dataProtectionParams && dataProtectionParams.encryptionLibraryUrl) || urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.msrCryptoJS.endpoint), [encryptionLibrary]);
                        encryptionLibraryDownloadPromise = fetchHelper.loadScript(encryptionLibraryUrl);
                    }
                    // Initialize promise object - external service specific scripts (e.g., LiftForward)
                    // There can be only 1 external service specific encryption file per PIDL/session.
                    if (typeof encryption !== "undefined") {
                        encryptionScriptDownloadPromise = createFakePromise();
                    }
                    else {
                        encryptionScript = (dataProtectionParams && dataProtectionParams.encryptionScript) || undefined;
                        var encryptionScriptUrl = (dataProtectionParams && dataProtectionParams.encryptionScriptUrl) || urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.encryptJS.endpoint), [encryptionScript]);
                        encryptionScriptDownloadPromise = fetchHelper.loadScript(encryptionScriptUrl).then(function () {
                            if (typeof encryption === "undefined") {
                                return { error: new pidlErrors.unexpectedError(errorMessages.msrEncryptionFailed, ["Fail to initialize " + encryptionScript + " instance"]) };
                            }
                            else {
                                tokenizeEncryptor = encryption;
                            }
                        });
                    }
                }
            }
            // Download MSR crypto and external service specific scripts from virtual enpoints
            return encryptionLibraryDownloadPromise.then(function () {
                return encryptionScriptDownloadPromise.then(function () {
                    return new Promise(function (resolve, reject) {
                        var _a;
                        var tokenizationEndpointInfo = config$1.virtualEndpoints.tokenization;
                        var tokenizationUrl = urlBuilder$1.buildUrl(config$1.getServiceEndpoint(tokenizationEndpointInfo.endpoint), [tokenSet, "getToken"]);
                        return fetchHelper.post(eventHub, true, tokenizationUrl, fetchHelper.getDefaultHttpHeaders(eventHub), '{ "data": "' + valueToTokenize + '" }', function (tokenData) {
                            resolve({ data: tokenData.data });
                        }, function (fetchFailureMessage) {
                            fetchFailureMessage = fetchFailureMessage || { status: pidlResultType.Fail };
                            fetchFailureMessage.failureObject = fetchFailureMessage.failureObject || {};
                            fetchFailureMessage.failureObject.code = serverErrorTypes.tokenizationFailed;
                            var valueProperties = " ";
                            if (typehelper.isString(valueToTokenize)) {
                                for (var i = 0; i < valueToTokenize.length; i++) {
                                    var charCode = valueToTokenize.charCodeAt(i);
                                    if (charCode >= 48 && charCode <= 57) {
                                        valueProperties = valueProperties + "d";
                                    }
                                    else {
                                        valueProperties = valueProperties + "c";
                                    }
                                }
                            }
                            else {
                                valueProperties = " n_s";
                            }
                            fetchFailureMessage.failureObject.message = fetchFailureMessage.failureObject.message ? fetchFailureMessage.failureObject.message + valueProperties : valueProperties;
                            resolve({
                                error: new pidlErrors.serverError(errorMessages.tokenizationFailed, tokenizationUrl, fetchFailureMessage.failureObject, fetchFailureMessage.httpStatus, fetchFailureMessage.httpStatusText, undefined, [fetchFailureMessage.errorMessage + valueProperties])
                            });
                        }, pidlOperation, tokenizationEndpointInfo.operation, tokenizationEndpointInfo.description, false, (_a = propertyDescription.dataProtection) === null || _a === void 0 ? void 0 : _a.fetchConfig, function () {
                            return new Promise(function (resolve, reject) {
                                if (encryptionHandler) {
                                    encryptionHandler.encrypt(propertyDescription, propertyDescription.token_set, valueToTokenize).then(function (encryptedValue) {
                                        var encryptedTokenizedHeader = {
                                            "content-type": "application/json",
                                            "x-ms-requestor": "Microsoft",
                                            "traceparent": utils.guid()
                                        };
                                        resolve({ success: true, headers: encryptedTokenizedHeader, payload: typeof encryptedValue !== "string" ? JSON.stringify(encryptedValue) : encryptedValue });
                                    }).catch(function (error) {
                                        reject(error);
                                    });
                                }
                                else {
                                    tokenizeEncryptor.Encrypt(propertyDescription, valueToTokenize, function (encryptedJson) {
                                        var encryptedTokenizedHeader = {
                                            "content-type": "application/json",
                                            "x-ms-requestor": "Microsoft",
                                            "traceparent": utils.guid()
                                        };
                                        resolve({ success: true, headers: encryptedTokenizedHeader, payload: JSON.stringify(encryptedJson) });
                                    }, function (error) {
                                        reject(error);
                                    });
                                }
                            });
                        }).catch(function (error) {
                            resolve({
                                error: new pidlErrors.unexpectedError(errorMessages.tokenizationFailed, [error.message])
                            });
                        });
                    }).catch(function (err) {
                        var message = "Encryption and tokenize failure: " + JSON.stringify(err);
                        return { error: new pidlErrors.serverError(errorMessages.msrEncryptionFailed, null, null, null, message, null, [message]) };
                    });
                }).catch(function (err) {
                    var message = "Fail to download " + encryptionScript + " script file: " + JSON.stringify(err);
                    return { error: new pidlErrors.serverError(errorMessages.msrEncryptionFailed, null, null, null, message, null, [message]) };
                });
            }).catch(function (err) {
                var message = "Fail to download " + encryptionLibrary + " script file: " + JSON.stringify(err);
                return { error: new pidlErrors.serverError(errorMessages.msrEncryptionFailed, null, null, null, message, null, [message]) };
            });
        };
        this.tokenizeMsrCryptoEncryption = function (propertyDescription, propertyName, eventHub, userInputData, pidlOperation, encryptionHandler) {
            eventHub.propertyTokenizing(propertyName, "");
            var valueToTokenize = userInputData[propertyName];
            return _this.doTokenizeMsrCryptoEncryption(propertyDescription, eventHub, propertyDescription.token_set, valueToTokenize, pidlOperation, encryptionHandler).then(function (result) {
                if (!result.error) {
                    userInputData[propertyName] = result.data;
                    eventHub.propertyTokenized(propertyName);
                }
                return { error: result.error };
            });
        };
        this.payPalHECEncryption = function (propertyDescription, propertyName, eventHub, userInputData, clientContext) {
            var scriptDownloadPromise;
            eventHub.propertyTokenizing(propertyName, "");
            if (typeof PayPalCrypto !== "undefined") {
                scriptDownloadPromise = createFakePromise();
            }
            else {
                var dataProtectionParams = propertyDescription && propertyDescription.dataProtection && propertyDescription.dataProtection.parameters;
                var paypalEncryptionScriptUrl = dataProtectionParams && dataProtectionParams.encryptionScriptUrl;
                if (!paypalEncryptionScriptUrl) {
                    var paypalEncryptionScript = (dataProtectionParams && dataProtectionParams.encryptionScript) || "paypalEncrypt.js";
                    paypalEncryptionScriptUrl = urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.paypalEncryptJS.endpoint), [paypalEncryptionScript]);
                }
                scriptDownloadPromise = fetchHelper.loadScript(paypalEncryptionScriptUrl);
            }
            var tokenizePropertyDescription = propertyDescription;
            return scriptDownloadPromise.then(function () {
                if (typeof PayPalCrypto === "undefined") {
                    return { error: new pidlErrors.unexpectedError(errorMessages.hmacError, ["Fail to initialize PayPal encryption instance"]) };
                }
                else {
                    return new Promise(function (resolve, reject) {
                        PayPalCrypto.Encrypt(tokenizePropertyDescription, clientContext, userInputData[propertyName], function (encryptedValue) {
                            userInputData[propertyName] = btoa(String.fromCharCode.apply(null, encryptedValue));
                            eventHub.propertyTokenized(propertyName);
                            resolve({});
                        });
                    });
                }
            }).catch(function (err) {
                var message = "Fail to download paypal encryption script file\n " + JSON.stringify(err);
                return { error: new pidlErrors.serverError(errorMessages.tokenizationFailed, null, null, null, message, null, [message]) };
            });
        };
        this.customEncryption = function (propertyDescription, propertyName, eventHub, userInputData, clientContext, encryptionHandler, errorMessage) {
            eventHub.propertyTokenizing(propertyName, "");
            var tokenizePropertyDescription = propertyDescription;
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var encryptedData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, encryptionHandler.encrypt(tokenizePropertyDescription, clientContext, userInputData[propertyName])];
                        case 1:
                            encryptedData = _a.sent();
                            userInputData[propertyName] = encryptedData;
                            eventHub.propertyTokenized(propertyName);
                            resolve({});
                            return [2 /*return*/];
                    }
                });
            }); }).catch(function (err) {
                var message = "".concat(errorMessage, "\n").concat(JSON.stringify(err));
                return { error: new pidlErrors.serverError(errorMessages.tokenizationFailed, null, null, null, message, null, [message]) };
            });
        };
        this.createHmacSignatureInternal = function (hmacInstance, eventHub, propertyName, userInputData, hmacContext, pidlOperation, propertyDescription, encryptionHandler) {
            return hmacInstance.init().then(function (hmacInitResult) {
                if (hmacInitResult.error) {
                    return { error: hmacInitResult.error };
                }
                var rawHmacKey = hmacInstance.getRawKey();
                var hmacPayload = "Pan:" + hmacContext.pan + "|HMACKey:" + rawHmacKey + "|UserCredential:" + hmacContext.userCredential;
                var result = { keyToken: null, data: null };
                var _a = propertyDescription && propertyDescription.dataProtection || {}, protection_type = _a.protection_type, fetchConfig = _a.fetchConfig;
                var tokenizationPromise;
                if (protection_type && protection_type.toUpperCase() === "HMACSIGNATUREMSRENCRYPT") {
                    tokenizationPromise = _this.doTokenizeMsrCryptoEncryption(propertyDescription, eventHub, hmac.token, rawHmacKey, pidlOperation, encryptionHandler);
                }
                else {
                    tokenizationPromise = _this.doServerTokenization(eventHub, hmac.token, rawHmacKey, pidlOperation, fetchConfig);
                }
                return tokenizationPromise.then(function (serverTokenResult) {
                    if (!serverTokenResult.error) {
                        result.keyToken = serverTokenResult.data;
                        return hmacInstance.sign(hmacPayload);
                    }
                    else {
                        return serverTokenResult;
                    }
                }).then(function (signDataResult) {
                    if (!signDataResult.error) {
                        result.data = signDataResult.data;
                        userInputData[hmac.userCredential] = hmacContext.userCredential;
                        userInputData[propertyName] = {
                            algorithm: hmac.algorithm,
                            keyToken: result.keyToken,
                            data: result.data
                        };
                    }
                    return { error: signDataResult.error };
                });
            });
        };
        this.getHmacSignatureFromSecurePX = function (propertyName, userInputData, panElement, userCredential) {
            var secureElement = panElement;
            return new Promise(function (resolve, reject) {
                secureElement.createHmacSignature("Pan", userCredential).then(function (response) {
                    userInputData[hmac.userCredential] = userCredential;
                    userInputData[propertyName] = response.value;
                    var result = {};
                    resolve(result);
                }).catch(function (err) {
                    resolve({ error: new pidlErrors.serverError(errorMessages.hmacError, null, null, null, err.message, null, [err.message]) });
                });
            });
        };
        this.createHmacSignature = function (eventHub, propertyName, userInputData, context, pidlOperation, propertyDescription, encryptionHandler) {
            var hmacContext = context.hmacContext;
            // Ignoring the HMAC error even for the case when userCredential is not passed to PIDL SDK by partner
            if (!webCrypto$1.isSupported() || !hmacContext || !hmacContext.userCredential) {
                userInputData[propertyName] = null;
                return createFakePromise({});
            }
            else if (hmacContext.panElement && hmacContext.panElement.isSecureProperty()) {
                return _this.getHmacSignatureFromSecurePX(propertyName, userInputData, hmacContext.panElement, hmacContext.userCredential);
            }
            else if (!hmacContext.pan) {
                userInputData[propertyName] = null;
                return createFakePromise({});
            }
            return _this.createHmacSignatureInternal(new hmac$1(), eventHub, propertyName, userInputData, hmacContext, pidlOperation, propertyDescription, encryptionHandler);
        };
        this.tokenizeUserInputDataInternal = function (eventHub, pidlDocument, userInputData, pidlOperation, clientInfo, context, encryptionHandler) {
            var dataDescription = pidlDocument.data_description;
            var clientContext = clientInfo || pidlDocument.clientContext;
            var tokenizationPromises = [];
            for (var propertyName in dataDescription) {
                var propertyDescription = dataDescription[propertyName];
                if (isPidlDocumentArray(propertyDescription)) {
                    var innerPidlDoc = propertyDescription && propertyDescription.length && propertyDescription[0];
                    if (innerPidlDoc) {
                        var innerPromises = _this.tokenizeUserInputDataInternal(eventHub, innerPidlDoc, userInputData[propertyName], pidlOperation, clientContext, context, encryptionHandler);
                        tokenizationPromises = __spreadArray(__spreadArray([], tokenizationPromises, true), innerPromises, true);
                    }
                }
                else {
                    if (propertyDescription.displayOnly || (pidlOperation === pidlOperationTypeValues.update && !propertyDescription.is_updatable)) {
                        continue;
                    }
                    if ((propertyDescription.token_set && !propertyDescription.token_set.startsWith(SecureFieldConstants.tokenizationValuePrefix)) || propertyDescription.dataProtection) {
                        if (userInputData.hasOwnProperty(propertyName)) {
                            var dataProtectionType = propertyDescription.dataProtection &&
                                propertyDescription.dataProtection.protection_type &&
                                typehelper.isString(propertyDescription.dataProtection.protection_type) &&
                                propertyDescription.dataProtection.protection_type.toUpperCase();
                            var tokenSet = propertyDescription.token_set &&
                                typehelper.isString(propertyDescription.token_set) &&
                                propertyDescription.token_set.toUpperCase();
                            if (dataProtectionType === "TOKENIZEMSRENCRYPT") {
                                tokenizationPromises.push(_this.tokenizeMsrCryptoEncryption(propertyDescription, propertyName, eventHub, userInputData, pidlOperation, encryptionHandler === null || encryptionHandler === void 0 ? void 0 : encryptionHandler[EncryptionTypes.Tokenization]));
                            }
                            else if (dataProtectionType === "HMACSIGNATURE") {
                                tokenizationPromises.push(_this.createHmacSignature(eventHub, propertyName, userInputData, context, pidlOperation, propertyDescription));
                            }
                            else if (dataProtectionType === "HMACSIGNATUREMSRENCRYPT") {
                                tokenizationPromises.push(_this.createHmacSignature(eventHub, propertyName, userInputData, context, pidlOperation, propertyDescription, encryptionHandler === null || encryptionHandler === void 0 ? void 0 : encryptionHandler[EncryptionTypes.Tokenization]));
                            }
                            else if (dataProtectionType === "MSRENCRYPT") {
                                tokenizationPromises.push(_this.msrCryptoEncryption(propertyDescription, propertyName, eventHub, userInputData));
                            }
                            else if (tokenSet === "PAYPALENCRYPTION") {
                                if (encryptionHandler && encryptionHandler[EncryptionTypes.PayPal]) {
                                    tokenizationPromises.push(_this.customEncryption(propertyDescription, propertyName, eventHub, userInputData, clientContext, encryptionHandler[EncryptionTypes.PayPal], "HEC Encryption failed."));
                                }
                                else {
                                    tokenizationPromises.push(_this.payPalHECEncryption(propertyDescription, propertyName, eventHub, userInputData, clientContext));
                                }
                            }
                            else if (tokenSet === "FILEUPLOAD") {
                                var uploadUrl = context.fileUploadUrls[propertyName];
                                tokenizationPromises.push(_this.fileUpload(propertyDescription, propertyName, eventHub, userInputData, context, pidlOperation, uploadUrl));
                            }
                            else {
                                tokenizationPromises.push(_this.serverTokenization(propertyDescription, propertyName, eventHub, userInputData, pidlOperation));
                            }
                        }
                        else {
                            if (!propertyDescription.is_optional) {
                                tokenizationPromises.push(createFakePromise({
                                    error: new pidlErrors.unexpectedError(errorMessages.tokenizationError, ["DataDescription contains a required field '" + propertyName + "' which is missing in the userInputData passed in."])
                                }));
                            }
                        }
                    }
                }
            }
            return tokenizationPromises;
        };
        this.getFileUploadUrlsInDisplayDescription = function (displayDescription, fileUploadUrls) {
            if (!displayDescription) {
                return;
            }
            if (isFilePickerDisplayDescription(displayDescription)) {
                fileUploadUrls[displayDescription.propertyName] = displayDescription === null || displayDescription === void 0 ? void 0 : displayDescription.uploadUrl;
            }
            if (isContainerDisplayDescription(displayDescription) && displayDescription.members) {
                for (var i = 0; i < displayDescription.members.length; i++) {
                    _this.getFileUploadUrlsInDisplayDescription(displayDescription.members[i], fileUploadUrls);
                }
            }
        };
        this.getFileUploadUrlsInPidlDoc = function (pidlDoc) {
            var fileUploadUrls = {};
            if (pidlDoc && pidlDoc.displayDescription && pidlDoc.displayDescription.length) {
                for (var i = 0; i < pidlDoc.displayDescription.length; i++) {
                    var displayDescription = pidlDoc.displayDescription[i];
                    _this.getFileUploadUrlsInDisplayDescription(displayDescription, fileUploadUrls);
                }
            }
            return fileUploadUrls;
        };
        // function tokenizer.tokenizeUserInputData
        //   This function takes sensitive pieces of the user's data and replaces them
        //   with tokens returned by the tokenization service.
        //
        this.tokenizeUserInputData = function (eventHub, pidlDoc, userInputData, pidlOperation, userCredential, encryptionHandler, modelData) {
            if (modelData === void 0) { modelData = null; }
            var tokenizationContext = {
                hmacContext: {
                    userCredential: userCredential,
                    pan: userInputData && userInputData.details && userInputData.details.accountToken,
                    panElement: modelData && modelData.getPropertyModelElement("accountToken")
                }
            };
            tokenizationContext.fileUploadUrls = _this.getFileUploadUrlsInPidlDoc(pidlDoc);
            var tokenizationPromises = _this.tokenizeUserInputDataInternal(eventHub, pidlDoc, userInputData, pidlOperation, null, tokenizationContext, encryptionHandler);
            return PromiseResultHelper$1.aggregateCommerceResults(tokenizationPromises, function (innerError) {
                if (innerError.code === errorMessages.tokenizationFailed.code) {
                    return innerError;
                }
                return new pidlErrors.unexpectedError(errorMessages.tokenizationFailed, [innerError.message]);
            });
        };
    }
    return Tokenizer;
}());
var Tokenizer$1 = new Tokenizer();

"use strict";
var Model = /** @class */ (function () {
    // urlsIn, userContextIn, displaySettingsIn, eventHubIn, pidlDocManagerIn, stateManagerIn
    function Model(params) {
        var _this = this;
        this.operationType = null;
        this.pidlDocManager = null;
        this.operationOptions = null;
        this.modelData = null;
        this.showMaskedValues = false;
        this.secureFieldOriginOverride = null;
        this.computedStyles = {
            style: {},
        };
        this.secureFieldResolved = false;
        this.urls = null;
        this.userContext = null;
        this.displaySettings = null;
        this.stateManager = null;
        this.view = null;
        this.eventHub = null;
        this.hasPidlResolved = false;
        this.postMessageTimeoutInMs = 200;
        this.maxRetryPostMessage = 5;
        this.pageIndex = 0;
        this.validator = null;
        this.currentlyRenderedPidl = null;
        this.callbacks = null;
        this.transformers = null;
        this.localDataSourceProviders = null;
        this.serverErrorRetries = {};
        this.suspendedNextAction = null;
        this.orchestratorId = -1;
        this.elements = [];
        this.resources = null;
        this.clientSettings = null;
        this.getClientSetting = function (settingName) {
            if (_this.clientSettings && _this.clientSettings[settingName]) {
                return _this.clientSettings[settingName];
            }
        };
        this.setOrchestratorId = function (id) {
            _this.orchestratorId = id;
        };
        this.getSubmitButton = function () {
            var children = _this.getCurrentPage().children;
            var submitGroupElement = modelElementsHelper$1.findElement(children, function (modelElement) {
                if (isGroupElement(modelElement) && modelElement.isSubmitGroup) {
                    return true;
                }
            });
            if (!submitGroupElement && !_this.callbacks.submit) {
                // Return failure when the submit group is missing and no submit callback is passed to DDC.
                _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.missingSubmitActionInPidlDoc));
                return null;
            }
            if (submitGroupElement) {
                var buttonElement = modelElementsHelper$1.findElement([submitGroupElement], function (modelElement) {
                    var submitFound = false;
                    var buttonPidlAction = isButtonElement(modelElement) && modelElement.pidlAction;
                    while (!submitFound && buttonPidlAction) {
                        submitFound = submitFound || buttonPidlAction.type === "submit" || buttonPidlAction.type === supportedPidlActions.successWithSelectedPidlAction || buttonPidlAction.type === supportedPidlActions.successWithPidlPayload || buttonPidlAction.type === supportedPidlActions.success || buttonPidlAction.type === supportedPidlActions.propertyBindingAction || buttonPidlAction.type === supportedPidlActions.mergeData;
                        buttonPidlAction = buttonPidlAction.nextAction;
                    }
                    return submitFound;
                });
                return isButtonElement(buttonElement) && buttonElement;
            }
        };
        this.setClientSettings = function (pidlDocManager) {
            var pidlDoc = pidlDocManager && pidlDocManager.getResolvedOrFirstPidlDoc();
            if (!pidlDoc || !pidlDoc.clientSettings) {
                return;
            }
            _this.clientSettings = pidlDoc.clientSettings;
        };
        this.getDataSources = function (operationType, bindingDataContext, dataSourceObjects) {
            var promises = [];
            dataSourceObjects = dataSourceObjects || pidlDocHelper$1.getDataSourceObjects(_this.pidlDocManager.getResolvedOrFirstPidlDoc());
            if (dataSourceObjects && dataSourceObjects.length) {
                dataSourceObjects.forEach(function (dataSourceObject) {
                    for (var dataSource in dataSourceObject) {
                        //check for the cached value first
                        if (!_this.modelData.getDataSource(dataSource)) {
                            promises.push(_this.getResourceData(dataSource, dataSourceObject[dataSource], operationType, bindingDataContext));
                        }
                    }
                });
            }
            return Promise.all(promises);
        };
        this.populateModelInternal = function (operationType) {
            _this.resources = new Resources(_this.pidlDocManager);
            _this.setClientSettings(_this.pidlDocManager);
            var modelElementsContainer = modelElementFactory$1.createModelElements(_this.pidlDocManager, operationType);
            if (modelElementFactory$1.isErrorObject(modelElementsContainer)) {
                return modelElementsContainer.error;
            }
            if (modelElementsContainer.warnings) {
                modelElementsContainer.warnings.forEach(function (warning) {
                    _this.eventHub.error(warning);
                });
            }
            _this.elements = modelElementsContainer.elements;
            _this.updateSubmitGroupVisibility(_this.elements, _this.displaySettings.submitButtonBlock.show);
            _this.setupSecureFields();
            return null;
        };
        this.populateModel = function (operationType, prefillData, isResourceInstance, cachePidlIdentity, propertyNamesToBeClearedFromCache) {
            var error = _this.populateModelInternal(operationType);
            if (error) {
                _this.eventHub.pageRendering(undefined);
                _this.eventHub.failure(error);
                return createFakeRejectedPromise(error);
            }
            _this.eventHub.pageRendering(modelElementsHelper$1.getDefaultSuccessPidlPayload(_this.elements, _this.eventHub));
            _this.modelData.populate(_this.elements);
            if (cachePidlIdentity) {
                _this.modelData.retrieveFromCache(cachePidlIdentity, propertyNamesToBeClearedFromCache);
            }
            var promises = [];
            if (prefillData) {
                if (isResourceInstance) {
                    promises.push(_this.transformResourceInstance(_this.elements, prefillData).then(function () {
                        _this.modelData.setInputInstance(_this.elements, prefillData);
                        modelElementsHelper$1.updateModelElements(_this.elements, { modelData: _this.modelData }, _this.eventHub);
                    }));
                }
                else {
                    _this.modelData.setPrefillData(_this, prefillData, _this.resources.constants, _this.eventHub);
                }
            }
            _this.modelData.setPrefillDataInPartnerDataSource(prefillData);
            var pidlPayload = _this.pidlDocManager.getPidlPayload();
            if (pidlPayload) {
                for (var key in pidlPayload) {
                    if (key !== pidlPayloadAttributes.pidlInfo) {
                        _this.modelData.setDataSource(key, pidlPayload[key]);
                    }
                }
                modelElementsHelper$1.updateModelElements(_this.elements, { modelData: _this.modelData }, _this.eventHub);
            }
            else {
                //get external data sources
                promises.push(_this.getDataSources(operationType, { modelData: _this.modelData, model: _this }).then(function () {
                    modelElementsHelper$1.updateModelElements(_this.elements, { modelData: _this.modelData }, _this.eventHub);
                }));
            }
            return Promise.all(promises).then(function () {
                _this.eventHub.modelUpdated(true);
            });
        };
        this.populateModelOnInternalCallback = function (operationType) {
            var error = _this.populateModelInternal(operationType);
            if (error) {
                _this.eventHub.failure(error);
                return error;
            }
            _this.modelData.updateModelElements(_this.elements);
            modelElementsHelper$1.updateModelElements(_this.elements, { modelData: _this.modelData }, _this.eventHub);
            _this.setupSecureFields();
            _this.eventHub.modelUpdated(false);
        };
        this.updateModelElementsOnInternalCallback = function (controlOperationType, maskedValuesDisplayed) {
            _this.modelData.updateModelElements(_this.elements);
            var bindingDataContext = { modelData: _this.modelData, resultData: { propertyUpdates: [] } };
            modelElementsHelper$1.updateModelElements(_this.elements, bindingDataContext, _this.eventHub);
            var conditionalPropertyUpdateValuePromises = [];
            if (bindingDataContext.resultData.propertyUpdates.length > 0) {
                var _loop_1 = function (propertyElement, propertyValue) {
                    conditionalPropertyUpdateValuePromises.push(_this.updatePropertyValue(propertyElement, propertyValue, controlOperationType, maskedValuesDisplayed).then(function () {
                        _this.eventHub.propertyConditionallyUpdated(propertyElement.getPropertyName(), propertyValue);
                    }));
                };
                for (var _i = 0, _a = bindingDataContext.resultData.propertyUpdates; _i < _a.length; _i++) {
                    var _b = _a[_i], propertyElement = _b.propertyElement, propertyValue = _b.propertyValue;
                    _loop_1(propertyElement, propertyValue);
                }
            }
            return Promise.all(conditionalPropertyUpdateValuePromises).then(function () {
                // To update any expression or other elements that are dependent on the updated properties
                if (bindingDataContext.resultData.propertyUpdates.length > 0) {
                    var bindingDataContext_1 = { modelData: _this.modelData, resultData: { propertyUpdates: [] } };
                    modelElementsHelper$1.updateModelElements(_this.elements, bindingDataContext_1, _this.eventHub);
                }
                _this.eventHub.modelUpdated(false);
            });
        };
        this.setupSecureFields = function () {
            var pageElement = _this.getCurrentPage();
            _this.setupSecureFieldsRecursive(pageElement);
        };
        this.setupSecureFieldsRecursive = function (pageElement) {
            if (!pageElement) {
                return;
            }
            var children = pageElement.children;
            if (!children) {
                return;
            }
            children.forEach(function (element) {
                if (element === null || element === void 0 ? void 0 : element.isSecureProperty()) {
                    var secureElement = element;
                    if (secureElement) {
                        secureElement.validationPromise = function () {
                            return _this.postSecureFieldMessage(secureElement.frameName, SecureFieldMessages.validate, "");
                        };
                        secureElement.submitPromise = function (tokenSet) {
                            return _this.postSecureFieldMessage(secureElement.frameName, SecureFieldMessages.prepareForSubmit, { tokenSet: tokenSet });
                        };
                        secureElement.createHmacSignature = function (tokenSet, userCredentials) {
                            return _this.postSecureFieldMessage(secureElement.frameName, SecureFieldMessages.createHmacSignature, { tokenSet: tokenSet, userCredentials: userCredentials });
                        };
                        secureElement.setFocus = function () {
                            return _this.postGuaranteedSecureFieldMessage(secureElement.frameName, SecureFieldMessages.applyFocus, "");
                        };
                    }
                }
                else if ((element === null || element === void 0 ? void 0 : element.type) === modelElementType.group) {
                    _this.setupSecureFieldsRecursive(element);
                }
            });
        };
        this.privateEventHandler = function (eventName, parameters) {
            switch (eventName) {
                case privateEventNames.success:
                    // pidlDocumentTypes.pidlOperationTypeValues.add is the operation type for both Add and Handle Challenge, see docdisplaycontrol
                    // TODO: Need to have clearAll() for success too
                    if (parameters && parameters.operationType &&
                        (parameters.operationType === pidlOperationTypeValues.add || parameters.operationType === pidlOperationTypeValues.update)) {
                        _this.pidlDocManager.clearCurrentPIDLResource();
                    }
                    break;
                case privateEventNames.failure:
                case privateEventNames.gohome:
                    _this.clearAll();
                    break;
            }
        };
        this.handleSuccess = function (response, linkedResponses) {
            _this.pidlDocManager.clearCache();
            if (response && pidlDocHelper$1.isPrimaryResource(_this.pidlDocManager.getResolvedOrFirstPidlDoc())) {
                _this.modelData.setPrimaryResourceResponse(response, linkedResponses);
            }
            // TODO: Define truthy for IClientAction and get rid of this as
            var responseClientAction = response && response.clientAction;
            if (responseClientAction) {
                return _this.handleClientAction(responseClientAction, response);
            }
            else {
                var _a = _this.pidlDocManager.getNextPidlRef() || { href: null }, href = _a.href, fetchConfig = _a.fetchConfig;
                if (href) {
                    var restMethodUrl_1 = urlBuilder$1.getRestMethodUrl(href, _this.userContext, null, { modelData: _this.modelData });
                    _this.pidlDocManager.downloadPidlDoc(_this.eventHub, restMethodUrl_1, fetchHelper.getHttpHeaders(_this.eventHub, _this.userContext, null, href, { modelData: _this.modelData }), undefined, undefined, fetchConfig).then(function (clientAction) {
                        if (clientAction && clientAction.type) {
                            return _this.handleClientAction(clientAction);
                        }
                        else {
                            return _this.populate();
                        }
                    }, function (fetchFailureMessage) {
                        _this.eventHub.failure(utils.createServerError(errorMessages.pidlDocDownloadFailed, restMethodUrl_1.url, fetchFailureMessage, [fetchFailureMessage.errorMessage]));
                        return createFakeRejectedPromise(fetchFailureMessage);
                    });
                }
                else {
                    _this.eventHub.success(_this.createSuccessEventPayload());
                    return createFakePromise();
                }
            }
        };
        this.createSuccessEventPayload = function () {
            var response = _this.modelData.getResourceResponse();
            var result = {
                id: _this.modelData.getPrimaryResourceResponseId(),
                operationType: _this.operationType,
                response: response && response.primary,
            };
            if (response && response.secondary && response.secondary.length) {
                result.secondaryResponses = response.secondary;
            }
            return result;
        };
        this.handleServerError = function (parsedServerError, requestUrl, pidlDoc) {
            var _a = parsedServerError.targettedInnerErrors, targettedInnerErrors = _a === void 0 ? [] : _a, clientAction = parsedServerError.clientAction;
            var promise$1 = createFakePromise();
            if (clientAction) {
                promise$1 = _this.doErrorNextClientAction(new pidlErrors.serverError(errorMessages.formSubmitFailed, requestUrl, parsedServerError.jsonResponse, parsedServerError.status, parsedServerError.statusText, parsedServerError.responseText, [parsedServerError.errorMessage]), parsedServerError.clientAction);
            }
            if (targettedInnerErrors.length) {
                return promise$1.then(function () {
                    var propertyErrors = [];
                    var fallbackMessage = "";
                    targettedInnerErrors.forEach(function (targettedError) {
                        if (targettedError.message === errorValue.empty) {
                            targettedError.message = "";
                        }
                        var properties = typehelper.isString(targettedError.target) ? targettedError.target.split(",") : [];
                        properties = pidlDocHelper$1.translateErrorTargetsToDisplayProperties(properties, pidlDoc);
                        var parent = modelElementsHelper$1.getParentIfSame(_this.elements, properties);
                        var inlineParentDisplayId = parent &&
                            parent.children &&
                            parent.children.length === properties.length &&
                            parent.layoutOrientation === groupLayoutOrientationTypesValues.inline ? parent.displayId : null;
                        utils.createPropertyErrors(properties, inlineParentDisplayId, modelElementsHelper$1.findFirstMatchingProperty(_this.elements, properties), targettedError, propertyErrors);
                        if (!fallbackMessage && !properties.length) {
                            fallbackMessage = targettedError.message;
                        }
                    });
                    var innerError = parsedServerError.innerError;
                    var message = (innerError && innerError.message !== errorValue.empty) ? parsedServerError.innerError.message : fallbackMessage;
                    _this.clearElementEditStates();
                    return _this.handleRetryableError(new pidlErrors.formValidationFailedError(errorMessages.formSubmissionFailedBadUserInput, message, propertyErrors, [message]), true);
                });
            }
            else {
                return promise$1.then(function () {
                    return createFakeRejectedPromise(new pidlErrors.serverError(errorMessages.formSubmitFailed, requestUrl, parsedServerError.jsonResponse, parsedServerError.status, parsedServerError.statusText, parsedServerError.responseText, [parsedServerError.errorMessage]));
                });
            }
        };
        // Always returns resolved promise
        this.handleRetryableError = function (formValidationError, serverJumpbackError) {
            var promise$1 = createFakePromise();
            var errors = formValidationError.errors;
            if (errors && errors.length) {
                // Get the first page that has an error:
                // We will start with the current page (pageIndex), as we don't want to advance beyond that.
                // Or in case of jump back, set the error page index to -1.
                var errorPageIndex_1 = !serverJumpbackError ? _this.pageIndex : -1;
                formValidationError.errors.forEach(function (error) {
                    // TODO: Define type guard for errors and use here IPropertyValidationFailedError
                    var err = error;
                    var tmpPageIndex = _this.getPropertyPageIndex(err.propertyName);
                    if (errorPageIndex_1 === -1) {
                        errorPageIndex_1 = tmpPageIndex;
                    }
                    else {
                        errorPageIndex_1 = (tmpPageIndex >= 0 && tmpPageIndex < errorPageIndex_1) ? tmpPageIndex : errorPageIndex_1;
                    }
                    var propertyElement = _this.getPropertyModelElement(err.propertyName);
                    if (propertyElement && propertyElement.onValidationFailed) {
                        var sidePropertyUpdateValuePromises = [];
                        for (var sidePropertyName in propertyElement.onValidationFailed) {
                            var sidePropertyElement = _this.getPropertyModelElement(sidePropertyName);
                            if (sidePropertyElement) {
                                var valueExpression = propertyElement.onValidationFailed[sidePropertyName];
                                var sideValue = valueExpression;
                                if (typehelper.isString(valueExpression)) {
                                    sideValue = utils.getConditionalFieldValue(valueExpression, { modelData: _this.modelData }, propertyElement);
                                }
                                sidePropertyUpdateValuePromises.push(_this.updatePropertyValue(sidePropertyElement, sideValue, controlOperationTypes.editing, false));
                            }
                        }
                        promise$1 = Promise.all(sidePropertyUpdateValuePromises).then(function () { return createFakePromise(); });
                    }
                });
                // Navigate to the earliest page with an error or navigate to any page, if it is a server jumpback error
                if (errorPageIndex_1 >= 0 && (errorPageIndex_1 < _this.pageIndex || serverJumpbackError)) {
                    promise$1 = promise$1.then(function () {
                        return _this.moveToPageIndex(errorPageIndex_1);
                    });
                }
            }
            return promise$1.then(function () {
                // log the errors for the entire page
                _this.eventHub.error(formValidationError);
                return { error: formValidationError };
            });
        };
        this.clearFlow = function () {
            var cachePidlIdentity = _this.modelData.cacheFlow();
            _this.modelData.clearFlow();
            _this.elements = [];
            _this.resources = {};
            _this.clientSettings = null;
            _this.pageIndex = 0;
            _this.pidlDocManager.reset();
            _this.showMaskedValues = false;
            _this.currentlyRenderedPidl = null;
            _this.serverErrorRetries = {};
            return cachePidlIdentity;
        };
        this.clearAll = function () {
            _this.modelData.clearAll();
            _this.clearFlow();
        };
        this.clearElementEditStates = function () {
            _this.elements.forEach(function (page) {
                // Reset the validation states of each element on this page:
                var pageModelDataProperties = _this.modelData.getModelDataProperties([page]);
                for (var propertyName in pageModelDataProperties) {
                    _this.validator.clearElementEditState(pageModelDataProperties[propertyName]);
                }
            });
        };
        this.handleRestartFlow = function () {
            // Get previous pageId before resetting the flow
            var oldPageIndex = _this.pageIndex;
            var oldPage = _this.getCurrentPage() || {};
            _this.clearFlow();
            _this.pidlDocManager.setToLastDownloadedPidlDoc(_this.eventHub);
            return _this.populate(null, true, oldPageIndex, oldPage);
        };
        this.handleRenderPidlClientAction = function (clientAction, response, isResourceInstance) {
            if (response) {
                for (var property in response) {
                    if (response.hasOwnProperty(property)) {
                        if (typeof response[property] === "object" && property !== "details") {
                            delete response[property];
                        }
                    }
                }
            }
            // Get previous pageId before resetting the flow
            var oldPageIndex = _this.pageIndex;
            var oldPage = _this.getCurrentPage();
            var cachePidlIdentity = _this.clearFlow();
            var pidlDocPromise = createFakePromise();
            if (isPidlDocumentArray(clientAction.context)) {
                _this.pidlDocManager.setPidlDoc(_this.eventHub, clientAction.context);
            }
            else if (isInvokeResourceActionApiParams(clientAction.context)) {
                var resourceActionContext = clientAction.context.resourceActionContext;
                var operationType = utils.getPidlOperationType(resourceActionContext.action);
                _this.pidlDocManager.setOperationInfo({ operationType: operationType });
                pidlDocPromise = _this.downloadPidlDocument(urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, resourceActionContext.pidlDocInfo), resourceActionContext.pidlDocInfo);
            }
            return pidlDocPromise.then(function () {
                return _this.populate(response, isResourceInstance, oldPageIndex, oldPage, clientAction.pidlRetainUserInput ? cachePidlIdentity : undefined, typehelper.isString(clientAction.pidlUserInputToClear) ? clientAction.pidlUserInputToClear.split(",") : clientAction.pidlUserInputToClear).then(function () {
                    if (clientAction.pidlError) {
                        var pidlDoc = _this.pidlDocManager.getResolvedOrFirstPidlDoc();
                        var parsedServerErrorResponse = utils.parseServerError(undefined, undefined, pidlDoc && pidlDoc.strings && pidlDoc.strings.serverErrorCodes, { status: pidlResultType.Error, failureObject: clientAction.pidlError }, _this.serverErrorRetries);
                        return _this.handleServerError(parsedServerErrorResponse, undefined, pidlDoc).then(function () {
                            return createFakePromise();
                        });
                    }
                });
            });
        };
        this.handleRenderPidlPageClientAction = function (clientAction, response, isResourceInstance) {
            if (response) {
                for (var property in response) {
                    if (response.hasOwnProperty(property)) {
                        if (typeof response[property] === "object" && property !== "details") {
                            delete response[property];
                        }
                    }
                }
            }
            if (clientAction.context && isPidlDocumentArray(clientAction.context) && clientAction.context.length > 0) {
                var pidlDoc = clientAction.context[0];
                var elements = modelElementFactory$1.createModelElementsFromDisplayDescriptions(pidlDoc.displayDescription, _this.operationType, null, null, pidlDoc, _this.pidlDocManager).elements;
                _this.updateSubmitGroupVisibility(elements, _this.displaySettings.submitButtonBlock.show);
                if (elements && elements.length > 0) {
                    _this.modelData.updateModelElements(elements);
                    _this.elements.splice(_this.pageIndex + 1, 0, elements[0]);
                    return _this.moveNextPage().then(function () {
                        _this.eventHub.renderedPidlPage();
                        return createFakePromise();
                    });
                }
            }
        };
        this.updateSubmitGroupVisibility = function (elements, showSubmitGroup) {
            var submitGroupElements = modelElementsHelper$1.findAllElements(elements, function (modelElement) {
                return isGroupElement(modelElement) && modelElement.isSubmitGroup;
            });
            for (var _i = 0, submitGroupElements_1 = submitGroupElements; _i < submitGroupElements_1.length; _i++) {
                var submitGroupElement = submitGroupElements_1[_i];
                submitGroupElement.isHidden = !showSubmitGroup;
            }
        };
        this.handleRenderModalClientAction = function (clientAction, response, isResourceInstance) {
            if (response) {
                for (var property in response) {
                    if (response.hasOwnProperty(property)) {
                        if (typeof response[property] === "object" && property !== "details") {
                            delete response[property];
                        }
                    }
                }
            }
            if (clientAction.context && isPidlDocumentArray(clientAction.context) && clientAction.context.length > 0) {
                var pidlDoc = clientAction.context[0];
                var elements = modelElementFactory$1.createModelElementsFromDisplayDescriptions(pidlDoc.displayDescription, _this.operationType, null, null, pidlDoc, _this.pidlDocManager).elements;
                _this.updateSubmitGroupVisibility(elements, _this.displaySettings.submitButtonBlock.show);
                if (elements && elements.length > 0) {
                    _this.modelData.updateModelElements(elements);
                    var currentPage = _this.getCurrentPage();
                    if (currentPage && currentPage.children && currentPage.children.length > 0) {
                        var lastElement = currentPage.children[currentPage.children.length - 1];
                        if (isGroupElement(lastElement) && lastElement.isModalGroup) {
                            currentPage.children.pop();
                        }
                    }
                    currentPage.children = __spreadArray(__spreadArray([], currentPage.children, true), elements[0].children, true);
                    _this.eventHub.modelUpdated(false);
                }
            }
        };
        this.setViewHandler = function (view) {
            // TODO: Remove access to IView from here and decouple model from view
            _this.view = view;
        };
        // TODO: figure out why throwFailures was added in the first place and maybe remove it if unnecessary anymore
        this.getLinkActionUrl = function (context, throwFailures, response) {
            if (response === void 0) { response = null; }
            var redirectContext = context;
            var _a = _this.urls, success = _a.success, failure = _a.failure;
            var redirectUrl;
            if (redirectContext && redirectContext.noCallbackParams) {
                if (redirectContext && redirectContext.baseUrl) {
                    redirectUrl = urlBuilder$1.createFromTemplate(redirectContext.baseUrl);
                }
                if (redirectUrl) {
                    return redirectUrl;
                }
                else if (throwFailures) {
                    _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.noRedirectUrlToNavigate));
                }
            }
            else if (success && failure) {
                var successUrl = success;
                var failureUrl = failure;
                // TODO: Define truthy for IRedirectUrlContext and use here.
                if (redirectContext && redirectContext.baseUrl) {
                    redirectUrl = urlBuilder$1.createFromTemplate(redirectContext.baseUrl);
                    successUrl = urlBuilder$1.addQueryStringParameters(successUrl, redirectContext.successParams);
                    failureUrl = urlBuilder$1.addQueryStringParameters(failureUrl, redirectContext.failureParams);
                }
                else if (typehelper.isString(context)) {
                    redirectUrl = urlBuilder$1.createFromTemplate(context);
                    var primaryResourceResponseId = _this.modelData.getPrimaryResourceResponseId();
                    if (primaryResourceResponseId) {
                        successUrl = urlBuilder$1.addQueryParameter(successUrl, "id", primaryResourceResponseId);
                        successUrl = configManager$1.additionalRedirectParams(successUrl, response);
                    }
                }
                if (redirectUrl) {
                    successUrl = encodeURIComponent(successUrl);
                    failureUrl = encodeURIComponent(failureUrl);
                    redirectUrl += "?ru=" + successUrl + "&rx=" + failureUrl;
                    return redirectUrl;
                }
                else if (throwFailures) {
                    _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.noRedirectUrlToNavigate));
                }
            }
            else if (throwFailures) {
                var missingParam = success ? "urls.failure" : "urls.success";
                _this.eventHub.failure(new pidlErrors.inputParameterValidationFailedError(errorMessages.inputParameterMissing, missingParam, [missingParam]));
            }
        };
        this.handleSecureFieldMessage = function (event, isTestCall) {
            if (!event || !event.data || !event.data.source || event.data.source !== SecureFieldConstants.secureFieldMessageSource || !event.data.event) {
                var sanityError = new pidlErrors.unexpectedError(errorMessages.unexpectedSecureFieldMessage);
                _this.eventHub.failure(sanityError);
                return;
            }
            _this.eventHub.secureFieldEventReceived(event.data.field, event.data.event, event.data.correlationId);
            var propertyElement;
            var promise;
            var match;
            switch (event.data.event) {
                case SecureFieldEvent.loaded:
                    if (!_this.loadedSecureFields.includes(event.data.field)) {
                        _this.loadedSecureFields.push(event.data.field);
                    }
                    propertyElement = _this.modelData.getModelDataProperty(event.data.field);
                    var payload = _this.getSecurePropertyInitializationPayload(propertyElement);
                    _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.init, payload), 0);
                    if (_this.hasPidlResolved) {
                        _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.hydrateState, ""), 0);
                    }
                    else {
                        // Clear value from potentially previous sessions.
                        _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.clearState, ""), 0);
                    }
                    var logoUrl = propertyElement.modelElement.getResolvedLogo();
                    var backgroundUrl = "";
                    if (logoUrl && event.data.field === "accountToken" && _this.hasPidlResolved) {
                        backgroundUrl = "background-image: url(".concat(logoUrl, "); background-repeat: no-repeat; background-position: right center; ");
                    }
                    if (backgroundUrl) {
                        _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.applyCss, backgroundUrl), 0);
                    }
                    var placeholder = propertyElement.modelElement.placeHolderText();
                    if (placeholder) {
                        _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.applyPlaceholder, placeholder), 0);
                    }
                    break;
                case SecureFieldEvent.initCompleted:
                    // Resolve any queued promises for this field.
                    _this.resolveSecureFieldInitCompletedPromise(event.data.field);
                    break;
                case SecureFieldEvent.keyPropertyResolved:
                    _this.hasPidlResolved = true;
                    _this.secureFieldResolved = true;
                    propertyElement = _this.modelData.getModelDataProperty(event.data.field);
                    promise = _this.updatePropertyValue(propertyElement.modelElement, event.data.payload, controlOperationTypes.finished, false).then(function () {
                        var payload = _this.getSecurePropertyInitializationPayload(propertyElement);
                        _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.init, payload), 0);
                        var logoUrl = propertyElement.modelElement.getResolvedLogo();
                        var backgroundUrl = "";
                        if (logoUrl) {
                            backgroundUrl = "background-image: url(".concat(logoUrl, "); background-repeat: no-repeat; background-position: right center; ");
                        }
                        if (backgroundUrl) {
                            _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.applyCss, backgroundUrl), 0);
                        }
                        // Update the property value again to ensure the value is validated with the new validation rules.
                        _this.updatePropertyValue(propertyElement.modelElement, event.data.payload, controlOperationTypes.finished, false).catch(function (error) {
                            // Do nothing
                        });
                        var placeholder = propertyElement.modelElement.placeHolderText();
                        if (placeholder) {
                            _this.guaranteedPostMessage(event.data.field, _this.buildMessage(SecureFieldMessages.applyPlaceholder, placeholder), 0);
                        }
                        // Re-intialize the cvvToken field from the new pidl.
                        var cvvElement = _this.modelData.getModelDataProperty("cvvToken");
                        payload = _this.getSecurePropertyInitializationPayload(cvvElement);
                        _this.guaranteedPostMessage("cvvToken", _this.buildMessage(SecureFieldMessages.init, payload), 0);
                        return _this.updatePropertyValue(cvvElement.modelElement, "", controlOperationTypes.finished, false);
                    }).catch(function (error) {
                        _this.secureFieldResolved = false;
                    });
                    if (isTestCall) {
                        return promise;
                    }
                    break;
                case SecureFieldEvent.valueUpdated:
                    var editState = event.data.payload.editState;
                    var operationType = event.data.payload.operationType;
                    propertyElement = _this.modelData.getModelDataProperty(event.data.field);
                    propertyElement.editState = editState;
                    promise = _this.updatePropertyValue(propertyElement.modelElement, "", operationType, false);
                    if (isTestCall) {
                        return promise;
                    }
                    break;
                case SecureFieldEvent.readyForSubmit:
                    match = _this.queuedSecureFieldPromises.find(function (x) { return x.id === event.data.correlationId; });
                    if (match) {
                        if (event.data.payload.error) {
                            _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.tokenizationFailed, [event.data.payload.error]));
                            return;
                        }
                        var value = {
                            value: event.data.payload.value,
                            propertyName: event.data.field
                        };
                        match.resolve(value);
                    }
                    else {
                        _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.secureFieldPromiseNotFound));
                    }
                    break;
                case SecureFieldEvent.validationCompleted:
                    match = _this.queuedSecureFieldPromises.find(function (x) { return x.id === event.data.correlationId; });
                    if (match) {
                        match.resolve(event.data.payload);
                    }
                    else {
                        _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.secureFieldPromiseNotFound));
                    }
                    break;
                case SecureFieldEvent.hmacSignatureCreated:
                    match = _this.queuedSecureFieldPromises.find(function (x) { return x.id === event.data.correlationId; });
                    if (match) {
                        if (event.data.payload.error) {
                            _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.hmacError, [event.data.payload.error]));
                            return;
                        }
                        var value = {
                            value: event.data.payload.value,
                            propertyName: event.data.field
                        };
                        match.resolve(value);
                    }
                    else {
                        _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.secureFieldPromiseNotFound));
                    }
                    break;
                default:
                    var error = new pidlErrors.unexpectedError(errorMessages.unmatchedSecureFieldEvent, [event.data.event]);
                    _this.eventHub.failure(error);
            }
        };
        this.handleChallengeiFrameMessage = function (event, isTestCall) {
            switch (event.data) {
                case ChallengeiFrameEvent.challengeiFrameLoaded:
                case ChallengeiFrameEvent.challengeCompleted:
                    _this.eventHub.challengeMessageReceived(event.data);
                    break;
                default:
                    var error = new pidlErrors.unexpectedError(errorMessages.unexpectedChallengeiFrameMessage);
                    _this.eventHub.failure(error);
            }
        };
        this.handleClientAction = function (clientAction, response, originator) {
            _this.eventHub.clientActionInvoked(clientAction === null || clientAction === void 0 ? void 0 : clientAction.type, { originator: originator });
            var error;
            switch (clientAction.type) {
                case clientActionTypeValues.None:
                    _this.eventHub.success(_this.createSuccessEventPayload());
                    break;
                case clientActionTypeValues.UpdatePropertyValue:
                    if (clientAction.context) {
                        var _a = clientAction.context, propertyName = _a.propertyName, propertyValue = _a.propertyValue;
                        var propertyElement = _this.getPropertyModelElement(propertyName);
                        if (propertyElement) {
                            return _this.updatePropertyValue(propertyElement, propertyValue, controlOperationTypes.editing, false);
                        }
                    }
                    break;
                case clientActionTypeValues.Redirect:
                    // TODO: Define type guard for context and get rid of this as
                    var redirectUrl = _this.getLinkActionUrl(clientAction.context, true, response);
                    if (redirectUrl) {
                        var oldPageIndex = _this.pageIndex;
                        var oldPage = _this.getCurrentPage() || {};
                        if (clientAction.redirectPidl) {
                            _this.eventHub.navigate("", redirectUrl, true, clientAction.context, null);
                            _this.clearFlow();
                            _this.pidlDocManager.setPidlDoc(_this.eventHub, clientAction.redirectPidl);
                            return _this.populate(response, true, oldPageIndex, oldPage);
                        }
                        else {
                            if (!_this.eventHub.navigate("", redirectUrl, true, clientAction.context, null)) {
                                _this.eventHub.redirecting(redirectUrl);
                                iocContainer$1.getRedirectionService().redirect(redirectUrl);
                            }
                            _this.clearFlow();
                        }
                    }
                    break;
                case clientActionTypeValues.Pidl:
                    return _this.handleRenderPidlClientAction(clientAction, response, true);
                case clientActionTypeValues.ReturnContext:
                    if (!clientAction.context) {
                        error = new pidlErrors.unexpectedError(errorMessages.invalidReturnContextPidl);
                        _this.eventHub.failure(error);
                    }
                    else {
                        // TODO: Update context definition to match ISuccessResponsePayload
                        _this.eventHub.success(clientAction.context);
                    }
                    break;
                case clientActionTypeValues.GoHome:
                    _this.eventHub.gohome();
                    break;
                case clientActionTypeValues.Failure:
                    var failureEvent = utils.createServerErrorFromIPxServiceError(originator === requestOriginator.iFrameMessageHandler ? errorMessages.iFrameReturnedFailure : errorMessages.failureClientActionReturned, clientAction.context);
                    _this.eventHub.failure(failureEvent);
                    break;
                case clientActionTypeValues.PidlModal:
                    _this.handleRenderModalClientAction(clientAction, response, true);
                    break;
                case clientActionTypeValues.PidlPage:
                    return _this.handleRenderPidlPageClientAction(clientAction, response, true);
                case clientActionTypeValues.MergeData:
                    if (clientAction.context && clientAction.context.payload) {
                        var context = clientAction.context;
                        var payload = context.payload;
                        _this.modelData.updateUserData(payload);
                        _this.eventHub.modelUpdated(false, true);
                    }
                    break;
                case clientActionTypeValues.RestAction:
                    if (clientAction.context) {
                        return _this.invokeRestMethod(clientAction.context);
                    }
                default:
                    error = new pidlErrors.unexpectedError(errorMessages.unknownClientActionType, [clientAction.type]);
                    _this.eventHub.failure(error);
                    break;
            }
            return error ? createFakeRejectedPromise(error) : createFakePromise();
        };
        this.doErrorNextClientAction = function (error, clientAction) {
            switch (clientAction.type) {
                case clientActionTypeValues.None:
                    return createFakePromise();
                case clientActionTypeValues.UpdatePropertyValue:
                    if (clientAction.context) {
                        var _a = clientAction.context, propertyName = _a.propertyName, propertyValue = _a.propertyValue, terminalError_1 = _a.terminalError;
                        var propertyElement = _this.getPropertyModelElement(propertyName);
                        if (propertyElement) {
                            return _this.updatePropertyValue(propertyElement, propertyValue, controlOperationTypes.editing, false).then(function () {
                                if (terminalError_1) {
                                    return createFakeRejectedPromise(error);
                                }
                                else {
                                    return createFakePromise();
                                }
                            });
                        }
                    }
                    return createFakePromise();
                case clientActionTypeValues.Pidl:
                    return _this.handleRenderPidlClientAction(clientAction, null, false).then(function () {
                        if (_this.modelData.retrieveFromCache()) {
                            _this.eventHub.dataUpdated();
                        }
                    });
                default:
                    return createFakeRejectedPromise(error);
            }
        };
        this.readUserInputData = function (skipReportingConflictingInputValues) {
            if (skipReportingConflictingInputValues === void 0) { skipReportingConflictingInputValues = false; }
            var pageElementData = _this.view.getPageElementValues();
            for (var propertyName in pageElementData) {
                var modelElement = _this.getPropertyModelElement(propertyName);
                var stringValue = pageElementData[propertyName];
                if (isTextBoxElement(modelElement) &&
                    !(_this.showMaskedValues && modelElement.maskDisplay) &&
                    modelElement.displayTransformations &&
                    modelElement.displayTransformations.forModel &&
                    typehelper.isString(stringValue)) {
                    pageElementData[propertyName] = utils.applyDisplayTransformation(modelElement.displayTransformations.forModel, stringValue) || pageElementData[propertyName];
                }
            }
            var conflictingInputValuesReporter = skipReportingConflictingInputValues ? null : function (propertyName) { _this.eventHub.conflictingInputValues(propertyName); };
            _this.modelData.mergeUserData(_this, pageElementData, conflictingInputValuesReporter);
        };
        this.resolveKeyProperty = function (pageModelDataProperties) {
            for (var propertyName in pageModelDataProperties) {
                var modelDataProperty = pageModelDataProperties[propertyName];
                if (modelDataProperty && isPropertyElement(modelDataProperty.modelElement)) {
                    var propertyElement = modelDataProperty.modelElement;
                    var value = propertyElement.isKeyProperty && !propertyElement.hidden() && modelDataProperty.getValue();
                    // TODO: Handle the case for values which might be treated as false by truthy (like empty string, false boolean value, etc.)
                    if (value) {
                        return _this.updateResolvedPidlDoc(value, propertyElement, controlOperationTypes.finished);
                    }
                }
            }
            return createFakePromise(true);
        };
        this.validatePage = function (validationOption) {
            var pageModelDataProperties = _this.modelData.getModelDataProperties([_this.getCurrentPage()]);
            var promise$1 = (validationOption === validationOptions.all) && _this.resolveKeyProperty(pageModelDataProperties) || createFakePromise();
            return promise$1.then(function () {
                pageModelDataProperties = _this.modelData.getModelDataProperties([_this.getCurrentPage()]);
                return _this.validator.validatePage(pageModelDataProperties, validationOption, _this.operationType);
            });
        };
        this.getClientDataProperties = function () {
            var clientDataProperties = { sessionId: utils.guid() };
            if (_this.operationOptions) {
                var _a = _this.operationOptions, sessionId = _a.sessionId, riskData = _a.riskData;
                if (sessionId) {
                    clientDataProperties.sessionId = sessionId;
                }
                if (riskData && riskData.greenId) {
                    clientDataProperties.greenId = riskData.greenId;
                }
            }
            return clientDataProperties;
        };
        this.getInputDataFromResponse = function (newInputData, payload, response) {
            for (var key in payload) {
                var value = payload[key];
                if (value.match && value.match(new RegExp("^\{(.)*\}$"))) {
                    var newKey = value.substring(1, value.length - 1);
                    if (!response || !response[newKey]) {
                        return new pidlErrors.unexpectedError(errorMessages.expectedPayloadValueNotPresentInServerResponse);
                    }
                    newInputData[key] = response[newKey];
                }
                else {
                    newInputData[key] = value;
                }
            }
            return null;
        };
        this.invokeSubmitRequest = function (pidlDoc, request, isSubmitRequest) {
            if (isSubmitRequest === void 0) { isSubmitRequest = true; }
            var submit = _this.callbacks.submit;
            var submissionSuccessTransformer = _this.transformers.submissionSuccessTransformer;
            if (isSubmitRequest && submit && (pidlDocHelper$1.isPrimaryResource(pidlDoc) || !request.url)) {
                return new Promise(function (resolve, reject) {
                    submit(request, { pidlDoc: pidlDoc }, function (response) {
                        resolve(response);
                    }, function (responseText, errors) {
                        reject(utils.parseCustomSubmitError(responseText, errors, request.url, request.errorCodeExpressions, pidlDoc && pidlDoc.strings && pidlDoc.strings.serverErrorCodes, _this.serverErrorRetries));
                    });
                });
            }
            else {
                if (!request.url || !request.virtualEndpoint) {
                    var error = new pidlErrors.unexpectedError(errorMessages.submitPidlRequestMissingParameters, [!request.url ? "url" : "virtualEndpoint"]);
                    _this.eventHub.failure(error);
                    return createFakeRejectedPromise(error);
                }
                return new Promise(function (resolve, reject) {
                    iocContainer$1.getPidlService().submitPidlDocument(_this.eventHub, request, _this.operationType, submissionSuccessTransformer).then(function (responseJson) {
                        resolve(responseJson);
                    }, function (fetchFailureMessage) {
                        reject(utils.parseServerError(request.url, request.errorCodeExpressions, pidlDoc && pidlDoc.strings && pidlDoc.strings.serverErrorCodes, fetchFailureMessage, _this.serverErrorRetries));
                    });
                });
            }
        };
        // TODO: Removed IDeferred and replace with regular promise
        this.submitValidatedData = function (deferred, pidlDoc, inputData, pidlAction, submitCount, response) {
            var _a;
            var id = _this.modelData.getId();
            pidlAction = pidlAction || pidlDocHelper$1.getSubmitPidlAction(pidlDoc) || {};
            submitCount = submitCount || 1;
            var isSubmitRequest = pidlAction.type !== supportedPidlActions.validate;
            var context = (submitCount === 1) ? pidlAction.context : pidlAction["context" + submitCount];
            var bindingDataContext = { modelData: _this.modelData };
            var url = (context && urlBuilder$1.getSubmitUrl(_this.operationType, _this.userContext, context, id, bindingDataContext));
            var request = {
                method: context && context.method ? context.method : httpActions.Post,
                url: url && url.url,
                headers: context && fetchHelper.getHttpHeaders(_this.eventHub, _this.userContext, context && context.headers, url && url.template, bindingDataContext),
                errorCodeExpressions: context && context.errorCodeExpressions,
                virtualEndpoint: url && url.virtualEndpoint
            };
            var promise$1 = createFakePromise();
            if (context && context.payload) {
                var newInputData = {};
                var error = _this.getInputDataFromResponse(newInputData, context.payload, response);
                if (error) {
                    deferred.reject(error);
                    return;
                }
                request.data = newInputData;
            }
            else {
                request.data = inputData;
                var tokenizePromise_1 = Tokenizer$1.tokenizeUserInputData(_this.eventHub, pidlDoc, request.data, _this.operationType, _this.userContext.getUserCredential(), (_a = _this.callbacks) === null || _a === void 0 ? void 0 : _a.encryptionHandler, _this.modelData);
                // TODO: Clear up the types for Tokenizer.tokenizeUserInputData
                promise$1 = new Promise(function (resolve, reject) {
                    tokenizePromise_1.then(function (result) {
                        var error = result.error;
                        if (error) {
                            if (pidlErrors.isServerError(error) && error.code === errorMessages.tokenizationFailed.code && error.status === 400) {
                                var parsedServerError = utils.parseServerError(error.url, undefined, pidlDoc && pidlDoc.strings && pidlDoc.strings.serverErrorCodes, {
                                    status: pidlResultType.Error,
                                    errorMessage: error.debugMessage,
                                    httpStatus: error.status,
                                    httpStatusText: error.statusText,
                                    failureObject: error.innererror
                                }, _this.serverErrorRetries);
                                return _this.handleServerError(parsedServerError, error.url, pidlDoc)
                                    .then(function (error) {
                                    deferred.resolve(error);
                                })
                                    .catch(deferred.reject);
                            }
                            else {
                                reject(error);
                            }
                        }
                        else {
                            resolve();
                        }
                    }).catch(function (err) { return reject(err); });
                });
            }
            promise$1.then(function () {
                _this.invokeSubmitRequest(pidlDoc, request, isSubmitRequest).then(function (responseJson) {
                    submitCount++;
                    var nextPidlAction = pidlAction["context" + submitCount];
                    if (nextPidlAction) {
                        _this.submitValidatedData(deferred, pidlDoc, inputData, pidlAction, submitCount, responseJson);
                    }
                    else {
                        deferred.resolve({ data: responseJson });
                    }
                }, function (parsedServerError) {
                    return _this.handleServerError(parsedServerError, request.url, pidlDoc)
                        .then(function (error) {
                        deferred.resolve(error);
                    })
                        .catch(deferred.reject);
                });
            }, function (errorObject) {
                deferred.reject(new pidlErrors.serverError(errorMessages.tokenizationFailed, null, errorObject, null, null, null, [(errorObject || {}).message]));
            });
        };
        this.scopeDownPidlDocAndUserInput = function (pidlAction, pidlDocument, userInputData) {
            if (pidlAction && pidlAction.type === supportedPidlActions.validate && pidlAction.context && pidlAction.context.propertyName) {
                var propertyName = pidlAction.context.propertyName;
                userInputData = commerceHelper$1.getPropertyValueFromInputData(userInputData, propertyName);
                var limitedPidlDoc = __assign(__assign({}, pidlDocument), { data_description: {} });
                var limitedDataDescription = commerceHelper$1.getPropertiesFromDataDescription(pidlDocument.data_description, propertyName);
                if (isDataDescription(limitedDataDescription)) {
                    limitedPidlDoc.data_description[propertyName] = limitedDataDescription;
                }
                else {
                    limitedPidlDoc.data_description = limitedDataDescription;
                }
                pidlDocument = limitedPidlDoc;
            }
            return { pidlDocument: pidlDocument, userInputData: userInputData };
        };
        this.validatePidlArray = function (commerceService, resolvedOrFirstPidlDoc, linkedPidls, clientDataProperties, basePidlAction) {
            var pidlDocs = __spreadArray([
                resolvedOrFirstPidlDoc
            ], linkedPidls.map(function (linkedPidl) { return _this.pidlDocManager.getLinkedPidl(pidlDocHelper$1.createIdentityHash(linkedPidl.linkedPidlId)); }), true);
            var validationErrors = [];
            var unexpectedError = null;
            var promises = pidlDocs.map(function (pidlDoc) {
                var inputData = commerceService.createUserInputData(pidlDoc, _this.modelData, clientDataProperties, _this.operationType, true);
                return UserInputDataValidator$1.validateUserInputData(_this.eventHub, pidlDoc, inputData, _this.operationType, _this.modelData).then(function (result) {
                    var innerResults = result.innerErrors;
                    if (innerResults && innerResults.length) {
                        innerResults.forEach(function (innerResult) {
                            var validationError = _this.createFormValidationError(innerResult.error);
                            if (pidlErrors.isUnexpectedError(validationError)) {
                                unexpectedError = validationError;
                            }
                            else {
                                validationErrors.push(validationError);
                            }
                        });
                    }
                });
            });
            return new Promise(function (resolve, reject) {
                Promise.all(promises).then(function () {
                    if (unexpectedError) {
                        reject(unexpectedError);
                    }
                    else if (validationErrors.length > 0) {
                        reject(validationErrors);
                    }
                    else {
                        resolve();
                    }
                }, function (errorObject) {
                    // TODO: This code path is not expected and it needs to handled correctly.
                    // If this code path is hit due to a throw in promise commerceService.validateUserInputData
                    // above, the errorObject might not have any proper message.
                    var errorMessage = (errorObject || {}).message;
                    reject(new pidlErrors.formValidationFailedError(errorMessages.formValidationFailed, errorMessage, [errorObject], [errorMessage]));
                });
            });
        };
        this.getResolvedOrFirstPidlDoc = function (pidlDocs, inputData) {
            if (pidlDocs.length === 1 || !inputData) {
                return pidlDocs[0];
            }
            return commerceHelper$1.getFirstResolvedPidlDocument(pidlDocs, inputData) || pidlDocs[0];
        };
        this.createFormValidationError = function (propertyError) {
            var propertyName = propertyError.propertyName, errorCode = propertyError.errorCode, debugMessage = propertyError.debugMessage;
            if (!propertyName) {
                return;
            }
            var modelDataProperty = _this.modelData.getModelDataProperty(propertyName);
            // If the modelDataProperty is null, this means this property is not mapped to a property defined in displayDescription.
            // Due to this, end user cannot enter/update value for the property.
            // For such a property, value could either be defined in the PIDL or could be send by partner.
            // Any validation error for such a property seems to be some integration issue and it is not user actionable.
            // So it is better to bail out and return a failure to partner for this error.
            if (!modelDataProperty) {
                return new pidlErrors.unexpectedError(errorMessages.validationFailedForNonUserInputProperty, [propertyName, errorCode, debugMessage]);
            }
            else {
                modelDataProperty.editState = propertyEditState.dirty;
                var property = modelElementsHelper$1.findPropertyElement(_this.elements, propertyName);
                if (property) {
                    propertyError.message = property.getErrorMessage(_this.getPropertyValue(propertyName), errorCode);
                }
                return propertyError;
            }
        };
        this.validateAndTransformUserInputPidlData = function (commerceService, pidlDocs, clientDataProperties, pidlAction, isLinkedPidl, onRetryableValidationErrors, onTransformSuccess) {
            return commerceService.createUserSecureInputData(pidlDocs[0], _this.modelData, clientDataProperties, _this.operationType, true).then(function (secureInputData) {
                var inputData = commerceService.createUserInputData(pidlDocs[0], _this.modelData, clientDataProperties, _this.operationType, true);
                if (inputData.details && secureInputData) {
                    inputData.details = utils.extend({}, inputData.details, secureInputData);
                }
                else if (inputData && secureInputData) {
                    // In case of Cvv challenge and search transaction, inputData.details does not exist, so we need to add secure data directly to inputData.
                    inputData = utils.extend({}, inputData, secureInputData);
                }
                var pidlDoc = _this.getResolvedOrFirstPidlDoc(pidlDocs, inputData);
                if (isLinkedPidl && !commerceService.canSubmitUserInputData(pidlDoc, inputData)) {
                    return createFakePromise({});
                }
                var _a = _this.scopeDownPidlDocAndUserInput(pidlAction, pidlDoc, inputData), pidlDocument = _a.pidlDocument, userInputData = _a.userInputData;
                pidlDoc = pidlDocument;
                inputData = userInputData;
                return new Promise(function (resolve, reject) {
                    var errorMessage = "";
                    var validationErrors = [];
                    // TODO: Remove this validation code as it is performed twice (first in validateAndSubmitUserInputData())
                    return UserInputDataValidator$1.validateUserInputData(_this.eventHub, pidlDoc, inputData, _this.operationType, _this.modelData)
                        .then(function (result) {
                        var propertyErrors = result.innerErrors;
                        if (propertyErrors && propertyErrors.length) {
                            propertyErrors.forEach(function (propertyError) {
                                var validationError = _this.createFormValidationError(propertyError);
                                if (validationError) {
                                    if (pidlErrors.isUnexpectedError(validationError)) {
                                        reject(validationError);
                                    }
                                    else {
                                        validationErrors.push(validationError);
                                    }
                                }
                            });
                        }
                    })
                        .then(function () {
                        if (validationErrors.length) {
                            onRetryableValidationErrors(errorMessage, validationErrors)
                                .then(function (error) {
                                resolve(error);
                            })
                                .catch(reject);
                        }
                        else {
                            return commerceService.transformUserInputData(pidlDoc, _this.eventHub, inputData, _this.operationType).then(function () {
                                return onTransformSuccess({ resolve: resolve, reject: reject }, pidlDoc, inputData, pidlAction);
                            }, function (errorObject) {
                                var errorMessage = errorObject && errorObject.message;
                                reject(new pidlErrors.formValidationFailedError(errorMessages.propertyTransformationFailed, errorMessage, [errorObject], [errorMessage]));
                            });
                        }
                    }, function (errorObject) {
                        // TODO: This code path is not expected and it needs to handled correctly.
                        // If this code path is hit due to a throw in promise commerceService.validateUserInputData
                        // above, the errorObject might not have any proper message.
                        var error = (errorObject || {});
                        var errorMessage = error.message;
                        reject(new pidlErrors.formValidationFailedError(errorMessages.formValidationFailed, errorMessage, [error], [errorMessage]));
                    });
                });
            });
        };
        this.handleRetryableValidationErrorsOnSubmit = function (errorMessage, validationErrors) {
            return _this.handleRetryableError(new pidlErrors.formValidationFailedError(errorMessages.formValidationFailed, errorMessage, validationErrors, [errorMessage]));
        };
        // TODO: Removed IDeferred and replace with regular promise that resolves with IPromiseResult
        this.tokenizeUserInputData = function (deferred, pidlDoc, inputData) {
            var _a;
            var tokenizePromise = Tokenizer$1.tokenizeUserInputData(_this.eventHub, pidlDoc, inputData, _this.operationType, _this.userContext.getUserCredential(), (_a = _this.callbacks) === null || _a === void 0 ? void 0 : _a.encryptionHandler, _this.modelData);
            return tokenizePromise.then(function (result) {
                var error = result.error;
                if (error) {
                    deferred.reject(error);
                }
                else {
                    deferred.resolve({ data: inputData });
                }
            }).catch(function (err) { return deferred.reject(err); });
        };
        this.submitLinkedPidlArray = function (pidlArray, result, clientDataProperties, basePidlDocs, basePidlAction) {
            return new Promise(function (resolve, reject) {
                if (!basePidlDocs && (!pidlArray || pidlArray.length === 0)) {
                    resolve();
                    return;
                }
                result.pending = pidlArray.length + (basePidlDocs ? 1 : 0);
                var onPromiseComplete = function () {
                    result.pending--;
                    if (result.pending === 0) {
                        resolve();
                    }
                };
                var commerceService = iocContainer$1.getCommerceService();
                if (basePidlDocs) {
                    _this.validateAndTransformUserInputPidlData(commerceService, basePidlDocs, clientDataProperties, basePidlAction, false, _this.handleRetryableValidationErrorsOnSubmit, _this.submitValidatedData).then(function (response) {
                        if (response && response.error) {
                            result.validationError = response.error;
                        }
                        else {
                            result.baseSuccessResponse = response && response.data ? response.data : response;
                        }
                        onPromiseComplete();
                    }, function (err) {
                        if (!pidlDocHelper$1.ignoreTerminatingError(basePidlDocs)) {
                            result.baseFailure = err;
                        }
                        onPromiseComplete();
                    });
                }
                pidlArray.forEach(function (pidlDesc) {
                    var linkedPidl = _this.pidlDocManager.getLinkedPidl(pidlDocHelper$1.createIdentityHash(pidlDesc.linkedPidlId));
                    _this.validateAndTransformUserInputPidlData(commerceService, [linkedPidl], clientDataProperties, pidlDocHelper$1.getSubmitPidlAction(linkedPidl), true, _this.handleRetryableValidationErrorsOnSubmit, _this.submitValidatedData).then(function (response) {
                        result.linkedResponses.push(response);
                        onPromiseComplete();
                    }, function (err) {
                        if (!pidlDocHelper$1.ignoreTerminatingError([linkedPidl])) {
                            result.failures.push(err);
                        }
                        onPromiseComplete();
                    });
                });
            });
        };
        this.validateAndSubmitUserInputData = function (pidlAction) {
            _this.readUserInputData();
            var clientDataProperties = _this.getClientDataProperties();
            var commerceService = iocContainer$1.getCommerceService();
            var result = { failures: [], pending: 0, baseFailure: null, baseSuccessResponse: null, linkedResponses: [] };
            // If one submit is running, do not run another submit.
            if (!_this.stateManager.canApiStart(pidlDdcApiNames.modelSubmitForm).result) {
                return createFakePromise({ result: result });
            }
            _this.eventHub.submitting();
            _this.stateManager.setState(controlStates.submitting);
            var basePidls = _this.pidlDocManager.getResolvedOrAllPidlDocs();
            var pidlSubmitOrder = commerceService.getPidlSubmitOrder(basePidls[0]);
            return new Promise(function (resolve, reject) {
                // For validate pidlAction, only submit base for validation
                if (pidlAction.type === supportedPidlActions.validate) {
                    pidlSubmitOrder.beforeBase = [];
                    pidlSubmitOrder.withBase = [];
                    pidlSubmitOrder.afterBase = [];
                }
                _this.validatePidlArray(commerceService, basePidls[0], pidlSubmitOrder.beforeBase.concat(pidlSubmitOrder.withBase, pidlSubmitOrder.afterBase), clientDataProperties, pidlAction).then(function () {
                    // submit before base pidls in parallel
                    return _this.submitLinkedPidlArray(pidlSubmitOrder.beforeBase, result, clientDataProperties).then(function () {
                        if (result.failures.length !== 0
                            || (result.linkedResponses && result.linkedResponses.length && result.linkedResponses.some(function (res) { return res.error; }))) {
                            // at least one beforeBase submit failed, do not continue submitting pidls
                            resolve();
                        }
                        else {
                            // submit base pidl with pidlSubmitOrder.withBase in parallel
                            return _this.submitLinkedPidlArray(pidlSubmitOrder.withBase, result, clientDataProperties, basePidls, pidlAction).then(function () {
                                if (result.failures.length !== 0 || result.baseFailure) {
                                    // base pidl or at least one withBase submit failed, do not continue submitting pidls
                                    resolve();
                                }
                                else {
                                    // submit after base pidls in parallel
                                    return _this.submitLinkedPidlArray(pidlSubmitOrder.afterBase, result, clientDataProperties).then(function () {
                                        resolve();
                                    });
                                }
                            });
                        }
                    });
                }, function (errors) {
                    if (pidlErrors.isUnexpectedError(errors)) {
                        result.failures.push(errors);
                        resolve();
                    }
                    else {
                        return _this.handleRetryableValidationErrorsOnSubmit("", (Array.isArray(errors) ? __spreadArray([], errors, true) : [errors])).
                            then(function (error) {
                            result.validationError = error.error;
                            resolve();
                        });
                    }
                }).catch(function (e) { resolve(); });
            }).then(function () {
                _this.stateManager.setState(controlStates.executing);
                _this.eventHub.submitted();
                return { result: result, basePidls: basePidls };
            });
        };
        this.transformResourceInstance = function (modelElements, resourceInstance) {
            // Always return success
            return Promise.all(_this.transformResourceInstanceInternal(modelElements, iocContainer$1.getCommerceService(), resourceInstance)).
                then(doNothing, doNothing);
        };
        this.transformResourceInstanceInternal = function (modelElements, commerceService, resourceInstance) {
            var promises = [];
            modelElements.forEach(function (modelElement) {
                if (isPropertyElement(modelElement) && modelElement.supportsDisplayTransformation) {
                    var pidlDocs = modelElement && modelElement.isLinkedPidl && modelElement.pidlIdentity ?
                        [_this.pidlDocManager.getLinkedPidl(modelElement.pidlIdentity)] :
                        _this.pidlDocManager.getResolvedOrAllPidlDocs();
                    promises = __spreadArray(__spreadArray([], promises, true), [
                        commerceService.transformUserInputPropertyForDisplay(pidlDocs, _this.eventHub, modelElement.getPropertyName(), resourceInstance, _this.operationType)
                    ], false);
                }
                if (modelElement.children && modelElement.children.length) {
                    promises = __spreadArray(__spreadArray([], promises, true), _this.transformResourceInstanceInternal(modelElement.children, commerceService, resourceInstance), true);
                }
            });
            /**
             * Promise Callsites:
             *  model.transformResourceInstance = rejection handled
             */
            return promises;
        };
        this.updateResolvedPidlDoc = function (propertyValue, propertyElement, controlOperationType) {
            /**
             * Promise Callsites:
             * model.updatePropertyValue = rejection handled
             * model.resolveKeyProperty = no rejection
             */
            return new Promise(function (resolve, reject) {
                _this.pidlDocManager.resolvePidlDoc(_this.eventHub, _this.getPropertyValue, propertyValue, propertyElement, controlOperationType).then(function (isResolved) {
                    if (isResolved) {
                        var resolvedPidl = _this.pidlDocManager.getResolvedOrFirstPidlDoc();
                        if (_this.currentlyRenderedPidl && _this.currentlyRenderedPidl.identity &&
                            resolvedPidl && resolvedPidl.identity &&
                            typehelper.objectEquals(_this.currentlyRenderedPidl.identity, resolvedPidl.identity)) {
                            resolve(false);
                        }
                        if (resolvedPidl && pidlDocHelper$1.isPrimaryResource(resolvedPidl)) {
                            _this.eventHub.updateTelemetryContext(resolvedPidl.identity);
                        }
                        // This is set to skip the data conflict reporting because in this flow (pidl change) resolution is done before
                        // the modelData is updated by the view.input Handler
                        _this.readUserInputData(true);
                        // TODO: Need to handle error returned from populateModelOnInternalCallback
                        _this.populateModelOnInternalCallback(_this.operationType);
                        _this.currentlyRenderedPidl = resolvedPidl;
                    }
                    resolve(isResolved);
                }).catch(function (err) { resolve(false); });
            });
        };
        this.updatePropertyValueInternal = function (propertyElement, propertyValue, controlOperationType) {
            if (propertyElement && propertyElement.getPropertyName) {
                // TODO: Make ModelData code consistent to make sure that there is always
                // a modelDataProperty corresponding to a propertyElement and get rid of null checks
                // for getModelDataProperty()
                var modelDataProperty = _this.modelData.getModelDataProperty(propertyElement.getPropertyName());
                if (modelDataProperty) {
                    if (modelDataProperty.setValue(propertyValue)) {
                        _this.setCurrentDataIndex(propertyElement.pidlIdentity, -1);
                    }
                    _this.sendResourceSelectedEventInternal(modelDataProperty, controlOperationType);
                    return _this.validator.validateProperty(modelDataProperty, controlOperationType, _this.operationType);
                }
            }
            return createFakePromise();
        };
        this.sendResourceSelectedEventInternal = function (modelDataProperty, controlOperationType) {
            if (_this.operationType === pidlOperationTypeValues.selectInstance && controlOperationType !== controlOperationTypes.finished) {
                // only send this event when the value has been edited or filled
                _this.eventHub.resourceSelected(modelDataProperty.propertyName, modelDataProperty.getValue(true, true));
            }
        };
        this.getPropertyPageIndex = function (propertyName) {
            var ret = -1;
            _this.elements.some(function (element, index) {
                if (element.children && modelElementsHelper$1.findPropertyElement(element.children, propertyName)) {
                    ret = index;
                    return true;
                }
            });
            return ret;
        };
        this.navigateToPageIndex = function (newPageIndex) {
            modelElementsHelper$1.updateModelElements(_this.elements, { modelData: _this.modelData });
            var oldPageIndex = _this.pageIndex;
            var oldPage = _this.getCurrentPage() || {};
            _this.pageIndex = newPageIndex;
            var page = _this.getCurrentPage() || {};
            _this.eventHub.pageNavigated(oldPageIndex, oldPage.displayId, oldPage.displayName, _this.pageIndex, page.displayId, page.displayName, page.containerDescription);
        };
        this.isMaskedValue = function (propertyElement, propertyValue, controlOperationType, maskedDisplayShown) {
            return propertyElement &&
                propertyElement.maskDisplay &&
                maskedDisplayShown &&
                controlOperationType === controlOperationTypes.finished &&
                propertyValue === _this.modelData.getMaskedPropertyValue(propertyElement.getPropertyName());
        };
        this.downloadPidlDocument = function (url, pidlDocInfo, pidlIdentityToResolve, hasPrefillData) {
            var headers = fetchHelper.getHttpHeaders(_this.eventHub, _this.userContext, null, url.template, null);
            // TODO: This hack is needed to make PX service route the call correctly
            // for getting anonymous PIDL document. Needs to remove it once PX fixes PIFD to
            // route it correctly.
            if (pidlDocInfo.anonymousPidl) {
                var existingFlights = headers[httpHeaders.msFlight];
                if (!existingFlights || existingFlights.indexOf("pxpidl") < 0) {
                    headers[httpHeaders.msFlight] = existingFlights ? existingFlights + ",pxpidl" : "pxpidl";
                }
            }
            // Hack used to attach clientContextInfo about the flow
            if (hasPrefillData) {
                var existingContext = headers[httpHeaders.msClientContext];
                if (existingContext) {
                    headers[httpHeaders.msClientContext] = existingContext + ",hasPrefillData";
                }
                else {
                    headers[httpHeaders.msClientContext] = "hasPrefillData";
                }
            }
            var promise$1 = _this.pidlDocManager.downloadPidlDoc(_this.eventHub, url, headers, pidlDocInfo, pidlIdentityToResolve);
            return promise$1.then(function (clientAction) {
                _this.eventHub.pidlDownloaded();
                return clientAction;
            }, function (fetchFailureMessage) {
                var errorMessage;
                if (fetchFailureMessage.connectivityError) {
                    errorMessage = errorMessages.connectivityError;
                }
                else {
                    errorMessage = errorMessages.pidlDocDownloadFailed;
                }
                var error = utils.createServerError(errorMessage, url.url, fetchFailureMessage, [fetchFailureMessage.errorMessage]);
                _this.eventHub.failure(error);
                return createFakeRejectedPromise(error);
            });
        };
        this.populate = function (prefillData, isResourceInstance, oldPageIndex, oldPage, cachePidlIdentity, propertyNamesToBeClearedFromCache) {
            _this.pageIndex = 0;
            if (_this.pidlDocManager.isEmpty()) {
                _this.eventHub.pageRendering(undefined);
                var error = new pidlErrors.unexpectedError(errorMessages.noPidlDocumentInPopulateRequest);
                _this.eventHub.failure(error);
                return createFakeRejectedPromise(error);
            }
            return _this.populateModel(_this.operationType, prefillData, isResourceInstance, cachePidlIdentity, propertyNamesToBeClearedFromCache).then(function () {
                oldPage = oldPage || {};
                var page = _this.getCurrentPage() || {};
                // TODO: production code always has stateManager defined so this check is not needed
                // but unit test code is working with dummy model instances which do not have stateManager
                // adding this check until those tests are fixed.
                if (_this.stateManager) {
                    // Updating the state to executing before sending the pageRendered event, so partners can
                    // call any subsequent method as needed.
                    _this.stateManager.setState(controlStates.executing);
                }
                _this.eventHub.pageRendered(oldPageIndex, oldPage.displayId, oldPage.displayName, _this.pageIndex, page.displayId, page.displayName, page.containerDescription);
                var pageModelDataProperties = _this.modelData.getModelDataProperties([_this.getCurrentPage()]);
                return _this.resolveKeyProperty(pageModelDataProperties).then(function () { return createFakePromise(); });
            });
        };
        this.updatePropertyValue = function (propertyElement, propertyValue, controlOperationType, maskedValuesDisplayed, broadcast, sideEffect) {
            if (broadcast === void 0) { broadcast = true; }
            if (sideEffect === void 0) { sideEffect = true; }
            if (!broadcast && propertyElement && propertyElement.broadcastTo) {
                propertyElement = _this.getPropertyModelElement(propertyElement.broadcastTo);
            }
            if (maskedValuesDisplayed) {
                if (_this.isMaskedValue(propertyElement, propertyValue, controlOperationType, maskedValuesDisplayed)) {
                    // Do not update value sent from UX, if it is a masked value
                    return createFakePromise();
                }
                else {
                    // Clear masked display value from model data
                    _this.modelData.clearMaskedPropertyValue(propertyElement.getPropertyName());
                }
            }
            var promise$1 = propertyElement && propertyElement.isKeyProperty && (propertyElement.resolutionPolicy !== resolutionPolicyValues.focusout || controlOperationType === controlOperationTypes.finished) ?
                _this.updateResolvedPidlDoc(propertyValue, propertyElement, controlOperationType) :
                createFakePromise(true);
            var propertyValueUpdated = false;
            var handler = function () {
                var currentPropertyValue = _this.modelData.getPropertyValue(propertyElement.getPropertyName());
                // if alwaysUpdateModelValue is set to true, update the property value even if it is the same
                var forceUpdatePropertyValue = propertyElement && isSelectionElement(propertyElement) && propertyElement.alwaysUpdateModelValue;
                if ((currentPropertyValue !== propertyValue) || forceUpdatePropertyValue || controlOperationType === controlOperationTypes.finished) {
                    propertyValueUpdated = true;
                    return _this.updatePropertyValueInternal(propertyElement, propertyValue, controlOperationType);
                }
            };
            return promise$1.then(handler, handler).then(function () {
                var promise$1 = createFakePromise();
                if (propertyValueUpdated && broadcast && propertyElement && propertyElement.broadcastTo) {
                    var localPropertyElementToBroadcastTo = _this.getPropertyModelElement(propertyElement.broadcastTo);
                    if (localPropertyElementToBroadcastTo) {
                        promise$1 = _this.updatePropertyValue(localPropertyElementToBroadcastTo, propertyValue, controlOperationType, maskedValuesDisplayed, broadcast);
                    }
                    promise$1 = promise$1.then(function () { return utils.broadcastPropertyValueUpdate(_this.orchestratorId, propertyElement, propertyValue, controlOperationType, maskedValuesDisplayed); });
                }
                return promise$1;
            }).then(function () {
                _this.sendSelectionChangeEvent(propertyElement, propertyValue);
            }).then(function () {
                // Take {} as a set of data descriptions, A/B/etc is a single property, Ab is a single property with a side effect to B
                // Side effects must be a 1 local hop or a 1 broadcast to 1 local hop so:
                // {Ab Ba} does not cause a stack overflow because Ba does not process its side effect to A
                // {Ab} {Ba} does not cause a feedback loop because broadcast to B disallows B from broadcasting
                // {Ab} {Bc Ca} causes C to be updated but not broadcasted back to A because change to B was caused by a broadcast
                // {Ab Bc} {Cd Da} causes D to be updated but not broadcasted back to A because change to C was caused by a broadcast
                if (propertyValueUpdated && propertyElement && propertyElement.sideEffects) {
                    var sidePropertyUpdateValuePromises = [];
                    for (var sidePropertyName in propertyElement.sideEffects) {
                        var sidePropertyElement = _this.getPropertyModelElement(sidePropertyName);
                        var valueExpression = propertyElement.sideEffects[sidePropertyName];
                        var sideValue = utils.getConditionalFieldValue(valueExpression, { modelData: _this.modelData }, propertyElement);
                        if (sideEffect && sidePropertyElement) {
                            sidePropertyUpdateValuePromises.push(_this.updatePropertyValue(sidePropertyElement, sideValue, controlOperationType, maskedValuesDisplayed, broadcast, false));
                        }
                        else if (broadcast) {
                            sidePropertyUpdateValuePromises.push(utils.broadcastPropertyValueUpdate(_this.orchestratorId, propertyElement, propertyValue, controlOperationType, maskedValuesDisplayed));
                        }
                    }
                    return Promise.all(sidePropertyUpdateValuePromises).then(function () { return createFakePromise(); });
                }
                return createFakePromise();
            }).then(function () {
                if (propertyValueUpdated && propertyElement && propertyElement.isConditionalFieldProperty()) {
                    return _this.updateModelElementsOnInternalCallback(controlOperationType, maskedValuesDisplayed);
                }
                return createFakePromise();
            }).then(function () {
                if (isCheckBoxElement(propertyElement) && propertyValueUpdated && typehelper.isBool(propertyValue)) {
                    _this.eventHub.toggleClicked(propertyElement.getPropertyName(), propertyValue);
                }
                return createFakePromise();
            });
        };
        this.sendSelectionChangeEvent = function (propertyElement, propertyValue) {
            if (isSelectionElement(propertyElement)) {
                _this.eventHub.selectionChanged(propertyElement.getPropertyName(), propertyElement.displayId, propertyValue);
                if (propertyElement.possibleOptions &&
                    propertyElement.possibleOptions[propertyValue] &&
                    propertyElement.possibleOptions[propertyValue].pidlAction &&
                    propertyElement.possibleOptions[propertyValue].pidlAction.type === supportedPidlActions.partnerAction) {
                    var params = typehelper.deepCopy(propertyElement.possibleOptions[propertyValue].pidlAction.context);
                    _this.eventHub.partnerAction(propertyElement.id, params);
                }
            }
        };
        this.sendResourceSelectedEvent = function (propertyName, controlOperationType) {
            var modelDataProperty = _this.modelData.getModelDataProperty(propertyName);
            if (modelDataProperty) {
                _this.sendResourceSelectedEventInternal(modelDataProperty, controlOperationType);
            }
        };
        this.getPropertyValue = function (propertyName) {
            return _this.modelData.getPropertyValue(propertyName);
        };
        this.getPropertyModelElement = function (propertyName) {
            return _this.modelData.getPropertyModelElement(propertyName);
        };
        this.setCurrentDataIndex = function (pidlIdentity, index) {
            _this.readUserInputData();
            _this.modelData.setMultiPropertySelectorIndex(pidlIdentity, index);
        };
        this.getCurrentDataIndex = function (pidlIdentity) {
            return _this.modelData.getMultiPropertySelectorIndex(pidlIdentity);
        };
        this.getCurrentPage = function () {
            return _this.elements[_this.pageIndex];
        };
        this.getCurrentPageId = function () {
            return (_this.elements.length > _this.pageIndex) ? _this.elements[_this.pageIndex].displayId : null;
        };
        this.getCaptchaType = function () {
            var val = _this.modelData.getPropertyValue(captchaPropertyName.captchaType);
            return val ? val : null;
        };
        this.validateEditedProperties = function () {
            return _this.validatePage(validationOptions.dirtyOnly);
        };
        this.moveToLastPage = function () {
            var togoPage = _this.elements.length - 1;
            _this.readUserInputData();
            _this.navigateToPageIndex(togoPage);
            return createFakePromise();
        };
        this.moveNextPage = function () {
            var nextPageIndex = _this.pageIndex + 1;
            if (nextPageIndex >= _this.elements.length) {
                _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.cannotMoveToNextPageAsOnLastPage));
                return createFakePromise();
            }
            _this.readUserInputData();
            return _this.validatePage(validationOptions.all).then(function () {
                // TODO: Need to fix this path for showing linked pidl data in display fields.
                var commerceService = iocContainer$1.getCommerceService();
                var userInputData = commerceService.createUserInputData(_this.pidlDocManager.getResolvedOrFirstPidlDoc(), _this.modelData, {}, _this.operationType, false);
                return commerceService.getUserDisplayDataPartial(_this.eventHub, _this.pidlDocManager, userInputData, _this.operationType).then(function (data) {
                    _this.modelData.setDisplayData(data);
                    _this.navigateToPageIndex(nextPageIndex);
                });
            });
        };
        this.submitPage = function () {
            _this.readUserInputData();
            return _this.validatePage(validationOptions.all).then(function () {
                // TODO: Need to fix this path for showing linked pidl data in display fields.
                var commerceService = iocContainer$1.getCommerceService();
                var userInputData = commerceService.createUserInputData(_this.pidlDocManager.getResolvedOrFirstPidlDoc(), _this.modelData, {}, _this.operationType, false);
                return commerceService.getUserDisplayDataPartial(_this.eventHub, _this.pidlDocManager, userInputData, _this.operationType).then(function (data) {
                    _this.modelData.setDisplayData(data);
                });
            });
        };
        this.movePrevPage = function () {
            return _this.moveToPageIndex(_this.pageIndex - 1);
        };
        this.moveToFirstPage = function () {
            return _this.moveToPageIndex(0);
        };
        this.moveToPageIndex = function (togoPage) {
            if (_this.pageIndex === togoPage || togoPage < 0 || togoPage >= _this.elements.length) {
                if (togoPage < 0) {
                    _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.cannotMoveToPrevPage));
                }
                else if (togoPage >= _this.elements.length) {
                    _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.cannotMoveToPageIndex));
                }
                return createFakePromise();
            }
            if (_this.pageIndex > togoPage) {
                _this.readUserInputData();
                _this.navigateToPageIndex(togoPage);
                return createFakePromise();
            }
            else {
                return _this.moveNextPage().then(function () {
                    return _this.moveToPageIndex(togoPage);
                });
            }
        };
        this.submitForm = function (pidlAction) {
            return _this.validateAndSubmitUserInputData(pidlAction).then(function (value) {
                var result = value.result, basePidls = value.basePidls;
                if (result.baseFailure) {
                    _this.eventHub.failure(result.baseFailure);
                    return createFakeRejectedPromise(result.baseFailure);
                }
                else if (result.failures.length >= 1) {
                    _this.eventHub.failure(result.failures[0]);
                    return createFakeRejectedPromise(result.baseFailure);
                }
                else if (result.baseSuccessResponse || pidlDocHelper$1.ignoreTerminatingError(basePidls)) {
                    // Submit succeeded or submit failed but error objects were not populated due to ignore terminating errors ->
                    // Continue as if submit succeeded.
                    return _this.handleSuccess(result.baseSuccessResponse, result.linkedResponses);
                }
            });
        };
        this.validateForm = function (pidlAction) {
            return _this.validateAndSubmitUserInputData(pidlAction).then(function (value) {
                var result = value.result;
                if (result.baseFailure || result.failures.length >= 1 || result.validationError) {
                    if (result.baseFailure) {
                        _this.eventHub.failure(result.baseFailure);
                        return createFakeRejectedPromise(result.baseFailure);
                    }
                    else if (result.failures && result.failures.length >= 1) {
                        _this.eventHub.failure(result.failures[0]);
                        return createFakeRejectedPromise(result.baseFailure);
                    }
                    else {
                        return createFakeRejectedPromise();
                    }
                }
                else if (result.baseSuccessResponse) {
                    var responseClientAction = result.baseSuccessResponse && result.baseSuccessResponse.clientAction;
                    if (responseClientAction) {
                        if (responseClientAction.type === clientActionTypeValues.MergeData) {
                            return _this.handleClientAction(responseClientAction, result.baseSuccessResponse).then(function () { return createFakePromise(); }, function (e) { return createFakeRejectedPromise(e); });
                        }
                        else {
                            if (pidlAction.nextAction) {
                                _this.suspendedNextAction = pidlAction.nextAction;
                            }
                            return _this.handleClientAction(responseClientAction, result.baseSuccessResponse).then(function () { return createFakeRejectedPromise(); }, function (e) { return createFakeRejectedPromise(e); });
                        }
                    }
                }
            });
        };
        this.createUserInputData = function (forSubmit, forPartner) {
            _this.readUserInputData();
            return iocContainer$1.getCommerceService().createUserInputData(_this.pidlDocManager.getResolvedOrFirstPidlDoc(), _this.modelData, _this.getClientDataProperties(), _this.operationType, forSubmit, forPartner);
        };
        this.returnUserInputData = function () {
            _this.readUserInputData();
            // TODO: Fix type for returned successful promise (resolve for this is called in tokenizeUserInputData)
            return _this.validateAndTransformUserInputPidlData(iocContainer$1.getCommerceService(), [_this.pidlDocManager.getResolvedOrFirstPidlDoc()], _this.getClientDataProperties(), null, false, function (errorMessage, validationErrors) {
                return createFakeRejectedPromise(new pidlErrors.formValidationFailedError(errorMessages.formValidationFailed, errorMessage, validationErrors, [errorMessage]));
            }, _this.tokenizeUserInputData);
        };
        this.gohome = function () {
            _this.eventHub.gohome();
        };
        this.moveNextOrSubmit = function () {
            if (_this.pageIndex < (_this.elements.length - 1)) {
                return _this.moveNextPage();
            }
            else {
                var submitButton = _this.getSubmitButton();
                if (submitButton && submitButton.pidlAction) {
                    return _this.invokePidlAction(submitButton.pidlAction).then(function () { return createFakePromise(); });
                }
                else {
                    _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.missingSubmitActionInPidlDoc));
                    return createFakeRejectedPromise();
                }
            }
        };
        this.submitAction = function () {
            var submitButton = _this.getSubmitButton();
            if (submitButton && submitButton.pidlAction) {
                return _this.invokePidlAction(submitButton.pidlAction).then(function () { return createFakePromise(); });
            }
            else {
                _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.missingSubmitActionInPidlDoc));
                return createFakeRejectedPromise();
            }
        };
        this.movePrevOrCancel = function () {
            if (_this.pageIndex > 0) {
                return _this.movePrevPage();
            }
            else {
                _this.gohome();
                return createFakePromise();
            }
        };
        this.invokePidlAction = function (pidlAction, additionalData) {
            var type = pidlAction.type, nextAction = pidlAction.nextAction, context = pidlAction.context;
            var params = null;
            _this.eventHub.pidlActionInvoked(type, { nextAction: nextAction === null || nextAction === void 0 ? void 0 : nextAction.type });
            return new Promise(function (resolve, reject) {
                var _a;
                switch (type) {
                    case supportedPidlActions.closePidlPage:
                        _this.movePrevPage().then(function () {
                            _this.elements.splice(_this.pageIndex + 1, 1);
                            resolve();
                        }, function () { return reject(); });
                        _this.eventHub.closePidlPage();
                        break;
                    case supportedPidlActions.closeModalDialog:
                        _this.eventHub.hideModalDialog();
                        var currentPage = _this.getCurrentPage();
                        if (currentPage && currentPage.children && currentPage.children.length > 0) {
                            var lastElement = currentPage.children[currentPage.children.length - 1];
                            if (isGroupElement(lastElement) && lastElement.isModalGroup) {
                                currentPage.children.pop();
                            }
                        }
                        resolve();
                        break;
                    case supportedPidlActions.continueSuspendedAction:
                        if (_this.suspendedNextAction) {
                            _this.invokePidlAction(_this.suspendedNextAction, additionalData).then(function () { return resolve(); }, function (e) { return reject(e); });
                        }
                        else {
                            resolve();
                        }
                        break;
                    case supportedPidlActions.propertyBindingAction:
                        var bindingPropertyName = context.bindingPropertyName, actionMap = context.actionMap;
                        var propertyValue = _this.getPropertyValue(bindingPropertyName);
                        if (typehelper.isBool(propertyValue)) {
                            propertyValue = typehelper.toString(propertyValue);
                        }
                        _this.eventHub.propertyValueSelected(bindingPropertyName, propertyValue);
                        var bindedAction = actionMap[propertyValue];
                        if (bindedAction) {
                            _this.invokePidlAction(bindedAction, additionalData).then(function () { return resolve(); }, function (e) { return reject(e); });
                        }
                        else {
                            resolve();
                        }
                        break;
                    case supportedPidlActions.mergeData:
                        var payload = context.payload;
                        _this.modelData.updateUserData(payload);
                        _this.eventHub.modelUpdated(false);
                        resolve();
                        break;
                    case supportedPidlActions.submit:
                        _this.submitForm(pidlAction).then(function () { return resolve(); }, function (e) { reject(e); });
                        break;
                    // this pidlAction moves to the previous page and deletes the page after, then invoke the default pidlAction on this page.
                    // Example: Arkose adds a new challenge page with pidlPage clientAction, this action would remove this page and move to the previous page and invoke the default submit action.
                    case supportedPidlActions.submitOriginalPidl:
                        _this.movePrevPage().then(function () {
                            _this.elements.splice(_this.pageIndex + 1, 1);
                            _this.invokeDefaultPidlAction().then(function () { return resolve(); }, function () { reject(); });
                        }, function () { return reject(); });
                        _this.eventHub.submitOriginalPidl();
                        break;
                    case supportedPidlActions.validate:
                        _this.validateForm(pidlAction).then(function () { return resolve(); }, function () { return reject(); });
                        break;
                    case supportedPidlActions.gohome:
                        _this.gohome();
                        resolve();
                        break;
                    case supportedPidlActions.first:
                        _this.moveToPageIndex(0).then(function () { return resolve(); }, function () { return reject(); });
                        break;
                    case supportedPidlActions.last:
                        _this.moveToLastPage().then(function () { return resolve(); }, function () { return reject(); });
                        break;
                    case supportedPidlActions.next:
                        _this.moveNextPage().then(function () { return resolve(); }, function () { return reject(); });
                        break;
                    case supportedPidlActions.prev:
                        _this.movePrevPage().then(function () { return resolve(); }, function () { return reject(); });
                        break;
                    case supportedPidlActions.moveToPageIndex:
                        var pageIndex = context.pageIndex;
                        _this.moveToPageIndex(pageIndex).then(function () { return resolve(); }, function () { return reject(); });
                        break;
                    case supportedPidlActions.restartFlow:
                        _this.restartFlow().then(function () { return resolve(); }, function () { return reject(); });
                        break;
                    case supportedPidlActions.restAction:
                        if (!context) {
                            _this.eventHub.error(new pidlErrors.unexpectedError(errorMessages.contextMissingFromPidlAction, [pidlAction.type]));
                            reject();
                        }
                        else {
                            _this.invokeRestMethod(context).then(function () { return resolve(); }, function () { return reject(); });
                        }
                        break;
                    case supportedPidlActions.success:
                        if (additionalData && additionalData.value) {
                            params = typehelper.deepCopy(additionalData.value);
                            params.operationType = _this.operationType;
                            _this.eventHub.success(params);
                        }
                        else {
                            _this.eventHub.success(_this.createSuccessEventPayload());
                        }
                        resolve();
                        break;
                    case supportedPidlActions.partnerAction:
                        if (additionalData && additionalData.value) {
                            params = typehelper.deepCopy(additionalData.value);
                            _this.eventHub.partnerAction(additionalData.id, params);
                        }
                        resolve();
                        break;
                    case supportedPidlActions.successWithPidlPayload:
                        params = typehelper.deepCopy(_this.createUserInputData(true));
                        params.operationType = _this.operationType;
                        if (additionalData && additionalData.value) {
                            params.additionalData = typehelper.deepCopy(additionalData.value);
                        }
                        _this.eventHub.success(params);
                        resolve();
                        break;
                    case supportedPidlActions.successWithSelectedPidlAction:
                        params = typehelper.deepCopy(_this.createUserInputData(true, true));
                        params.operationType = _this.operationType;
                        if (additionalData && additionalData.value) {
                            params.additionalData = typehelper.deepCopy(additionalData.value);
                        }
                        _this.eventHub.success(params);
                        resolve();
                        break;
                    case supportedPidlActions.navigateAndNext:
                        var navigateUrl = _this.getLinkActionUrl(context, true);
                        if (navigateUrl) {
                            var redirectionService = iocContainer$1.getRedirectionService();
                            var navigationHandled = _this.eventHub.navigate(additionalData.id, navigateUrl, false, null, additionalData.dest);
                            if (!navigationHandled && redirectionService) {
                                redirectionService.openInNewTab(navigateUrl);
                            }
                            _this.moveNextPage().then(function () { return resolve(); }, function () { return reject(); });
                        }
                        else {
                            reject();
                        }
                        break;
                    case supportedPidlActions.navigate:
                        _this.eventHub.navigate(additionalData.id, context, false, null, additionalData.dest, pidlAction.dest);
                        resolve();
                        break;
                    case supportedPidlActions.triggerEvent:
                        _this.eventHub.triggerEvent((_a = pidlAction.context.name) !== null && _a !== void 0 ? _a : "", pidlAction.context.params);
                        resolve();
                        break;
                    case supportedPidlActions.redirect:
                        _this.eventHub.navigate(additionalData.id, _this.getLinkActionUrl(context, true), true, context, null);
                        resolve();
                        break;
                    case supportedPidlActions.poll:
                        resolve();
                        break;
                    case supportedPidlActions.updatePollAndMoveLast:
                        _this.eventHub.updatePollAndMoveLast(context);
                        break;
                    case supportedPidlActions.noAction:
                        resolve();
                        break;
                    default:
                        _this.eventHub.error(new pidlErrors.unexpectedError(errorMessages.unknownActionType, [type]));
                        reject();
                        break;
                }
            }).then(function () {
                return nextAction ? _this.invokePidlAction(nextAction, additionalData) : true;
            }, function (e) {
                if (e) {
                    throw e;
                }
                return false;
            });
        };
        this.invokeDefaultPidlAction = function () {
            // get default action
            var defaultAction = modelElementsHelper$1.getDefaultPidlAction([_this.getCurrentPage()], _this.eventHub);
            // log error if default action is not found
            if (!defaultAction) {
                _this.eventHub.error(new pidlErrors.unexpectedError(errorMessages.defaultActionNotFound));
                return createFakeRejectedPromise(false);
            }
            return _this.invokePidlAction(defaultAction);
        };
        this.invokeRestMethod = function (restMethodContext) {
            if (!restMethodContext.href || !restMethodContext.method) {
                var missingParameter = !restMethodContext.href ? "href" : "method";
                _this.eventHub.error(new pidlErrors.unexpectedError(errorMessages.restActionPidlActionMissingParameters, [missingParameter]));
                return createFakePromise();
            }
            var bindingDataContext = { modelData: _this.modelData };
            var shouldHandleSuccess = restMethodContext && restMethodContext.shouldHandleSuccess;
            // TODO: This complex url handling is not needed for anything other
            // than pidl document. Complex URL scheme should be removed for
            // all cases where it is not needed
            var url = urlBuilder$1.getRestMethodUrl(restMethodContext.href, _this.userContext, _this.modelData.getId(), bindingDataContext);
            var request = {
                url: url.url,
                method: restMethodContext.method,
                headers: fetchHelper.getHttpHeaders(_this.eventHub, _this.userContext, restMethodContext.headers, url.template, bindingDataContext),
                virtualEndpoint: url.virtualEndpoint,
                errorCodeExpressions: restMethodContext.errorCodeExpressions,
                data: typehelper.serialize(restMethodContext.payload)
            };
            _this.eventHub.restMethodInvoking(url.url, _this.operationType);
            /**
             * Promise rejection handled here.
             */
            return new Promise(function (resolve, reject) {
                iocContainer$1.getPidlService().invokeRestMethod(_this.eventHub, request, _this.operationType).then(function (response) {
                    _this.eventHub.restMethodInvoked(request.url);
                    var responseClientAction = response && response.clientAction;
                    if (responseClientAction) {
                        return _this.handleClientAction(responseClientAction, response);
                    }
                    if (response && shouldHandleSuccess) {
                        _this.modelData.setPrimaryResourceResponse(response);
                        _this.eventHub.success(_this.createSuccessEventPayload());
                    }
                    resolve();
                }, function (fetchFailureMessage) {
                    var pidlDoc = _this.pidlDocManager.getResolvedOrFirstPidlDoc();
                    return _this.handleServerError(utils.parseServerError(request.url, request.errorCodeExpressions, pidlDoc && pidlDoc.strings && pidlDoc.strings.serverErrorCodes, fetchFailureMessage), request.url, _this.pidlDocManager.getResolvedOrFirstPidlDoc()).
                        then(function () { return resolve(); }, function (e) { return reject(e); });
                });
            }).then(doNothing, function (err) {
                _this.eventHub.failure(err);
                return createFakeRejectedPromise(err);
            });
        };
        this.getMultiPropertySelectorPossibleOptions = function (pidlIdentity) {
            return _this.modelData.getMultiPropertySelectorPossibleOptions(pidlIdentity);
        };
        this.restartFlow = function () {
            return new Promise(function (resolve, reject) {
                _this.handleRestartFlow().then(function () {
                    if (_this.modelData.retrieveFromCache()) {
                        _this.eventHub.dataUpdated();
                    }
                    resolve();
                }, function (e) { return reject(e); });
            });
        };
        this.refreshData = function (prefillData) {
            //check for any datasources
            var shouldUpdateModel = false;
            var getDataSourcesPromise = createFakePromise();
            var dataSourceObjects = pidlDocHelper$1.getDataSourceObjects(_this.pidlDocManager.getResolvedOrFirstPidlDoc());
            if (dataSourceObjects && dataSourceObjects.length > 0) {
                //clear the existing datasources
                _this.modelData.clearDataSourceCache();
                //first set given partner data before getting external data sources
                _this.modelData.setPrefillDataInPartnerDataSource(prefillData);
                //get external data sources
                getDataSourcesPromise = _this.getDataSources(_this.operationType, { modelData: _this.modelData, model: _this }, dataSourceObjects);
                shouldUpdateModel = true;
            }
            return getDataSourcesPromise.then(function () {
                if (shouldUpdateModel) {
                    // clear the existing modeldata properties
                    _this.modelData.clearFlow();
                    _this.modelData.populate(_this.elements);
                }
                _this.modelData.setPrefillData(_this, prefillData, _this.resources.constants, _this.eventHub);
                modelElementsHelper$1.updateModelElements(_this.elements, { modelData: _this.modelData });
                shouldUpdateModel ? _this.eventHub.modelUpdated(false) : _this.eventHub.dataUpdated();
            });
        };
        this.loadedSecureFields = [];
        this.queuedSecureFieldPromises = [];
        this.queuedIFrameLoadedPromises = [];
        this.queuedIFrameInitCompletedPromises = [];
        this.userContext = params.userContext;
        this.eventHub = params.eventHub;
        this.pidlDocManager = params.pidlDocManager;
        this.stateManager = params.stateManager;
        // TODO: remove fallback DisplaySettings once tests are fixed
        this.displaySettings = params.displaySettings || new DisplaySettings({ containerId: "" });
        this.urls = params.urls || {};
        this.callbacks = params.callbacks || {};
        this.transformers = params.transformers || {};
        this.localDataSourceProviders = params.localDataSourceProviders;
        this.modelData = new ModelData(this.pidlDocManager);
        this.eventHub.addPrivateEventHandler(this.privateEventHandler);
        this.eventHub.registerEventExtender("pageId", this.getCurrentPageId);
        this.validator = new Validator(this.eventHub, this.displaySettings.alwaysValidateOnChange);
        this.resources = new Resources(this.pidlDocManager);
        this.setClientSettings(this.pidlDocManager);
    }
    Model.prototype.getResourceData = function (dataSourceName, dataSourceObject, pidlOperation, bindingDataContext) {
        var _this = this;
        var getResourceDataPromise = null;
        var dataSourceConfig;
        if (dataSourceObject.dataSourceConfig) {
            dataSourceConfig = dataSourceObject.dataSourceConfig;
            delete dataSourceObject.dataSourceConfig;
        }
        if (isPidlLink(dataSourceObject)) {
            var href = dataSourceObject.href, method = dataSourceObject.method, headers = dataSourceObject.headers, fetchConfig = dataSourceObject.fetchConfig;
            var restMethodUrl = urlBuilder$1.getRestMethodUrl(href, this.userContext, this.modelData.getId(), bindingDataContext);
            var url = restMethodUrl.url, template = restMethodUrl.template, virtualEndpoint = restMethodUrl.virtualEndpoint;
            var request_1 = {
                url: url,
                method: method,
                virtualEndpoint: virtualEndpoint,
                pidlOperation: pidlOperation,
                headers: fetchHelper.getHttpHeaders(this.eventHub, this.userContext, headers, template, bindingDataContext),
                fetchConfig: fetchConfig
            };
            getResourceDataPromise = new Promise(function (resolve, reject) {
                return iocContainer$1.getPidlService().getInstance(_this.eventHub, request_1).then(function (instance) {
                    _this.eventHub.instanceDownloaded();
                    resolve(instance);
                }, function (fetchFailureMessage) {
                    var serverError = utils.createServerError(errorMessages.resourceInstanceDownloadFailed, request_1.url, fetchFailureMessage, [fetchFailureMessage.errorMessage]);
                    _this.eventHub.failure(serverError);
                    reject(serverError);
                });
            });
        }
        else if (isMembersInDataSources(dataSourceObject)) {
            // datasource contains PI members
            getResourceDataPromise = createFakePromise(dataSourceObject.members);
        }
        else {
            getResourceDataPromise = createFakePromise(dataSourceObject);
        }
        return new Promise(function (resolve, reject) {
            getResourceDataPromise.then(function (instance) { return __awaiter(_this, void 0, void 0, function () {
                var dataSourceValues, getLocalDataSourcePromise, mergingFunction_1;
                var _this = this;
                return __generator(this, function (_a) {
                    dataSourceValues = instance;
                    getLocalDataSourcePromise = createFakePromise(dataSourceValues);
                    if (dataSourceConfig && dataSourceConfig.useLocalDataSource && this.localDataSourceProviders && this.localDataSourceProviders[dataSourceName]) {
                        mergingFunction_1 = this.localDataSourceProviders[dataSourceName].mergingFunction || "mergeLocalData";
                        this.eventHub.getLocalDataSourceInvoked(dataSourceName);
                        getLocalDataSourcePromise = this.localDataSourceProviders[dataSourceName].getDataSource().then(function (localData) {
                            dataSourceValues = utils.getFunctionExecutionResult({ functionName: mergingFunction_1, arguments: [instance, localData] }, bindingDataContext);
                            var dataSourceValuesCount = utils.getFunctionExecutionResult({ functionName: "getDataSourceCount", arguments: [dataSourceName, dataSourceValues] }, bindingDataContext);
                            _this.eventHub.getLocalDataSourceResolved(dataSourceName, dataSourceValuesCount);
                            return dataSourceValues;
                        }, function (error) {
                            _this.eventHub.getLocalDataSourceError(dataSourceName, error);
                        });
                    }
                    return [2 /*return*/, getLocalDataSourcePromise.then(function (combinedDataSource) {
                            var filteredDataSource = combinedDataSource;
                            if (dataSourceConfig && dataSourceConfig.filter && dataSourceConfig.filter.functionName) {
                                filteredDataSource = utils.getFunctionExecutionResult({ functionName: dataSourceConfig.filter.functionName, arguments: [combinedDataSource, dataSourceConfig.filter.functionContext] }, bindingDataContext);
                            }
                            _this.modelData.setDataSource(dataSourceName, filteredDataSource);
                            resolve();
                        })];
                });
            }); }, function (error) {
                reject(error);
            });
        });
    };
    Model.prototype.postChallengeiFrameMessage = function (msg) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _a, _b;
            // the frame id "iframe_ChallengeFrame" is constructed based on the input of the displayId: "ChallengeFrame" from the pidl.json that challenge management services served.
            // Reference for postMessage to nested iframe: https://stackoverflow.com/questions/15076293/window-postmessage-to-a-nested-iframe-in-cross-domain
            var challengeiFrame = (_b = (_a = window.frames["iframe_ChallengeFrame"]) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.frames["challenge_iframe"];
            if (challengeiFrame) {
                // challenge iframe is loaded and ready to receive messages.
                var origin = "https://" + config$1.getServiceEndpoint(config$1.virtualEndpoints.challengeUI.endpoint);
                challengeiFrame.contentWindow.postMessage(msg, origin);
            }
            else {
                // challenge iframe isn't loaded yet.
                setTimeout(function () {
                    _this.postChallengeiFrameMessage(msg).then().catch(function () {
                        var error = new pidlErrors.unexpectedError(errorMessages.challengeIframeMessagePostFailure);
                        _this.eventHub.failure(error);
                    });
                }, _this.postMessageTimeoutInMs);
            }
        });
    };
    Model.prototype.postSecureFieldMessage = function (fieldName, event, message, correlationId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var msg = _this.buildMessage(event, message);
            if (correlationId) {
                msg.correlationId = correlationId;
            }
            // TODO: Figure out a way to timeout promises on queuedSecureFieldPromises.
            _this.queuedSecureFieldPromises.push({
                id: msg.correlationId,
                resolve: resolve,
                reject: reject
            });
            _this.guaranteedPostMessage(fieldName, msg, 0);
        });
    };
    Model.prototype.postGuaranteedSecureFieldMessage = function (fieldName, event, message, correlationId) {
        var msg = this.buildMessage(event, message);
        if (correlationId) {
            msg.correlationId = correlationId;
        }
        this.guaranteedPostMessage(fieldName, msg, 0);
    };
    Model.prototype.queueSecureFieldLoadedPromise = function (fieldName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queuedIFrameLoadedPromises.push({
                id: fieldName,
                resolve: resolve,
                reject: reject
            });
        });
    };
    Model.prototype.resolveSecureFieldLoadedPromise = function (fieldName) {
        // Resolve any queued promises for this field.
        this.queuedIFrameLoadedPromises.forEach(function (x) {
            if (x.id === fieldName) {
                x.resolve();
            }
        });
        // Remove any queued promises for this field.
        this.queuedIFrameLoadedPromises = this.queuedIFrameLoadedPromises.filter(function (x) { return x.id !== fieldName; });
    };
    Model.prototype.queueSecureFieldInitCompletedPromise = function (fieldName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queuedIFrameInitCompletedPromises.push({
                id: fieldName,
                resolve: resolve,
                reject: reject
            });
        });
    };
    Model.prototype.resolveSecureFieldInitCompletedPromise = function (fieldName) {
        // Resolve any queued promises for this field.
        this.queuedIFrameInitCompletedPromises.forEach(function (x) {
            if (x.id === fieldName) {
                x.resolve();
            }
        });
        // Remove any queued promises for this field.
        this.queuedIFrameInitCompletedPromises = this.queuedIFrameInitCompletedPromises.filter(function (x) { return x.id !== fieldName; });
    };
    Model.prototype.buildMessage = function (event, msg) {
        return {
            source: SecureFieldConstants.pidlSdkMessageSource,
            event: event,
            payload: msg,
            correlationId: utils.guid()
        };
    };
    Model.prototype.guaranteedPostMessage = function (frameName, msg, currentTry) {
        var _this = this;
        if (currentTry > this.maxRetryPostMessage) {
            return;
        }
        currentTry++;
        if (this.loadedSecureFields.includes(frameName) && window.frames[frameName]) {
            // Iframe is loaded and ready to receive messages.
            var origin = "https://" + config$1.getServiceEndpoint(config$1.virtualEndpoints.securePx.endpoint);
            if (this.secureFieldOriginOverride) {
                origin = this.secureFieldOriginOverride;
            }
            window.frames[frameName].postMessage(msg, origin);
            this.eventHub.secureFieldEventPosted(frameName, msg.event, msg.correlationId);
        }
        else {
            // Iframe isn't loaded yet.
            this.eventHub.secureFieldEventQueued(frameName, msg.event, msg.correlationId);
            setTimeout(function () {
                _this.guaranteedPostMessage(frameName, msg, currentTry);
            }, this.postMessageTimeoutInMs);
        }
    };
    Model.prototype.getSecurePropertyInitializationPayload = function (modelDataProperty) {
        var _a, _b, _c;
        var dataDescription = (_a = modelDataProperty === null || modelDataProperty === void 0 ? void 0 : modelDataProperty.modelElement) === null || _a === void 0 ? void 0 : _a.dataDescription;
        var displayDescription = (_b = modelDataProperty === null || modelDataProperty === void 0 ? void 0 : modelDataProperty.modelElement) === null || _b === void 0 ? void 0 : _b.displayDescription;
        var propertyName = displayDescription === null || displayDescription === void 0 ? void 0 : displayDescription.propertyName;
        var validations = dataDescription.validations == null ? [dataDescription.validation] : dataDescription.validations;
        var payload = {
            maxLength: displayDescription === null || displayDescription === void 0 ? void 0 : displayDescription.maxLength,
            isOptional: dataDescription.is_optional,
            resolutionPolicy: (_c = modelDataProperty === null || modelDataProperty === void 0 ? void 0 : modelDataProperty.modelElement) === null || _c === void 0 ? void 0 : _c.resolutionPolicy,
            keyPropertyResolutionMappings: dataDescription.keyPropertyResolutionMappings,
            propertyDataValidations: validations,
            cssStyles: this.computedStyles.style[propertyName],
            msCv: this.eventHub.getCorrelationId(),
            sessionId: this.eventHub.getSessionId(),
        };
        return payload;
    };
    Model.prototype.testHookSetCurrentPage = function (pageIndexIn) {
        this.pageIndex = pageIndexIn;
    };
    Model.prototype.testHookGetCurrentPage = function () {
        return this.pageIndex;
    };
    Model.prototype.testHookGetValidator = function () {
        return this.validator;
    };
    Model.prototype.testHookGetModelData = function () {
        return this.modelData;
    };
    Model.prototype.testHookClearElementEditStates = function () {
        return this.clearElementEditStates();
    };
    Model.prototype.testHookSetCallbacks = function (callbacksIn) {
        this.callbacks = callbacksIn;
    };
    Model.prototype.testHookSetSuspendedNextAction = function (suspendedNextAction) {
        this.suspendedNextAction = suspendedNextAction;
    };
    return Model;
}());

"use strict";
var pidlDocumentManager = /** @class */ (function () {
    function pidlDocumentManager(getPidlDocumentHook, pidlPayload) {
        var _this = this;
        this.getPidlDocumentHook = null;
        this.originalPidlDocs = [];
        this.resolvedPidlDocs = [];
        this.pidlIdentityHashMapping = {};
        this.downloadedPidlDocsByUrl = {};
        this.lastDownloadedPidlDoc = null;
        this.operationInfo = null;
        this.currentUrl = null;
        this.currentHeaders = null;
        this.pidlPayload = null;
        this.logos = [];
        this.updatePidlDocStore = function (pidls, resolvedPidlDocs, pidlDocInfo) {
            if (_this.operationInfo && _this.operationInfo.handle) {
                var store = iocContainer$1.getPidlStoreService();
                if (store) {
                    var cacheEntry = store.get(_this.operationInfo.handle);
                    pidls = pidls || (cacheEntry && cacheEntry.pidls);
                    var resolvedPidlIdentity = (resolvedPidlDocs[0] && resolvedPidlDocs[0].identity) || (cacheEntry && cacheEntry.resolvedPidlIdentity);
                    store.put(_this.operationInfo.handle, pidlDocInfo || cacheEntry.pidlDocInfo, pidls, resolvedPidlIdentity);
                }
            }
        };
        this.getResolvedLogoDescription = function (displayDescriptions) {
            for (var i = 0; i < displayDescriptions.length; i++) {
                var displayDescription = displayDescriptions[i];
                if (isLogoDisplayDescription(displayDescription)) {
                    return displayDescription;
                }
                if (isContainerDisplayDescription(displayDescription) && displayDescription.members) {
                    var resolvedDisplayDescription = _this.getResolvedLogoDescription(displayDescription.members);
                    if (resolvedDisplayDescription) {
                        return resolvedDisplayDescription;
                    }
                }
            }
        };
        this.getIdentityLessCountry = function (identity) {
            return identity.description_type + "_" + identity.type;
        };
        this.addIdentity = function (pidlDoc) {
            if (!pidlDoc || !pidlDoc.identity) {
                return;
            }
            var identityHash = pidlDocHelper$1.createIdentityHash(pidlDoc.identity);
            var identityString = _this.getIdentityLessCountry(pidlDoc.identity);
            _this.pidlIdentityHashMapping[identityHash] = identityString;
        };
        this.addLogo = function (pidlDoc) {
            var pages = pidlDoc.displayDescription;
            if (!pages || !typehelper.isArray(pages)) {
                return;
            }
            for (var index = 0; index < pages.length; index++) {
                var newLogos = [];
                pidlDocHelper$1.getLogoDescriptions(pages[index], newLogos);
                for (var i = 0; i < newLogos.length; i++) {
                    var duplicate = false;
                    for (var j = 0; j < _this.logos.length; j++) {
                        if (_this.logos[j].displayId === newLogos[i].displayId) {
                            duplicate = true;
                            break;
                        }
                    }
                    if (!duplicate) {
                        _this.logos.push(newLogos[i]);
                    }
                }
            }
        };
        this.checkPidlDoc = function (pidlDoc) {
            if (!pidlDoc) {
                return;
            }
            _this.addIdentity(pidlDoc);
            var dataDescription = pidlDoc.data_description;
            for (var dataDescriptorId in dataDescription) {
                var innerDescription = dataDescription[dataDescriptorId];
                // Check for sub-pidls, these also need to be evaluated
                if (innerDescription instanceof Array) {
                    for (var i = 0; i < innerDescription.length; i++) {
                        _this.checkPidlDoc(innerDescription[i]);
                    }
                }
            }
        };
        this.isPidlForCurrentOperation = function (pidlDoc) {
            if (_this.operationInfo &&
                _this.operationInfo.operationType &&
                pidlDoc &&
                pidlDoc.identity &&
                pidlDoc.identity.operation) {
                return typehelper.equalsIgnoreCase(_this.operationInfo.operationType, pidlDoc.identity.operation) ||
                    typehelper.equalsIgnoreCase(pidlOperationTypeValues.update, pidlDoc.identity.operation);
            }
            return true;
        };
        this.swapPidlDoc = function (eventHub, pidlDoc, pidlIdentityToResolve) {
            _this.resetPidlDocs();
            if (!pidlDoc) {
                return;
            }
            if (pidlDoc instanceof Array) {
                for (var index = 0; index < pidlDoc.length; index++) {
                    _this.checkPidlDoc(pidlDoc[index]);
                    if (_this.isPidlForCurrentOperation(pidlDoc[index])) {
                        _this.originalPidlDocs.push(pidlDoc[index]);
                        _this.addLogo(pidlDoc[index]);
                    }
                }
            }
            else {
                _this.checkPidlDoc(pidlDoc);
                if (_this.isPidlForCurrentOperation(pidlDoc)) {
                    _this.originalPidlDocs.push(pidlDoc);
                    _this.addLogo(pidlDoc);
                }
            }
            if (_this.originalPidlDocs.length === 1) {
                _this.resolvedPidlDocs = typehelper.copyArray(_this.originalPidlDocs);
            }
            else if (pidlIdentityToResolve) {
                typehelper.invokeIf(_this.originalPidlDocs, function (singlePidl) {
                    var pidlIdentity = singlePidl.identity;
                    return typehelper.objectEquals(pidlIdentityToResolve, pidlIdentity);
                }, function (i) {
                    _this.resolvedPidlDocs.push(_this.originalPidlDocs[i]);
                });
            }
            if (_this.resolvedPidlDocs.length === 0) {
                var commerceService = iocContainer$1.getCommerceService();
                var keyElementCallbackMap = pidlDocHelper$1.createKeyPropertyMap(_this.originalPidlDocs, pidlDocHelper$1.getDefaultPropertyValueGetter());
                var pidlWithValidDefaultKey = commerceService.getFirstPidlWithValidDefaultKey(_this.originalPidlDocs, keyElementCallbackMap);
                if (pidlWithValidDefaultKey) {
                    _this.resolvedPidlDocs.push(pidlWithValidDefaultKey);
                }
            }
            if (eventHub) {
                eventHub.pidlResolved("swapPidlDocs", _this.resolvedPidlDocs);
            }
        };
        this.resetPidlDocs = function () {
            _this.originalPidlDocs = [];
            _this.resolvedPidlDocs = [];
            _this.pidlIdentityHashMapping = {};
            _this.logos = [];
        };
        this.getPidlDocument = function (eventHub, request) {
            eventHub.pidlDownloading(request.url);
            /**
             * Promise Callsites:
             * pidlDocumentManager.downloadPidlDoc = rejection not handled
             *  => pidlDocManager.resolvePidlDoc = rejection handled
             *  => model.handleSuccess = rejection handled
             *  => controlApi.downloadPidlDocument = rejection handled
             */
            return new Promise(function (resolve, reject) {
                var lookupUrl = typehelper.toLowerCase(request.url);
                if (_this.pidlPayload) {
                    resolve(_this.pidlPayload);
                }
                else if (_this.downloadedPidlDocsByUrl[lookupUrl]) {
                    resolve(_this.downloadedPidlDocsByUrl[lookupUrl]);
                }
                else {
                    var pidlService = iocContainer$1.getPidlService();
                    var getPidlDocumentPromise = pidlService.getPidlDocument(eventHub, request, _this.getPidlDocumentHook);
                    return getPidlDocumentPromise.then(function (pidlDocument) {
                        _this.downloadedPidlDocsByUrl[lookupUrl] = pidlDocument;
                        resolve(pidlDocument);
                    }, function (fetchFailureMessage) {
                        reject(fetchFailureMessage);
                    });
                }
            });
        };
        this.setPidlDoc = function (eventHub, pidlDoc, pidlIdentityToResolve) {
            // downloadedPidlDocsByUrl needs to be cleared because setting a new Pidl Doc means it's going down a new flow and the downloaded pidls are not valid
            _this.clearCache();
            // Making sure that pidlDoc is an array because a lot of our current logic assumes so
            if (!(pidlDoc instanceof Array)) {
                pidlDoc = pidlDoc ? [pidlDoc] : null;
            }
            _this.swapPidlDoc(eventHub, pidlDoc, pidlIdentityToResolve);
            // TODO: If swapPidlDoc is getting called multiple times, store might already have list of PIDLs. So it will be needed to add these PIDLs in those PIDLs.
            // That is not an immediate issue for select instance calls.
            _this.updatePidlDocStore(pidlDoc, _this.resolvedPidlDocs, _this.currentPidlDocInfo);
        };
        this.getPidlPayload = function () {
            return _this.pidlPayload;
        };
        this.setToLastDownloadedPidlDoc = function (eventHub) {
            _this.setPidlDoc(eventHub, _this.lastDownloadedPidlDoc);
        };
        this.downloadPidlDoc = function (eventHub, url, headers, pidlDocInfo, pidlIdentityToResolve, fetchConfig) {
            return new Promise(function (resolve, reject) {
                _this.getPidlDocument(eventHub, {
                    url: url.url,
                    headers: headers,
                    virtualEndpoint: url.virtualEndpoint,
                    pidlOperation: _this.operationInfo.operationType,
                    fetchConfig: fetchConfig
                }).then(function (response) {
                    var _a, _b;
                    if (response && response[0] && response[0].clientAction) {
                        resolve(response[0].clientAction);
                        return;
                    }
                    var pidlDocument;
                    if (isPidlPayload(response)) {
                        for (var key in (_a = response === null || response === void 0 ? void 0 : response.pidlInfo) === null || _a === void 0 ? void 0 : _a.pidls) {
                            if (_this.operationInfo.operationType.toLowerCase() === key.toLowerCase()) {
                                pidlDocument = (_b = response === null || response === void 0 ? void 0 : response.pidlInfo) === null || _b === void 0 ? void 0 : _b.pidls[key];
                                break;
                            }
                        }
                        _this.pidlPayload = response;
                    }
                    else {
                        pidlDocument = response;
                    }
                    _this.currentUrl = url;
                    _this.currentHeaders = headers;
                    _this.currentPidlDocInfo = pidlDocInfo || _this.currentPidlDocInfo;
                    _this.lastDownloadedPidlDoc = pidlDocument;
                    _this.swapPidlDoc(eventHub, pidlDocument, pidlIdentityToResolve);
                    // TODO: If swapPidlDoc is getting called multiple times, store might already have list of PIDLs. So it will be needed to add these PIDLs in those PIDLs.
                    // That is not an immediate issue for select instance calls.
                    _this.updatePidlDocStore(pidlDocument, _this.resolvedPidlDocs, pidlDocInfo);
                    resolve();
                }, function (fetchFailureMessage) {
                    reject(fetchFailureMessage);
                });
            });
        };
        this.retrievePidlDocFromCache = function (eventHub, handle, pidlIdentityToResolve) {
            /**
             * Promise Callsites:
             * controlApi.selectResource = rejection handled
             */
            return new Promise(function (resolve, reject) {
                var store = iocContainer$1.getPidlStoreService();
                var val = store.get(handle);
                if (val && val.pidls) {
                    _this.lastDownloadedPidlDoc = val.pidls;
                    _this.swapPidlDoc(eventHub, val.pidls, pidlIdentityToResolve);
                    resolve();
                }
                else {
                    reject(errorMessages.invalidCacheEntry);
                }
            });
        };
        this.shouldDownloadNewPidl = function (newPidlIdentities, keyPropertyElement, keyValue, controlOperationType) {
            if ((newPidlIdentities instanceof Array && newPidlIdentities.length >= 1) || !_this.currentUrl) {
                return false;
            }
            // Restricting PIDL downloads for drop downs to only cases, when there is a valid selection.
            if (isDropdownElement(keyPropertyElement) && keyPropertyElement.possibleOptions && !keyValue) {
                return false;
            }
            return keyPropertyElement.triggerPidlDownloadOnChange &&
                (controlOperationType === controlOperationTypes.finished ||
                    (isDropdownElement(keyPropertyElement) && controlOperationType === controlOperationTypes.editing));
        };
        this.resolvePidlDoc = function (eventHub, propertyNameValueGetter, keyValue, keyPropertyElement, controlOperationType) {
            var commerceService = iocContainer$1.getCommerceService();
            var pidlDocs = _this.getAllPidlDocs();
            var keyPropertyMap = pidlDocHelper$1.createKeyPropertyMap(pidlDocs, pidlDocHelper$1.getPropertyValueGetter(keyPropertyElement.getPropertyName(), keyValue, propertyNameValueGetter));
            /**
             * Promise Callsites:
             * model.updateResolvedPidlDoc = rejection handled
             */
            return commerceService.resolveInfoDescriptionId(pidlDocs, keyPropertyMap).then(function (newPidlIdentities) {
                if (_this.shouldDownloadNewPidl(newPidlIdentities, keyPropertyElement, keyValue, controlOperationType)) {
                    var updatedParameters = typehelper.deepCopy(_this.currentUrl.originalParameters);
                    var pidlDocInfoUpdated = utils.updatePidlDocUrlParams(updatedParameters.pidlDocInfo, keyPropertyMap);
                    if (pidlDocInfoUpdated) {
                        var url = _this.currentUrl.recreateUrl(updatedParameters);
                        var promise = _this.downloadPidlDoc(eventHub, url, _this.currentHeaders, updatedParameters.pidlDocInfo);
                        return promise.then(function () {
                            eventHub.pidlDownloaded();
                            var reresolve = _this.resolvePidlDoc(eventHub, propertyNameValueGetter, keyValue, keyPropertyElement, controlOperationType);
                            return reresolve.then(function () {
                                return true;
                            });
                        }, function (fetchFailureMessage) {
                            eventHub.failure(utils.createServerError(errorMessages.pidlDocDownloadFailed, url.url, fetchFailureMessage, [fetchFailureMessage.errorMessage]));
                            return false;
                        });
                    }
                }
                else if (!pidlDocHelper$1.matchPidlIdsToPidls(commerceService, newPidlIdentities, _this.resolvedPidlDocs)) {
                    _this.resolvedPidlDocs = pidlDocHelper$1.resolvePidlDocs(_this.originalPidlDocs, newPidlIdentities);
                    eventHub.pidlResolved("resolvedPidlDocs", _this.resolvedPidlDocs);
                    if (_this.resolvedPidlDocs.length !== 0) {
                        return true;
                    }
                }
                return false;
            });
        };
        this.isEmpty = function () {
            return _this.originalPidlDocs.length === 0;
        };
        this.getResolvedOrAllPidlDocs = function () {
            return _this.resolvedPidlDocs.length !== 0 ? _this.resolvedPidlDocs : _this.originalPidlDocs;
        };
        this.getResolvedOrFirstPidlDoc = function () {
            if (_this.resolvedPidlDocs.length > 0) {
                return _this.resolvedPidlDocs[0];
            }
            return _this.originalPidlDocs.length > 0 ? _this.originalPidlDocs[0] : null;
        };
        this.getAllPidlDocs = function () {
            return _this.originalPidlDocs;
        };
        this.clearCurrentPIDLResource = function () {
            if (_this.currentPidlDocInfo) {
                var store = iocContainer$1.getPidlStoreService();
                store.removeResourceEntries(_this.currentPidlDocInfo.resourceType);
            }
        };
        this.getPidlIdentity = function () {
            var pidlDoc = _this.getResolvedOrFirstPidlDoc();
            if (!pidlDoc) {
                return null;
            }
            return pidlDoc.identity;
        };
        this.getAllLogos = function () {
            return _this.logos;
        };
        // Only returns a logo when there's only one resolved pidl for when there are multiple resolved pidls (e.g. Korea local cards)
        this.getResolvedLogo = function () {
            if (_this.resolvedPidlDocs.length === 1) {
                return _this.getResolvedLogoDescription(_this.resolvedPidlDocs[0].displayDescription);
            }
        };
        this.getLogoUrl = function (paymentMethodType, cardLogos) {
            var lowerCaseType = paymentMethodType.toLowerCase();
            switch (lowerCaseType) {
                case "mastercard":
                    return cardLogos["mc"];
                case "americanexpress":
                case "american express":
                    return cardLogos["amex"];
                default:
                    return cardLogos[lowerCaseType] || "";
            }
        };
        this.getLogosFromDataDescription = function () {
            var _a;
            var pidlDoc = _this.getResolvedOrFirstPidlDoc();
            if ((_a = pidlDoc === null || pidlDoc === void 0 ? void 0 : pidlDoc.data_description) === null || _a === void 0 ? void 0 : _a.cardLogos) {
                var logosDescription = pidlDoc.data_description.cardLogos;
                return (logosDescription === null || logosDescription === void 0 ? void 0 : logosDescription.possible_values) || {};
            }
            return {};
        };
        this.getIdentityString = function (identityHash) {
            if (identityHash && identityHash in _this.pidlIdentityHashMapping) {
                return _this.pidlIdentityHashMapping[identityHash];
            }
            else {
                return null;
            }
        };
        this.reset = function () {
            _this.resetPidlDocs();
            _this.operationInfo = null;
            _this.clearCache();
        };
        this.clearCache = function () {
            _this.downloadedPidlDocsByUrl = {};
        };
        this.getNextPidlRef = function () {
            if (_this.resolvedPidlDocs[0] && _this.resolvedPidlDocs[0].links) {
                return _this.resolvedPidlDocs[0].links.nextPidl;
            }
        };
        this.getLinkedPidls = function () {
            var basePidlDoc = _this.getResolvedOrFirstPidlDoc();
            if (basePidlDoc) {
                return basePidlDoc.linkedPidls;
            }
        };
        this.getLinkedPidl = function (linkedPidlId) {
            var linkedPidls = _this.getLinkedPidls();
            if (linkedPidls) {
                for (var i = 0; i < linkedPidls.length; i++) {
                    var linkedPidlHash = pidlDocHelper$1.createIdentityHash(linkedPidls[i].identity);
                    if (linkedPidlHash === linkedPidlId) {
                        return linkedPidls[i];
                    }
                }
            }
        };
        this.setOperationInfo = function (operationInfoIn) {
            _this.operationInfo = operationInfoIn;
        };
        this.getOperationHandle = function () {
            if (_this.operationInfo) {
                return _this.operationInfo.handle;
            }
            return;
        };
        this.testHookGetGetPidlDocumentHook = function () {
            return _this.getPidlDocumentHook;
        };
        this.testHookGetResolvedPidlDoc = function () {
            return _this.resolvedPidlDocs;
        };
        this.testHookSetResolvedPidlDocument = function (newResolvedPidlDocs) {
            _this.resolvedPidlDocs = newResolvedPidlDocs instanceof Array ? newResolvedPidlDocs : [newResolvedPidlDocs];
        };
        this.testHookSetCurrentUrl = function (currentUrlIn) {
            _this.currentUrl = currentUrlIn;
        };
        this.getPidlDocumentHook = getPidlDocumentHook || null;
        this.pidlPayload = pidlPayload || null;
    }
    return pidlDocumentManager;
}());

"use strict";
var apiAllowedStates = {
    addAddress: [
        controlStates.initialized
    ],
    selectPaymentInstrument: [
        controlStates.initialized
    ],
    addPaymentInstrument: [
        controlStates.initialized
    ],
    listAddress: [
        controlStates.initialized
    ],
    addResource: [
        controlStates.initialized
    ],
    applyResource: [
        controlStates.initialized
    ],
    replaceResource: [
        controlStates.initialized
    ],
    updateResource: [
        controlStates.initialized
    ],
    updateProfile: [
        controlStates.initialized
    ],
    selectResource: [
        controlStates.initialized
    ],
    selectSingleResource: [
        controlStates.initialized
    ],
    selectResourceType: [
        controlStates.initialized
    ],
    validateResource: [
        controlStates.initialized
    ],
    showResource: [
        controlStates.initialized
    ],
    offerResource: [
        controlStates.initialized
    ],
    searchResource: [
        controlStates.initialized
    ],
    deleteResource: [
        controlStates.initialized
    ],
    fundStoredValue: [
        controlStates.initialized
    ],
    createPaymentSession: [
        controlStates.initialized
    ],
    handleChallenge: [
        controlStates.initialized
    ],
    handlePaymentChallenge: [
        controlStates.initialized
    ],
    handlePurchaseRiskChallenge: [
        controlStates.initialized
    ],
    handlePurchasePendingState: [
        controlStates.initialized
    ],
    renderPidlPage: [
        controlStates.initialized
    ],
    getPidlPayload: [
        controlStates.executing
    ],
    invokePageDefaultAction: [
        controlStates.executing
    ],
    invokeResourceAction: [
        controlStates.initialized,
        controlStates.executing
    ],
    moveNextPage: [
        controlStates.executing
    ],
    submitPage: [
        controlStates.submitting,
        controlStates.executing,
        controlStates.initialized,
    ],
    movePrevPage: [
        controlStates.executing
    ],
    moveToLastPage: [
        controlStates.executing
    ],
    moveToFirstPage: [
        controlStates.executing
    ],
    refreshData: [
        controlStates.executing
    ],
    cancel: [
        controlStates.initialized,
        controlStates.executing,
        controlStates.submitting
    ],
    modelSubmitForm: [
        controlStates.executing
    ],
    handleAction: [
        controlStates.initialized
    ],
    getSelectedResource: [
        controlStates.initialized,
        controlStates.executing,
        controlStates.submitting
    ],
    renderPidlDocument: [
        controlStates.initialized
    ],
    postMessageToChildIFrames: [
        controlStates.executing,
        controlStates.submitting
    ],
    profilePrerequisite: [
        controlStates.initialized,
    ],
    handleCheckout: [
        controlStates.initialized
    ],
    getPayeeTaxProfile: [
        controlStates.initialized
    ],
    redeemMSRewards: [
        controlStates.initialized
    ],
    searchTransactions: [
        controlStates.initialized
    ],
    selectMSRewards: [
        controlStates.initialized
    ]
};
var stateManager = /** @class */ (function () {
    function stateManager(eventHub) {
        this.state = controlStates.notInitialized;
        this.eventHub = eventHub;
        var self = this;
        this.eventHub.addPrivateEventHandler(function (eventName, parameters) {
            self.privateEventHandler(eventName);
        });
    }
    stateManager.prototype.privateEventHandler = function (eventName) {
        if (this.state === controlStates.notInitialized) {
            return;
        }
        switch (eventName) {
            case privateEventNames.success:
            case privateEventNames.failure:
            case privateEventNames.gohome:
                this.setState(controlStates.initialized);
                break;
        }
    };
    stateManager.prototype.getState = function () {
        return this.state;
    };
    stateManager.prototype.setState = function (s) {
        this.eventHub.stateChanged(this.state, s);
        this.state = s;
    };
    stateManager.prototype.canApiStart = function (api) {
        if (this.state === controlStates.notInitialized) {
            return {
                error: new pidlErrors.apiValidationError(errorMessages.apiCannotStartAsControlNotInitialized, api, [api]),
                result: false
            };
        }
        var allowedStates = apiAllowedStates[api];
        if (!allowedStates) {
            return {
                error: new pidlErrors.unexpectedError(errorMessages.apiStateMappingNotFound, [api]),
                result: false
            };
        }
        if (!typehelper.contains(allowedStates, this.state)) {
            return {
                error: new pidlErrors.apiValidationError(errorMessages.apiCannotStartAsNotAllowedInCurrentState, api, [api, this.state, allowedStates.toString()]),
                result: false
            };
        }
        return { result: true };
    };
    return stateManager;
}());

"use strict";
var userContextWrapper = /** @class */ (function () {
    function userContextWrapper(userContextIn) {
        this.userContext = userContextIn;
    }
    userContextWrapper.prototype.getServiceParam = function (template, paramName) {
        if (!this.userContext) {
            return null;
        }
        var virtualEndpoint = configManager$1.findVirtualEndpointInTemplate(template);
        if (virtualEndpoint && virtualEndpoint.name && this.userContext.serviceOverrides) {
            for (var endpointName in this.userContext.serviceOverrides) {
                if (typehelper.toLowerCase(endpointName) === virtualEndpoint.name) {
                    return this.userContext.serviceOverrides[endpointName][paramName] || this.userContext[paramName];
                }
            }
        }
        return this.userContext[paramName];
    };
    userContextWrapper.prototype.getAdditionalHeaders = function (template) {
        return this.getServiceParam(template, "additionalHeaders");
    };
    userContextWrapper.prototype.getAuthToken = function (template) {
        return this.getServiceParam(template, "authToken");
    };
    userContextWrapper.prototype.getUserId = function (template) {
        return this.getServiceParam(template, "userId");
    };
    userContextWrapper.prototype.getHeaders = function (defaultHeaders, template) {
        defaultHeaders = defaultHeaders || {};
        var authToken = this.getAuthToken(template);
        if (authToken) {
            defaultHeaders[httpHeaders.authorization] = authToken;
        }
        var additionalHeaders = this.getAdditionalHeaders(template);
        if (additionalHeaders) {
            for (var key in additionalHeaders) {
                defaultHeaders[key] = additionalHeaders[key];
            }
        }
        return defaultHeaders;
    };
    userContextWrapper.prototype.getUserCredential = function (template) {
        var authToken = this.getAuthToken(template);
        if (!authToken) {
            var additionalHeaders = this.getAdditionalHeaders(template);
            for (var header in additionalHeaders) {
                if (typehelper.equalsIgnoreCase(header, httpHeaders.authorization)) {
                    authToken = additionalHeaders[header];
                    break;
                }
            }
        }
        return authToken;
    };
    return userContextWrapper;
}());

"use strict";
var ViewEventHandler = /** @class */ (function () {
    function ViewEventHandler(paramsIn) {
        var _this = this;
        this.waitForSecureFields = false;
        this.displaySettings = null;
        this.model = null;
        this.userContext = null;
        this.eventHub = null;
        this.focusTarget = null;
        this.unseenErrors = [];
        this.securePropertyPromises = [];
        this.securePropertyInitCompletedPromises = [];
        // Contains propertyName or groupDisplayId to array of propertyName or groupDisplayId for the error being processed.
        this.errorPropertyGroups = {};
        this.pollingActions = {};
        this.pageRestActions = {};
        this.valueSetters = [];
        this.view = null;
        this.pollingTimersAndCounters = {};
        this.showHideBusy = function (show) {
            if (!show && _this.displaySettings.busyUntilInitialPageRendered) {
                return;
            }
            if (_this.displaySettings.busyBlockShowHideHandler) {
                _this.displaySettings.busyBlockShowHideHandler(show);
            }
            else {
                _this.view.showHideBusy(show);
            }
        };
        this.applyForModelDisplayTransformation = function (propertyElement, value, showingMaskedValue) {
            if (isTextBoxElement(propertyElement) && !(showingMaskedValue && propertyElement.maskDisplay) && propertyElement.displayTransformations && propertyElement.displayTransformations.forModel) {
                return utils.applyDisplayTransformation(propertyElement.displayTransformations.forModel, value);
            }
        };
        this.hideError = function (propertyName) {
            // propertyName can be actual propertyName or groupDisplayId from server response
            if (propertyName) {
                _this.view.hidePropertyError(propertyName);
            }
            else {
                _this.view.hidePageError();
            }
        };
        this.showGroupError = function (error) {
            if (!error.groupDisplayId) {
                return false;
            }
            if (!_this.view.showGroupError(error)) {
                _this.unseenErrors.push(error);
            }
            return true;
        };
        this.showPropertyError = function (error) {
            if (!error.propertyName) {
                return false;
            }
            if (!_this.view.showPropertyError(error)) {
                _this.unseenErrors.push(error);
            }
            return true;
        };
        this.showPageError = function (error) {
            return _this.view.showPageError(error);
        };
        this.hideModalDialog = function () {
            return _this.view.hideModalDialog();
        };
        this.showError = function (error) {
            var shouldShowPageError = false;
            switch (error.type) {
                // formValidationFailedError has multiple errors: formValidationFailed, editedPropertiesValidationFailed, formSubmissionFailedBadUserInput, propertyTransformationFailed
                case errorTypes.formValidation:
                    var formValidationError = error;
                    if (formValidationError.errors && formValidationError.errors.length > 0) {
                        for (var i = 0; i < formValidationError.errors.length; i++) {
                            if (formValidationError.errors[i].message === errorValue.empty) {
                                formValidationError.errors[i].message = "";
                            }
                            if (!_this.showError(formValidationError.errors[i])) {
                                return;
                            }
                        }
                        if ((error.name === errorMessages.formSubmissionFailedBadUserInput.name) && (formValidationError.message !== errorValue.empty)) {
                            shouldShowPageError = true;
                        }
                    }
                    else {
                        shouldShowPageError = true;
                    }
                    break;
                case errorTypes.userInputValidation:
                    var validationError = error;
                    if (validationError.validationErrorType === validationErrorTypes.group) {
                        shouldShowPageError = !_this.showGroupError(error);
                    }
                    else {
                        shouldShowPageError = !_this.showPropertyError(error);
                    }
                    break;
                default:
                    shouldShowPageError = true;
                    break;
            }
            if (shouldShowPageError) {
                _this.showPageError(error);
            }
            return true;
        };
        this.fillForm = function (updateReason) {
            var propertyNames = _this.view.getVisibleProperties();
            _this.model.showMaskedValues = (updateReason === viewUpdateReasons.pageNavigated);
            var context = {
                isRadioProperty: false,
                firstRadioChecked: false,
                updateReason: updateReason
            };
            propertyNames.forEach(function (propertyName) {
                var property = _this.model.modelData.getProperty(propertyName);
                var propertyElement = _this.model.getPropertyModelElement(propertyName);
                context.isRadioProperty = isRadioElement(propertyElement);
                var prefillData = _this.model.modelData.getPrefillData();
                var propertyValue = (_this.model.showMaskedValues && _this.model.modelData.getMaskedPropertyValue(propertyName)) ||
                    (isTextBoxElement(propertyElement) && propertyElement.displayTransformations && propertyElement.displayTransformations.forFormat &&
                        utils.applyDisplayTransformation(propertyElement.displayTransformations.forFormat, property.value)) ||
                    property.value;
                if (_this.model.showMaskedValues && propertyValue !== property.value) {
                    _this.view.setAccessibilityText(propertyElement, ((propertyElement.tags && propertyElement.tags.maskedAccessibilityName) || propertyElement.accessibilityName || propertyElement.displayName));
                }
                if (isDropdownElement(propertyElement)) {
                    context.dropdownElement = propertyElement;
                }
                if (propertyValue) {
                    // property element value will be filled, send resourceSelected event
                    _this.model.sendResourceSelectedEvent(propertyName, controlOperationTypes.ready);
                }
                if (isButtonListElement(propertyElement) && prefillData && prefillData.id) {
                    _this.view.updateButtonList(propertyElement, prefillData.id, prefillData.invalid);
                }
                _this.view.updatePropertyValue(propertyName, property.editable, propertyValue, context);
            });
            if (_this.valueSetters && _this.valueSetters.length) {
                for (var j = 0; j < _this.valueSetters.length; j++) {
                    _this.valueSetters[j].set();
                }
            }
            _this.view.updatePrefillControls();
        };
        this.reset = function () {
            _this.unseenErrors = [];
            _this.errorPropertyGroups = {};
            _this.model.showMaskedValues = false;
            _this.view.reset();
            _this.valueSetters = [];
            _this.stopAllPolling();
        };
        this.stopAllPolling = function () {
            for (var pollingElementDisplayId in _this.pollingTimersAndCounters) {
                _this.stopPoll(pollingElementDisplayId);
            }
            _this.pollingTimersAndCounters = {};
            _this.pollingActions = {};
        };
        this.stopPoll = function (pollingElementDisplayId) {
            // stop poll for specified id and reset the polling counters
            if (_this.pollingTimersAndCounters[pollingElementDisplayId]) {
                _this.pollingTimersAndCounters[pollingElementDisplayId].pollingCounter = 0;
                clearInterval(_this.pollingTimersAndCounters[pollingElementDisplayId].pollingTimer);
            }
        };
        this.startPollingWithNextAction = function (key) {
            if (_this.pollingActions[key] && _this.pollingActions[key].nextAction) {
                _this.pollingActions[key] = _this.pollingActions[key].nextAction;
                _this.pollingHandler(key, _this.pollingActions[key]);
            }
        };
        this.registerGroupedErrors = function (error) {
            if (error && error.errors && error.errors.length) {
                var errorPropertyNames = [];
                for (var i = 0; i < error.errors.length; ++i) {
                    var propertyValidationErr = error.errors[i];
                    var groupValidationErr = error.errors[i];
                    if (propertyValidationErr.propertyName) {
                        errorPropertyNames.push(propertyValidationErr.propertyName);
                        _this.errorPropertyGroups[propertyValidationErr.propertyName] = errorPropertyNames;
                    }
                    if (groupValidationErr.groupDisplayId) {
                        errorPropertyNames.push(groupValidationErr.groupDisplayId);
                        _this.errorPropertyGroups[groupValidationErr.groupDisplayId] = errorPropertyNames;
                    }
                }
            }
        };
        this.deregisterGroupedErrors = function (propertyName, hideErrorCallback) {
            if (!hideErrorCallback) {
                hideErrorCallback = _this.hideError;
            }
            if (propertyName && _this.errorPropertyGroups[propertyName]) {
                var errorPropertyNames = _this.errorPropertyGroups[propertyName];
                for (var i = 0; i < errorPropertyNames.length; ++i) {
                    var errorPropertyName = errorPropertyNames[i];
                    if (_this.unseenErrors.length > 0) {
                        typehelper.filter(_this.unseenErrors, function (e) {
                            return !e.propertyName || e.propertyName !== errorPropertyName;
                        });
                    }
                    hideErrorCallback(errorPropertyName);
                    delete _this.errorPropertyGroups[errorPropertyName];
                }
            }
        };
        this.handleErrorEvent = function (parameters) {
            if (!_this.displaySettings.hidePropertyErrors) {
                var error = parameters.error;
                if (error) {
                    if ((pidlErrors.isServerError(error) && !error.retryable) || !pidlErrors.isServerError(error)) {
                        _this.showHideBusy(false);
                    }
                    _this.sortError(error);
                    _this.showError(error);
                    if (error.name === errorMessages.formSubmissionFailedBadUserInput.name) {
                        _this.registerGroupedErrors(error);
                        _this.view.setFocusOnFirstError();
                    }
                    else if (error.name === errorMessages.formValidationFailed.name) {
                        _this.view.setFocusOnFirstError();
                    }
                }
            }
        };
        this.sortError = function (error) {
            if (error.type !== errorTypes.formValidation) {
                return;
            }
            var formValidationError = error;
            if (formValidationError.errors === null || formValidationError.errors.length <= 1) {
                return;
            }
            var pageElement = _this.model.getCurrentPage();
            var errors = [];
            _this.addError(pageElement, formValidationError, errors);
            formValidationError.errors = errors;
        };
        this.addError = function (element, formValidationError, errors) {
            if (element === null || element === undefined) {
                return;
            }
            for (var i = 0; i < element.children.length; i++) {
                var child = element.children[i];
                if (isPropertyElement(child) || isSecurePropertyElement(child)) {
                    var propertyName = child.getPropertyName();
                    var oneError = _this.getErrorByPropertyName(formValidationError.errors, propertyName);
                    if (oneError !== null) {
                        errors.push(oneError);
                    }
                }
                else if (isContainerElement(child)) {
                    _this.addError(child, formValidationError, errors);
                    var groupError = _this.getErrorByDisplayId(formValidationError.errors, child.displayId);
                    if (groupError !== null) {
                        errors.push(groupError);
                    }
                }
            }
        };
        this.getErrorByPropertyName = function (errors, propertyName) {
            if (propertyName === null || propertyName === undefined) {
                return null;
            }
            for (var i = 0; i < errors.length; i++) {
                var error = errors[i];
                if (propertyName === error.propertyName) {
                    return error;
                }
            }
            return null;
        };
        this.getErrorByDisplayId = function (errors, displayId) {
            if (displayId === null || displayId === undefined) {
                return null;
            }
            for (var i = 0; i < errors.length; i++) {
                var error = errors[i];
                if (displayId === error.groupDisplayId) {
                    return error;
                }
            }
            return null;
        };
        this.handlePropertyValidated = function (parameters) {
            if (parameters) {
                _this.hideError(parameters.propertyName);
                _this.deregisterGroupedErrors(parameters.propertyName);
            }
        };
        this.setSubmitButtonState = function (disabled) {
            var submitButton = _this.model.getSubmitButton();
            var _a = submitButton || {}, _b = _a.accessibilityName, accessibilityName = _b === void 0 ? null : _b, _c = _a.disabledAccessibilityName, disabledAccessibilityName = _c === void 0 ? null : _c, _d = _a.displayId, displayId = _d === void 0 ? null : _d;
            _this.view.setDisabledByDisplayId(displayId, disabled, { accessibilityName: accessibilityName, disabledAccessibilityName: disabledAccessibilityName });
        };
        this.publicEventHandler = function (eventName, parameters) {
            switch (eventName) {
                case eventNames.error:
                    _this.handleErrorEvent(parameters);
                    break;
                case eventNames.propertyValidated:
                    _this.handlePropertyValidated(parameters);
                    break;
                case eventNames.pidlDownloading:
                case eventNames.pageRendering:
                case eventNames.inputSubmitting:
                case eventNames.redirecting:
                case eventNames.instanceDownloading:
                case eventNames.restMethodInvoking:
                case eventNames.propertyTokenizing:
                    _this.showHideBusy(true);
                    break;
                case eventNames.pageRendered:
                    _this.displaySettings.busyUntilInitialPageRendered = false;
                    // TODO: May need to be rethought on how this gets triggered
                    _this.pollingActions = modelElementsHelper$1.getPollingPidlActions(_this.model.elements);
                    for (var key in _this.pollingActions) {
                        _this.pollingHandler(key, _this.pollingActions[key]);
                    }
                    var radioElements = modelElementsHelper$1.findRadioElements(_this.model.elements);
                    radioElements.forEach(function (radioElement) {
                        if (isPropertyElement(radioElement)) {
                            _this.model.sendSelectionChangeEvent(radioElement, radioElement.defaultValue);
                        }
                    });
                    // check if page any restAction
                    _this.pageRestActions = modelElementsHelper$1.getPagePidlActions(_this.model.elements, supportedPidlActions.restAction);
                    var pageRestActionPromises = [];
                    for (var key in _this.pageRestActions) {
                        pageRestActionPromises.push(_this.invokePidlAction(_this.pageRestActions[key]));
                    }
                    if (pageRestActionPromises.length > 0) {
                        Promise.all(pageRestActionPromises).finally(function () {
                            _this.showHideBusy(false);
                        }).catch(_this.displaySettings.propagateCallbackException ? throwException : doNothing);
                        break; // Only hide busy block after all rest actions are invoked
                    }
                    if (_this.waitForSecureFields) {
                        break; // Do not hide busy block if we are waiting for secure fields
                    }
                case eventNames.pageDisplayed:
                case eventNames.pidlDownloaded:
                case eventNames.instanceDownloaded:
                case eventNames.restMethodInvoked:
                    _this.showHideBusy(false);
                    break;
                case eventNames.pageNavigated:
                    _this.updateView(viewUpdateReasons.pageNavigated);
                    break;
                case eventNames.propertySelected:
                    _this.view.markAsFilled(parameters.divId);
                    break;
            }
        };
        this.privateEventHandler = function (eventName, parameters) {
            switch (eventName) {
                case privateEventNames.modelUpdated:
                    var updateReason = parameters && parameters.created ? viewUpdateReasons.modelCreated : viewUpdateReasons.modelUpdated;
                    _this.updateView(updateReason, parameters === null || parameters === void 0 ? void 0 : parameters.skipHideBusyBlock);
                    break;
                case privateEventNames.dataUpdated:
                    _this.fillForm();
                    break;
                case privateEventNames.secureFieldLoadWaitStarted:
                    _this.showHideBusy(true);
                    _this.waitForSecureFields = true;
                    break;
                case privateEventNames.secureFieldLoadWaitEnded:
                    _this.showHideBusy(false);
                    _this.waitForSecureFields = false;
                    break;
                case privateEventNames.success:
                case privateEventNames.failure:
                case privateEventNames.gohome:
                    _this.showHideBusy(false);
                    _this.reset();
                    break;
                case privateEventNames.propertyCreated:
                    var propertyCreatedArgs = parameters;
                    _this.view.checkAndMarkAsFilled(propertyCreatedArgs.divId, propertyCreatedArgs.controlId);
                    break;
                case privateEventNames.propertyUnselected:
                    var propertyUnselectedArgs = parameters;
                    _this.view.checkAndMarkAsUnfilled(propertyUnselectedArgs.divId, propertyUnselectedArgs.id);
                    break;
                case privateEventNames.postMessageBusyTimerStarted:
                    _this.showHideBusy(true);
                    break;
                case privateEventNames.postMessageBusyTimerEnded:
                    _this.showHideBusy(false);
                    break;
                case privateEventNames.hideModalDialog:
                    _this.hideModalDialog();
                    break;
                case privateEventNames.submitting:
                    _this.setSubmitButtonState(true);
                    break;
                case privateEventNames.submitted:
                    _this.setSubmitButtonState(false);
                    break;
                case privateEventNames.updatePollAndMoveLast:
                    var pollId = parameters.pollId || "";
                    _this.stopPoll(pollId);
                    _this.startPollingWithNextAction(pollId);
                    _this.model.moveToLastPage().catch(doNothing);
                    break;
            }
        };
        this.getPollingPidlActionContext = function (pollingPidlAction) {
            var _a = pollingPidlAction.context, href = _a.href, responseResultExpression = _a.responseResultExpression, responseActions = _a.responseActions, method = _a.method;
            if (href && responseResultExpression && responseActions && method) {
                return pollingPidlAction.context;
            }
        };
        this.getPidlActionFromPollingResponse = function (response, responseResultExpression, responseActions) {
            if (!response || !responseResultExpression || !responseActions) {
                return null;
            }
            var responseValue = typehelper.getPropertyValueByJPath(response, responseResultExpression);
            var pidlActionToBeInvoked = typehelper.getPropertyValueByJPath(responseActions, responseValue);
            return pidlActionToBeInvoked;
        };
        this.getModelPropertyValue = function (propertyName) {
            return _this.model.getPropertyValue(propertyName);
        };
        this.updateModelPropertyValue = function (propertyName, value, operation) {
            return _this.model.updatePropertyValue(_this.model.getPropertyModelElement(propertyName), value, operation, false);
        };
        this.updateView = function (updateReason, skipHideBusyBlock) {
            var pageElement = _this.model.getCurrentPage();
            var captchaType = _this.model.getCaptchaType();
            if (!_this.model.secureFieldResolved) {
                _this.view.reset();
            }
            var ret = _this.view.render({
                updateReason: updateReason,
                focusTarget: _this.focusTarget,
                captchaType: captchaType,
                pageElement: pageElement,
                viewEventHandler: _this,
                displaySettings: _this.displaySettings,
                eventHub: _this.eventHub
            });
            _this.valueSetters = ret.valueSetters;
            _this.eventHub.pageRefreshed();
            _this.fillForm(updateReason);
            if (_this.view.restoreCaretPosition && updateReason !== viewUpdateReasons.pageNavigated) {
                _this.view.restoreCaretPosition();
            }
            // We ignore any errors coming from validation
            _this.model.validateEditedProperties().catch(doNothing);
            if (updateReason === viewUpdateReasons.modelCreated) {
                _this.unseenErrors = [];
                _this.errorPropertyGroups = {};
            }
            else {
                var errors = _this.unseenErrors;
                _this.unseenErrors = [];
                if (!skipHideBusyBlock) {
                    _this.showHideBusy(false);
                }
                for (var i = 0; i < errors.length; i++) {
                    _this.showError(errors[i]);
                }
                if (updateReason !== viewUpdateReasons.modelUpdated) {
                    _this.view.setFocusOnFirstError();
                }
            }
        };
        this.hasSecureFields = function (pageElement) {
            var _a;
            var children = pageElement.children;
            if (!children) {
                return false;
            }
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var child = children_1[_i];
                if ((_a = child === null || child === void 0 ? void 0 : child.isSecureProperty) === null || _a === void 0 ? void 0 : _a.call(child)) {
                    return true;
                }
                else if (isGroupElement(child)) {
                    if (_this.hasSecureFields(child)) {
                        return true;
                    }
                }
            }
            return false;
        };
        this.getTimeoutPromise = function (ms) {
            return new Promise(function (_, reject) {
                var timeoutId = setTimeout(function () {
                    reject(new Error("Timeout"));
                }, ms);
                _this.getTimeoutPromise.id = timeoutId;
            });
        };
        this.clearTimeoutPromise = function () {
            var _a;
            try {
                var timeoutId = (_a = _this.getTimeoutPromise) === null || _a === void 0 ? void 0 : _a.id;
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            }
            catch (error) {
                // We don't want to throw an error in the cleanup process
            }
        };
        this.createSecurePropertyLoadedPromise = function (id) {
            _this.securePropertyPromises.push(_this.model.queueSecureFieldLoadedPromise(id));
        };
        this.resolveSecurePropertyLoadedPromise = function (id) {
            _this.model.resolveSecureFieldLoadedPromise(id);
        };
        this.createSecurePropertyInitCompletedPromise = function (id) {
            _this.securePropertyInitCompletedPromises.push(_this.model.queueSecureFieldInitCompletedPromise(id));
        };
        this.getSecurePropertyLoadedPromises = function () {
            return _this.securePropertyPromises;
        };
        this.getSecurePropertyInitCompletedPromises = function () {
            return _this.securePropertyInitCompletedPromises;
        };
        this.extractStylesFromStylesheet = function (styles) {
            var stylesheets = document.styleSheets;
            var errorSelector = ".errorStroke";
            var pidlddcErrorSelector = ".".concat(htmlClassNames.errorStroke);
            var secureFieldSelector = ".".concat(htmlClassNames.secureProperty);
            for (var i = 0; i < stylesheets.length; i++) {
                var stylesheet = stylesheets[i];
                try {
                    var rules = stylesheet.cssRules || stylesheet.rules;
                    for (var j = 0; j < rules.length; j++) {
                        var rule = rules[j];
                        if (rule instanceof CSSStyleRule) {
                            var selectors = rule.selectorText.split(",");
                            for (var k = 0; k < selectors.length; k++) {
                                var selector = selectors[k].trim();
                                if (selector.includes(errorSelector) || selector.includes(pidlddcErrorSelector)) {
                                    styles.push(selector + "{ " + rule.style.cssText + " }");
                                }
                                else if (selector.includes(secureFieldSelector)) {
                                    selector = selector.replace(secureFieldSelector, "");
                                    styles.push(selector + "{ " + rule.style.cssText + " }");
                                }
                            }
                        }
                    }
                }
                catch (error) {
                    _this.eventHub.styleSheetError(error, stylesheet === null || stylesheet === void 0 ? void 0 : stylesheet.href);
                }
            }
        };
        this.computeSecurePropertyStyles = function (propertyName, securePropertyHardCodedStyles) {
            var styles = [];
            if (securePropertyHardCodedStyles && Object.keys(securePropertyHardCodedStyles).length === 0) {
                _this.extractStylesFromStylesheet(styles);
            }
            else if (securePropertyHardCodedStyles) {
                _this.computeStylesFromHardCodedStyles(securePropertyHardCodedStyles, styles);
            }
            _this.model.computedStyles.style[propertyName] = styles;
        };
        this.computeStylesFromHardCodedStyles = function (securePropertyHardCodedStyles, styles) {
            var textFieldSelector = 'input[type="text"]';
            var textFieldCssText = Object.keys(securePropertyHardCodedStyles.textFieldStyles).map(function (property) { return "".concat(property, ":").concat(securePropertyHardCodedStyles.textFieldStyles[property]); }).join(";");
            styles.push(textFieldSelector + "{" + textFieldCssText + "}");
            var textFieldGroupSelector = ".normalClass";
            var textFieldGroupCssText = Object.keys(securePropertyHardCodedStyles.fieldGroupNormalStyles).map(function (property) { return "".concat(property, ":").concat(securePropertyHardCodedStyles.fieldGroupNormalStyles[property]); }).join(";");
            styles.push(textFieldGroupSelector + "{" + textFieldGroupCssText + "}");
            var focusTextFieldGroupSelector = ".focusClass";
            var focusTextFieldGroupCssText = Object.keys(securePropertyHardCodedStyles.fieldGroupFocusStyles).map(function (property) { return "".concat(property, ":").concat(securePropertyHardCodedStyles.fieldGroupFocusStyles[property]); }).join(";");
            styles.push(focusTextFieldGroupSelector + "{" + focusTextFieldGroupCssText + "}");
            var errorTextFieldGroupSelector = ".errorClass";
            var errorTextFieldGroupCssText = Object.keys(securePropertyHardCodedStyles.fieldGroupErrorStyles).map(function (property) { return "".concat(property, ":").concat(securePropertyHardCodedStyles.fieldGroupErrorStyles[property]); }).join(";");
            styles.push(errorTextFieldGroupSelector + "{" + errorTextFieldGroupCssText + "}");
            var focusErrorTextFieldGroupSelector = ".focusErrorClass";
            var focusErrorTextFieldGroupCssText = Object.keys(securePropertyHardCodedStyles.fieldGroupFocusErrorStyles).map(function (property) { return "".concat(property, ":").concat(securePropertyHardCodedStyles.fieldGroupFocusErrorStyles[property]); }).join(";");
            styles.push(focusErrorTextFieldGroupSelector + "{" + focusErrorTextFieldGroupCssText + "}");
        };
        this.getMultiPropertySelectorPossibleOptions = function (pidlIdentity) {
            return _this.model.getMultiPropertySelectorPossibleOptions(pidlIdentity);
        };
        this.inputHandler = function (context) {
            _this.model.showMaskedValues = false;
            var value = _this.applyForModelDisplayTransformation(context.propertyElement, context.val, _this.model.showMaskedValues) || context.val;
            _this.focusTarget = context.caretPosition && context.caretPosition.id;
            var controlOperationType = isCheckBoxElement(context.propertyElement) ||
                isDropdownElement(context.propertyElement)
                ? controlOperationTypes.finished
                : controlOperationTypes.editing;
            _this.model.updatePropertyValue(context.propertyElement, value, controlOperationType, _this.model.showMaskedValues).catch(doNothing);
            if (_this.view.updateDisplayValue) {
                _this.view.updateDisplayValue(context.id, context.propertyElement, value, context.caretPosition);
            }
            _this.view.updatePrefillControls();
        };
        this.focusoutHandler = function (context) {
            var value = _this.applyForModelDisplayTransformation(context.propertyElement, context.val, _this.model.showMaskedValues) || context.val;
            _this.focusTarget = context.focusTarget;
            _this.model.updatePropertyValue(context.propertyElement, value, controlOperationTypes.finished, _this.model.showMaskedValues).catch(doNothing);
            _this.view.updatePrefillControls();
            _this.eventHub.propertyUnselected(context.id, context.propertyElement.getPropertyName(), context.divId);
        };
        this.dropdownSelectHandler = function (context) {
            var value = context.val;
            _this.focusTarget = context.focusTarget;
            _this.model.updatePropertyValue(context.propertyElement, value, controlOperationTypes.editing, _this.model.showMaskedValues).catch(doNothing);
            _this.view.updatePrefillControls();
        };
        this.buttonClickHandler = function (context) {
            _this.eventHub.click(context.id);
            _this.model.invokePidlAction(context.pidlAction, context).catch(_this.displaySettings.propagateCallbackException ? throwException : doNothing);
        };
        this.invokePidlAction = function (pidlAction) {
            return _this.model.invokePidlAction(pidlAction).catch(_this.displaySettings.propagateCallbackException ? throwException : doNothing);
        };
        this.iFrameMessageTimeoutHandler = function (clientAction) {
            _this.model.handleClientAction(clientAction)
                .then(function () {
                _this.eventHub.postMessageTimeoutHandleSuccess(clientAction.type);
            }).catch(function () {
                _this.eventHub.postMessageTimeoutHandleFailure("specified client action is not successful. clientAction type: " + clientAction.type);
            });
        };
        this.challengeiFrameMessageTimeoutHandler = function (clientAction) {
            // reduce this function and use it for placeholder for now.
            _this.model.handleClientAction(clientAction)
                .then(function () {
            }).catch(function () {
            });
        };
        this.postSecureFieldMessage = function (fieldName, event, message) {
            return _this.model.postSecureFieldMessage(fieldName, event, message);
        };
        this.secureIFrameOnLoadHandler = function (context) {
            _this.resolveSecurePropertyLoadedPromise(context.id);
        };
        this.getClientSetting = function (settingName) {
            return _this.model.getClientSetting(settingName);
        };
        this.postChallengeIframeMessage = function (message) {
            return _this.model.postChallengeiFrameMessage(message);
        };
        this.secureFieldMessageHandler = function (evt) {
            var expectedOrigin = utils.getHostName(config$1.getServiceEndpoint(config$1.virtualEndpoints.securePx.endpoint));
            var actualOrigin = utils.getHostName(evt.origin);
            if (actualOrigin === expectedOrigin) {
                if (evt && evt.data && evt.data.source === SecureFieldConstants.secureFieldMessageSource) {
                    _this.model.handleSecureFieldMessage(evt);
                }
            }
        };
        this.iFrameMessageHandler = function (evt) {
            var expectedOrigin = utils.getHostName(config$1.getServiceEndpoint(config$1.virtualEndpoints.pifd.endpoint));
            var expectedOriginBE = utils.getHostName(config$1.getServiceEndpoint(config$1.virtualEndpoints.pifdBackend.endpoint));
            var actualOrigin = utils.getHostName(evt.origin);
            _this.eventHub.postMessageReceived(actualOrigin, expectedOrigin, evt.data && evt.data.length);
            //check actual origin matches with expected origin
            if (actualOrigin === expectedOrigin || actualOrigin === expectedOriginBE) {
                var parsedJson = utils.parseJSON(evt.data);
                var clientAction = parsedJson.succeeded ? parsedJson.value : null;
                if (clientAction) {
                    _this.model.handleClientAction(clientAction, null, requestOriginator.iFrameMessageHandler).then(function () { _this.eventHub.postMessageHandleSuccess(clientAction.type); }, function () { _this.eventHub.postMessageHandleFailure("specified client action is not successful. clientAction type: " + clientAction.type); });
                }
                else {
                    _this.eventHub.postMessageHandleFailure("clientAction is not specified");
                }
            }
        };
        this.challengeiFrameMessageHandler = function (evt) {
            var expectedOrigin = utils.getHostName(config$1.getServiceEndpoint(config$1.virtualEndpoints.challengeUI.endpoint));
            var actualOrigin = utils.getHostName(evt.origin);
            //check actual origin matches with expected origin
            if (actualOrigin === expectedOrigin) {
                var parsedJson = utils.parseJSON(evt.data);
                // filter out non-client action type from MessageEvent: e.g. preventing parent window listens to Arkose broadcasts messages.
                var clientAction = parsedJson.succeeded && (evt.type in clientActionTypeValues) ? parsedJson.value : null;
                if (clientAction) {
                    _this.model.handleClientAction(clientAction, null, requestOriginator.iFrameMessageHandler).then(function () { _this.eventHub.postMessageHandleSuccess(clientAction.type); }, function () { _this.eventHub.postMessageHandleFailure("specified client action is not successful. clientAction type: " + clientAction.type); });
                }
                else {
                    _this.eventHub.postMessageHandleFailure("clientAction is not specified");
                }
                // make sure the handler does not listen to "broadcast" message from Arkose
                if (evt.type === "message" && (evt.data in ChallengeiFrameEvent)) {
                    _this.model.handleChallengeiFrameMessage(evt);
                }
            }
        };
        this.iFrameBusyTimerStartedHandler = function (messageTimer) {
            _this.eventHub.postMessageBusyTimerStarted("Busy started for timer ".concat(messageTimer));
        };
        this.iFrameBusyTimerEndedHandler = function (messageTimer) {
            _this.eventHub.postMessageBusyTimerEnded("Busy ended for timer ".concat(messageTimer));
        };
        this.hyperlinkClickHandler = function (context) {
            var redirectionService = iocContainer$1.getRedirectionService();
            var pidlAction = context.pidlAction;
            var handled = false;
            switch (pidlAction.type) {
                case supportedPidlActions.redirect:
                    var redirectUrl = _this.model.getLinkActionUrl(pidlAction.context, false);
                    handled = _this.eventHub.navigate(context.id, redirectUrl, true, pidlAction.context, null);
                    if (!handled && redirectionService) {
                        redirectionService.redirect(redirectUrl);
                        return true;
                    }
                    break;
                case supportedPidlActions.navigate:
                default:
                    handled = _this.eventHub.navigate(context.id, pidlAction.context, false, null, pidlAction.dest);
                    if (!handled && redirectionService) {
                        return !redirectionService.openInNewTab(pidlAction.context);
                    }
                    break;
            }
            return !handled;
        };
        this.captchaHyperlinkClickHandler = function (propertyName, value, operation) {
            _this.updateModelPropertyValue(propertyName, value, operation).catch(doNothing);
        };
        this.updatePrefillValue = function (pidlIdentity, value) {
            /**
             * pidl-react API, promise rejection handled in React component
             */
            if (value === true) {
                _this.model.setCurrentDataIndex(pidlIdentity, 0);
            }
            else if (value === false) {
                _this.model.setCurrentDataIndex(pidlIdentity, -1);
            }
            else {
                _this.model.setCurrentDataIndex(pidlIdentity, value);
            }
            return _this.model.validateEditedProperties();
        };
        this.prefillChangeHandler = function (context) {
            var isCheckbox = context.type && context.type === modelElementType.checkBox;
            if (isCheckbox) {
                if (context.val) {
                    _this.model.setCurrentDataIndex(context.pidlIdentity, 0);
                }
                else {
                    _this.model.setCurrentDataIndex(context.pidlIdentity, -1);
                }
            }
            else {
                _this.model.setCurrentDataIndex(context.pidlIdentity, context.val);
            }
            _this.fillForm(viewUpdateReasons.prefillChanged);
            if (!isCheckbox) {
                _this.model.validateEditedProperties().catch(doNothing);
            }
        };
        this.propertySelectedHandler = function (context) {
            _this.eventHub.propertySelected(context.id, context.propertyName, context.divId);
        };
        this.propertyUnselectedHandler = function (context) {
            _this.eventHub.propertyUnselected(context.id, context.propertyName, context.divId);
        };
        this.postMessageToChildIFrames = function (params) {
            return _this.view.postMessageToChildIFrames(params);
        };
        this.pollingHandler = function (elementDisplayId, pollingPidlAction) {
            if (!pollingPidlAction) {
                return false;
            }
            // store a timer and a polling counter for this pollingElement in pollingTimersAndCounters
            var pollingTimerAndCounter = { pollingTimer: null, pollingCounter: 0 };
            _this.pollingTimersAndCounters[elementDisplayId] = pollingTimerAndCounter;
            // get and validate pidlAction context
            var context = _this.getPollingPidlActionContext(pollingPidlAction);
            if (!context) {
                return false;
            }
            var method = context.method, payload = context.payload, headers = context.headers, _a = context.interval, interval = _a === void 0 ? pollingInterval.Default : _a, responseResultExpression = context.responseResultExpression, responseActions = context.responseActions, maxPollingAttempts = context.maxPollingAttempts, checkPollingTimeOut = context.checkPollingTimeOut, fetchConfig = context.fetchConfig;
            var header = fetchHelper.getHttpHeaders(_this.eventHub, _this.userContext, headers);
            var url = urlBuilder$1.getSubmitUrl(_this.model.operationType, _this.userContext, context, _this.model.modelData.getId());
            var _b = url.virtualEndpoint, operation = _b.operation, description = _b.description;
            var pollingErrorHandler = function (error, pollingElementdisplayId) {
                clearInterval(_this.pollingTimersAndCounters[pollingElementdisplayId].pollingTimer);
                _this.pollingTimersAndCounters[pollingElementdisplayId].pollingCounter = 0;
                delete _this.pollingTimersAndCounters[pollingElementdisplayId];
                _this.eventHub.pollingEnded(pollingElementdisplayId);
                _this.eventHub.failure(error);
            };
            // Weird type issue, setInterval is typed number but not reflected as such locally
            // https://stackoverflow.com/questions/51376589/typescript-what-type-is-f-e-setinterval
            _this.pollingTimersAndCounters[elementDisplayId].pollingTimer = setInterval(function () {
                var pollingPromise = null;
                if (method === httpActions.Get) {
                    _this.eventHub.pollingStarted(elementDisplayId);
                    pollingPromise = fetchHelper.get(_this.eventHub, url.url, header, _this.model.operationType, operation, description, fetchConfig);
                }
                else if (method === httpActions.Post) {
                    _this.eventHub.pollingStarted(elementDisplayId);
                    pollingPromise = fetchHelper.post(_this.eventHub, true, url.url, header, JSON.stringify(payload), null, null, _this.model.operationType, operation, description, false, fetchConfig);
                }
                else if (method === httpActions.Put) {
                    _this.eventHub.pollingStarted(elementDisplayId);
                    pollingPromise = fetchHelper.put(_this.eventHub, true, url.url, header, JSON.stringify(payload), null, null, _this.model.operationType, operation, description, false, fetchConfig);
                }
                else {
                    var error = new pidlErrors.unexpectedError(errorMessages.unableToSetupPolling);
                    pollingErrorHandler(error, elementDisplayId);
                    return false;
                }
                if (pollingPromise !== null) {
                    pollingPromise.then(function (response) {
                        if (checkPollingTimeOut && _this.pollingTimersAndCounters[elementDisplayId].pollingCounter++ > maxPollingAttempts) {
                            var error = new pidlErrors.unexpectedError(errorMessages.pollingTimedOut);
                            pollingErrorHandler(error, elementDisplayId);
                            return false;
                        }
                        var pidlActionTobeInvoked = _this.getPidlActionFromPollingResponse(response, responseResultExpression, responseActions) || pollingPidlAction;
                        if (pidlActionTobeInvoked.type !== supportedPidlActions.poll) {
                            clearInterval(_this.pollingTimersAndCounters[elementDisplayId].pollingTimer);
                            _this.pollingTimersAndCounters[elementDisplayId].pollingCounter = 0;
                            delete _this.pollingTimersAndCounters[elementDisplayId];
                            _this.eventHub.pollingEnded(elementDisplayId);
                            if (pidlActionTobeInvoked.type === supportedPidlActions.moveNextAndPoll) {
                                _this.model.moveNextPage().catch(doNothing);
                                _this.pollingActions[elementDisplayId] = pollingPidlAction.nextAction;
                                return _this.pollingHandler(elementDisplayId, pollingPidlAction.nextAction);
                            }
                            else if (pidlActionTobeInvoked.type === supportedPidlActions.updatePoll) {
                                _this.pollingActions[elementDisplayId] = pollingPidlAction.nextAction;
                                return _this.pollingHandler(elementDisplayId, pollingPidlAction.nextAction);
                            }
                            else if (pidlActionTobeInvoked.type === supportedPidlActions.handleFailure) {
                                _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessages.failurePollingResponseReturned, [JSON.stringify(response)]));
                                return false;
                            }
                            // update the primary resource response with the latest polling response.
                            // Otherwise, the response returned to the client won't be the latest polling reponse when pidlAction type is sucesss.
                            if (response && pidlDocHelper$1.isPrimaryResource(_this.model.pidlDocManager.getResolvedOrFirstPidlDoc())) {
                                _this.model.modelData.setPrimaryResourceResponse(response);
                            }
                        }
                        if (response && response.clientAction && pidlActionTobeInvoked && pidlActionTobeInvoked.type === supportedPidlActions.success) {
                            _this.model.handleClientAction(response.clientAction).then(function () {
                                _this.eventHub.pollClientActionSuccess(response.clientAction.type);
                            }).catch(function () {
                                _this.eventHub.pollClientActionFailure("specified client action is not successful. clientAction type: " + response.clientAction.type);
                            });
                        }
                        else {
                            return _this.model.invokePidlAction(pidlActionTobeInvoked);
                        }
                    }, function (error) {
                        pollingErrorHandler(error, elementDisplayId);
                        return false;
                    });
                }
                else {
                    var error = new pidlErrors.unexpectedError(errorMessages.unableToSetupPolling);
                    pollingErrorHandler(error, elementDisplayId);
                    return false;
                }
            }, interval);
            return true;
        };
        this.testHookPublicEventHandler = function (eventName, parameters) {
            _this.publicEventHandler(eventName, parameters);
        };
        this.testHookPrivateEventHandler = function (eventName, parameters) {
            _this.privateEventHandler(eventName, parameters);
        };
        this.testHookGetUnseenErrors = function () {
            return _this.unseenErrors;
        };
        this.testHookSetUnseenErrors = function (unseenErrorsIn) {
            _this.unseenErrors = unseenErrorsIn;
        };
        this.testHookFillForm = function (displaySettings, updateReason) {
            _this.displaySettings = displaySettings;
            _this.fillForm(updateReason);
        };
        this.testHookGetErrorPropertyGroups = function () {
            return _this.errorPropertyGroups;
        };
        this.testHookRegisterGroupedErrors = function (parameters) {
            _this.registerGroupedErrors(parameters);
        };
        this.testHookDeregisterGroupedErrors = function (propertyName, hideErrorCallback) {
            _this.deregisterGroupedErrors(propertyName, hideErrorCallback);
        };
        this.testHookSetShowMaskedFlag = function (showMaskedValuesIn) {
            _this.model.showMaskedValues = showMaskedValuesIn;
        };
        this.testHookGetRenderer = function () {
            return _this.view;
        };
        this.testHookUpdateView = function (updateReason) {
            _this.updateView(updateReason);
        };
        this.testHookSetFocusTarget = function (focusTarget) {
            _this.focusTarget = focusTarget;
        };
        this.eventHub = paramsIn.eventHub;
        this.displaySettings = paramsIn.displaySettings;
        this.model = paramsIn.model;
        this.view = paramsIn.view;
        this.userContext = paramsIn.userContext;
        if (paramsIn.iFrameMessageHandler) {
            this.iFrameMessageHandler = paramsIn.iFrameMessageHandler;
        }
        this.eventHub.addPublicEventHandler(function (eventName, parameters) {
            _this.publicEventHandler(eventName, parameters);
        });
        this.eventHub.addPrivateEventHandler(function (eventName, parameters) {
            _this.privateEventHandler(eventName, parameters);
        });
        this.view.initialize(this.eventHub, this.model, this.displaySettings, this);
        this.model.setViewHandler(this.view);
    }
    return ViewEventHandler;
}());

"use strict";
var env = /** @class */ (function () {
    function env() {
        var _this = this;
        this.env = "prod";
        this.envs = [
            "int",
            "ppe",
            "prod",
            "feature",
            "aircapi"
        ];
        this.get = function () {
            return _this.env;
        };
        this.set = function (envIn) {
            var envLower = typehelper.toLowerCase(envIn);
            if (typehelper.contains(_this.envs, envLower)) {
                _this.env = envLower;
                config$1.setEnv(_this.env);
            }
        };
        this.getAll = function () {
            return _this.envs;
        };
    }
    return env;
}());
var pidlEnv = new env();

"use strict";
var version = "2.7.0-alpha.12";
var VersionHelper = /** @class */ (function () {
    function VersionHelper() {
        this.get = function () {
            return version;
        };
    }
    return VersionHelper;
}());
var version$1 = new VersionHelper();

"use strict";
var oneDSAdapter = /** @class */ (function () {
    function oneDSAdapter() {
        var _this = this;
        this.applicationInsightsInstance = null;
        this.cvPlugin = null;
        this.cvInstance = null;
        this.cvInitialValue = null;
        this.userConsentDetailsCallback = function () {
            return {
                Advertising: false,
                Analytics: false,
                Required: true,
                SocialMedia: false,
            };
        };
        this.initOneDsObjects = function () {
            if (!_this.applicationInsightsInstance) {
                try {
                    var instrumentationKey = "4127950a47f84a01a75e9a7d49d79f14-b56cc96f-0faa-4455-912a-6b8df93eeac5-6769";
                    if (!_this.cvPlugin) {
                        _this.initCVPlugin();
                    }
                    if (iocContainer$1.getOneDSService()) {
                        _this.applicationInsightsInstance = iocContainer$1.getOneDSService().getApplicationInsights();
                    }
                    var config = {
                        instrumentationKey: instrumentationKey,
                        extensions: [
                            _this.cvPlugin
                        ],
                        extensionConfig: [],
                        propertyConfiguration: {
                            gpcDataSharingOptIn: false,
                            callback: {
                                userConsentDetails: _this.userConsentDetailsCallback
                            }
                        },
                    };
                    //Initialize SDK
                    if (_this.applicationInsightsInstance && typehelper.isFunction(_this.applicationInsightsInstance.initialize)) {
                        _this.applicationInsightsInstance.initialize(config, []);
                    }
                }
                catch (err) {
                    if (iocContainer$1.getLoggingService()) {
                        iocContainer$1.getLoggingService().logError("1DS Error : Error when attempting to initialize 1DS.", err);
                    }
                }
            }
        };
        this.initCVPlugin = function () {
            if (!_this.cvPlugin) {
                if (iocContainer$1.getOneDSService()) {
                    _this.cvPlugin = iocContainer$1.getOneDSService().getCorrelationVectorPlugin(_this.cvInitialValue);
                }
                var cv = void 0;
                if (_this.cvPlugin && typehelper.isFunction(_this.cvPlugin.getCv)) {
                    cv = _this.cvPlugin.getCv();
                }
                if (cv && typehelper.isFunction(cv.isInit) && cv.isInit()) {
                    _this.cvInstance = cv;
                }
                else {
                    if (iocContainer$1.getOneDSService()) {
                        _this.cvPlugin = iocContainer$1.getOneDSService().getCorrelationVectorPlugin();
                    }
                    if (_this.cvPlugin && typehelper.isFunction(_this.cvPlugin.getCv)) {
                        _this.cvInstance = _this.cvPlugin && _this.cvPlugin.getCv();
                    }
                }
            }
        };
        this.getCVInstance = function () {
            if (!_this.cvInstance) {
                _this.initCVPlugin();
            }
            return _this.cvInstance;
        };
        this.reset = function () {
            _this.cvPlugin = null;
            _this.cvInstance = null;
            _this.applicationInsightsInstance = null;
        };
        this.setUserConsentDetailsCallback = function (userConsentDetailsCallback) {
            if (userConsentDetailsCallback) {
                _this.userConsentDetailsCallback = userConsentDetailsCallback;
            }
        };
        this.getApplicationInsights = function () {
            if (!_this.applicationInsightsInstance) {
                _this.initOneDsObjects();
            }
            return _this.applicationInsightsInstance;
        };
        this.writeEvent = function (name, partB, partC) {
            try {
                var oneds = _this.getApplicationInsights();
                if (oneds && typehelper.isFunction(oneds.trackEvent)) {
                    oneds.trackEvent({ name: name, baseData: partB }, partC);
                }
                else {
                    if (iocContainer$1.getLoggingService()) {
                        iocContainer$1.getLoggingService().logError("1DS Error : ApplicationInsights is not correctly initialized");
                    }
                }
            }
            catch (err) {
                if (iocContainer$1.getLoggingService()) {
                    iocContainer$1.getLoggingService().logError("1DS Error : Error when attempting to track event with 1DS.", err);
                }
            }
        };
        this.getIncrementedCV = function () {
            try {
                var cv = _this.getCVInstance();
                return cv && typehelper.isFunction(cv.increment) && cv.increment();
            }
            catch (error) {
                if (iocContainer$1.getLoggingService()) {
                    iocContainer$1.getLoggingService().logError("1DS Error : There was an issue with incrementing the correlation vector", error);
                }
            }
        };
        this.getCVValue = function () {
            try {
                var cv = _this.getCVInstance();
                return cv && typehelper.isFunction(cv.getValue) && cv.getValue();
            }
            catch (error) {
                if (iocContainer$1.getLoggingService()) {
                    iocContainer$1.getLoggingService().logError("1DS Error : There is an issue with correlation vector getValue function", error);
                }
            }
        };
        this.initCV = function (cvInitValue) {
            try {
                if (cvInitValue) {
                    _this.cvInitialValue = cvInitValue;
                    // Reset cV plugin and AppInsights instance
                    _this.reset();
                }
            }
            catch (error) {
                if (iocContainer$1.getLoggingService()) {
                    iocContainer$1.getLoggingService().logError("1DS Error : There is an issue with Initializing CV", error);
                }
            }
        };
        this.testHookReset = function () {
            _this.applicationInsightsInstance = null;
            _this.cvInstance = null;
        };
    }
    return oneDSAdapter;
}());
var oneDSAdapter$1 = new oneDSAdapter();

"use strict";
var telemetryContext = /** @class */ (function () {
    function telemetryContext(options, sdkViewType) {
        var _this = this;
        this.partnerContext = {};
        this.enableLogging = true;
        this.enableConsoleLogging = true;
        this.enablePrivateEventConsoleLogging = false;
        this.enableUnhandledRejectionLogging = true;
        this.sdkVersion = version$1.get();
        this.env = pidlEnv.get();
        this.sessionId = utils.guid();
        this.telemetryResource = { resourceType: "", parameters: { id: null } };
        this.userConsentDetailsCallback = null;
        this.updateResourceInfo = function (resourceInfo) {
            if (resourceInfo) {
                try {
                    for (var key in resourceInfo.parameters) {
                        if (resourceInfo.parameters.hasOwnProperty(key)) {
                            _this.telemetryResource.parameters[key] = resourceInfo.parameters[key];
                        }
                    }
                }
                catch (e) {
                }
                if (resourceInfo.id) {
                    _this.telemetryResource.parameters.id = resourceInfo.id;
                }
                if (resourceInfo.resourceType) {
                    _this.telemetryResource.resourceType = resourceInfo.resourceType;
                }
            }
        };
        this.update = function (operationType, resourceInfo) {
            _this.operationType = operationType;
            if (resourceInfo) {
                _this.updateResourceInfo(resourceInfo);
            }
        };
        this.trackNewOperation = function (operationType, resourceInfo) {
            _this.operationId = utils.guid();
            _this.update(operationType, resourceInfo);
        };
        if (options) {
            // pidlsdk report currently uses three dimensions 'client' , 'deviceFamily' and 'pageName' that are set by partner in contextData like: { client: "<appName>", deviceFamily: "<deviceName>", pageName: "<appSourcePage>" }
            this.partnerContext = options.contextData || {};
            this.enableLogging = !options.disableLogging;
            this.enableConsoleLogging = !options.disableConsoleLogging;
            this.enablePrivateEventConsoleLogging = !!options.enablePrivateEventConsoleLogging;
            this.enableUnhandledRejectionLogging = !options.disableUnhandledRejectionLogging;
            this.telemetryOverrides = options.overrides;
            this.customTelemetryFrameworkWindowNamespace = options.customTelemetryFrameworkWindowNamespace;
            if (this.partnerContext && this.partnerContext.cvInitValue && oneDSAdapter$1) {
                oneDSAdapter$1.initCV(this.partnerContext.cvInitValue);
            }
            if (options.userConsentDetailsCallback) {
                this.userConsentDetailsCallback = options.userConsentDetailsCallback;
            }
            oneDSAdapter$1.setUserConsentDetailsCallback(this.userConsentDetailsCallback);
        }
        var _a = this.partnerContext, sessionId = _a.sessionId, cvInitValue = _a.cvInitValue;
        if (!sessionId && cvInitValue) {
            sessionId = cvInitValue.substr(0, cvInitValue.indexOf("."));
            this.partnerContext.sessionId = sessionId;
        }
        if (!sessionId && this.sessionId) {
            this.partnerContext.sessionId = this.sessionId;
        }
        this.sdkViewType = sdkViewType;
    }
    return telemetryContext;
}());

// tslint:disable:no-console
"use strict";
var loggingService = /** @class */ (function () {
    function loggingService() {
    }
    // Log error
    loggingService.prototype.logError = function (type, errorObject) {
        var errDetails = "";
        if (errorObject) {
            try {
                errDetails = JSON.stringify(errorObject);
            }
            catch (e) {
                errDetails = "";
            }
        }
        var message = type + "= " + errDetails;
        console.error(message);
    };
    // Log warning
    loggingService.prototype.logWarning = function (message) {
        console.warn(message);
    };
    // Log verbose message
    loggingService.prototype.logMessage = function (message) {
        console.log(message);
    };
    return loggingService;
}());

"use strict";
var userInputDataHelper = /** @class */ (function () {
    function userInputDataHelper() {
        var _this = this;
        this.createUserDataPropertyValue = function (propertyName, propertyDescription, modelData, forSubmit, forPartner) {
            if (propertyDescription.indexedOn && propertyDescription.possible_values) {
                // for indexedOn, we need the possible options id, not the pidlAction, so send forSubmit=false in all cases
                var indexerPropertyId = modelData.getPropertyValue(propertyDescription.indexedOn, false);
                if (indexerPropertyId && propertyDescription.possible_values[indexerPropertyId]) {
                    return propertyDescription.possible_values[indexerPropertyId];
                }
            }
            var value = modelData.getPropertyValue(commerceHelper$1.getDisplayPropertyName(propertyDescription, propertyName), forSubmit, forPartner);
            value = value === undefined ? utils.getFormatStringExpressionValue(propertyDescription.default_value, { modelData: modelData }) : value;
            if (propertyDescription.type === dataTypes.bool) {
                value = typehelper.boolify(value);
            }
            return value;
        };
        this.createUserSecureInputDataInternal = function (pidlDocument, modelData, clientDataProperties, pidlOperation, mapping, forSubmit, forPartner) {
            var dataDescription = pidlDocument.data_description;
            var promises = [];
            for (var propertyName in dataDescription) {
                var propertyDescription = dataDescription[propertyName];
                if (isPidlDocumentArray(propertyDescription)) {
                    var innerPidlDoc = propertyDescription && propertyDescription.length && propertyDescription[0];
                    if (innerPidlDoc) {
                        var innerPromise = _this.createUserSecureInputDataInternal(innerPidlDoc, modelData, clientDataProperties, pidlOperation, mapping, forSubmit, forPartner);
                        promises.push(innerPromise);
                    }
                }
                else {
                    var propertyElement = modelData.getModelDataProperty(propertyName);
                    if (propertyElement && propertyElement.modelElement && propertyElement.modelElement.isSecureProperty()) {
                        if (propertyDescription.token_set && propertyDescription.token_set.startsWith(SecureFieldConstants.tokenizationValuePrefix)) {
                            propertyDescription.token_set = propertyDescription.token_set.replace(SecureFieldConstants.tokenizationValuePrefix, "");
                        }
                        var promise = propertyElement.modelElement.prepareForSubmit(propertyDescription.token_set).then(function (response) {
                            var tokenizedPropertyDescription = dataDescription[response.propertyName];
                            tokenizedPropertyDescription.token_set = SecureFieldConstants.tokenizationValuePrefix + tokenizedPropertyDescription.token_set;
                            mapping[response.propertyName] = response.value;
                        });
                        promises.push(promise);
                    }
                }
            }
            return Promise.all(promises).then(function () {
                return;
            });
        };
        this.createUserInputDataInternal = function (pidlDocument, modelData, clientDataProperties, pidlOperation, forSubmit, forPartner) {
            var _a;
            var userInputData = {};
            var dataDescription = pidlDocument.data_description;
            for (var propertyName in dataDescription) {
                var propertyDescription = dataDescription[propertyName];
                if (isPidlDocumentArray(propertyDescription)) {
                    var innerPidlDoc = propertyDescription && propertyDescription.length && propertyDescription[0];
                    if (innerPidlDoc) {
                        userInputData[propertyName] = _this.createUserInputDataInternal(innerPidlDoc, modelData, clientDataProperties, pidlOperation, forSubmit, forPartner);
                    }
                }
                else {
                    if ((propertyDescription.displayOnly && !forPartner) || (pidlOperation === pidlOperationTypeValues.update && !propertyDescription.is_updatable)) {
                        // ignore displayonly properties only if we are not preparing this userInputData for partner
                        continue;
                    }
                    if (propertyDescription.type === dataTypes.hidden) {
                        if (!userInputData[propertyName]) {
                            if (clientDataProperties[propertyName]) {
                                userInputData[propertyName] = clientDataProperties[propertyName];
                            }
                            else {
                                userInputData[propertyName] = utils.getFormatStringExpressionValue(propertyDescription.default_value, { modelData: modelData });
                            }
                        }
                        continue;
                    }
                    var value = _this.createUserDataPropertyValue(propertyName, propertyDescription, modelData, forSubmit, forPartner);
                    if (value) {
                        if (forSubmit && propertyDescription.type === dataTypes.returnObject) {
                            // userInputData should be replaced with the value for submit
                            if (!typehelper.isObject(value)) {
                                value = (_a = {}, _a[propertyName] = value, _a);
                            }
                            userInputData = utils.extend({}, userInputData, value);
                        }
                        else {
                            userInputData[propertyName] = _this.getValueInDataType(value, forSubmit, propertyDescription);
                        }
                    }
                }
            }
            return userInputData;
        };
        this.getValueInDataType = function (value, forSubmit, propertyDescription) {
            if (forSubmit) {
                if (propertyDescription.type === dataTypes.number) {
                    var retVal = Number(value);
                    return isNaN(retVal) ? value : retVal;
                }
                else if (propertyDescription.type === dataTypes.bool) {
                    if (!typehelper.isBool(value)) {
                        return typehelper.equalsIgnoreCase(value, "true");
                    }
                }
                else if (propertyDescription.type === dataTypes.object) {
                    if (!typehelper.isObject(value)) {
                        try {
                            return JSON.parse(value);
                        }
                        catch (e) {
                            return value;
                        }
                    }
                }
            }
            return value;
        };
        this.canSubmitUserInputDataInternal = function (pidlDocument, inputData, retObject) {
            var dataDescription = pidlDocument.data_description;
            for (var propertyName in dataDescription) {
                var propertyDescription = dataDescription[propertyName];
                if (isPidlDocumentArray(propertyDescription)) {
                    var innerPidlDoc = propertyDescription && propertyDescription.length && propertyDescription[0];
                    if (innerPidlDoc) {
                        _this.canSubmitUserInputDataInternal(innerPidlDoc, inputData ? inputData[propertyName] : inputData, retObject);
                        if (retObject.canSubmit) {
                            return;
                        }
                    }
                }
                else {
                    if (propertyDescription.propertyType === propertyTypes.userData) {
                        retObject.noUserInputData = false;
                        if (!propertyDescription.is_optional || (inputData && inputData[propertyName])) {
                            retObject.canSubmit = true;
                            return;
                        }
                    }
                }
            }
        };
        // function userInputDataHelper.createUserInputData
        //   Returns a user input data object given a pidlDocument and modelData
        //
        this.createUserInputData = function (pidlDocument, modelData, clientDataProperties, pidlOperation, forSubmit, forPartner) {
            return _this.createUserInputDataInternal(pidlDocument, modelData, clientDataProperties, pidlOperation, forSubmit, forPartner);
        };
        this.createUserSecureInputData = function (pidlDocument, modelData, clientDataProperties, pidlOperation, forSubmit, forPartner) {
            var userInputData = {};
            return _this.createUserSecureInputDataInternal(pidlDocument, modelData, clientDataProperties, pidlOperation, userInputData, forSubmit, forPartner).then(function () {
                return userInputData;
            });
        };
        // function userInputDataHelper.canSubmitUserInputData
        //   Returns true if given inputData object contains user input data that is non-optional or non-empty
        //      or when the pidl document has no user input fields (e.g. paypal).
        //   Returns false when all user data fields are optional and empty.
        //
        this.canSubmitUserInputData = function (pidlDocument, inputData) {
            var retObject = { canSubmit: false, noUserInputData: true };
            _this.canSubmitUserInputDataInternal(pidlDocument, inputData, retObject);
            return retObject.canSubmit || retObject.noUserInputData;
        };
    }
    return userInputDataHelper;
}());
var userInputDataHelper$1 = new userInputDataHelper();

"use strict";
var UserInputDataTransformer = /** @class */ (function () {
    function UserInputDataTransformer() {
        var _this = this;
        this.setPropertyValueOfInputData = function (userInputData, propertyName, propertyValue) {
            for (var currProperty in userInputData) {
                if (currProperty === propertyName) {
                    userInputData[currProperty] = propertyValue;
                    break;
                }
                // The property in the data_description could be a sub PIDL objects. Example: 'details' is a sub PIDL within Payment Method Descriptions PIDL.
                else if (typehelper.isObject(userInputData[currProperty])) {
                    _this.setPropertyValueOfInputData(userInputData[currProperty], propertyName, propertyValue);
                }
            }
        };
        this.checkForValidTransformationTarget = function (propertyDescription, transformationTarget) {
            var _a = propertyDescription.transformation, transformation = _a === void 0 ? {} : _a;
            return (transformationTarget === pidlTransformationTargets.forSubmit && typehelper.boolify(transformation.forSubmit)) ||
                (transformationTarget === pidlTransformationTargets.forDisplay && typehelper.boolify(transformation.forDisplay));
        };
        this.transformUserInputDataFromService = function (eventHub, pidlDocument, propertyName, transformationTarget, propertyValue, url, pidlOperation, onTransformationComplete, fetchConfig) {
            var postData = {
                value: propertyValue,
                pidlIdentity: pidlDocument.identity,
                propertyName: propertyName,
                transformationTarget: transformationTarget
            };
            var httpHeaders$1 = fetchHelper.getDefaultHttpHeaders(eventHub);
            httpHeaders$1[httpHeaders.msFlight] = "pxpidl";
            fetchHelper
                .post(eventHub, true, urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.transformation.endpoint), [url]), httpHeaders$1, JSON.stringify(postData), function (transformedData) {
                var transformationResult;
                if (typehelper.equalsIgnoreCase(transformedData.status, pidlResultType.Passed)) {
                    transformationResult = {
                        status: pidlResultType.Passed,
                        transformedValue: transformedData.transformedValue
                    };
                }
                else {
                    transformationResult = {
                        status: pidlResultType.Fail,
                        errorCode: transformedData.errorCode,
                        errorMessage: transformedData.errorMessage
                    };
                }
                onTransformationComplete(transformationResult);
            }, function (fetchFailureMessage) {
                onTransformationComplete({
                    status: pidlResultType.Error,
                    mode: transformationModesValues.service,
                    errorMessage: fetchFailureMessage.errorMessage
                });
            }, pidlOperation, config$1.virtualEndpoints.transformation.operation, config$1.virtualEndpoints.transformation.description, true, fetchConfig).catch(
            // TODO: We need to evaluate this and catch handling
            doNothing);
        };
        this.transformPropertyInternal = function (eventHub, pidlDocument, desiredPropertyName, userInputData, transformationTarget, pidlOperation, onFail, onTransformationComplete) {
            var propertyFound = false;
            var dataDescription = pidlDocument.data_description;
            var _loop_1 = function (propertyName) {
                var propertyDescription = dataDescription[propertyName];
                if (isPidlDocumentArray(propertyDescription)) {
                    var innerPidlDoc = propertyDescription.length && propertyDescription[0];
                    if (innerPidlDoc) {
                        propertyFound = _this.transformPropertyInternal(eventHub, innerPidlDoc, desiredPropertyName, userInputData, transformationTarget, pidlOperation, function (e) {
                            onFail(e);
                        }, onTransformationComplete) || propertyFound;
                    }
                }
                else {
                    if (propertyName === desiredPropertyName) {
                        var propertyValue = commerceHelper$1.getPropertyValueFromInputData(userInputData, propertyName);
                        _this.transformPropertyFromPropertyDescription(eventHub, pidlDocument, propertyName, propertyDescription, transformationTarget, propertyValue, pidlOperation, function (transformationResult) {
                            if (transformationResult.status === pidlResultType.Passed) {
                                _this.setPropertyValueOfInputData(userInputData, propertyName, transformationResult.transformedValue);
                                onTransformationComplete();
                            }
                            if (transformationResult.status === pidlResultType.Error || transformationResult.status === pidlResultType.Fail) {
                                onFail(new Error(transformationResult.errorMessage));
                            }
                        });
                        if (_this.checkForValidTransformationTarget(propertyDescription, transformationTarget)) {
                            return { value: true };
                        }
                    }
                }
            };
            for (var propertyName in dataDescription) {
                var state_1 = _loop_1(propertyName);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
            return propertyFound;
        };
        this.transformUserInputDataInternal = function (eventHub, pidlDocument, userInputData, transformationTarget, onFail, onComplete, pidlOperation, isPartial) {
            var dataDescription = pidlDocument.data_description;
            var transformationCallPending = 0;
            var isTransformationPending = false;
            var properties = isPartial ? userInputData : dataDescription;
            var _loop_2 = function (propertyName) {
                // TODO: Make sure that this is fine to get propertyDescription from dataDescription
                // from PIDL but while traversing on userInputData is fine.
                var propertyDescription = dataDescription[propertyName];
                if (isPidlDocumentArray(propertyDescription)) {
                    var innerPidlDoc = propertyDescription && propertyDescription.length && propertyDescription[0];
                    if (innerPidlDoc) {
                        transformationCallPending++;
                        isTransformationPending =
                            _this.transformUserInputDataInternal(eventHub, innerPidlDoc, userInputData[propertyName], transformationTarget, function (e) {
                                onFail(e);
                            }, function () {
                                transformationCallPending--;
                                if (transformationCallPending === 0) {
                                    if (isTransformationPending) {
                                        if (onComplete) {
                                            onComplete();
                                        }
                                    }
                                }
                            }, pidlOperation, isPartial) || isTransformationPending;
                    }
                }
                else {
                    if (pidlOperation === pidlOperationTypeValues.update && !propertyDescription.is_updatable) {
                        return "continue";
                    }
                    var propertyValue = commerceHelper$1.getPropertyValueFromInputData(userInputData, propertyName);
                    if (!propertyValue) {
                        if (propertyDescription.displayOnly || isPartial) {
                            return "continue";
                        }
                        if (!propertyDescription.is_optional) {
                            onFail(new Error(propertyName + " is a required property per the pidlDocument but is missing in the userInputData object passed in."));
                        }
                    }
                    isTransformationPending = _this.transformPropertyFromPropertyDescription(eventHub, pidlDocument, propertyName, propertyDescription, transformationTarget, propertyValue, pidlOperation, function (transformationResult) {
                        if (transformationResult.status === pidlResultType.Passed) {
                            _this.setPropertyValueOfInputData(userInputData, propertyName, transformationResult.transformedValue);
                        }
                        if (transformationResult.status === pidlResultType.Error || transformationResult.status === pidlResultType.Fail) {
                            onFail(new Error(transformationResult.errorMessage));
                        }
                        if (transformationResult.mode === transformationModesValues.service) {
                            transformationCallPending--;
                            if (transformationCallPending === 0) {
                                if (onComplete) {
                                    onComplete();
                                }
                            }
                        }
                    });
                    if (isTransformationPending) {
                        transformationCallPending++;
                    }
                }
            };
            for (var propertyName in properties) {
                _loop_2(propertyName);
            }
            if (transformationCallPending === 0) {
                if (onComplete) {
                    onComplete();
                }
            }
            return transformationCallPending > 0;
        };
        this.transformPropertyFromPropertyDescription = function (eventHub, pidlDocument, propertyName, propertyDescription, transformationTarget, propertyValue, pidlOperation, onPropertyTransformationComplete) {
            var _a;
            var transformationResult = {};
            var isTransformationPending = false;
            if (!propertyValue) {
                return false;
            }
            if (propertyDescription.transformation) {
                var target = null;
                if (transformationTarget === pidlTransformationTargets.forSubmit) {
                    if (propertyDescription.transformation.forSubmit) {
                        target = propertyDescription.transformation.forSubmit;
                    }
                    else {
                        onPropertyTransformationComplete(transformationResult);
                        return isTransformationPending;
                    }
                }
                else if (transformationTarget === pidlTransformationTargets.forDisplay) {
                    if (propertyDescription.transformation.forDisplay) {
                        target = propertyDescription.transformation.forDisplay;
                    }
                    else {
                        onPropertyTransformationComplete(transformationResult);
                        return isTransformationPending;
                    }
                }
                else {
                    throw new Error(propertyName + "has invalid transformation type.");
                }
                // TODO: Does these names need to be changed to camel case
                var inputregex = target.inputregex, transformregex = target.transformregex;
                if (inputregex) {
                    if (transformregex) {
                        var inputRegex = new RegExp(inputregex);
                        var outputValue = propertyValue.replace(inputRegex, transformregex);
                        transformationResult = {
                            status: pidlResultType.Passed,
                            transformedValue: JSON.parse('"' + outputValue + '"')
                        };
                    }
                    transformationResult.mode = transformationModesValues.regex;
                }
                else if (target.url) {
                    isTransformationPending = true;
                    _this.transformUserInputDataFromService(eventHub, pidlDocument, propertyName, transformationTarget, propertyValue, target.url, pidlOperation, function (result) {
                        transformationResult = result;
                        transformationResult.mode = transformationModesValues.service;
                        onPropertyTransformationComplete(transformationResult);
                    }, (_a = propertyDescription === null || propertyDescription === void 0 ? void 0 : propertyDescription.dataProtection) === null || _a === void 0 ? void 0 : _a.fetchConfig);
                }
            }
            if (!isTransformationPending) {
                onPropertyTransformationComplete(transformationResult);
            }
            return isTransformationPending;
        };
        // function commerce2.getUserDisplayDataPartial
        //   This function constructs and returns an object with the properties and values that can be displayed back to the
        //   user. This variant of the function can work on partial data and does not require the entire data to be present.
        this.getUserDisplayDataPartial = function (eventHub, pidlDocument, userInputData, onFail, onComplete, pidlOperation) {
            var userDisplayData = typehelper.deepCopy(userInputData);
            _this.transformUserInputDataInternal(eventHub, pidlDocument, userDisplayData, pidlTransformationTargets.forDisplay, onFail, function () {
                onComplete(userDisplayData);
            }, pidlOperation, true);
        };
        // function commerce2.transformUserInputData
        //   This function iterates through every property in the userInputData, performs transformation if they are defined
        //
        this.transformUserInputData = function (eventHub, pidlDocument, userInputData, onFail, onComplete, pidlOperation) {
            _this.transformUserInputDataInternal(eventHub, pidlDocument, userInputData, pidlTransformationTargets.forSubmit, onFail, onComplete, pidlOperation);
        };
        // function commerce2.transformPropertyForDisplayByName
        //   This function iterates through the data description and applies display transforms to the property if applicable for submit
        //
        this.transformUserInputPropertyForDisplay = function (eventHub, pidlDocument, propertyName, userDisplayData, pidlOperation, onFail, onComplete) {
            if (!_this.transformPropertyInternal(eventHub, pidlDocument, propertyName, userDisplayData, pidlTransformationTargets.forDisplay, pidlOperation, onFail, onComplete)) {
                onFail(Error("The property with property Name:" + propertyName + " does not have valid display transform in data description"));
            }
        };
    }
    return UserInputDataTransformer;
}());
var UserInputDataTransformer$1 = new UserInputDataTransformer();

"use strict";
var commerceService = /** @class */ (function () {
    function commerceService() {
        var _this = this;
        this.getParentOfProperty = function (propertyName, userDisplayData) {
            for (var key in userDisplayData) {
                if (key === propertyName) {
                    return userDisplayData;
                }
                else if (typehelper.isObject(userDisplayData[key])) {
                    var parent = _this.getParentOfProperty(propertyName, userDisplayData[key]);
                    if (parent) {
                        return parent;
                    }
                }
            }
        };
        this.areIdentitiesEqual = function (identityA, identityB) {
            if (!identityA || !identityB) {
                return false;
            }
            if (typehelper.keyCount(identityA) !== typehelper.keyCount(identityB)) {
                return false;
            }
            for (var key in identityA) {
                if (identityA[key] !== identityB[key]) {
                    return false;
                }
            }
            return true;
        };
        this.resolveInfoDescriptionId = function (pidlDocs, keyElementNamesAndValueCallbacks) {
            /**
             * Promise Callsites:
             * pidlDocumentManager.resolvePidlDoc = rejection not handled
             *  => model.updateResolvedPidlDoc = rejection handled
             */
            return _this.invoke(function (result) {
                try {
                    var ret = commerce2.resolveInfoDescriptionId(pidlDocs, keyElementNamesAndValueCallbacks);
                    result.resolve(ret);
                }
                catch (err) {
                    result.reject(err);
                }
            });
        };
        this.getFirstPidlWithValidDefaultKey = function (pidlDocs, keyElementNamesAndValueCallbacks) {
            return commerce2.getFirstPidlWithValidDefaultKey(pidlDocs, keyElementNamesAndValueCallbacks);
        };
        this.createUserInputData = function (pidlDoc, modelData, clientData, pidlOperation, forSubmit, forPartner) {
            return userInputDataHelper$1.createUserInputData(pidlDoc, modelData, clientData, pidlOperation, forSubmit, forPartner);
        };
        this.createUserSecureInputData = function (pidlDoc, modelData, clientData, pidlOperation, forSubmit, forPartner) {
            return userInputDataHelper$1.createUserSecureInputData(pidlDoc, modelData, clientData, pidlOperation, forSubmit, forPartner);
        };
    }
    commerceService.prototype.invoke = function (actionToInvoke) {
        return new Promise(function (resolve, reject) {
            actionToInvoke({ resolve: resolve, reject: reject });
        });
    };
    commerceService.prototype.getUserDisplayDataPartial = function (eventHub, pidlDocManager, userInputData, pidlOperation) {
        /**
         * Promise Callsites:
         * model.moveNextPage = rejection not handled
         */
        return this.invoke(function (result) {
            try {
                var pidlDocs = pidlDocManager.getResolvedOrAllPidlDocs();
                var pidlDoc = commerceHelper$1.getFirstResolvedPidlDocument(pidlDocs, userInputData);
                if (pidlDoc == null) {
                    pidlDoc = pidlDocs[0];
                }
                UserInputDataTransformer$1.getUserDisplayDataPartial(eventHub, pidlDoc, userInputData, function (errorObject) {
                    result.reject(errorObject);
                }, function (ret) {
                    result.resolve(ret);
                }, pidlOperation);
            }
            catch (err) {
                result.reject(err);
            }
        });
    };
    commerceService.prototype.transformUserInputData = function (pidlDoc, eventHub, userInputData, pidlOperation) {
        /**
         * Promise Callsites:
         * model.validateAndTransformUserInputPidlData = rejection handled
         */
        return this.invoke(function (result) {
            try {
                UserInputDataTransformer$1.transformUserInputData(eventHub, pidlDoc, userInputData, function (errorObject) {
                    result.reject(errorObject);
                }, function () {
                    result.resolve();
                }, pidlOperation);
            }
            catch (err) {
                result.reject(err);
            }
        });
    };
    commerceService.prototype.transformUserInputPropertyForDisplay = function (pidlDocs, eventHub, propertyName, userDisplayData, pidlOperation) {
        var _this = this;
        /**
         * Promise Callsites:
         * model.transformResourceInstanceInternal = rejection not handled
         *  => model.transformResourceInstance = rejection handled
         */
        return this.invoke(function (result) {
            var failed = false;
            eventHub.propertyTransforming(propertyName);
            try {
                var propertyParent = _this.getParentOfProperty(propertyName, userDisplayData);
                var tempDisplayData = {};
                tempDisplayData[propertyName] = propertyParent[propertyName];
                var pidlDoc = commerceHelper$1.getFirstResolvedPidlDocument(pidlDocs, userDisplayData);
                if (pidlDoc == null) {
                    pidlDoc = pidlDocs[0];
                }
                UserInputDataTransformer$1.transformUserInputPropertyForDisplay(eventHub, pidlDoc, propertyName, tempDisplayData, pidlOperation, function (errorObject) {
                    failed = true;
                    result.reject(errorObject);
                }, function () {
                    eventHub.propertyTransformed(propertyName);
                    propertyParent[propertyName] = tempDisplayData[propertyName];
                    result.resolve();
                });
                // TODO: There is a bug in commerce2.transformUserInputPropertyForDisplay(). It does not call onComplete(), so calling it explicitly here
                // Need to remove this call once commerce.js is fixed
                if (!failed) {
                    eventHub.propertyTransformed(propertyName);
                    propertyParent[propertyName] = tempDisplayData[propertyName];
                    result.resolve();
                }
            }
            catch (err) {
                result.reject(err);
            }
        });
    };
    commerceService.prototype.canSubmitUserInputData = function (pidlDocument, inputData) {
        return userInputDataHelper$1.canSubmitUserInputData(pidlDocument, inputData);
    };
    commerceService.prototype.getPidlSubmitOrder = function (pidlDocument) {
        return commerce2.getPidlSubmitOrder(pidlDocument);
    };
    return commerceService;
}());

"use strict";
function invokeGetRequest(eventHub, request) {
    /**
     * Promise Callsite
     * pidlService.getPidlDocument = rejection handled downstream
     * pidlService.getInstance = rejection handled downstream
     */
    return fetchHelper.get(eventHub, request.url, request.headers, request.pidlOperation, request.virtualEndpoint.operation, request.virtualEndpoint.description, request.fetchConfig);
}
var pidlService = /** @class */ (function () {
    function pidlService() {
    }
    pidlService.prototype.getPidlDocument = function (eventHub, request, getPidlDocumentHook) {
        /**
         * Promise Callsites:
         * pidlDocManager.getPidlDocument = rejection handled
         */
        if (getPidlDocumentHook) {
            return new Promise(function (resolve, reject) {
                getPidlDocumentHook(request, function (pidlDocs) {
                    resolve(pidlDocs);
                }, function (errorObject) {
                    reject(errorObject);
                });
            });
        }
        return invokeGetRequest(eventHub, request);
    };
    pidlService.prototype.getInstance = function (eventHub, request) {
        /**
         * Promise Callsites:
         * model.getResourceData = rejection handled
         * controlApi.downloadInstance = rejection handled
         * controlApi.handleChallenge = rejection handled
         */
        eventHub.instanceDownloading(request.url);
        return invokeGetRequest(eventHub, request);
    };
    pidlService.prototype.submitPidlDocument = function (eventHub, request, pidlOperation, submissionSuccessTransformer) {
        eventHub.inputSubmitting(request.url);
        /**
         * Promise Callsites:
         * model.invokeSubmitRequest = rejection handled
         */
        return new Promise(function (resolve, reject) {
            // TODO: Need to review catch block below. We might like to throw from there.
            fetchHelper.invokeFetch(eventHub, true, request.method, request.url, request.headers, (request.method.toUpperCase() === httpActions.Get || request.method.toUpperCase() === httpActions.Delete) ? null : JSON.stringify(request.data), function (responseJson) {
                if (submissionSuccessTransformer) {
                    responseJson = submissionSuccessTransformer(request, responseJson);
                }
                var action = "None";
                if (isPidlDocumentWithClientAction(responseJson) && responseJson.clientAction) {
                    action = responseJson.clientAction.type;
                }
                eventHub.inputSubmitted(action);
                resolve(responseJson);
            }, function (fetchFailureMessage) {
                reject(fetchFailureMessage);
            }, pidlOperation, request.virtualEndpoint.operation, request.virtualEndpoint.description).catch(resolve);
        });
    };
    pidlService.prototype.invokeRestMethod = function (eventHub, request, pidlOperation) {
        /**
         * Promise Callsites:
         * model.invokeRestMethod = rejection handled
         */
        // TODO: Need to review catch block below. We might like to throw from there.
        return new Promise(function (resolve, reject) {
            fetchHelper.invokeFetch(eventHub, true, request.method, request.url, request.headers, request.data, function (response) {
                resolve(response);
            }, function (fetchFailureMessage) {
                reject(fetchFailureMessage);
            }, pidlOperation, request.virtualEndpoint.operation, request.virtualEndpoint.description).catch(resolve);
        });
    };
    pidlService.prototype.getRequestInstance = function (eventHub, resourceInfo, userContext, pidlOperation, fetchConfig) {
        var url = urlBuilder$1.getResourceUrl(resourceInfo, userContext);
        return {
            url: url.url,
            headers: fetchHelper.getHttpHeaders(eventHub, userContext, null, url.template, null),
            virtualEndpoint: url.virtualEndpoint,
            pidlOperation: pidlOperation,
            fetchConfig: fetchConfig
        };
    };
    return pidlService;
}());

"use strict";
var pidlStoreService = /** @class */ (function () {
    function pidlStoreService() {
        this.cache = null;
        this.cache = new DataCache();
    }
    pidlStoreService.prototype.put = function (handle, pidlDocInfo, pidls, resolvedPidlIdentity) {
        var entry = { pidlDocInfo: pidlDocInfo, pidls: pidls, resolvedPidlIdentity: resolvedPidlIdentity };
        this.cache.put(handle, entry);
    };
    pidlStoreService.prototype.get = function (handle) {
        return this.cache.get(handle);
    };
    pidlStoreService.prototype.remove = function (handle) {
        this.cache.remove(handle);
    };
    pidlStoreService.prototype.removeResourceEntries = function (resourceType) {
        this.cache.removeIf(function (entry) {
            return entry && entry.pidlDocInfo && typehelper.equalsIgnoreCase(entry.pidlDocInfo.resourceType, resourceType);
        });
    };
    return pidlStoreService;
}());

"use strict";
var redirectionService = /** @class */ (function () {
    function redirectionService() {
    }
    redirectionService.prototype.redirect = function (url) {
        window.location.replace(url);
        window.location.href = url;
    };
    redirectionService.prototype.openInNewTab = function (url) {
        if (window && window.open) {
            window.open(url);
            return true;
        }
        return false;
    };
    return redirectionService;
}());

"use strict";
var controlApi = /** @class */ (function () {
    // TODO: Make ICallbacks for controlApi that requires IView in it
    function controlApi(userContext, returnOptions, eventHandler, displayOptions, callbacks, telemetryOptions, externalPrivateEventHandler, oneDSService, transformers, pidlPayload, localDataSourceProviders) {
        var _this = this;
        this.addSecureFieldPreLoadIFrame = function () {
            try {
                // if document is not defined, we are not in a web environment
                var isWeb = typeof document !== "undefined";
                if (!isWeb) {
                    return;
                }
                _this.eventHub.addSecureFieldPreLoadIFrameStarted();
                var secureIFrameId = "secureFieldIFrame";
                var securepxUrl = urlBuilder$1.buildUrl(config$1.getServiceEndpoint(config$1.virtualEndpoints.securePx.endpoint), ["resources", "securefield.html"]);
                var secureFieldIFrame = document.createElement("iframe");
                secureFieldIFrame.id = secureIFrameId;
                secureFieldIFrame.name = "preloadSecureFieldIFrame";
                secureFieldIFrame.style.display = "none";
                secureFieldIFrame.setAttribute("sandbox", ""); // We don't want this iframe to have any permissions and execute scripts. This is only to load the securefield.html
                secureFieldIFrame.src = securepxUrl;
                var existingIFrame = document.getElementById(secureIFrameId);
                if (!existingIFrame) {
                    if (document.body) {
                        document.body.appendChild(secureFieldIFrame);
                    }
                }
                else {
                    existingIFrame.src = securepxUrl;
                }
                _this.eventHub.addSecureFieldPreLoadIFrameCompleted();
            }
            catch (err) {
                _this.eventHub.addSecureFieldPreLoadIFrameFailed(utils.convertErrorToString(err));
            }
        };
        this.logConstructorCall = function (userContextIn, returnOptions, eventHandler, displayOptions, telemetryOptions) {
            var parametersPassed = {
                userContext: typehelper.boolify(userContextIn),
                returnOptions: typehelper.boolify(returnOptions),
                eventHandler: typehelper.boolify(eventHandler),
                displayOptions: typehelper.boolify(displayOptions),
                telemetryOptions: typehelper.boolify(telemetryOptions)
            };
            var sanitizedParameters = {
                returnOptions: returnOptions,
                displayOptions: displayOptions,
                telemetryOptions: telemetryOptions
            };
            _this.eventHub.apiCalled(pidlDdcApiNames.constructor, parametersPassed, sanitizedParameters);
        };
        this.unhandledRejectionHandler = function (event) {
            var reason = event.reason && event.reason.stack;
            if (reason) {
                _this.eventHub.error(new pidlErrors.unexpectedError(errorMessages.unhandledRejection, [reason]));
            }
        };
        this.handlePrivateEvent = function (event, params) {
            try {
                switch (event) {
                    case privateEventNames.stateChanged:
                        if (params && params.newState === controlStates.initialized && _this.telemetryContext.enableUnhandledRejectionLogging) {
                            window.addEventListener("unhandledrejection", _this.unhandledRejectionHandler);
                        }
                        break;
                    case privateEventNames.failure:
                    case privateEventNames.success:
                    case privateEventNames.gohome:
                        if (_this.telemetryContext.enableUnhandledRejectionLogging) {
                            window.removeEventListener("unhandledrejection", _this.unhandledRejectionHandler);
                        }
                }
            }
            catch (err) {
                // We need to catch ReferenceErrors when window is undefined in server side rendering
            }
        };
        this.canApiStart = function (api) {
            var ret = _this.stateManager.canApiStart(api);
            if (!ret.result) {
                _this.eventHub.error(ret.error);
                return false;
            }
            return true;
        };
        this.getChallengePidlInfo = function (params) {
            var challengePidlInfo = {
                resourceType: "Challenge",
                parameters: typehelper.deepCopy(params.piResourceInfo.parameters)
            };
            challengePidlInfo.parameters.piid = params.piResourceInfo.id;
            challengePidlInfo.parameters.sessionId = params.sessionId;
            challengePidlInfo.parameters.orderId = params.orderId;
            return challengePidlInfo;
        };
        this.provisionWalletToken = function (sessionData, data) {
            var provisionTokenBody = {
                piFamily: data === null || data === void 0 ? void 0 : data.family,
                piType: data === null || data === void 0 ? void 0 : data.type,
                tokenReference: data === null || data === void 0 ? void 0 : data.tokenReference,
                sessionData: sessionData
            };
            return new Promise(function (resolve, reject) {
                var _a;
                var resourceInfo = {
                    resourceType: pidlResourceTypes.WalletToken,
                    parameters: {}
                };
                var config = configManager$1.getResourceEndpoint(resourceInfo.resourceType);
                var url = (_a = urlBuilder$1.getResourceUrl(resourceInfo, _this.userContext)) === null || _a === void 0 ? void 0 : _a.url;
                try {
                    return fetchHelper.post(_this.eventHub, true, url, fetchHelper.getHttpHeaders(_this.eventHub, _this.userContext, undefined, config.template), JSON.stringify(provisionTokenBody), function (response) { return resolve(response); }, function (error) { return reject(error); }, pidlOperationTypeValues.provisionWalletToken, config.operation, config.description, true);
                }
                catch (err) {
                    reject(err);
                }
            });
        };
        this.handlePaymentAgentChallenge = function (paymentSessionOrData, challengePidlInfo, containerRef, testHeaders) {
            var _a, _b;
            if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.paymentAgent) === null || _a === void 0 ? void 0 : _a.isReadyToPay) === null || _b === void 0 ? void 0 : _b.call(_a))) {
                var error = new pidlErrors.invalidSetupError(errorMessages.invalidSetup);
                _this.eventHub.failure(error);
                return _this.apiFailure(false);
            }
            var promise$1 = window.paymentAgent.handleChallenge(paymentSessionOrData, testHeaders);
            var handlePaymentAgentChallengePromise = promise$1
                .then(function (data) {
                //provision token call
                if (data.tokenReference) {
                    var provisionPromise = _this.provisionWalletToken(paymentSessionOrData, data);
                    return provisionPromise
                        .then(function (response) {
                        // Make wrapping container visible
                        // TODO, add JS support for this pattern
                        if (containerRef) {
                            containerRef.current.style.display = "flex";
                            containerRef.current.attributes["aria-hidden"] = "false";
                        }
                        challengePidlInfo.parameters.paymentSessionOrData = __assign(__assign({}, paymentSessionOrData), response);
                        var ret = _this.renderPidlPageInternal(challengePidlInfo);
                        return ret;
                    });
                }
                else {
                    var ret = _this.renderPidlPageInternal(challengePidlInfo);
                    return ret;
                }
            })
                .catch(function (err) {
                if ((err === null || err === void 0 ? void 0 : err.type) === "cancel" || (err === null || err === void 0 ? void 0 : err.name) === "AbortError" || (err === null || err === void 0 ? void 0 : err.statusCode) === "CANCELED") {
                    _this.model.gohome();
                    return createFakePromise();
                }
                else {
                    var errorDetails = {
                        error: err,
                        stack: err === null || err === void 0 ? void 0 : err.stack,
                        message: err === null || err === void 0 ? void 0 : err.message,
                    };
                    var error = void 0;
                    if (err === "failed to open window") {
                        error = new pidlErrors.failedToOpenWindowError(errorMessages.failedToOpenWindow, JSON.stringify(errorDetails));
                    }
                    else {
                        error = new pidlErrors.paymentMethodFailureError(errorMessages.paymentMethodFailure, JSON.stringify(errorDetails));
                    }
                    _this.eventHub.failure(error);
                    return _this.apiFailure(error);
                }
            });
            return _this.apiSuccess(true, handlePaymentAgentChallengePromise);
        };
        this.invokeResourceAction = function (params) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.invokeResourceAction);
            _this.eventHub.apiCalled(pidlDdcApiNames.invokeResourceAction);
            if (!_this.canApiStart(pidlDdcApiNames.invokeResourceAction) ||
                !params ||
                !inputValidationHelper$1.validateResourceActionParams(_this.eventHub, params)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.invokeResourceAction, false);
                return _this.apiFailure(false);
            }
            var resourceActionContext = params.resourceActionContext;
            var ret = { result: null, promise: createFakePromise(null) };
            switch (resourceActionContext.action) {
                case resourceActions.addResource:
                case resourceActions.addAddress:
                    _this.telemetryContext.update(telemetryPidlOperationType.add, resourceActionContext.pidlDocInfo);
                    ret = _this.addResourceInternal(pidlOperationTypeValues.add, resourceActionContext.pidlDocInfo, params.prefillData, params.options);
                    break;
                case resourceActions.collectResourceInfo:
                    _this.telemetryContext.update(telemetryPidlOperationType.renderPidlPage, resourceActionContext.pidlDocInfo);
                    ret = _this.renderPidlPageInternal(resourceActionContext.pidlDocInfo, params.options);
                    break;
                case resourceActions.handleChallenge:
                    _this.telemetryContext.update(telemetryPidlOperationType.verify, resourceActionContext.resourceInfo);
                    ret = _this.handleChallengeInternal(resourceActionContext.resourceInfo, params.options);
                    break;
                case resourceActions.selectPaymentInstrument:
                case resourceActions.selectResource:
                    _this.telemetryContext.update(telemetryPidlOperationType.selectResource, resourceActionContext.pidlDocInfo);
                    ret = _this.selectInstanceInternal(resourceActionContext.pidlDocInfo, params.options, resourceActionContext, params.selectedResourceInfo);
                    break;
                case resourceActions.selectResourceType:
                    _this.telemetryContext.update(telemetryPidlOperationType.selectResourceType, resourceActionContext.pidlDocInfo);
                    ret = _this.selectResourceTypeInternal(resourceActionContext.pidlDocInfo, params.options);
                    break;
                case resourceActions.selectSingleResource:
                    _this.telemetryContext.update(telemetryPidlOperationType.selectSingleResource, resourceActionContext.pidlDocInfo);
                    ret = _this.selectSingleInstanceInternal(resourceActionContext.pidlDocInfo, params.options, resourceActionContext, params.selectedResourceInfo);
                    break;
                case resourceActions.updateProfile:
                case resourceActions.updateResource:
                    _this.telemetryContext.update(telemetryPidlOperationType.update, resourceActionContext.pidlDocInfo || resourceActionContext.resourceInfo);
                    ret = _this.updateOrDeleteResourceInternal(resourceActionContext.resourceInfo, resourceActionContext.resource, resourceActionContext.pidlDocInfo, params.options);
                    break;
                case resourceActions.deleteResource:
                    _this.telemetryContext.update(telemetryPidlOperationType.delete, resourceActionContext.pidlDocInfo || resourceActionContext.resourceInfo);
                    ret = _this.updateOrDeleteResourceInternal(resourceActionContext.resourceInfo, resourceActionContext.resource, resourceActionContext.pidlDocInfo, params.options, pidlOperationTypeValues.delete);
                    break;
                case resourceActions.searchTransactions:
                    _this.telemetryContext.update(telemetryPidlOperationType.searchTransactions, resourceActionContext.pidlDocInfo);
                    ret = _this.addResourceInternal(pidlOperationTypeValues.searchTransactions, resourceActionContext.pidlDocInfo, undefined, params.options);
                    break;
            }
            _this.eventHub.apiReturned(pidlDdcApiNames.invokeResourceAction, typehelper.boolify(ret.result), ret.promise);
            return ret;
        };
        this.addResourceInternal = function (operationType, pidlDocInfo, prefillData, options) {
            if (!inputValidationHelper$1.validatePidlDocInfo(_this.eventHub, pidlDocInfo) ||
                !inputValidationHelper$1.validateAddUpdateOrDeleteOptions(_this.eventHub, options)) {
                return _this.apiFailure(false);
            }
            var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
            return _this.apiSuccess(true, _this.getPidl(url, prefillData, operationType, options, pidlDocInfo));
        };
        this.addResource = function (pidlDocInfo, prefillData, options) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.add, pidlDocInfo);
            // Preload secure field iframe contents to speed up the secure fields loading
            if (_this.displaySettings.secureFieldPreLoadingEnabled) {
                _this.addSecureFieldPreLoadIFrame();
            }
            _this.eventHub.apiCalled(pidlDdcApiNames.addResource, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                prefillData: typehelper.boolify(prefillData),
                options: typehelper.boolify(options)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.addResource)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.addResource, false);
                return _this.apiFailure(false);
            }
            var ret = _this.addResourceInternal(pidlOperationTypeValues.add, pidlDocInfo, prefillData, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.addResource, ret.result, ret.promise);
            return ret;
        };
        this.msRewardsInternal = function (operationType, pidlDocInfo) {
            if (!inputValidationHelper$1.validatePidlDocInfo(_this.eventHub, pidlDocInfo)) {
                return _this.apiFailure(false);
            }
            var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
            return _this.apiSuccess(true, _this.getPidl(url, {}, operationType, {}, pidlDocInfo));
        };
        this.redeemMSRewards = function (pidlDocInfo) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.redeemMSRewards, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.redeemMSRewards, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.redeemMSRewards)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.redeemMSRewards, false);
                return _this.apiFailure(false);
            }
            var ret = _this.msRewardsInternal(pidlOperationTypeValues.redeem, pidlDocInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.redeemMSRewards, ret.result, ret.promise);
            return ret;
        };
        this.selectMSRewards = function (pidlDocInfo) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.selectMSRewards, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.selectMSRewards, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.selectMSRewards)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.selectMSRewards, false);
                return _this.apiFailure(false);
            }
            var ret = _this.msRewardsInternal(pidlOperationTypeValues.select, pidlDocInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.selectMSRewards, ret.result, ret.promise);
            return ret;
        };
        this.searchTransactions = function (params) {
            var pidlDocInfo = params.pidlDocInfo, options = params.options;
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.searchTransactions, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.searchTransactions, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                options: typehelper.boolify(options)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.searchTransactions)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.searchTransactions, false);
                return _this.apiFailure(false);
            }
            var ret = _this.addResourceInternal(pidlOperationTypeValues.searchTransactions, pidlDocInfo, undefined, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.searchTransactions, ret.result, ret.promise);
            return ret;
        };
        this.addPaymentInstrument = function (pidlDocInfo, prefillData, options) {
            var _a;
            var pidlDocWithResource = __assign(__assign({}, pidlDocInfo), { resourceType: (pidlDocInfo === null || pidlDocInfo === void 0 ? void 0 : pidlDocInfo.resourceType) ? (_a = pidlDocInfo === null || pidlDocInfo === void 0 ? void 0 : pidlDocInfo.resourceType) === null || _a === void 0 ? void 0 : _a.toString() : "PaymentInstrument" });
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.addPaymentInstrument, pidlDocWithResource);
            _this.eventHub.apiCalled(pidlDdcApiNames.addPaymentInstrument, {
                pidlDocInfo: typehelper.boolify(pidlDocWithResource),
                prefillData: typehelper.boolify(prefillData),
                options: typehelper.boolify(options)
            }, {
                pidlDocInfo: pidlDocWithResource
            });
            if (!_this.canApiStart(pidlDdcApiNames.addPaymentInstrument)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.addPaymentInstrument, false);
                return _this.apiFailure(false);
            }
            var ret = _this.addResourceInternal(pidlOperationTypeValues.add, pidlDocWithResource, prefillData, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.addPaymentInstrument, ret.result, ret.promise);
            return ret;
        };
        this.applyResource = function (pidlDocInfo, prefillData, options) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.applyResource, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.applyResource, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                prefillData: typehelper.boolify(prefillData),
                options: typehelper.boolify(options)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.applyResource)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.applyResource, false);
                return _this.apiFailure(false);
            }
            var ret = _this.addResourceInternal(pidlOperationTypeValues.apply, pidlDocInfo, prefillData, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.applyResource, ret.result, ret.promise);
            return ret;
        };
        this.replaceResource = function (pidlDocInfo, intersectingData, options) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.replace, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.replaceResource, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                prefillData: typehelper.boolify(intersectingData),
                options: typehelper.boolify(options)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.replaceResource)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.replaceResource, false);
                return _this.apiFailure(false);
            }
            var ret = _this.addResourceInternal(pidlOperationTypeValues.replace, pidlDocInfo, intersectingData, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.replaceResource, ret.result, ret.promise);
            return ret;
        };
        this.addAddress = function (pidlDocInfo, prefillData, options) {
            var pidlDocWithResource = __assign(__assign({}, pidlDocInfo), { resourceType: "Address" });
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.addAddress, pidlDocWithResource);
            _this.eventHub.apiCalled(pidlDdcApiNames.addAddress, {
                pidlDocInfo: typehelper.boolify(pidlDocWithResource),
                prefillData: typehelper.boolify(prefillData),
                options: typehelper.boolify(options)
            }, {
                pidlDocInfo: pidlDocWithResource
            });
            if (!_this.canApiStart(pidlDdcApiNames.addAddress)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.addAddress, false);
                return _this.apiFailure(false);
            }
            var ret = _this.addResourceInternal(pidlOperationTypeValues.add, pidlDocWithResource, prefillData, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.addAddress, ret.result, ret.promise);
            return ret;
        };
        this.validateAddress = function (pidlDocInfo) {
            var pidlDocWithResource = __assign(__assign({}, pidlDocInfo), { resourceType: "Address" });
            return _this.validateResource(pidlDocWithResource);
        };
        this.handleCheckout = function (params) {
            var _a = params || {}, checkoutId = _a.checkoutId, partner = _a.partner, redirectUrl = _a.redirectUrl, paymentProviderId = _a.paymentProviderId, language = _a.language, market = _a.market;
            var resourceInfo = {
                resourceType: pidlResourceTypes.Checkout,
                parameters: { partner: partner, checkoutId: checkoutId, redirectUrl: redirectUrl, paymentProviderId: paymentProviderId, language: language, market: market },
                anonymousPidl: params.anonymousUser
            };
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.handleCheckout, resourceInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.handleCheckout, {
                checkoutParams: typehelper.boolify(params),
            }, {});
            if (!_this.canApiStart(pidlDdcApiNames.handleCheckout) ||
                !inputValidationHelper$1.validateCheckoutParams(_this.eventHub, params)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.handlePaymentChallenge, false);
                return _this.apiFailure(false);
            }
            var handleCheckOutPidlInfo = {
                resourceType: pidlResourceTypes.Checkout,
                parameters: { partner: partner, checkoutId: checkoutId, redirectUrl: redirectUrl, paymentProviderId: paymentProviderId, language: language, market: market },
                anonymousPidl: params.anonymousUser
            };
            // Render pidl
            var ret = _this.renderPidlPageInternal(handleCheckOutPidlInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.handleCheckout, ret.result, ret.promise);
            return ret;
        };
        this.getPayeeTaxProfile = function (params) {
            var _a = params || {}, section = _a.section, tenant = _a.tenant, sapidind = _a.sapidind, status = _a.status, accounttype = _a.accounttype, payfromcc = _a.payfromcc, residencecc = _a.residencecc, language = _a.language;
            var resourceInfo = {
                resourceType: pidlResourceTypes.PayeeTaxProfile,
                parameters: { section: section, tenant: tenant, sapidind: sapidind, status: status, accounttype: accounttype, payfromcc: payfromcc, residencecc: residencecc, language: language },
            };
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.getPayeeTaxProfile, resourceInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.getPayeeTaxProfile, {
                payeeTaxProfileParams: typehelper.boolify(params),
            }, {});
            if (!_this.canApiStart(pidlDdcApiNames.getPayeeTaxProfile) ||
                !inputValidationHelper$1.validatePayeeTaxProfileParams(_this.eventHub, params)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.getPayeeTaxProfile, false);
                return _this.apiFailure(false);
            }
            var getPayeeTaxProfilePidlInfo = {
                resourceType: pidlResourceTypes.PayeeTaxProfile,
                parameters: { section: section, tenant: tenant, sapidind: sapidind, status: status, accounttype: accounttype, payfromcc: payfromcc, residencecc: residencecc, language: language }
            };
            // Render pidl
            var ret = _this.renderPidlPageInternal(getPayeeTaxProfilePidlInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.getPayeeTaxProfile, ret.result, ret.promise);
            return ret;
        };
        this.createPaymentSession = function (paymentSessionData) {
            var _a = paymentSessionData || {}, _b = _a.partner, partner = _b === void 0 ? null : _b, _c = _a.country, market = _c === void 0 ? null : _c, _d = _a.language, language = _d === void 0 ? null : _d;
            var resourceInfo = { resourceType: pidlResourceTypes.PaymentSession, parameters: { partner: partner, market: market, language: language, paymentSessionData: paymentSessionData } };
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.createPaymentSession, resourceInfo);
            // TODO: Figure out, if we can log paymentSessionData object in telemetry.
            _this.eventHub.apiCalled(pidlDdcApiNames.createPaymentSession, {
                paymentSessionData: typehelper.boolify(paymentSessionData),
            }, {});
            if (!_this.canApiStart(pidlDdcApiNames.createPaymentSession) ||
                !inputValidationHelper$1.validatePaymentSessionData(_this.eventHub, paymentSessionData)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.createPaymentSession, false);
                return _this.apiFailure(false);
            }
            // prepare pidlDocInfo to call into addResource
            var pidlDocInfo = {
                resourceType: pidlResourceTypes.PaymentSession,
                parameters: { paymentSessionData: paymentSessionData }
            };
            // Need to add billableAccountId and classicProduct as querystring parameters to the PIFD call to resolve the accountId correctly.
            if (paymentSessionData.billableAccountId) {
                pidlDocInfo.parameters.billableAccountId = paymentSessionData.billableAccountId;
            }
            if (paymentSessionData.classicProduct) {
                pidlDocInfo.parameters.classicProduct = paymentSessionData.classicProduct;
            }
            var ret = _this.addResourceInternal(pidlOperationTypeValues.add, pidlDocInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.createPaymentSession, ret.result, ret.promise);
            return ret;
        };
        this.renderPidlPageInternal = function (pidlDocInfo, options) {
            if (!inputValidationHelper$1.validatePidlDocInfo(_this.eventHub, pidlDocInfo) ||
                !inputValidationHelper$1.validateSelectOrRenderOptions(_this.eventHub, options)) {
                return _this.apiFailure(false);
            }
            var operationType = pidlOperationTypeValues.renderPidlPage;
            var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
            return _this.apiSuccess(true, _this.getPidl(url, null, operationType, options, pidlDocInfo));
        };
        this.renderPidlPage = function (pidlDocInfo, options) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.renderPidlPage, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.renderPidlPage, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                options: typehelper.boolify(options)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.renderPidlPage)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.renderPidlPage, false);
                return _this.apiFailure(false);
            }
            var ret = _this.renderPidlPageInternal(pidlDocInfo, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.renderPidlPage, ret.result, ret.promise);
            return ret;
        };
        this.handlePaymentChallenge = function (paymentSessionOrData, containerRef) {
            var _a, _b;
            var _c = paymentSessionOrData || {}, _d = _c.partner, partner = _d === void 0 ? null : _d, _e = _c.country, market = _e === void 0 ? null : _e, _f = _c.language, language = _f === void 0 ? null : _f;
            var resourceInfo = { resourceType: pidlResourceTypes.Challenge, parameters: { partner: partner, market: market, language: language, paymentSessionOrData: paymentSessionOrData, timezoneOffset: new Date().getTimezoneOffset() } };
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.handlePaymentChallenge, resourceInfo);
            // TODO: Figure out, if we can log paymentSession object in telemetry.
            _this.eventHub.apiCalled(pidlDdcApiNames.handlePaymentChallenge, {
                paymentSessionData: typehelper.boolify(paymentSessionOrData),
            }, {});
            if (!_this.canApiStart(pidlDdcApiNames.handlePaymentChallenge) ||
                !inputValidationHelper$1.validatePaymentSessionOrData(_this.eventHub, paymentSessionOrData)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.handlePaymentChallenge, false);
                return _this.apiFailure(false);
            }
            // prepare pidlDocInfo to get payment challenge pidl
            var challengePidlInfo = {
                resourceType: pidlResourceTypes.Challenge,
                parameters: {
                    paymentSessionOrData: paymentSessionOrData,
                    timezoneOffset: new Date().getTimezoneOffset()
                }
            };
            // Need to add billableAccountId and classicProduct as querystring parameters to the PIFD call to resolve the accountId correctly.
            if (paymentSessionOrData.billableAccountId) {
                challengePidlInfo.parameters.billableAccountId = paymentSessionOrData.billableAccountId;
            }
            if (paymentSessionOrData.classicProduct) {
                challengePidlInfo.parameters.classicProduct = paymentSessionOrData.classicProduct;
            }
            // GooglePay and ApplePay invoke a paymentAgent to render the payment sheet on screen for users, then afterwards we continue
            // the handlepaymentChallenge flow as normal to render PSD2 challenge if needed
            var ret;
            var headers = _this.userContext.getHeaders({}, "");
            var msTestHeaders = headers[httpHeaders.msTest] || "";
            var msFlightHeaders = utils.getFlightHeaders(_this.userContext);
            if ((msFlightHeaders === null || msFlightHeaders === void 0 ? void 0 : msFlightHeaders.includes(flightHeaders.enablePaymentAgentChallenge)) && ((_b = (_a = window.paymentAgent) === null || _a === void 0 ? void 0 : _a.isPaymentAgentSupportedPI) === null || _b === void 0 ? void 0 : _b.call(_a, paymentSessionOrData))) {
                ret = _this.handlePaymentAgentChallenge(paymentSessionOrData, challengePidlInfo, containerRef, msTestHeaders);
            }
            else if (paymentSessionOrData.piid === PaymentMethodPIIDs$1.googlePay || paymentSessionOrData.piid === PaymentMethodPIIDs$1.applePay) {
                // If we are not flighted or paymentAgent check failed and we're passing in a Google Pay or Apple Pay PIID, then we need to throw
                // an error since we won't be able to open Gpay/Apay.
                var error = new pidlErrors.invalidSetupError(errorMessages.invalidSetup);
                _this.eventHub.failure(error);
                ret = _this.apiFailure(false);
            }
            else {
                ret = _this.renderPidlPageInternal(challengePidlInfo);
            }
            _this.eventHub.apiReturned(pidlDdcApiNames.handlePaymentChallenge, ret.result, ret.promise);
            return ret;
        };
        this.handlePurchasePendingState = function (params) {
            // Verify parameters
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.handlePurchasePendingState);
            _this.eventHub.apiCalled(pidlDdcApiNames.handlePurchasePendingState);
            if (!_this.canApiStart(pidlDdcApiNames.handlePurchasePendingState) ||
                !params ||
                !inputValidationHelper$1.validateHandlePurchasePendingStateParams(_this.eventHub, params)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.handlePurchasePendingState, false);
                return _this.apiFailure(false);
            }
            var challengePidlInfo = _this.getChallengePidlInfo(params);
            var ret = _this.renderPidlPageInternal(challengePidlInfo, params.options);
            _this.eventHub.apiReturned(pidlDdcApiNames.handlePurchasePendingState, true, ret.promise);
            return _this.apiSuccess(true, ret.promise);
        };
        this.handlePurchaseRiskChallenge = function (params) {
            // Verify parameters
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.handlePurchaseRiskChallenge);
            _this.eventHub.apiCalled(pidlDdcApiNames.handlePurchaseRiskChallenge);
            if (!_this.canApiStart(pidlDdcApiNames.handlePurchaseRiskChallenge) ||
                !params ||
                !inputValidationHelper$1.validatePurchaseRiskChallengeParams(_this.eventHub, params)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.handlePurchaseRiskChallenge, false);
                return _this.apiFailure(false);
            }
            // Make a call to challenge descriptions
            var challengePidlInfo = _this.getChallengePidlInfo(params);
            // Input validation must need to make sure that first element is there
            // TODO: Need to normalize parameters passing to PX rather than translating first risk data parameter as type in challenge description
            challengePidlInfo.parameters.type = params.riskChallengeData[0];
            // Render pidl
            var ret = _this.renderPidlPageInternal(challengePidlInfo, params.options);
            _this.eventHub.apiReturned(pidlDdcApiNames.handlePurchaseRiskChallenge, ret.result, ret.promise);
            return ret;
        };
        this.handleChallengeInternal = function (resourceInfo, options) {
            if (!inputValidationHelper$1.validateResourceInfo(_this.eventHub, resourceInfo) ||
                !inputValidationHelper$1.validateAddUpdateOrDeleteOptions(_this.eventHub, options)) {
                return _this.apiFailure(false);
            }
            var operationType = pidlOperationTypeValues.add;
            _this.model.operationType = operationType;
            _this.model.operationOptions = (options);
            _this.model.pidlDocManager.setOperationInfo({ operationType: operationType });
            var pidlService = iocContainer$1.getPidlService();
            var request = pidlService.getRequestInstance(_this.eventHub, resourceInfo, _this.userContext, operationType);
            var promise$1 = pidlService.getInstance(_this.eventHub, request);
            return _this.apiSuccess(true, promise$1.then(function (instance) {
                _this.stateManager.setState(controlStates.executing);
                _this.eventHub.instanceDownloaded();
                var pidlDocInfo = configManager$1.getPidlDocInfoFromResource(resourceInfo, instance);
                _this.telemetryContext.updateResourceInfo(pidlDocInfo);
                if (!instance.clientAction) {
                    _this.eventHub.success({ id: instance.id, operationType: operationType, response: instance });
                }
                else {
                    return _this.model.handleClientAction(instance.clientAction, instance);
                }
            }, function (fetchFailureMessage) {
                var error = utils.createServerError(errorMessages.resourceInstanceDownloadFailed, request.url, fetchFailureMessage, [fetchFailureMessage.errorMessage]);
                _this.eventHub.failure(error);
                return createFakeRejectedPromise(error);
            }));
        };
        this.handleChallenge = function (resourceInfo, options) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.verify, resourceInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.handleChallenge, {
                resourceInfo: typehelper.boolify(resourceInfo),
                options: typehelper.boolify(options)
            }, {
                resourceInfo: resourceInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.handleChallenge)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.handleChallenge, false);
                return _this.apiFailure(false);
            }
            var ret = _this.handleChallengeInternal(resourceInfo, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.handleChallenge, ret.result, ret.promise);
            return ret;
        };
        this.updateOrDeleteResourceInternal = function (resourceInfo, resource, pidlDocInfo, options, operationType) {
            if ((pidlDocInfo && !inputValidationHelper$1.validatePidlDocInfo(_this.eventHub, pidlDocInfo)) ||
                !inputValidationHelper$1.validateAddUpdateOrDeleteOptions(_this.eventHub, options)) {
                return _this.apiFailure(false);
            }
            var operationType = operationType || pidlOperationTypeValues.update;
            _this.model.operationType = operationType;
            _this.model.operationOptions = options;
            _this.model.modelData.setInputParametersInPartnerDataSource({ pidlDocInfo: pidlDocInfo });
            _this.model.pidlDocManager.setOperationInfo({ operationType: operationType });
            var promise = null;
            if (!resource) {
                if (!inputValidationHelper$1.validateResourceInfo(_this.eventHub, resourceInfo)) {
                    return _this.apiFailure(false);
                }
                promise = _this.downloadInstance(resourceInfo, pidlDocInfo, operationType, options);
            }
            else {
                promise = _this.downloadPidlDocument(urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo), options, function () { return _this.model.populate(resource, true); }, pidlDocInfo);
            }
            return _this.apiSuccess(true, promise.then(function () { return _this.stateManager.setState(controlStates.executing); }));
        };
        this.updateResource = function (resourceInfo, resource, pidlDocInfo, options) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.update, pidlDocInfo || resourceInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.updateResource, {
                resourceInfo: typehelper.boolify(resourceInfo),
                resource: typehelper.boolify(resource),
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                options: typehelper.boolify(options)
            }, {
                resourceInfo: resourceInfo,
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.updateResource)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.updateResource, false);
                return _this.apiFailure(false);
            }
            var ret = _this.updateOrDeleteResourceInternal(resourceInfo, resource, pidlDocInfo, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.updateResource, ret.result, ret.promise);
            return ret;
        };
        this.selectResource = function (pidlDocInfo, options, operationType, onPidlDownloadCompletion, targetIdentity, handle, selectedResourceInfo) {
            if ((!handle && !pidlDocInfo) ||
                (pidlDocInfo && (!(inputValidationHelper$1.validatePidlDocInfo(_this.eventHub, pidlDocInfo) || inputValidationHelper$1.validateResourceInfo(_this.eventHub, pidlDocInfo)) || !inputValidationHelper$1.validateSelectOrRenderOptions(_this.eventHub, options))) ||
                (handle && !inputValidationHelper$1.validateHandle(_this.eventHub, handle)) ||
                (selectedResourceInfo && !inputValidationHelper$1.validateSelectedResourceInfo(_this.eventHub, selectedResourceInfo))) {
                return _this.apiFailure(null);
            }
            if (selectedResourceInfo && (selectedResourceInfo.id || selectedResourceInfo.backupId)) {
                pidlDocInfo = pidlDocInfo || {};
                pidlDocInfo.parameters = pidlDocInfo.parameters || {};
                pidlDocInfo.parameters.filters = pidlDocInfo.parameters.filters || {};
                if (selectedResourceInfo.id) {
                    pidlDocInfo.parameters.filters.id = selectedResourceInfo.id;
                }
                if (selectedResourceInfo.backupId) {
                    pidlDocInfo.parameters.filters.backupId = selectedResourceInfo.backupId;
                }
            }
            var operationHandle = handle || utils.guid();
            _this.model.pidlDocManager.setOperationInfo({ handle: operationHandle, operationType: operationType });
            _this.model.operationType = operationType;
            _this.model.modelData.setInputParametersInPartnerDataSource({ pidlDocInfo: pidlDocInfo });
            var promise = null;
            // processing handle takes precedence over pidlDocInfo and options
            if (handle) {
                /**
                 * Promise rejection handled by user/tests
                 */
                promise = new Promise(function (resolve, reject) {
                    _this.model.pidlDocManager.retrievePidlDocFromCache(_this.eventHub, operationHandle, targetIdentity).then(function () {
                        onPidlDownloadCompletion().then(resolve, function (e) { reject(e); });
                    }, function (errorMessage) {
                        _this.eventHub.failure(new pidlErrors.unexpectedError(errorMessage, []));
                        reject();
                    });
                });
            }
            else {
                _this.model.operationOptions = options;
                configManager$1.updatePidlDocInfo(pidlDocInfo);
                promise = _this.downloadPidlDocument(urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo), options, onPidlDownloadCompletion, pidlDocInfo, targetIdentity);
            }
            return _this.apiSuccess(operationHandle, promise.then(function () { return _this.stateManager.setState(controlStates.executing); }));
        };
        this.selectResourceTypeInternal = function (pidlDocInfo, options) {
            return _this.selectResource(pidlDocInfo, options, pidlOperationTypeValues.select, _this.onDownloadValidateOrSelectResourceType.bind(_this));
        };
        this.selectResourceType = function (pidlDocInfo, options) {
            var _a, _b;
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.selectResourceType, pidlDocInfo);
            var localPidlDocInfo = pidlDocInfo;
            // check if googlepay and applepay supported, if not, will remove from pidlDocInfo allowedPMs
            var headers = _this.userContext.getHeaders({}, "");
            var msFlightHeaders = headers[httpHeaders.msFlight] || "";
            var paymentAgentInitializationPromise = createFakePromise();
            if ((msFlightHeaders === null || msFlightHeaders === void 0 ? void 0 : msFlightHeaders.includes(flightHeaders.enablePaymentAgentChallenge))
                && ((_a = window.paymentAgent) === null || _a === void 0 ? void 0 : _a.getInitPromise)) {
                paymentAgentInitializationPromise = (_b = window.paymentAgent.getInitPromise()) !== null && _b !== void 0 ? _b : paymentAgentInitializationPromise;
            }
            var promise$1 = paymentAgentInitializationPromise.then(function () {
                if (msFlightHeaders === null || msFlightHeaders === void 0 ? void 0 : msFlightHeaders.includes(flightHeaders.enablePaymentAgentChallenge)) {
                    localPidlDocInfo = utils.verifyClientSupported(pidlDocInfo);
                }
                _this.eventHub.apiCalled(pidlDdcApiNames.selectResourceType, {
                    pidlDocInfo: typehelper.boolify(localPidlDocInfo),
                    options: typehelper.boolify(options)
                }, {
                    pidlDocInfo: localPidlDocInfo
                });
                if (!_this.canApiStart(pidlDdcApiNames.selectResourceType)) {
                    _this.eventHub.apiReturned(pidlDdcApiNames.selectResourceType, false);
                    return _this.apiFailure(null);
                }
                var ret = _this.selectResourceTypeInternal(localPidlDocInfo, options);
                _this.eventHub.apiReturned(pidlDdcApiNames.selectResourceType, typehelper.boolify(ret.result), ret.promise);
                return ret;
            });
            return _this.apiSuccess(null, promise$1);
        };
        this.updateProfile = function (resourceInfo, resource, pidlDocInfo, options) {
            var pidlDocWithResource = __assign(__assign({}, pidlDocInfo), { resourceType: "Profile" });
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.updateProfile, pidlDocWithResource || resourceInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.updateProfile, {
                resourceInfo: typehelper.boolify(resourceInfo),
                resource: typehelper.boolify(resource),
                pidlDocInfo: typehelper.boolify(pidlDocWithResource),
                options: typehelper.boolify(options)
            }, {
                resourceInfo: resourceInfo,
                pidlDocInfo: pidlDocWithResource,
            });
            if (!_this.canApiStart(pidlDdcApiNames.updateProfile)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.updateProfile, false);
                return _this.apiFailure(false);
            }
            var ret = _this.updateOrDeleteResourceInternal(resourceInfo, resource, pidlDocWithResource, options);
            _this.eventHub.apiReturned(pidlDdcApiNames.updateProfile, ret.result, ret.promise);
            return ret;
        };
        this.selectInstanceInternal = function (pidlDocInfo, options, actionContext, selectedResourceInfo) {
            return _this.selectResource(pidlDocInfo, options, pidlOperationTypeValues.selectInstance, function () { return _this.onDownloadSelectResource(actionContext && actionContext.prefillData); }, actionContext && actionContext.targetIdentity, actionContext && actionContext.handle, selectedResourceInfo);
        };
        // Handle is an id returned earlier from selectResource or singleSingleResource APIs. Data/PIDLs associated
        // is kept in pidl document store using handle as a key.
        this.selectInstance = function (pidlDocInfo, options, actionContext, selectedResourceInfo) {
            var _a, _b;
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.selectResource, pidlDocInfo);
            var localPidlDocInfo = pidlDocInfo;
            // check if googlepay and applepay supported, if not, will remove from pidlDocInfo allowedPMs
            var headers = _this.userContext.getHeaders({}, "");
            var msFlightHeaders = headers[httpHeaders.msFlight] || "";
            var paymentAgentInitializationPromise = createFakePromise();
            if ((msFlightHeaders === null || msFlightHeaders === void 0 ? void 0 : msFlightHeaders.includes(flightHeaders.enablePaymentAgentChallenge))
                && ((_a = window.paymentAgent) === null || _a === void 0 ? void 0 : _a.getInitPromise)) {
                paymentAgentInitializationPromise = (_b = window.paymentAgent.getInitPromise()) !== null && _b !== void 0 ? _b : paymentAgentInitializationPromise;
            }
            var promise$1 = paymentAgentInitializationPromise.then(function () {
                if (msFlightHeaders === null || msFlightHeaders === void 0 ? void 0 : msFlightHeaders.includes(flightHeaders.enablePaymentAgentChallenge)) {
                    localPidlDocInfo = utils.verifyClientSupported(pidlDocInfo);
                }
                _this.eventHub.apiCalled(pidlDdcApiNames.selectResource, {
                    pidlDocInfo: typehelper.boolify(localPidlDocInfo),
                    options: typehelper.boolify(options),
                    actionContext: typehelper.boolify(actionContext)
                }, {
                    pidlDocInfo: localPidlDocInfo
                });
                if (!_this.canApiStart(pidlDdcApiNames.selectResource)) {
                    _this.eventHub.apiReturned(pidlDdcApiNames.selectResource, false);
                    return _this.apiFailure(null);
                }
                var ret = _this.selectInstanceInternal(localPidlDocInfo, options, actionContext, selectedResourceInfo);
                _this.eventHub.apiReturned(pidlDdcApiNames.selectResource, typehelper.boolify(ret.result), ret.promise);
                return ret;
            });
            return _this.apiSuccess(null, promise$1);
        };
        this.listAddress = function (pidlDocInfo, options, actionContext, selectedResourceInfo) {
            var pidlDocWithResource = __assign(__assign({}, pidlDocInfo), { resourceType: "Address" });
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.listAddress, pidlDocWithResource);
            _this.eventHub.apiCalled(pidlDdcApiNames.listAddress, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                options: typehelper.boolify(options),
                actionContext: typehelper.boolify(actionContext)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.listAddress)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.listAddress, false);
                return _this.apiFailure(null);
            }
            var ret = _this.selectInstanceInternal(pidlDocInfo, options, actionContext, selectedResourceInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.listAddress, typehelper.boolify(ret.result), ret.promise);
            return ret;
        };
        this.selectPaymentInstrument = function (pidlDocInfo, options, actionContext, selectedResourceInfo, includePidl) {
            var pidlDocWithResource;
            if (includePidl) {
                pidlDocWithResource = __assign(__assign({}, pidlDocInfo), { resourceType: pidlDocInfo.resourceType });
            }
            else {
                pidlDocWithResource = __assign(__assign({}, pidlDocInfo), { resourceType: "PaymentInstrument" });
            }
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.selectPaymentInstrument, pidlDocWithResource);
            _this.eventHub.apiCalled(pidlDdcApiNames.selectPaymentInstrument, {
                pidlDocInfo: typehelper.boolify(pidlDocWithResource),
                options: typehelper.boolify(options),
                actionContext: typehelper.boolify(actionContext)
            }, {
                pidlDocWithResource: pidlDocWithResource
            });
            if (!_this.canApiStart(pidlDdcApiNames.selectPaymentInstrument)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.selectPaymentInstrument, false);
                return _this.apiFailure(null);
            }
            var ret = _this.selectInstanceInternal(pidlDocWithResource, options, actionContext, selectedResourceInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.selectPaymentInstrument, typehelper.boolify(ret.result), ret.promise);
            return ret;
        };
        this.selectSingleInstanceInternal = function (pidlDocInfo, options, actionContext, selectedResourceInfo) {
            return _this.selectResource(pidlDocInfo, options, pidlOperationTypeValues.selectSingleInstance, function () { return _this.onDownloadSelectSingleResource(actionContext && actionContext.handle); }, actionContext && actionContext.targetIdentity, actionContext && actionContext.handle, selectedResourceInfo);
        };
        // Handle is an id returned earlier from selectResource or singleSingleResource APIs. Data/PIDLs associated
        // is kept in pidl document store using handle as a key.
        this.selectSingleInstance = function (pidlDocInfo, options, actionContext, selectedResourceInfo) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.selectSingleResource, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.selectSingleResource, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                options: typehelper.boolify(options),
                actionContext: typehelper.boolify(actionContext)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.selectSingleResource)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.selectSingleResource, false);
                return _this.apiFailure(null);
            }
            var ret = _this.selectSingleInstanceInternal(pidlDocInfo, options, actionContext, selectedResourceInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.selectSingleResource, typehelper.boolify(ret.result), ret.promise);
            return ret;
        };
        this.runApi = function (name, action, inputValidator, returnValue, returnPromise) {
            if (inputValidator === void 0) { inputValidator = function () { return false; }; }
            if (returnValue === void 0) { returnValue = function () { return true; }; }
            if (returnPromise === void 0) { returnPromise = function () { return undefined; }; }
            _this.eventHub.apiCalled(name);
            if (!_this.canApiStart(name) || inputValidator()) {
                _this.eventHub.apiReturned(name, false);
                return _this.apiFailure(false);
            }
            var promise = action();
            var retVal = returnValue();
            _this.eventHub.apiReturned(name, typehelper.boolify(retVal), promise);
            return _this.apiSuccess(retVal, returnPromise() || promise);
        };
        this.showResource = function (params) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.show);
            var pidlDocInfo = params.pidlDocInfo, prefillData = params.prefillData, options = params.options;
            var inputValidator = function () {
                return !params ||
                    !inputValidationHelper$1.validateShowResourceParams(_this.eventHub, params) ||
                    !inputValidationHelper$1.validatePidlDocInfo(_this.eventHub, pidlDocInfo) ||
                    !inputValidationHelper$1.validateResourceOptions(_this.eventHub, options);
            };
            var action = function () {
                var operationType = pidlOperationTypeValues.show;
                var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
                return _this.getPidl(url, prefillData, operationType, options, pidlDocInfo);
            };
            return _this.runApi(pidlDdcApiNames.showResource, action, inputValidator);
        };
        this.offerResource = function (params) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.offer);
            var pidlDocInfo = params.pidlDocInfo;
            var inputValidator = function () {
                return !params ||
                    !inputValidationHelper$1.validateOfferResourceParams(_this.eventHub, params) ||
                    !inputValidationHelper$1.validatePidlDocInfo(_this.eventHub, pidlDocInfo);
            };
            var action = function () {
                var operationType = pidlOperationTypeValues.offer;
                var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
                return _this.getPidl(url, null, operationType, null, pidlDocInfo);
            };
            return _this.runApi(pidlDdcApiNames.offerResource, action, inputValidator);
        };
        this.searchResource = function (params) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.search);
            var pidlDocInfo = params.pidlDocInfo, options = params.options;
            var inputValidator = function () {
                return !params || !inputValidationHelper$1.validateSearchResourceParams(_this.eventHub, params);
            };
            var action = function () {
                var operationType = pidlOperationTypeValues.search;
                var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
                return _this.getPidl(url, null, operationType, options, pidlDocInfo);
            };
            return _this.runApi(pidlDdcApiNames.searchResource, action, inputValidator);
        };
        this.deleteResource = function (params) {
            var resourceInfo = params.resourceInfo, resource = params.resource, pidlDocInfo = params.pidlDocInfo, options = params.options;
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.delete, resourceInfo || pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.deleteResource, {
                resourceInfo: typehelper.boolify(resourceInfo),
                resource: typehelper.boolify(resource),
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                options: typehelper.boolify(options)
            }, {
                resourceInfo: resourceInfo,
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.deleteResource) || !params) {
                _this.eventHub.apiReturned(pidlDdcApiNames.deleteResource, false);
                return _this.apiFailure(false);
            }
            var ret = _this.updateOrDeleteResourceInternal(resourceInfo, resource, pidlDocInfo, options, pidlOperationTypeValues.delete);
            _this.eventHub.apiReturned(pidlDdcApiNames.deleteResource, ret.result, ret.promise);
            return ret;
        };
        this.fundStoredValue = function (params) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.fundStoredValue);
            var pidlDocInfo = params.pidlDocInfo, options = params.options;
            var inputValidator = function () {
                return !params || !inputValidationHelper$1.validateFundStoredValueParams(_this.eventHub, params);
            };
            var action = function () {
                var operationType = pidlOperationTypeValues.fundStoredValue;
                var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
                return _this.getPidl(url, null, operationType, options, pidlDocInfo);
            };
            return _this.runApi(pidlDdcApiNames.fundStoredValue, action, inputValidator);
        };
        this.validateResource = function (pidlDocInfo, options, actionContext, selectedResourceInfo) {
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.validateResource, pidlDocInfo);
            _this.eventHub.apiCalled(pidlDdcApiNames.validateResource, {
                pidlDocInfo: typehelper.boolify(pidlDocInfo),
                options: typehelper.boolify(options),
                actionContext: typehelper.boolify(actionContext)
            }, {
                pidlDocInfo: pidlDocInfo
            });
            if (!_this.canApiStart(pidlDdcApiNames.validateResource)) {
                _this.eventHub.apiReturned(pidlDdcApiNames.validateResource, false);
                return _this.apiFailure(null);
            }
            var ret = _this.selectResource(pidlDocInfo, options, pidlOperationTypeValues.validateInstance, _this.onDownloadValidateOrSelectResourceType.bind(_this), actionContext && actionContext.targetIdentity, actionContext && actionContext.handle, selectedResourceInfo);
            _this.eventHub.apiReturned(pidlDdcApiNames.validateResource, typehelper.boolify(ret.result), ret.promise);
            return ret;
        };
        this.moveNextPage = function () {
            return _this.runApi(pidlDdcApiNames.moveNextPage, function () { return _this.model.moveNextOrSubmit().catch(_this.displaySettings.propagateCallbackException ? throwException : doNothing); });
        };
        this.submitPage = function () {
            return _this.runApi(pidlDdcApiNames.submitPage, function () { return _this.model.submitAction().catch(_this.displaySettings.propagateCallbackException ? throwException : doNothing); });
        };
        this.moveToLastPage = function () {
            return _this.runApi(pidlDdcApiNames.moveToLastPage, function () { return _this.model.moveToLastPage().catch(doNothing); });
        };
        this.movePrevPage = function () {
            return _this.runApi(pidlDdcApiNames.movePrevPage, function () { return _this.model.movePrevOrCancel().catch(doNothing); });
        };
        this.moveToFirstPage = function () {
            return _this.runApi(pidlDdcApiNames.moveToFirstPage, function () { return _this.model.moveToFirstPage().catch(doNothing); });
        };
        this.refreshData = function (prefillData) {
            return _this.runApi(pidlDdcApiNames.refreshData, function () { return _this.model.refreshData(prefillData).catch(doNothing); });
        };
        this.cancel = function () {
            return _this.runApi(pidlDdcApiNames.cancel, function () {
                _this.model.gohome();
                return createFakePromise();
            });
        };
        this.getSelectedResource = function () {
            var returnValue = function () {
                var successPayload = {};
                var currentPage = _this.model.getCurrentPage();
                if (currentPage) {
                    var operationType = currentPage.operationType;
                    if (operationType === pidlOperationTypeValues.selectSingleInstance) {
                        successPayload = modelElementsHelper$1.getDefaultSuccessPidlPayload([currentPage], _this.eventHub);
                    }
                    else if (operationType === pidlOperationTypeValues.selectInstance || operationType === pidlOperationTypeValues.select) {
                        successPayload = typehelper.deepCopy(_this.model.createUserInputData(true, true));
                    }
                }
                successPayload.operationType = _this.model.operationType;
                if (!successPayload) {
                    successPayload = undefined;
                }
                return successPayload;
            };
            return _this.runApi(pidlDdcApiNames.getSelectedResource, function () { return createFakePromise(); }, function () { return false; }, returnValue);
        };
        this.invokePageDefaultAction = function () {
            return _this.runApi(pidlDdcApiNames.invokePageDefaultAction, function () { return _this.model.invokeDefaultPidlAction().catch(doNothing); }, function () { return false; }, function () { return true; }, function () { return createFakePromise(); });
        };
        this.returnUserInputData = function () {
            /**
             * pidl-react API. Promise rejection handled by react component users
             */
            return new Promise(function (resolve, reject) {
                _this.model.returnUserInputData().then(function (userInputData) {
                    var successPayload = {};
                    successPayload.payload = typehelper.deepCopy(userInputData);
                    successPayload.operationType = pidlOperationTypeValues.getPidlPayload;
                    resolve(successPayload);
                }, function (errorObject) {
                    _this.eventHub.error(errorObject);
                    reject();
                });
            });
        };
        this.getPidlPayload = function () {
            return _this.runApi(pidlDdcApiNames.getPidlPayload, function () { return _this.returnUserInputData().then(function (successPayload) { return _this.eventHub.payloadCreated(successPayload); }, doNothing); }, function () { return _this.model.operationType !== pidlOperationTypeValues.renderPidlPage; }, function () { return true; }, function () { return createFakePromise(); });
        };
        this.postMessageToChildIFrames = function (params) {
            // TODO: Check whether always returning true is actually needed or not
            return _this.runApi(pidlDdcApiNames.postMessageToChildIFrames, function () { return undefined; }, function () { return false; }, function () { return _this.viewEventHandler.postMessageToChildIFrames(params); }, function () { return createFakePromise(); });
        };
        this.testHookRenderPidl = function (pidlDocument, operation, prefillData) {
            _this.model.pidlDocManager.setPidlDoc(_this.eventHub, pidlDocument);
            _this.model.operationType = operation;
            return _this.model.populate(prefillData).catch(doNothing);
        };
        this.testHookRenderPidlPage = function (pidlDocument, operation, pageIndex, prefillData) {
            if (pageIndex === void 0) { pageIndex = 0; }
            _this.telemetryContext.trackNewOperation(telemetryPidlOperationType.renderPidlDocument);
            _this.eventHub.apiCalled(pidlDdcApiNames.renderPidlDocument);
            var promise$1 = _this.testHookRenderPidl(pidlDocument, operation, prefillData).then(function () {
                _this.model.moveToPageIndex(pageIndex).catch(doNothing);
                _this.stateManager.setState(controlStates.executing);
            });
            _this.eventHub.apiReturned(pidlDdcApiNames.renderPidlDocument, true, promise$1);
            return true;
        };
        var _a = callbacks || {}, telemetryLogger = _a.telemetryLogger, getPidlDocument = _a.getPidlDocument, sdkView = _a.view, fetchHandler = _a.fetchHandler;
        var sdkViewType = sdkView && typehelper.isFunction(sdkView.getViewType) && sdkView.getViewType();
        this.telemetryContext = new telemetryContext(telemetryOptions, sdkViewType);
        this.eventHub = new EventHub(telemetryLogger, this.telemetryContext);
        this.stateManager = new stateManager(this.eventHub);
        if (!iocContainer$1.getLoggingService()) {
            iocContainer$1.setLoggingService(new loggingService());
        }
        if (!iocContainer$1.getOneDSService()) {
            if (oneDSService) {
                iocContainer$1.setOneDSService(oneDSService);
            }
            else {
                var mockOneDSService = {
                    getApplicationInsights: function () {
                        return {
                            initialize: function () { },
                            trackEvent: function () { }
                        };
                    },
                    getCorrelationVectorPlugin: function () {
                        return {
                            getCv: function () {
                                return {
                                    count: 0,
                                    increment: function () { this.count = this.count + 1; return this.getValue(); },
                                    getValue: function () { return "cv__" + this.count; },
                                    isInit: function () { return true; }
                                };
                            }
                        };
                    }
                };
                iocContainer$1.setOneDSService(mockOneDSService);
            }
        }
        // This call is done before any event listener is registered. It is needed as we like
        // to make sure to capture this in our telemetry before any errors.
        this.logConstructorCall(userContext, returnOptions, eventHandler, displayOptions, telemetryOptions);
        if (!inputValidationHelper$1.validateReturnOptions(this.eventHub, returnOptions)) {
            this.eventHub.apiReturned(pidlDdcApiNames.constructor, false);
            return;
        }
        this.eventHub.addReturnOptions(returnOptions);
        if (!iocContainer$1.getCommerceService()) {
            iocContainer$1.setCommerceService(new commerceService());
        }
        if (!iocContainer$1.getRedirectionService()) {
            iocContainer$1.setRedirectionService(new redirectionService());
        }
        if (!iocContainer$1.getPidlService()) {
            iocContainer$1.setPidlService(new pidlService());
        }
        if (!iocContainer$1.getPidlStoreService()) {
            iocContainer$1.setPidlStoreService(new pidlStoreService());
        }
        if (eventHandler) {
            this.eventHub.addPublicEventHandler(eventHandler);
        }
        this.eventHub.addPrivateEventHandler(this.handlePrivateEvent);
        if (externalPrivateEventHandler) {
            this.eventHub.addPrivateEventHandler(externalPrivateEventHandler);
        }
        if (!inputValidationHelper$1.validateInputParameters(this.eventHub, userContext, displayOptions, telemetryOptions, callbacks)) {
            this.eventHub.apiReturned(pidlDdcApiNames.constructor, false);
            return;
        }
        this.callbacks = callbacks;
        this.transformers = transformers;
        this.localDataSourceProviders = localDataSourceProviders;
        this.userContext = new userContextWrapper(userContext);
        this.displaySettings = new DisplaySettings(displayOptions);
        if (!this.displaySettings.containerId) {
            this.eventHub.failure(new pidlErrors.inputParameterValidationFailedError(errorMessages.containerIdNotFound, "containerId", [this.displaySettings.containerId]));
            this.eventHub.apiReturned(pidlDdcApiNames.constructor, false);
            return;
        }
        this.model = new Model({
            urls: returnOptions.urls,
            userContext: this.userContext,
            displaySettings: this.displaySettings,
            eventHub: this.eventHub,
            pidlDocManager: new pidlDocumentManager(getPidlDocument, pidlPayload),
            stateManager: this.stateManager,
            callbacks: this.callbacks,
            transformers: this.transformers,
            localDataSourceProviders: this.localDataSourceProviders
        });
        utils.registerToOrchestrator({ model: this.model, addPublicEventHandler: this.eventHub.addPublicEventHandler });
        var _b = this.callbacks, iFrameMessageHandler = _b.iFrameMessageHandler, view = _b.view;
        this.viewEventHandler = new ViewEventHandler({
            eventHub: this.eventHub,
            model: this.model,
            displaySettings: this.displaySettings,
            view: view,
            iFrameMessageHandler: iFrameMessageHandler,
            userContext: this.userContext
        });
        if (fetchHandler) {
            fetchHelper.setFetchHandler(fetchHandler);
        }
        this.stateManager.setState(controlStates.initialized);
    }
    controlApi.prototype.sumbitAction = function () {
        throw new Error("Method not implemented.");
    };
    controlApi.prototype.apiSuccess = function (value, promise$1) {
        return { result: value, promise: promise$1.catch(this.displaySettings.propagateCallbackException ? throwException : doNothing) || createFakePromise() };
    };
    controlApi.prototype.apiFailure = function (value) {
        return { result: value, promise: createFakePromise() };
    };
    controlApi.prototype.onDownloadSelectResource = function (prefillData) {
        return this.model.populate(prefillData);
    };
    controlApi.prototype.onDownloadValidateOrSelectResourceType = function () {
        return this.model.populate();
    };
    controlApi.prototype.onDownloadSelectSingleResource = function (handle) {
        if (!this.model.pidlDocManager.isEmpty()) {
            return this.model.populate();
        }
        else {
            var response = { handle: handle, action: "selectResource" };
            // TODO: Fix this type for eventHub success. This code path might not be getting used in any live scenario
            // and this needs to be just removed.
            this.eventHub.success(response);
            return createFakePromise();
        }
    };
    controlApi.prototype.getPidl = function (url, prefillData, operationType, options, pidlDocInfo) {
        var _this = this;
        this.model.operationType = operationType;
        this.model.operationOptions = options;
        this.model.modelData.setInputParametersInPartnerDataSource({ pidlDocInfo: pidlDocInfo });
        this.model.pidlDocManager.setOperationInfo({ operationType: operationType });
        var promise$1 = this.downloadPidlDocument(url, options, function () { return _this.model.populate(prefillData, false); }, pidlDocInfo, undefined, !!prefillData);
        return promise$1.then(function () { return _this.stateManager.setState(controlStates.executing); }, doNothing);
    };
    controlApi.prototype.downloadInstance = function (resourceInfo, pidlDocInfo, operationType, options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var pidlService = iocContainer$1.getPidlService();
            var request = pidlService.getRequestInstance(_this.eventHub, resourceInfo, _this.userContext, operationType);
            pidlService.getInstance(_this.eventHub, request).then(function (instance) {
                _this.eventHub.instanceDownloaded();
                if (!pidlDocInfo) {
                    pidlDocInfo = configManager$1.getPidlDocInfoFromResource(resourceInfo, instance);
                    _this.telemetryContext.updateResourceInfo(pidlDocInfo);
                }
                var url = urlBuilder$1.getPidlDocUrl(_this.userContext, operationType, pidlDocInfo);
                if (url && url.url) {
                    return _this.downloadPidlDocument(url, options, function () { return _this.model.populate(instance, true); }, pidlDocInfo).then(function (value) { return resolve(value); }, reject);
                }
                else {
                    reject();
                }
            }, function (fetchFailureMessage) {
                var serverError = utils.createServerError(errorMessages.resourceInstanceDownloadFailed, request.url, fetchFailureMessage, [fetchFailureMessage.errorMessage]);
                _this.eventHub.failure(serverError);
                reject(serverError);
            });
        });
    };
    controlApi.prototype.downloadPidlDocument = function (url, options, onPidlDownloadCompletion, pidlDocInfo, pidlIdentityToResolve, hasPrefillData) {
        var _this = this;
        return this.model.downloadPidlDocument(url, pidlDocInfo, pidlIdentityToResolve, hasPrefillData).then(function (clientAction) {
            if (isClientAction(clientAction)) {
                return _this.model.handleClientAction(clientAction);
            }
            else {
                return onPidlDownloadCompletion();
            }
        });
    };
    return controlApi;
}());

"use strict";
var mockFactory = /** @class */ (function () {
    function mockFactory(eventHubIn, mockFunctions) {
        this.defaultWaitTime = 500;
        this.eventHub = eventHubIn;
        this.mockFunctions = mockFunctions || [];
        this.mockFunctionsMap = {};
        this.mockFunctions.forEach(function (mockFunction) {
            this.mockFunctionsMap[mockFunction.name] = mockFunction;
        }, this);
    }
    mockFactory.prototype.getMockedFunctionNames = function () {
        var mockedFunctionNames = [];
        this.mockFunctions.forEach(function (mockFunction) {
            mockedFunctionNames = mockedFunctionNames.concat(mockFunction.name);
        });
        return mockedFunctionNames;
    };
    mockFactory.prototype.createMockedFunction = function (methodName, methodLength) {
        return mockFactory.setArity(function () {
            var mockFunction = this.mockFunctionsMap[methodName];
            mockFunction.triggers.forEach(function (mockEvent) {
                setTimeout(this.eventHub[mockEvent.name].bind(this.eventHub), this.defaultWaitTime, mockEvent.params);
            }, this);
            return mockFunction.returns;
        }.bind(this), methodLength);
    };
    mockFactory.createArguments = function (count) {
        if (count < 1) {
            return "arg";
        }
        var result = "arg0";
        for (var i = 1; i < count; i++) {
            result = result + ",arg" + i;
        }
        return result;
    };
    mockFactory.setArity = function (f, n) {
        return new Function(mockFactory.createArguments(n), // arguments list
        "return this.apply(this, arguments);" // actual call
        ).bind(f);
    };
    return mockFactory;
}());

var oneDSLogger = /** @class */ (function () {
    function oneDSLogger() {
        if (!iocContainer$1.getTelemetryInjectionService()) {
            iocContainer$1.setTelemetryInjectionService(new telemetryInjectionService());
        }
    }
    oneDSLogger.prototype.logEvent = function (eventName, parameters, telemetryContext) {
        iocContainer$1.getTelemetryInjectionService().logEvent(telemetryContext, eventName, parameters);
    };
    oneDSLogger.prototype.getCorrelationId = function () {
        return oneDSAdapter$1.getCVValue();
    };
    oneDSLogger.prototype.getHttpRequestCorrelationHeader = function () {
        var cv = oneDSAdapter$1.getIncrementedCV();
        if (cv) {
            return { name: httpHeaders.msCV, value: cv };
        }
    };
    return oneDSLogger;
}());

"use strict";
var telemetryInjectionService = /** @class */ (function () {
    function telemetryInjectionService() {
    }
    telemetryInjectionService.prototype.logEvent = function (telemetryContext, eventName, parameters) {
        oneDSAdapter$1.setUserConsentDetailsCallback(telemetryContext === null || telemetryContext === void 0 ? void 0 : telemetryContext.userConsentDetailsCallback);
        if (eventName === eventNames.fetchCallCompleted) {
            this.logOSREvent(telemetryContext, parameters && parameters.httpRequestTelemetryData);
        }
        else {
            this.logGenericEvent(telemetryContext, eventName, parameters);
        }
    };
    telemetryInjectionService.prototype.logGenericEvent = function (telemetryContext, eventName, parameters) {
        var _a, _b, _c, _d, _e;
        try {
            if (typehelper.isObject(telemetryContext)) {
                var pageUri = ((window || {}).location || {}).href || "";
                var oneDSEvent = {
                    name: "Microsoft.Commerce.Payments.PidlSdk.PageEvent",
                    partB: {
                        pageName: (document || {}).title || "",
                        uri: pageUri,
                        destUri: pageUri,
                        customSessionGuid: telemetryContext.sessionId,
                        impressionGuid: telemetryContext.operationId,
                        contentJsonVer: 1.0,
                        content: JSON.stringify({ eventName: eventName })
                    },
                    partC: {
                        // Next step: Remove the following lines after
                        // 1. confirm partnerContextMap, eventParametersMap and resourceParametersMap are correctly populated
                        // 2. update kusto pipeline, if there is any handling on eventParameters, resourceParameters
                        // 3. remove dependances in payment funnel
                        // The properties will be retired
                        // partnerContext: JSON.stringify(telemetryContext.partnerContext),
                        // partnerFlowId: telemetryContext.partnerContext?.flowId,
                        // partnerSessionId: telemetryContext.partnerContext?.sessionId,
                        // partnerScenarioId: telemetryContext.partnerContext?.scenarioId,
                        // partnerName: telemetryContext.partnerContext?.partnerName,
                        // oneDSEvent.partC.resourceParameters = JSON.stringify(telemetryContext.telemetryResource.parameters);
                        sdkVersion: telemetryContext.sdkVersion,
                        sdkViewType: telemetryContext.sdkViewType,
                        env: telemetryContext.env,
                        partnerName: (_a = telemetryContext.partnerContext) === null || _a === void 0 ? void 0 : _a.partnerName,
                        partnerContext: JSON.stringify(telemetryContext.partnerContext),
                        partnerContextMap: telemetryContext.partnerContext,
                        parentOperationId: ((_b = telemetryContext.partnerContext) === null || _b === void 0 ? void 0 : _b.parentOperationId) || telemetryContext.operationId,
                        partnerFlowId: (_c = telemetryContext.partnerContext) === null || _c === void 0 ? void 0 : _c.flowId,
                        partnerSessionId: (_d = telemetryContext.partnerContext) === null || _d === void 0 ? void 0 : _d.sessionId,
                        partnerScenarioId: (_e = telemetryContext.partnerContext) === null || _e === void 0 ? void 0 : _e.scenarioId,
                        operationId: telemetryContext.operationId,
                        operationType: telemetryContext.operationType,
                        eventName: eventName,
                        eventParameters: JSON.stringify(parameters),
                        eventParametersMap: parameters,
                        baseType: "Ms.Content.PageAction"
                    }
                };
                if (typehelper.isObject(telemetryContext.telemetryResource)) {
                    oneDSEvent.partC.resourceType = telemetryContext.telemetryResource.resourceType;
                    oneDSEvent.partC.resourceParameters = JSON.stringify(telemetryContext.telemetryResource.parameters);
                    oneDSEvent.partC.resourceParametersMap = telemetryContext.telemetryResource.parameters;
                }
                oneDSAdapter$1.writeEvent(oneDSEvent.name, oneDSEvent.partB, oneDSEvent.partC);
            }
        }
        catch (err) {
            iocContainer$1.getLoggingService().logError("TelemetryError", err);
        }
    };
    telemetryInjectionService.prototype.logOSREvent = function (telemetryContext, httpRequestTelemetryData) {
        var _a, _b, _c, _d, _e;
        try {
            if (typehelper.isObject(telemetryContext)) {
                var customData = {
                    partner: ((telemetryContext.telemetryResource || {}).parameters || {}).partner,
                    telemetryContext: telemetryContext,
                    responseHeaders: httpRequestTelemetryData.headers
                };
                var oneDSEvent = {
                    name: "Ms.Webi.OutgoingRequest",
                    partB: {
                        operationName: httpRequestTelemetryData.operationName,
                        targetUri: httpRequestTelemetryData.targetUri,
                        latencyMs: httpRequestTelemetryData.latencyMs,
                        serviceErrorCode: (!httpRequestTelemetryData.succeeded && httpRequestTelemetryData.serviceErrorCode && !isNaN(httpRequestTelemetryData.serviceErrorCode)) ? httpRequestTelemetryData.serviceErrorCode : -1,
                        succeeded: httpRequestTelemetryData.succeeded,
                        requestMethod: httpRequestTelemetryData.requestMethod,
                        responseContentType: httpRequestTelemetryData.responseContentType,
                        protocolStatusCode: httpRequestTelemetryData.protocolStatusCode,
                        dependencyOperationName: httpRequestTelemetryData.dependencyOperationName,
                        dependencyOperationVersion: httpRequestTelemetryData.dependencyOperationVersion && httpRequestTelemetryData.dependencyOperationVersion.toString(),
                        dependencyName: httpRequestTelemetryData.serviceName,
                        dependencyType: "webservice",
                        responseSizeBytes: httpRequestTelemetryData.contentLength
                    },
                    partC: {
                        customSessionGuid: telemetryContext.sessionId,
                        impressionGuid: telemetryContext.operationId,
                        message: httpRequestTelemetryData.failureResponse,
                        retryCount: httpRequestTelemetryData.retryCount,
                        customData: JSON.stringify(customData),
                        sdkVersion: telemetryContext.sdkVersion,
                        sdkViewType: telemetryContext.sdkViewType,
                        env: telemetryContext.env,
                        partnerName: (_a = telemetryContext.partnerContext) === null || _a === void 0 ? void 0 : _a.partnerName,
                        partnerContext: JSON.stringify(telemetryContext.partnerContext),
                        operationId: telemetryContext.operationId,
                        parentOperationId: ((_b = telemetryContext.partnerContext) === null || _b === void 0 ? void 0 : _b.parentOperationId) || telemetryContext.operationId,
                        partnerFlowId: (_c = telemetryContext.partnerContext) === null || _c === void 0 ? void 0 : _c.flowId,
                        partnerSessionId: (_d = telemetryContext.partnerContext) === null || _d === void 0 ? void 0 : _d.sessionId,
                        partnerScenarioId: (_e = telemetryContext.partnerContext) === null || _e === void 0 ? void 0 : _e.scenarioId,
                        partnerContextMap: telemetryContext.partnerContext,
                        operationType: telemetryContext.operationType,
                        baseType: "Ms.Qos.OutgoingServiceRequest"
                    }
                };
                oneDSAdapter$1.writeEvent(oneDSEvent.name, oneDSEvent.partB, oneDSEvent.partC);
            }
        }
        catch (err) {
            iocContainer$1.getLoggingService().logError("TelemetryError", err);
        }
    };
    return telemetryInjectionService;
}());

var LoggerWrapper = /** @class */ (function () {
    function LoggerWrapper(oneDSLogger, callbackLogger) {
        var multipleLoggersEnabled = configManager$1.getTelemetryLoggerProperties().enableMultipleLoggers;
        if (multipleLoggersEnabled && callbackLogger) {
            this.loggers = [oneDSLogger, callbackLogger];
        }
        else if (callbackLogger) {
            this.loggers = [callbackLogger];
        }
        else {
            this.loggers = [oneDSLogger];
        }
    }
    LoggerWrapper.prototype.logEvent = function (eventName, parameters, telemetryContext) {
        for (var _i = 0, _a = this.loggers; _i < _a.length; _i++) {
            var logger = _a[_i];
            logger.logEvent(eventName, parameters, telemetryContext);
        }
    };
    LoggerWrapper.prototype.getCorrelationId = function () {
        var _a;
        // Making an assumption here. Current implementation has pidlsdk's 1ds logger as the first logger in the list.
        var correlationId;
        for (var _i = 0, _b = this.loggers; _i < _b.length; _i++) {
            var logger = _b[_i];
            var loggerId = (_a = logger.getCorrelationId) === null || _a === void 0 ? void 0 : _a.call(logger);
            if (loggerId) {
                correlationId = loggerId;
            }
        }
        return correlationId;
    };
    LoggerWrapper.prototype.getHttpRequestCorrelationHeader = function () {
        var _a;
        // Making an assumption here. Current implementation has pidlsdk's 1ds logger as the first logger in the list.
        var correlationHeader;
        for (var _i = 0, _b = this.loggers; _i < _b.length; _i++) {
            var logger = _b[_i];
            var loggerHeader = (_a = logger.getHttpRequestCorrelationHeader) === null || _a === void 0 ? void 0 : _a.call(logger);
            if (loggerHeader) {
                correlationHeader = loggerHeader;
            }
        }
        return correlationHeader;
    };
    LoggerWrapper.prototype.getLoggers = function () {
        return this.loggers;
    };
    return LoggerWrapper;
}());

"use strict";
var htmlAttributesHelper = /** @class */ (function () {
    function htmlAttributesHelper() {
        var _this = this;
        this.getContainerClassName = function (containerType) {
            if (!containerType) {
                return;
            }
            switch (containerType) {
                case containerTypes.busyBlock:
                    return htmlClassNames.busyBlock;
                case containerTypes.errorBlock:
                    return htmlClassNames.errorBlock;
                case containerTypes.helpDialogBlock:
                    return htmlClassNames.helpDialogBlock;
                case containerTypes.helpDialogContentBlock:
                    return htmlClassNames.helpDialogContentBlock;
                case containerTypes.modalDialogBlock:
                    return htmlClassNames.modalDialogBlock;
                case containerTypes.modalDialogContentBlock:
                    return htmlClassNames.modalDialogContentBlock;
                case containerTypes.pageContentBlock:
                    return htmlClassNames.pageContentBlock;
                case containerTypes.submitBlock:
                    return htmlClassNames.submitBlock;
            }
        };
        this.getDivClassName = function (eventHub, divType, containerType) {
            switch (divType) {
                case modelElementType.dropdown:
                    return [htmlClassNames.dropdownDiv, htmlClassNames.propertyDiv];
                case modelElementType.checkBox:
                    return [htmlClassNames.checkBoxDiv, htmlClassNames.propertyDiv];
                case modelElementType.textBox:
                    return [htmlClassNames.textBoxDiv, htmlClassNames.propertyDiv];
                case modelElementType.secureProperty:
                    return [htmlClassNames.propertyDiv];
                case modelElementType.image:
                    return [htmlClassNames.imageDiv];
                case modelElementType.logo:
                    return [htmlClassNames.logoDiv];
                case modelElementType.button:
                    return [htmlClassNames.buttonDiv];
                case modelElementType.iFrame:
                    return [htmlClassNames.iFrameDiv];
                case modelElementType.group:
                    var classes = [htmlClassNames.groupDiv];
                    var containerClass = _this.getContainerClassName(containerType);
                    if (containerClass) {
                        classes.push(containerClass);
                    }
                    return classes;
            }
        };
        this.generateClassName = function (eventHub, elementType, propertyName, type, containerType) {
            var classNames = _this.getClassName(eventHub, elementType, propertyName);
            if (type) {
                var divClass = _this.getDivClassName(eventHub, type, containerType);
                if (divClass) {
                    classNames = classNames.concat(divClass);
                }
            }
            if (!classNames) {
                return;
            }
            return classNames.join(" ");
        };
        this.getClassName = function (eventHub, elementType, propertyName) {
            switch (elementType) {
                case htmlElementTypes.div:
                    return [htmlClassNames.div];
                case htmlElementTypes.label:
                    return [htmlClassNames.label];
                case htmlElementTypes.dropdown:
                    return [htmlClassNames.property, htmlClassNames.dropdown, _this.getPropertyClassName(propertyName)];
                case htmlElementTypes.radio:
                    return [htmlClassNames.property, htmlClassNames.radio, _this.getPropertyClassName(propertyName)];
                case htmlElementTypes.buttonList:
                    return [htmlClassNames.property, htmlClassNames.buttonList, _this.getPropertyClassName(propertyName)];
                case htmlElementTypes.checkBox:
                    return [htmlClassNames.property, htmlClassNames.checkBox, _this.getPropertyClassName(propertyName)];
                case htmlElementTypes.textBox:
                    return [htmlClassNames.property, htmlClassNames.textBox, _this.getPropertyClassName(propertyName)];
                case htmlElementTypes.secureProperty:
                    return [htmlClassNames.secureProperty];
                case htmlElementTypes.button:
                    return [htmlClassNames.button];
                case htmlElementTypes.iFrame:
                    return [htmlClassNames.iFrame];
                case htmlElementTypes.heading:
                    return [htmlClassNames.staticText, htmlClassNames.heading];
                case htmlElementTypes.subHeading:
                    return [htmlClassNames.staticText, htmlClassNames.subHeading];
                case htmlElementTypes.text:
                    return [htmlClassNames.staticText, htmlClassNames.text];
                case htmlElementTypes.textGroup:
                    return [htmlClassNames.staticText, htmlClassNames.text, htmlClassNames.textGroup];
                case htmlElementTypes.hyperlink:
                    return [htmlClassNames.hyperlink];
                case htmlElementTypes.image:
                    return [htmlClassNames.image];
                case htmlElementTypes.logo:
                    return [htmlClassNames.logo];
                case htmlElementTypes.errorDiv:
                    return [htmlClassNames.errorDiv];
                case htmlElementTypes.error:
                    return [htmlClassNames.error];
                case htmlElementTypes.audio:
                    return [htmlClassNames.audio];
                default:
                    eventHub.failure(new pidlErrors.unexpectedError(errorMessages.noMappingToGetHtmlClassNameForElement, [elementType]));
                    return;
            }
        };
        this.getDivId = function (id) {
            return _this.getId(htmlElementIdPrefixes.div, id);
        };
        this.getId = function (prefix, id) {
            return typehelper.replaceCharactersForHtml(typehelper.startsWith(id, prefix) ? id : prefix + id);
        };
        this.getPropertyClassName = function (propertyName) {
            return _this.getId(htmlElementIdPrefixes.property, propertyName);
        };
        this.concatIdElement = function (id, element) {
            return typehelper.replaceCharactersForHtml(id + "_" + element);
        };
    }
    htmlAttributesHelper.prototype.concatClassName = function (classNames, className) {
        return (classNames && className && classNames.trim() + " " + className) || classNames || className;
    };
    return htmlAttributesHelper;
}());
var htmlAttributesHelper$1 = new htmlAttributesHelper();



var eventArgs = /*#__PURE__*/Object.freeze({
	__proto__: null
});



var internal_core = /*#__PURE__*/Object.freeze({
	__proto__: null,
	constants: constants,
	modelElementTypes: modelelements,
	promise: promise,
	eventArgs: eventArgs,
	msrCrypto: msrCrypto$2,
	tokenEncrypt: encrypt,
	oneDSAdapter: oneDSAdapter$1,
	commerce2: commerce2,
	commerceHelper: commerceHelper$1,
	config: config$1,
	configManager: configManager$1,
	error: pidlErrors,
	fetchHelper: fetchHelper,
	inputValidationHelper: inputValidationHelper$1,
	iocContainer: iocContainer$1,
	modelElementFactory: modelElementFactory$1,
	modelElementsHelper: modelElementsHelper$1,
	pidlDocHelper: pidlDocHelper$1,
	tokenizer: Tokenizer$1,
	typeHelper: typehelper,
	urlBuilder: urlBuilder$1,
	userInputDataHelper: userInputDataHelper$1,
	userInputDataTransformer: UserInputDataTransformer$1,
	userInputDataValidator: UserInputDataValidator$1,
	utils: utils,
	validationFunctions: validationFunctions$1,
	version: version$1,
	webCrypto: webCrypto$1,
	htmlAttributeHelper: htmlAttributesHelper$1,
	hmac: hmac$1,
	DisplaySettings: DisplaySettings,
	errorMessages: errorMessages,
	EventHub: EventHub,
	FetchConfig: FetchConfig,
	mockFactory: mockFactory,
	Resources: Resources,
	stateManager: stateManager,
	telemetryContext: telemetryContext,
	userContextWrapper: userContextWrapper,
	ViewEventHandler: ViewEventHandler,
	DataCache: DataCache,
	DataStore: DataStore,
	InputPrefillDataManager: InputPrefillDataManager,
	Model: Model,
	ModelData: ModelData,
	ModelDataProperty: ModelDataProperty,
	MultiPropertySelector: MultiPropertySelector,
	pidlDocumentManager: pidlDocumentManager,
	Validator: Validator,
	commerceService: commerceService,
	loggingService: loggingService,
	pidlService: pidlService,
	pidlStoreService: pidlStoreService,
	redirectionService: redirectionService,
	oneDSLogger: oneDSLogger,
	telemetryInjectionService: telemetryInjectionService,
	LoggerWrapper: LoggerWrapper
});

"use strict";



var pidl = /*#__PURE__*/Object.freeze({
	__proto__: null,
	env: pidlEnv,
	internal: internal_core,
	pidlDocumentTypes: pidlDocumentTypes,
	controlApi: controlApi,
	get EncryptionTypes () { return EncryptionTypes; },
	get PaymentMethodPIIDs () { return PaymentMethodPIIDs$1; }
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate$1(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param$1(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate$1(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers$1(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey$1(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName$1(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata$1(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding$1 = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar$1(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding$1(o, m, p);
}

function __values$1(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$1(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread$1() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$1(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays$1() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray$1(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await$1(v) {
    return this instanceof __await$1 ? (this.v = v, this) : new __await$1(v);
}

function __asyncGenerator$1(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await$1 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator$1(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await$1(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues$1(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values$1 === "function" ? __values$1(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject$1(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault$1 = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar$1(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding$1(result, mod, k);
    __setModuleDefault$1(result, mod);
    return result;
}

function __importDefault$1(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet$1(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet$1(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn$1(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource$1(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;

}

var _SuppressedError$1 = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources$1(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError$1(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

var tslib_es6$1 = {
    __extends: __extends$1,
    __assign: __assign$1,
    __rest: __rest$1,
    __decorate: __decorate$1,
    __param: __param$1,
    __metadata: __metadata$1,
    __awaiter: __awaiter$1,
    __generator: __generator$1,
    __createBinding: __createBinding$1,
    __exportStar: __exportStar$1,
    __values: __values$1,
    __read: __read$1,
    __spread: __spread$1,
    __spreadArrays: __spreadArrays$1,
    __spreadArray: __spreadArray$1,
    __await: __await$1,
    __asyncGenerator: __asyncGenerator$1,
    __asyncDelegator: __asyncDelegator$1,
    __asyncValues: __asyncValues$1,
    __makeTemplateObject: __makeTemplateObject$1,
    __importStar: __importStar$1,
    __importDefault: __importDefault$1,
    __classPrivateFieldGet: __classPrivateFieldGet$1,
    __classPrivateFieldSet: __classPrivateFieldSet$1,
    __classPrivateFieldIn: __classPrivateFieldIn$1,
    __addDisposableResource: __addDisposableResource$1,
    __disposeResources: __disposeResources$1,
};

var pidlReactClassPrefix = knownTagPrefixes.pidlReact;

var startsWith = typehelper.startsWith;

(function (AppScenario) {
    AppScenario["None"] = "none";
    AppScenario["AddAddress"] = "addAddress";
    AppScenario["AddPaymentInstrument"] = "addPaymentInstrument";
    AppScenario["EditPaymentInstrument"] = "editPaymentInstrument";
    AppScenario["DeletePaymentInstrument"] = "deletePaymentInstrument";
    AppScenario["ApplyPaymentInstrument"] = "applyPaymentInstrument";
    AppScenario["SelectPaymentMethod"] = "selectPaymentMethod";
    AppScenario["ConfirmPayment"] = "confirmPayment";
    AppScenario["SelectPaymentInstrument"] = "selectPaymentInstrument";
    AppScenario["ListAddress"] = "listAddress";
    AppScenario["RiskChallenge"] = "riskChallenge";
    AppScenario["ProfilePrerequisite"] = "profilePrerequisite";
    AppScenario["PaymentInstrumentDetails"] = "paymentInstrumentDetails";
    AppScenario["HandlePaymentChallenge"] = "handlePaymentChallenge";
    AppScenario["VerifyAddress"] = "verifyAddress";
    AppScenario["RedeemMSRewards"] = "redeemMSRewards";
    AppScenario["SelectMSRewards"] = "selectMSRewards";
    AppScenario["OfferPaymentInstrument"] = "offerPaymentInstrument";
})(exports.AppScenario || (exports.AppScenario = {}));

(function (ElementType) {
    ElementType["alert"] = "alert";
    ElementType["button"] = "button";
    ElementType["buttonGroup"] = "buttonGroup";
    ElementType["checkbox"] = "checkbox";
    ElementType["dialog"] = "dialog";
    ElementType["dropdown"] = "dropdown";
    ElementType["error"] = "error";
    ElementType["group"] = "group";
    ElementType["captcha"] = "captcha";
    ElementType["audio"] = "audio";
    ElementType["heading"] = "heading";
    ElementType["helpDialog"] = "helpDialog";
    ElementType["hyperlink"] = "hyperlink";
    ElementType["iframe"] = "iframe";
    ElementType["challengeIframe"] = "challengeIframe";
    ElementType["secureProperty"] = "secureProperty";
    ElementType["securePropertyLabel"] = "securePropertyLabel";
    ElementType["image"] = "image";
    ElementType["label"] = "label";
    ElementType["logo"] = "logo";
    ElementType["subheading"] = "subheading";
    ElementType["text"] = "text";
    ElementType["textBox"] = "textBox";
    ElementType["radio"] = "radio";
    ElementType["radioCircle"] = "radioCircle";
    ElementType["checkedRadioCircle"] = "checkedRadioCircle";
    ElementType["modal"] = "modal";
    ElementType["overlay"] = "overlay";
    ElementType["spinner"] = "spinner";
    ElementType["panel"] = "panel";
    ElementType["textgroup"] = "textgroup";
    ElementType["filePicker"] = "filePicker";
    ElementType["separator"] = "separator";
    ElementType["tooltip"] = "tooltip";
})(exports.ElementType || (exports.ElementType = {}));

var defaultEnvironment = "prod";
var AddAddressConstants = {
    DefaultAddressType: "jarvis_v3",
    Operation: "add",
    ContainerId: "addResource",
    ResourceType: "Address",
    UserId: "me",
    ViewTermsId: "viewTermsButton",
};
var SelectPaymentMethodConstants = {
    AllowedPaymentMethods: [
        "credit_card",
        "ewallet.paypal",
        "ewallet.kakaopay",
        "ewallet.stored_value",
        "mobile_billing_non_sim",
        "online_bank_transfer.paysafecard",
        "ewallet.venmo",
    ],
    Operation: "select",
    ContainerId: "selectResource",
    ResourceType: "PaymentInstrument",
    UserId: "me",
};
var EditAddressConstants = {
    AddressType: "jarvis_v3",
    Operation: "update",
    ContainerId: "updateResource",
    ResourceType: "AddressEx",
    UserId: "me",
};
var HandleRiskChallengeConstants = {
    ContainerId: "RiskChallenge",
    Operation: "RenderPidlPage",
    ResourceType: "Challenge",
    UserId: "me",
};
var ConfirmPaymentConstants = {
    ContainerId: "RiskChallenge",
    Operation: "RenderPidlPage",
    ResourceType: "Challenge",
    UserId: "me",
    RiskChallengeData: "globalPIQrCode",
    ViewTermsId: "globalPIQrCodePrivacyStatement",
    RedirectButton: "globalPIQrCodeRedirectButton",
    RedirectButtonPage2: "globalPIQrCodeRedirectButtonPage2",
};
var ValidateAddressConstants = {
    Operation: "validateInstance",
    ContainerId: "validateResource",
    ResourceType: "Address",
    UserId: "me",
};
var ResourceHelpersConstants = {
    isCreditCard: "isUserPICreditCard",
    isCreditCardExpired: "isCreditCardExpired",
    isEwalletStoredValue: "IsEwalletStoredValue",
};
var SelectMSRewardsConstants = {
    Operation: "select",
    ContainerId: "selectMSRewards",
    ResourceType: "MSRewards",
    UserId: "me",
    useCsvTogglePropertyName: "useCsv",
    redeemPointsTogglePropertyName: "redeemPoints",
    csvTotalPropertyName: "csvTotal",
    formattedCsvTotalPropertyName: "formattedCsvTotal",
    pointsValueTotalPropertyName: "pointsValueTotal",
    formattedPointsValueTotalPropertyName: "formattedPointsValueTotal",
};
var SelectPaymentInstrumentConstants = {
    AllowedPaymentMethods: [
        "credit_card",
        "direct_debit",
        "online_bank_transfer.paysafecard",
        "ewallet",
        "finance_leasing",
        "mobile_billing_non_sim",
        "virtual",
    ],
    Operation: "select",
    ContainerId: "selectResource",
    ResourceType: "PaymentInstrument",
    UserId: "me",
    SecondaryPIFilter: { SplitPaymentSupported: true },
    SelectPaymentInstrument: "SelectPaymentInstrument",
    paymentInstrumentList: "paymentInstrumentList",
    addNewPaymentMethodFamily: "add_new_payment_method",
    preventDefaultSelection: "addnewpm_no_default_selection",
};
var ManagePaymentInstrumentConstants = {
    NewPaymentMethodLink: "newPaymentMethodLink",
    RedeemGiftCardLink: "redeemGiftCardLink",
    ManagePaymentInstrument: "ManagePaymentInstrument",
    redeemGiftCardHandlerName: "redeemGiftCardHandler",
};
var ListAddressConstants = {
    Operation: "selectInstance",
    ContainerId: "listAddress",
    ResourceType: "Address",
    UserId: "me",
    DefaultAddressType: "jarvis_v3",
};
var AddPaymentInstrumentConstants = {
    Operation: "add",
    ContainerId: "addPaymentInstrument",
    ResourceType: "PaymentInstrument",
    UserId: "me",
    ViewTermsId: "viewTermsButton",
    LogoRowElement: "acceptedCardsLogos"
};
var DeletePaymentInstrumentConstants = {
    ContainerId: "deletePaymentInstrument",
    Operation: "delete",
    ResourceType: "PaymentInstrument",
    UserId: "me",
};
var EditPaymentInstrumentConstants = {
    ContainerId: "editPaymentInstrument",
    ViewTermsId: "viewTermsButton",
    Operation: "update",
    ResourceType: "PaymentInstrument",
    UserId: "me",
};
var RedeemMSRewardsConstants = {
    ContainerId: "MSRewards",
    ResourceType: "MSRewards",
    UserId: "me",
};
var ApplyPaymentInstrumentConstants = {
    Operation: "add",
    ContainerId: "addPaymentInstrument",
    ResourceType: "PaymentInstrument",
    UserId: "me",
    ViewTermsId: "viewTermsButton",
    PaymentType: "mc",
    PaymentFamily: "credit_card",
    DefaultScenario: "xboxCreditCardInit",
};
var OfferPaymentInstrumentConstants = {
    Operation: "offer",
    ContainerId: "offerPaymentInstrument",
    ResourceType: "PaymentInstrument",
    UserId: "me",
};
var ProfilePrerequisiteConstants = {
    Operation: "update",
    ContainerId: "profilePrerequisite",
    ResourceType: "Profile",
    UserId: "me",
    type: "consumer",
};
var PaymentInstrumentDetailsConstants = {
    Operation: "selectSingleInstance",
    ContainerId: "paymentInstrumentDetails",
    ResourceType: "PaymentInstrument",
    UserId: "me",
    type: "consumer",
    Scenario: "details",
    ChangeButtonId: "changeSinglePIButton",
};
var HandleIndia3DSChallengeConstants = {
    ContainerId: "handlePaymentChallenge",
    Operation: "RenderPidlPage",
    ResourceType: "Challenge",
    UserId: "me",
    ViewTermsId: "viewTermsButton",
};
var RiskChallengeConstants = {
    ViewTermsId: "viewTermsButton",
};
(function (AddressScenario) {
    AddressScenario["billing"] = "billing";
    AddressScenario["shipping"] = "shipping";
    AddressScenario["profile"] = "profile";
})(exports.AddressScenario || (exports.AddressScenario = {}));
(function (ApplyPaymentInstrumentScenario) {
    ApplyPaymentInstrumentScenario["xboxCoBrandedCard"] = "xboxCoBrandedCard";
    ApplyPaymentInstrumentScenario["xboxApplyFullPageRender"] = "xboxApplyFullPageRender";
})(exports.ApplyPaymentInstrumentScenario || (exports.ApplyPaymentInstrumentScenario = {}));
(function (OfferPaymentInstrumentScenario) {
    OfferPaymentInstrumentScenario["xboxCoBrandedCardBuyNow"] = "xboxCoBrandedCardBuyNow";
})(exports.OfferPaymentInstrumentScenario || (exports.OfferPaymentInstrumentScenario = {}));

var PageErrorBlock = function (_a) {
    var children = _a.children;
    return (
    // TODO: Get className with helper function
    React.createElement("div", { className: "pidlddc-div pidlddc-div-group pidlddc-error-block", id: "pidlddc-div-pageerrorblock", "aria-live": "polite" }, children));
};
var BodyBlock = function (_a) {
    var children = _a.children;
    return (
    // TODO: Get className with helper function
    React.createElement("div", { className: "pidlddc-div pidlddc-div-group pidlddc-pagecontent-block", id: "pidlddc-div-pagebodycontents" }, children));
};

var specialCases = {
    "propertyName": function (element, newProps) { return newProps.propertyName = element.getPropertyName(); },
    "elementId": function (element, newProps) { return newProps.elementId = element.id; },
    "resolvedLogo": function (element, newProps) { return newProps.resolvedLogo = element.getResolvedLogo(); },
    "pidlKey": function (element, newProps) { return newProps.pidlKey = element.key; },
};
;
function ElementWrapper() {
    return function Descriptor(Component, keys) {
        function WrappedComponent(props, forwardRef) {
            var element = props.element;
            if (element) {
                var newProps = {};
                for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                    var key = keys_1[_i];
                    var specialCase = specialCases[key];
                    if (specialCase) {
                        specialCase(element, newProps);
                    }
                    else {
                        var descriptor = element[key];
                        newProps[key] = descriptor instanceof Function
                            ? descriptor()
                            : element[key];
                    }
                }
                return React.createElement(Component, __assign$1({ ref: forwardRef }, newProps, props));
            }
            else {
                return null;
            }
        }
        WrappedComponent.displayName = "ElementWrapper(".concat(keys.join("|"), " => ").concat(Component.displayName || "UnknownComponent", ")");
        var Wrapped = React.forwardRef(WrappedComponent);
        return Wrapped;
    };
}
var PropertyElementWrapper = ElementWrapper();
var ModelElementWrapper = ElementWrapper();
var ContainerElementWrapper = ElementWrapper();
var GroupElementWrapper = ElementWrapper();
var CaptchaElementWrapper = ElementWrapper();
var TextGroupElementWrapper = ElementWrapper();
var TextDisplayElementWrapper = ElementWrapper();
var ImageElementWrapper = ElementWrapper();
var IFrameElementWrapper = ElementWrapper();
var ChallengeIFrameElementWrapper = ElementWrapper();
var SecurePropertyElementWrapper = ElementWrapper();
var DropdownElementWrapper = ElementWrapper();
var ButtonListElementWrapper = ElementWrapper();
var TextBoxElementWrapper = ElementWrapper();
var CheckBoxElementWrapper = ElementWrapper();
var RadioElementWrapper = ElementWrapper();
var ButtonElementWrapper = ElementWrapper();
var FilePickerElementWrapper = ElementWrapper();
var AudioElementWrapper = ElementWrapper();
var LogoDisplayElementWrapper = ElementWrapper();
var SelectOptionElementWrapper = ElementWrapper();
var SeparatorElementWrapper = ElementWrapper();

var CurrentPidlDoc = React.createContext({
    pidlDocs: []
});
var IsInline = React.createContext(false);
var PropertyState = React.createContext({ values: {}, accessibilityText: {}, errors: {} });
var GroupErrors = React.createContext({});
var RenderContext = React.createContext({ elementFactory: null, displayOptions: null, displaySettings: null, theme: null, userContext: null });
var EventHub$1 = React.createContext(null);
var StyleProviderContext = React.createContext(null);

function getTagClassNames(tags) {
    if (tags === void 0) { tags = {}; }
    var classNames = [];
    if (tags) {
        for (var _i = 0, _a = Object.keys(tags); _i < _a.length; _i++) {
            var key = _a[_i];
            if (typehelper.startsWith(key, knownTagPrefixes.noPidlddc) || typehelper.startsWith(key, knownTagPrefixes.pidlReact)) {
                classNames.push(tags[key]);
            }
            else if (!knownTags[key] && !utils.isTagPrefixKnown(key)) {
                classNames.push(htmlClassPrefixes.taggedClass + tags[key]);
            }
        }
    }
    return classNames;
}
function getClassNamesFromStyleHints(styleHints) {
    var classNames = [];
    if (styleHints) {
        for (var _i = 0, styleHints_1 = styleHints; _i < styleHints_1.length; _i++) {
            var styleHint = styleHints_1[_i];
            classNames.push(htmlClassPrefixes.taggedClass + styleHint);
        }
    }
    return classNames;
}
function getPidlReactCustomProps(tags) {
    if (tags === void 0) { tags = {}; }
    var customProps = [];
    if (tags) {
        for (var _i = 0, _a = Object.keys(tags); _i < _a.length; _i++) {
            var key = _a[_i];
            if (typehelper.startsWith(key, knownTagPrefixes.pidlReact)) {
                customProps.push(tags[key].substring(knownTagPrefixes.pidlReact.length));
            }
        }
    }
    return customProps;
}
function shouldHideInlineError(tags) {
    if (tags === void 0) { tags = {}; }
    if (tags) {
        for (var _i = 0, _a = Object.keys(tags); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key === knownTags.hideInlineError) {
                return true;
            }
        }
    }
    return false;
}

var Error$1 = function (_a) {
    var propertyName = _a.propertyName;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.error, propertyName);
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        return React.createElement(PropertyState.Consumer, null, function (state) {
            var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings;
            var error = state.errors[propertyName] ? state.errors[propertyName].message : null;
            if (!error) {
                return null;
            }
            var errorProps = {
                errorMessage: error
            };
            if (elementFactory && elementFactory.canCreate(exports.ElementType.error, errorProps, {})) {
                return elementFactory.create(exports.ElementType.error, errorProps);
            }
            return (React.createElement("span", { 
                // TODO: Get className with helper function
                className: classnames("pidlddc-error", { "d-none": !error }, "text-danger"), id: id, tabIndex: -1, role: "alert" }, error));
        });
    }));
};
Error$1.displayName = "Error";
var PageAlert = function (props) {
    var message = props.message;
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings;
        var alertElementProps = {
            elementId: "pidlddc-page-alert-id",
            message: message,
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.alert, alertElementProps, {})) {
            return elementFactory.create(exports.ElementType.alert, alertElementProps);
        }
        return React.createElement("div", { id: alertElementProps.elementId, className: "pidlddc-error-alert", role: "alert" }, alertElementProps.message);
    }));
};
PageAlert.displayName = "PageAlert";

var ButtonInner = function (props) {
    var className = props.className, element = props.element, elementId = props.elementId, displayContent = props.displayContent, pidlAction = props.pidlAction, disabled = props.disabled, accessibilityName = props.accessibilityName, onClick = props.onClick, tags = props.tags, styleHints = props.styleHints, tooltipText = props.tooltipText, gridColumn = props.gridColumn, gridRow = props.gridRow, accessibilityHint = props.accessibilityHint, containerLayoutOrientation = props.containerLayoutOrientation;
    var type = pidlAction.type, isDefault = pidlAction.isDefault;
    var isPrimary = (type === "submit") || isDefault;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.button, elementId);
    var additionalClassName = classnames(className, getTagClassNames(tags));
    var propertyElementRef = element.propertyElementRef;
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, theme = renderContext.theme;
        var buttonProps = {
            id: id,
            displayContent: displayContent,
            onClick: onClick,
            additionalClassName: additionalClassName,
            disabled: disabled,
            ariaLabel: accessibilityName,
            accessibilityHint: accessibilityHint,
            primary: isPrimary,
            type: isPrimary ? "primary" : "secondary",
            propertyElementRef: propertyElementRef,
            theme: theme,
            styleHints: styleHints,
            tooltipText: tooltipText,
            gridColumn: gridColumn,
            gridRow: gridRow,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.button, buttonProps, {})) {
            return elementFactory.create(exports.ElementType.button, buttonProps);
        }
        return (React.createElement("button", { id: id, className: classnames(isPrimary ? "pidlddc-highlighted" : "pidlddc-back", additionalClassName), disabled: disabled, "aria-label": accessibilityName, onClick: onClick }, displayContent));
    }));
};
var Button = ButtonElementWrapper(ButtonInner, ["elementId", "pidlAction", "disabled", "displayContent", "accessibilityName", "accessibilityHint", "tags", "styleHints", "tooltipText", "containerLayoutOrientation"]);
Button.displayName = "Button";
var ButtonListElementInner = function (props) {
    var elementId = props.elementId, displayText = props.displayText, displayImageUrl = props.displayImageUrl, createElement = props.createElement, displayContentContainer = props.displayContentContainer, isDisabled = props.isDisabled, pidlKey = props.pidlKey, onClick = props.onClick, buttonAction = props.buttonAction, containerDisplayId = props.containerDisplayId, ariaLabel = props.ariaLabel, propertyElementRef = props.propertyElementRef, styleHints = props.styleHints, containerLayoutOrientation = props.containerLayoutOrientation;
    var buttonContent = displayContentContainer ? createElement(displayContentContainer) :
        [
            displayImageUrl ? React.createElement("img", { src: displayImageUrl, key: "".concat(elementId, "-img"), id: "pidlddc-buttonlist-".concat(elementId, "-").concat(pidlKey) }) : null,
            displayText,
        ];
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions;
        var _a = htmlAttributesHelper$1, concatIdElement = _a.concatIdElement, getId = _a.getId;
        var id = concatIdElement(getId(displayOptions.inputPropertyIdPrefix, elementId), pidlKey);
        var onButtonClick = function () { return onClick({
            id: id,
            pidlAction: buttonAction,
            value: buttonAction.context,
            dest: "",
        }); };
        var buttonProps = {
            id: id,
            key: pidlKey,
            onClick: onButtonClick,
            additionalClassName: "",
            displayContent: buttonContent,
            disabled: isDisabled,
            primary: false,
            type: "list",
            containerDisplayId: containerDisplayId,
            ariaLabel: ariaLabel,
            propertyElementRef: propertyElementRef,
            styleHints: styleHints,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.button, buttonProps, {})) {
            return elementFactory.create(exports.ElementType.button, buttonProps);
        }
        return (React.createElement("button", { id: id, disabled: isDisabled, onClick: onButtonClick, "aria-label": ariaLabel }, buttonProps.displayContent));
    }));
};
var ButtonListElement$1 = SelectOptionElementWrapper(ButtonListElementInner, ["displayImageUrl", "displayContentContainer", "displayText", "isDisabled", "displayContent", "displayType", "pidlKey", "styleHints", "containerLayoutOrientation"]);
ButtonListElement$1.displayName = "ButtonListElement";
var ButtonListInner = function (props) {
    var createElement = props.createElement, elementId = props.elementId, possibleOptions = props.possibleOptions, onClick = props.onClick, tags = props.tags, displayId = props.displayId, element = props.element, styleHints = props.styleHints, containerLayoutOrientation = props.containerLayoutOrientation;
    var options = [];
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.buttongroup, elementId);
    var propertyElementRef = element.propertyElementRef;
    // attach focus ref to first element in list that is not disabled
    var refAttached = false;
    for (var key in possibleOptions) {
        if (possibleOptions.hasOwnProperty(key) && possibleOptions[key]) {
            var option = possibleOptions[key];
            var buttonAction = possibleOptions[key].pidlAction || { context: { id: key }, type: "" };
            var ref = null;
            if (!refAttached && !option.isDisabled) {
                ref = propertyElementRef;
                refAttached = true;
            }
            options.push(React.createElement(ButtonListElement$1, { element: option, elementId: elementId, createElement: createElement, onClick: onClick, buttonAction: buttonAction, pidlKey: key, containerDisplayId: displayId, propertyElementRef: ref, ariaLabel: option === null || option === void 0 ? void 0 : option.accessibilityName }));
        }
    }
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory;
        var buttonGroupProps = {
            id: id,
            additionalClassName: classnames(getTagClassNames(tags)),
            options: options,
            optionsDirection: "vertical",
            displayId: displayId,
            propertyElementRef: propertyElementRef,
            styleHints: styleHints,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.buttonGroup, buttonGroupProps, {})) {
            return elementFactory.create(exports.ElementType.buttonGroup, buttonGroupProps);
        }
        return (React.createElement("div", { className: classnames(getTagClassNames(tags)), id: buttonGroupProps.id }, options));
    }));
};
var ButtonList = ButtonListElementWrapper(ButtonListInner, ["elementId", "possibleOptions", "disabled", "hidden", "tags", "displayId", "styleHints", "containerLayoutOrientation"]);
ButtonList.displayName = "ButtonList";

var CheckBoxInner = function (props) {
    var elementId = props.elementId, required = props.required, disabled = props.disabled, hidden = props.hidden, propertyName = props.propertyName, displayName = props.displayName, accessibilityName = props.accessibilityName, onChange = props.onChange, tags = props.tags, displayId = props.displayId, useDisplayIdAsKeyForCheckState = props.useDisplayIdAsKeyForCheckState, element = props.element, styleHints = props.styleHints, containerLayoutOrientation = props.containerLayoutOrientation;
    var propertyElementRef = element.propertyElementRef;
    var _a = htmlAttributesHelper$1, getDivId = _a.getDivId, getId = _a.getId;
    var divId = getDivId(elementId);
    var hideInlineError = shouldHideInlineError(tags);
    var wrapGroupedElements = function (elementFactory, innerJSX) {
        if ((elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
            return innerJSX;
        }
        return (React.createElement("div", { id: divId }, innerJSX));
    };
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        // TODO: Remove the coupling to a state object from outside this component.
        return React.createElement(PropertyState.Consumer, null, function (state) {
            var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings;
            var inputId = getId(displayOptions.inputPropertyIdPrefix, element.displayType === pidlDisplayTypesValues.prefillControl ? displaySettings.prefillCheckboxBlock.id : propertyName);
            var checkBoxElementProps = {
                elementId: inputId,
                displayContent: displayName,
                onChange: onChange,
                displayId: displayId,
                disabled: disabled,
                ariaLabel: state.accessibilityText[propertyName] || accessibilityName,
                additionalClassName: classnames(getTagClassNames(tags)),
                inlineError: (state.errors[propertyName] && !hideInlineError) ? state.errors[propertyName].message : undefined,
                // TODO: Ideally checked state should be stored under propertyName. However due to bug 21876918 the prefill checkbox needs to use displayId.
                // Once the bug is fixed, consider refactoring this code and the code that uses the prefill checkbox to stop using displayId for check state.
                checked: useDisplayIdAsKeyForCheckState ? !!state.values[displayId] : (state.values[propertyName] === true || state.values[propertyName] === "true"),
                hidden: hidden,
                required: required,
                id: inputId,
                propertyName: propertyName,
                propertyElementRef: propertyElementRef,
                styleHints: styleHints,
                containerLayoutOrientation: containerLayoutOrientation
            };
            var capabilities = elementFactory && elementFactory.canCreate(exports.ElementType.checkbox, checkBoxElementProps, {});
            if (capabilities) {
                return wrapGroupedElements(elementFactory, (React.createElement(React.Fragment, null,
                    elementFactory.create(exports.ElementType.checkbox, checkBoxElementProps),
                    ((!capabilities || !capabilities.inlineError) && !hideInlineError) ? React.createElement(Error$1, { propertyName: propertyName }) : null)));
            }
            else {
                var labelId = "".concat(checkBoxElementProps.elementId, "_label");
                return (React.createElement("div", { id: divId },
                    React.createElement("label", { id: labelId, htmlFor: inputId, "aria-label": checkBoxElementProps.ariaLabel, hidden: checkBoxElementProps.hidden },
                        React.createElement("input", { type: "checkbox", id: inputId, required: checkBoxElementProps.required, hidden: checkBoxElementProps.hidden, disabled: checkBoxElementProps.disabled, checked: checkBoxElementProps.checked, "aria-labelledby": labelId, onChange: function (event) {
                                return checkBoxElementProps.onChange(event.currentTarget.checked);
                            } }),
                        checkBoxElementProps.displayContent),
                    hideInlineError ? null : React.createElement(Error$1, { propertyName: propertyName })));
            }
        });
    }));
};
var CheckBox = CheckBoxElementWrapper(CheckBoxInner, ["elementId", "propertyName", "accessibilityName", "displayName", "required", "hidden", "disabled", "tags", "displayId", "styleHints", "containerLayoutOrientation"]);
CheckBox.displayName = "CheckBox";

/**
 *
 * Group Wrapper for PIDL document display groups
 * @implements {IFluentPidl}
 */
var GroupWrapper = /** @class */ (function () {
    function GroupWrapper(group) {
        this.group = group;
    }
    // tslint:disable:no-any
    GroupWrapper.prototype.addChild = function (displayDescription) {
        if (!this.group.members) {
            this.group.members = [];
        }
        this.group.members.push(displayDescription);
        return this;
    };
    GroupWrapper.prototype.addHeading = function (displayId, displayContent) {
        return this.addChild({
            displayId: displayId,
            displayContent: displayContent,
            displayType: pidlDisplayTypesValues.heading,
        });
    };
    GroupWrapper.prototype.addSubheading = function (displayId, displayContent) {
        return this.addChild({
            displayId: displayId,
            displayContent: displayContent,
            displayType: pidlDisplayTypesValues.subheading,
        });
    };
    GroupWrapper.prototype.addText = function (displayId, displayContent) {
        return this.addChild({
            displayId: displayId,
            displayContent: displayContent,
            displayType: pidlDisplayTypesValues.text,
        });
    };
    GroupWrapper.prototype.addGroup = function (displayId, displayName, isSubmitGroup) {
        if (isSubmitGroup === void 0) { isSubmitGroup = false; }
        if (!this.group.members) {
            this.group.members = [];
        }
        var newGroup = {
            displayId: displayId,
            isSubmitGroup: isSubmitGroup,
            displayType: pidlDisplayTypesValues.group,
            layoutOrientation: groupLayoutOrientationTypesValues.vertical,
            displayName: displayName || '',
            members: []
        };
        this.group.members.push(newGroup);
        return new GroupWrapper(newGroup);
    };
    GroupWrapper.prototype.addInlineGroup = function (displayId, displayName, isSubmitGroup) {
        if (isSubmitGroup === void 0) { isSubmitGroup = false; }
        if (!this.group.members) {
            this.group.members = [];
        }
        var newGroup = {
            displayId: displayId,
            isSubmitGroup: isSubmitGroup,
            displayType: pidlDisplayTypesValues.group,
            layoutOrientation: groupLayoutOrientationTypesValues.inline,
            displayName: displayName || '',
            members: []
        };
        this.group.members.push(newGroup);
        return new GroupWrapper(newGroup);
    };
    GroupWrapper.prototype.addExpression = function (displayId, displayContent) {
        return this.addChild({
            displayId: displayId,
            displayContent: displayContent,
            displayType: pidlDisplayTypesValues.expression
        });
    };
    GroupWrapper.prototype.addTextGroup = function (displayId, displayName) {
        if (!this.group.members) {
            this.group.members = [];
        }
        var newGroup = {
            displayId: displayId,
            isSubmitGroup: false,
            displayType: pidlDisplayTypesValues.textGroup,
            layoutOrientation: groupLayoutOrientationTypesValues.inline,
            displayName: displayName || '',
            members: []
        };
        this.group.members.push(newGroup);
        return new GroupWrapper(newGroup);
    };
    GroupWrapper.prototype.addSubmitGroup = function (displayId, displayName) {
        return this.addInlineGroup(displayId, displayName, true);
    };
    GroupWrapper.prototype.addButton = function (displayId, displayContent, pidlAction, additionalProps) {
        if (additionalProps === void 0) { additionalProps = {}; }
        return this.addChild(__assign$1({ displayId: displayId, pidlAction: pidlAction, displayContent: displayContent, displayType: 'button', tags: { accessibilityName: displayContent } }, additionalProps));
    };
    GroupWrapper.prototype.addSubmitButton = function (displayId, displayContent, pidlAction) {
        pidlAction = __assign$1({ type: "submit", isDefault: true }, pidlAction);
        return this.addButton(displayId, displayContent, pidlAction, { isHighlighted: true });
    };
    GroupWrapper.prototype.addCancelButton = function (displayId, displayContent, pidlAction) {
        pidlAction = __assign$1({ type: "gohome" }, pidlAction);
        return this.addButton(displayId, displayContent, pidlAction, { isBack: true });
    };
    return GroupWrapper;
}());
/**
 *
 * PIDL Document Builder
 */
var PidlDocBuilder = /** @class */ (function () {
    function PidlDocBuilder(identity) {
        var _this = this;
        this.addDataDescription = function (propertyName, dataDescription) {
            _this.dataDescription[propertyName] = dataDescription;
            return _this;
        };
        this.addPage = function (displayId, displayName) {
            var newPage = {
                displayId: displayId,
                displayName: displayName,
                members: [],
                displayType: pidlDisplayTypesValues.page,
            };
            _this.pages.push(newPage);
            return new GroupWrapper(newPage);
        };
        this.build = function () {
            return {
                identity: _this.identity,
                data_description: _this.dataDescription,
                displayDescription: _this.pages
            };
        };
        this.identity = identity;
        this.dataDescription = {};
        this.pages = [];
    }
    return PidlDocBuilder;
}());

/**
 *
 * PIDL Property Validation Helper
 * @implements {ICustomValidation}
 */
var ValidationWrapper = /** @class */ (function () {
    function ValidationWrapper(validations) {
        var _this = this;
        this.required = function (errorCode, errorMessage) {
            _this.validations.push({
                error_code: errorCode,
                error_message: errorMessage,
                validationType: validationModesValues.regex,
                regex: '^(?!^[\\u0009\\u000A\\u000D\\u0020\\u2000-\\u200B]*$)[\\u0009\\u000A\\u000D\\u0020-\\uD7FF\\uE000-\\uFFFD\\u10000-\\u10FFFF]{1,128}$'
            });
            return _this;
        };
        this.hasLetters = function (errorCode, errorMessage, length) {
            var range = typeof length === 'number' ? length : "".concat(length[0], ",").concat(length[1]);
            _this.validations.push({
                error_code: errorCode,
                error_message: errorMessage,
                validationType: validationModesValues.regex,
                // tslint:disable:max-line-length
                regex: "^(?!^[\\u0009\\u000A\\u000D\\u0020\\u2000-\\u200B]*$)[\\u0009\\u000A\\u000D\\u0020-\\uD7FF\\uE000-\\uFFFD\\u10000-\\u10FFFF]{".concat(range, "}$")
            });
            return _this;
        };
        this.alphanumeric = function (errorCode, errorMessage, length) {
            var range = typeof length === 'number' ? length : "".concat(length[0], ",").concat(length[1]);
            _this.validations.push({
                error_code: errorCode,
                error_message: errorMessage,
                validationType: validationModesValues.regex,
                regex: "^[A-Za-z0-9]{".concat(range, "}$")
            });
            return _this;
        };
        this.numeric = function (errorCode, errorMessage, length) {
            var range = typeof length === 'number' ? length : "".concat(length[0], ",").concat(length[1]);
            _this.validations.push({
                error_code: errorCode,
                error_message: errorMessage,
                validationType: validationModesValues.regex,
                regex: "^\\d{".concat(range, "}$")
            });
            return _this;
        };
        this.exactly = function (errorCode, errorMessage, values) {
            values = Array.isArray(values) ? values.join('|') : values;
            _this.validations.push({
                error_code: errorCode,
                error_message: errorMessage,
                validationType: validationModesValues.regex,
                regex: "^".concat(values, "$")
            });
            return _this;
        };
        this.validations = validations;
    }
    return ValidationWrapper;
}());
/**
 *
 * PIDL Property Builder
 */
var PidlPropertyBuilder = /** @class */ (function () {
    function PidlPropertyBuilder(propertyName, base) {
        var _this = this;
        this.validations = [];
        this.possibleValues = null;
        this.possibleOptions = null;
        this.dataCollectionSource = null;
        this.defaultValue = null;
        this.isDisabled = null;
        this.setDataCollectionSource = function (source, value, displayText) {
            _this.dataCollectionSource = source;
            _this.possibleOptions = {};
            _this.possibleOptions[value] = {
                displayText: displayText,
                isDisabled: false
            };
            return _this;
        };
        this.validate = function () {
            return new ValidationWrapper(_this.validations);
        };
        this.setPossibleValues = function (possibleValues) {
            _this.possibleOptions = {};
            for (var _i = 0, _a = Object.keys(possibleValues); _i < _a.length; _i++) {
                var key = _a[_i];
                _this.possibleOptions[key] = {
                    displayText: possibleValues[key],
                    isDisabled: false
                };
            }
            _this.possibleValues = possibleValues;
            return _this;
        };
        this.setDisabled = function () {
            _this.isDisabled = true;
            return _this;
        };
        this.setDefaultValue = function (defaultValue) {
            _this.defaultValue = defaultValue;
            return _this;
        };
        this.buildData = function () {
            var generated = {
                validations: _this.validations
            };
            if (_this.validations.length > 0) {
                generated.validation = _this.validations[0];
            }
            if (_this.dataCollectionSource) {
                generated.possible_values = {};
            }
            if (_this.defaultValue) {
                generated.default_value = _this.defaultValue;
            }
            return __assign$1(__assign$1({}, _this.base), generated);
        };
        this.buildDisplay = function (additionalProps) {
            var propertyName = _this.propertyName;
            // tslint:disable:no-any
            var props = {};
            if (_this.dataCollectionSource) {
                props.dataCollectionSource = _this.dataCollectionSource;
                props.possibleOptions = _this.possibleOptions;
            }
            else if (_this.possibleValues) {
                props.possibleValues = {};
                props.possibleOptions = {};
                Object.keys(_this.possibleValues).forEach(function (key) {
                    var value = _this.possibleValues && _this.possibleValues[key];
                    if (value) {
                        props.possibleValues[key] = value;
                        props.possibleOptions[key] = { displayText: value, isDisabled: false };
                    }
                });
                props.displaySelectionText = "--- ".concat(propertyName, " ---");
            }
            var validation = _this.validations[0];
            var displayErrorMessages = validation ? {
                defaultErrorMessage: validation.error_message,
                fromErrorCode: [
                    {
                        errorCode: validation.error_code,
                        errorMessage: validation.error_message
                    }
                ]
            } : {};
            var isDisabled = _this.isDisabled ? true : false;
            return __assign$1(__assign$1({ displayName: propertyName, showDisplayName: 'true', displayId: "display_".concat(propertyName), displayType: 'property', propertyName: propertyName, tags: { accessibilityName: propertyName }, displayErrorMessages: displayErrorMessages, isDisabled: isDisabled }, props), additionalProps);
        };
        this.propertyName = propertyName;
        this.base = base || {
            propertyType: 'userData',
            type: 'string',
            dataType: 'string',
            is_updatable: true,
        };
    }
    return PidlPropertyBuilder;
}());

var PrefillCheckBoxInner = function (props) {
    var displayId = props.displayId, required = props.required, disabled = props.disabled, hidden = props.hidden, elementId = props.elementId, propertyName = props.propertyName, displayName = props.displayName, accessibilityName = props.accessibilityName, onChange = props.onChange, tags = props.tags, element = props.element, getMultiPropertySelectorPossibleOptions = props.getMultiPropertySelectorPossibleOptions;
    var possibleOptions = getMultiPropertySelectorPossibleOptions(element.pidlIdentity);
    var isHidden = hidden || !possibleOptions;
    return React.createElement(CheckBox, { element: element, elementId: elementId, required: required, hidden: isHidden, disabled: disabled, propertyName: propertyName, displayName: displayName, accessibilityName: accessibilityName, 
        // TODO: The public onChange methods have different signatures between the regular CheckBox and PrefillCheckbox, the first takes a "true" or "false" string, the second a boolean. They should both take a boolean.
        onChange: function (value) { return onChange(value); }, displayId: displayId, useDisplayIdAsKeyForCheckState: true, tags: tags });
};
var PrefillCheckBox = CheckBoxElementWrapper(PrefillCheckBoxInner, ["elementId", "propertyName", "accessibilityName", "displayName", "displayId", "required", "hidden", "disabled", "tags"]);
PrefillCheckBox.displayName = "PrefillCheckBox";

var ModalInner = /** @class */ (function (_super) {
    __extends$1(ModalInner, _super);
    function ModalInner(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleDisplay = function (newState) {
            _this.setState({ open: newState });
        };
        _this.state = { open: true };
        return _this;
    }
    ModalInner.prototype.render = function () {
        var _a = this.props, layoutOrientation = _a.layoutOrientation, elementId = _a.elementId, childNodes = _a.childNodes, tags = _a.tags, _b = _a.element, displayId = _b.displayId, type = _b.type;
        var open = this.state.open;
        var getDivId = htmlAttributesHelper$1.getDivId;
        var modalId = getDivId(elementId);
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            var elementFactory = renderContext.elementFactory, displaySettings = renderContext.displaySettings;
            var modalElementProps = {
                childNodes: childNodes,
                layoutOrientation: layoutOrientation,
                elementId: modalId,
                groupClassName: getTagClassNames(tags),
                displayId: displayId,
                type: type,
                displaySettings: displaySettings,
                open: open
            };
            if (elementFactory && elementFactory.canCreate(exports.ElementType.modal, modalElementProps, {})) {
                return elementFactory.create(exports.ElementType.modal, modalElementProps);
            }
            else {
                var modalBackgroundStyle = {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(128,128,128,0.5)",
                    display: open ? "initial" : "none"
                };
                var modalStyle = {
                    position: "fixed",
                    top: "50vh",
                    left: "50vw",
                    transform: "translate(-50%,-50%)",
                    height: "75%",
                    width: "50%",
                    backgroundColor: "white",
                    padding: "50px",
                    overflow: "scroll"
                };
                modalElementProps.groupClassName = modalElementProps.groupClassName.filter(function (className) { return !typehelper.startsWith(className, knownTagPrefixes.pidlReact); });
                return React.createElement("div", { key: "".concat(elementId, "-modal"), id: "".concat(elementId, "-modal"), style: modalBackgroundStyle, className: classnames(modalElementProps.groupClassName) },
                    React.createElement("dialog", { key: "".concat(elementId, "-modal-content"), id: "".concat(elementId, "-modal-content"), tabIndex: -1, open: true, style: modalStyle },
                        React.createElement(IsInline.Provider, { value: layoutOrientation === "inline" }, childNodes)));
            }
        }));
    };
    return ModalInner;
}(React.Component));
var Modal = GroupElementWrapper(ModalInner, ["elementId", "layoutOrientation", "tags"]);
Modal.displayName = "Modal";

var DropdownInner = /** @class */ (function (_super) {
    __extends$1(DropdownInner, _super);
    function DropdownInner(props) {
        var _this = _super.call(this, props) || this;
        if (props.eventHub) {
            var elementId = props.elementId, possibleOptions = props.possibleOptions, displayId = props.displayId, maxLength = props.maxLength;
            var getDivId = htmlAttributesHelper$1.getDivId;
            var id = getDivId(elementId);
            props.eventHub.propertyCreating(id, { displayId: displayId, possibleOptions: possibleOptions, maxLength: maxLength }, {});
        }
        return _this;
    }
    DropdownInner.prototype.render = function () {
        var _this = this;
        var _a = this.props, elementId = _a.elementId, possibleOptions = _a.possibleOptions, accessibilityName = _a.accessibilityName, displayName = _a.displayName, showDisplayName = _a.showDisplayName, propertyName = _a.propertyName, hidden = _a.hidden, isPrefill = _a.isPrefill, onSelect = _a.onSelect, disabled = _a.disabled, required = _a.required, displaySelectionText = _a.displaySelectionText, onFocus = _a.onFocus, onBlur = _a.onBlur, optionsElements = _a.optionsElements, isSelectFirstItem = _a.isSelectFirstItem, displayId = _a.displayId, element = _a.element, eventHub = _a.eventHub, styleHints = _a.styleHints, containerLayoutOrientation = _a.containerLayoutOrientation, setOpenDropdownId = _a.setOpenDropdownId, openDropdownId = _a.openDropdownId, alwaysUpdateModelValue = _a.alwaysUpdateModelValue;
        var constants$1 = constants;
        var _b = htmlAttributesHelper$1, getDivId = _b.getDivId, generateClassName = _b.generateClassName;
        var getId = htmlAttributesHelper$1.getId;
        var errorId = getId(constants$1.htmlElementIdPrefixes.error, elementId);
        var inputId = getId(constants$1.htmlElementIdPrefixes.input, elementId);
        var dummyLabelId = "input_".concat(elementId, "dummyLabel");
        var divId = getDivId(elementId);
        var propertyElementRef = element.propertyElementRef;
        var ariaLabelledById = "".concat(dummyLabelId, " ").concat(errorId);
        var options = [];
        var defaultValue;
        for (var _i = 0, _c = Object.keys(possibleOptions || {}); _i < _c.length; _i++) {
            var key = _c[_i];
            if (possibleOptions[key]) {
                defaultValue = (isPrefill || isSelectFirstItem) && !defaultValue ? key : defaultValue;
                var _d = possibleOptions[key], displayText = _d.displayText, isDisabled = _d.isDisabled, displayImageUrl = _d.displayImageUrl, styleHints_1 = _d.styleHints;
                options.push({
                    key: key,
                    text: displayText,
                    disabled: isDisabled,
                    data: {
                        imageUrl: displayImageUrl,
                    },
                    styleHints: styleHints_1
                });
            }
        }
        var isHidden = hidden || Object.keys(possibleOptions).length === 0 ? true : false;
        var onFocusInternal = function (value) {
            eventHub.propertySelected(inputId, propertyName, divId);
            if (onFocus) {
                onFocus(value);
            }
        };
        var id = getDivId(elementId);
        var className = generateClassName(null, constants$1.htmlElementTypes.div, propertyName, constants$1.modelElementType.dropdown);
        var wrapLabelDisplayName = function (elementFactory, displayName, ariaLabel, hideLabel) {
            if ((elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
                // We can ignore this label because the element rendering the dropdown will recieve
                // the display name as a prop and can handle it there.
                return (React.createElement(React.Fragment, null));
            }
            return (React.createElement("label", { id: dummyLabelId, "aria-label": ariaLabel, style: { display: hideLabel ? "none" : undefined }, "aria-hidden": hideLabel },
                displayName,
                React.createElement("span", { className: "".concat(id, "-asterisk") }, _this.props.required ? "*" : "")));
        };
        var wrapGroupedElements = function (elementFactory, id, className, innerJSX) {
            if ((elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
                return (React.createElement(React.Fragment, null, innerJSX));
            }
            return (React.createElement("div", { id: id, className: className }, innerJSX));
        };
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            var elementFactory = renderContext.elementFactory, theme = renderContext.theme;
            return wrapGroupedElements(elementFactory, id, className, (React.createElement(PropertyState.Consumer, null, function (state) {
                var htmlAttributes = {};
                var style = htmlAttributes ? htmlAttributes.style : undefined;
                var inlineError = state.errors[propertyName] ? state.errors[propertyName].message : undefined;
                var isInValidationErrorGroup = state.errors[propertyName] ? true : false;
                var dropdownElementProps = {
                    disabled: disabled,
                    inlineError: inlineError,
                    isInValidationErrorGroup: isInValidationErrorGroup,
                    onBlur: onBlur,
                    onFocus: onFocusInternal,
                    optionsElements: optionsElements,
                    required: required,
                    showDisplayName: showDisplayName,
                    displayName: displayName,
                    displayId: displayId,
                    id: inputId,
                    ariaLabelId: ariaLabelledById,
                    dropdownOptions: options,
                    hidden: hidden || options.length === 0,
                    onChange: onSelect,
                    placeholder: isPrefill ? undefined : displaySelectionText,
                    value: state.values[propertyName] && state.values[propertyName].toString() || defaultValue,
                    style: style,
                    propertyElementRef: propertyElementRef,
                    theme: theme,
                    styleHints: styleHints,
                    containerLayoutOrientation: containerLayoutOrientation,
                    setOpenDropdownId: setOpenDropdownId,
                    openDropdownId: openDropdownId,
                    alwaysUpdateModelValue: alwaysUpdateModelValue,
                };
                var capabilities = elementFactory && elementFactory.canCreate(exports.ElementType.dropdown, dropdownElementProps, { inlineError: true, label: showDisplayName });
                var dropdownElement = null;
                if (capabilities) {
                    dropdownElement = elementFactory.create(exports.ElementType.dropdown, dropdownElementProps);
                }
                else {
                    dropdownElement = _this.renderDropdownElement(dropdownElementProps);
                }
                var hideLabel = !showDisplayName || (capabilities && capabilities.label);
                return (React.createElement(React.Fragment, null,
                    wrapLabelDisplayName(elementFactory, displayName, state.accessibilityText[propertyName] || accessibilityName, hideLabel),
                    dropdownElement,
                    (!capabilities || !capabilities.inlineError) ? React.createElement(Error$1, { propertyName: propertyName }) : null));
            })));
        }));
    };
    DropdownInner.prototype.renderDropdownElement = function (dropdownElementProps) {
        var id = dropdownElementProps.id, dropdownOptions = dropdownElementProps.dropdownOptions, onChange = dropdownElementProps.onChange, value = dropdownElementProps.value, additionalClassName = dropdownElementProps.additionalClassName, hidden = dropdownElementProps.hidden, disabled = dropdownElementProps.disabled, required = dropdownElementProps.required, placeholder = dropdownElementProps.placeholder, ariaLabelId = dropdownElementProps.ariaLabelId, inlineError = dropdownElementProps.inlineError, onFocus = dropdownElementProps.onFocus, onBlur = dropdownElementProps.onBlur, isInValidationErrorGroup = dropdownElementProps.isInValidationErrorGroup;
        var selectionText = placeholder ? React.createElement("option", { value: "" }, placeholder) : null;
        var showErrorStyle = inlineError || (isInValidationErrorGroup && !disabled);
        var options = [];
        dropdownOptions.forEach(function (dropdownOption) {
            var key = dropdownOption.key, text = dropdownOption.text, disabled = dropdownOption.disabled;
            options.push(React.createElement("option", { value: key, key: key, disabled: disabled }, text));
        });
        return (React.createElement("select", { id: id, className: showErrorStyle ? classnames(additionalClassName, "pidlddc-errorstroke") : additionalClassName, hidden: hidden, disabled: disabled, required: required, "aria-labelledby": ariaLabelId, onFocus: function (event) {
                if (onFocus && event && event.currentTarget) {
                    onFocus(event.currentTarget.value);
                }
            }, onBlur: function (event) {
                if (onBlur && event && event.currentTarget) {
                    onBlur(event.currentTarget.value);
                }
            }, onChange: function (event) {
                if (onChange && event && event.target) {
                    onChange(event.target.value);
                }
            }, value: value },
            selectionText,
            options));
    };
    return DropdownInner;
}(React.Component));
var Dropdown = DropdownElementWrapper(DropdownInner, ["elementId", "propertyName", "possibleOptions", "required", "hidden", "disabled", "displayName", "showDisplayName", "displaySelectionText", "accessibilityName", "tags", "isSelectFirstItem", "displayId", "styleHints", "containerLayoutOrientation", "alwaysUpdateModelValue"]);
Dropdown.displayName = "Dropdown";

var GroupError = function (_a) {
    var elementId = _a.elementId, isInline = _a.isInline;
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        return React.createElement(GroupErrors.Consumer, null, function (groupErrors) {
            var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings;
            var errorMessage = groupErrors[elementId] ? groupErrors[elementId].message : "";
            var errorProps = { errorMessage: errorMessage };
            if (elementFactory && elementFactory.canCreate(exports.ElementType.error, errorProps, {})) {
                return elementFactory.create(exports.ElementType.error, errorProps);
            }
            var props = {
                // TODO: Get className with helper function
                className: classnames("pidlddc-group-error", { "d-none": !errorMessage }, "text-danger"),
                id: "pidlddc-error-".concat(elementId),
                tabIndex: -1,
                role: "alert",
            };
            return isInline ? (React.createElement("span", __assign$1({}, props, { "aria-hidden": !errorMessage }), errorMessage)) : (React.createElement("div", __assign$1({}, props, { "aria-hidden": !errorMessage }), errorMessage));
        });
    }));
};
GroupError.displayName = "GroupError";
var GroupInner = function (props) {
    var layoutOrientation = props.layoutOrientation, elementId = props.elementId, childNodes = props.childNodes, tags = props.tags, labelNode = props.labelNode, _a = props.element, displayId = _a.displayId, type = _a.type, isSubmitGroup = _a.isSubmitGroup, isHidden = _a.isHidden, styleHints = props.styleHints, accessibilityName = props.accessibilityName, gridColumn = props.gridColumn, gridRow = props.gridRow, containerLayoutOrientation = props.containerLayoutOrientation;
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, displaySettings = renderContext.displaySettings;
        var getDivId = htmlAttributesHelper$1.getDivId;
        return React.createElement(IsInline.Consumer, null, function (isInline) {
            var _a;
            if (isHidden || (isSubmitGroup && ((_a = displaySettings === null || displaySettings === void 0 ? void 0 : displaySettings.submitButtonBlock) === null || _a === void 0 ? void 0 : _a.show) === false)) {
                return null;
            }
            var groupElementId = getDivId(elementId);
            var errorNode = React.createElement(GroupError, { elementId: elementId, isInline: isInline });
            var groupElementProps = {
                childNodes: childNodes,
                errorNode: errorNode,
                labelNode: labelNode,
                layoutOrientation: layoutOrientation,
                elementId: groupElementId,
                groupClassName: getTagClassNames(tags),
                displayId: displayId,
                type: type,
                displaySettings: displaySettings,
                styleHints: styleHints,
                isSubmitGroup: isSubmitGroup,
                ariaLabel: accessibilityName,
                gridColumn: gridColumn,
                gridRow: gridRow,
                containerLayoutOrientation: containerLayoutOrientation
            };
            if (elementFactory && elementFactory.canCreate(exports.ElementType.group, groupElementProps, {})) {
                return elementFactory.create(exports.ElementType.group, groupElementProps);
            }
            else {
                groupElementProps.groupClassName = groupElementProps.groupClassName.filter(function (className) { return !typehelper.startsWith(className, knownTagPrefixes.pidlReact); });
                return React.createElement("div", { id: groupElementProps.elementId, className: classnames(groupElementProps.groupClassName) },
                    labelNode,
                    React.createElement(IsInline.Provider, { value: layoutOrientation === "inline" }, childNodes),
                    errorNode);
            }
        });
    }));
};
var Group = GroupElementWrapper(GroupInner, ["elementId", "layoutOrientation", "tags", "accessibilityName", "styleHints", "containerLayoutOrientation"]);
Group.displayName = "Group";
var TextGroupInner = function (props) {
    var layoutOrientation = props.layoutOrientation, elementId = props.elementId, children = props.children, tags = props.tags, ariaLabelledBy = props.ariaLabelledBy, styleHints = props.styleHints, containerLayoutOrientation = props.containerLayoutOrientation;
    var isInline = layoutOrientation === "inline";
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.div, elementId);
    var wrapGroupedElements = function (elementFactory, innerJSX) {
        var textgroupElementProps = {
            children: children,
            additionalClassName: classnames(getTagClassNames(tags)),
            elementId: elementId,
            ariaLabelledBy: ariaLabelledBy,
            styleHints: styleHints,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.textgroup, textgroupElementProps, {})) {
            return elementFactory.create(exports.ElementType.textgroup, textgroupElementProps);
        }
        else if ((elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
            return (React.createElement(React.Fragment, null, innerJSX));
        }
        return (React.createElement("div", { id: id, className: classnames({ "d-inline-block": isInline }, getTagClassNames(tags)) }, innerJSX));
    };
    return (React.createElement(RenderContext.Consumer, null, function (_a) {
        var elementFactory = _a.elementFactory;
        return wrapGroupedElements(elementFactory, (React.createElement(React.Fragment, null,
            children,
            React.createElement(GroupError, { elementId: elementId, isInline: true }))));
    }));
};
var TextGroup = TextGroupElementWrapper(TextGroupInner, ["elementId", "layoutOrientation", "tags", "styleHints", "containerLayoutOrientation"]);
TextGroup.displayName = "TextGroup";

var CaptchaInner = /** @class */ (function (_super) {
    __extends$1(CaptchaInner, _super);
    function CaptchaInner(props) {
        var _this = _super.call(this, props) || this;
        if (props.eventHub) {
            var elementId = props.elementId;
            var getDivId = htmlAttributesHelper$1.getDivId;
            var id = getDivId(elementId);
            props.eventHub.captchaRendered(id);
        }
        return _this;
    }
    CaptchaInner.prototype.render = function () {
        var _a = this.props, elementId = _a.elementId, audioChildNodes = _a.audioChildNodes, imageChildNodes = _a.imageChildNodes, tags = _a.tags, element = _a.element, required = _a.required;
        var displayId = element.displayId, type = element.type, id = element.id, displayName = element.displayName, showDisplayName = element.showDisplayName, accessibilityName = element.accessibilityName;
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            return React.createElement(PropertyState.Consumer, null, function (state) {
                var elementFactory = renderContext.elementFactory;
                var getDivId = htmlAttributesHelper$1.getDivId;
                var showImageCaptcha = state.values[id] == "image" ? true : false;
                var captchaElementId = getDivId(elementId);
                var captchaElementProps = {
                    audioChildNodes: audioChildNodes,
                    imageChildNodes: imageChildNodes,
                    elementId: captchaElementId,
                    captchaClassName: getTagClassNames(tags),
                    displayId: displayId,
                    type: type,
                    showImageCaptcha: showImageCaptcha,
                    displayName: displayName,
                    showDisplayName: showDisplayName,
                    required: required
                };
                if (elementFactory && elementFactory.canCreate(exports.ElementType.captcha, captchaElementProps, {})) {
                    return elementFactory.create(exports.ElementType.captcha, captchaElementProps);
                }
                else {
                    var labelNode = React.createElement("label", { className: classnames("pidlddc-label", !showDisplayName ? "d-none" : "d-block"), id: elementId, "aria-label": accessibilityName }, displayName);
                    captchaElementProps.captchaClassName = captchaElementProps.captchaClassName.filter(function (className) { return !typehelper.startsWith(className, knownTagPrefixes.pidlReact); });
                    return React.createElement("div", { id: captchaElementProps.elementId, className: classnames(captchaElementProps.captchaClassName) },
                        labelNode,
                        showImageCaptcha && imageChildNodes,
                        !showImageCaptcha && audioChildNodes);
                }
            });
        }));
    };
    return CaptchaInner;
}(React.Component));
var Captcha = CaptchaElementWrapper(CaptchaInner, ["elementId", "tags", "required"]);
Captcha.displayName = "Captcha";

var GroupLabelInner = function (_a) {
    var element = _a.element, elementId = _a.elementId, hidden = _a.hidden, required = _a.required, disabled = _a.disabled, showDisplayName = _a.showDisplayName, displayName = _a.displayName, accessibilityName = _a.accessibilityName;
    return showDisplayName ? (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings;
        var getId = htmlAttributesHelper$1.getId;
        var constants$1 = constants;
        var id = getId(constants$1.htmlElementIdPrefixes.label, elementId);
        var labelProps = {
            disabled: disabled,
            required: required,
            elementId: id,
            displayContent: displayName
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.label, labelProps, {})) {
            return elementFactory.create(exports.ElementType.label, labelProps);
        }
        for (var i = 0; i < element.children.length; i++) {
            if (element.children[i].dataDescription != null && !element.children[i].dataDescription.is_optional) {
                labelProps.required = true;
                break;
            }
        }
        return React.createElement("label", { 
            // TODO: Get className with helper function
            className: classnames("pidlddc-label", hidden || !showDisplayName ? "d-none" : "d-block"), id: labelProps.elementId, "aria-label": accessibilityName },
            displayName,
            React.createElement("span", { className: "".concat(labelProps.elementId, "-asterisk") }, labelProps.required ? "*" : ""));
    })) : null;
};
GroupLabelInner.displayName = "GroupLabelInner";
var GroupLabel = GroupElementWrapper(GroupLabelInner, ["elementId", "hidden", "displayName", "showDisplayName", "accessibilityName"]);
GroupLabel.displayName = "GroupLabel";

var HelpDialogInner = /** @class */ (function (_super) {
    __extends$1(HelpDialogInner, _super);
    function HelpDialogInner(props) {
        var _this = _super.call(this, props) || this;
        _this.linkRef = React.createRef();
        _this.toggle = function (newState) {
            if (!newState && _this.linkRef && _this.linkRef.current && _this.linkRef.current.focus) {
                _this.linkRef.current.focus();
            }
            _this.setState({ open: newState });
        };
        _this.escapeHandler = function (ev) {
            if (ev.keyCode === 27) {
                _this.toggle(false);
            }
        };
        _this.state = { open: false };
        return _this;
    }
    HelpDialogInner.prototype.componentDidUpdate = function () {
        var _a;
        var _b = this.props, elementId = _b.elementId, elementFactory = _b.elementFactory;
        var open = this.state.open;
        if (!((_a = elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) === null || _a === void 0 ? void 0 : _a.call(elementFactory))) {
            var modalBody = document.getElementById("".concat(elementId, "-dialog-body"));
            if (open) {
                document.addEventListener("keydown", this.escapeHandler, false);
                if (modalBody && modalBody.focus) {
                    modalBody.focus();
                }
            }
            else {
                document.removeEventListener("keydown", this.escapeHandler, false);
            }
        }
    };
    HelpDialogInner.prototype.render = function () {
        var _this = this;
        var _a = this.props, elementId = _a.elementId, displayHelpName = _a.displayHelpName, displayImage = _a.displayImage, children = _a.children, element = _a.element;
        var open = this.state.open;
        if ((!displayHelpName || displayHelpName.length === 0) && !displayImage) {
            return null;
        }
        var tags = element.getHelpDialogTags();
        var accessibilityName = tags && tags[helpDialogPrefixedTags.linkAccessibilityName] || element.accessibilityName;
        var closeButtonAccessibilityName = tags && tags[helpDialogPrefixedTags.closeButtonAccessibilityName] || "";
        var id = "".concat(displayImage ? htmlElementIdPrefixes.image : htmlElementIdPrefixes.button).concat(elementId);
        var linkAdditionalClassName = displayImage ? htmlClassNames.helpImageLink : htmlClassNames.helpTextLink;
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings;
            if (!HelpDialogInner.elementIdHelpDialogIndex[elementId]) {
                HelpDialogInner.elementIdHelpDialogIndex[elementId] = HelpDialogInner.latestHelpDialogIndex;
                HelpDialogInner.latestHelpDialogIndex++;
            }
            var helpDialogIndexText = HelpDialogInner.elementIdHelpDialogIndex[elementId] === 0 ? "" : HelpDialogInner.elementIdHelpDialogIndex[elementId];
            var contentId = displaySettings ? displaySettings.getAffixedDisplayElementId(htmlElementIdPrefixes.helpDialogContent + displaySettings.helpDialogBlock.id + helpDialogIndexText) : elementId;
            var modalProps = {
                id: id,
                children: children,
                linkAdditionalClassName: linkAdditionalClassName,
                linkText: displayHelpName,
                linkImageSource: displayImage,
                linkAriaLabel: accessibilityName,
                contentId: contentId,
                closeButtonAccessibilityName: closeButtonAccessibilityName
            };
            if (elementFactory && elementFactory.canCreate(exports.ElementType.helpDialog, modalProps, {})) {
                return elementFactory.create(exports.ElementType.helpDialog, modalProps);
            }
            return ([
                React.createElement("a", { key: "".concat(id, "-toggle"), id: id, className: linkAdditionalClassName, "aria-label": accessibilityName, "aria-haspopup": "dialog", onClick: function () { return _this.toggle(true); }, href: "javascript:void(null);", ref: _this.linkRef }, (displayImage ? React.createElement("img", { src: displayImage, alt: accessibilityName }) : displayHelpName)),
                //TODO: Implement without using <dialog> because EdgeBrowser (without Chromium), IE and Safari do not support it and in Firefox users have to enable the feature first.
                React.createElement("dialog", { key: "".concat(elementId, "-dialog-body"), id: "".concat(elementId, "-dialog-body"), tabIndex: -1, onBlur: function () { return _this.toggle(false); }, open: open },
                    React.createElement("div", { key: "".concat(elementId, "-dialog-close-button"), id: "".concat(elementId, "-dialog-close-button"), style: { textAlign: "right", width: "100%", paddingBottom: "6px" } },
                        React.createElement("button", { "aria-label": closeButtonAccessibilityName, onClick: function () { return _this.toggle(false); } },
                            React.createElement("span", { "aria-hidden": "true" }, "x"))),
                    children)
            ]);
        }));
    };
    HelpDialogInner.elementIdHelpDialogIndex = {};
    HelpDialogInner.latestHelpDialogIndex = 0;
    return HelpDialogInner;
}(React.Component));
var HelpDialog = PropertyElementWrapper(HelpDialogInner, ["elementId", "displayHelp", "displayHelpName", "displayImage"]);
HelpDialog.displayName = "HelpDialog";

var HyperlinkInner = function (props) {
    var _a;
    var elementId = props.elementId, pidlAction = props.pidlAction, displayContent = props.displayContent, accessibilityName = props.accessibilityName, tags = props.tags, onClick = props.onClick, styleHints = props.styleHints, gridColumn = props.gridColumn, gridRow = props.gridRow, containerLayoutOrientation = props.containerLayoutOrientation;
    var url = "javascript:void(null);";
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.hyperlink, elementId);
    var additionalClassName = classnames(getTagClassNames(tags));
    var noUrl = (_a = getPidlReactCustomProps(tags)) === null || _a === void 0 ? void 0 : _a.includes("noUrl");
    var clickHandler = function () {
        if (onClick) {
            onClick({ pidlAction: pidlAction, id: elementId });
        }
    };
    var internalClickHandler = function (e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (onClick) {
            onClick({ pidlAction: pidlAction, id: elementId });
        }
    };
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings, theme = renderContext.theme;
        var hyperlinkProps = {
            id: id,
            displayContent: displayContent,
            additionalClassName: additionalClassName,
            href: pidlAction && pidlAction.context && !noUrl ? pidlAction.context : url,
            ariaLabel: accessibilityName,
            onClick: clickHandler,
            theme: theme,
            styleHints: styleHints,
            gridColumn: gridColumn,
            gridRow: gridRow,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.hyperlink, hyperlinkProps, {})) {
            return elementFactory.create(exports.ElementType.hyperlink, hyperlinkProps);
        }
        return (React.createElement("a", { id: id, href: pidlAction && pidlAction.context ? pidlAction.context : url, "aria-label": accessibilityName, className: additionalClassName, onClick: internalClickHandler }, displayContent));
    }));
};
var Hyperlink = TextDisplayElementWrapper(HyperlinkInner, ["elementId", "pidlAction", "displayContent", "accessibilityName", "tags", "styleHints", "containerLayoutOrientation"]);
Hyperlink.displayName = "Hyperlink";

var DefaultIFrameElement = /** @class */ (function (_super) {
    __extends$1(DefaultIFrameElement, _super);
    function DefaultIFrameElement(props) {
        var _this = _super.call(this, props) || this;
        _this.onEvent = function (event) {
            var _a = _this.props, sourceUrl = _a.sourceUrl, expectedClientActionId = _a.expectedClientActionId, onIFrameMessage = _a.onIFrameMessage, onIFrameBusyTimerEnded = _a.onIFrameBusyTimerEnded;
            var messageTimer = _this.state.messageTimer;
            if (sourceUrl && event.origin && sourceUrl.indexOf(event.origin) !== 0) {
                return;
            }
            var parsedJson = utils.parseJSON(event.data);
            var clientAction = parsedJson.succeeded ? parsedJson.value : null;
            if (clientAction && expectedClientActionId && clientAction.actionId !== expectedClientActionId) {
                // The postMessage was not intended for this iframe.
                return;
            }
            // Clear timeout handler timer
            if (messageTimer) {
                onIFrameBusyTimerEnded(messageTimer);
                clearTimeout(messageTimer);
                _this.setState({ messageTimer: null });
            }
            onIFrameMessage(event);
        };
        _this.iframe = React.createRef();
        _this.state = {
            executing: true,
            width: props.element.width,
            height: props.element.height,
        };
        return _this;
    }
    DefaultIFrameElement.prototype.postMessage = function (params) {
        if (this.iframe &&
            this.iframe.current &&
            this.iframe.current.contentWindow &&
            this.iframe.current.contentWindow.postMessage) {
            this.iframe.current.contentWindow.postMessage(params.message, params.targetOrigin);
            return true;
        }
        return false;
    };
    DefaultIFrameElement.prototype.updateHeight = function (height) {
        this.setState({ height: height });
    };
    DefaultIFrameElement.prototype.componentDidMount = function () {
        var _a = this.props, displayContent = _a.displayContent, sourceUrl = _a.sourceUrl, onIFrameMessageTimeout = _a.onIFrameMessageTimeout, messageTimeout = _a.messageTimeout, messageTimeoutClientAction = _a.messageTimeoutClientAction, onIFrameBusyTimerStarted = _a.onIFrameBusyTimerStarted, onIFrameBusyTimerEnded = _a.onIFrameBusyTimerEnded;
        var current = this.iframe.current;
        var messageTimer = this.state.messageTimer;
        window.addEventListener(eventTypes.message, this.onEvent);
        if (!sourceUrl && displayContent && current) {
            var innerDocument = current.contentDocument;
            if (innerDocument) {
                innerDocument.open();
                innerDocument.write(displayContent);
                innerDocument.close();
            }
        }
        if (!messageTimer && messageTimeout && messageTimeoutClientAction) {
            var messageTimer_1 = window.setTimeout(function () {
                onIFrameMessageTimeout(messageTimeoutClientAction);
                onIFrameBusyTimerEnded(messageTimer_1);
            }, messageTimeout);
            onIFrameBusyTimerStarted(messageTimer_1);
            this.setState({ messageTimer: messageTimer_1 });
        }
    };
    DefaultIFrameElement.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.props, displayContent = _a.displayContent, sourceUrl = _a.sourceUrl;
        var current = this.iframe.current;
        if (!sourceUrl && displayContent && prevProps && prevProps.displayContent !== displayContent && current) {
            var innerDocument = current.contentDocument;
            if (innerDocument) {
                innerDocument.open();
                innerDocument.write(displayContent);
                innerDocument.close();
            }
        }
    };
    DefaultIFrameElement.prototype.componentWillUnmount = function () {
        window.removeEventListener(eventTypes.message, this.onEvent);
    };
    DefaultIFrameElement.prototype.render = function () {
        var _a = this.props, displayId = _a.displayId, accessibilityName = _a.accessibilityName, hidden = _a.hidden, tags = _a.tags, sourceUrl = _a.sourceUrl, containerLayoutOrientation = _a.containerLayoutOrientation;
        var _b = this.state, width = _b.width, height = _b.height;
        var iframeStyle = { width: width, height: height };
        var getId = htmlAttributesHelper$1.getId;
        var constants$1 = constants;
        var id = getId(constants$1.htmlElementIdPrefixes.iframe, displayId);
        // Removes all non-digits (e.g. "px", "%") from width and height and determines if either width or height are larger than 0.
        // We only want to hide the border for iframes size 0. For > 0 we don't specify a border and let partner's CSS style it.
        var iframeBorder = (width || height) && Number((width + height).replace(/\D/g, "")) === 0 ? 0 : undefined;
        return this.state.executing ? (React.createElement("iframe", { key: id, className: classnames(getTagClassNames(tags)), id: id, src: sourceUrl, hidden: hidden, "aria-label": accessibilityName, ref: this.iframe, style: iframeStyle, frameBorder: iframeBorder })) : null;
    };
    return DefaultIFrameElement;
}(React.Component));
var IFrameElementInner = function (props) {
    var formatHeader = function (displayId, authToken) {
        var _a, _b;
        switch (displayId) {
            case "xboxCoBrandedCardIframe":
                try {
                    return {
                        xuh: (_a = authToken.split('=')[1]) === null || _a === void 0 ? void 0 : _a.split(';')[0],
                        xt: (_b = authToken.split('=')[1]) === null || _b === void 0 ? void 0 : _b.split(';')[1]
                    };
                }
                catch (_c) {
                    return {
                        authorization: authToken
                    };
                }
            default:
                return {
                    authorization: authToken
                };
        }
    };
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, userContext = renderContext.userContext, displayOptions = renderContext.displayOptions;
        var displayId = props.displayId, useAuth = props.useAuth, containerLayoutOrientation = props.containerLayoutOrientation;
        var headers = {};
        if (useAuth && (userContext === null || userContext === void 0 ? void 0 : userContext.authToken) != null) {
            headers = formatHeader(displayId, userContext.authToken);
        }
        var extendedProps = __assign$1(__assign$1({}, props), { headers: headers, useWebView2: displayOptions.useWebView2 || false, containerLayoutOrientation: containerLayoutOrientation });
        if (elementFactory && elementFactory.canCreate(exports.ElementType.iframe, extendedProps, {})) {
            return elementFactory.create(exports.ElementType.iframe, extendedProps);
        }
        return React.createElement(DefaultIFrameElement, __assign$1({}, extendedProps, { ref: extendedProps.iFrameElementRef }));
    }));
};
var IFrameElement$1 = IFrameElementWrapper(IFrameElementInner, ["displayId", "accessibilityName", "hidden", "tags", "displayContent", "sourceUrl", "expectedClientActionId", "messageTimeout", "messageTimeoutClientAction", "useAuth", "loadingMessage", "containerLayoutOrientation"]);

var ImageInner = function (props) {
    var accessibilityName = props.accessibilityName, element = props.element, elementId = props.elementId, sourceUrl = props.sourceUrl, codepoint = props.codepoint, tags = props.tags, styleHints = props.styleHints, gridColumn = props.gridColumn, gridRow = props.gridRow, containerLayoutOrientation = props.containerLayoutOrientation;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var _a;
        var elementFactory = renderContext.elementFactory;
        var imageProps = {
            additionalClassName: classnames(getTagClassNames(tags)),
            ariaLabel: accessibilityName || ((_a = element === null || element === void 0 ? void 0 : element.displayDescription) === null || _a === void 0 ? void 0 : _a.accessibilityName),
            elementId: getId(constants$1.htmlElementIdPrefixes.image, elementId),
            sourceUrl: sourceUrl,
            codepoint: codepoint,
            styleHints: styleHints,
            gridColumn: gridColumn,
            gridRow: gridRow,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.image, imageProps, {})) {
            return elementFactory.create(exports.ElementType.image, imageProps);
        }
        else {
            return React.createElement("img", { id: imageProps.elementId, src: sourceUrl, alt: accessibilityName, "aria-label": accessibilityName, className: imageProps.additionalClassName });
        }
    }));
};
var Image = ImageElementWrapper(ImageInner, ["elementId", "accessibilityName", "sourceUrl", "codepoint", "tags", "styleHints", "containerLayoutOrientation"]);
Image.displayName = "Image";
var LogoElementInner = function (props) {
    var displayId = props.displayId, sourceUrl = props.sourceUrl, tags = props.tags, styleHints = props.styleHints, gridColumn = props.gridColumn, gridRow = props.gridRow, containerLayoutOrientation = props.containerLayoutOrientation;
    var accessibilityName = tags && tags.accessibilityName ? tags.accessibilityName : undefined;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    return React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory;
        var logoProps = {
            additionalClassName: classnames(getTagClassNames(tags)),
            ariaLabel: accessibilityName,
            elementId: getId(constants$1.htmlElementIdPrefixes.image, displayId),
            sourceUrl: sourceUrl,
            styleHints: styleHints,
            gridColumn: gridColumn,
            gridRow: gridRow,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.logo, logoProps, {})) {
            return elementFactory.create(exports.ElementType.logo, logoProps);
        }
        else {
            return React.createElement("img", { className: classnames("pidlddc-logo-image", "pidlddc-logoBlock", logoProps.additionalClassName), id: logoProps.elementId, src: sourceUrl, alt: accessibilityName, "aria-label": accessibilityName, style: { width: "48px", height: "48px" } });
        }
    });
};
var LogoElement$1 = LogoDisplayElementWrapper(LogoElementInner, ["displayId", "sourceUrl", "tags", "styleHints", "containerLayoutOrientation"]);
LogoElement$1.displayName = "LogoElement";

var PropertyLabelInner = function (props) {
    var elementId = props.elementId, hidden = props.hidden, showDisplayName = props.showDisplayName, displayName = props.displayName, accessibilityName = props.accessibilityName, element = props.element;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.label, elementId);
    return (React.createElement(PropertyState.Consumer, null, function (state) {
        return (React.createElement("label", { 
            // TODO: Get className with helper function
            className: classnames("pidlddc-label", { "d-none": hidden || !showDisplayName }), id: id, "aria-label": state.accessibilityText[element.getPropertyName()] || accessibilityName },
            displayName,
            React.createElement("span", { className: "".concat(id, "-asterisk") }, element.dataDescription.is_optional ? "" : "*")));
    }));
};
var PropertyLabel = PropertyElementWrapper(PropertyLabelInner, ["elementId", "propertyName", "hidden", "displayName", "showDisplayName", "accessibilityName"]);
PropertyLabel.displayName = "PropertyLabel";

var RadioInner = /** @class */ (function (_super) {
    __extends$1(RadioInner, _super);
    function RadioInner(props) {
        return _super.call(this, props) || this;
    }
    RadioInner.prototype.render = function () {
        var _a = this.props, element = _a.element, elementId = _a.elementId, possibleOptions = _a.possibleOptions, accessibilityName = _a.accessibilityName, displayName = _a.displayName, showDisplayName = _a.showDisplayName, propertyName = _a.propertyName, disabled = _a.disabled, required = _a.required, hidden = _a.hidden, onSelect = _a.onSelect, tags = _a.tags, optionsElements = _a.optionsElements, styleHints = _a.styleHints;
        var options = [];
        for (var key in possibleOptions) {
            if (possibleOptions.hasOwnProperty(key)) {
                options.push({
                    key: key,
                    value: possibleOptions[key].key || key,
                    isDisabled: possibleOptions[key].isDisabled,
                    displayText: possibleOptions[key].displayText,
                    displayImageUrl: possibleOptions[key].displayImageUrl,
                });
            }
        }
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            return React.createElement(IsInline.Consumer, null, function (isInline) {
                return React.createElement(PropertyState.Consumer, null, function (state) {
                    var _a;
                    var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings, theme = renderContext.theme;
                    var getId = htmlAttributesHelper$1.getId;
                    var constants$1 = constants;
                    var id = getId(constants$1.htmlElementIdPrefixes.div, elementId);
                    var radioProps = {
                        elementId: elementId,
                        isInline: isInline,
                        hidden: hidden,
                        options: options,
                        optionsElements: optionsElements,
                        ariaLabel: state.accessibilityText[propertyName] || accessibilityName,
                        showDisplayName: showDisplayName,
                        displayName: displayName || element.displayName,
                        additionalClassName: classnames(getTagClassNames(tags)),
                        onSelect: onSelect,
                        disabled: disabled,
                        propertyName: propertyName,
                        required: required,
                        invalid: false,
                        selectedValue: state.values[propertyName] && state.values[propertyName].toString(),
                        propertyElementRef: element.propertyElementRef,
                        theme: theme,
                        styleHints: styleHints
                    };
                    var capabilities = elementFactory && elementFactory.canCreate(exports.ElementType.radio, radioProps, {});
                    if (capabilities) {
                        if ((_a = elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) === null || _a === void 0 ? void 0 : _a.call(elementFactory)) {
                            return elementFactory.create(exports.ElementType.radio, radioProps);
                        }
                        return React.createElement("div", { id: id, className: classnames(id, getId(constants$1.htmlElementIdPrefixes.div, element.displayId)) },
                            elementFactory.create(exports.ElementType.radio, radioProps),
                            (!capabilities || !capabilities.inlineError) ? React.createElement(Error$1, { propertyName: propertyName }) : null);
                    }
                    else {
                        return React.createElement("div", { className: classnames("pidlddc-input-".concat(elementId)) },
                            options.map(function (option) {
                                var optionId = "input_".concat(elementId, "_").concat(option.value);
                                var displayTextLabelId = "".concat(optionId, "_displayTextLabel");
                                return React.createElement("div", { key: optionId },
                                    React.createElement("label", { id: "".concat(optionId, "_displayNameLabel"), "aria-label": radioProps.ariaLabel, className: classnames({ "pidlddc-hidden": !showDisplayName }), "aria-hidden": !showDisplayName }, displayName),
                                    React.createElement("div", { className: classnames(getTagClassNames(tags)) },
                                        React.createElement("label", { id: displayTextLabelId, htmlFor: optionId, "aria-label": option.displayText, onClick: function () { return (option.isDisabled || disabled) ? null : onSelect(option.value); } },
                                            React.createElement("input", { id: optionId, type: "radio", name: "radio-input-".concat(propertyName), disabled: option.isDisabled || disabled, required: required, "aria-labelledby": displayTextLabelId, value: option.value, onChange: function () { return onSelect(option.value); }, checked: radioProps.selectedValue === option.value }),
                                            optionsElements && optionsElements[option.value] ? optionsElements[option.value] : option.displayText)));
                            }),
                            React.createElement(Error$1, { propertyName: propertyName }));
                    }
                });
            });
        }));
    };
    return RadioInner;
}(React.Component));
var Radio = RadioElementWrapper(RadioInner, ["elementId", "propertyName", "possibleOptions", "required", "hidden", "disabled", "showDisplayName", "accessibilityName", "tags", "styleHints"]);
Radio.displayName = "Radio";

var HeadingInner = function (props) {
    var elementId = props.elementId, displayContent = props.displayContent, tags = props.tags, styleHints = props.styleHints, containerLayoutOrientation = props.containerLayoutOrientation;
    var additionalClassName = classnames(getTagClassNames(tags));
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.text, elementId);
    var ishidden = props.element.isHidden;
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings, theme = renderContext.theme;
        var textProps = {
            id: id,
            elementId: id,
            displayContent: displayContent,
            additionalClassName: additionalClassName,
            theme: theme,
            styleHints: styleHints,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (ishidden) {
            return null;
        }
        if (elementFactory && elementFactory.canCreate(exports.ElementType.heading, textProps, {})) {
            return elementFactory.create(exports.ElementType.heading, textProps);
        }
        return React.createElement("h2", { id: id, className: additionalClassName }, displayContent);
    }));
};
var Heading = TextDisplayElementWrapper(HeadingInner, ["elementId", "displayContent", "tags", "styleHints", "containerLayoutOrientation"]);
Heading.displayName = "Heading";
var SubHeadingInner = function (props) {
    var elementId = props.elementId, displayContent = props.displayContent, tags = props.tags, styleHints = props.styleHints, containerLayoutOrientation = props.containerLayoutOrientation;
    var additionalClassName = classnames(getTagClassNames(tags));
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.text, elementId);
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings, theme = renderContext.theme;
        var textProps = {
            id: id,
            elementId: id,
            displayContent: displayContent,
            additionalClassName: additionalClassName,
            theme: theme,
            styleHints: styleHints,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.subheading, textProps, {})) {
            return elementFactory.create(exports.ElementType.subheading, textProps);
        }
        return React.createElement("h3", { id: id, className: additionalClassName }, displayContent);
    }));
};
var SubHeading = TextDisplayElementWrapper(SubHeadingInner, ["elementId", "displayContent", "tags", "styleHints", "containerLayoutOrientation"]);
SubHeading.displayName = "SubHeading";
var TextInner = function (props) {
    var elementId = props.elementId, displayContent = props.displayContent, tags = props.tags, styleHints = props.styleHints, gridColumn = props.gridColumn, gridRow = props.gridRow, hidden = props.hidden, containerLayoutOrientation = props.containerLayoutOrientation, accessibilityName = props.accessibilityName;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.text, elementId);
    var customProps = getPidlReactCustomProps(tags);
    var additionalClassName = classnames(getTagClassNames(tags));
    var style = hidden ? { display: "none" } : undefined;
    return (React.createElement(IsInline.Consumer, null, function (isInline) {
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, displaySettings = renderContext.displaySettings, theme = renderContext.theme;
            var textProps = {
                id: id,
                displayContent: displayContent,
                additionalClassName: additionalClassName,
                inline: isInline,
                theme: theme,
                hidden: hidden,
                styleHints: styleHints,
                gridColumn: gridColumn,
                gridRow: gridRow,
                containerLayoutOrientation: containerLayoutOrientation,
                accessibilityName: accessibilityName
            };
            if (elementFactory) {
                if (hidden && (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
                    return undefined;
                }
                var labelProps = {
                    displayContent: displayContent,
                    elementId: id,
                    theme: theme,
                };
                if (customProps.indexOf("labelText") >= 0 && elementFactory.canCreate(exports.ElementType.label, textProps, {})) {
                    return elementFactory.create(exports.ElementType.label, labelProps);
                }
                else if (elementFactory.canCreate(exports.ElementType.text, textProps, {})) {
                    return elementFactory.create(exports.ElementType.text, textProps);
                }
            }
            return isInline ? (React.createElement("span", { id: id, className: additionalClassName, style: style }, displayContent)) : (React.createElement("p", { id: id, className: additionalClassName, style: style }, displayContent));
        }));
    }));
};
var Text = TextDisplayElementWrapper(TextInner, ["elementId", "displayContent", "tags", "styleHints", "hidden", "containerLayoutOrientation", "accessibilityName"]);
Text.displayName = "Text";

var NativeTextBox = /** @class */ (function (_super) {
    __extends$1(NativeTextBox, _super);
    function NativeTextBox(props) {
        var _this = _super.call(this, props) || this;
        _this.getTransformedLength = function (displayTransformations, value, pos) {
            var precedingValue = value.substr(0, pos);
            var transformedPrecedingValue = utils.applyDisplayTransformation(displayTransformations.forModel, precedingValue);
            transformedPrecedingValue = utils.applyDisplayTransformation(displayTransformations.forFormat, transformedPrecedingValue);
            return transformedPrecedingValue.length;
        };
        _this.onFocus = function (event) {
            var onFocus = _this.props.onFocus;
            if (onFocus && event && event.currentTarget) {
                onFocus(event.currentTarget.value);
            }
        };
        _this.onBlur = function (event) {
            var onBlur = _this.props.onBlur;
            if (onBlur && event && event.currentTarget) {
                onBlur(event.currentTarget.value);
            }
        };
        _this.onChange = function (event) {
            var _a = _this.props, element = _a.element, onChange = _a.onChange, id = _a.id;
            var displayTransformations = element.displayTransformations;
            NativeTextBox.caretPosition = {
                id: id,
                start: event.currentTarget.selectionStart,
                end: event.currentTarget.selectionEnd,
                direction: event.currentTarget.selectionDirection === "forward" ? "forward" : event.currentTarget.selectionDirection === "backward" ? "backward" : "none",
            };
            var currentValue = event.currentTarget.value;
            if (displayTransformations && displayTransformations.forModel && displayTransformations.forFormat) {
                NativeTextBox.caretPosition.start = _this.getTransformedLength(displayTransformations, currentValue, NativeTextBox.caretPosition.start);
                NativeTextBox.caretPosition.end = _this.getTransformedLength(displayTransformations, currentValue, NativeTextBox.caretPosition.end);
            }
            if (onChange) {
                var value = event.currentTarget.value;
                if (displayTransformations && displayTransformations.forModel) {
                    value = utils.applyDisplayTransformation(displayTransformations.forModel, value);
                }
                onChange(value);
            }
        };
        _this.onCompositionStart = function (event) {
            _this.inComposition = true;
        };
        _this.onCompositionEnd = function (event) {
            _this.inComposition = false;
        };
        _this.htmlInput = React.createRef();
        _this.inComposition = false;
        return _this;
    }
    NativeTextBox.prototype.componentDidUpdate = function () {
        var id = this.props.id;
        if (id === NativeTextBox.caretPosition.id) {
            this.htmlInput.current.setSelectionRange(NativeTextBox.caretPosition.start, NativeTextBox.caretPosition.end, NativeTextBox.caretPosition.direction);
        }
    };
    NativeTextBox.prototype.render = function () {
        var _a = this.props, element = _a.element, additionalClassName = _a.additionalClassName, id = _a.id, maskInput = _a.maskInput, maxLength = _a.maxLength, required = _a.required, hidden = _a.hidden, disabled = _a.disabled, placeholder = _a.placeholder, ariaLabelId = _a.ariaLabelId, inlineError = _a.inlineError, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, isInValidationErrorGroup = _a.isInValidationErrorGroup, styleHints = _a.styleHints;
        var value = this.props.value;
        var displayTransformations = element.displayTransformations;
        var showErrorStyle = inlineError || (isInValidationErrorGroup && !disabled);
        if (!this.inComposition && displayTransformations && displayTransformations.forFormat) {
            value = utils.applyDisplayTransformation(displayTransformations.forFormat, value);
        }
        return (React.createElement("input", { type: maskInput ? "password" : "text", className: showErrorStyle ? classnames(additionalClassName, "pidlddc-errorstroke") : additionalClassName, id: id, ref: this.htmlInput, maxLength: maxLength, required: required, hidden: hidden, disabled: disabled, value: value, placeholder: placeholder, "aria-labelledby": ariaLabelId, onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onChange, onCompositionStart: this.onCompositionStart, onCompositionEnd: this.onCompositionEnd }));
    };
    NativeTextBox.caretPosition = {
        id: null,
        start: 0,
        end: 0,
        direction: "none",
    };
    return NativeTextBox;
}(React.Component));
var TextBoxInner = /** @class */ (function (_super) {
    __extends$1(TextBoxInner, _super);
    function TextBoxInner(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (value) {
            var _a = _this.props, onUpdateValue = _a.onUpdateValue, propertyName = _a.propertyName;
            onUpdateValue(propertyName, value, controlOperationTypes.editing);
        };
        _this.onBlur = function (value) {
            var _a = _this.props, onUpdateValue = _a.onUpdateValue, propertyName = _a.propertyName;
            onUpdateValue(propertyName, value, controlOperationTypes.finished);
        };
        _this.onSelected = function (id, propertyName, divId) {
            var eventHandler = _this.props.eventHandler;
            eventHandler.propertySelectedHandler({ id: id, propertyName: propertyName, divId: divId });
        };
        _this.onUnselected = function (id, propertyName, divId) {
            var eventHandler = _this.props.eventHandler;
            eventHandler.propertyUnselectedHandler({ id: id, propertyName: propertyName, divId: divId });
        };
        _this.onFocusInternal = function (value) {
            var _a = _this.props, elementId = _a.elementId, propertyName = _a.propertyName, displayOptions = _a.displayOptions, onFocus = _a.onFocus;
            var _b = htmlAttributesHelper$1, getDivId = _b.getDivId, getId = _b.getId;
            var divId = getDivId(elementId);
            var inputId = getId(displayOptions.inputPropertyIdPrefix, propertyName);
            if (_this.onSelected) {
                _this.onSelected(inputId, propertyName, divId);
            }
            if (onFocus) {
                onFocus(value);
            }
        };
        _this.onBlurInternal = function (value) {
            var _a = _this.props, elementId = _a.elementId, propertyName = _a.propertyName, displayOptions = _a.displayOptions;
            var _b = htmlAttributesHelper$1, getDivId = _b.getDivId, getId = _b.getId;
            var divId = getDivId(elementId);
            var inputId = getId(displayOptions.inputPropertyIdPrefix, propertyName);
            if (_this.onUnselected) {
                _this.onUnselected(inputId, propertyName, divId);
            }
            if (_this.onBlur) {
                _this.onBlur(value);
            }
        };
        return _this;
    }
    TextBoxInner.prototype.render = function () {
        var _this = this;
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            return React.createElement(PropertyState.Consumer, null, function (state) {
                var elementFactory = renderContext.elementFactory, displayOptions = renderContext.displayOptions, theme = renderContext.theme;
                var _a = _this.props, elementId = _a.elementId, element = _a.element, required = _a.required, disabled = _a.disabled, hidden = _a.hidden, propertyName = _a.propertyName, maxLength = _a.maxLength, displayHelpName = _a.displayHelpName, displayImage = _a.displayImage, _b = _a.tags, tags = _b === void 0 ? {} : _b, placeHolderText = _a.placeHolderText, showKeyLogo = _a.showKeyLogo, resolvedLogo = _a.resolvedLogo, displayHelpChildren = _a.displayHelpChildren, onFocus = _a.onFocus, displayId = _a.displayId, accessibilityName = _a.accessibilityName, accessibilityHint = _a.accessibilityHint, styleHints = _a.styleHints, containerLayoutOrientation = _a.containerLayoutOrientation;
                var displayName = element.displayName, showDisplayName = element.showDisplayName, displayDescription = element.displayDescription, propertyElementRef = element.propertyElementRef;
                var constants$1 = constants;
                var _c = htmlAttributesHelper$1, getDivId = _c.getDivId, getId = _c.getId, generateClassName = _c.generateClassName, concatClassName = _c.concatClassName;
                var divId = getDivId(elementId);
                var inputId = getId(displayOptions.inputPropertyIdPrefix, propertyName);
                var capabilities = { inlineError: true };
                var inlineError = state.errors[propertyName] ? state.errors[propertyName].message : undefined;
                var isInValidationErrorGroup = state.errors[propertyName] ? true : false;
                var label = showDisplayName ? React.createElement(PropertyLabel, { element: element }) : null;
                var helpDialogElementProps = {
                    id: elementId,
                };
                var inlineHelpLink = (displayHelpName || displayImage) ? React.createElement(HelpDialog, __assign$1({}, helpDialogElementProps, { element: element, children: displayHelpChildren, elementFactory: elementFactory })) : null;
                var textBoxProps = {
                    disabled: disabled,
                    displayName: displayName,
                    hidden: hidden,
                    inlineError: inlineError,
                    isInValidationErrorGroup: isInValidationErrorGroup,
                    maskInput: displayDescription && displayDescription.maskInput,
                    maxLength: maxLength,
                    onBlur: _this.onBlurInternal,
                    onChange: _this.onChange,
                    onFocus: _this.onFocusInternal,
                    required: required,
                    showDisplayName: showDisplayName,
                    inlineHelpLink: inlineHelpLink,
                    additionalClassName: classnames(getTagClassNames(tags)),
                    ariaLabelId: "pidlddc-label-".concat(propertyName, " pidlddc-error-").concat(propertyName),
                    id: inputId,
                    inlineLogo: showKeyLogo && resolvedLogo,
                    placeholder: placeHolderText,
                    value: (state.values[propertyName] && state.values[propertyName].toString()) || "",
                    propertyName: propertyName,
                    displayId: displayId,
                    propertyElementRef: propertyElementRef,
                    ariaLabel: accessibilityName,
                    accessibilityHint: accessibilityHint,
                    theme: theme,
                    styleHints: styleHints,
                    containerLayoutOrientation: containerLayoutOrientation
                };
                capabilities = elementFactory && elementFactory.canCreate(exports.ElementType.textBox, textBoxProps, capabilities);
                var textElement = null;
                if (capabilities) {
                    textElement = elementFactory.create(exports.ElementType.textBox, textBoxProps);
                    if (capabilities.label) {
                        label = null;
                    }
                    if (capabilities.inlineHelpLink) {
                        inlineHelpLink = null;
                    }
                }
                else {
                    textElement = React.createElement(NativeTextBox, __assign$1({}, textBoxProps, { element: element }));
                }
                var className = generateClassName(null, constants$1.htmlElementTypes.div, propertyName, constants$1.modelElementType.textBox);
                if (displayId) {
                    className = concatClassName(className, getDivId(displayId));
                }
                var wrapGroupedElements = function (innerJSX) {
                    if ((elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
                        return (React.createElement(React.Fragment, null, innerJSX));
                    }
                    return (React.createElement("div", { id: divId, className: className }, innerJSX));
                };
                return wrapGroupedElements(React.createElement(React.Fragment, null,
                    label && inlineHelpLink && element.displayHelpPosition !== displayHelpPosition.floatRight ? React.createElement("span", null,
                        label,
                        " ",
                        inlineHelpLink) : label,
                    inlineHelpLink && element.displayHelpPosition === displayHelpPosition.floatRight ? React.createElement("span", null,
                        textElement,
                        " ",
                        inlineHelpLink) : textElement,
                    label && inlineHelpLink ? null : inlineHelpLink,
                    (!capabilities || !capabilities.inlineError) ? React.createElement(Error$1, { propertyName: propertyName }) : null));
            });
        }));
    };
    return TextBoxInner;
}(React.Component));
var TextBox = TextBoxElementWrapper(TextBoxInner, ["elementId", "tags", "propertyName", "displayHelpName", "maxLength", "required", "hidden", "disabled", "showKeyLogo", "resolvedLogo", "placeHolderText", "displayImage", "displayId", "accessibilityName", "accessibilityHint", "styleHints", "containerLayoutOrientation"]);
TextBox.displayName = "TextBox";

var FilePickerInner = /** @class */ (function (_super) {
    __extends$1(FilePickerInner, _super);
    function FilePickerInner(props) {
        var _this = _super.call(this, props) || this;
        _this.inputFileRef = React.createRef();
        _this.onChange = function (event) {
            var _a = _this.props, onUpdateValue = _a.onUpdateValue, propertyName = _a.propertyName;
            var path = _this.inputFileRef.current.value;
            if (path) {
                _this.setState({ selectedFile: path.split(/(\\|\/)/g).pop() });
            }
            else {
                _this.setState({ selectedFile: "" });
            }
            onUpdateValue(propertyName, event.target.files[0], controlOperationTypes.finished);
        };
        _this.state = { selectedFile: "" };
        _this.onButtonClick = _this.onButtonClick.bind(_this);
        return _this;
    }
    FilePickerInner.prototype.onButtonClick = function () {
        if (this.inputFileRef && this.inputFileRef.current && this.inputFileRef.current.click) {
            this.inputFileRef.current.click();
        }
    };
    FilePickerInner.prototype.render = function () {
        var _this = this;
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            return React.createElement(PropertyState.Consumer, null, function (state) {
                var elementFactory = renderContext.elementFactory;
                var selectedFile = _this.state.selectedFile;
                var _a = _this.props, className = _a.className, element = _a.element, propertyName = _a.propertyName, elementId = _a.elementId, disabled = _a.disabled, accessibilityName = _a.accessibilityName, tags = _a.tags, required = _a.required, displayHelpName = _a.displayHelpName, displayHelpChildren = _a.displayHelpChildren, displayImage = _a.displayImage;
                var displayName = element.displayName, showDisplayName = element.showDisplayName, displayContent = element.displayContent;
                var getId = htmlAttributesHelper$1.getId;
                var constants$1 = constants;
                var id = getId(constants$1.htmlElementIdPrefixes.filePicker, elementId);
                var additionalClassName = classnames(className, getTagClassNames(tags));
                var capabilities = { inlineError: true };
                var labelNode = showDisplayName ? React.createElement(PropertyLabel, { element: element }) : null;
                var errorNode = React.createElement(Error$1, { propertyName: propertyName });
                var helpDialogElementProps = {
                    id: elementId,
                };
                var inlineHelpLink = (displayHelpName || displayImage) ? React.createElement(HelpDialog, __assign$1({}, helpDialogElementProps, { element: element, children: displayHelpChildren, elementFactory: elementFactory })) : null;
                var filePickerProps = {
                    id: id,
                    additionalClassName: additionalClassName,
                    disabled: disabled,
                    inlineHelpLink: inlineHelpLink,
                    onChange: _this.onChange,
                    onButtonClick: _this.onButtonClick,
                    ariaLabel: accessibilityName,
                    displayName: displayName,
                    displayContent: displayContent,
                    showDisplayName: showDisplayName,
                    required: required,
                    errorNode: errorNode,
                    selectedFile: selectedFile,
                    inputFileRef: _this.inputFileRef
                };
                capabilities = elementFactory && elementFactory.canCreate(exports.ElementType.filePicker, filePickerProps, capabilities);
                if (capabilities) {
                    return elementFactory.create(exports.ElementType.filePicker, filePickerProps);
                }
                return (React.createElement("div", { id: id, className: classnames(additionalClassName) },
                    labelNode && inlineHelpLink && element.displayHelpPosition !== displayHelpPosition.floatRight ? React.createElement("span", null,
                        labelNode,
                        " ",
                        inlineHelpLink) : labelNode,
                    labelNode && inlineHelpLink ? null : inlineHelpLink,
                    React.createElement("input", { type: "file", name: "file", ref: _this.inputFileRef, onChange: function (event) {
                            return _this.onChange(event);
                        }, style: { display: "none" } }),
                    React.createElement("button", { id: id + "_button", "aria-label": accessibilityName, disabled: disabled, onClick: _this.onButtonClick }, displayContent),
                    " ",
                    React.createElement("label", { id: id + "_label" },
                        " ",
                        selectedFile,
                        " "),
                    (!capabilities || !capabilities.inlineError) ? React.createElement(Error$1, { propertyName: propertyName }) : null));
            });
        }));
    };
    return FilePickerInner;
}(React.Component));
;
var FilePicker = FilePickerElementWrapper(FilePickerInner, ["elementId", "disabled", "displayHelpName", "displayImage", "accessibilityName", "tags", "required"]);
FilePicker.displayName = "FilePicker";

var AudioInner = function (props) {
    var className = props.className, element = props.element, elementId = props.elementId, accessibilityName = props.accessibilityName, tags = props.tags, audioUrl = props.audioUrl;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.audio, elementId);
    var additionalClassName = classnames(className, getTagClassNames(tags));
    var propertyElementRef = element.propertyElementRef;
    return (React__default.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, theme = renderContext.theme;
        var audioProps = {
            id: id,
            additionalClassName: additionalClassName,
            ariaLabel: accessibilityName,
            propertyElementRef: propertyElementRef,
            theme: theme,
            audioUrl: audioUrl
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.audio, audioProps, {})) {
            return elementFactory.create(exports.ElementType.audio, audioProps);
        }
        return (React__default.createElement("div", { id: id, className: additionalClassName },
            React__default.createElement("audio", { "aria-label": accessibilityName, src: audioUrl, controls: true })));
    }));
};
var Audio = AudioElementWrapper(AudioInner, ["elementId", "accessibilityName", "tags", "audioUrl"]);
Audio.displayName = "Audio";

var DefaultChallengeIFrameElement = /** @class */ (function (_super) {
    __extends$1(DefaultChallengeIFrameElement, _super);
    function DefaultChallengeIFrameElement(props) {
        var _this = _super.call(this, props) || this;
        _this.onEvent = function (event) {
            var _a = _this.props, sourceUrl = _a.sourceUrl, expectedClientActionId = _a.expectedClientActionId, onChallengeIFrameMessage = _a.onChallengeIFrameMessage, onChallengeIFrameBusyTimerEnded = _a.onChallengeIFrameBusyTimerEnded;
            var messageTimer = _this.state.messageTimer;
            if (sourceUrl && event.origin && sourceUrl.indexOf(event.origin) !== 0) {
                return;
            }
            // Clear timeout handler timer
            if (messageTimer) {
                onChallengeIFrameBusyTimerEnded(messageTimer);
                clearTimeout(messageTimer);
                _this.setState({ messageTimer: null });
            }
            onChallengeIFrameMessage(event);
        };
        _this.iframe = React.createRef();
        _this.state = {
            executing: true,
            width: props.element.width,
            height: props.element.height,
        };
        return _this;
    }
    DefaultChallengeIFrameElement.prototype.updateHeight = function (height) {
        this.setState({ height: height });
    };
    DefaultChallengeIFrameElement.prototype.componentDidMount = function () {
        var _a = this.props, displayContent = _a.displayContent, sourceUrl = _a.sourceUrl, onChallengeIFrameMessageTimeout = _a.onChallengeIFrameMessageTimeout, messageTimeout = _a.messageTimeout, messageTimeoutClientAction = _a.messageTimeoutClientAction, onChallengeIFrameBusyTimerStarted = _a.onChallengeIFrameBusyTimerStarted, onChallengeIFrameBusyTimerEnded = _a.onChallengeIFrameBusyTimerEnded;
        var current = this.iframe.current;
        var messageTimer = this.state.messageTimer;
        window.addEventListener(eventTypes.message, this.onEvent);
        if (!sourceUrl && displayContent && current) {
            var innerDocument = current.contentDocument;
            if (innerDocument) {
                innerDocument.open();
                innerDocument.write(displayContent);
                innerDocument.close();
            }
        }
        if (!messageTimer && messageTimeout && messageTimeoutClientAction) {
            var messageTimer_1 = window.setTimeout(function () {
                onChallengeIFrameMessageTimeout(messageTimeoutClientAction);
                onChallengeIFrameBusyTimerEnded(messageTimer_1);
            }, messageTimeout);
            onChallengeIFrameBusyTimerStarted(messageTimer_1);
            this.setState({ messageTimer: messageTimer_1 });
        }
    };
    DefaultChallengeIFrameElement.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.props, displayContent = _a.displayContent, sourceUrl = _a.sourceUrl;
        var current = this.iframe.current;
        if (!sourceUrl && displayContent && prevProps && prevProps.displayContent !== displayContent && current) {
            var innerDocument = current.contentDocument;
            if (innerDocument) {
                innerDocument.open();
                innerDocument.write(displayContent);
                innerDocument.close();
            }
        }
    };
    DefaultChallengeIFrameElement.prototype.componentWillUnmount = function () {
        window.removeEventListener(eventTypes.message, this.onEvent);
    };
    DefaultChallengeIFrameElement.prototype.render = function () {
        var _a = this.props, displayId = _a.displayId, accessibilityName = _a.accessibilityName, hidden = _a.hidden, tags = _a.tags, sourceUrl = _a.sourceUrl, containerLayoutOrientation = _a.containerLayoutOrientation;
        var _b = this.state, width = _b.width, height = _b.height;
        var iframeStyle = { width: width, height: height };
        var getId = htmlAttributesHelper$1.getId;
        var constants$1 = constants;
        var id = getId(constants$1.htmlElementIdPrefixes.iframe, displayId);
        // Removes all non-digits (e.g. "px", "%") from width and height and determines if either width or height are larger than 0.
        // We only want to hide the border for iframes size 0. For > 0 we don't specify a border and let partner's CSS style it.
        var iframeBorder = (width || height) && Number((width + height).replace(/\D/g, "")) === 0 ? 0 : undefined;
        return this.state.executing ? (React.createElement("iframe", { key: id, className: classnames(getTagClassNames(tags)), id: id, src: sourceUrl, hidden: hidden, "aria-label": accessibilityName, ref: this.iframe, style: iframeStyle, frameBorder: iframeBorder })) : null;
    };
    return DefaultChallengeIFrameElement;
}(React.Component));
var ChallengeIFrameElementInner = function (props) {
    var formatHeader = function (displayId, authToken) {
        var _a, _b;
        switch (displayId) {
            case "xboxCoBrandedCardIframe":
                try {
                    return {
                        xuh: (_a = authToken.split('=')[1]) === null || _a === void 0 ? void 0 : _a.split(';')[0],
                        xt: (_b = authToken.split('=')[1]) === null || _b === void 0 ? void 0 : _b.split(';')[1]
                    };
                }
                catch (_c) {
                    return {
                        authorization: authToken
                    };
                }
            default:
                return {
                    authorization: authToken
                };
        }
    };
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory, userContext = renderContext.userContext, displayOptions = renderContext.displayOptions;
        var displayId = props.displayId, useAuth = props.useAuth, containerLayoutOrientation = props.containerLayoutOrientation;
        var headers = {};
        if (useAuth && (userContext === null || userContext === void 0 ? void 0 : userContext.authToken) != null) {
            headers = formatHeader(displayId, userContext.authToken);
        }
        var extendedProps = __assign$1(__assign$1({}, props), { headers: headers, useWebView2: displayOptions.useWebView2 || false, containerLayoutOrientation: containerLayoutOrientation });
        if (elementFactory && elementFactory.canCreate(exports.ElementType.challengeIframe, extendedProps, {})) {
            return elementFactory.create(exports.ElementType.challengeIframe, extendedProps);
        }
        return React.createElement(DefaultChallengeIFrameElement, __assign$1({}, extendedProps, { ref: extendedProps.challengeIFrameElementRef }));
    }));
};
var ChallengeIFrameElement$1 = ChallengeIFrameElementWrapper(ChallengeIFrameElementInner, ["displayId", "accessibilityName", "hidden", "tags", "displayContent", "sourceUrl", "expectedClientActionId", "messageTimeout", "messageTimeoutClientAction", "useAuth", "loadingMessage", "containerLayoutOrientation"]);

var SeparatorInner = function (props) {
    var elementId = props.elementId, tags = props.tags;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.separator, elementId);
    var additionalClassName = classnames(getTagClassNames(tags));
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory;
        var separatorProps = {
            id: id,
            additionalClassName: additionalClassName
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.separator, separatorProps, {})) {
            return elementFactory.create(exports.ElementType.separator, separatorProps);
        }
        return (React.createElement("hr", { id: id, className: additionalClassName }));
    }));
};
var Separator = TextDisplayElementWrapper(SeparatorInner, ["elementId", "tags"]);
Separator.displayName = "Separator";

var SpinnerInner = function (props) {
    var elementId = props.elementId, tags = props.tags, containerLayoutOrientation = props.containerLayoutOrientation;
    var getId = htmlAttributesHelper$1.getId;
    var constants$1 = constants;
    var id = getId(constants$1.htmlElementIdPrefixes.spinner, elementId);
    var additionalClassName = classnames(getTagClassNames(tags));
    return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory;
        var spinnerProps = {
            elementId: elementId,
            additionalClassName: additionalClassName,
            containerLayoutOrientation: containerLayoutOrientation
        };
        if (elementFactory && elementFactory.canCreate(exports.ElementType.spinner, spinnerProps, {})) {
            return elementFactory.create(exports.ElementType.spinner, spinnerProps);
        }
        return (React.createElement("hr", { id: id, className: additionalClassName }));
    }));
};
var Spinner = TextDisplayElementWrapper(SpinnerInner, ["elementId", "tags", "containerLayoutOrientation"]);
Spinner.displayName = "Spinner";

var DefaultSecurePropertyElement = /** @class */ (function (_super) {
    __extends$1(DefaultSecurePropertyElement, _super);
    function DefaultSecurePropertyElement(props) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, props) || this;
        _this.onLoadEventHandler = function () {
            var _a = _this.props, element = _a.element, eventHandler = _a.eventHandler;
            eventHandler.resolveSecurePropertyLoadedPromise(element.id);
        };
        _this.onMessageEvent = function (event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, sourceUrl = _g.sourceUrl, propertyName = _g.propertyName, displayId = _g.displayId, eventHandler = _g.eventHandler;
            var _h = htmlAttributesHelper$1, getDivId = _h.getDivId, getId = _h.getId;
            var constants$1 = constants;
            var divId = getDivId(displayId);
            var id = getId(constants$1.htmlElementIdPrefixes.secureProperty, propertyName);
            if ((event === null || event === void 0 ? void 0 : event.origin) && (sourceUrl === null || sourceUrl === void 0 ? void 0 : sourceUrl.indexOf(event.origin)) !== 0) {
                return;
            }
            if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.event) === constants$1.SecureFieldEvent.focused && ((_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.field) === propertyName) {
                _this.onFocusInternal(id, event.data.field, divId);
                return;
            }
            if (((_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.event) === constants$1.SecureFieldEvent.blurred && ((_d = event === null || event === void 0 ? void 0 : event.data) === null || _d === void 0 ? void 0 : _d.field) === propertyName) {
                _this.onBlurInternal(id, event.data.field, divId);
                return;
            }
            if (((_e = event === null || event === void 0 ? void 0 : event.data) === null || _e === void 0 ? void 0 : _e.source) === constants$1.SecureFieldConstants.secureFieldMessageSource && ((_f = event === null || event === void 0 ? void 0 : event.data) === null || _f === void 0 ? void 0 : _f.field) === propertyName) {
                eventHandler.secureFieldMessageHandler(event);
            }
        };
        _this.onFocusInternal = function (id, fieldName, divId) {
            var eventHandler = _this.props.eventHandler;
            eventHandler.propertySelectedHandler({ id: id, propertyName: fieldName, divId: divId });
        };
        _this.onBlurInternal = function (id, fieldName, divId) {
            var eventHandler = _this.props.eventHandler;
            eventHandler.propertyUnselectedHandler({ id: id, propertyName: fieldName, divId: divId });
        };
        _this.computeStyles = function () {
            var _a = htmlAttributesHelper$1, generateClassName = _a.generateClassName, getPropertyClassName = _a.getPropertyClassName, concatClassName = _a.concatClassName;
            var constants$1 = constants;
            var _b = _this.props, propertyName = _b.propertyName, tags = _b.tags, eventHandler = _b.eventHandler;
            var classNames = generateClassName(null, constants$1.htmlElementTypes.textBox, propertyName);
            classNames = concatClassName(classNames, getPropertyClassName(propertyName));
            classNames = concatClassName(classNames, classnames(getTagClassNames(tags)));
            eventHandler.computeSecurePropertyStyles(propertyName, _this.securePropertyHardCodedStyles);
        };
        _this.getStylesFromHints = function (styleHints) {
            if (!styleHints) {
                return undefined;
            }
            var styles = {};
            for (var _i = 0, styleHints_1 = styleHints; _i < styleHints_1.length; _i++) {
                var styleHint = styleHints_1[_i];
                switch (styleHint.toLowerCase()) {
                    case "width-fill":
                        styles = __assign$1(__assign$1({}, styles), { width: "100%" });
                        break;
                    case "width-half":
                        styles = __assign$1(__assign$1({}, styles), { width: "50%" });
                        break;
                    case "width-quarter":
                        styles = __assign$1(__assign$1({}, styles), { width: "25%" });
                        break;
                }
            }
            return styles;
        };
        _this.iframe = React.createRef();
        _this.state = {
            executing: true,
            width: (_a = props.element) === null || _a === void 0 ? void 0 : _a.width,
            height: (_b = props.element) === null || _b === void 0 ? void 0 : _b.height,
        };
        var eventHub = props.eventHub, element = props.element, displayId = props.displayId, frameName = props.frameName, propertyName = props.propertyName, sourceUrl = props.sourceUrl;
        eventHub === null || eventHub === void 0 ? void 0 : eventHub.propertyCreating(element === null || element === void 0 ? void 0 : element.id, { displayId: displayId, frameName: frameName, propertyName: propertyName, sourceUrl: sourceUrl }, {});
        return _this;
    }
    DefaultSecurePropertyElement.prototype.componentDidMount = function () {
        var _a = this.props, element = _a.element, eventHandler = _a.eventHandler;
        var propertyElementRef = element.propertyElementRef;
        if (propertyElementRef) {
            element.setFocus();
        }
        this.computeStyles();
        window.addEventListener(eventTypes.message, this.onMessageEvent);
        eventHandler.createSecurePropertyLoadedPromise(element.id);
        eventHandler.createSecurePropertyInitCompletedPromise(element.id);
    };
    DefaultSecurePropertyElement.prototype.componentWillUnmount = function () {
        window.removeEventListener(eventTypes.message, this.onMessageEvent);
    };
    DefaultSecurePropertyElement.prototype.render = function () {
        var _this = this;
        return (React.createElement(RenderContext.Consumer, null, function (renderContext) {
            return React.createElement(PropertyState.Consumer, null, function (state) {
                var _a;
                var elementFactory = renderContext.elementFactory;
                var capabilities = {};
                var _b = _this.props, displayId = _b.displayId, propertyName = _b.propertyName, accessibilityName = _b.accessibilityName, hidden = _b.hidden, tags = _b.tags, sourceUrl = _b.sourceUrl, frameName = _b.frameName, element = _b.element, labelNode = _b.labelNode, displayHelpName = _b.displayHelpName, displayImage = _b.displayImage, displayHelpChildren = _b.displayHelpChildren, styleHints = _b.styleHints;
                var _c = _this.state, width = _c.width, height = _c.height;
                var iframeStyle = { width: width, height: height };
                var _d = htmlAttributesHelper$1, getId = _d.getId, getDivId = _d.getDivId, generateClassName = _d.generateClassName, concatClassName = _d.concatClassName;
                var constants$1 = constants;
                var id = getId(constants$1.htmlElementIdPrefixes.secureProperty, propertyName);
                var divId = getDivId(displayId);
                var className = generateClassName(null, constants$1.htmlElementTypes.div, null, constants$1.modelElementType.secureProperty);
                if (propertyName) {
                    className = concatClassName(className, getDivId(propertyName));
                }
                var iframeClassName = generateClassName(null, constants$1.htmlElementTypes.secureProperty);
                if (tags) {
                    iframeClassName = concatClassName(iframeClassName, classnames(getTagClassNames(tags)));
                }
                var helpDialogElementProps = {
                    id: displayId,
                };
                var inlineHelpLink = (displayHelpName || displayImage) ? React.createElement(HelpDialog, __assign$1({}, helpDialogElementProps, { element: element, children: displayHelpChildren, elementFactory: elementFactory })) : null;
                capabilities = elementFactory && elementFactory.canCreate(exports.ElementType.secureProperty, null, capabilities);
                if (capabilities) {
                    _this.securePropertyHardCodedStyles = capabilities.securePropertyHardCodedStyles;
                    if ((_a = capabilities.securePropertyHardCodedStyles) === null || _a === void 0 ? void 0 : _a.secureIframeDimensions) {
                        iframeStyle = __assign$1({}, capabilities.securePropertyHardCodedStyles.secureIframeDimensions);
                    }
                    // fluent ui and office-fabric render inlinehelp link through secure property label
                    if (!capabilities.inlineHelpLink) {
                        inlineHelpLink = null;
                    }
                }
                if (styleHints) {
                    iframeStyle = __assign$1(__assign$1({}, iframeStyle), _this.getStylesFromHints(styleHints));
                }
                var iframeElement = React.createElement("iframe", { className: iframeClassName, id: id, src: sourceUrl, hidden: hidden, "aria-label": accessibilityName, ref: _this.iframe, style: __assign$1(__assign$1({}, iframeStyle), { "verticalAlign": "middle" }), sandbox: "allow-same-origin allow-scripts", name: frameName, frameBorder: "0", onLoad: _this.onLoadEventHandler });
                return _this.state.executing ? (React.createElement("div", { id: divId, className: className },
                    labelNode && inlineHelpLink && element.displayHelpPosition === displayHelpPosition.floatRight ? React.createElement("span", null,
                        labelNode,
                        " ",
                        inlineHelpLink) : labelNode,
                    inlineHelpLink ? React.createElement("span", null,
                        inlineHelpLink,
                        " ",
                        iframeElement) : iframeElement,
                    React.createElement(Error$1, { propertyName: propertyName }))) : null;
            });
        }));
    };
    return DefaultSecurePropertyElement;
}(React.Component));
var SecurePropertyElement$1 = SecurePropertyElementWrapper(DefaultSecurePropertyElement, ["displayId", "propertyName", "displayHelpName", "displayImage", "accessibilityName", "hidden", "frameName", "tags", "sourceUrl", "styleHints"]);

var SecurePropertyLabelInner = function (_a) {
    var element = _a.element, elementId = _a.elementId, hidden = _a.hidden, required = _a.required, disabled = _a.disabled, displayId = _a.displayId, displayHelpName = _a.displayHelpName, displayImage = _a.displayImage, showDisplayName = _a.showDisplayName, displayName = _a.displayName, accessibilityName = _a.accessibilityName, displayHelpChildren = _a.displayHelpChildren;
    return showDisplayName ? (React.createElement(RenderContext.Consumer, null, function (renderContext) {
        var elementFactory = renderContext.elementFactory;
        var getId = htmlAttributesHelper$1.getId;
        var constants$1 = constants;
        var id = getId(constants$1.htmlElementIdPrefixes.label, elementId);
        var helpDialogElementProps = {
            id: displayId,
        };
        var inlineHelpLink = (displayHelpName || displayImage) ? React.createElement(HelpDialog, __assign$1({}, helpDialogElementProps, { element: element, children: displayHelpChildren, elementFactory: elementFactory })) : null;
        var securePropertyLabelProps = {
            disabled: disabled,
            required: required,
            elementId: id,
            displayContent: displayName,
            inlineHelpLink: inlineHelpLink,
        };
        if (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.canCreate(exports.ElementType.securePropertyLabel, securePropertyLabelProps, {})) {
            return elementFactory.create(exports.ElementType.securePropertyLabel, securePropertyLabelProps);
        }
        return React.createElement("label", { className: classnames("pidlddc-label", hidden || !showDisplayName ? "d-none" : "d-block"), id: securePropertyLabelProps.elementId, "aria-label": accessibilityName },
            displayName,
            React.createElement("span", { className: "".concat(securePropertyLabelProps.elementId, "-asterisk") }, required ? "*" : ""));
    })) : null;
};
SecurePropertyLabelInner.displayName = "SecurePropertyLabelInner";
var SecurePropertyLabel = SecurePropertyElementWrapper(SecurePropertyLabelInner, ["elementId", "hidden", "displayName", "displayId", "displayHelpName", "displayImage", "showDisplayName", "accessibilityName", "required"]);
SecurePropertyLabel.displayName = "SecurePropertyLabel";

function createElement(element, eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs, setOpenDropdownId, openDropdownId) {
    var _a;
    if (!element.canBeRendered()) {
        return (null);
    }
    var propertyElement = element;
    var propertyName = (propertyElement.getPropertyName && propertyElement.getPropertyName()) || "";
    if (!element.isText() && element.hidden()) {
        return (null);
    }
    var wrapGroupedElements = function (elementFactory, innerJSX, isLogo) {
        if (isLogo && (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.createLogoWrapper)) {
            return elementFactory.createLogoWrapper(innerJSX);
        }
        if ((elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
            return (React.createElement(React.Fragment, null, innerJSX));
        }
        return (React.createElement("div", { 
            // TODO: Get className with helper function
            className: "pidlddc-div pidlddc-div-logo pidlddc-logoBlock", id: "pidlddc-div-pagelogoblock0" }, innerJSX));
    };
    var isHandledHyperlinkPidlAction = function (pidlAction) {
        return pidlAction && (pidlAction.type === supportedPidlActions.navigate || pidlAction.type === supportedPidlActions.redirect);
    };
    var defaultProps = { element: element };
    var displayHelp = element.displayHelp, operationType = element.operationType;
    var type = modelElementType;
    var possibleOptions;
    var optionsElements;
    switch (element.type) {
        case type.page:
            return element.children && element.children.map ? element.children.map(elementMap(eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs, setOpenDropdownId, openDropdownId)) : null;
        case type.dataCollectionBindingGroup:
        case type.group:
            var groupProps = __assign$1(__assign$1({}, defaultProps), { childNodes: element.children && element.children.map ? element.children.map(elementMap(eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs, setOpenDropdownId, openDropdownId)) : null, labelNode: React.createElement(GroupLabel, __assign$1({}, defaultProps)) });
            if (isGroupElement(element) && element.isModalGroup) {
                return React.createElement(Modal, __assign$1({}, groupProps, { ref: element.groupElementRef }));
            }
            else {
                return React.createElement(Group, __assign$1({}, groupProps));
            }
        case type.captcha:
            return React.createElement(EventHub$1.Consumer, null, function (eventHub) {
                var audioEventHandler = __assign$1({}, eventHandler);
                var imageEventHandler = __assign$1({}, eventHandler);
                audioEventHandler.buttonClickHandler = function () {
                    var id = element.id;
                    audioEventHandler.captchaHyperlinkClickHandler(id, "image", controlOperationTypes.finished);
                };
                imageEventHandler.buttonClickHandler = function () {
                    var id = element.id;
                    imageEventHandler.captchaHyperlinkClickHandler(id, "audio", controlOperationTypes.finished);
                };
                var captchaProps = __assign$1(__assign$1({}, defaultProps), { audioChildNodes: element.audioChildren && element.audioChildren.map ? element.audioChildren.map(elementMap(audioEventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs)) : null, imageChildNodes: element.imageChildren && element.imageChildren.map ? element.imageChildren.map(elementMap(imageEventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs)) : null });
                return React.createElement(Captcha, __assign$1({}, captchaProps, { eventHub: eventHub }));
            });
        case type.textGroup:
            var textGroupAriaLabelledBy = void 0;
            if (element.children && element.children[0] && element.children[0].id) {
                textGroupAriaLabelledBy = htmlAttributesHelper$1.getId(htmlElementIdPrefixes.text, element.children[0].id);
            }
            var textGroup = (React.createElement(TextGroup, __assign$1({}, defaultProps, { ariaLabelledBy: textGroupAriaLabelledBy }),
                React.createElement(IsInline.Provider, { value: true }, element.children && element.children.map ? element.children.map(elementMap(eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs)) : null)));
            return textGroup;
        case type.heading:
            return React.createElement(Heading, __assign$1({}, defaultProps));
        case type.subheading:
            return React.createElement(SubHeading, __assign$1({}, defaultProps));
        case type.text:
            return React.createElement(Text, __assign$1({}, defaultProps));
        case type.hyperlink:
            return React.createElement(Hyperlink, __assign$1({ onClick: isHandledHyperlinkPidlAction(element.pidlAction) ? eventHandler.hyperlinkClickHandler : eventHandler.buttonClickHandler }, defaultProps));
        case type.image:
            return React.createElement(Image, __assign$1({}, defaultProps));
        case type.logo:
            var logos = element.getAllLogos();
            var props_1 = __assign$1({}, defaultProps);
            var components_1 = logos && logos.map ? logos.map(function (logo) { return (React.createElement(LogoElement$1, { element: logo, containerLayoutOrientation: props_1.element.containerLayoutOrientation })); }) : null;
            return (React.createElement(RenderContext.Consumer, null, function (_a) {
                var elementFactory = _a.elementFactory;
                return wrapGroupedElements(elementFactory, components_1, true);
            }));
        case type.dropdown:
            return React.createElement(EventHub$1.Consumer, null, function (eventHub) {
                if (element.displayType === pidlDisplayTypesValues.prefillControl) {
                    var onDropdownSelect_1 = function (value) {
                        var prefillValue = parseInt(value);
                        if (!isNaN(prefillValue)) {
                            onUpdatePrefill(element, prefillValue);
                        }
                    };
                    var possibleOptions_1 = eventHandler.getMultiPropertySelectorPossibleOptions(element.pidlIdentity) || [];
                    return (React.createElement(Dropdown, { element: __assign$1(__assign$1({}, element), { getPropertyName: function () { return element.displayId; }, possibleOptions: possibleOptions_1 }), isPrefill: true, onSelect: onDropdownSelect_1, eventHub: eventHub, setOpenDropdownId: setOpenDropdownId, openDropdownId: openDropdownId }));
                }
                var onDropdownSelect = function (value) {
                    // Fixing https://microsoft.visualstudio.com/OSGS/_workitems/edit/35544153/
                    // Calling onUpdateValue with 2 different states to replicate the state change when user types and then tabs out of a textbox
                    // Which is the same action done with dropdown, where user picks an option then the dropdown closes (tab out for focus)
                    // This is so that group error is cleared out on selection
                    onUpdateValue(propertyName, value.toString(), controlOperationTypes.editing);
                    onUpdateValue(propertyName, value.toString(), controlOperationTypes.finished);
                };
                possibleOptions = element.possibleOptions;
                if (possibleOptions) {
                    optionsElements = {};
                    for (var _i = 0, _a = Object.keys(possibleOptions || {}); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (possibleOptions[key]) {
                            var displayContentContainer = possibleOptions[key].displayContentContainer;
                            if (displayContentContainer) {
                                if (!optionsElements) {
                                    optionsElements = {};
                                }
                                optionsElements[key] = createElement(displayContentContainer, eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs);
                            }
                        }
                    }
                }
                return (React.createElement(Dropdown, __assign$1({}, defaultProps, { onSelect: onDropdownSelect, optionsElements: optionsElements, eventHub: eventHub, setOpenDropdownId: setOpenDropdownId, openDropdownId: openDropdownId })));
            });
        case type.checkBox:
            if (element.displayType === pidlDisplayTypesValues.prefillControl) {
                var onPrefillChange = function (value) {
                    onUpdatePrefill(element, value);
                };
                return (React.createElement(PrefillCheckBox, __assign$1({}, defaultProps, { onChange: onPrefillChange, getMultiPropertySelectorPossibleOptions: eventHandler.getMultiPropertySelectorPossibleOptions })));
            }
            var onCheckboxChange = function (value) {
                onUpdateValue(propertyName, value, controlOperationTypes.editing);
            };
            return (React.createElement(CheckBox, __assign$1({}, defaultProps, { onChange: onCheckboxChange })));
        case type.textBox:
            var displayHelpChildren_1;
            if (displayHelp) {
                var displayHelpElements = modelElementFactory$1.createModelElementsFromDisplayDescriptions(displayHelp, operationType);
                displayHelpChildren_1 = displayHelpElements.elements && displayHelpElements.elements.map ? displayHelpElements.elements.map(elementMap(eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs)) : undefined;
            }
            return React.createElement(RenderContext.Consumer, null, function (renderContext) {
                return React.createElement(TextBox, __assign$1({}, defaultProps, { displayHelpChildren: displayHelpChildren_1, onUpdateValue: onUpdateValue, propertyName: propertyName, eventHandler: eventHandler, displayOptions: renderContext.displayOptions }));
            });
            ;
        case type.button:
            var pidlAction_1 = element.pidlAction;
            var displayContentModelElement = element.displayContentModelElement;
            var displayContent = element.displayContent;
            var onButtonClick = function () { return eventHandler.buttonClickHandler({
                id: element.id,
                pidlAction: pidlAction_1,
                value: pidlAction_1.context,
                dest: "",
            }); };
            var displayContentElement = void 0;
            if (displayContentModelElement) {
                displayContentElement = createElement(displayContentModelElement, eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs);
            }
            return (React.createElement(Button, __assign$1({}, defaultProps, { onClick: onButtonClick, displayContent: displayContentElement !== null && displayContentElement !== void 0 ? displayContentElement : displayContent })));
        case type.audio:
            return (React.createElement(Audio, __assign$1({}, defaultProps)));
        case type.radio:
            var onRadioSelect = function (value) {
                onUpdateValue(propertyName, value, controlOperationTypes.editing);
            };
            possibleOptions = element.possibleOptions;
            if (possibleOptions) {
                optionsElements = {};
                for (var _i = 0, _b = Object.keys(possibleOptions || {}); _i < _b.length; _i++) {
                    var key = _b[_i];
                    if (possibleOptions[key]) {
                        var displayContentContainer = possibleOptions[key].displayContentContainer;
                        displayContentContainer && displayContentContainer[eventNames.isDisabled] ? displayContentContainer[eventNames.isDisabled] = possibleOptions[key].isDisabled : null;
                        if (displayContentContainer) {
                            if (!optionsElements) {
                                optionsElements = {};
                            }
                            // The key here is different from the dropdown ones because of how Radio.tsx creates their options
                            optionsElements[possibleOptions[key].key || key] = createElement(displayContentContainer, eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs);
                        }
                    }
                }
            }
            return (React.createElement(Radio, __assign$1({}, defaultProps, { onSelect: onRadioSelect, optionsElements: optionsElements })));
        case type.expression:
            return React.createElement(Text, __assign$1({}, defaultProps));
        case type.buttonList:
            return (React.createElement(ButtonList, __assign$1({}, defaultProps, { onClick: eventHandler.buttonClickHandler, createElement: function (element) {
                    return createElement(element, eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs);
                } })));
        case type.iFrame:
            var iFrameInnerRef = React.createRef();
            var iFrameElement = (React.createElement(IFrameElement$1, __assign$1({}, defaultProps, { key: element.id, onIFrameMessageTimeout: eventHandler.iFrameMessageTimeoutHandler, onIFrameMessage: function (response) { return eventHandler.iFrameMessageHandler(response); }, onIFrameBusyTimerStarted: eventHandler.iFrameBusyTimerStartedHandler, onIFrameBusyTimerEnded: eventHandler.iFrameBusyTimerEndedHandler, iFrameElementRef: iFrameInnerRef })));
            iFrameInnerRefs.push(iFrameInnerRef);
            return iFrameElement;
        case type.challengeIFrame:
            var challengeIFrameInnerRef = React.createRef();
            var challengeIFrameElement = (React.createElement(ChallengeIFrameElement$1, __assign$1({}, defaultProps, { key: element.id, onChallengeIFrameMessageTimeout: eventHandler.iFrameMessageTimeoutHandler, onChallengeIFrameMessage: function (response) { return eventHandler.challengeiFrameMessageHandler(response); }, onChallengeIFrameBusyTimerStarted: eventHandler.iFrameBusyTimerStartedHandler, onChallengeIFrameBusyTimerEnded: eventHandler.iFrameBusyTimerEndedHandler, challengeIFrameElementRef: challengeIFrameInnerRef })));
            iFrameInnerRefs.push(challengeIFrameInnerRef);
            return challengeIFrameElement;
        case type.filePicker:
            var filePickerDisplayHelpChildren = void 0;
            if (displayHelp) {
                var displayHelpElements = modelElementFactory$1.createModelElementsFromDisplayDescriptions(displayHelp, operationType);
                filePickerDisplayHelpChildren = (displayHelpElements === null || displayHelpElements === void 0 ? void 0 : displayHelpElements.elements) && ((_a = displayHelpElements === null || displayHelpElements === void 0 ? void 0 : displayHelpElements.elements) === null || _a === void 0 ? void 0 : _a.map) ? displayHelpElements.elements.map(elementMap(eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs)) : undefined;
            }
            return (React.createElement(FilePicker, __assign$1({}, defaultProps, { displayHelpChildren: filePickerDisplayHelpChildren, propertyName: propertyName, onUpdateValue: onUpdateValue })));
        case type.separator:
            return React.createElement(Separator, __assign$1({}, defaultProps));
        case type.spinner:
            return React.createElement(Spinner, __assign$1({}, defaultProps));
        case type.secureProperty:
            return React.createElement(EventHub$1.Consumer, null, function (eventHub) {
                var _a;
                var securePropertyDisplayHelpChildren;
                if (displayHelp) {
                    var displayHelpElements = modelElementFactory$1.createModelElementsFromDisplayDescriptions(displayHelp, operationType);
                    securePropertyDisplayHelpChildren = (displayHelpElements === null || displayHelpElements === void 0 ? void 0 : displayHelpElements.elements) && ((_a = displayHelpElements === null || displayHelpElements === void 0 ? void 0 : displayHelpElements.elements) === null || _a === void 0 ? void 0 : _a.map) ? displayHelpElements.elements.map(elementMap(eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs, setOpenDropdownId, openDropdownId)) : undefined;
                }
                var securePropertyModelElement = __assign$1(__assign$1({}, defaultProps), { labelNode: React.createElement(SecurePropertyLabel, __assign$1({}, defaultProps, { displayHelpChildren: securePropertyDisplayHelpChildren })) });
                var securePropertyElement = (React.createElement(SecurePropertyElement$1, __assign$1({}, securePropertyModelElement, { eventHub: eventHub, displayHelpChildren: securePropertyDisplayHelpChildren, eventHandler: eventHandler })));
                return securePropertyElement;
            });
        default:
            return undefined;
    }
}
function elementMap(eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs, setOpenDropdownId, openDropdownId) {
    return function (element, index, array) {
        return createElement(element, eventHandler, onUpdateValue, onUpdatePrefill, iFrameInnerRefs, setOpenDropdownId, openDropdownId);
    };
}

var StateWrapper = /** @class */ (function (_super) {
    __extends$1(StateWrapper, _super);
    function StateWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.update = function (update, afterUpdate) {
            // tslint:disable-next-line: no-empty
            update.run.apply(update, __spreadArray$1([_this, afterUpdate || (function () { })], update.args, false));
        };
        _this.displayValues = {};
        _this.propertyNames = [];
        _this.getPropertyNames(_this.props.pageElement.children, _this.propertyNames);
        _this.state = {
            propertyErrors: {},
            groupErrors: {},
            pendingValues: {},
            accessibilityText: {},
        };
        return _this;
    }
    StateWrapper.prototype.updatePropertyValues = function (afterUpdate) {
        var _a = this.props, getModelPropertyValue = _a.getModelPropertyValue, onPropertyChange = _a.onPropertyChange;
        // tslint:disable-next-line: forin
        for (var propertyName in this.state.pendingValues) {
            var newValue = getModelPropertyValue(propertyName);
            if (newValue !== undefined && onPropertyChange) {
                onPropertyChange(propertyName, newValue);
            }
        }
        this.setState({
            pendingValues: {}
        }, afterUpdate);
    };
    StateWrapper.prototype.getPropertyNames = function (children, propertyNames) {
        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var child = children_1[_i];
            if (child.isProperty()) {
                var property = child;
                if (property.displayType !== pidlDisplayTypesValues.prefillControl) {
                    propertyNames.push(property.getPropertyName());
                }
            }
            else if (child.isCaptcha()) {
                var element = child;
                propertyNames.push(element.getPropertyName());
            }
            if (child.children && child.children.length) {
                this.getPropertyNames(child.children, propertyNames);
            }
        }
    };
    StateWrapper.prototype.getPropertyState = function () {
        var _a = this.props, getModelPropertyValue = _a.getModelPropertyValue, pageElement = _a.pageElement;
        var propertyValues = {};
        this.propertyNames = [];
        if (pageElement && pageElement.children) {
            this.getPropertyNames(pageElement.children, this.propertyNames);
        }
        for (var _i = 0, _b = this.propertyNames; _i < _b.length; _i++) {
            var propertyName = _b[_i];
            propertyValues[propertyName] = getModelPropertyValue(propertyName);
        }
        var values = __assign$1(__assign$1(__assign$1({}, this.displayValues), propertyValues), this.state.pendingValues);
        return {
            errors: this.state.propertyErrors,
            values: values,
            accessibilityText: this.state.accessibilityText,
        };
    };
    StateWrapper.prototype.render = function () {
        var _a = this.props, children = _a.children, elementFactory = _a.elementFactory, displayOptions = _a.displayOptions, displaySettings = _a.displaySettings, eventHub = _a.eventHub, theme = _a.theme, userContext = _a.userContext;
        return (React.createElement(EventHub$1.Provider, { value: eventHub },
            React.createElement(GroupErrors.Provider, { value: this.state.groupErrors },
                React.createElement(PropertyState.Provider, { value: this.getPropertyState() },
                    React.createElement(RenderContext.Provider, { value: { elementFactory: elementFactory, displayOptions: displayOptions, displaySettings: displaySettings, theme: theme, userContext: userContext } }, children)))));
    };
    return StateWrapper;
}(React.Component));
var showPropertyErrorUpdate = function (wrapper, afterUpdate, error) {
    var _a;
    wrapper.setState({
        propertyErrors: __assign$1(__assign$1({}, wrapper.state.propertyErrors), (_a = {}, _a[error.propertyName] = error, _a)),
    }, afterUpdate);
};
var showGroupErrorUpdate = function (wrapper, afterUpdate, error) {
    var _a;
    wrapper.setState({
        groupErrors: __assign$1(__assign$1({}, wrapper.state.groupErrors), (_a = {}, _a[error.groupDisplayId] = error, _a)),
    }, afterUpdate);
};
var hidePropertyErrorUpdate = function (wrapper, afterUpdate, propertyName) {
    var errors = __assign$1({}, wrapper.state.propertyErrors);
    if (errors[propertyName]) {
        delete errors[propertyName];
        wrapper.setState({ propertyErrors: errors }, afterUpdate);
    }
    else {
        // propertyName in this case is groupDisplayId from server response
        var grouperrors = __assign$1({}, wrapper.state.groupErrors);
        if (grouperrors && grouperrors[propertyName]) {
            delete grouperrors[propertyName];
            wrapper.setState({ groupErrors: grouperrors }, afterUpdate);
        }
    }
};
var propertyValueUpdate = function (wrapper, afterUpdate) {
    /**
     * This event signals that PIDLSDK is done with validation and
     * StateWrapper can use getModelPropertyValue to get the real values
     */
    wrapper.updatePropertyValues(afterUpdate);
};
var accessibilityTextUpdate = function (wrapper, afterUpdate, propertyName, accessibilityText) {
    var _a;
    /**
     * This event signals that PIDLSDK has sent an accessibility text change
     */
    wrapper.setState({
        accessibilityText: __assign$1(__assign$1({}, wrapper.state.accessibilityText), (_a = {}, _a[propertyName] = accessibilityText, _a))
    }, afterUpdate);
};
var pendingValueUpdate = function (wrapper, afterUpdate, propertyName, value) {
    var _a;
    /**
     * With controlled inputs, React resets the DOM value if the prop
     * isn't updated within a frame or two. Since PIDLSDK runs validation
     * and we wait for it to finish before updating, we have to let the
     * StateWrapper know that there is a pending value.
     */
    wrapper.setState({
        pendingValues: __assign$1(__assign$1({}, wrapper.state.pendingValues), (_a = {}, _a[propertyName] = value, _a)),
    });
};
var displayValueUpdate = function (wrapper, afterUpdate, displayName, value) {
    var _a;
    wrapper.displayValues = __assign$1(__assign$1({}, wrapper.displayValues), (_a = {}, _a[displayName] = value, _a));
    wrapper.forceUpdate(afterUpdate);
};
var resetUpdate = function (wrapper, afterUpdate) {
    wrapper.setState({
        propertyErrors: {},
        groupErrors: {},
    }, afterUpdate);
};

var foldChildren = function (children, elements, properties) {
    children.map(function (child) {
        if (child.isProperty()) {
            var property = child;
            var name_1 = property.getPropertyName();
            properties[name_1] = property;
        }
        elements[child.id] = child;
        foldChildren(child.children || [], elements, properties);
    });
};
var PidlComponent = /** @class */ (function (_super) {
    __extends$1(PidlComponent, _super);
    function PidlComponent(props) {
        var _this = _super.call(this, props) || this;
        _this._propertyElementRef = React.createRef();
        _this._propertyElementErrorRef = React.createRef();
        _this._modalRef = React.createRef();
        _this._navigationWrapperRef = React.createRef();
        _this.pageHasSecureFields = false;
        _this.alreadyWaiting = false;
        _this.moreThanOneBusyBlockPropExists = function () {
            var _a = _this.props, busyBlockElement = _a.busyBlockElement, displayOptions = _a.displayOptions;
            var busyBlockId = displayOptions.busyBlockId, busyBlockShowHideHandler = displayOptions.busyBlockShowHideHandler;
            var options = [busyBlockId, busyBlockElement, busyBlockShowHideHandler];
            var passedInProps = options.filter(function (item) { return item; });
            return passedInProps.length > 1;
        };
        _this.moveNextPage = function () {
            var _a;
            if ((_a = _this.pidlControlApi) === null || _a === void 0 ? void 0 : _a.moveNextPage) {
                return _this.pidlControlApi.moveNextPage().result;
            }
            return false;
        };
        _this.submitPage = function () {
            var _a;
            if ((_a = _this.pidlControlApi) === null || _a === void 0 ? void 0 : _a.submitPage) {
                return _this.pidlControlApi.submitPage().result;
            }
            return false;
        };
        _this.moveToLastPage = function () {
            var _a;
            if ((_a = _this.pidlControlApi) === null || _a === void 0 ? void 0 : _a.moveToLastPage) {
                return _this.pidlControlApi.moveToLastPage().result;
            }
            return false;
        };
        _this.movePrevPage = function () {
            var _a;
            if ((_a = _this.pidlControlApi) === null || _a === void 0 ? void 0 : _a.movePrevPage) {
                return _this.pidlControlApi.movePrevPage().result;
            }
            return false;
        };
        _this.moveToFirstPage = function () {
            var _a;
            if ((_a = _this.pidlControlApi) === null || _a === void 0 ? void 0 : _a.moveToFirstPage) {
                return _this.pidlControlApi.moveToFirstPage().result;
            }
            return false;
        };
        _this.cancel = function () {
            var _a;
            if ((_a = _this.pidlControlApi) === null || _a === void 0 ? void 0 : _a.cancel) {
                return _this.pidlControlApi.cancel().result;
            }
            return false;
        };
        _this.getPidlExternalControlPropsMap = function () {
            return _this.pidlExternalControlProps;
        };
        _this.getSelectedResource = function () {
            if (!_this.pidlControlApi) {
                return null;
            }
            return _this.pidlControlApi.getSelectedResource().result;
        };
        _this.getPidlPayload = function () {
            if (!_this.pidlControlApi) {
                return null;
            }
            return _this.pidlControlApi.returnUserInputData();
        };
        _this.postMessageToChildIFrames = function (params) {
            if (_this.pidlControlApi && _this.pidlControlApi.postMessageToChildIFrames) {
                return _this.pidlControlApi.postMessageToChildIFrames(params).result;
            }
            return false;
        };
        _this.updateChildIFramesHeight = function (height) {
            if (_this.iFrameInnerRefs) {
                _this.iFrameInnerRefs.forEach(function (value, index, array) {
                    if (value && value.current && value.current.updateHeight) {
                        value.current.updateHeight(height);
                    }
                });
            }
        };
        _this.focusOnPageRefresh = function (eventName) {
            if (_this.state.disableFocusOnLoad) {
                return;
            }
            if (eventName === eventNames.pageRendered ||
                eventName === eventNames.pageRefreshed ||
                eventName === privateEventNames.secureFieldLoadWaitEnded) {
                setTimeout(function () {
                    var _a, _b, _c, _d;
                    if (!_this.state.firstErrorPropertyName) {
                        if (_this.props.onPageRendered) {
                            _this.props.onPageRendered();
                        }
                        // Focus on the first visible and enabled property element when it is a secure field
                        var firstElement = _this.findFirstVisibleEnabledPropertyElement(_this.state.pageElement.children);
                        if (firstElement && firstElement.isSecureProperty()) {
                            firstElement.setFocus();
                        }
                        else if (!_this.props.propertyElementRef) {
                            if ((_b = (_a = _this._propertyElementRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus) {
                                (_d = (_c = _this._propertyElementRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.focus();
                            }
                        }
                    }
                }, 100);
            }
            else if (eventName === eventNames.pageNavigated) {
                setTimeout(function () {
                    var _a, _b, _c;
                    if (!_this.state.firstErrorPropertyName) {
                        var propertyRef = (_a = _this.props.propertyElementRef) !== null && _a !== void 0 ? _a : _this._propertyElementRef;
                        if ((_b = propertyRef === null || propertyRef === void 0 ? void 0 : propertyRef.current) === null || _b === void 0 ? void 0 : _b.focus) {
                            (_c = propertyRef === null || propertyRef === void 0 ? void 0 : propertyRef.current) === null || _c === void 0 ? void 0 : _c.focus();
                        }
                    }
                }, 100);
            }
        };
        _this.busyBlockShowHide = function (showBusyBlock) {
            _this.setState({ showBusyBlock: showBusyBlock });
        };
        _this.toggleVisualCaptcha = function (propertyName, value, operation) {
            _this.onUpdateValue(propertyName, value, operation);
        };
        _this.shouldRenderBusyBlock = function () {
            var showBusyBlock = _this.state.showBusyBlock;
            var busyBlockElement = _this.props.busyBlockElement;
            return busyBlockElement
                && React.isValidElement(busyBlockElement)
                && showBusyBlock;
        };
        _this.displayPidl = function (loadPromises, initPromises) {
            var _a = _this.state, eventHub = _a.eventHub, waitForSecureFields = _a.waitForSecureFields, showBusyBlock = _a.showBusyBlock;
            _this.alreadyWaiting = false;
            if (waitForSecureFields) {
                _this.setState(__assign$1(__assign$1({}, _this.state), { waitForSecureFields: false }));
            }
            if (showBusyBlock) {
                _this.busyBlockShowHide(false);
            }
            loadPromises.length = 0;
            initPromises.length = 0;
            eventHub.secureFieldLoadWaitEnded();
        };
        _this.waitForSecureFieldsLoadCompletion = function () {
            var _a = _this.state, eventHub = _a.eventHub, viewEventHandler = _a.viewEventHandler;
            var securePropertyPromises = (viewEventHandler === null || viewEventHandler === void 0 ? void 0 : viewEventHandler.getSecurePropertyLoadedPromises()) || [];
            var secureFieldInitCompletedPromises = (viewEventHandler === null || viewEventHandler === void 0 ? void 0 : viewEventHandler.getSecurePropertyInitCompletedPromises()) || [];
            _this.alreadyWaiting = true;
            Promise.all(securePropertyPromises).then(function () {
                eventHub.secureFieldsLoaded();
                var initWaitTime = viewEventHandler.getClientSetting(ClientSettingNames.pidlSdkWaitTimeForSecureFieldsInit) || SecureFieldConstants.pidlSdkWaitTimeForSecureFieldsInit;
                Promise.race([Promise.all(secureFieldInitCompletedPromises), viewEventHandler.getTimeoutPromise(initWaitTime)]).then(function () {
                    viewEventHandler.clearTimeoutPromise();
                    _this.displayPidl(securePropertyPromises, secureFieldInitCompletedPromises);
                }).catch(function (error) {
                    _this.displayPidl(securePropertyPromises, secureFieldInitCompletedPromises);
                    if (error instanceof Error && error.message === "Timeout") {
                        error.message = "Timeout waiting for secure fields to resolve";
                        var errorObj = new pidlErrors.secureFieldInitCompletedTimeoutError(errorMessages.secureFieldInitCompletedTimeout, error.toString());
                        eventHub.failure(errorObj);
                    }
                });
            }).catch(function (error) {
                _this.displayPidl(securePropertyPromises, secureFieldInitCompletedPromises);
            });
        };
        _this.reset = function () {
            /**
             * We want to give the user a chance to update props *before*
             * a reset so we will init pidl in component did mount
             */
            // This will re-render the parent div and wipe out any old contents
            _this.setState({
                properties: {},
                pageError: undefined,
                viewEventHandler: undefined,
                pageElement: undefined,
            }, function () { return _this.updateState({
                run: resetUpdate,
                args: [],
            }); });
        };
        _this.findFirstVisibleErroredProperty = function (modelElements, errors) {
            var erroredPropertyNames = [];
            for (var i = 0; i < errors.length; i++) {
                erroredPropertyNames.push(errors[i].propertyName);
            }
            var context = {};
            _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, ctx) {
                if (modelElement && modelElement.isProperty() && !modelElement.disabled() && !modelElement.hidden() && erroredPropertyNames.includes(modelElement.getPropertyName())) {
                    ctx.element = modelElement;
                    return true;
                }
            }, context);
            return context.element;
        };
        _this.findFirstVisibleEnabledPropertyElement = function (modelElements) {
            var context = {};
            _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, ctx) {
                if (modelElement && (modelElement.isIframe() || modelElement.isSecureProperty() || modelElement.isButton() || modelElement.isPrefillControl() || modelElement.isProperty()) && !modelElement.disabled() && !modelElement.hidden()) {
                    if (isRadioElement(modelElement) && _this.isRadioPossibleOptionsAllDisabled(modelElement)) {
                        return false;
                    }
                    ctx.element = modelElement;
                    return true;
                }
            }, context);
            return context.element;
        };
        _this.findHighlightedButton = function (modelElements) {
            var context = {};
            _this.propertiesVisitorProcessingAny(modelElements, function (modelElement, ctx) {
                if (modelElement && (modelElement.isButton() && modelElement.isHighlighted()) && !modelElement.disabled() && !modelElement.hidden()) {
                    ctx.element = modelElement;
                    return true;
                }
            }, context);
            return context.element;
        };
        _this.isRadioPossibleOptionsAllDisabled = function (radioElement) {
            var possibleOptionsKeys = typehelper.getKeys(radioElement.possibleOptions);
            var allDisabled = true;
            for (var i = 0; i < possibleOptionsKeys.length; i++) {
                allDisabled = allDisabled && radioElement.possibleOptions[possibleOptionsKeys[i]].isDisabled;
            }
            return allDisabled;
        };
        _this.findPropertyElementByPropertyName = function (modelElements, propertyName, propertyValue) {
            var context = {};
            _this.propertiesVisitorProcessingDataProperty(modelElements, function (modelElement, ctx) {
                if (modelElement &&
                    modelElement.disabled && !modelElement.disabled() &&
                    modelElement.hidden && !modelElement.hidden() &&
                    modelElement.getPropertyName && modelElement.getPropertyName() === propertyName &&
                    (!isRadioElement(modelElement) ||
                        (propertyValue && !typehelper.isEmptyString(modelElementsHelper$1.normalizeValueToDisplayDescriptionPossibleOptions(modelElement, propertyValue))))) {
                    if (isRadioElement(modelElement) && _this.isRadioPossibleOptionsAllDisabled(modelElement)) {
                        return false;
                    }
                    ctx.element = modelElement;
                    return true;
                }
            }, context);
            return context.element;
        };
        _this.setOpenDropdownId = function (id) {
            _this.setState({ openDropdownId: id });
        };
        _this.onUpdateValue = function (propertyName, value, operation) {
            if (!_this.state.viewEventHandler) {
                return;
            }
            _this.pendingPropertyValue(propertyName, value);
            var updatePropertyValue = function () {
                _this.state.viewEventHandler.updateModelPropertyValue(propertyName, value, operation).then(function () {
                    _this.updatePropertyValues();
                });
            };
            if (operation === controlOperationTypes.finished) {
                /*
                    In case of the focusout resolution policy, on focusOut, the pidlDoc gets resolved before the
                    propertyUnselected event which updates the lastFocusedProperty. Thus the lastFocusedProperty is
                    lost. This results in the first input box getting focused instead of true lastFocusedProperty.
                    This 1ms delay makes sure that the lastFocusedProperty is updated before pidlDoc resolution.
                */
                setTimeout(updatePropertyValue, 1);
            }
            else {
                updatePropertyValue();
            }
        };
        _this.updateButtonList = function (PropertyElement, id, invalid) {
            var possibleOptions = PropertyElement.possibleOptions;
            for (var key in possibleOptions) {
                if (key === id) {
                    if (invalid) {
                        possibleOptions[key].isDisabled = invalid;
                    }
                    if (possibleOptions[key].displayContentContainer) {
                        possibleOptions[key].displayContentContainer.tags = { "selected": "selected" };
                    }
                }
            }
        };
        _this.onUpdatePrefill = function (property, value) {
            if (!_this.state.viewEventHandler) {
                return;
            }
            var handler = function () {
                _this.updateDisplayValue(property.displayId, value);
            };
            _this.state.viewEventHandler.updatePrefillValue(property.pidlIdentity, value).then(handler, handler);
        };
        _this.updateState = function (update) {
            if (update) {
                _this.pendingUpdates.push(update);
            }
            if (_this.wrapper.current && _this.pendingUpdates.length > 0) {
                var action = _this.pendingUpdates[0];
                _this.pendingUpdates.splice(0, 1);
                _this.wrapper.current.update(action, function () { return _this.updateState(); });
            }
        };
        _this.getTelemetryLogger = function () {
            var _a;
            var _b = _this.props, callbacksIn = _b.callbacksIn, elementFactory = _b.elementFactory, telemetryOptions = _b.telemetryOptions;
            var isReactNative = (_a = elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) === null || _a === void 0 ? void 0 : _a.call(elementFactory);
            var callbackLogger = callbacksIn === null || callbacksIn === void 0 ? void 0 : callbacksIn.telemetryLogger;
            var telemetryLoggerAvailable = !!(elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.telemetryLogger);
            if (isReactNative && telemetryLoggerAvailable) {
                // Native logger, no 1ds package available
                return _this.props.elementFactory.telemetryLogger(callbackLogger, telemetryOptions);
            }
            var oneDSLogger$1 = new oneDSLogger();
            return new LoggerWrapper(oneDSLogger$1, callbackLogger);
        };
        _this.initPidl = function () {
            var _a = _this.props, userContext = _a.userContext, returnOptions = _a.returnOptions, displayOptions = _a.displayOptions, telemetryOptions = _a.telemetryOptions, callbacksIn = _a.callbacksIn, transformersIn = _a.transformersIn, onShowHideBusy = _a.onShowHideBusy, pidlsdkMock = _a.pidlsdkMock, pidlPayload = _a.pidlPayload, localDataSourceProviders = _a.localDataSourceProviders;
            var transformers = __assign$1({}, transformersIn);
            var callbacks = __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: _this.getTelemetryLogger(), view: callbacksIn && callbacksIn.view ? callbacksIn.view : {
                    // tslint:disable-next-line: no-empty
                    initialize: function () { },
                    render: function (renderContext) {
                        if (!renderContext.pageElement || !renderContext.pageElement.children || renderContext.pageElement.children.length === 0) {
                            return { succeeded: false };
                        }
                        var elements = {};
                        var properties = {};
                        var values = {};
                        var transformedPage = _this.transformPage(renderContext.pageElement, renderContext.displaySettings);
                        foldChildren(transformedPage.children, elements, properties);
                        for (var key in properties) {
                            if (properties.hasOwnProperty(key)) {
                                values[key] = renderContext.viewEventHandler.getModelPropertyValue(key) || "";
                            }
                        }
                        renderContext.viewEventHandler.captchaHyperlinkClickHandler = _this.toggleVisualCaptcha;
                        if (renderContext.updateReason === viewUpdateReasons.modelCreated) {
                            _this.pageHasSecureFields = renderContext.viewEventHandler.hasSecureFields(renderContext.pageElement);
                            if (_this.pageHasSecureFields) {
                                _this.setState({ waitForSecureFields: true });
                            }
                        }
                        _this.setState({
                            elements: elements,
                            properties: properties,
                            pageElement: transformedPage,
                            viewEventHandler: renderContext.viewEventHandler,
                            displaySettings: renderContext.displaySettings,
                            eventHub: renderContext.eventHub,
                        });
                        return { succeeded: true };
                    },
                    reset: function () { },
                    showHideBusy: function (show) { return onShowHideBusy && onShowHideBusy(show); },
                    // tslint:disable-next-line: no-empty
                    markAsFilled: function (containerDivId) { },
                    // tslint:disable-next-line: no-empty
                    markAsUnfilled: function (containerDivId) { },
                    // tslint:disable-next-line: no-empty
                    checkAndMarkAsFilled: function (containerDivId, propertyId) { },
                    // tslint:disable-next-line: no-empty
                    checkAndMarkAsUnfilled: function (containerDivId, propertyId) { },
                    // tslint:disable-next-line: no-empty
                    setFocusOnFirstError: function () {
                        setTimeout(function () {
                            var _a, _b, _c, _d;
                            if (_this.state.firstErrorPropertyName) {
                                if ((_b = (_a = _this._propertyElementErrorRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus) {
                                    (_d = (_c = _this._propertyElementErrorRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.focus();
                                }
                                _this.setState({ firstErrorPropertyName: undefined });
                            }
                        }, 100);
                    },
                    showPropertyError: function (error) {
                        _this.showPropertyError(error);
                        return true;
                    },
                    showGroupError: function (error) {
                        // TODO: Refactor pidlsdk to call showPropertyError with all errors instead
                        //      of one at a time which causes the previous errors to be lost
                        _this.showGroupError(error);
                        return true;
                    },
                    showPageError: function (error) {
                        _this.setState({ pageError: error });
                        return false;
                    },
                    hidePropertyError: function (propertyName) {
                        _this.hidePropertyError(propertyName);
                    },
                    hidePageError: function () { _this.setState({ pageError: undefined }); },
                    postMessageToChildIFrames: function (params) {
                        var result = true;
                        if (_this.iFrameInnerRefs) {
                            _this.iFrameInnerRefs.forEach(function (value, index, array) {
                                if (value && value.current && value.current.postMessage) {
                                    var currentResult = value.current.postMessage(params);
                                    result = result && currentResult;
                                }
                                else {
                                    result = false;
                                }
                            });
                        }
                        return result;
                    },
                    getPageElementValues: function () {
                        return _this.wrapper.current ? _this.wrapper.current.getPropertyState().values : {};
                    },
                    setDisabledByDisplayId: function (displayId, val, accessibilityData) {
                        // TODO: Set context to enable/disable buttons
                    },
                    getVisibleProperties: function () {
                        if (_this.wrapper.current && _this.state.pageElement) {
                            var propertyNames = [];
                            _this.wrapper.current.getPropertyNames([_this.state.pageElement], propertyNames);
                            return propertyNames;
                        }
                        return [];
                    },
                    updatePrefillControls: function () {
                        _this.updatePropertyValues();
                    },
                    updatePropertyValue: function (propertyName, editable, propertyValue, context) {
                        var property = _this.state.properties[propertyName];
                        if (property) {
                            _this.updateDisplayValue(property.displayName, propertyValue);
                        }
                    },
                    updateButtonList: function (PropertyElement, id, invalid) {
                        _this.updateButtonList(PropertyElement, id, invalid);
                    },
                    setAccessibilityText: function (propertyElement, text) {
                        _this.updateAccessibilityText(propertyElement.getPropertyName(), text);
                    },
                    hideModalDialog: function () {
                        var _a, _b;
                        (_b = (_a = _this._modalRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.toggleDisplay(false);
                    },
                    getViewType: function () {
                        return "reactview";
                    }
                } });
            var newControl;
            if (pidlsdkMock) {
                newControl = pidlsdkMock.initMock(userContext, returnOptions, _this.eventHandler, displayOptions, telemetryOptions, callbacks, transformers);
            }
            else {
                newControl = new controlApi(userContext, returnOptions, _this.eventHandler, __assign$1(__assign$1({}, displayOptions), { containerId: displayOptions.containerId || "" }), callbacks, telemetryOptions, _this.privateEventHandler, _this.oneDSService, transformers, pidlPayload, localDataSourceProviders);
            }
            _this.props.operation(newControl);
            return newControl;
        };
        if (_this.moreThanOneBusyBlockPropExists()) {
            throw new Error(errorMessages.onlyOneBusyBlockPropAllowed.debugMessage);
        }
        _this.eventHandler = function (eventName, eventParams) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (((_a = _this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.createNavigationWrapper) && (eventParams === null || eventParams === void 0 ? void 0 : eventParams.currentPageIndex) || (eventParams === null || eventParams === void 0 ? void 0 : eventParams.pageId)) {
                if (eventParams.currentPageIndex !== _this.state.currentPageIndex || eventParams.pageId !== _this.state.currentPageId) {
                    _this.setState({
                        currentPageIndex: eventParams === null || eventParams === void 0 ? void 0 : eventParams.currentPageIndex,
                        currentPageId: eventParams === null || eventParams === void 0 ? void 0 : eventParams.pageId,
                    });
                }
            }
            if (((_b = _this.props.elementFactory) === null || _b === void 0 ? void 0 : _b.createNavigationWrapper) && eventName === eventNames.pageRefreshed) {
                // NavigationWrapper maintains its own element refs for xbox controller focus logic.
                // Refs get refreshed in most cases, except when pidl resolve happens for the same card type,
                // in which case, we need to force refresh using the event captured here.
                (_d = (_c = _this._navigationWrapperRef.current) === null || _c === void 0 ? void 0 : _c.forceFocusRefRefresh) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            if (eventName === eventNames.error &&
                _this.state.pageElement &&
                (((_e = eventParams === null || eventParams === void 0 ? void 0 : eventParams.error) === null || _e === void 0 ? void 0 : _e.code) === errorMessages.formSubmissionFailedBadUserInput.code ||
                    ((_f = eventParams === null || eventParams === void 0 ? void 0 : eventParams.error) === null || _f === void 0 ? void 0 : _f.code) === errorMessages.formValidationFailed.code) &&
                ((_g = eventParams === null || eventParams === void 0 ? void 0 : eventParams.error) === null || _g === void 0 ? void 0 : _g.errors) &&
                ((_h = eventParams === null || eventParams === void 0 ? void 0 : eventParams.error) === null || _h === void 0 ? void 0 : _h.errors.length) > 0 &&
                (((_j = eventParams === null || eventParams === void 0 ? void 0 : eventParams.error) === null || _j === void 0 ? void 0 : _j.errors[0].propertyName) || ((_k = eventParams === null || eventParams === void 0 ? void 0 : eventParams.error) === null || _k === void 0 ? void 0 : _k.errors[0].groupDisplayId))) {
                var firstVisibleError = _this.findFirstVisibleErroredProperty(_this.state.pageElement.children, eventParams.error.errors);
                _this.setState({
                    firstErrorPropertyName: (_l = firstVisibleError === null || firstVisibleError === void 0 ? void 0 : firstVisibleError.getPropertyName()) !== null && _l !== void 0 ? _l : eventParams.error.errors[0].propertyName
                });
            }
            if (eventName === eventNames.propertySelected) {
                _this.setState({
                    disableFocusOnLoad: false,
                    lastFocusedPropertyName: eventParams === null || eventParams === void 0 ? void 0 : eventParams.propertyName,
                });
            }
            if (eventName === eventNames.selectionChanged) {
                _this.setState({
                    disableFocusOnLoad: false,
                    lastFocusedPropertyName: eventParams === null || eventParams === void 0 ? void 0 : eventParams.propertyName,
                    lastFocusedPropertyValue: eventParams === null || eventParams === void 0 ? void 0 : eventParams.propertyValue,
                });
            }
            _this.focusOnPageRefresh(eventName);
            return _this.props.onEvent && _this.props.onEvent(eventName, eventParams);
        };
        _this.privateEventHandler = function (eventName, eventParams) {
            if (eventName === privateEventNames.propertyUnselected) {
                _this.setState({
                    lastFocusedPropertyName: undefined,
                    firstErrorPropertyName: undefined
                });
            }
            if (eventName === privateEventNames.success) {
                _this.reset();
            }
            _this.focusOnPageRefresh(eventName);
        };
        if (_this.props && _this.props.elementFactory && _this.props.elementFactory.getOneDSService) {
            _this.oneDSService = _this.props.elementFactory.getOneDSService();
        }
        _this.wrapper = React.createRef();
        _this.pendingUpdates = [];
        _this.iFrameInnerRefs = [];
        _this.state = {
            elements: {},
            properties: {},
            pageError: undefined,
            viewEventHandler: undefined,
            displaySettings: undefined,
            eventHub: undefined,
            showBusyBlock: false,
            currentPageIndex: null,
            currentPageId: null,
            lastFocusedPropertyName: undefined,
            lastFocusedPropertyValue: undefined,
            firstErrorPropertyName: undefined,
            disableFocusOnLoad: _this.props.displayOptions.disableFocusOnLoad,
            waitForSecureFields: false,
            openDropdownId: ""
        };
        return _this;
    }
    PidlComponent.prototype.componentDidMount = function () {
        var env = this.props.env;
        pidlEnv.set(env || defaultEnvironment);
        this.pidlControlApi = this.pidlControlApi || this.initPidl();
    };
    PidlComponent.prototype.isAddResourceProps = function (object) {
        return object && object.pidlDocInfo;
    };
    PidlComponent.prototype.componentDidUpdate = function (prevProps) {
        this.pidlControlApi = this.pidlControlApi || this.initPidl();
        // Resetting the controlApi on change o the pidlDocInfo. This will force update of the page.
        // TODO: Need to look for other updates too.
        if (this.isAddResourceProps(this.props)) {
            if (prevProps && prevProps.pidlDocInfo && this.props.pidlDocInfo && JSON.stringify(prevProps.pidlDocInfo) !== JSON.stringify(this.props.pidlDocInfo)) {
                this.pidlControlApi = this.initPidl();
            }
        }
    };
    PidlComponent.prototype.componentWillUnmount = function () {
        // Clean up: unsubscribe or clear timers
        try {
            var viewEventHandler = this.state.viewEventHandler;
            viewEventHandler.clearTimeoutPromise();
        }
        catch (e) {
            // We don't want to throw an error in the cleanup
        }
    };
    PidlComponent.prototype.wrapGroupedElements = function (elementFactory, innerJSX) {
        var pageError = this.state.pageError;
        if ((elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.isReactNative) && elementFactory.isReactNative()) {
            return (React.createElement(React.Fragment, null, innerJSX));
        }
        return (React.createElement("div", { className: classnames("pidl-react-page-error", { "d-none": !pageError || !pageError.message }) }, innerJSX));
    };
    PidlComponent.prototype.render = function () {
        var _a;
        var _b = this.props, displayOptions = _b.displayOptions, children = _b.children, onPropertyChange = _b.onPropertyChange, elementFactory = _b.elementFactory, busyBlockElement = _b.busyBlockElement, propertyElementRef = _b.propertyElementRef, theme = _b.theme;
        var _c = this.state, pageElement = _c.pageElement, viewEventHandler = _c.viewEventHandler, pageError = _c.pageError, displaySettings = _c.displaySettings, eventHub = _c.eventHub, firstErrorPropertyName = _c.firstErrorPropertyName, lastFocusedPropertyName = _c.lastFocusedPropertyName, lastFocusedPropertyValue = _c.lastFocusedPropertyValue;
        var pidlDisplayOptions = displayOptions;
        if (busyBlockElement && React.isValidElement(busyBlockElement)) {
            pidlDisplayOptions.busyBlockShowHideHandler = this.busyBlockShowHide;
        }
        var output = children;
        if (this.pidlControlApi && pageElement && viewEventHandler) {
            this.attachFocusRef(pageElement, propertyElementRef, firstErrorPropertyName, lastFocusedPropertyName, lastFocusedPropertyValue);
            this.attachModalRef(pageElement);
            var pageChildren = pageElement.children.map(elementMap(viewEventHandler, this.onUpdateValue, this.onUpdatePrefill, this.iFrameInnerRefs, this.setOpenDropdownId, this.state.openDropdownId));
            var onKeyPressPidlActions_1 = new Map();
            var keyPidlActions_1 = pageElement.keyPidlActions;
            Object.keys(keyPidlActions_1 ? keyPidlActions_1 : {}).forEach(function (key) {
                var pidlAction = keyPidlActions_1[key];
                onKeyPressPidlActions_1.set(key, function () {
                    viewEventHandler.invokePidlAction(pidlAction);
                });
            });
            var _d = this.state, eventHub_1 = _d.eventHub, waitForSecureFields_1 = _d.waitForSecureFields;
            var pageWrapper = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.createNavigationWrapper)
                ? elementFactory.createNavigationWrapper(pageChildren, this.state.currentPageIndex, this.state.currentPageId, this.cancel, this.movePrevPage, this.moveToLastPage, this.moveToFirstPage, this.moveNextPage, this._navigationWrapperRef, onKeyPressPidlActions_1)
                : this.pageHasSecureFields ? React.createElement("div", { style: { display: (waitForSecureFields_1 ? 'none' : 'block') } }, pageChildren)
                    : React.createElement(React.Fragment, null, pageChildren);
            output = (React.createElement(StateWrapper, { ref: this.wrapper, getModelPropertyValue: viewEventHandler.getModelPropertyValue, onPropertyChange: onPropertyChange, pageElement: pageElement, elementFactory: elementFactory, displayOptions: pidlDisplayOptions, displaySettings: displaySettings, eventHub: eventHub_1, theme: theme, userContext: this.props.userContext }, pageWrapper));
        }
        var renderBusyBlock = function () {
            return (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.createBusyBlockWrapper)
                ? elementFactory.createBusyBlockWrapper(React.cloneElement(busyBlockElement))
                : React.cloneElement(busyBlockElement);
        };
        var pageAlert = pageError ? React.createElement(PageAlert, { message: pageError.message }) : null;
        var _e = this.state, waitForSecureFields = _e.waitForSecureFields, showBusyBlock = _e.showBusyBlock;
        var secureFieldPromiseExists = ((_a = viewEventHandler === null || viewEventHandler === void 0 ? void 0 : viewEventHandler.getSecurePropertyLoadedPromises()) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (this.pageHasSecureFields && waitForSecureFields && secureFieldPromiseExists) {
            if (!showBusyBlock) {
                this.busyBlockShowHide(true);
            }
            if (!this.alreadyWaiting) {
                eventHub.secureFieldLoadWaitStarted();
                this.waitForSecureFieldsLoadCompletion();
            }
        }
        return React.createElement(React.Fragment, null,
            React.createElement(RenderContext.Provider, { value: { elementFactory: elementFactory, displayOptions: pidlDisplayOptions, displaySettings: displaySettings, theme: theme, userContext: this.props.userContext } },
                React.createElement(React.Fragment, null, this.wrapGroupedElements(elementFactory, pageAlert))),
            this.shouldRenderBusyBlock() && renderBusyBlock(),
            output);
    };
    PidlComponent.prototype.attachFocusRef = function (pageElement, partnerPropertyElementRef, firstErrorPropertyName, lastFocusedPropertyName, lastFocusedPropertyValue) {
        var children = pageElement.children;
        var focusTarget;
        if (firstErrorPropertyName) {
            focusTarget = this.findPropertyElementByPropertyName(children, firstErrorPropertyName);
            if (focusTarget) {
                focusTarget.propertyElementRef = this._propertyElementErrorRef;
            }
        }
        else {
            if (lastFocusedPropertyName) {
                focusTarget = this.findPropertyElementByPropertyName(children, lastFocusedPropertyName, lastFocusedPropertyValue);
                if (!focusTarget) {
                    focusTarget = this.findFirstVisibleEnabledPropertyElement(children);
                }
            }
            else {
                focusTarget = this.findFirstVisibleEnabledPropertyElement(children);
            }
            var highlightedButton = this.findHighlightedButton(children);
            if (focusTarget) {
                if (focusTarget.isButton() && highlightedButton) {
                    focusTarget = highlightedButton;
                }
                if (!focusTarget.propertyElementRef) {
                    focusTarget.propertyElementRef = partnerPropertyElementRef !== null && partnerPropertyElementRef !== void 0 ? partnerPropertyElementRef : this._propertyElementRef;
                }
            }
        }
    };
    PidlComponent.prototype.attachModalRef = function (pageElement) {
        var children = pageElement.children;
        var modalElement;
        children.forEach(function (childElement) {
            if (isGroupElement(childElement)) {
                modalElement = childElement;
            }
        });
        if (modalElement) {
            modalElement.groupElementRef = this._modalRef;
        }
    };
    PidlComponent.prototype.propertiesVisitorProcessingDataProperty = function (modelProperties, action, context) {
        if (!modelProperties) {
            return;
        }
        if (!Array.isArray(modelProperties)) {
            return this.propertyVisitorProcessingDataProperty(modelProperties, action, context);
        }
        else {
            for (var index = 0; index < modelProperties.length; index++) {
                var stopProcessing = this.propertyVisitorProcessingDataProperty(modelProperties[index], action, context);
                if (stopProcessing) {
                    return stopProcessing;
                }
            }
        }
    };
    PidlComponent.prototype.propertyVisitorProcessingDataProperty = function (modelProperty, action, context) {
        if (!modelProperty) {
            return;
        }
        if (modelProperty.isProperty() || modelProperty.isSecureProperty() || modelProperty.isButton()) {
            var stopProcessing = action(modelProperty, context);
            if (stopProcessing) {
                return stopProcessing;
            }
        }
        if (modelProperty.children && modelProperty.children.length > 0 && (!context || !context.stopDescendantsProcessing)) {
            return this.propertiesVisitorProcessingDataProperty(modelProperty.children, action, context);
        }
        if (context) {
            delete context.stopDescendantsProcessing;
        }
    };
    PidlComponent.prototype.propertiesVisitorProcessingAny = function (modelProperties, action, context) {
        if (!modelProperties) {
            return;
        }
        if (!Array.isArray(modelProperties)) {
            return this.propertyVisitorProcessingAny(modelProperties, action, context);
        }
        else {
            for (var index = 0; index < modelProperties.length; index++) {
                var stopProcessing = this.propertyVisitorProcessingAny(modelProperties[index], action, context);
                if (stopProcessing) {
                    return stopProcessing;
                }
            }
        }
    };
    PidlComponent.prototype.propertyVisitorProcessingAny = function (modelProperty, action, context) {
        if (!modelProperty) {
            return;
        }
        var stopProcessing = action(modelProperty, context);
        if (stopProcessing) {
            return stopProcessing;
        }
        if (modelProperty.children && modelProperty.children.length > 0 && (!context || !context.stopDescendantsProcessing)) {
            return this.propertiesVisitorProcessingAny(modelProperty.children, action, context);
        }
        if (context) {
            delete context.stopDescendantsProcessing;
        }
    };
    PidlComponent.prototype.pendingPropertyValue = function (propertyName, value) {
        this.updateState({
            run: pendingValueUpdate,
            args: [propertyName, value],
        });
    };
    PidlComponent.prototype.updatePropertyValues = function () {
        this.updateState({
            run: propertyValueUpdate,
            args: [],
        });
    };
    PidlComponent.prototype.updateDisplayValue = function (displayName, value) {
        this.updateState({
            run: displayValueUpdate,
            args: [displayName, value],
        });
    };
    PidlComponent.prototype.updateAccessibilityText = function (propertyName, accessibilityText) {
        this.updateState({
            run: accessibilityTextUpdate,
            args: [propertyName, accessibilityText],
        });
    };
    PidlComponent.prototype.showGroupError = function (error) {
        this.updateState({
            run: showGroupErrorUpdate,
            args: [error],
        });
    };
    PidlComponent.prototype.showPropertyError = function (error) {
        this.updateState({
            run: showPropertyErrorUpdate,
            args: [error],
        });
    };
    PidlComponent.prototype.hidePropertyError = function (propertyName) {
        this.updateState({
            run: hidePropertyErrorUpdate,
            args: [propertyName],
        });
    };
    PidlComponent.prototype.splitChildren = function (page, displaySettings) {
        var children = __spreadArray$1([], page.children, true);
        if (!children || !children.length) {
            return children;
        }
        var lastElement = children[children.length - 1];
        if (!isGroupElement(lastElement) || !lastElement.isSubmitGroup) {
            return children;
        }
        if (lastElement === null || lastElement === void 0 ? void 0 : lastElement.isSubmitGroup) {
            this.setExternalControlNames(lastElement);
            lastElement.isHidden = !displaySettings.submitButtonBlock.show;
        }
        var operationType = lastElement.operationType, pidlIdentity = lastElement.pidlIdentity, isLinkedPidl = lastElement.isLinkedPidl;
        children.pop();
        var pageBlockDisplayDescription = {
            displayId: htmlElementIdSuffixes.pageBlock,
            displayType: pidlDisplayTypesValues.group,
            displayName: null,
            styleHints: page.displayDescription.styleHints,
        };
        var pageBlock = new GroupElement(modelElementType.group, null, pageBlockDisplayDescription, operationType, pidlIdentity, isLinkedPidl);
        pageBlock.children = children;
        lastElement.id = displaySettings.submitButtonBlock.id;
        return [
            pageBlock,
            lastElement,
        ];
    };
    PidlComponent.prototype.transformPage = function (page, displaySettings) {
        return __assign$1(__assign$1({}, page), { children: this.splitChildren(page, displaySettings) });
    };
    PidlComponent.prototype.setExternalControlNames = function (lastElement) {
        var pidlExternalControlProps = new Map();
        var gohome = supportedPidlActions.gohome;
        var submit = supportedPidlActions.submit;
        var next = supportedPidlActions.next;
        var prev = supportedPidlActions.prev;
        var members = lastElement.members;
        if (members) {
            members.forEach(function (member) {
                var _a;
                if (member.displayContent &&
                    ((_a = member.pidlAction) === null || _a === void 0 ? void 0 : _a.type) &&
                    (
                    // This check probably isn't needed, but let's
                    // restrict pidlExternalControlProps to use only
                    // four action types for now
                    member.pidlAction.type == gohome ||
                        member.pidlAction.type == submit ||
                        member.pidlAction.type == next ||
                        member.pidlAction.type == prev)) {
                    pidlExternalControlProps[member.pidlAction.type] = {
                        type: member.pidlAction.type,
                        displayContent: member.displayContent,
                    };
                }
            });
        }
        this.pidlExternalControlProps = pidlExternalControlProps;
    };
    PidlComponent.defaultProps = {
        env: defaultEnvironment,
    };
    return PidlComponent;
}(React.Component));

var BaseComponent = /** @class */ (function (_super) {
    __extends$1(BaseComponent, _super);
    function BaseComponent(props, pidlOperation) {
        var _this = _super.call(this, props) || this;
        _this.moveNextPage = function () {
            if (_this.pidlRef.current && _this.pidlRef.current.moveNextPage) {
                return _this.pidlRef.current.moveNextPage();
            }
            return false;
        };
        _this.submitPage = function () {
            if (_this.pidlRef.current && _this.pidlRef.current.submitPage) {
                return _this.pidlRef.current.submitPage();
            }
            return false;
        };
        _this.movePrevPage = function () {
            if (_this.pidlRef.current && _this.pidlRef.current.movePrevPage) {
                return _this.pidlRef.current.movePrevPage();
            }
            return false;
        };
        _this.moveToFirstPage = function () {
            if (_this.pidlRef.current && _this.pidlRef.current.moveToFirstPage) {
                return _this.pidlRef.current.moveToFirstPage();
            }
            return false;
        };
        _this.cancel = function () {
            if (_this.pidlRef.current && _this.pidlRef.current.cancel) {
                return _this.pidlRef.current.cancel();
            }
            return false;
        };
        _this.getPidlExternalControlPropsMap = function () {
            if (_this.pidlRef.current && _this.pidlRef.current.getPidlExternalControlPropsMap) {
                return _this.pidlRef.current.getPidlExternalControlPropsMap();
            }
            return null;
        };
        _this.getSelectedResource = function () {
            return _this.pidlRef.current && _this.pidlRef.current.getSelectedResource();
        };
        _this.getPidlPayload = function () {
            return _this.pidlRef.current && _this.pidlRef.current.getPidlPayload();
        };
        _this.postMessageToChildIFrames = function (params) {
            if (_this.pidlRef.current && _this.pidlRef.current.postMessageToChildIFrames) {
                return _this.pidlRef.current.postMessageToChildIFrames(params);
            }
            return false;
        };
        _this.implementationMissing = function (source, component, parameters) {
            var _a, _b, _c;
            if (!_this.pidlRef.current) {
                return null;
            }
            ;
            var eventHub = (_c = (_b = (_a = _this.pidlRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.eventHub;
            eventHub === null || eventHub === void 0 ? void 0 : eventHub.implementationMissing(source, component, parameters);
        };
        _this.updateChildIFramesHeight = function (height) {
            _this.pidlRef.current &&
                _this.pidlRef.current.updateChildIFramesHeight &&
                _this.pidlRef.current.updateChildIFramesHeight(height);
        };
        _this.pidlRef = React.createRef();
        _this.pidlOperation = pidlOperation;
        return _this;
    }
    BaseComponent.prototype.render = function () {
        return (React.createElement(PidlComponent, __assign$1({}, this.props, { ref: this.pidlRef, operation: this.pidlOperation }), this.props.children));
    };
    return BaseComponent;
}(React.Component));

var AddAddressInternal = /** @class */ (function (_super) {
    __extends$1(AddAddressInternal, _super);
    function AddAddressInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.addAddress(_this.props.pidlDocInfo, _this.props.prefillData, _this.props.options); }) || this;
        return _this;
    }
    return AddAddressInternal;
}(BaseComponent));
var AddAddress = /** @class */ (function (_super) {
    __extends$1(AddAddress, _super);
    function AddAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function (scenario, country, language, partner, parameters, addressType, setAsDefaultBilling) {
            var compiledParams = {
                operation: AddAddressConstants.Operation,
                type: addressType || AddAddressConstants.DefaultAddressType,
                scenario: scenario,
                country: country,
                language: language,
                partner: partner,
                setAsDefaultBilling: scenario === exports.AddressScenario.profile ? true : setAsDefaultBilling,
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (success, failure, gohome) {
            return {
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.onEvent = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, viewTermsHandler = _a.viewTermsHandler;
            var _b = constants, eventNames = _b.eventNames, CustomTriggerEventConstants = _b.CustomTriggerEventConstants;
            if ((eventName === eventNames.triggerEvent && viewTermsHandler && eventParams.eventName === CustomTriggerEventConstants.viewTermsTriggered) ||
                (eventName === eventNames.navigate && viewTermsHandler && eventParams.displayId === AddAddressConstants.ViewTermsId)) {
                viewTermsHandler(eventParams);
            }
            if (onEvent) {
                onEvent(eventName, eventParams);
            }
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.AddAddress, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    AddAddress.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    AddAddress.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    AddAddress.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, country = _a.country, language = _a.language, scenario = _a.scenario, addressType = _a.addressType, partner = _a.partner, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, prefillData = _a.prefillData, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, telemetryOptions = _a.telemetryOptions, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, setAsDefaultBilling = _a.setAsDefaultBilling, headers = _a.headers, callbacksIn = _a.callbacksIn, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters(scenario, country, language, partner, parameters, addressType, setAsDefaultBilling);
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(AddAddressInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: AddAddressConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), pidlDocInfo: {
                    resourceType: AddAddressConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.onEvent, userContext: {
                    authToken: authToken,
                    userId: AddAddressConstants.UserId,
                    additionalHeaders: headers
                }, elementFactory: elementFactory, prefillData: prefillData, pidlsdkMock: pidlsdkMock, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return AddAddress;
}(React__default.Component));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var AddPaymentInstrumentInternal = /** @class */ (function (_super) {
    __extends$1(AddPaymentInstrumentInternal, _super);
    function AddPaymentInstrumentInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.addPaymentInstrument(_this.props.pidlDocInfo, _this.props.prefillData, _this.props.options); }) || this;
        return _this;
    }
    return AddPaymentInstrumentInternal;
}(BaseComponent));
var AddPaymentInstrument = /** @class */ (function (_super) {
    __extends$1(AddPaymentInstrument, _super);
    function AddPaymentInstrument(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function (country, language, partner, parameters, paymentFamily, paymentType, completePrerequisites, sessionId, scenario) {
            var compiledParams = {
                operation: AddPaymentInstrumentConstants.Operation,
                country: country,
                language: language,
                partner: partner,
                completePrerequisites: completePrerequisites,
                type: paymentType,
                family: paymentFamily,
                sessionId: sessionId,
                scenario: scenario
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (redirectionSuccessUrl, redirectionFailureUrl, success, failure, gohome) {
            var redirectionUrl = {
                success: redirectionSuccessUrl,
                failure: redirectionFailureUrl,
            };
            return {
                urls: redirectionUrl,
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.compileCallbacks = function () {
            var _a = _this.props, telemetryLogger = _a.telemetryLogger, elementFactory = _a.elementFactory, callbacksIn = _a.callbacksIn;
            var ret = __assign$1({}, callbacksIn);
            if (telemetryLogger) {
                ret["telemetryLogger"] = telemetryLogger;
            }
            if (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.encryptionHandler) {
                ret["encryptionHandler"] = elementFactory.encryptionHandler();
            }
            return ret;
        };
        _this.compileOptions = function (greenId) {
            if (!greenId) {
                return null;
            }
            return {
                riskData: {
                    greenId: greenId,
                },
            };
        };
        _this.onEvent = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, viewTermsHandler = _a.viewTermsHandler;
            var _b = constants, eventNames = _b.eventNames, CustomTriggerEventConstants = _b.CustomTriggerEventConstants;
            if ((eventName === eventNames.triggerEvent && viewTermsHandler && eventParams.eventName === CustomTriggerEventConstants.viewTermsTriggered) ||
                (eventName === eventNames.navigate && viewTermsHandler && eventParams.displayId === AddPaymentInstrumentConstants.ViewTermsId)) {
                viewTermsHandler(eventParams);
            }
            if (onEvent) {
                onEvent(eventName, eventParams);
            }
        };
        _this.getResourceType = function () {
            var sessionId = _this.props.sessionId;
            if (sessionId != null) {
                return "AddPiQrCode";
            }
            else {
                return AddPaymentInstrumentConstants.ResourceType;
            }
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.AddPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    AddPaymentInstrument.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    AddPaymentInstrument.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    AddPaymentInstrument.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, completePrerequisites = _a.completePrerequisites, scenario = _a.scenario, sessionId = _a.sessionId, country = _a.country, language = _a.language, partner = _a.partner, paymentFamily = _a.paymentFamily, paymentType = _a.paymentType, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, prefillData = _a.prefillData, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, telemetryOptions = _a.telemetryOptions, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, headers = _a.headers, greenId = _a.greenId, redirectionSuccessUrl = _a.redirectionSuccessUrl, redirectionFailureUrl = _a.redirectionFailureUrl, serviceOverrides = _a.serviceOverrides, useWebView2 = _a.useWebView2, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters(country, language, partner, parameters, paymentFamily, paymentType, completePrerequisites, sessionId, scenario);
        var returnOptions = this.compileReturnOptions(redirectionSuccessUrl, redirectionFailureUrl, onSuccess, onFailure, onCancel);
        var callbacksIn = this.compileCallbacks();
        var options = this.compileOptions(greenId);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(AddPaymentInstrumentInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: AddPaymentInstrumentConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock, useWebView2: useWebView2 }), pidlDocInfo: {
                    resourceType: this.getResourceType(),
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.onEvent, userContext: {
                    authToken: authToken,
                    userId: AddPaymentInstrumentConstants.UserId,
                    additionalHeaders: headers,
                    serviceOverrides: serviceOverrides,
                }, elementFactory: elementFactory, prefillData: prefillData, pidlsdkMock: pidlsdkMock, callbacksIn: callbacksIn, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef, options: options })));
    };
    return AddPaymentInstrument;
}(React__default.Component));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var ApplyPaymentInstrumentInternal = /** @class */ (function (_super) {
    __extends$1(ApplyPaymentInstrumentInternal, _super);
    function ApplyPaymentInstrumentInternal(props) {
        var _this = this;
        var pidlDocInfo = __assign$1(__assign$1({}, props.pidlDocInfo), { resourceType: "PaymentInstrument" });
        _this = _super.call(this, props, function (controlApi) { return controlApi.applyResource(pidlDocInfo, _this.props.prefillData, _this.props.options); }) || this;
        return _this;
    }
    return ApplyPaymentInstrumentInternal;
}(BaseComponent));
var ApplyPaymentInstrument = /** @class */ (function (_super) {
    __extends$1(ApplyPaymentInstrument, _super);
    function ApplyPaymentInstrument(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function () {
            var _a = _this.props, country = _a.country, language = _a.language, partner = _a.partner, parameters = _a.parameters, paymentFamily = _a.paymentFamily, paymentType = _a.paymentType, scenario = _a.scenario, prefillData = _a.prefillData, provider = _a.provider, channel = _a.channel, referrerId = _a.referrerId, sessionId = _a.sessionId, ocid = _a.ocid;
            var compiledParams = {
                operation: ApplyPaymentInstrumentConstants.Operation,
                country: country,
                language: language,
                partner: partner,
                scenario: scenario,
                type: paymentType,
                family: paymentFamily,
                prefillData: prefillData,
                provider: provider,
                channel: channel,
                referrerId: referrerId,
                sessionId: sessionId,
                ocid: ocid,
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            var _a, _b, _c;
            var timeoutErr = (_c = (_b = (_a = pidl === null || pidl === void 0 ? void 0 : internal_core) === null || _a === void 0 ? void 0 : _a.errorMessages) === null || _b === void 0 ? void 0 : _b.pollingTimedOut) === null || _c === void 0 ? void 0 : _c.code;
            if (timeoutErr && error.code === timeoutErr.toString()) {
                _this.props.onTimeOut(error);
                return;
            }
            _this.props.onFailure(error);
        };
        _this.compileReturnOptions = function (success, failure, gohome, redirectReturnUrls) {
            return {
                urls: redirectReturnUrls,
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.compileCallbacks = function () {
            var _a = _this.props, telemetryLogger = _a.telemetryLogger, elementFactory = _a.elementFactory, callbacksIn = _a.callbacksIn;
            var ret = __assign$1({}, callbacksIn);
            if (telemetryLogger) {
                ret.telemetryLogger = telemetryLogger;
            }
            if (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.encryptionHandler) {
                ret.encryptionHandler = elementFactory.encryptionHandler();
            }
            return ret;
        };
        _this.onEvent = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, onNavigate = _a.onNavigate;
            if (onNavigate && eventName === eventNames.navigate) {
                onNavigate(eventParams);
            }
            if (onEvent) {
                onEvent(eventName, eventParams);
            }
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.ApplyPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    ApplyPaymentInstrument.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    ApplyPaymentInstrument.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    // tslint:disable-next-line: member-ordering
    ApplyPaymentInstrument.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, busyBlockElement = _a.busyBlockElement, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, redirectReturnUrls = _a.redirectReturnUrls, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, prefillData = _a.prefillData, telemetryOptions = _a.telemetryOptions, propertyElementRef = _a.propertyElementRef, onEvent = _a.onEvent, onPageRendered = _a.onPageRendered, headers = _a.headers, useWebView2 = _a.useWebView2, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters();
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel, redirectReturnUrls);
        var callbacksIn = this.compileCallbacks();
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(ApplyPaymentInstrumentInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: ApplyPaymentInstrumentConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock, useWebView2: useWebView2 }), pidlDocInfo: {
                    resourceType: ApplyPaymentInstrumentConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.onEvent, userContext: {
                    authToken: authToken,
                    userId: ApplyPaymentInstrumentConstants.UserId,
                    additionalHeaders: headers,
                }, elementFactory: elementFactory, prefillData: prefillData, pidlsdkMock: pidlsdkMock, callbacksIn: callbacksIn, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return ApplyPaymentInstrument;
}(React__default.Component));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var AddResource = /** @class */ (function (_super) {
    __extends$1(AddResource, _super);
    function AddResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.addResource(_this.props.pidlDocInfo, _this.props.prefillData, _this.props.options); }) || this;
        return _this;
    }
    return AddResource;
}(BaseComponent));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for applying resource represented by the PIDL document.
 */
var ApplyResource = /** @class */ (function (_super) {
    __extends$1(ApplyResource, _super);
    function ApplyResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.applyResource(_this.props.pidlDocInfo, _this.props.prefillData, _this.props.options); }) || this;
        return _this;
    }
    return ApplyResource;
}(BaseComponent));

var ConfirmPaymentInternal = /** @class */ (function (_super) {
    __extends$1(ConfirmPaymentInternal, _super);
    function ConfirmPaymentInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.handlePurchasePendingState(_this.props.parameters); }) || this;
        return _this;
    }
    return ConfirmPaymentInternal;
}(BaseComponent));
var ConfirmPayment = /** @class */ (function (_super) {
    __extends$1(ConfirmPayment, _super);
    function ConfirmPayment(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileDisplayOptions = function () {
            var _a = _this.props, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, useWebView2 = _a.useWebView2, displayOptions = _a.displayOptions;
            return __assign$1(__assign$1({}, displayOptions), { containerId: ConfirmPaymentConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock, useWebView2: useWebView2 });
        };
        _this.compileParameters = function () {
            var _a = _this.props, country = _a.country, language = _a.language, partner = _a.partner, piid = _a.piid, orderId = _a.orderId, sessionId = _a.sessionId;
            var resourceInfo = {
                resourceType: ConfirmPaymentConstants.ResourceType,
                parameters: {
                    market: country,
                    language: language,
                    partner: partner,
                    sessionId: sessionId,
                    orderId: orderId,
                },
                id: piid,
            };
            return {
                piResourceInfo: resourceInfo,
                sessionId: sessionId,
                orderId: orderId,
                options: {},
            };
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function () {
            var _a = _this.props, onSuccess = _a.onSuccess, onCancel = _a.onCancel, redirectReturnUrls = _a.redirectReturnUrls;
            var _b = __assign$1({}, redirectReturnUrls), success = _b.success, failure = _b.failure, gohome = _b.gohome;
            return {
                callbacks: {
                    success: onSuccess,
                    failure: _this.FailureHandler,
                    gohome: onCancel,
                },
                urls: {
                    success: success,
                    failure: failure,
                    gohome: gohome,
                },
            };
        };
        _this.compileCallbacksIn = function () { return (__assign$1(__assign$1({}, _this.props.callbacksIn), { telemetryLogger: _this.props.telemetryLogger })); };
        _this.compileUserContext = function () { return ({
            authToken: _this.props.authToken,
            userId: ConfirmPaymentConstants.UserId,
            additionalHeaders: _this.props.headers
        }); };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.ConfirmPayment, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    ConfirmPayment.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    ConfirmPayment.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    ConfirmPayment.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, pidlsdkMock = _a.pidlsdkMock, propertyElementRef = _a.propertyElementRef, telemetryOptions = _a.telemetryOptions, onEvent = _a.onEvent, onPageRendered = _a.onPageRendered, elementFactory = _a.elementFactory, busyBlockElement = _a.busyBlockElement;
        var styleProvider = this.state.styleProvider;
        var displayOptions = this.compileDisplayOptions();
        var parameters = this.compileParameters();
        var returnOptions = this.compileReturnOptions();
        var callbacksIn = this.compileCallbacksIn();
        var userContext = this.compileUserContext();
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(ConfirmPaymentInternal, { busyBlockElement: busyBlockElement, displayOptions: displayOptions, parameters: parameters, env: env, returnOptions: returnOptions, userContext: userContext, onEvent: onEvent, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: callbacksIn, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return ConfirmPayment;
}(React__default.Component));

var CreatePaymentSession = /** @class */ (function (_super) {
    __extends$1(CreatePaymentSession, _super);
    function CreatePaymentSession(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.createPaymentSession(_this.props.paymentSessionOrData); }) || this;
        return _this;
    }
    return CreatePaymentSession;
}(BaseComponent));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var EditAddressInternal = /** @class */ (function (_super) {
    __extends$1(EditAddressInternal, _super);
    function EditAddressInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.updateResource(_this.props.resourceInfo, null, _this.props.pidlDocInfo); }) || this;
        return _this;
    }
    return EditAddressInternal;
}(BaseComponent));
var EditAddress = /** @class */ (function (_super) {
    __extends$1(EditAddress, _super);
    function EditAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function (scenario, country, language, partner, parameters, addressId) {
            var compiledParams = __assign$1({
                operation: EditAddressConstants.Operation,
                type: EditAddressConstants.AddressType,
                scenario: scenario,
            }, { country: country, language: language, partner: partner, addressId: addressId });
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (success, failure, gohome) {
            return {
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.onEvent = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, viewTermsHandler = _a.viewTermsHandler;
            var _b = constants, eventNames = _b.eventNames, CustomTriggerEventConstants = _b.CustomTriggerEventConstants;
            if ((eventName === eventNames.triggerEvent && viewTermsHandler && eventParams.eventName === CustomTriggerEventConstants.viewTermsTriggered) ||
                (eventName === eventNames.navigate && viewTermsHandler && eventParams.displayId === AddAddressConstants.ViewTermsId)) {
                viewTermsHandler(eventParams);
            }
            if (onEvent) {
                onEvent(eventName, eventParams);
            }
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        // Edit Address uses the same flow as AddAddress so we pass in AppScenario.AddAddress here to initializeStyles
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.AddAddress, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    EditAddress.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    EditAddress.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    EditAddress.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, addressId = _a.addressId, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, scenario = _a.scenario, country = _a.country, language = _a.language, partner = _a.partner, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, headers = _a.headers, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters(scenario, country, language, partner, parameters, addressId);
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(EditAddressInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: EditAddressConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), resourceInfo: {
                    id: addressId,
                    resourceType: EditAddressConstants.ResourceType,
                    parameters: {},
                }, pidlDocInfo: {
                    resourceType: EditAddressConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.onEvent, userContext: {
                    authToken: authToken,
                    userId: EditAddressConstants.UserId,
                    additionalHeaders: headers
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: { telemetryLogger: telemetryLogger }, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return EditAddress;
}(React__default.Component));

var EditPaymentInstrumentInternal = /** @class */ (function (_super) {
    __extends$1(EditPaymentInstrumentInternal, _super);
    function EditPaymentInstrumentInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.updateResource(_this.props.resourceInfo, null, _this.props.pidlDocInfo); }) || this;
        return _this;
    }
    return EditPaymentInstrumentInternal;
}(BaseComponent));
var EditPaymentInstrument = /** @class */ (function (_super) {
    __extends$1(EditPaymentInstrument, _super);
    function EditPaymentInstrument(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.onEvent = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, viewTermsHandler = _a.viewTermsHandler;
            var _b = constants, eventNames = _b.eventNames, CustomTriggerEventConstants = _b.CustomTriggerEventConstants;
            if ((eventName === eventNames.triggerEvent && viewTermsHandler && eventParams.eventName === CustomTriggerEventConstants.viewTermsTriggered) ||
                (eventName === eventNames.navigate && viewTermsHandler && eventParams.displayId === EditPaymentInstrumentConstants.ViewTermsId)) {
                viewTermsHandler(eventParams);
            }
            if (onEvent) {
                onEvent(eventName, eventParams);
            }
        };
        _this.compileParameters = function (country, language, type, family, partner, parameters) {
            var compiledParams = {
                country: country,
                language: language,
                partner: partner,
                type: type,
                family: family
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (success, gohome) {
            return {
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.EditPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    EditPaymentInstrument.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    EditPaymentInstrument.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    EditPaymentInstrument.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, paymentInstrumentId = _a.paymentInstrumentId, paymentType = _a.paymentType, paymentFamily = _a.paymentFamily, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, country = _a.country, language = _a.language, partner = _a.partner, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, headers = _a.headers, callbacksIn = _a.callbacksIn, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters(country, language, paymentType, paymentFamily, partner, parameters);
        var returnOptions = this.compileReturnOptions(onSuccess, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(EditPaymentInstrumentInternal, { busyBlockElement: busyBlockElement, env: env, returnOptions: returnOptions, onEvent: this.onEvent, userContext: {
                    authToken: authToken,
                    userId: EditPaymentInstrumentConstants.UserId,
                    additionalHeaders: headers,
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: EditPaymentInstrumentConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), resourceInfo: {
                    id: paymentInstrumentId,
                    resourceType: EditPaymentInstrumentConstants.ResourceType,
                    parameters: {
                        partner: partner
                    },
                }, pidlDocInfo: {
                    resourceType: EditPaymentInstrumentConstants.ResourceType,
                    parameters: compiledParams,
                }, ref: this.baseComponentRef })));
    };
    return EditPaymentInstrument;
}(React__default.Component));

var FundStoredValue = /** @class */ (function (_super) {
    __extends$1(FundStoredValue, _super);
    function FundStoredValue(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.fundStoredValue(_this.props.fundStoredValueParams); }) || this;
        return _this;
    }
    return FundStoredValue;
}(BaseComponent));

var HandlePaymentChallenge = /** @class */ (function (_super) {
    __extends$1(HandlePaymentChallenge, _super);
    function HandlePaymentChallenge(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.handlePaymentChallenge(_this.props.paymentSessionOrData, _this.props.containerRef); }) || this;
        return _this;
    }
    return HandlePaymentChallenge;
}(BaseComponent));

var HandlePurchaseRiskChallenge = /** @class */ (function (_super) {
    __extends$1(HandlePurchaseRiskChallenge, _super);
    function HandlePurchaseRiskChallenge(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.handlePurchaseRiskChallenge(_this.props.parameters); }) || this;
        return _this;
    }
    return HandlePurchaseRiskChallenge;
}(BaseComponent));

(function (RiskPurchaseType) {
    RiskPurchaseType["CVV"] = "cvv";
    RiskPurchaseType["SMS"] = "sms";
})(exports.RiskPurchaseType || (exports.RiskPurchaseType = {}));
var HandleRiskChallengeInternal = /** @class */ (function (_super) {
    __extends$1(HandleRiskChallengeInternal, _super);
    function HandleRiskChallengeInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.handlePurchaseRiskChallenge(_this.props.parameters); }) || this;
        return _this;
    }
    return HandleRiskChallengeInternal;
}(BaseComponent));
var HandleRiskChallenge = /** @class */ (function (_super) {
    __extends$1(HandleRiskChallenge, _super);
    function HandleRiskChallenge(props) {
        var _this = _super.call(this, props) || this;
        _this.HandleRiskChallengeInternalRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.onEvent = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, viewTermsHandler = _a.viewTermsHandler;
            var _b = constants, eventNames = _b.eventNames, CustomTriggerEventConstants = _b.CustomTriggerEventConstants;
            if ((eventName === eventNames.triggerEvent && viewTermsHandler && eventParams.eventName === CustomTriggerEventConstants.viewTermsTriggered) ||
                (eventName === eventNames.navigate && viewTermsHandler && eventParams.displayId === RiskChallengeConstants.ViewTermsId)) {
                viewTermsHandler(eventParams);
            }
            if (onEvent) {
                onEvent(eventName, eventParams);
            }
        };
        _this.compileDisplayOptions = function () {
            var _a = _this.props, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, displayOptions = _a.displayOptions;
            return __assign$1(__assign$1({}, displayOptions), { containerId: HandleRiskChallengeConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock });
        };
        _this.compileParameters = function () {
            var _a = _this.props, piid = _a.piid, language = _a.language, country = _a.country, partner = _a.partner, type = _a.type, sessionId = _a.sessionId;
            return {
                options: {},
                piResourceInfo: {
                    id: piid,
                    parameters: {
                        language: language,
                        market: country,
                        partner: partner,
                    },
                    resourceType: HandleRiskChallengeConstants.ResourceType,
                },
                riskChallengeData: [type],
                sessionId: sessionId,
            };
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function () {
            var _a = _this.props, onSuccess = _a.onSuccess, onCancel = _a.onCancel;
            return {
                callbacks: {
                    success: _this.onSuccess,
                    failure: _this.FailureHandler,
                    gohome: onCancel,
                },
            };
        };
        _this.onSuccess = function (data) {
            var _a = _this.props, onSuccess = _a.onSuccess, type = _a.type;
            if (type === exports.RiskPurchaseType.SMS) {
                var smsSuccess = {
                    challengeType: exports.RiskPurchaseType.SMS
                };
                onSuccess(smsSuccess);
            }
            else {
                onSuccess(data);
            }
        };
        _this.compileCallbacksIn = function () {
            var _a = _this.props, onSuccess = _a.onSuccess, telemetryLogger = _a.telemetryLogger, callbacksIn = _a.callbacksIn, type = _a.type;
            var callbacks = __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger });
            if (type === exports.RiskPurchaseType.CVV) {
                callbacks = __assign$1(__assign$1({}, callbacks), { submit: function (request) {
                        var data = request === null || request === void 0 ? void 0 : request.data;
                        onSuccess(data);
                    } });
            }
            return callbacks;
        };
        _this.transformPidlString = function (eventHub) {
            return function (request, responseJson) {
                var transformJson = responseJson;
                if (!request) {
                    eventHub.error(new pidlErrors.unexpectedError(errorMessages.inputParameterMissing, ["request"]));
                }
                else if (!request.url) {
                    eventHub.error(new pidlErrors.unexpectedError(errorMessages.inputParameterMissing, ["request url"]));
                }
                else if (request.url.toLowerCase().includes("challenge/sms/validate") && typeof responseJson === "string") {
                    transformJson = { value: responseJson };
                }
                return transformJson;
            };
        };
        _this.moveNextPage = function () {
            var _a, _b;
            (_b = (_a = _this.HandleRiskChallengeInternalRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.moveNextPage();
        };
        _this.movePrevPage = function () {
            var _a, _b;
            (_b = (_a = _this.HandleRiskChallengeInternalRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.movePrevPage();
        };
        _this.cancel = function () {
            var _a, _b;
            (_b = (_a = _this.HandleRiskChallengeInternalRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.cancel();
        };
        _this.getRef = function () {
            return _this.HandleRiskChallengeInternalRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.RiskChallenge, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    HandleRiskChallenge.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    HandleRiskChallenge.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    HandleRiskChallenge.prototype.render = function () {
        var _this = this;
        var styleProvider = this.state.styleProvider;
        var _a = this.props, authToken = _a.authToken, busyBlockElement = _a.busyBlockElement, env = _a.env, elementFactory = _a.elementFactory, pidlsdkMock = _a.pidlsdkMock, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, telemetryOptions = _a.telemetryOptions, headers = _a.headers;
        var displayOptions = this.compileDisplayOptions();
        var parameters = this.compileParameters();
        var returnOptions = this.compileReturnOptions();
        var callbacksIn = this.compileCallbacksIn();
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(EventHub$1.Consumer, null, function (eventHub) {
                return React__default.createElement(HandleRiskChallengeInternal, { busyBlockElement: busyBlockElement, displayOptions: displayOptions, parameters: parameters, env: env, returnOptions: returnOptions, userContext: {
                        authToken: authToken,
                        userId: HandleRiskChallengeConstants.UserId,
                        additionalHeaders: headers,
                    }, onEvent: _this.onEvent, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: callbacksIn, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, transformersIn: { submissionSuccessTransformer: _this.transformPidlString(eventHub) }, ref: _this.HandleRiskChallengeInternalRef });
            })));
    };
    return HandleRiskChallenge;
}(React__default.Component));

var ListAddressInternal = /** @class */ (function (_super) {
    __extends$1(ListAddressInternal, _super);
    function ListAddressInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.listAddress(_this.props.pidlDocInfo, _this.props.options, _this.props.actionContext, _this.props.selectedResourceInfo); }) || this;
        return _this;
    }
    return ListAddressInternal;
}(BaseComponent));
var ListAddress = /** @class */ (function (_super) {
    __extends$1(ListAddress, _super);
    function ListAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function (scenario, country, language, partner, parameters, operation, addressType) {
            var compiledParams = {
                operation: operation,
                scenario: scenario,
                type: addressType || ListAddressConstants.DefaultAddressType,
                country: country,
                language: language,
                partner: partner,
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (success, failure, gohome) {
            return {
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.ListAddress, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    ListAddress.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    ListAddress.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    ListAddress.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, country = _a.country, language = _a.language, partner = _a.partner, scenario = _a.scenario, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, telemetryOptions = _a.telemetryOptions, addressType = _a.addressType, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, onEvent = _a.onEvent, callbacksIn = _a.callbacksIn, headers = _a.headers, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledListAddressParams = this.compileParameters(scenario, country, language, partner, parameters, ListAddressConstants.Operation, addressType);
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(ListAddressInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: ListAddressConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), pidlDocInfo: {
                    resourceType: ListAddressConstants.ResourceType,
                    parameters: compiledListAddressParams,
                }, env: env, returnOptions: returnOptions, onEvent: onEvent, userContext: {
                    authToken: authToken,
                    userId: ListAddressConstants.UserId,
                    additionalHeaders: headers
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return ListAddress;
}(React__default.Component));

var PaymentInstrumentDetailsInternal = /** @class */ (function (_super) {
    __extends$1(PaymentInstrumentDetailsInternal, _super);
    function PaymentInstrumentDetailsInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.selectSingleInstance(_this.props.pidlDocInfo, _this.props.options, _this.props.actionContext, _this.props.selectedResourceInfo); }) || this;
        return _this;
    }
    return PaymentInstrumentDetailsInternal;
}(BaseComponent));
var PaymentInstrumentDetails = /** @class */ (function (_super) {
    __extends$1(PaymentInstrumentDetails, _super);
    function PaymentInstrumentDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function () {
            var _a = _this.props, country = _a.country, language = _a.language, partner = _a.partner, parameters = _a.parameters;
            var compiledParams = {
                operation: PaymentInstrumentDetailsConstants.Operation,
                country: country,
                language: language,
                partner: partner,
                filters: { id: _this.props.paymentInstrument.id }
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.compileReturnOptions = function () {
            var _a = _this.props, onCancel = _a.onCancel, onFailure = _a.onFailure;
            return {
                callbacks: {
                    failure: onFailure,
                    gohome: onCancel,
                },
            };
        };
        _this.eventHandler = function (eventName, params) {
            var _a = _this.props, onChange = _a.onChange, onEvent = _a.onEvent, paymentInstrument = _a.paymentInstrument;
            if (eventName === eventNames.click && (params === null || params === void 0 ? void 0 : params.id) === PaymentInstrumentDetailsConstants.ChangeButtonId && onChange) {
                onChange(paymentInstrument.id);
            }
            if (onEvent) {
                onEvent(eventName, params);
            }
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.PaymentInstrumentDetails, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, null, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    PaymentInstrumentDetails.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    PaymentInstrumentDetails.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    PaymentInstrumentDetails.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, busyBlockElement = _a.busyBlockElement, elementFactory = _a.elementFactory, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, telemetryOptions = _a.telemetryOptions, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, callbacksIn = _a.callbacksIn, headers = _a.headers, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters();
        var returnOptions = this.compileReturnOptions();
        // stub creation of elements
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(PaymentInstrumentDetailsInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: PaymentInstrumentDetailsConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), pidlDocInfo: {
                    resourceType: PaymentInstrumentDetailsConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.eventHandler, userContext: {
                    authToken: authToken,
                    userId: PaymentInstrumentDetailsConstants.UserId,
                    additionalHeaders: headers
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return PaymentInstrumentDetails;
}(React__default.Component));

var ProfilePrerequisiteInternal = /** @class */ (function (_super) {
    __extends$1(ProfilePrerequisiteInternal, _super);
    function ProfilePrerequisiteInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.updateProfile(_this.props.resourceInfo, _this.props.resource, _this.props.pidlDocInfo, _this.props.options || {}); }) || this;
        return _this;
    }
    return ProfilePrerequisiteInternal;
}(BaseComponent));
;
var ProfilePrerequisite = /** @class */ (function (_super) {
    __extends$1(ProfilePrerequisite, _super);
    function ProfilePrerequisite(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compilePidlDocParameters = function (country, language, partner, parameters) {
            var compiledParams = {
                operation: ProfilePrerequisiteConstants.Operation,
                country: country,
                language: language,
                partner: partner,
                type: "consumer",
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.compileResourceParameters = function (country, language, partner, parameters) {
            var compiledParams = {
                country: country,
                language: language,
                partner: partner,
                type: "consumer",
            };
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (success, failure, gohome) {
            return {
                callbacks: {
                    failure: _this.FailureHandler,
                    success: success,
                    gohome: gohome,
                },
            };
        };
        _this.onEvent = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, viewTermsHandler = _a.viewTermsHandler;
            var _b = constants, eventNames = _b.eventNames, CustomTriggerEventConstants = _b.CustomTriggerEventConstants;
            if ((eventName === eventNames.triggerEvent && viewTermsHandler && eventParams.eventName === CustomTriggerEventConstants.viewTermsTriggered) ||
                (eventName === eventNames.navigate && viewTermsHandler && eventParams.displayId === AddPaymentInstrumentConstants.ViewTermsId)) {
                viewTermsHandler(eventParams);
            }
            if (onEvent) {
                onEvent(eventName, eventParams);
            }
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.ProfilePrerequisite, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    ProfilePrerequisite.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    ProfilePrerequisite.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    ProfilePrerequisite.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, country = _a.country, language = _a.language, partner = _a.partner, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, propertyElementRef = _a.propertyElementRef, profileId = _a.profileId, onPageRendered = _a.onPageRendered, callbacksIn = _a.callbacksIn, headers = _a.headers, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compilePidlDocParameters(country, language, partner, parameters);
        var compiledResourceParams = this.compileResourceParameters(country, language, partner, parameters);
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(ProfilePrerequisiteInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: ProfilePrerequisiteConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), pidlDocInfo: {
                    resourceType: ProfilePrerequisiteConstants.ResourceType,
                    parameters: compiledParams,
                }, resourceInfo: {
                    resourceType: ProfilePrerequisiteConstants.ResourceType,
                    parameters: compiledResourceParams,
                    id: profileId,
                }, env: env, returnOptions: returnOptions, onEvent: this.onEvent, userContext: {
                    authToken: authToken,
                    userId: ProfilePrerequisiteConstants.UserId,
                    additionalHeaders: headers
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return ProfilePrerequisite;
}(React__default.Component));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for replacing resource represented by the PIDL document.
 */
var ReplaceResource = /** @class */ (function (_super) {
    __extends$1(ReplaceResource, _super);
    function ReplaceResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.replaceResource(_this.props.pidlDocInfo, _this.props.intersectingData, _this.props.options); }) || this;
        return _this;
    }
    return ReplaceResource;
}(BaseComponent));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for searching resource.
 * On submitting the form, it generates the data which could be used to search resource details.
 *
 * For example, for credit card user can enter the PAN number as the resource identifier.
 * In this example, the form generates the tokenized card number, which could be used to get more details about the credit card.
 */
var SearchResource = /** @class */ (function (_super) {
    __extends$1(SearchResource, _super);
    function SearchResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.searchResource({
            pidlDocInfo: _this.props.pidlDocInfo,
            options: _this.props.options
        }); }) || this;
        return _this;
    }
    return SearchResource;
}(BaseComponent));

var localCardProvider = createCommonjsModule(function (module, exports) {
"use strict";
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalCards = void 0;
function getLocalCards() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            if (navigator.userAgent.indexOf('Edg') === -1) {
                resolve([]);
                return;
            }
            let timer;
            const driverReadyHandler = () => {
                window.dispatchEvent(new CustomEvent('LoadLocalCards', {}));
            };
            const localCardsReadyHandler = (message) => {
                const { localCards } = JSON.parse(message.detail);
                const pis = localCards.map(({ cardNumber, expMonth, expYear, cardType, name, billingAddress, }) => {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const address = {
                        first_name: '',
                        last_name: '',
                        address_line1: (_a = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.addressLine1) !== null && _a !== void 0 ? _a : '',
                        address_line2: (_b = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.addressLine2) !== null && _b !== void 0 ? _b : '',
                        city: (_c = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city) !== null && _c !== void 0 ? _c : '',
                        district: (_d = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.state) !== null && _d !== void 0 ? _d : '',
                        region: '',
                        postal_code: (_e = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode) !== null && _e !== void 0 ? _e : '',
                        country: (_f = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country) !== null && _f !== void 0 ? _f : '',
                        phone_number: '',
                        unit_number: (_g = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.aptNum) !== null && _g !== void 0 ? _g : '',
                    };
                    const details = {
                        accountHolderName: name,
                        accountToken: cardNumber,
                        paymentMethodType: cardType,
                        expiryYear: expYear,
                        expiryMonth: expMonth,
                        cardType: 'Credit',
                        address,
                    };
                    return {
                        details,
                    };
                });
                resolve(pis);
                clearTimeout(timer);
                window.removeEventListener('BuyNowIsReady', driverReadyHandler);
                window.removeEventListener('LoadLocalCardsFinished', localCardsReadyHandler);
            };
            timer = setTimeout(() => {
                resolve([]);
                window.removeEventListener('BuyNowIsReady', driverReadyHandler);
                window.removeEventListener('LoadLocalCardsFinished', localCardsReadyHandler);
            }, 500);
            window.addEventListener('BuyNowIsReady', driverReadyHandler);
            window.addEventListener('LoadLocalCardsFinished', localCardsReadyHandler);
            // Dispatch event
            window.dispatchEvent(new CustomEvent('IsBuyNowReady', {}));
        });
    });
}
exports.getLocalCards = getLocalCards;
const xpayLocalCardProvider = {
    getLocalCards,
};
exports.default = xpayLocalCardProvider;
});

var xpayLocalCardProvider = unwrapExports(localCardProvider);
var localCardProvider_1 = localCardProvider.getLocalCards;

var SelectResourceInternal = /** @class */ (function (_super) {
    __extends$1(SelectResourceInternal, _super);
    function SelectResourceInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.selectPaymentInstrument(_this.props.pidlDocInfo, _this.props.options, _this.props.actionContext, _this.props.selectedResourceInfo, _this.props.includePidl); }) || this;
        return _this;
    }
    return SelectResourceInternal;
}(BaseComponent));
var SelectPaymentInstrument = /** @class */ (function (_super) {
    __extends$1(SelectPaymentInstrument, _super);
    function SelectPaymentInstrument(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.allowAddNewPaymentMethod = false;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.getResourceType = function () {
            var includePidl = _this.props.includePidl;
            if (includePidl) {
                return SelectPaymentInstrumentConstants.paymentInstrumentList;
            }
            else {
                return SelectPaymentInstrumentConstants.ResourceType;
            }
        };
        _this.compileParameters = function () {
            var _a = _this.props, country = _a.country, language = _a.language, partner = _a.partner, allowedPaymentMethods = _a.allowedPaymentMethods, defaultPaymentMethod = _a.defaultPaymentMethod, parameters = _a.parameters, sessionId = _a.sessionId, orderId = _a.orderId, merchantId = _a.merchantId, currency = _a.currency, filters = _a.filters, classicProduct = _a.classicProduct, billableAccountId = _a.billableAccountId, includePidl = _a.includePidl, paymentInstrumentSelectedHandler = _a.paymentInstrumentSelectedHandler, onAddNewPaymentMethod = _a.onAddNewPaymentMethod;
            var compiledParams = {
                allowedPaymentMethods: (allowedPaymentMethods === null || allowedPaymentMethods === void 0 ? void 0 : allowedPaymentMethods.length) ? allowedPaymentMethods : SelectPaymentInstrumentConstants.AllowedPaymentMethods,
                operation: SelectPaymentInstrumentConstants.Operation,
                country: country,
                language: language,
                partner: partner,
            };
            // If paymentInstrumentSelectedHandler and onAddNewPaymentMethod are provided, include add_new_payment_method allowed type.  This is so for dropdown cases, the add new payment method option is included.
            if (compiledParams.allowedPaymentMethods.length && compiledParams.allowedPaymentMethods.indexOf(SelectPaymentInstrumentConstants.addNewPaymentMethodFamily) < 0 && paymentInstrumentSelectedHandler && onAddNewPaymentMethod) {
                compiledParams.allowedPaymentMethods = __spreadArray$1(__spreadArray$1([], compiledParams.allowedPaymentMethods, true), [SelectPaymentInstrumentConstants.addNewPaymentMethodFamily], false);
            }
            if (sessionId) {
                compiledParams.sessionId = sessionId;
            }
            if (includePidl) {
                compiledParams.includePidl = includePidl;
            }
            if (orderId) {
                compiledParams.orderId = orderId;
            }
            if (merchantId) {
                compiledParams.merchantId = merchantId;
            }
            if (currency) {
                compiledParams.currency = currency;
            }
            if (filters) {
                compiledParams.filters = filters;
            }
            if (classicProduct) {
                compiledParams.classicProduct = classicProduct;
            }
            if (billableAccountId) {
                compiledParams.billableAccountId = billableAccountId;
            }
            if (defaultPaymentMethod) {
                compiledParams.defaultPaymentMethod = defaultPaymentMethod;
            }
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.failureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function () {
            var _a = _this.props, onCancel = _a.onCancel, onSuccess = _a.onSuccess;
            return {
                callbacks: {
                    failure: _this.failureHandler,
                    success: onSuccess,
                    gohome: onCancel,
                },
            };
        };
        _this.isCreditCard = function (pi) {
            // initializeResources() needs to be called from parent app.
            // App needs to include @cspayments/pidl-resource-helpers in bundle.
            if (window === null || window === void 0 ? void 0 : window.pidlResourceHelpers) {
                return utils.getFunctionExecutionResult({ functionName: ResourceHelpersConstants.isCreditCard }, { contextData: pi });
            }
        };
        _this.isCreditCardExpired = function (pi) {
            // initializeResources() needs to be called from parent app.
            // App needs to include @cspayments/pidl-resource-helpers in bundle.
            if (window === null || window === void 0 ? void 0 : window.pidlResourceHelpers) {
                return utils.getFunctionExecutionResult({ functionName: ResourceHelpersConstants.isCreditCardExpired }, { contextData: pi });
            }
        };
        _this.onEventInternal = function (eventName, parameters) {
            var _a = _this.props, onEvent = _a.onEvent, paymentInstrumentSelectedHandler = _a.paymentInstrumentSelectedHandler, userPiAvailableCheckHandler = _a.userPiAvailableCheckHandler;
            if (eventName == eventNames.pageRefreshed) {
                if (parameters && (parameters === null || parameters === void 0 ? void 0 : parameters.pageId) == "noPaymentInstrumentSelectPage") {
                    _this.setState({ userPiExists: false });
                    if (userPiAvailableCheckHandler) {
                        userPiAvailableCheckHandler(_this.state.userPiExists);
                    }
                }
            }
            if (paymentInstrumentSelectedHandler && eventName === eventNames.resourceSelected) {
                var resource = _this.getSelectedResource();
                var onAddNewPaymentMethod = _this.props.onAddNewPaymentMethod;
                // On first render (allowAddNewPaymentMethod is false) DO NOT call onAddNewPaymentMethod if PM type has no_default_selection as suffix
                if (!_this.allowAddNewPaymentMethod && (!resource || !((resource === null || resource === void 0 ? void 0 : resource.paymentMethodType) === SelectPaymentInstrumentConstants.preventDefaultSelection))) {
                    _this.allowAddNewPaymentMethod = true;
                }
                // For dropdown scenarios, if the option "Add New Payment Method" is selected, call onAddNewPaymentMethod
                if (resource.paymentMethodFamily === SelectPaymentInstrumentConstants.addNewPaymentMethodFamily && _this.allowAddNewPaymentMethod && onAddNewPaymentMethod) {
                    return onAddNewPaymentMethod();
                }
                // set allowAddNewPaymentMethod to true after the first render
                _this.allowAddNewPaymentMethod = true;
                return paymentInstrumentSelectedHandler(resource);
            }
            if (onEvent) {
                return onEvent(eventName, parameters);
            }
        };
        _this.getWalletCards = function (walletProvider) { return __awaiter$1(_this, void 0, void 0, function () {
            var getWalletCardsTimeout_1, timeoutMs, walletCards;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(walletProvider === null || walletProvider === void 0 ? void 0 : walletProvider.getLocalCards)) return [3 /*break*/, 2];
                        timeoutMs = walletProvider.timeout || 0;
                        if (timeoutMs > 0) {
                            getWalletCardsTimeout_1 = setTimeout(function () {
                                try {
                                    throw new Error("Timeout getting wallet cards");
                                }
                                catch (e) {
                                    clearTimeout(getWalletCardsTimeout_1);
                                    // Log error, but keep going
                                }
                            }, timeoutMs);
                        }
                        return [4 /*yield*/, walletProvider.getLocalCards()
                                .then(function (cards) {
                                return cards;
                            })
                                .catch(function () {
                                return [];
                            })];
                    case 1:
                        walletCards = (_a.sent()) || [];
                        if (getWalletCardsTimeout_1) {
                            clearTimeout(getWalletCardsTimeout_1);
                        }
                        return [2 /*return*/, walletCards];
                    case 2: return [2 /*return*/, []];
                }
            });
        }); };
        _this.getLocalWalletProvider = function (walletProvider) {
            return { paymentInstruments: { mergingFunction: "mergeAndFillLocalCards", getDataSource: function () { return _this.getWalletCards(walletProvider); } } };
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        _this.populatePrefillData = function (selectedResource) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            var expiryMonth = (_a = selectedResource.details) === null || _a === void 0 ? void 0 : _a.expiryMonth;
            var normalizedExpiryMonth = expiryMonth.startsWith && expiryMonth.startsWith("0") ? expiryMonth.substring(1) : expiryMonth;
            return {
                accountToken: (_b = selectedResource.details) === null || _b === void 0 ? void 0 : _b.accountToken,
                accountHolderName: (_c = selectedResource.details) === null || _c === void 0 ? void 0 : _c.accountHolderName,
                expiryYear: (_e = (_d = selectedResource.details) === null || _d === void 0 ? void 0 : _d.expiryYear) === null || _e === void 0 ? void 0 : _e.toString(),
                expiryMonth: normalizedExpiryMonth === null || normalizedExpiryMonth === void 0 ? void 0 : normalizedExpiryMonth.toString(),
                address: {
                    address_line1: (_g = (_f = selectedResource.details) === null || _f === void 0 ? void 0 : _f.address) === null || _g === void 0 ? void 0 : _g.address_line1,
                    address_line2: ((_j = (_h = selectedResource.details) === null || _h === void 0 ? void 0 : _h.address) === null || _j === void 0 ? void 0 : _j.address_line2) || "",
                    address_line3: ((_l = (_k = selectedResource.details) === null || _k === void 0 ? void 0 : _k.address) === null || _l === void 0 ? void 0 : _l.address_line3) || "",
                    city: (_o = (_m = selectedResource.details) === null || _m === void 0 ? void 0 : _m.address) === null || _o === void 0 ? void 0 : _o.city,
                    region: ((_q = (_p = selectedResource.details) === null || _p === void 0 ? void 0 : _p.address) === null || _q === void 0 ? void 0 : _q.region) || ((_s = (_r = selectedResource.details) === null || _r === void 0 ? void 0 : _r.address) === null || _s === void 0 ? void 0 : _s.district),
                    postal_code: (_u = (_t = selectedResource.details) === null || _t === void 0 ? void 0 : _t.address) === null || _u === void 0 ? void 0 : _u.postal_code,
                    country: (_w = (_v = selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.details) === null || _v === void 0 ? void 0 : _v.address) === null || _w === void 0 ? void 0 : _w.country
                }
            };
        };
        _this.getSelectedResource = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var resource = (_b = (_a = _this.baseComponentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getSelectedResource();
            var selectedResource = (resource === null || resource === void 0 ? void 0 : resource.instance) || (resource === null || resource === void 0 ? void 0 : resource.paymentInstrumentId) || {};
            var paymentInstrumentInformation = {
                id: selectedResource.id,
                paymentMethodFamily: (_c = selectedResource.paymentMethod) === null || _c === void 0 ? void 0 : _c.paymentMethodFamily,
                paymentMethodType: (_d = selectedResource.paymentMethod) === null || _d === void 0 ? void 0 : _d.paymentMethodType,
                displayName: (_f = (_e = selectedResource.paymentMethod) === null || _e === void 0 ? void 0 : _e.display) === null || _f === void 0 ? void 0 : _f.name,
                email: (_g = selectedResource.details) === null || _g === void 0 ? void 0 : _g.email,
                lastFourDigits: (_h = selectedResource.details) === null || _h === void 0 ? void 0 : _h.lastFourDigits,
                isExpired: _this.isCreditCard(selectedResource) ? _this.isCreditCardExpired(selectedResource) : false,
                soldToAddressRequired: (_k = (_j = selectedResource.paymentMethod) === null || _j === void 0 ? void 0 : _j.properties) === null || _k === void 0 ? void 0 : _k.soldToAddressRequired,
                properties: (_l = selectedResource.paymentMethod) === null || _l === void 0 ? void 0 : _l.properties,
            };
            // Selected PI will be not saved if it's from external wallet
            if ((_m = selectedResource.details) === null || _m === void 0 ? void 0 : _m.isNotSaved) {
                paymentInstrumentInformation.isNotSaved = selectedResource.details.isNotSaved;
                paymentInstrumentInformation.prefillData = _this.populatePrefillData(selectedResource);
            }
            return paymentInstrumentInformation;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
            userPiExists: true
        };
        return _this;
    }
    SelectPaymentInstrument.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    SelectPaymentInstrument.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    SelectPaymentInstrument.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, busyBlockElement = _a.busyBlockElement, elementFactory = _a.elementFactory, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, actionContext = _a.actionContext, telemetryOptions = _a.telemetryOptions, pidlPayload = _a.pidlPayload, includePidl = _a.includePidl, propertyElementRef = _a.propertyElementRef, onEvent = _a.onEvent, onPageRendered = _a.onPageRendered, headers = _a.headers, callbacksIn = _a.callbacksIn, walletProvider = _a.walletProvider, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters();
        var returnOptions = this.compileReturnOptions();
        var localWalletProvider = this.getLocalWalletProvider(walletProvider !== null && walletProvider !== void 0 ? walletProvider : xpayLocalCardProvider);
        var resourceType = this.getResourceType();
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(SelectResourceInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: SelectPaymentInstrumentConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), pidlDocInfo: {
                    resourceType: resourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.onEventInternal, userContext: {
                    authToken: authToken,
                    userId: SelectPaymentInstrumentConstants.UserId,
                    additionalHeaders: headers,
                }, actionContext: actionContext, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef, includePidl: includePidl, pidlPayload: pidlPayload, localDataSourceProviders: localWalletProvider })));
    };
    return SelectPaymentInstrument;
}(React__default.Component));

var SelectPaymentMethodInternal = /** @class */ (function (_super) {
    __extends$1(SelectPaymentMethodInternal, _super);
    function SelectPaymentMethodInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.selectResourceType(_this.props.pidlDocInfo, _this.props.options); }) || this;
        return _this;
    }
    return SelectPaymentMethodInternal;
}(BaseComponent));
var SelectPaymentMethod = /** @class */ (function (_super) {
    __extends$1(SelectPaymentMethod, _super);
    function SelectPaymentMethod(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function () {
            var _a = _this.props, country = _a.country, language = _a.language, partner = _a.partner, parameters = _a.parameters, defaultPaymentMethod = _a.defaultPaymentMethod, allowedPaymentMethods = _a.allowedPaymentMethods, filters = _a.filters, sessionId = _a.sessionId, orderId = _a.orderId, merchantId = _a.merchantId, currency = _a.currency, pmGroupPageId = _a.pmGroupPageId;
            var compiledParams = {
                allowedPaymentMethods: (allowedPaymentMethods === null || allowedPaymentMethods === void 0 ? void 0 : allowedPaymentMethods.length) ? allowedPaymentMethods : SelectPaymentMethodConstants.AllowedPaymentMethods,
                operation: SelectPaymentMethodConstants.Operation,
                country: country,
                language: language,
                partner: partner,
            };
            if (defaultPaymentMethod) {
                compiledParams.defaultPaymentMethod = defaultPaymentMethod;
            }
            if (sessionId) {
                compiledParams.sessionId = sessionId;
            }
            if (orderId) {
                compiledParams.orderId = orderId;
            }
            if (merchantId) {
                compiledParams.merchantId = merchantId;
            }
            if (currency) {
                compiledParams.currency = currency;
            }
            if (filters) {
                compiledParams.filters = filters;
            }
            if (pmGroupPageId) {
                compiledParams.pmGroupPageId = pmGroupPageId;
            }
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (success, failure, gohome) {
            return {
                callbacks: {
                    failure: _this.FailureHandler,
                    success: success,
                    gohome: gohome,
                },
            };
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentMethod, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    SelectPaymentMethod.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    SelectPaymentMethod.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    SelectPaymentMethod.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, busyBlockElement = _a.busyBlockElement, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, callbacksIn = _a.callbacksIn, propertyElementRef = _a.propertyElementRef, onEvent = _a.onEvent, onPageRendered = _a.onPageRendered, telemetryLogger = _a.telemetryLogger, headers = _a.headers, displayOptions = _a.displayOptions, telemetryOptions = _a.telemetryOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters();
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(SelectPaymentMethodInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: SelectPaymentMethodConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock, disableFocusOnLoad: this.props.disableFocusOnLoad }), pidlDocInfo: {
                    resourceType: SelectPaymentMethodConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: onEvent, userContext: {
                    authToken: authToken,
                    userId: SelectPaymentMethodConstants.UserId,
                    additionalHeaders: headers
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, telemetryOptions: telemetryOptions, ref: this.baseComponentRef })));
    };
    return SelectPaymentMethod;
}(React__default.Component));

var SelectResource = /** @class */ (function (_super) {
    __extends$1(SelectResource, _super);
    function SelectResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.selectInstance(_this.props.pidlDocInfo, _this.props.options, _this.props.actionContext, _this.props.selectedResourceInfo); }) || this;
        return _this;
    }
    return SelectResource;
}(BaseComponent));

var SelectResourceType = /** @class */ (function (_super) {
    __extends$1(SelectResourceType, _super);
    function SelectResourceType(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.selectResourceType(_this.props.pidlDocInfo, _this.props.options); }) || this;
        return _this;
    }
    return SelectResourceType;
}(BaseComponent));

var SelectSingleResource = /** @class */ (function (_super) {
    __extends$1(SelectSingleResource, _super);
    function SelectSingleResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.selectSingleInstance(_this.props.pidlDocInfo, _this.props.options, _this.props.actionContext, _this.props.selectedResourceInfo); }) || this;
        return _this;
    }
    return SelectSingleResource;
}(BaseComponent));

var ShowResource = /** @class */ (function (_super) {
    __extends$1(ShowResource, _super);
    function ShowResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.showResource({
            pidlDocInfo: _this.props.pidlDocInfo,
            prefillData: _this.props.prefillData,
            options: _this.props.options
        }); }) || this;
        return _this;
    }
    return ShowResource;
}(BaseComponent));

var TestHookRenderPidl = /** @class */ (function (_super) {
    __extends$1(TestHookRenderPidl, _super);
    function TestHookRenderPidl(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.testHookRenderPidlPage(_this.props.pidlDocument, _this.props.operation, _this.props.pageIndex || 0, _this.props.prefillData); }) || this;
        return _this;
    }
    return TestHookRenderPidl;
}(BaseComponent));

var UpdateResource = /** @class */ (function (_super) {
    __extends$1(UpdateResource, _super);
    function UpdateResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.updateResource(_this.props.resourceInfo, _this.props.resource, _this.props.pidlDocInfo, _this.props.options || {}); }) || this;
        return _this;
    }
    return UpdateResource;
}(BaseComponent));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var ValidateAddressInternal = /** @class */ (function (_super) {
    __extends$1(ValidateAddressInternal, _super);
    function ValidateAddressInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.validateAddress(_this.props.pidlDocInfo); }) || this;
        return _this;
    }
    return ValidateAddressInternal;
}(BaseComponent));
(function (ValidateAddressPages) {
    ValidateAddressPages[ValidateAddressPages["validateAddressPage"] = 0] = "validateAddressPage";
    ValidateAddressPages[ValidateAddressPages["editAddressPage"] = 1] = "editAddressPage";
})(exports.ValidateAddressPages || (exports.ValidateAddressPages = {}));
var ValidateAddress = /** @class */ (function (_super) {
    __extends$1(ValidateAddress, _super);
    function ValidateAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onValidateAddressEvent = function (eventName, parameters) {
            var _a = _this.props, onEvent = _a.onEvent, currentPageChangeHandler = _a.currentPageChangeHandler;
            if (eventName == eventNames.pageRefreshed) {
                switch (parameters.pageId) {
                    case "addressSuggestionPage1":
                        _this.setState({ currentPage: exports.ValidateAddressPages.validateAddressPage });
                        break;
                    case "addressSuggestionPage2":
                        _this.setState({ currentPage: exports.ValidateAddressPages.editAddressPage });
                        break;
                    default: break;
                }
                if (currentPageChangeHandler) {
                    currentPageChangeHandler(_this.state.currentPage);
                }
            }
            if (onEvent) {
                return onEvent(eventName, parameters);
            }
        };
        _this.getCurrentPage = function () {
            return _this.state.currentPage;
        };
        _this.getRef = function () {
            return _this.props.pidlSdkRef || _this.baseComponentRef;
        };
        _this.state = {
            currentPage: exports.ValidateAddressPages.validateAddressPage,
        };
        return _this;
    }
    ValidateAddress.prototype.compileParameters = function (country, language, partner, addressId, addressType, parameters) {
        var compiledParams = __assign$1({ operation: ValidateAddressConstants.Operation, type: addressType }, { country: country, language: language, partner: partner, addressId: addressId });
        if (parameters) {
            compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
        }
        return compiledParams;
    };
    ValidateAddress.prototype.render = function () {
        var _a = this.props, userContext = _a.userContext, env = _a.env, parameters = _a.parameters, country = _a.country, language = _a.language, partner = _a.partner, addressId = _a.addressId, addressType = _a.addressType, elementFactory = _a.elementFactory, returnOptions = _a.returnOptions, pidlSdkRef = _a.pidlSdkRef, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, onEvent = _a.onEvent, callbacksIn = _a.callbacksIn;
        var compiledParams = this.compileParameters(country, language, partner, addressId, addressType, parameters);
        return (React__default.createElement(ValidateAddressInternal, { displayOptions: {
                containerId: ValidateAddressConstants.ContainerId,
                busyBlockShowHideHandler: busyBlockShowHideHandler,
                showSubmitBlock: showSubmitBlock
            }, pidlDocInfo: {
                resourceType: ValidateAddressConstants.ResourceType,
                parameters: compiledParams,
            }, env: env, returnOptions: returnOptions, userContext: userContext, elementFactory: elementFactory, ref: pidlSdkRef || this.baseComponentRef, onEvent: this.onValidateAddressEvent, callbacksIn: callbacksIn }));
    };
    return ValidateAddress;
}(React__default.Component));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var ValidateResource = /** @class */ (function (_super) {
    __extends$1(ValidateResource, _super);
    function ValidateResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.validateResource(_this.props.pidlDocInfo); }) || this;
        return _this;
    }
    return ValidateResource;
}(BaseComponent));

var HandleCheckout = /** @class */ (function (_super) {
    __extends$1(HandleCheckout, _super);
    function HandleCheckout(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.handleCheckout(_this.props.checkoutParams); }) || this;
        return _this;
    }
    return HandleCheckout;
}(BaseComponent));

var DeleteResource = /** @class */ (function (_super) {
    __extends$1(DeleteResource, _super);
    function DeleteResource(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.deleteResource({
            resourceInfo: _this.props.resourceInfo,
            resource: _this.props.resource,
            pidlDocInfo: _this.props.pidlDocInfo,
            options: _this.props.options || {}
        }); }) || this;
        return _this;
    }
    return DeleteResource;
}(BaseComponent));

var DeletePaymentInstrument = /** @class */ (function (_super) {
    __extends$1(DeletePaymentInstrument, _super);
    function DeletePaymentInstrument(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function (country, language, partner, paymentFamily, paymentType, paymentInstrumentId) {
            return {
                id: paymentInstrumentId,
                resourceType: DeletePaymentInstrumentConstants.ResourceType,
                resourceEndpoint: undefined,
                parameters: {
                    market: country,
                    language: language,
                    partner: partner,
                    family: paymentFamily,
                    type: paymentType,
                },
            };
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileReturnOptions = function (success, gohome) {
            return {
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.DeletePaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    DeletePaymentInstrument.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    DeletePaymentInstrument.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    DeletePaymentInstrument.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, paymentInstrumentId = _a.paymentInstrumentId, paymentType = _a.paymentType, paymentFamily = _a.paymentFamily, env = _a.env, busyBlockElement = _a.busyBlockElement, country = _a.country, language = _a.language, partner = _a.partner, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onCancel = _a.onCancel, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, telemetryLogger = _a.telemetryLogger, headers = _a.headers, callbacksIn = _a.callbacksIn, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters(country, language, partner, paymentFamily, paymentType, paymentInstrumentId);
        var returnOptions = this.compileReturnOptions(onSuccess, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(DeleteResource, { returnOptions: returnOptions, busyBlockElement: busyBlockElement, env: env, options: undefined, resourceInfo: compiledParams, elementFactory: elementFactory, callbacksIn: __assign$1(__assign$1({}, callbacksIn), { telemetryLogger: telemetryLogger }), userContext: {
                    authToken: authToken,
                    userId: DeletePaymentInstrumentConstants.UserId,
                    additionalHeaders: headers
                }, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: DeletePaymentInstrumentConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), ref: this.baseComponentRef })));
    };
    return DeletePaymentInstrument;
}(React__default.Component));

var HandleIndia3DSChallengeInternal = /** @class */ (function (_super) {
    __extends$1(HandleIndia3DSChallengeInternal, _super);
    function HandleIndia3DSChallengeInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.handlePaymentChallenge(_this.props.paymentSessionOrData); }) || this;
        return _this;
    }
    return HandleIndia3DSChallengeInternal;
}(BaseComponent));
var HandleIndia3DSChallenge = /** @class */ (function (_super) {
    __extends$1(HandleIndia3DSChallenge, _super);
    function HandleIndia3DSChallenge(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileDisplayOptions = function () {
            var _a = _this.props, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, displayOptions = _a.displayOptions;
            return __assign$1(__assign$1({}, displayOptions), { containerId: HandleIndia3DSChallengeConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock });
        };
        _this.successHandler = function (params) {
            if (params.challengeStatus === "Cancelled" || params.challengeStatus === "Unknown") {
                _this.props.onCancel(params);
            }
            else if (params.challengeStatus === "TimedOut") {
                _this.props.onFailure(params);
            }
            else {
                _this.props.onSuccess(params);
            }
        };
        _this.failureHandler = function (error) {
            var serverError = error === null || error === void 0 ? void 0 : error.error;
            _this.props.onFailure(serverError === null || serverError === void 0 ? void 0 : serverError.innererror);
        };
        _this.compileReturnOptions = function () {
            var onCancel = _this.props.onCancel;
            return {
                callbacks: {
                    success: _this.successHandler,
                    failure: _this.failureHandler,
                    gohome: onCancel,
                },
            };
        };
        _this.compileCallbacksIn = function () {
            var telemetryLogger = _this.props.telemetryLogger;
            return {
                telemetryLogger: telemetryLogger,
            };
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.HandlePaymentChallenge, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    HandleIndia3DSChallenge.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    HandleIndia3DSChallenge.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    HandleIndia3DSChallenge.prototype.render = function () {
        var styleProvider = this.state.styleProvider;
        var _a = this.props, authToken = _a.authToken, busyBlockElement = _a.busyBlockElement, env = _a.env, elementFactory = _a.elementFactory, headers = _a.headers, paymentSessionOrData = _a.paymentSessionOrData, pidlsdkMock = _a.pidlsdkMock, propertyElementRef = _a.propertyElementRef, onEvent = _a.onEvent, onPageRendered = _a.onPageRendered, telemetryOptions = _a.telemetryOptions;
        var displayOptions = this.compileDisplayOptions();
        var returnOptions = this.compileReturnOptions();
        var callbacksIn = this.compileCallbacksIn();
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(HandleIndia3DSChallengeInternal, { busyBlockElement: busyBlockElement, displayOptions: displayOptions, env: env, returnOptions: returnOptions, userContext: {
                    authToken: authToken,
                    userId: HandleIndia3DSChallengeConstants.UserId,
                    additionalHeaders: headers,
                }, paymentSessionOrData: paymentSessionOrData, onEvent: onEvent, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: callbacksIn, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return HandleIndia3DSChallenge;
}(React__default.Component));

(function (AllowedViews) {
    AllowedViews[AllowedViews["SelectPaymentInstrument"] = 0] = "SelectPaymentInstrument";
    AllowedViews[AllowedViews["SelectPaymentMethod"] = 1] = "SelectPaymentMethod";
    AllowedViews[AllowedViews["AddPaymentInstrument"] = 2] = "AddPaymentInstrument";
    AllowedViews[AllowedViews["EditPaymentInstrument"] = 3] = "EditPaymentInstrument";
})(exports.AllowedViews || (exports.AllowedViews = {}));
(function (ManagePaymentInstrumentMode) {
    ManagePaymentInstrumentMode[ManagePaymentInstrumentMode["Select"] = 0] = "Select";
})(exports.ManagePaymentInstrumentMode || (exports.ManagePaymentInstrumentMode = {}));
var ManagePaymentInstrument = /** @class */ (function (_super) {
    __extends$1(ManagePaymentInstrument, _super);
    function ManagePaymentInstrument(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.SelectPaymentInstrumentRef = React__default.createRef();
        _this.SelectPaymentMethodRef = React__default.createRef();
        _this.AddPaymentInstrumentRef = React__default.createRef();
        _this.EditPaymentInstrumentRef = React__default.createRef();
        _this.setCurrentView = function () {
            var _a = _this.props, pidlPayload = _a.pidlPayload, allowedPaymentMethods = _a.allowedPaymentMethods;
            if (pidlPayload && typehelper.isArray(pidlPayload.allowedPaymentMethods) && pidlPayload.allowedPaymentMethods.length === 0) {
                return exports.AllowedViews.SelectPaymentMethod;
            }
            return exports.AllowedViews.SelectPaymentInstrument;
        };
        _this.isCreditCardExpired = function (pi) {
            // initializeResources() needs to be called from parent app.
            // App needs to include @cspayments/pidl-resource-helpers in bundle.
            if (window === null || window === void 0 ? void 0 : window.pidlResourceHelpers) {
                return utils.getFunctionExecutionResult({ functionName: ResourceHelpersConstants.isCreditCardExpired }, { contextData: pi });
            }
        };
        _this.isGiftCard = function (pi) {
            // initializeResources() needs to be called from parent app.
            // App needs to include @cspayments/pidl-resource-helpers in bundle.
            if (window === null || window === void 0 ? void 0 : window.pidlResourceHelpers) {
                return utils.getFunctionExecutionResult({ functionName: ResourceHelpersConstants.isEwalletStoredValue }, { contextData: pi });
            }
        };
        _this.onSelectPIEvent = function (eventName, parameters) {
            var _a, _b;
            var _c = _this.props, onEvent = _c.onEvent, paymentInstrumentSelectedHandler = _c.paymentInstrumentSelectedHandler;
            if (paymentInstrumentSelectedHandler && eventName === eventNames.resourceSelected && _this.state.currentView === exports.AllowedViews.SelectPaymentInstrument) {
                return paymentInstrumentSelectedHandler((_b = (_a = _this.SelectPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getSelectedResource());
            }
            if (onEvent) {
                return onEvent(eventName, parameters);
            }
        };
        _this.onSelectPISuccess = function (params) {
            var _a, _b, _c;
            // this if block is for windowssettings partner
            if (params.resourceActionContext) {
                switch (params.resourceActionContext.action) {
                    case "selectResourceType":
                        _this.setState({ currentView: exports.AllowedViews.SelectPaymentMethod });
                        break;
                    case "addResource":
                        _this.setState({
                            paymentFamily: params.paymentMethodFamily,
                            paymentType: params.paymentMethodType,
                            currentView: exports.AllowedViews.AddPaymentInstrument
                        });
                        break;
                    case "editPaymentInstrument":
                        _this.setState({
                            paymentFamily: params.resourceActionContext.resource.paymentMethod.paymentMethodFamily,
                            paymentType: params.resourceActionContext.resource.paymentMethod.paymentMethodType,
                            paymentInstrumentId: params.resourceActionContext.resource.id,
                            currentView: exports.AllowedViews.EditPaymentInstrument
                        });
                        break;
                }
                return;
            }
            // this if block is for cart partner
            // if params.action is success then it means that user has selected a valid payment instrument and we trigger onSuccess callback
            if (params.action && typehelper.toLowerCase(params.action) !== "success") {
                switch (params.action) {
                    case "selectResourceType":
                        _this.setState({ currentView: exports.AllowedViews.SelectPaymentMethod });
                        break;
                    case "updateResource":
                        var instance_1 = params.instance;
                        if (!typehelper.isString(instance_1)) {
                            _this.setState({
                                currentView: exports.AllowedViews.EditPaymentInstrument,
                                paymentFamily: instance_1.paymentMethod.paymentMethodFamily,
                                paymentType: instance_1.paymentMethod.paymentMethodType,
                                paymentInstrumentId: instance_1.id,
                            });
                        }
                        break;
                }
                return;
            }
            // code from here on is common to all partners: (xbox, cart, windowssettings)
            var instance = params.instance;
            var _d = _this.props, onSuccess = _d.onSuccess, onFailure = _d.onFailure, redeemGiftCardHandler = _d.redeemGiftCardHandler;
            var NewPaymentMethodLink = ManagePaymentInstrumentConstants.NewPaymentMethodLink, RedeemGiftCardLink = ManagePaymentInstrumentConstants.RedeemGiftCardLink, ManagePaymentInstrument = ManagePaymentInstrumentConstants.ManagePaymentInstrument, redeemGiftCardHandlerName = ManagePaymentInstrumentConstants.redeemGiftCardHandlerName;
            if (typeof instance === "string") {
                if (instance === NewPaymentMethodLink) {
                    _this.setState({ currentView: exports.AllowedViews.SelectPaymentMethod });
                }
                if (instance === RedeemGiftCardLink) {
                    if (redeemGiftCardHandler) {
                        redeemGiftCardHandler();
                    }
                    else {
                        var ref = (_b = (_a = _this.SelectPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef();
                        (_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.implementationMissing(ManagePaymentInstrument, redeemGiftCardHandlerName);
                        onFailure({
                            name: errorTypes.missingImplementationError,
                            message: "Implentation of ".concat(redeemGiftCardHandlerName !== null && redeemGiftCardHandlerName !== void 0 ? redeemGiftCardHandlerName : "undefined", " missing in ").concat(ManagePaymentInstrument),
                            code: "",
                            type: errorTypes.missingImplementationError,
                            debugMessage: ""
                        });
                    }
                }
            }
            else if (_this.isCreditCardExpired(instance)) {
                _this.setState({
                    currentView: exports.AllowedViews.EditPaymentInstrument,
                    paymentFamily: instance.paymentMethod.paymentMethodFamily,
                    paymentType: instance.paymentMethod.paymentMethodType,
                    paymentInstrumentId: instance.id,
                });
            }
            else {
                onSuccess(instance);
            }
        };
        _this.onSelectPaymentMethodSuccess = function (params) {
            if (_this.isGiftCard({ paymentMethod: { paymentMethodFamily: params.paymentMethodFamily, paymentMethodType: params.paymentMethodType } })) {
                _this.onSelectPISuccess({
                    operationType: pidlOperationTypeValues.select,
                    instance: ManagePaymentInstrumentConstants.RedeemGiftCardLink
                });
            }
            else {
                if (typehelper.toLowerCase(_this.props.partner) === "windowssettings" && typehelper.toLowerCase(params.paymentMethodFamily) !== "credit_card") {
                    var onSuccess = _this.props.onSuccess;
                    onSuccess(params);
                }
                else {
                    _this.setState({
                        paymentFamily: params.paymentMethodFamily,
                        paymentType: params.paymentMethodType,
                        currentView: exports.AllowedViews.AddPaymentInstrument,
                    });
                }
            }
        };
        _this.onAddPISuccess = function (params) {
            try {
                var instance = params.response;
                instance.piModified = true;
                var onSuccess = _this.props.onSuccess;
                onSuccess(instance);
            }
            catch (err) {
                _this.setState({ currentView: exports.AllowedViews.SelectPaymentInstrument });
            }
        };
        _this.onEditPISuccess = function (params) {
            _this.setState({ currentView: exports.AllowedViews.SelectPaymentInstrument });
            var onUpdateSuccess = _this.props.onUpdateSuccess;
            if (onUpdateSuccess) {
                try {
                    var instance = params.response;
                    instance.piModified = true;
                    onUpdateSuccess(instance);
                }
                catch (err) {
                    // do nothing
                }
            }
        };
        _this.cancelSelectPM = function () {
            _this.pmGroupPageId = undefined;
            _this.setState({ currentView: exports.AllowedViews.SelectPaymentInstrument, pmGroupPageId: _this.pmGroupPageId });
        };
        _this.cancelAddPI = function () {
            var goToSelectPIOnAddCancel = _this.props.goToSelectPIOnAddCancel;
            _this.pmGroupPageId = _this.state.paymentFamily;
            var currentView = goToSelectPIOnAddCancel ? exports.AllowedViews.SelectPaymentInstrument : exports.AllowedViews.SelectPaymentMethod;
            _this.setState({ currentView: currentView, pmGroupPageId: _this.pmGroupPageId });
        };
        _this.cancelEditPI = function () {
            _this.setState({ currentView: exports.AllowedViews.SelectPaymentInstrument });
        };
        _this.moveNextPage = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            switch (_this.state.currentView) {
                case exports.AllowedViews.SelectPaymentInstrument:
                    (_c = (_b = (_a = _this.SelectPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.moveNextPage();
                    break;
                case exports.AllowedViews.SelectPaymentMethod:
                    (_f = (_e = (_d = _this.SelectPaymentMethodRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.getRef().current) === null || _f === void 0 ? void 0 : _f.moveNextPage();
                    break;
                case exports.AllowedViews.AddPaymentInstrument:
                    (_j = (_h = (_g = _this.AddPaymentInstrumentRef) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.getRef().current) === null || _j === void 0 ? void 0 : _j.moveNextPage();
                    break;
                case exports.AllowedViews.EditPaymentInstrument:
                    (_m = (_l = (_k = _this.EditPaymentInstrumentRef) === null || _k === void 0 ? void 0 : _k.current) === null || _l === void 0 ? void 0 : _l.getRef().current) === null || _m === void 0 ? void 0 : _m.moveNextPage();
                    break;
            }
        };
        _this.movePrevPage = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            switch (_this.state.currentView) {
                case exports.AllowedViews.SelectPaymentInstrument:
                    (_c = (_b = (_a = _this.SelectPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.movePrevPage();
                    break;
                case exports.AllowedViews.SelectPaymentMethod:
                    (_f = (_e = (_d = _this.SelectPaymentMethodRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.getRef().current) === null || _f === void 0 ? void 0 : _f.movePrevPage();
                    break;
                case exports.AllowedViews.AddPaymentInstrument:
                    (_j = (_h = (_g = _this.AddPaymentInstrumentRef) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.getRef().current) === null || _j === void 0 ? void 0 : _j.movePrevPage();
                    break;
                case exports.AllowedViews.EditPaymentInstrument:
                    (_m = (_l = (_k = _this.EditPaymentInstrumentRef) === null || _k === void 0 ? void 0 : _k.current) === null || _l === void 0 ? void 0 : _l.getRef().current) === null || _m === void 0 ? void 0 : _m.movePrevPage();
                    break;
            }
        };
        _this.cancel = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            switch (_this.state.currentView) {
                case exports.AllowedViews.SelectPaymentInstrument:
                    (_c = (_b = (_a = _this.SelectPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.cancel();
                    break;
                case exports.AllowedViews.SelectPaymentMethod:
                    (_f = (_e = (_d = _this.SelectPaymentMethodRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.getRef().current) === null || _f === void 0 ? void 0 : _f.cancel();
                    break;
                case exports.AllowedViews.AddPaymentInstrument:
                    (_j = (_h = (_g = _this.AddPaymentInstrumentRef) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.getRef().current) === null || _j === void 0 ? void 0 : _j.cancel();
                    break;
                case exports.AllowedViews.EditPaymentInstrument:
                    (_m = (_l = (_k = _this.EditPaymentInstrumentRef) === null || _k === void 0 ? void 0 : _k.current) === null || _l === void 0 ? void 0 : _l.getRef().current) === null || _m === void 0 ? void 0 : _m.cancel();
                    break;
            }
        };
        _this.cancelSelectPaymentInstrument = function () {
            var _a, _b, _c;
            if (_this.state.currentView === exports.AllowedViews.SelectPaymentInstrument) {
                (_c = (_b = (_a = _this.SelectPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.cancel();
            }
        };
        _this.cancelOrMovePrevSelectPaymentMethod = function () {
            var _a, _b, _c;
            if (_this.state.currentView === exports.AllowedViews.SelectPaymentMethod) {
                (_c = (_b = (_a = _this.SelectPaymentMethodRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.movePrevPage();
            }
        };
        _this.cancelAddPaymentInstrument = function () {
            var _a, _b, _c;
            if (_this.state.currentView === exports.AllowedViews.AddPaymentInstrument) {
                (_c = (_b = (_a = _this.AddPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.cancel();
            }
        };
        _this.cancelEditPaymentInstrument = function () {
            var _a, _b, _c;
            if (_this.state.currentView === exports.AllowedViews.EditPaymentInstrument) {
                (_c = (_b = (_a = _this.EditPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.cancel();
            }
        };
        _this.submitAddPaymentInstrument = function () {
            var _a, _b, _c;
            if (_this.state.currentView === exports.AllowedViews.AddPaymentInstrument) {
                (_c = (_b = (_a = _this.AddPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.moveNextPage();
            }
        };
        _this.submitEditPaymentInstrument = function () {
            var _a, _b, _c;
            if (_this.state.currentView === exports.AllowedViews.EditPaymentInstrument) {
                (_c = (_b = (_a = _this.EditPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getRef().current) === null || _c === void 0 ? void 0 : _c.moveNextPage();
            }
        };
        _this.getCurrentView = function () {
            return _this.state.currentView;
        };
        _this.getSelectedResource = function () {
            var _a, _b;
            if (_this.state.currentView === exports.AllowedViews.SelectPaymentInstrument) {
                return (_b = (_a = _this.SelectPaymentInstrumentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getSelectedResource();
            }
        };
        _this.state = {
            currentView: _this.setCurrentView(),
            paymentFamily: "",
            paymentType: "",
            paymentInstrumentId: "",
            allowedPaymentMethods: _this.props.allowedPaymentMethods,
            selectPMAllowedPaymentMethods: (((_a = _this.props.selectPMAllowedPaymentMethods) === null || _a === void 0 ? void 0 : _a.length) > 0) ? _this.props.selectPMAllowedPaymentMethods : _this.props.allowedPaymentMethods,
        };
        _this.pmGroupPageId = undefined;
        return _this;
    }
    ManagePaymentInstrument.prototype.componentDidMount = function () {
        if (this.props.currentViewChangeHandler) {
            this.props.currentViewChangeHandler(exports.AllowedViews.SelectPaymentInstrument);
        }
    };
    ManagePaymentInstrument.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.props.currentViewChangeHandler && this.state.currentView !== prevState.currentView) {
            this.props.currentViewChangeHandler(this.state.currentView);
        }
    };
    ManagePaymentInstrument.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, telemetryLogger = _a.telemetryLogger, telemetryOptions = _a.telemetryOptions, language = _a.language, partner = _a.partner, elementFactory = _a.elementFactory, onFailure = _a.onFailure, onCancel = _a.onCancel, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, redirectionSuccessUrl = _a.redirectionSuccessUrl, redirectionFailureUrl = _a.redirectionFailureUrl, includePidl = _a.includePidl, pidlPayload = _a.pidlPayload, actionContext = _a.actionContext, pidlsdkMock = _a.pidlsdkMock, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, onEvent = _a.onEvent, completePrerequisites = _a.completePrerequisites, viewTermsHandler = _a.viewTermsHandler, defaultPaymentMethod = _a.defaultPaymentMethod, sessionId = _a.sessionId, orderId = _a.orderId, merchantId = _a.merchantId, currency = _a.currency, filters = _a.filters, headers = _a.headers, walletProvider = _a.walletProvider, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, displayOptions = _a.displayOptions;
        var _c = this.state, currentView = _c.currentView, paymentFamily = _c.paymentFamily, paymentType = _c.paymentType, piid = _c.paymentInstrumentId, allowedPaymentMethods = _c.allowedPaymentMethods, selectPMAllowedPaymentMethods = _c.selectPMAllowedPaymentMethods;
        var _d = this.props, country = _d.country, market = _d.market;
        country = country || market;
        return (React__default.createElement(React__default.Fragment, null,
            currentView === exports.AllowedViews.SelectPaymentInstrument &&
                React__default.createElement(SelectPaymentInstrument, { baseStyleOverrides: baseStyleOverrides, scenarioStyleOverrides: scenarioStyleOverrides, baseFocusStyleOverrides: baseFocusStyleOverrides, scenarioFocusStyleOverrides: scenarioFocusStyleOverrides, elementFactory: elementFactory, authToken: authToken, env: env, onSuccess: this.onSelectPISuccess, onFailure: onFailure, onCancel: onCancel, busyBlockShowHideHandler: busyBlockShowHideHandler, busyBlockElement: busyBlockElement, country: country, language: language, partner: partner, parameters: parameters, pidlsdkMock: pidlsdkMock, telemetryLogger: telemetryLogger, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, onEvent: this.onSelectPIEvent, allowedPaymentMethods: allowedPaymentMethods, filters: filters, sessionId: sessionId, orderId: orderId, merchantId: merchantId, currency: currency, headers: headers, includePidl: includePidl, pidlPayload: pidlPayload, actionContext: actionContext, showSubmitBlock: showSubmitBlock, ref: this.SelectPaymentInstrumentRef, walletProvider: walletProvider, displayOptions: displayOptions }),
            currentView === exports.AllowedViews.SelectPaymentMethod &&
                React__default.createElement(SelectPaymentMethod, { baseStyleOverrides: baseStyleOverrides, scenarioStyleOverrides: scenarioStyleOverrides, baseFocusStyleOverrides: baseFocusStyleOverrides, scenarioFocusStyleOverrides: scenarioFocusStyleOverrides, elementFactory: elementFactory, authToken: authToken, env: env, onSuccess: this.onSelectPaymentMethodSuccess, onFailure: onFailure, onCancel: this.cancelSelectPM, busyBlockShowHideHandler: busyBlockShowHideHandler, busyBlockElement: busyBlockElement, country: country, language: language, partner: partner, parameters: parameters, pidlsdkMock: pidlsdkMock, telemetryLogger: telemetryLogger, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, onEvent: onEvent, defaultPaymentMethod: defaultPaymentMethod, allowedPaymentMethods: selectPMAllowedPaymentMethods, filters: filters, sessionId: sessionId, orderId: orderId, merchantId: merchantId, currency: currency, headers: headers, pmGroupPageId: this.pmGroupPageId, showSubmitBlock: showSubmitBlock, ref: this.SelectPaymentMethodRef, displayOptions: displayOptions }),
            currentView === exports.AllowedViews.AddPaymentInstrument &&
                React__default.createElement(AddPaymentInstrument, { baseStyleOverrides: baseStyleOverrides, scenarioStyleOverrides: scenarioStyleOverrides, baseFocusStyleOverrides: baseFocusStyleOverrides, scenarioFocusStyleOverrides: scenarioFocusStyleOverrides, elementFactory: elementFactory, authToken: authToken, env: env, onSuccess: this.onAddPISuccess, onFailure: onFailure, onCancel: this.cancelAddPI, busyBlockShowHideHandler: busyBlockShowHideHandler, busyBlockElement: busyBlockElement, country: country, language: language, partner: partner, paymentFamily: paymentFamily, paymentType: paymentType, completePrerequisites: completePrerequisites, parameters: parameters, redirectionSuccessUrl: redirectionSuccessUrl, redirectionFailureUrl: redirectionFailureUrl, pidlsdkMock: pidlsdkMock, telemetryLogger: telemetryLogger, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, onEvent: onEvent, viewTermsHandler: viewTermsHandler, showSubmitBlock: showSubmitBlock, headers: typehelper.toLowerCase(this.props.partner) === "windowssettings" ? __assign$1(__assign$1({}, headers), { "x-ms-flight": "PXUsePartnerSettingsService" }) : headers, ref: this.AddPaymentInstrumentRef, displayOptions: displayOptions }),
            currentView === exports.AllowedViews.EditPaymentInstrument &&
                React__default.createElement(EditPaymentInstrument, { baseStyleOverrides: baseStyleOverrides, scenarioStyleOverrides: scenarioStyleOverrides, baseFocusStyleOverrides: baseFocusStyleOverrides, scenarioFocusStyleOverrides: scenarioFocusStyleOverrides, elementFactory: elementFactory, authToken: authToken, env: env, onSuccess: this.onEditPISuccess, onFailure: onFailure, onCancel: this.cancelEditPI, busyBlockShowHideHandler: busyBlockShowHideHandler, busyBlockElement: busyBlockElement, country: country, language: language, partner: partner, paymentInstrumentId: piid, paymentFamily: paymentFamily, paymentType: paymentType, parameters: parameters, pidlsdkMock: pidlsdkMock, telemetryLogger: telemetryLogger, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, onEvent: onEvent, viewTermsHandler: viewTermsHandler, showSubmitBlock: showSubmitBlock, headers: typehelper.toLowerCase(this.props.partner) === "windowssettings" ? __assign$1(__assign$1({}, headers), { "x-ms-flight": "PXUsePartnerSettingsService" }) : headers, ref: this.EditPaymentInstrumentRef, displayOptions: displayOptions })));
    };
    return ManagePaymentInstrument;
}(React__default.Component));

var AllowedViews;
(function (AllowedViews) {
    AllowedViews[AllowedViews["ListAddress"] = 0] = "ListAddress";
    AllowedViews[AllowedViews["AddNewAddress"] = 1] = "AddNewAddress";
    AllowedViews[AllowedViews["EditAddress"] = 2] = "EditAddress";
})(AllowedViews || (AllowedViews = {}));
(function (ManageAddressMode) {
    ManageAddressMode[ManageAddressMode["Select"] = 0] = "Select";
    ManageAddressMode[ManageAddressMode["Edit"] = 1] = "Edit";
})(exports.ManageAddressMode || (exports.ManageAddressMode = {}));
var ManageAddress = /** @class */ (function (_super) {
    __extends$1(ManageAddress, _super);
    function ManageAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.onSuccessWrapper = function (params) {
            if (params.id === "newAddressLink" && _this.props.onAddNewAddress) {
                // Render internal addAddress
                _this.props.onAddNewAddress(params);
            }
            else if (params.id === "newAddressLink") {
                _this.setState({ currentView: AllowedViews.AddNewAddress });
            }
            else if (_this.shouldOpenEditView(params)) {
                _this.setState({ currentView: AllowedViews.EditAddress, addressId: params.instance.id });
            }
            else {
                _this.props.onSuccess(params);
            }
        };
        _this.shouldOpenEditView = function (params) {
            var _a, _b;
            var _c = _this.props, mode = _c.mode, scenario = _c.scenario;
            return mode === exports.ManageAddressMode.Edit
                || (mode === exports.ManageAddressMode.Select && !(((_a = params === null || params === void 0 ? void 0 : params.instance) === null || _a === void 0 ? void 0 : _a.first_name) && ((_b = params === null || params === void 0 ? void 0 : params.instance) === null || _b === void 0 ? void 0 : _b.last_name)) && scenario === exports.AddressScenario.shipping);
        };
        _this.returnToListView = function () {
            _this.setState({ currentView: AllowedViews.ListAddress });
        };
        _this.state = {
            currentView: AllowedViews.ListAddress,
        };
        return _this;
    }
    ManageAddress.prototype.componentDidUpdate = function (prevProps) {
        // If any of these props change, remount the listAddress view
        var _a = this.props, mode = _a.mode, scenario = _a.scenario, country = _a.country, language = _a.language, partner = _a.partner, addressType = _a.addressType;
        if (prevProps.mode !== mode || prevProps.scenario !== scenario || prevProps.country !== country || prevProps.language !== language || prevProps.partner !== partner || prevProps.addressType !== addressType) {
            this.setState({ currentView: AllowedViews.ListAddress });
        }
    };
    ManageAddress.prototype.render = function () {
        var _a = this.props, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, telemetryLogger = _a.telemetryLogger, telemetryOptions = _a.telemetryOptions, authToken = _a.authToken, env = _a.env, addressType = _a.addressType, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockElement = _a.busyBlockElement, country = _a.country, language = _a.language, partner = _a.partner, scenario = _a.scenario, elementFactory = _a.elementFactory, onFailure = _a.onFailure, onCancel = _a.onCancel, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, onEvent = _a.onEvent, viewTermsHandler = _a.viewTermsHandler, headers = _a.headers, displayOptions = _a.displayOptions;
        var _c = this.state, addressId = _c.addressId, currentView = _c.currentView;
        return (React__default.createElement(React__default.Fragment, null,
            currentView === AllowedViews.ListAddress &&
                React__default.createElement(ListAddress, { authToken: authToken, elementFactory: elementFactory, env: env, scenario: scenario, addressType: addressType, country: country, language: language, partner: partner, onSuccess: this.onSuccessWrapper, onFailure: onFailure, onCancel: onCancel, baseStyleOverrides: baseStyleOverrides, scenarioStyleOverrides: scenarioStyleOverrides, baseFocusStyleOverrides: baseFocusStyleOverrides, scenarioFocusStyleOverrides: scenarioFocusStyleOverrides, busyBlockElement: busyBlockElement, busyBlockShowHideHandler: busyBlockShowHideHandler, pidlsdkMock: pidlsdkMock, telemetryLogger: telemetryLogger, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, onEvent: onEvent, headers: headers, showSubmitBlock: showSubmitBlock, displayOptions: displayOptions }),
            currentView === AllowedViews.AddNewAddress &&
                React__default.createElement(AddAddress, { authToken: authToken, elementFactory: elementFactory, env: env, country: country, language: language, partner: partner, scenario: scenario, addressType: addressType, onSuccess: this.returnToListView, onFailure: onFailure, onCancel: this.returnToListView, baseStyleOverrides: baseStyleOverrides, scenarioStyleOverrides: scenarioStyleOverrides, baseFocusStyleOverrides: baseFocusStyleOverrides, scenarioFocusStyleOverrides: scenarioFocusStyleOverrides, busyBlockElement: busyBlockElement, busyBlockShowHideHandler: busyBlockShowHideHandler, pidlsdkMock: pidlsdkMock, telemetryLogger: telemetryLogger, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, onEvent: onEvent, viewTermsHandler: viewTermsHandler, headers: headers, showSubmitBlock: showSubmitBlock, displayOptions: displayOptions }),
            currentView === AllowedViews.EditAddress &&
                React__default.createElement(EditAddress, { authToken: authToken, addressId: addressId, elementFactory: elementFactory, env: env, country: country, scenario: scenario, language: language, partner: partner, onSuccess: this.returnToListView, onFailure: onFailure, onCancel: this.returnToListView, baseStyleOverrides: baseStyleOverrides, scenarioStyleOverrides: scenarioStyleOverrides, baseFocusStyleOverrides: baseFocusStyleOverrides, scenarioFocusStyleOverrides: scenarioFocusStyleOverrides, busyBlockShowHideHandler: busyBlockShowHideHandler, onPageRendered: onPageRendered, onEvent: onEvent, viewTermsHandler: viewTermsHandler, telemetryLogger: telemetryLogger, telemetryOptions: telemetryOptions, headers: headers, showSubmitBlock: showSubmitBlock, displayOptions: displayOptions })));
    };
    return ManageAddress;
}(React__default.Component));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var VerifyAddressInternal = /** @class */ (function (_super) {
    __extends$1(VerifyAddressInternal, _super);
    function VerifyAddressInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.validateAddress(_this.props.pidlDocInfo); }) || this;
        return _this;
    }
    return VerifyAddressInternal;
}(BaseComponent));
(function (VerifyAddressPages) {
    VerifyAddressPages[VerifyAddressPages["verifyAddressPage"] = 0] = "verifyAddressPage";
    VerifyAddressPages[VerifyAddressPages["editAddressPage"] = 1] = "editAddressPage";
    VerifyAddressPages[VerifyAddressPages["noAddressSuggestionsPage"] = 2] = "noAddressSuggestionsPage";
})(exports.VerifyAddressPages || (exports.VerifyAddressPages = {}));
var VerifyAddress = /** @class */ (function (_super) {
    __extends$1(VerifyAddress, _super);
    function VerifyAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.VerifyAddressRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.onVerifyAddressEvent = function (eventName, parameters) {
            var _a = _this.props, onEvent = _a.onEvent, currentPageChangeHandler = _a.currentPageChangeHandler;
            if (eventName == eventNames.pageRefreshed) {
                switch (parameters.pageId) {
                    case "addressSuggestionPage1":
                        currentPageChangeHandler ? currentPageChangeHandler(exports.VerifyAddressPages.verifyAddressPage) : null;
                        break;
                    case "addressSuggestionPage2":
                        currentPageChangeHandler ? currentPageChangeHandler(exports.VerifyAddressPages.editAddressPage) : null;
                        break;
                    case "noAddressSuggestionsPage":
                        currentPageChangeHandler ? currentPageChangeHandler(exports.VerifyAddressPages.noAddressSuggestionsPage) : null;
                        break;
                    default: break;
                }
            }
            if (onEvent) {
                return onEvent(eventName, parameters);
            }
        };
        _this.moveNextPage = function () {
            var _a, _b;
            (_b = (_a = _this.VerifyAddressRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.moveNextPage();
        };
        _this.movePrevPage = function () {
            var _a, _b;
            (_b = (_a = _this.VerifyAddressRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.movePrevPage();
        };
        _this.cancel = function () {
            var _a, _b;
            (_b = (_a = _this.VerifyAddressRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.cancel();
        };
        _this.submitPage = function () {
            var _a, _b;
            (_b = (_a = _this.VerifyAddressRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.submitPage();
        };
        _this.getRef = function () {
            return _this.VerifyAddressRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.VerifyAddress, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    VerifyAddress.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    VerifyAddress.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    VerifyAddress.prototype.compileParameters = function (country, language, partner, addressId, addressType, parameters) {
        var compiledParams = __assign$1({ operation: ValidateAddressConstants.Operation, type: addressType }, { country: country, language: language, partner: partner, addressId: addressId });
        if (parameters) {
            compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
        }
        return compiledParams;
    };
    VerifyAddress.prototype.compileReturnOptions = function (success, failure, gohome) {
        return {
            callbacks: {
                success: success,
                failure: failure,
                gohome: gohome,
            },
        };
    };
    VerifyAddress.prototype.render = function () {
        var _a = this.props, env = _a.env, parameters = _a.parameters, country = _a.country, language = _a.language, partner = _a.partner, addressId = _a.addressId, addressType = _a.addressType, elementFactory = _a.elementFactory, busyBlockElement = _a.busyBlockElement, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, onEvent = _a.onEvent, callbacksIn = _a.callbacksIn, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, headers = _a.headers, telemetryLogger = _a.telemetryLogger, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, pidlsdkMock = _a.pidlsdkMock, authToken = _a.authToken, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters(country, language, partner, addressId, addressType, parameters);
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(VerifyAddressInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: ValidateAddressConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), pidlDocInfo: {
                    resourceType: ValidateAddressConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.onVerifyAddressEvent, userContext: {
                    authToken: authToken,
                    userId: ValidateAddressConstants.UserId,
                    additionalHeaders: headers
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: { telemetryLogger: telemetryLogger }, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.VerifyAddressRef })));
    };
    return VerifyAddress;
}(React__default.Component));

var RedeemMSRewardsInternal = /** @class */ (function (_super) {
    __extends$1(RedeemMSRewardsInternal, _super);
    function RedeemMSRewardsInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.redeemMSRewards(_this.props.pidlDocInfo); }) || this;
        return _this;
    }
    return RedeemMSRewardsInternal;
}(BaseComponent));
var RedeemMSRewards = /** @class */ (function (_super) {
    __extends$1(RedeemMSRewards, _super);
    function RedeemMSRewards(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.FailureHandler = function (error) {
            _this.props.onFailure(error.error);
        };
        _this.compileRewardsContextData = function (orderAmount, currency) {
            var rewardsContextData = {
                orderAmount: orderAmount,
                currency: currency,
            };
            return rewardsContextData;
        };
        _this.compileParameters = function (country, language, partner, parameters, orderAmount, currency) {
            var rewardsContextData = _this.compileRewardsContextData(orderAmount, currency);
            var compiledParams = {
                country: country,
                language: language,
                partner: partner,
                type: _this.getResourceType(),
                rewardsContextData: rewardsContextData
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.compileReturnOptions = function (success, failure, gohome) {
            return {
                callbacks: {
                    success: success,
                    failure: _this.FailureHandler,
                    gohome: gohome,
                },
            };
        };
        _this.compileCallbacks = function () {
            var _a = _this.props, telemetryLogger = _a.telemetryLogger, elementFactory = _a.elementFactory, callbacksIn = _a.callbacksIn;
            var ret = __assign$1({}, callbacksIn);
            if (telemetryLogger) {
                ret["telemetryLogger"] = telemetryLogger;
            }
            if (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.encryptionHandler) {
                ret["encryptionHandler"] = elementFactory.encryptionHandler();
            }
            return ret;
        };
        _this.getResourceType = function () {
            return RedeemMSRewardsConstants.ResourceType;
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.RedeemMSRewards, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    RedeemMSRewards.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    RedeemMSRewards.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    RedeemMSRewards.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, parameters = _a.parameters, busyBlockElement = _a.busyBlockElement, country = _a.country, language = _a.language, partner = _a.partner, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, onEvent = _a.onEvent, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryLogger = _a.telemetryLogger, telemetryOptions = _a.telemetryOptions, propertyElementRef = _a.propertyElementRef, onPageRendered = _a.onPageRendered, headers = _a.headers, orderAmount = _a.orderAmount, currency = _a.currency, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters(country, language, partner, parameters, orderAmount, currency);
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel);
        var callbacksIn = this.compileCallbacks();
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(RedeemMSRewardsInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: RedeemMSRewardsConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock }), pidlDocInfo: {
                    resourceType: this.getResourceType(),
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, userContext: {
                    authToken: authToken,
                    userId: RedeemMSRewardsConstants.UserId,
                    additionalHeaders: headers,
                }, onEvent: onEvent, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, callbacksIn: callbacksIn, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return RedeemMSRewards;
}(React__default.Component));

/**
 * Downloads a PIDL document using PIDL document information and renders a form for adding resource represented by the PIDL document.
 */
var SearchTransactions = /** @class */ (function (_super) {
    __extends$1(SearchTransactions, _super);
    function SearchTransactions(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.searchTransactions({
            pidlDocInfo: _this.props.pidlDocInfo,
            options: _this.props.options
        }); }) || this;
        return _this;
    }
    return SearchTransactions;
}(BaseComponent));

var OfferPaymentInstrumentInternal = /** @class */ (function (_super) {
    __extends$1(OfferPaymentInstrumentInternal, _super);
    function OfferPaymentInstrumentInternal(props) {
        return _super.call(this, props, function (controlApi) { return controlApi.offerResource({
            pidlDocInfo: props.pidlDocInfo
        }); }) || this;
    }
    return OfferPaymentInstrumentInternal;
}(BaseComponent));
var OfferPaymentInstrument = /** @class */ (function (_super) {
    __extends$1(OfferPaymentInstrument, _super);
    function OfferPaymentInstrument(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileParameters = function () {
            var _a = _this.props, country = _a.country, language = _a.language, partner = _a.partner, parameters = _a.parameters, scenario = _a.scenario;
            var compiledParams = {
                operation: OfferPaymentInstrumentConstants.Operation,
                country: country,
                language: language,
                partner: partner,
                scenario: scenario,
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.compileReturnOptions = function (success, failure, gohome, redirectReturnUrls) {
            return {
                urls: redirectReturnUrls,
                callbacks: {
                    success: success,
                    failure: failure,
                    gohome: gohome,
                },
            };
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.OfferPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    OfferPaymentInstrument.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    OfferPaymentInstrument.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    // tslint:disable-next-line: member-ordering
    OfferPaymentInstrument.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, busyBlockElement = _a.busyBlockElement, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, redirectReturnUrls = _a.redirectReturnUrls, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryOptions = _a.telemetryOptions, propertyElementRef = _a.propertyElementRef, onEvent = _a.onEvent, onPageRendered = _a.onPageRendered, headers = _a.headers, useWebView2 = _a.useWebView2, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters();
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel, redirectReturnUrls);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(OfferPaymentInstrumentInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: OfferPaymentInstrumentConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock, useWebView2: useWebView2 }), pidlDocInfo: {
                    resourceType: OfferPaymentInstrumentConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: onEvent, userContext: {
                    authToken: authToken,
                    userId: OfferPaymentInstrumentConstants.UserId,
                    additionalHeaders: headers,
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return OfferPaymentInstrument;
}(React__default.Component));

var SelectMSRewardsInternal = /** @class */ (function (_super) {
    __extends$1(SelectMSRewardsInternal, _super);
    function SelectMSRewardsInternal(props) {
        var _this = _super.call(this, props, function (controlApi) { return controlApi.selectMSRewards(_this.props.pidlDocInfo); }) || this;
        return _this;
    }
    return SelectMSRewardsInternal;
}(BaseComponent));
var SelectMSRewards = /** @class */ (function (_super) {
    __extends$1(SelectMSRewards, _super);
    function SelectMSRewards(props) {
        var _this = _super.call(this, props) || this;
        _this.baseComponentRef = React__default.createRef();
        _this.onAppThemeChangeHandlerRegistration = undefined;
        _this.onAppThemeChanged = function (theme) {
            var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides, baseDisabledStyleOverrides = _a.baseDisabledStyleOverrides, scenarioDisabledStyleOverrides = _a.scenarioDisabledStyleOverrides;
            var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
                && elementFactory.initializeStyles(exports.AppScenario.SelectPaymentInstrument, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides, baseDisabledStyleOverrides, scenarioDisabledStyleOverrides);
            _this.setState({ styleProvider: styleProvider });
        };
        _this.compileRewardsContextData = function (orderAmount, currency) {
            var rewardsContextData = {
                orderAmount: orderAmount,
                currency: currency,
            };
            return rewardsContextData;
        };
        _this.getResourceType = function () {
            return SelectMSRewardsConstants.ResourceType;
        };
        _this.compileParameters = function () {
            var _a = _this.props, country = _a.country, currency = _a.currency, language = _a.language, orderAmount = _a.orderAmount, partner = _a.partner, parameters = _a.parameters, scenario = _a.scenario;
            var rewardsContextData = _this.compileRewardsContextData(orderAmount, currency);
            var compiledParams = {
                operation: OfferPaymentInstrumentConstants.Operation,
                country: country,
                language: language,
                partner: partner,
                rewardsContextData: rewardsContextData,
                scenario: scenario,
                type: _this.getResourceType(),
            };
            if (parameters) {
                compiledParams = __assign$1(__assign$1({}, compiledParams), parameters);
            }
            return compiledParams;
        };
        _this.compileReturnOptions = function (success, failure, gohome, redirectReturnUrls) {
            return {
                urls: redirectReturnUrls,
                callbacks: {
                    success: success,
                    failure: failure,
                    gohome: gohome,
                },
            };
        };
        _this.onEventInternal = function (eventName, eventParams) {
            var _a = _this.props, onEvent = _a.onEvent, onMSRewardsSelectionChange = _a.onMSRewardsSelectionChange;
            if (onMSRewardsSelectionChange &&
                (eventName === eventNames.pageRendered ||
                    eventName === eventNames.pageRefreshed) &&
                _this.baseComponentRef &&
                _this.baseComponentRef.current &&
                _this.baseComponentRef.current.getPidlPayload) {
                _this.baseComponentRef.current.getPidlPayload().then(function (pidlPayload) {
                    if (pidlPayload && pidlPayload.payload && pidlPayload.payload.data) {
                        onMSRewardsSelectionChange(pidlPayload.payload.data);
                    }
                });
            }
            if (onEvent) {
                return onEvent(eventName, eventParams);
            }
        };
        _this.getRef = function () {
            return _this.baseComponentRef;
        };
        var _a = _this.props, elementFactory = _a.elementFactory, partner = _a.partner, baseStyleOverrides = _a.baseStyleOverrides, scenarioStyleOverrides = _a.scenarioStyleOverrides, baseFocusStyleOverrides = _a.baseFocusStyleOverrides, scenarioFocusStyleOverrides = _a.scenarioFocusStyleOverrides;
        var styleProvider = (elementFactory === null || elementFactory === void 0 ? void 0 : elementFactory.initializeStyles)
            && elementFactory.initializeStyles(exports.AppScenario.SelectMSRewards, partner, baseStyleOverrides, scenarioStyleOverrides, baseFocusStyleOverrides, scenarioFocusStyleOverrides);
        _this.state = {
            styleProvider: styleProvider,
        };
        return _this;
    }
    SelectMSRewards.prototype.componentDidMount = function () {
        var _a;
        if (this.props && this.props.elementFactory && this.props.elementFactory.addAppThemeChangeHandler) {
            this.onAppThemeChangeHandlerRegistration = (_a = this.props.elementFactory) === null || _a === void 0 ? void 0 : _a.addAppThemeChangeHandler(this.onAppThemeChanged);
        }
    };
    SelectMSRewards.prototype.componentWillUnmount = function () {
        var _a;
        if (this.onAppThemeChangeHandlerRegistration && this.onAppThemeChangeHandlerRegistration.remove) {
            (_a = this.onAppThemeChangeHandlerRegistration) === null || _a === void 0 ? void 0 : _a.remove();
        }
    };
    // tslint:disable-next-line: member-ordering
    SelectMSRewards.prototype.render = function () {
        var _a = this.props, authToken = _a.authToken, env = _a.env, busyBlockElement = _a.busyBlockElement, elementFactory = _a.elementFactory, onSuccess = _a.onSuccess, onFailure = _a.onFailure, onCancel = _a.onCancel, redirectReturnUrls = _a.redirectReturnUrls, _b = _a.showSubmitBlock, showSubmitBlock = _b === void 0 ? true : _b, busyBlockShowHideHandler = _a.busyBlockShowHideHandler, pidlsdkMock = _a.pidlsdkMock, telemetryOptions = _a.telemetryOptions, propertyElementRef = _a.propertyElementRef, onEvent = _a.onEvent, onPageRendered = _a.onPageRendered, headers = _a.headers, useWebView2 = _a.useWebView2, displayOptions = _a.displayOptions;
        var styleProvider = this.state.styleProvider;
        var compiledParams = this.compileParameters();
        var returnOptions = this.compileReturnOptions(onSuccess, onFailure, onCancel, redirectReturnUrls);
        return (React__default.createElement(StyleProviderContext.Provider, { value: { styleProvider: styleProvider } },
            React__default.createElement(SelectMSRewardsInternal, { busyBlockElement: busyBlockElement, displayOptions: __assign$1(__assign$1({}, displayOptions), { containerId: SelectMSRewardsConstants.ContainerId, busyBlockShowHideHandler: busyBlockShowHideHandler, showSubmitBlock: showSubmitBlock, useWebView2: useWebView2 }), pidlDocInfo: {
                    resourceType: SelectMSRewardsConstants.ResourceType,
                    parameters: compiledParams,
                }, env: env, returnOptions: returnOptions, onEvent: this.onEventInternal, userContext: {
                    authToken: authToken,
                    userId: SelectMSRewardsConstants.UserId,
                    additionalHeaders: headers,
                }, elementFactory: elementFactory, pidlsdkMock: pidlsdkMock, telemetryOptions: telemetryOptions, propertyElementRef: propertyElementRef, onPageRendered: onPageRendered, ref: this.baseComponentRef })));
    };
    return SelectMSRewards;
}(React__default.Component));

exports.AddAddress = AddAddress;
exports.AddAddressConstants = AddAddressConstants;
exports.AddPaymentInstrument = AddPaymentInstrument;
exports.AddPaymentInstrumentConstants = AddPaymentInstrumentConstants;
exports.AddPaymentInstrumentInternal = AddPaymentInstrumentInternal;
exports.AddResource = AddResource;
exports.ApplyPaymentInstrument = ApplyPaymentInstrument;
exports.ApplyPaymentInstrumentConstants = ApplyPaymentInstrumentConstants;
exports.ApplyPaymentInstrumentInternal = ApplyPaymentInstrumentInternal;
exports.ApplyResource = ApplyResource;
exports.Audio = Audio;
exports.AudioInner = AudioInner;
exports.BodyBlock = BodyBlock;
exports.Button = Button;
exports.ButtonInner = ButtonInner;
exports.ButtonList = ButtonList;
exports.ButtonListElement = ButtonListElement$1;
exports.ButtonListElementInner = ButtonListElementInner;
exports.ButtonListInner = ButtonListInner;
exports.Captcha = Captcha;
exports.CaptchaInner = CaptchaInner;
exports.CheckBox = CheckBox;
exports.CheckBoxInner = CheckBoxInner;
exports.ConfirmPayment = ConfirmPayment;
exports.ConfirmPaymentConstants = ConfirmPaymentConstants;
exports.ConfirmPaymentInternal = ConfirmPaymentInternal;
exports.CreatePaymentSession = CreatePaymentSession;
exports.DefaultIFrameElement = DefaultIFrameElement;
exports.DeletePaymentInstrument = DeletePaymentInstrument;
exports.DeletePaymentInstrumentConstants = DeletePaymentInstrumentConstants;
exports.DeleteResource = DeleteResource;
exports.Dropdown = Dropdown;
exports.EditAddress = EditAddress;
exports.EditAddressConstants = EditAddressConstants;
exports.EditPaymentInstrument = EditPaymentInstrument;
exports.EditPaymentInstrumentConstants = EditPaymentInstrumentConstants;
exports.Error = Error$1;
exports.FilePicker = FilePicker;
exports.FundStoredValue = FundStoredValue;
exports.Group = Group;
exports.GroupError = GroupError;
exports.GroupLabel = GroupLabel;
exports.GroupLabelInner = GroupLabelInner;
exports.HandleCheckout = HandleCheckout;
exports.HandleIndia3DSChallenge = HandleIndia3DSChallenge;
exports.HandleIndia3DSChallengeConstants = HandleIndia3DSChallengeConstants;
exports.HandleIndia3DSChallengeInternal = HandleIndia3DSChallengeInternal;
exports.HandlePaymentChallenge = HandlePaymentChallenge;
exports.HandlePurchaseRiskChallenge = HandlePurchaseRiskChallenge;
exports.HandleRiskChallenge = HandleRiskChallenge;
exports.HandleRiskChallengeConstants = HandleRiskChallengeConstants;
exports.HandleRiskChallengeInternal = HandleRiskChallengeInternal;
exports.Heading = Heading;
exports.HeadingInner = HeadingInner;
exports.HelpDialog = HelpDialog;
exports.HelpDialogInner = HelpDialogInner;
exports.Hyperlink = Hyperlink;
exports.IFrameElement = IFrameElement$1;
exports.IFrameElementInner = IFrameElementInner;
exports.Image = Image;
exports.ListAddress = ListAddress;
exports.ListAddressConstants = ListAddressConstants;
exports.LogoElement = LogoElement$1;
exports.ManageAddress = ManageAddress;
exports.ManagePaymentInstrument = ManagePaymentInstrument;
exports.ManagePaymentInstrumentConstants = ManagePaymentInstrumentConstants;
exports.Modal = Modal;
exports.ModalInner = ModalInner;
exports.OfferPaymentInstrument = OfferPaymentInstrument;
exports.OfferPaymentInstrumentConstants = OfferPaymentInstrumentConstants;
exports.OfferPaymentInstrumentInternal = OfferPaymentInstrumentInternal;
exports.PageAlert = PageAlert;
exports.PageErrorBlock = PageErrorBlock;
exports.PaymentInstrumentDetails = PaymentInstrumentDetails;
exports.PaymentInstrumentDetailsConstants = PaymentInstrumentDetailsConstants;
exports.PaymentInstrumentDetailsInternal = PaymentInstrumentDetailsInternal;
exports.PidlComponent = PidlComponent;
exports.PidlDocBuilder = PidlDocBuilder;
exports.PidlPropertyBuilder = PidlPropertyBuilder;
exports.PrefillCheckBox = PrefillCheckBox;
exports.PrefillCheckBoxInner = PrefillCheckBoxInner;
exports.ProfilePrerequisite = ProfilePrerequisite;
exports.ProfilePrerequisiteConstants = ProfilePrerequisiteConstants;
exports.PropertyLabel = PropertyLabel;
exports.PropertyLabelInner = PropertyLabelInner;
exports.Radio = Radio;
exports.RedeemMSRewards = RedeemMSRewards;
exports.RedeemMSRewardsConstants = RedeemMSRewardsConstants;
exports.RedeemMSRewardsInternal = RedeemMSRewardsInternal;
exports.ReplaceResource = ReplaceResource;
exports.ResourceHelpersConstants = ResourceHelpersConstants;
exports.RiskChallengeConstants = RiskChallengeConstants;
exports.SearchResource = SearchResource;
exports.SearchTransactions = SearchTransactions;
exports.SelectMSRewards = SelectMSRewards;
exports.SelectMSRewardsConstants = SelectMSRewardsConstants;
exports.SelectPaymentInstrument = SelectPaymentInstrument;
exports.SelectPaymentInstrumentConstants = SelectPaymentInstrumentConstants;
exports.SelectPaymentMethod = SelectPaymentMethod;
exports.SelectPaymentMethodConstants = SelectPaymentMethodConstants;
exports.SelectPaymentMethodInternal = SelectPaymentMethodInternal;
exports.SelectResource = SelectResource;
exports.SelectResourceType = SelectResourceType;
exports.SelectSingleResource = SelectSingleResource;
exports.ShowResource = ShowResource;
exports.StyleProviderContext = StyleProviderContext;
exports.SubHeading = SubHeading;
exports.SubHeadingInner = SubHeadingInner;
exports.TestHookRenderPidl = TestHookRenderPidl;
exports.Text = Text;
exports.TextBox = TextBox;
exports.TextGroup = TextGroup;
exports.TextInner = TextInner;
exports.UpdateResource = UpdateResource;
exports.ValidateAddress = ValidateAddress;
exports.ValidateAddressConstants = ValidateAddressConstants;
exports.ValidateResource = ValidateResource;
exports.VerifyAddress = VerifyAddress;
exports.defaultEnvironment = defaultEnvironment;
exports.getClassNamesFromStyleHints = getClassNamesFromStyleHints;
exports.getPidlReactCustomProps = getPidlReactCustomProps;
exports.getTagClassNames = getTagClassNames;
exports.pidl = pidl;
exports.pidlReactClassPrefix = pidlReactClassPrefix;
exports.shouldHideInlineError = shouldHideInlineError;
exports.startsWith = startsWith;
